webpackJsonp([0],{

/***/ "+E39":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("S82l")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "+ZMJ":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("lOnJ");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "+tPU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("xGkn");
var global = __webpack_require__("7KvD");
var hide = __webpack_require__("hJx8");
var Iterators = __webpack_require__("/bQp");
var TO_STRING_TAG = __webpack_require__("dSzd")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "+wWI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_9ec85033_js__ = __webpack_require__("h7Sf");
/* unused harmony reexport BTooltip */





var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chunk_cca88db8_js__["d" /* r */])(Vue, __WEBPACK_IMPORTED_MODULE_2__chunk_9ec85033_js__["a" /* T */]);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);


/***/ }),

/***/ "//Fk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("U5ju"), __esModule: true };

/***/ }),

/***/ "/506":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__("75l9");

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ "/Rej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BDatetimepicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_d0a313ea_js__ = __webpack_require__("EmVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__ = __webpack_require__("QR9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chunk_1196ee55_js__ = __webpack_require__("iBFZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chunk_42f463e6_js__ = __webpack_require__("mMDG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__chunk_4d76806f_js__ = __webpack_require__("t4YS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__chunk_eb60b35a_js__ = __webpack_require__("RbWz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__chunk_77ffdf8b_js__ = __webpack_require__("8cDm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__chunk_66a4ceca_js__ = __webpack_require__("ajTP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__chunk_a684d1f3_js__ = __webpack_require__("5udn");















var _components;
var script = {
  name: 'BDatetimepicker',
  components: (_components = {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_12__chunk_66a4ceca_js__["a" /* D */].name, __WEBPACK_IMPORTED_MODULE_12__chunk_66a4ceca_js__["a" /* D */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_13__chunk_a684d1f3_js__["a" /* T */].name, __WEBPACK_IMPORTED_MODULE_13__chunk_a684d1f3_js__["a" /* T */]), _components),
  mixins: [__WEBPACK_IMPORTED_MODULE_3__chunk_d0a313ea_js__["a" /* F */]],
  inheritAttrs: false,
  props: {
    value: {
      type: Date
    },
    editable: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    horizontalTimePicker: Boolean,
    disabled: Boolean,
    icon: String,
    iconPack: String,
    inline: Boolean,
    openOnFocus: Boolean,
    position: String,
    mobileNative: {
      type: Boolean,
      default: true
    },
    minDatetime: Date,
    maxDatetime: Date,
    datetimeFormatter: {
      type: Function
    },
    datetimeParser: {
      type: Function
    },
    datetimeCreator: {
      type: Function,
      default: function _default(date) {
        if (typeof __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDatetimeCreator === 'function') {
          return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDatetimeCreator(date);
        } else {
          return date;
        }
      }
    },
    datepicker: Object,
    timepicker: Object,
    tzOffset: {
      type: Number,
      default: 0
    },
    focusable: {
      type: Boolean,
      default: true
    },
    appendToBody: Boolean
  },
  data: function data() {
    return {
      newValue: this.adjustValue(this.value)
    };
  },
  computed: {
    computedValue: {
      get: function get() {
        return this.newValue;
      },
      set: function set(value) {
        if (value) {
          var val = new Date(value.getTime());

          if (this.newValue) {
            // restore time part
            if ((value.getDate() !== this.newValue.getDate() || value.getMonth() !== this.newValue.getMonth() || value.getFullYear() !== this.newValue.getFullYear()) && value.getHours() === 0 && value.getMinutes() === 0 && value.getSeconds() === 0) {
              val.setHours(this.newValue.getHours(), this.newValue.getMinutes(), this.newValue.getSeconds(), 0);
            }
          } else {
            val = this.datetimeCreator(value);
          } // check min and max range


          if (this.minDatetime && val < this.adjustValue(this.minDatetime)) {
            val = this.adjustValue(this.minDatetime);
          } else if (this.maxDatetime && val > this.adjustValue(this.maxDatetime)) {
            val = this.adjustValue(this.maxDatetime);
          }

          this.newValue = new Date(val.getTime());
        } else {
          this.newValue = this.adjustValue(this.value);
        }

        var adjustedValue = this.adjustValue(this.newValue, true); // reverse adjust

        this.$emit('input', adjustedValue);
      }
    },
    isMobileNative: function isMobileNative() {
      return this.mobileNative && this.tzOffset === 0;
    },
    isMobile: function isMobile$1() {
      return this.isMobileNative && __WEBPACK_IMPORTED_MODULE_1__helpers_js__["c" /* isMobile */].any();
    },
    minDate: function minDate() {
      if (!this.minDatetime) {
        return this.datepicker ? this.adjustValue(this.datepicker.minDate) : null;
      }

      var adjMinDatetime = this.adjustValue(this.minDatetime);
      return new Date(adjMinDatetime.getFullYear(), adjMinDatetime.getMonth(), adjMinDatetime.getDate(), 0, 0, 0, 0);
    },
    maxDate: function maxDate() {
      if (!this.maxDatetime) {
        return this.datepicker ? this.adjustValue(this.datepicker.maxDate) : null;
      }

      var adjMaxDatetime = this.adjustValue(this.maxDatetime);
      return new Date(adjMaxDatetime.getFullYear(), adjMaxDatetime.getMonth(), adjMaxDatetime.getDate(), 0, 0, 0, 0);
    },
    minTime: function minTime() {
      if (!this.minDatetime || this.newValue === null || typeof this.newValue === 'undefined') {
        return this.timepicker ? this.adjustValue(this.timepicker.minTime) : null;
      }

      var adjMinDatetime = this.adjustValue(this.minDatetime);

      if (adjMinDatetime.getFullYear() === this.newValue.getFullYear() && adjMinDatetime.getMonth() === this.newValue.getMonth() && adjMinDatetime.getDate() === this.newValue.getDate()) {
        return adjMinDatetime;
      }
    },
    maxTime: function maxTime() {
      if (!this.maxDatetime || this.newValue === null || typeof this.newValue === 'undefined') {
        return this.timepicker ? this.adjustValue(this.timepicker.maxTime) : null;
      }

      var adjMaxDatetime = this.adjustValue(this.maxDatetime);

      if (adjMaxDatetime.getFullYear() === this.newValue.getFullYear() && adjMaxDatetime.getMonth() === this.newValue.getMonth() && adjMaxDatetime.getDate() === this.newValue.getDate()) {
        return adjMaxDatetime;
      }
    },
    datepickerSize: function datepickerSize() {
      return this.datepicker && this.datepicker.size ? this.datepicker.size : this.size;
    },
    timepickerSize: function timepickerSize() {
      return this.timepicker && this.timepicker.size ? this.timepicker.size : this.size;
    },
    timepickerDisabled: function timepickerDisabled() {
      return this.timepicker && this.timepicker.disabled ? this.timepicker.disabled : this.disabled;
    }
  },
  watch: {
    value: function value(val) {
      this.newValue = this.adjustValue(this.value);
    },
    tzOffset: function tzOffset(val) {
      this.newValue = this.adjustValue(this.value);
    }
  },
  methods: {
    adjustValue: function adjustValue(value) {
      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!value) return value;

      if (reverse) {
        return new Date(value.getTime() - this.tzOffset * 60000);
      } else {
        return new Date(value.getTime() + this.tzOffset * 60000);
      }
    },
    defaultDatetimeParser: function defaultDatetimeParser(date) {
      if (typeof this.datetimeParser === 'function') {
        return this.datetimeParser(date);
      } else if (typeof __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDatetimeParser === 'function') {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDatetimeParser(date);
      } else {
        return new Date(Date.parse(date));
      }
    },
    defaultDatetimeFormatter: function defaultDatetimeFormatter(date) {
      if (typeof this.datetimeFormatter === 'function') {
        return this.datetimeFormatter(date);
      } else if (typeof __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDatetimeFormatter === 'function') {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDatetimeFormatter(date);
      } else {
        if (this.$refs.timepicker) {
          var d = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12);
          return d.toLocaleDateString() + ' ' + this.$refs.timepicker.timeFormatter(date, this.$refs.timepicker);
        }

        return null;
      }
    },

    /*
    * Parse date from string
    */
    onChangeNativePicker: function onChangeNativePicker(event) {
      var date = event.target.value;
      var s = date ? date.split(/\D/) : [];

      if (s.length >= 5) {
        var year = parseInt(s[0], 10);
        var month = parseInt(s[1], 10) - 1;
        var day = parseInt(s[2], 10);
        var hours = parseInt(s[3], 10);
        var minutes = parseInt(s[4], 10); // Seconds are omitted intentionally; they are unsupported by input
        // type=datetime-local and cause the control to fail native validation

        this.computedValue = new Date(year, month, day, hours, minutes);
      } else {
        this.computedValue = null;
      }
    },
    formatNative: function formatNative(value) {
      var date = new Date(value);

      if (value && !isNaN(date)) {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        return year + '-' + ((month < 10 ? '0' : '') + month) + '-' + ((day < 10 ? '0' : '') + day) + 'T' + ((hours < 10 ? '0' : '') + hours) + ':' + ((minutes < 10 ? '0' : '') + minutes) + ':' + ((seconds < 10 ? '0' : '') + seconds);
      }

      return '';
    },
    toggle: function toggle() {
      this.$refs.datepicker.toggle();
    }
  },
  mounted: function mounted() {
    if (!this.isMobile || this.inline) {
      // $refs attached, it's time to refresh datepicker (input)
      if (this.newValue) {
        this.$refs.datepicker.$forceUpdate();
      }
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile || _vm.inline)?_c('b-datepicker',_vm._b({ref:"datepicker",attrs:{"open-on-focus":_vm.openOnFocus,"position":_vm.position,"loading":_vm.loading,"inline":_vm.inline,"editable":_vm.editable,"expanded":_vm.expanded,"close-on-click":false,"date-formatter":_vm.defaultDatetimeFormatter,"date-parser":_vm.defaultDatetimeParser,"min-date":_vm.minDate,"max-date":_vm.maxDate,"icon":_vm.icon,"icon-pack":_vm.iconPack,"size":_vm.datepickerSize,"placeholder":_vm.placeholder,"horizontal-time-picker":_vm.horizontalTimePicker,"range":false,"disabled":_vm.disabled,"mobile-native":_vm.isMobileNative,"focusable":_vm.focusable,"append-to-body":_vm.appendToBody},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"change-month":function($event){_vm.$emit('change-month', $event);},"change-year":function($event){_vm.$emit('change-year', $event);}},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v;},expression:"computedValue"}},'b-datepicker',_vm.datepicker,false),[_c('nav',{staticClass:"level is-mobile"},[(_vm.$slots.left !== undefined)?_c('div',{staticClass:"level-item has-text-centered"},[_vm._t("left")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"level-item has-text-centered"},[_c('b-timepicker',_vm._b({ref:"timepicker",attrs:{"inline":"","editable":_vm.editable,"min-time":_vm.minTime,"max-time":_vm.maxTime,"size":_vm.timepickerSize,"disabled":_vm.timepickerDisabled,"focusable":_vm.focusable,"mobile-native":_vm.isMobileNative},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v;},expression:"computedValue"}},'b-timepicker',_vm.timepicker,false))],1),_vm._v(" "),(_vm.$slots.right !== undefined)?_c('div',{staticClass:"level-item has-text-centered"},[_vm._t("right")],2):_vm._e()])]):_c('b-input',_vm._b({ref:"input",attrs:{"type":"datetime-local","autocomplete":"off","value":_vm.formatNative(_vm.computedValue),"placeholder":_vm.placeholder,"size":_vm.size,"icon":_vm.icon,"icon-pack":_vm.iconPack,"rounded":_vm.rounded,"loading":_vm.loading,"max":_vm.formatNative(_vm.maxDate),"min":_vm.formatNative(_vm.minDate),"disabled":_vm.disabled,"readonly":false,"use-html5-validation":_vm.useHtml5Validation},on:{"focus":_vm.onFocus,"blur":_vm.onBlur},nativeOn:{"change":function($event){return _vm.onChangeNativePicker($event)}}},'b-input',_vm.$attrs,false))};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Datetimepicker = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["d" /* r */])(Vue, Datetimepicker);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "/bQp":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "/ocq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),

/***/ "01Ww":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_d0a313ea_js__ = __webpack_require__("EmVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chunk_77ffdf8b_js__ = __webpack_require__("8cDm");
/* unused harmony reexport BSelect */









var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["d" /* r */])(Vue, __WEBPACK_IMPORTED_MODULE_6__chunk_77ffdf8b_js__["a" /* S */]);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);


/***/ }),

/***/ "162o":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__("mypn");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "1Wsa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessageMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");



var MessageMixin = {
  components: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({}, __WEBPACK_IMPORTED_MODULE_1__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_1__chunk_cdfca85b_js__["a" /* I */]),
  props: {
    active: {
      type: Boolean,
      default: true
    },
    title: String,
    closable: {
      type: Boolean,
      default: true
    },
    message: String,
    type: String,
    hasIcon: Boolean,
    size: String,
    icon: String,
    iconPack: String,
    iconSize: String,
    autoClose: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 2000
    }
  },
  data: function data() {
    return {
      isActive: this.active
    };
  },
  watch: {
    active: function active(value) {
      this.isActive = value;
    },
    isActive: function isActive(value) {
      if (value) {
        this.setAutoClose();
      } else {
        if (this.timer) {
          clearTimeout(this.timer);
        }
      }
    }
  },
  computed: {
    /**
     * Icon name (MDI) based on type.
     */
    computedIcon: function computedIcon() {
      if (this.icon) {
        return this.icon;
      }

      switch (this.type) {
        case 'is-info':
          return 'information';

        case 'is-success':
          return 'check-circle';

        case 'is-warning':
          return 'alert';

        case 'is-danger':
          return 'alert-circle';

        default:
          return null;
      }
    }
  },
  methods: {
    /**
     * Close the Message and emit events.
     */
    close: function close() {
      this.isActive = false;
      this.$emit('close');
      this.$emit('update:active', false);
    },

    /**
     * Set timer to auto close message
     */
    setAutoClose: function setAutoClose() {
      var _this = this;

      if (this.autoClose) {
        this.timer = setTimeout(function () {
          if (_this.isActive) {
            _this.close();
          }
        }, this.duration);
      }
    }
  },
  mounted: function mounted() {
    this.setAutoClose();
  }
};




/***/ }),

/***/ "21It":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("FtD3");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "2DS2":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * tiny-cookie - A tiny cookie manipulation plugin
 * https://github.com/Alex1990/tiny-cookie
 * Under the MIT license | (c) Alex Chao
 */

!(function(root, factory) {

  // Uses CommonJS, AMD or browser global to create a jQuery plugin.
  // See: https://github.com/umdjs/umd
  if (true) {
    // Expose this plugin as an AMD module. Register an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node/CommonJS module
    module.exports = factory();
  } else {
    // Browser globals 
    root.Cookie = factory();
  }

}(this, function() {

  'use strict';

  // The public function which can get/set/remove cookie.
  function Cookie(key, value, opts) {
    if (value === void 0) {
      return Cookie.get(key);
    } else if (value === null) {
      Cookie.remove(key);
    } else {
      Cookie.set(key, value, opts);
    }
  }

  // Check if the cookie is enabled.
  Cookie.enabled = function() {
    var key = '__test_key';
    var enabled;

    document.cookie = key + '=1';
    enabled = !!document.cookie;

    if (enabled) Cookie.remove(key);

    return enabled;
  };

  // Get the cookie value by the key.
  Cookie.get = function(key, raw) {
    if (typeof key !== 'string' || !key) return null;

    key = '(?:^|; )' + escapeRe(key) + '(?:=([^;]*?))?(?:;|$)';

    var reKey = new RegExp(key);
    var res = reKey.exec(document.cookie);

    return res !== null ? (raw ? res[1] : decodeURIComponent(res[1])) : null;
  };

  // Get the cookie's value without decoding.
  Cookie.getRaw = function(key) {
    return Cookie.get(key, true);
  };

  // Set a cookie.
  Cookie.set = function(key, value, raw, opts) {
    if (raw !== true) {
      opts = raw;
      raw = false;
    }
    opts = opts ? convert(opts) : convert({});
    var cookie = key + '=' + (raw ? value : encodeURIComponent(value)) + opts;
    document.cookie = cookie;
  };

  // Set a cookie without encoding the value.
  Cookie.setRaw = function(key, value, opts) {
    Cookie.set(key, value, true, opts);
  };

  // Remove a cookie by the specified key.
  Cookie.remove = function(key) {
    Cookie.set(key, 'a', { expires: new Date() });
  };

  // Helper function
  // ---------------

  // Escape special characters.
  function escapeRe(str) {
    return str.replace(/[.*+?^$|[\](){}\\-]/g, '\\$&');
  }

  // Convert an object to a cookie option string.
  function convert(opts) {
    var res = '';

    for (var p in opts) {
      if (opts.hasOwnProperty(p)) {

        if (p === 'expires') {
          var expires = opts[p];
          if (typeof expires !== 'object') {
            expires += typeof expires === 'number' ? 'D' : '';
            expires = computeExpires(expires);
          }
          opts[p] = expires.toUTCString();
        }

        if (p === 'secure') {
          if (opts[p]) {
            res += ';' + p;
          }

          continue;
        }

        res += ';' + p + '=' + opts[p];
      }
    }

    if (!opts.hasOwnProperty('path')) {
      res += ';path=/';
    }

    return res;
  }

  // Return a future date by the given string.
  function computeExpires(str) {
    var expires = new Date();
    var lastCh = str.charAt(str.length - 1);
    var value = parseInt(str, 10);

    switch (lastCh) {
      case 'Y': expires.setFullYear(expires.getFullYear() + value); break;
      case 'M': expires.setMonth(expires.getMonth() + value); break;
      case 'D': expires.setDate(expires.getDate() + value); break;
      case 'h': expires.setHours(expires.getHours() + value); break;
      case 'm': expires.setMinutes(expires.getMinutes() + value); break;
      case 's': expires.setSeconds(expires.getSeconds() + value); break;
      default: expires = new Date(str);
    }

    return expires;
  }

  return Cookie;

}));


/***/ }),

/***/ "2KxR":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "2uRq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BNavbar */
/* unused harmony export BNavbarDropdown */
/* unused harmony export BNavbarItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_cca88db8_js__ = __webpack_require__("rhEV");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'NavbarBurger',
  props: {
    isOpened: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g({staticClass:"navbar-burger burger",class:{ 'is-active': _vm.isOpened },attrs:{"role":"button","aria-label":"menu","aria-expanded":_vm.isOpened}},_vm.$listeners),[_c('span',{attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{attrs:{"aria-hidden":"true"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var NavbarBurger = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var isTouch = typeof window !== 'undefined' && ('ontouchstart' in window || navigator.msMaxTouchPoints > 0);
var events = isTouch ? ['touchstart', 'click'] : ['click'];
var instances = [];

function processArgs(bindingValue) {
  var isFunction = typeof bindingValue === 'function';

  if (!isFunction && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["a" /* b */])(bindingValue) !== 'object') {
    throw new Error("v-click-outside: Binding value should be a function or an object, typeof ".concat(bindingValue, " given"));
  }

  return {
    handler: isFunction ? bindingValue : bindingValue.handler,
    middleware: bindingValue.middleware || function (isClickOutside) {
      return isClickOutside;
    },
    events: bindingValue.events || events
  };
}

function onEvent(_ref) {
  var el = _ref.el,
      event = _ref.event,
      handler = _ref.handler,
      middleware = _ref.middleware;
  var isClickOutside = event.target !== el && !el.contains(event.target);

  if (!isClickOutside) {
    return;
  }

  if (middleware(event, el)) {
    handler(event, el);
  }
}

function bind(el, _ref2) {
  var value = _ref2.value;

  var _processArgs = processArgs(value),
      _handler = _processArgs.handler,
      middleware = _processArgs.middleware,
      events = _processArgs.events;

  var instance = {
    el: el,
    eventHandlers: events.map(function (eventName) {
      return {
        event: eventName,
        handler: function handler(event) {
          return onEvent({
            event: event,
            el: el,
            handler: _handler,
            middleware: middleware
          });
        }
      };
    })
  };
  instance.eventHandlers.forEach(function (_ref3) {
    var event = _ref3.event,
        handler = _ref3.handler;
    return document.addEventListener(event, handler);
  });
  instances.push(instance);
}

function update(el, _ref4) {
  var value = _ref4.value;

  var _processArgs2 = processArgs(value),
      _handler2 = _processArgs2.handler,
      middleware = _processArgs2.middleware,
      events = _processArgs2.events; // `filter` instead of `find` for compat with IE


  var instance = instances.filter(function (instance) {
    return instance.el === el;
  })[0];
  instance.eventHandlers.forEach(function (_ref5) {
    var event = _ref5.event,
        handler = _ref5.handler;
    return document.removeEventListener(event, handler);
  });
  instance.eventHandlers = events.map(function (eventName) {
    return {
      event: eventName,
      handler: function handler(event) {
        return onEvent({
          event: event,
          el: el,
          handler: _handler2,
          middleware: middleware
        });
      }
    };
  });
  instance.eventHandlers.forEach(function (_ref6) {
    var event = _ref6.event,
        handler = _ref6.handler;
    return document.addEventListener(event, handler);
  });
}

function unbind(el) {
  // `filter` instead of `find` for compat with IE
  var instance = instances.filter(function (instance) {
    return instance.el === el;
  })[0];
  instance.eventHandlers.forEach(function (_ref7) {
    var event = _ref7.event,
        handler = _ref7.handler;
    return document.removeEventListener(event, handler);
  });
}

var directive = {
  bind: bind,
  update: update,
  unbind: unbind,
  instances: instances
};

var FIXED_TOP_CLASS = 'is-fixed-top';
var BODY_FIXED_TOP_CLASS = 'has-navbar-fixed-top';
var BODY_SPACED_FIXED_TOP_CLASS = 'has-spaced-navbar-fixed-top';
var FIXED_BOTTOM_CLASS = 'is-fixed-bottom';
var BODY_FIXED_BOTTOM_CLASS = 'has-navbar-fixed-bottom';
var BODY_SPACED_FIXED_BOTTOM_CLASS = 'has-spaced-navbar-fixed-bottom';

var isFilled = function isFilled(str) {
  return !!str;
};

var script$1 = {
  name: 'BNavbar',
  components: {
    NavbarBurger: NavbarBurger
  },
  directives: {
    clickOutside: directive
  },
  props: {
    type: [String, Object],
    transparent: {
      type: Boolean,
      default: false
    },
    fixedTop: {
      type: Boolean,
      default: false
    },
    fixedBottom: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    },
    wrapperClass: {
      type: String
    },
    closeOnClick: {
      type: Boolean,
      default: true
    },
    mobileBurger: {
      type: Boolean,
      default: true
    },
    spaced: Boolean,
    shadow: Boolean
  },
  data: function data() {
    return {
      internalIsActive: this.isActive,
      _isNavBar: true // Used internally by NavbarItem

    };
  },
  computed: {
    isOpened: function isOpened() {
      return this.internalIsActive;
    },
    computedClasses: function computedClasses() {
      var _ref;

      return [this.type, (_ref = {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_ref, FIXED_TOP_CLASS, this.fixedTop), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_ref, FIXED_BOTTOM_CLASS, this.fixedBottom), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_ref, 'is-spaced', this.spaced), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_ref, 'has-shadow', this.shadow), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_ref, 'is-transparent', this.transparent), _ref)];
    }
  },
  watch: {
    isActive: {
      handler: function handler(isActive) {
        this.internalIsActive = isActive;
      },
      immediate: true
    },
    fixedTop: {
      handler: function handler(isSet) {
        this.checkIfFixedPropertiesAreColliding();

        if (isSet) {
          // TODO Apply only one of the classes once PR is merged in Bulma:
          // https://github.com/jgthms/bulma/pull/2737
          this.setBodyClass(BODY_FIXED_TOP_CLASS);
          this.spaced && this.setBodyClass(BODY_SPACED_FIXED_TOP_CLASS);
        } else {
          this.removeBodyClass(BODY_FIXED_TOP_CLASS);
          this.removeBodyClass(BODY_SPACED_FIXED_TOP_CLASS);
        }
      },
      immediate: true
    },
    fixedBottom: {
      handler: function handler(isSet) {
        this.checkIfFixedPropertiesAreColliding();

        if (isSet) {
          // TODO Apply only one of the classes once PR is merged in Bulma:
          // https://github.com/jgthms/bulma/pull/2737
          this.setBodyClass(BODY_FIXED_BOTTOM_CLASS);
          this.spaced && this.setBodyClass(BODY_SPACED_FIXED_BOTTOM_CLASS);
        } else {
          this.removeBodyClass(BODY_FIXED_BOTTOM_CLASS);
          this.removeBodyClass(BODY_SPACED_FIXED_BOTTOM_CLASS);
        }
      },
      immediate: true
    }
  },
  methods: {
    toggleActive: function toggleActive() {
      this.internalIsActive = !this.internalIsActive;
      this.emitUpdateParentEvent();
    },
    closeMenu: function closeMenu() {
      if (this.closeOnClick) {
        this.internalIsActive = false;
        this.emitUpdateParentEvent();
      }
    },
    emitUpdateParentEvent: function emitUpdateParentEvent() {
      this.$emit('update:isActive', this.internalIsActive);
    },
    setBodyClass: function setBodyClass(className) {
      if (typeof window !== 'undefined') {
        document.body.classList.add(className);
      }
    },
    removeBodyClass: function removeBodyClass(className) {
      if (typeof window !== 'undefined') {
        document.body.classList.remove(className);
      }
    },
    checkIfFixedPropertiesAreColliding: function checkIfFixedPropertiesAreColliding() {
      var areColliding = this.fixedTop && this.fixedBottom;

      if (areColliding) {
        throw new Error('You should choose if the BNavbar is fixed bottom or fixed top, but not both');
      }
    },
    genNavbar: function genNavbar(createElement) {
      var navBarSlots = [this.genNavbarBrandNode(createElement), this.genNavbarSlotsNode(createElement)];

      if (!isFilled(this.wrapperClass)) {
        return this.genNavbarSlots(createElement, navBarSlots);
      } // It wraps the slots into a div with the provided wrapperClass prop


      var navWrapper = createElement('div', {
        class: this.wrapperClass
      }, navBarSlots);
      return this.genNavbarSlots(createElement, [navWrapper]);
    },
    genNavbarSlots: function genNavbarSlots(createElement, slots) {
      return createElement('nav', {
        staticClass: 'navbar',
        class: this.computedClasses,
        attrs: {
          role: 'navigation',
          'aria-label': 'main navigation'
        },
        directives: [{
          name: 'click-outside',
          value: this.closeMenu
        }]
      }, slots);
    },
    genNavbarBrandNode: function genNavbarBrandNode(createElement) {
      return createElement('div', {
        class: 'navbar-brand'
      }, [this.$slots.brand, this.genBurgerNode(createElement)]);
    },
    genBurgerNode: function genBurgerNode(createElement) {
      if (this.mobileBurger) {
        var defaultBurgerNode = createElement('navbar-burger', {
          props: {
            isOpened: this.isOpened
          },
          on: {
            click: this.toggleActive
          }
        });
        var hasBurgerSlot = !!this.$scopedSlots.burger;
        return hasBurgerSlot ? this.$scopedSlots.burger({
          isOpened: this.isOpened,
          toggleActive: this.toggleActive
        }) : defaultBurgerNode;
      }
    },
    genNavbarSlotsNode: function genNavbarSlotsNode(createElement) {
      return createElement('div', {
        staticClass: 'navbar-menu',
        class: {
          'is-active': this.isOpened
        }
      }, [this.genMenuPosition(createElement, 'start'), this.genMenuPosition(createElement, 'end')]);
    },
    genMenuPosition: function genMenuPosition(createElement, positionName) {
      return createElement('div', {
        staticClass: "navbar-".concat(positionName)
      }, this.$slots[positionName]);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.fixedTop) {
      var className = this.spaced ? BODY_SPACED_FIXED_TOP_CLASS : BODY_FIXED_TOP_CLASS;
      this.removeBodyClass(className);
    } else if (this.fixedBottom) {
      var _className = this.spaced ? BODY_SPACED_FIXED_BOTTOM_CLASS : BODY_FIXED_BOTTOM_CLASS;

      this.removeBodyClass(_className);
    }
  },
  render: function render(createElement, fn) {
    return this.genNavbar(createElement);
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = undefined;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Navbar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chunk_cca88db8_js__["c" /* _ */])(
    {},
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
var clickableWhiteList = ['div', 'span'];
var script$2 = {
  name: 'BNavbarItem',
  inheritAttrs: false,
  props: {
    tag: {
      type: String,
      default: 'a'
    },
    active: Boolean
  },
  methods: {
    /**
     * Keypress event that is bound to the document
     */
    keyPress: function keyPress(event) {
      // Esc key
      // TODO: use code instead (because keyCode is actually deprecated)
      // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
      if (event.keyCode === 27) {
        this.closeMenuRecursive(this, ['NavBar']);
      }
    },

    /**
     * Close parent if clicked outside.
     */
    handleClickEvent: function handleClickEvent(event) {
      var isOnWhiteList = clickableWhiteList.some(function (item) {
        return item === event.target.localName;
      });

      if (!isOnWhiteList) {
        var parent = this.closeMenuRecursive(this, ['NavbarDropdown', 'NavBar']);
        if (parent.$data._isNavbarDropdown) this.closeMenuRecursive(parent, ['NavBar']);
      }
    },

    /**
     * Close parent recursively
     */
    closeMenuRecursive: function closeMenuRecursive(current, targetComponents) {
      if (!current.$parent) return null;
      var foundItem = targetComponents.reduce(function (acc, item) {
        if (current.$parent.$data["_is".concat(item)]) {
          current.$parent.closeMenu();
          return current.$parent;
        }

        return acc;
      }, null);
      return foundItem || this.closeMenuRecursive(current.$parent, targetComponents);
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      this.$el.addEventListener('click', this.handleClickEvent);
      document.addEventListener('keyup', this.keyPress);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      this.$el.removeEventListener('click', this.handleClickEvent);
      document.removeEventListener('keyup', this.keyPress);
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",staticClass:"navbar-item",class:{
            'is-active': _vm.active
        }},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var NavbarItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

//
var script$3 = {
  name: 'BNavbarDropdown',
  directives: {
    clickOutside: directive
  },
  props: {
    label: String,
    hoverable: Boolean,
    active: Boolean,
    right: Boolean,
    arrowless: Boolean,
    boxed: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    collapsible: Boolean
  },
  data: function data() {
    return {
      newActive: this.active,
      isHoverable: this.hoverable,
      _isNavbarDropdown: true // Used internally by NavbarItem

    };
  },
  watch: {
    active: function active(value) {
      this.newActive = value;
    }
  },
  methods: {
    showMenu: function showMenu() {
      this.newActive = true;
    },

    /**
    * See naming convetion of navbaritem
    */
    closeMenu: function closeMenu() {
      this.newActive = !this.closeOnClick;

      if (this.hoverable && this.closeOnClick) {
        this.isHoverable = false;
      }
    },
    checkHoverable: function checkHoverable() {
      if (this.hoverable) {
        this.isHoverable = true;
      }
    }
  }
};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeMenu),expression:"closeMenu"}],staticClass:"navbar-item has-dropdown",class:{
            'is-hoverable': _vm.isHoverable,
            'is-active': _vm.newActive
        },on:{"mouseenter":_vm.checkHoverable}},[_c('a',{staticClass:"navbar-link",class:{
                'is-arrowless': _vm.arrowless,
                'is-active': _vm.newActive && _vm.collapsible
            },attrs:{"role":"menuitem","aria-haspopup":"true","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.newActive = !_vm.newActive;}}},[(_vm.label)?[_vm._v(_vm._s(_vm.label))]:_vm._t("label")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsible || (_vm.collapsible && _vm.newActive)),expression:"!collapsible || (collapsible && newActive)"}],staticClass:"navbar-dropdown",class:{
                'is-right': _vm.right,
                'is-boxed': _vm.boxed,
            }},[_vm._t("default")],2)])};
var __vue_staticRenderFns__$2 = [];

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var NavbarDropdown = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chunk_cca88db8_js__["d" /* r */])(Vue, Navbar);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chunk_cca88db8_js__["d" /* r */])(Vue, NavbarItem);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chunk_cca88db8_js__["d" /* r */])(Vue, NavbarDropdown);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "3Eo+":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "3fs2":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("RY/4");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var Iterators = __webpack_require__("/bQp");
module.exports = __webpack_require__("FeBl").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "3wcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalProgrammatic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_42f463e6_js__ = __webpack_require__("mMDG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_0cb0546b_js__ = __webpack_require__("aGWY");
/* unused harmony reexport BModal */








var localVueInstance;
var ModalProgrammatic = {
  open: function open(params) {
    var parent;

    if (typeof params === 'string') {
      params = {
        content: params
      };
    }

    var defaultParam = {
      programmatic: true
    };

    if (params.parent) {
      parent = params.parent;
      delete params.parent;
    }

    var propsData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* merge */])(defaultParam, params);
    var vm = typeof window !== 'undefined' && window.Vue ? window.Vue : localVueInstance || __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["d" /* V */];
    var ModalComponent = vm.extend(__WEBPACK_IMPORTED_MODULE_5__chunk_0cb0546b_js__["a" /* M */]);
    return new ModalComponent({
      parent: parent,
      el: document.createElement('div'),
      propsData: propsData
    });
  }
};
var Plugin = {
  install: function install(Vue) {
    localVueInstance = Vue;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["d" /* r */])(Vue, __WEBPACK_IMPORTED_MODULE_5__chunk_0cb0546b_js__["a" /* M */]);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["a"])(Vue, 'modal', ModalProgrammatic);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "4mcu":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "4xRR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BLoading */
/* unused harmony export LoadingProgrammatic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_b9bdb0e4_js__ = __webpack_require__("UZQh");






//
var script = {
  name: 'BLoading',
  props: {
    active: Boolean,
    programmatic: Boolean,
    container: [Object, Function, __WEBPACK_IMPORTED_MODULE_4__chunk_b9bdb0e4_js__["b" /* H */]],
    isFullPage: {
      type: Boolean,
      default: true
    },
    animation: {
      type: String,
      default: 'fade'
    },
    canCancel: {
      type: Boolean,
      default: false
    },
    onCancel: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      isActive: this.active || false,
      displayInFullPage: this.isFullPage
    };
  },
  watch: {
    active: function active(value) {
      this.isActive = value;
    },
    isFullPage: function isFullPage(value) {
      this.displayInFullPage = value;
    }
  },
  methods: {
    /**
    * Close the Modal if canCancel.
    */
    cancel: function cancel() {
      if (!this.canCancel || !this.isActive) return;
      this.close();
    },

    /**
    * Emit events, and destroy modal if it's programmatic.
    */
    close: function close() {
      var _this = this;

      this.onCancel.apply(null, arguments);
      this.$emit('close');
      this.$emit('update:active', false); // Timeout for the animation complete before destroying

      if (this.programmatic) {
        this.isActive = false;
        setTimeout(function () {
          _this.$destroy();

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["b" /* removeElement */])(_this.$el);
        }, 150);
      }
    },

    /**
    * Keypress event that is bound to the document.
    */
    keyPress: function keyPress(event) {
      // Esc key
      if (event.keyCode === 27) this.cancel();
    }
  },
  created: function created() {
    if (typeof window !== 'undefined') {
      document.addEventListener('keyup', this.keyPress);
    }
  },
  beforeMount: function beforeMount() {
    // Insert the Loading component in body tag
    // only if it's programmatic
    if (this.programmatic) {
      if (!this.container) {
        document.body.appendChild(this.$el);
      } else {
        this.displayInFullPage = false;
        this.$emit('update:is-full-page', false);
        this.container.appendChild(this.$el);
      }
    }
  },
  mounted: function mounted() {
    if (this.programmatic) this.isActive = true;
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      document.removeEventListener('keyup', this.keyPress);
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.animation}},[(_vm.isActive)?_c('div',{staticClass:"loading-overlay is-active",class:{ 'is-full-page': _vm.displayInFullPage }},[_c('div',{staticClass:"loading-background",on:{"click":_vm.cancel}}),_vm._v(" "),_vm._t("default",[_c('div',{staticClass:"loading-icon"})])],2):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Loading = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var localVueInstance;
var LoadingProgrammatic = {
  open: function open(params) {
    var defaultParam = {
      programmatic: true
    };
    var propsData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* merge */])(defaultParam, params);
    var vm = typeof window !== 'undefined' && window.Vue ? window.Vue : localVueInstance || __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["d" /* V */];
    var LoadingComponent = vm.extend(Loading);
    return new LoadingComponent({
      el: document.createElement('div'),
      propsData: propsData
    });
  }
};
var Plugin = {
  install: function install(Vue) {
    localVueInstance = Vue;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["d" /* r */])(Vue, Loading);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["a"])(Vue, 'loading', LoadingProgrammatic);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "52gC":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "5PlU":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("RY/4");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var Iterators = __webpack_require__("/bQp");
module.exports = __webpack_require__("FeBl").isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ "5VQ+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "5udn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Timepicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_d1591eb8_js__ = __webpack_require__("QR9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_1196ee55_js__ = __webpack_require__("iBFZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_4d76806f_js__ = __webpack_require__("t4YS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chunk_eb60b35a_js__ = __webpack_require__("RbWz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chunk_77ffdf8b_js__ = __webpack_require__("8cDm");









var _components;
var script = {
  name: 'BTimepicker',
  components: (_components = {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_3__chunk_d1591eb8_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_3__chunk_d1591eb8_js__["a" /* I */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_6__chunk_eb60b35a_js__["a" /* F */].name, __WEBPACK_IMPORTED_MODULE_6__chunk_eb60b35a_js__["a" /* F */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_7__chunk_77ffdf8b_js__["a" /* S */].name, __WEBPACK_IMPORTED_MODULE_7__chunk_77ffdf8b_js__["a" /* S */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_1__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_1__chunk_cdfca85b_js__["a" /* I */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_5__chunk_4d76806f_js__["a" /* D */].name, __WEBPACK_IMPORTED_MODULE_5__chunk_4d76806f_js__["a" /* D */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_5__chunk_4d76806f_js__["b" /* a */].name, __WEBPACK_IMPORTED_MODULE_5__chunk_4d76806f_js__["b" /* a */]), _components),
  mixins: [__WEBPACK_IMPORTED_MODULE_4__chunk_1196ee55_js__["a" /* T */]],
  inheritAttrs: false,
  data: function data() {
    return {
      _isTimepicker: true
    };
  },
  computed: {
    nativeStep: function nativeStep() {
      if (this.enableSeconds) return '1';
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timepicker control",class:[_vm.size, {'is-expanded': _vm.expanded}]},[(!_vm.isMobile || _vm.inline)?_c('b-dropdown',{ref:"dropdown",attrs:{"position":_vm.position,"disabled":_vm.disabled,"inline":_vm.inline,"append-to-body":_vm.appendToBody,"append-to-body-copy-parent":""},on:{"active-change":_vm.onActiveChange}},[(!_vm.inline)?_c('b-input',_vm._b({ref:"input",attrs:{"slot":"trigger","autocomplete":"off","value":_vm.formatValue(_vm.computedValue),"placeholder":_vm.placeholder,"size":_vm.size,"icon":_vm.icon,"icon-pack":_vm.iconPack,"loading":_vm.loading,"disabled":_vm.disabled,"readonly":!_vm.editable,"rounded":_vm.rounded,"use-html5-validation":_vm.useHtml5Validation},on:{"focus":_vm.handleOnFocus},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.toggle(true);},"change":function($event){_vm.onChange($event.target.value);}},slot:"trigger"},'b-input',_vm.$attrs,false)):_vm._e(),_vm._v(" "),_c('b-dropdown-item',{attrs:{"disabled":_vm.disabled,"focusable":_vm.focusable,"custom":""}},[_c('b-field',{attrs:{"grouped":"","position":"is-centered"}},[_c('b-select',{attrs:{"disabled":_vm.disabled,"placeholder":"00"},nativeOn:{"change":function($event){_vm.onHoursChange($event.target.value);}},model:{value:(_vm.hoursSelected),callback:function ($$v) {_vm.hoursSelected=$$v;},expression:"hoursSelected"}},_vm._l((_vm.hours),function(hour){return _c('option',{key:hour.value,attrs:{"disabled":_vm.isHourDisabled(hour.value)},domProps:{"value":hour.value}},[_vm._v("\r\n                            "+_vm._s(hour.label)+"\r\n                        ")])})),_vm._v(" "),_c('span',{staticClass:"control is-colon"},[_vm._v(":")]),_vm._v(" "),_c('b-select',{attrs:{"disabled":_vm.disabled,"placeholder":"00"},nativeOn:{"change":function($event){_vm.onMinutesChange($event.target.value);}},model:{value:(_vm.minutesSelected),callback:function ($$v) {_vm.minutesSelected=$$v;},expression:"minutesSelected"}},_vm._l((_vm.minutes),function(minute){return _c('option',{key:minute.value,attrs:{"disabled":_vm.isMinuteDisabled(minute.value)},domProps:{"value":minute.value}},[_vm._v("\r\n                            "+_vm._s(minute.label)+"\r\n                        ")])})),_vm._v(" "),(_vm.enableSeconds)?[_c('span',{staticClass:"control is-colon"},[_vm._v(":")]),_vm._v(" "),_c('b-select',{attrs:{"disabled":_vm.disabled,"placeholder":"00"},nativeOn:{"change":function($event){_vm.onSecondsChange($event.target.value);}},model:{value:(_vm.secondsSelected),callback:function ($$v) {_vm.secondsSelected=$$v;},expression:"secondsSelected"}},_vm._l((_vm.seconds),function(second){return _c('option',{key:second.value,attrs:{"disabled":_vm.isSecondDisabled(second.value)},domProps:{"value":second.value}},[_vm._v("\r\n                                "+_vm._s(second.label)+"\r\n                            ")])}))]:_vm._e(),_vm._v(" "),(!_vm.isHourFormat24)?_c('b-select',{attrs:{"disabled":_vm.disabled},nativeOn:{"change":function($event){_vm.onMeridienChange($event.target.value);}},model:{value:(_vm.meridienSelected),callback:function ($$v) {_vm.meridienSelected=$$v;},expression:"meridienSelected"}},_vm._l((_vm.meridiens),function(meridien){return _c('option',{key:meridien,domProps:{"value":meridien}},[_vm._v("\r\n                            "+_vm._s(meridien)+"\r\n                        ")])})):_vm._e()],2),_vm._v(" "),(_vm.$slots.default !== undefined && _vm.$slots.default.length)?_c('footer',{staticClass:"timepicker-footer"},[_vm._t("default")],2):_vm._e()],1)],1):_c('b-input',_vm._b({ref:"input",attrs:{"type":"time","step":_vm.nativeStep,"autocomplete":"off","value":_vm.formatHHMMSS(_vm.computedValue),"placeholder":_vm.placeholder,"size":_vm.size,"icon":_vm.icon,"icon-pack":_vm.iconPack,"rounded":_vm.rounded,"loading":_vm.loading,"max":_vm.formatHHMMSS(_vm.maxTime),"min":_vm.formatHHMMSS(_vm.minTime),"disabled":_vm.disabled,"readonly":false,"use-html5-validation":_vm.useHtml5Validation},on:{"focus":_vm.handleOnFocus,"blur":function($event){_vm.onBlur() && _vm.checkHtml5Validity();}},nativeOn:{"change":function($event){_vm.onChange($event.target.value);}}},'b-input',_vm.$attrs,false))],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Timepicker = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );




/***/ }),

/***/ "7+uW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("162o").setImmediate))

/***/ }),

/***/ "77Pl":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "7GwW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var settle = __webpack_require__("21It");
var cookies = __webpack_require__("p1b6");
var buildURL = __webpack_require__("DQCr");
var buildFullPath = __webpack_require__("Oi+a");
var parseHeaders = __webpack_require__("oJlt");
var isURLSameOrigin = __webpack_require__("GHBc");
var createError = __webpack_require__("FtD3");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "7KvD":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "82Mu":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var macrotask = __webpack_require__("L42u").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("R9M2")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "880/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("hJx8");


/***/ }),

/***/ "8cDm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Select; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_d0a313ea_js__ = __webpack_require__("EmVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__ = __webpack_require__("rhEV");





var script = {
  name: 'BSelect',
  components: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({}, __WEBPACK_IMPORTED_MODULE_2__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_2__chunk_cdfca85b_js__["a" /* I */]),
  mixins: [__WEBPACK_IMPORTED_MODULE_1__chunk_d0a313ea_js__["a" /* F */]],
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number, Boolean, Object, Array, Function],
      default: null
    },
    placeholder: String,
    multiple: Boolean,
    nativeSize: [String, Number]
  },
  data: function data() {
    return {
      selected: this.value,
      _elementRef: 'select'
    };
  },
  computed: {
    computedValue: {
      get: function get() {
        return this.selected;
      },
      set: function set(value) {
        this.selected = value;
        this.$emit('input', value);
        !this.isValid && this.checkHtml5Validity();
      }
    },
    spanClasses: function spanClasses() {
      return [this.size, this.statusType, {
        'is-fullwidth': this.expanded,
        'is-loading': this.loading,
        'is-multiple': this.multiple,
        'is-rounded': this.rounded,
        'is-empty': this.selected === null
      }];
    }
  },
  watch: {
    /**
    * When v-model is changed:
    *   1. Set the selected option.
    *   2. If it's invalid, validate again.
    */
    value: function value(_value) {
      this.selected = _value;
      !this.isValid && this.checkHtml5Validity();
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control",class:{ 'is-expanded': _vm.expanded, 'has-icons-left': _vm.icon }},[_c('span',{staticClass:"select",class:_vm.spanClasses},[_c('select',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.computedValue),expression:"computedValue"}],ref:"select",attrs:{"multiple":_vm.multiple,"size":_vm.nativeSize},on:{"blur":function($event){_vm.$emit('blur', $event) && _vm.checkHtml5Validity();},"focus":function($event){_vm.$emit('focus', $event);},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.computedValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0];}}},'select',_vm.$attrs,false),[(_vm.placeholder)?[(_vm.computedValue == null)?_c('option',{attrs:{"disabled":"","hidden":""},domProps:{"value":null}},[_vm._v("\r\n                        "+_vm._s(_vm.placeholder)+"\r\n                    ")]):_vm._e()]:_vm._e(),_vm._v(" "),_vm._t("default")],2)]),_vm._v(" "),(_vm.icon)?_c('b-icon',{staticClass:"is-left",attrs:{"icon":_vm.icon,"pack":_vm.iconPack,"size":_vm.iconSize}}):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Select = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );




/***/ }),

/***/ "94VQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("Yobk");
var descriptor = __webpack_require__("X8DO");
var setToStringTag = __webpack_require__("e6n0");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("hJx8")(IteratorPrototype, __webpack_require__("dSzd")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "ATYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BTaginput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_d0a313ea_js__ = __webpack_require__("EmVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__ = __webpack_require__("QR9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chunk_3fcea532_js__ = __webpack_require__("es+Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chunk_7292bea2_js__ = __webpack_require__("vNXG");










var _components;
var script = {
  name: 'BTaginput',
  components: (_components = {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_7__chunk_3fcea532_js__["a" /* A */].name, __WEBPACK_IMPORTED_MODULE_7__chunk_3fcea532_js__["a" /* A */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_8__chunk_7292bea2_js__["a" /* T */].name, __WEBPACK_IMPORTED_MODULE_8__chunk_7292bea2_js__["a" /* T */]), _components),
  mixins: [__WEBPACK_IMPORTED_MODULE_3__chunk_d0a313ea_js__["a" /* F */]],
  inheritAttrs: false,
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: String,
    rounded: {
      type: Boolean,
      default: false
    },
    attached: {
      type: Boolean,
      default: false
    },
    maxtags: {
      type: [Number, String],
      required: false
    },
    hasCounter: {
      type: Boolean,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultTaginputHasCounter;
      }
    },
    field: {
      type: String,
      default: 'value'
    },
    autocomplete: Boolean,
    nativeAutocomplete: String,
    openOnFocus: Boolean,
    disabled: Boolean,
    ellipsis: Boolean,
    closable: {
      type: Boolean,
      default: true
    },
    confirmKeyCodes: {
      type: Array,
      default: function _default() {
        return [13, 188];
      }
    },
    removeOnKeys: {
      type: Array,
      default: function _default() {
        return [8];
      }
    },
    allowNew: Boolean,
    onPasteSeparators: {
      type: Array,
      default: function _default() {
        return [','];
      }
    },
    beforeAdding: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    allowDuplicates: {
      type: Boolean,
      default: false
    },
    checkInfiniteScroll: {
      type: Boolean,
      default: false
    },
    appendToBody: Boolean
  },
  data: function data() {
    return {
      tags: Array.isArray(this.value) ? this.value.slice(0) : this.value || [],
      newTag: '',
      _elementRef: 'input',
      _isTaginput: true
    };
  },
  computed: {
    rootClasses: function rootClasses() {
      return {
        'is-expanded': this.expanded
      };
    },
    containerClasses: function containerClasses() {
      return {
        'is-focused': this.isFocused,
        'is-focusable': this.hasInput
      };
    },
    valueLength: function valueLength() {
      return this.newTag.trim().length;
    },
    defaultSlotName: function defaultSlotName() {
      return this.hasDefaultSlot ? 'default' : 'dontrender';
    },
    emptySlotName: function emptySlotName() {
      return this.hasEmptySlot ? 'empty' : 'dontrender';
    },
    headerSlotName: function headerSlotName() {
      return this.hasHeaderSlot ? 'header' : 'dontrender';
    },
    footerSlotName: function footerSlotName() {
      return this.hasFooterSlot ? 'footer' : 'dontrender';
    },
    hasDefaultSlot: function hasDefaultSlot() {
      return !!this.$scopedSlots.default;
    },
    hasEmptySlot: function hasEmptySlot() {
      return !!this.$slots.empty;
    },
    hasHeaderSlot: function hasHeaderSlot() {
      return !!this.$slots.header;
    },
    hasFooterSlot: function hasFooterSlot() {
      return !!this.$slots.footer;
    },

    /**
     * Show the input field if a maxtags hasn't been set or reached.
     */
    hasInput: function hasInput() {
      return this.maxtags == null || this.tagsLength < this.maxtags;
    },
    tagsLength: function tagsLength() {
      return this.tags.length;
    },

    /**
     * If Taginput has onPasteSeparators prop,
     * returning new RegExp used to split pasted string.
     */
    separatorsAsRegExp: function separatorsAsRegExp() {
      var sep = this.onPasteSeparators;
      return sep.length ? new RegExp(sep.map(function (s) {
        return s ? s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') : null;
      }).join('|'), 'g') : null;
    }
  },
  watch: {
    /**
     * When v-model is changed set internal value.
     */
    value: function value(_value) {
      this.tags = Array.isArray(_value) ? _value.slice(0) : _value || [];
    },
    hasInput: function hasInput() {
      if (!this.hasInput) this.onBlur();
    }
  },
  methods: {
    addTag: function addTag(tag) {
      var tagToAdd = tag || this.newTag.trim();

      if (tagToAdd) {
        if (!this.autocomplete) {
          var reg = this.separatorsAsRegExp;

          if (reg && tagToAdd.match(reg)) {
            tagToAdd.split(reg).map(function (t) {
              return t.trim();
            }).filter(function (t) {
              return t.length !== 0;
            }).map(this.addTag);
            return;
          }
        } // Remove the tag input previously added (if not allowDuplicates).


        if (!this.allowDuplicates) {
          var index = this.tags.indexOf(tagToAdd);

          if (index >= 0) {
            this.tags.splice(index, 1);
            return;
          }
        } // Add the tag input if it is not blank
        // or previously added (if not allowDuplicates).


        var add = !this.allowDuplicates ? this.tags.indexOf(tagToAdd) === -1 : true;

        if (add && this.beforeAdding(tagToAdd)) {
          this.tags.push(tagToAdd);
          this.$emit('input', this.tags);
          this.$emit('add', tagToAdd);
        }
      }

      this.newTag = '';
    },
    getNormalizedTagText: function getNormalizedTagText(tag) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["a" /* b */])(tag) === 'object') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["e" /* getValueByPath */])(tag, this.field);
      }

      return tag;
    },
    customOnBlur: function customOnBlur(event) {
      // Add tag on-blur if not select only
      if (!this.autocomplete) this.addTag();
      this.onBlur(event);
    },
    onSelect: function onSelect(option) {
      var _this = this;

      if (!option) return;
      this.addTag(option);
      this.$nextTick(function () {
        _this.newTag = '';
      });
    },
    removeTag: function removeTag(index, event) {
      var tag = this.tags.splice(index, 1)[0];
      this.$emit('input', this.tags);
      this.$emit('remove', tag);
      if (event) event.stopPropagation();

      if (this.openOnFocus && this.$refs.autocomplete) {
        this.$refs.autocomplete.focus();
      }

      return tag;
    },
    removeLastTag: function removeLastTag() {
      if (this.tagsLength > 0) {
        this.removeTag(this.tagsLength - 1);
      }
    },
    keydown: function keydown(event) {
      if (this.removeOnKeys.indexOf(event.keyCode) !== -1 && !this.newTag.length) {
        this.removeLastTag();
      } // Stop if is to accept select only


      if (this.autocomplete && !this.allowNew) return;

      if (this.confirmKeyCodes.indexOf(event.keyCode) >= 0) {
        event.preventDefault();
        this.addTag();
      }
    },
    onTyping: function onTyping(event) {
      this.$emit('typing', event.trim());
    },
    emitInfiniteScroll: function emitInfiniteScroll() {
      this.$emit('infinite-scroll');
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"taginput control",class:_vm.rootClasses},[_c('div',{staticClass:"taginput-container",class:[_vm.statusType, _vm.size, _vm.containerClasses],attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.hasInput && _vm.focus($event);}}},[_vm._t("selected",_vm._l((_vm.tags),function(tag,index){return _c('b-tag',{key:_vm.getNormalizedTagText(tag) + index,attrs:{"type":_vm.type,"size":_vm.size,"rounded":_vm.rounded,"attached":_vm.attached,"tabstop":false,"disabled":_vm.disabled,"ellipsis":_vm.ellipsis,"closable":_vm.closable,"title":_vm.ellipsis && _vm.getNormalizedTagText(tag)},on:{"close":function($event){_vm.removeTag(index, $event);}}},[_vm._t("tag",[_vm._v("\r\n                        "+_vm._s(_vm.getNormalizedTagText(tag))+"\r\n                    ")],{tag:tag})],2)}),{tags:_vm.tags}),_vm._v(" "),(_vm.hasInput)?_c('b-autocomplete',_vm._b({ref:"autocomplete",attrs:{"data":_vm.data,"field":_vm.field,"icon":_vm.icon,"icon-pack":_vm.iconPack,"maxlength":_vm.maxlength,"has-counter":false,"size":_vm.size,"disabled":_vm.disabled,"loading":_vm.loading,"autocomplete":_vm.nativeAutocomplete,"open-on-focus":_vm.openOnFocus,"keep-open":_vm.openOnFocus,"keep-first":!_vm.allowNew,"use-html5-validation":_vm.useHtml5Validation,"check-infinite-scroll":_vm.checkInfiniteScroll,"append-to-body":_vm.appendToBody},on:{"typing":_vm.onTyping,"focus":_vm.onFocus,"blur":_vm.customOnBlur,"select":_vm.onSelect,"infinite-scroll":_vm.emitInfiniteScroll},nativeOn:{"keydown":function($event){return _vm.keydown($event)}},scopedSlots:_vm._u([{key:_vm.defaultSlotName,fn:function(props){return [_vm._t("default",null,{option:props.option,index:props.index})]}}]),model:{value:(_vm.newTag),callback:function ($$v) {_vm.newTag=$$v;},expression:"newTag"}},'b-autocomplete',_vm.$attrs,false),[_c('template',{slot:_vm.headerSlotName},[_vm._t("header")],2),_vm._v(" "),_c('template',{slot:_vm.emptySlotName},[_vm._t("empty")],2),_vm._v(" "),_c('template',{slot:_vm.footerSlotName},[_vm._t("footer")],2)],2):_vm._e()],2),_vm._v(" "),(_vm.hasCounter && (_vm.maxtags || _vm.maxlength))?_c('small',{staticClass:"help counter"},[(_vm.maxlength && _vm.valueLength > 0)?[_vm._v("\r\n                "+_vm._s(_vm.valueLength)+" / "+_vm._s(_vm.maxlength)+"\r\n            ")]:(_vm.maxtags)?[_vm._v("\r\n                "+_vm._s(_vm.tagsLength)+" / "+_vm._s(_vm.maxtags)+"\r\n            ")]:_vm._e()],2):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Taginput = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["d" /* r */])(Vue, Taginput);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "BO1k":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("fxRn"), __esModule: true };

/***/ }),

/***/ "CXw9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("O4g8");
var global = __webpack_require__("7KvD");
var ctx = __webpack_require__("+ZMJ");
var classof = __webpack_require__("RY/4");
var $export = __webpack_require__("kM2E");
var isObject = __webpack_require__("EqjI");
var aFunction = __webpack_require__("lOnJ");
var anInstance = __webpack_require__("2KxR");
var forOf = __webpack_require__("NWt+");
var speciesConstructor = __webpack_require__("t8x9");
var task = __webpack_require__("L42u").set;
var microtask = __webpack_require__("82Mu")();
var newPromiseCapabilityModule = __webpack_require__("qARP");
var perform = __webpack_require__("dNDb");
var userAgent = __webpack_require__("iUbK");
var promiseResolve = __webpack_require__("fJUb");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("dSzd")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("xH/j")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("e6n0")($Promise, PROMISE);
__webpack_require__("bRrM")(PROMISE);
Wrapper = __webpack_require__("FeBl")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("dY0y")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "Cdx3":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("sB3e");
var $keys = __webpack_require__("lktj");

__webpack_require__("uqUo")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "D2L2":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "DQCr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "DUeU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),

/***/ "DuR2":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "EGZi":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "EmVE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormElementMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_6985c8ce_js__ = __webpack_require__("V5O4");


var FormElementMixin = {
  props: {
    size: String,
    expanded: Boolean,
    loading: Boolean,
    rounded: Boolean,
    icon: String,
    iconPack: String,
    // Native options to use in HTML5 validation
    autocomplete: String,
    maxlength: [Number, String],
    useHtml5Validation: {
      type: Boolean,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_0__chunk_6985c8ce_js__["a" /* c */].defaultUseHtml5Validation;
      }
    },
    validationMessage: String
  },
  data: function data() {
    return {
      isValid: true,
      isFocused: false,
      newIconPack: this.iconPack || __WEBPACK_IMPORTED_MODULE_0__chunk_6985c8ce_js__["a" /* c */].defaultIconPack
    };
  },
  computed: {
    /**
     * Find parent Field, max 3 levels deep.
     */
    parentField: function parentField() {
      var parent = this.$parent;

      for (var i = 0; i < 3; i++) {
        if (parent && !parent.$data._isField) {
          parent = parent.$parent;
        }
      }

      return parent;
    },

    /**
     * Get the type prop from parent if it's a Field.
     */
    statusType: function statusType() {
      if (!this.parentField) return;
      if (!this.parentField.newType) return;

      if (typeof this.parentField.newType === 'string') {
        return this.parentField.newType;
      } else {
        for (var key in this.parentField.newType) {
          if (this.parentField.newType[key]) {
            return key;
          }
        }
      }
    },

    /**
     * Get the message prop from parent if it's a Field.
     */
    statusMessage: function statusMessage() {
      if (!this.parentField) return;
      return this.parentField.newMessage || this.parentField.$slots.message;
    },

    /**
     * Fix icon size for inputs, large was too big
     */
    iconSize: function iconSize() {
      switch (this.size) {
        case 'is-small':
          return this.size;

        case 'is-medium':
          return;

        case 'is-large':
          return this.newIconPack === 'mdi' ? 'is-medium' : '';
      }
    }
  },
  methods: {
    /**
     * Focus method that work dynamically depending on the component.
     */
    focus: function focus() {
      var _this = this;

      if (this.$data._elementRef === undefined) return;
      this.$nextTick(function () {
        var el = _this.$el.querySelector(_this.$data._elementRef);

        if (el) el.focus();
      });
    },
    onBlur: function onBlur($event) {
      this.isFocused = false;
      this.$emit('blur', $event);
      this.checkHtml5Validity();
    },
    onFocus: function onFocus($event) {
      this.isFocused = true;
      this.$emit('focus', $event);
    },
    getElement: function getElement() {
      return this.$el.querySelector(this.$data._elementRef);
    },
    setInvalid: function setInvalid() {
      var type = 'is-danger';
      var message = this.validationMessage || this.getElement().validationMessage;
      this.setValidity(type, message);
    },
    setValidity: function setValidity(type, message) {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.parentField) {
          // Set type only if not defined
          if (!_this2.parentField.type) {
            _this2.parentField.newType = type;
          } // Set message only if not defined


          if (!_this2.parentField.message) {
            _this2.parentField.newMessage = message;
          }
        }
      });
    },

    /**
     * Check HTML5 validation, set isValid property.
     * If validation fail, send 'is-danger' type,
     * and error message to parent if it's a Field.
     */
    checkHtml5Validity: function checkHtml5Validity() {
      if (!this.useHtml5Validation) return;
      if (this.$refs[this.$data._elementRef] === undefined) return;
      if (this.getElement() === null) return;

      if (!this.getElement().checkValidity()) {
        this.setInvalid();
        this.isValid = false;
      } else {
        this.setValidity(null, null);
        this.isValid = true;
      }

      return this.isValid;
    }
  }
};




/***/ }),

/***/ "EqBC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("kM2E");
var core = __webpack_require__("FeBl");
var global = __webpack_require__("7KvD");
var speciesConstructor = __webpack_require__("t8x9");
var promiseResolve = __webpack_require__("fJUb");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "EqjI":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "EzMU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BTable */
/* unused harmony export BTableColumn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_d0a313ea_js__ = __webpack_require__("EmVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__ = __webpack_require__("QR9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chunk_2793447b_js__ = __webpack_require__("gNW3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chunk_7bdbd626_js__ = __webpack_require__("QBkZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__chunk_77ffdf8b_js__ = __webpack_require__("8cDm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__chunk_bd608559_js__ = __webpack_require__("lZGu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__chunk_0e3f4fb5_js__ = __webpack_require__("ji3u");













var _components;
var script = {
  name: 'BTableMobileSort',
  components: (_components = {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_9__chunk_77ffdf8b_js__["a" /* S */].name, __WEBPACK_IMPORTED_MODULE_9__chunk_77ffdf8b_js__["a" /* S */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__["a" /* I */]), _components),
  props: {
    currentSortColumn: Object,
    sortMultipleData: Array,
    isAsc: Boolean,
    columns: Array,
    placeholder: String,
    iconPack: String,
    sortIcon: {
      type: String,
      default: 'arrow-up'
    },
    sortIconSize: {
      type: String,
      default: 'is-small'
    },
    sortMultiple: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      sortMultipleSelect: '',
      mobileSort: this.currentSortColumn,
      defaultEvent: {
        shiftKey: true,
        altKey: true,
        ctrlKey: true
      },
      ignoreSort: false
    };
  },
  computed: {
    showPlaceholder: function showPlaceholder() {
      var _this = this;

      return !this.columns || !this.columns.some(function (column) {
        return column === _this.mobileSort;
      });
    }
  },
  watch: {
    sortMultipleSelect: function sortMultipleSelect(column) {
      if (this.ignoreSort) {
        this.ignoreSort = false;
      } else {
        this.$emit('sort', column, this.defaultEvent);
      }
    },
    mobileSort: function mobileSort(column) {
      if (this.currentSortColumn === column) return;
      this.$emit('sort', column, this.defaultEvent);
    },
    currentSortColumn: function currentSortColumn(column) {
      this.mobileSort = column;
    }
  },
  methods: {
    removePriority: function removePriority() {
      var _this2 = this;

      this.$emit('removePriority', this.sortMultipleSelect); // ignore the watcher to sort when we just change whats displayed in the select
      // otherwise the direction will be flipped
      // The sort event is already triggered by the emit

      this.ignoreSort = true; // Select one of the other options when we reset one

      var remainingFields = this.sortMultipleData.filter(function (data) {
        return data.field !== _this2.sortMultipleSelect.field;
      }).map(function (data) {
        return data.field;
      });
      this.sortMultipleSelect = this.columns.filter(function (column) {
        return remainingFields.includes(column.field);
      })[0];
    },
    getSortingObjectOfColumn: function getSortingObjectOfColumn(column) {
      return this.sortMultipleData.filter(function (i) {
        return i.field === column.field;
      })[0];
    },
    columnIsDesc: function columnIsDesc(column) {
      var sortingObject = this.getSortingObjectOfColumn(column);

      if (sortingObject) {
        return !!(sortingObject.order && sortingObject.order === 'desc');
      }

      return true;
    },
    getLabel: function getLabel(column) {
      var sortingObject = this.getSortingObjectOfColumn(column);

      if (sortingObject) {
        return column.label + '(' + (this.sortMultipleData.indexOf(sortingObject) + 1) + ')';
      }

      return column.label;
    },
    sort: function sort() {
      this.$emit('sort', this.sortMultiple ? this.sortMultipleSelect : this.mobileSort, this.defaultEvent);
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field table-mobile-sort"},[_c('div',{staticClass:"field has-addons"},[(_vm.sortMultiple)?_c('b-select',{attrs:{"expanded":""},model:{value:(_vm.sortMultipleSelect),callback:function ($$v) {_vm.sortMultipleSelect=$$v;},expression:"sortMultipleSelect"}},_vm._l((_vm.columns),function(column,index){return (column.sortable)?_c('option',{key:index,domProps:{"value":column}},[_vm._v("\r\n                    "+_vm._s(_vm.getLabel(column))+"\r\n                    "),(_vm.getSortingObjectOfColumn(column))?[(_vm.columnIsDesc(column))?[_vm._v("\r\n                            ↓\r\n                        ")]:[_vm._v("\r\n                            ↑\r\n                        ")]]:_vm._e()],2):_vm._e()})):_c('b-select',{attrs:{"expanded":""},model:{value:(_vm.mobileSort),callback:function ($$v) {_vm.mobileSort=$$v;},expression:"mobileSort"}},[(_vm.placeholder)?[_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPlaceholder),expression:"showPlaceholder"}],attrs:{"selected":"","disabled":"","hidden":""},domProps:{"value":{}}},[_vm._v("\r\n                        "+_vm._s(_vm.placeholder)+"\r\n                    ")])]:_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(column,index){return (column.sortable)?_c('option',{key:index,domProps:{"value":column}},[_vm._v("\r\n                    "+_vm._s(column.label)+"\r\n                ")]):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"control"},[(_vm.sortMultiple && _vm.sortMultipleData.length > 0)?[_c('button',{staticClass:"button is-primary",on:{"click":_vm.sort}},[_c('b-icon',{class:{ 'is-desc': _vm.columnIsDesc(_vm.sortMultipleSelect) },attrs:{"icon":_vm.sortIcon,"pack":_vm.iconPack,"size":_vm.sortIconSize,"both":""}})],1),_vm._v(" "),_c('button',{staticClass:"button is-primary",on:{"click":_vm.removePriority}},[_c('b-icon',{attrs:{"icon":"delete","size":_vm.sortIconSize,"both":""}})],1)]:(!_vm.sortMultiple)?_c('button',{staticClass:"button is-primary",on:{"click":_vm.sort}},[_c('b-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSortColumn === _vm.mobileSort),expression:"currentSortColumn === mobileSort"}],class:{ 'is-desc': !_vm.isAsc },attrs:{"icon":_vm.sortIcon,"pack":_vm.iconPack,"size":_vm.sortIconSize,"both":""}})],1):_vm._e()],2)],1)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var TableMobileSort = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
var script$1 = {
  name: 'BTableColumn',
  props: {
    label: String,
    customKey: [String, Number],
    field: String,
    meta: [String, Number, Boolean, Function, Object, Array],
    width: [Number, String],
    numeric: Boolean,
    centered: Boolean,
    searchable: Boolean,
    sortable: Boolean,
    visible: {
      type: Boolean,
      default: true
    },
    subheading: [String, Number],
    customSort: Function,
    sticky: Boolean,
    headerSelectable: {
      type: Boolean,
      default: true
    },
    headerClass: String,
    cellClass: String,
    internal: Boolean // Used internally by Table

  },
  data: function data() {
    return {
      newKey: this.customKey || this.label,
      _isTableColumn: true
    };
  },
  computed: {
    rootClasses: function rootClasses() {
      return [this.cellClass, {
        'has-text-right': this.numeric && !this.centered,
        'has-text-centered': this.centered,
        'is-sticky': this.sticky
      }];
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    if (!this.$parent.$data._isTable) {
      this.$destroy();
      throw new Error('You should wrap bTableColumn on a bTable');
    }

    if (this.internal) return; // Since we're using scoped prop the columns gonna be multiplied,
    // this finds when to stop based on the newKey property.

    var repeated = this.$parent.newColumns.some(function (column) {
      return column.newKey === _this.newKey;
    });
    !repeated && this.$parent.newColumns.push(this);
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$parent.visibleData.length) return;
    if (this.$parent.newColumns.length !== 1) return;

    if (this.$parent.newColumns.length) {
      var index = this.$parent.newColumns.map(function (column) {
        return column.newKey;
      }).indexOf(this.newKey);

      if (index >= 0) {
        this.$parent.newColumns.splice(index, 1);
      }
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('td',{class:_vm.rootClasses,attrs:{"data-label":_vm.label}},[_vm._t("default")],2):_vm._e()};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var TableColumn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

var _components$1;
var script$2 = {
  name: 'BTable',
  components: (_components$1 = {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components$1, __WEBPACK_IMPORTED_MODULE_8__chunk_7bdbd626_js__["a" /* C */].name, __WEBPACK_IMPORTED_MODULE_8__chunk_7bdbd626_js__["a" /* C */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components$1, __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__["a" /* I */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components$1, __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__["a" /* I */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components$1, __WEBPACK_IMPORTED_MODULE_10__chunk_bd608559_js__["a" /* P */].name, __WEBPACK_IMPORTED_MODULE_10__chunk_bd608559_js__["a" /* P */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components$1, __WEBPACK_IMPORTED_MODULE_11__chunk_0e3f4fb5_js__["a" /* S */].name, __WEBPACK_IMPORTED_MODULE_11__chunk_0e3f4fb5_js__["a" /* S */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components$1, TableMobileSort.name, TableMobileSort), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components$1, TableColumn.name, TableColumn), _components$1),
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bordered: Boolean,
    striped: Boolean,
    narrowed: Boolean,
    hoverable: Boolean,
    loading: Boolean,
    detailed: Boolean,
    checkable: Boolean,
    headerCheckable: {
      type: Boolean,
      default: true
    },
    checkboxPosition: {
      type: String,
      default: 'left',
      validator: function validator(value) {
        return ['left', 'right'].indexOf(value) >= 0;
      }
    },
    selected: Object,
    isRowSelectable: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    focusable: Boolean,
    customIsChecked: Function,
    isRowCheckable: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    checkedRows: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mobileCards: {
      type: Boolean,
      default: true
    },
    defaultSort: [String, Array],
    defaultSortDirection: {
      type: String,
      default: 'asc'
    },
    sortIcon: {
      type: String,
      default: 'arrow-up'
    },
    sortIconSize: {
      type: String,
      default: 'is-small'
    },
    sortMultiple: {
      type: Boolean,
      default: false
    },
    sortMultipleData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    sortMultipleKey: {
      type: String,
      default: null
    },
    paginated: Boolean,
    currentPage: {
      type: Number,
      default: 1
    },
    perPage: {
      type: [Number, String],
      default: 20
    },
    showDetailIcon: {
      type: Boolean,
      default: true
    },
    paginationSimple: Boolean,
    paginationSize: String,
    paginationPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(value) {
        return ['bottom', 'top', 'both'].indexOf(value) >= 0;
      }
    },
    backendSorting: Boolean,
    backendFiltering: Boolean,
    rowClass: {
      type: Function,
      default: function _default() {
        return '';
      }
    },
    openedDetailed: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hasDetailedVisible: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    detailKey: {
      type: String,
      default: ''
    },
    customDetailRow: {
      type: Boolean,
      default: false
    },
    backendPagination: Boolean,
    total: {
      type: [Number, String],
      default: 0
    },
    iconPack: String,
    mobileSortPlaceholder: String,
    customRowKey: String,
    draggable: {
      type: Boolean,
      default: false
    },
    scrollable: Boolean,
    ariaNextLabel: String,
    ariaPreviousLabel: String,
    ariaPageLabel: String,
    ariaCurrentLabel: String,
    stickyHeader: Boolean,
    height: [Number, String],
    filtersEvent: {
      type: String,
      default: ''
    },
    cardLayout: Boolean
  },
  data: function data() {
    return {
      sortMultipleDataLocal: [],
      getValueByPath: __WEBPACK_IMPORTED_MODULE_1__helpers_js__["e" /* getValueByPath */],
      newColumns: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["e" /* d */])(this.columns),
      visibleDetailRows: this.openedDetailed,
      newData: this.data,
      newDataTotal: this.backendPagination ? this.total : this.data.length,
      newCheckedRows: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["e" /* d */])(this.checkedRows),
      lastCheckedRowIndex: null,
      newCurrentPage: this.currentPage,
      currentSortColumn: {},
      isAsc: true,
      filters: {},
      firstTimeSort: true,
      // Used by first time initSort
      _isTable: true // Used by TableColumn

    };
  },
  computed: {
    sortMultipleDataComputed: function sortMultipleDataComputed() {
      return this.backendSorting ? this.sortMultipleData : this.sortMultipleDataLocal;
    },
    tableClasses: function tableClasses() {
      return {
        'is-bordered': this.bordered,
        'is-striped': this.striped,
        'is-narrow': this.narrowed,
        'is-hoverable': (this.hoverable || this.focusable) && this.visibleData.length
      };
    },
    tableWrapperClasses: function tableWrapperClasses() {
      return {
        'has-mobile-cards': this.mobileCards,
        'has-sticky-header': this.stickyHeader,
        'is-card-list': this.cardLayout,
        'table-container': this.isScrollable
      };
    },
    rooClasses: function rooClasses() {
      return {
        'is-loading': this.loading
      };
    },

    /**
    * Splitted data based on the pagination.
    */
    visibleData: function visibleData() {
      if (!this.paginated) return this.newData;
      var currentPage = this.newCurrentPage;
      var perPage = this.perPage;

      if (this.newData.length <= perPage) {
        return this.newData;
      } else {
        var start = (currentPage - 1) * perPage;
        var end = parseInt(start, 10) + parseInt(perPage, 10);
        return this.newData.slice(start, end);
      }
    },
    visibleColumns: function visibleColumns() {
      if (!this.newColumns) return this.newColumns;
      return this.newColumns.filter(function (column) {
        return column.visible || column.visible === undefined;
      });
    },

    /**
    * Check if all rows in the page are checked.
    */
    isAllChecked: function isAllChecked() {
      var _this = this;

      var validVisibleData = this.visibleData.filter(function (row) {
        return _this.isRowCheckable(row);
      });
      if (validVisibleData.length === 0) return false;
      var isAllChecked = validVisibleData.some(function (currentVisibleRow) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["f" /* indexOf */])(_this.newCheckedRows, currentVisibleRow, _this.customIsChecked) < 0;
      });
      return !isAllChecked;
    },

    /**
    * Check if all rows in the page are checkable.
    */
    isAllUncheckable: function isAllUncheckable() {
      var _this2 = this;

      var validVisibleData = this.visibleData.filter(function (row) {
        return _this2.isRowCheckable(row);
      });
      return validVisibleData.length === 0;
    },

    /**
    * Check if has any sortable column.
    */
    hasSortablenewColumns: function hasSortablenewColumns() {
      return this.newColumns.some(function (column) {
        return column.sortable;
      });
    },

    /**
    * Check if has any searchable column.
    */
    hasSearchablenewColumns: function hasSearchablenewColumns() {
      return this.newColumns.some(function (column) {
        return column.searchable;
      });
    },

    /**
    * Check if has any column using subheading.
    */
    hasCustomSubheadings: function hasCustomSubheadings() {
      if (this.$scopedSlots && this.$scopedSlots.subheading) return true;
      return this.newColumns.some(function (column) {
        return column.subheading || column.$scopedSlots && column.$scopedSlots.subheading;
      });
    },

    /**
    * Return total column count based if it's checkable or expanded
    */
    columnCount: function columnCount() {
      var count = this.newColumns.length;
      count += this.checkable ? 1 : 0;
      count += this.detailed && this.showDetailIcon ? 1 : 0;
      return count;
    },

    /**
    * return if detailed row tabled
    * will be with chevron column & icon or not
    */
    showDetailRowIcon: function showDetailRowIcon() {
      return this.detailed && this.showDetailIcon;
    },

    /**
    * return if scrollable table
    */
    isScrollable: function isScrollable() {
      if (this.scrollable) return true;
      if (!this.newColumns) return false;
      return this.newColumns.some(function (column) {
        return column.sticky;
      });
    }
  },
  watch: {
    /**
    * When data prop change:
    *   1. Update internal value.
    *   2. Filter data if it's not backend-filtered.
    *   3. Sort again if it's not backend-sorted.
    *   4. Set new total if it's not backend-paginated.
    */
    data: function data(value) {
      var _this3 = this;

      this.newData = value;

      if (!this.backendFiltering) {
        this.newData = value.filter(function (row) {
          return _this3.isRowFiltered(row);
        });
      }

      if (!this.backendSorting) {
        this.sort(this.currentSortColumn, true);
      }

      if (!this.backendPagination) {
        this.newDataTotal = this.newData.length;
      }
    },

    /**
    * When Pagination total change, update internal total
    * only if it's backend-paginated.
    */
    total: function total(newTotal) {
      if (!this.backendPagination) return;
      this.newDataTotal = newTotal;
    },

    /**
    * When checkedRows prop change, update internal value without
    * mutating original data.
    */
    checkedRows: function checkedRows(rows) {
      this.newCheckedRows = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["e" /* d */])(rows);
    },
    columns: function columns(value) {
      this.newColumns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["e" /* d */])(value);
    },
    newColumns: function newColumns(value) {
      this.checkSort();
    },
    filters: {
      handler: function handler(value) {
        var _this4 = this;

        if (this.backendFiltering) {
          this.$emit('filters-change', value);
        } else {
          this.newData = this.data.filter(function (row) {
            return _this4.isRowFiltered(row);
          });

          if (!this.backendPagination) {
            this.newDataTotal = this.newData.length;
          }

          if (!this.backendSorting) {
            if (this.sortMultiple && this.sortMultipleDataLocal && this.sortMultipleDataLocal.length > 0) {
              this.doSortMultiColumn();
            } else if (Object.keys(this.currentSortColumn).length > 0) {
              this.doSortSingleColumn(this.currentSortColumn);
            }
          }
        }
      },
      deep: true
    },

    /**
    * When the user wants to control the detailed rows via props.
    * Or wants to open the details of certain row with the router for example.
    */
    openedDetailed: function openedDetailed(expandedRows) {
      this.visibleDetailRows = expandedRows;
    },
    currentPage: function currentPage(newVal) {
      this.newCurrentPage = newVal;
    }
  },
  methods: {
    onFiltersEvent: function onFiltersEvent(event) {
      this.$emit("filters-event-".concat(this.filtersEvent), {
        event: event,
        filters: this.filters
      });
    },
    findIndexOfSortData: function findIndexOfSortData(column) {
      var sortObj = this.sortMultipleDataComputed.filter(function (i) {
        return i.field === column.field;
      })[0];
      return this.sortMultipleDataComputed.indexOf(sortObj) + 1;
    },
    removeSortingPriority: function removeSortingPriority(column) {
      if (this.backendSorting) {
        this.$emit('sorting-priority-removed', column.field);
      } else {
        this.sortMultipleDataLocal = this.sortMultipleDataLocal.filter(function (priority) {
          return priority.field !== column.field;
        });
        var formattedSortingPriority = this.sortMultipleDataLocal.map(function (i) {
          return (i.order && i.order === 'desc' ? '-' : '') + i.field;
        });
        this.newData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["g" /* multiColumnSort */])(this.newData, formattedSortingPriority);
      }
    },
    resetMultiSorting: function resetMultiSorting() {
      this.sortMultipleDataLocal = [];
      this.currentSortColumn = {};
      this.newData = this.data;
    },

    /**
    * Sort an array by key without mutating original data.
    * Call the user sort function if it was passed.
    */
    sortBy: function sortBy(array, key, fn, isAsc) {
      var sorted = []; // Sorting without mutating original data

      if (fn && typeof fn === 'function') {
        sorted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["e" /* d */])(array).sort(function (a, b) {
          return fn(a, b, isAsc);
        });
      } else {
        sorted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["e" /* d */])(array).sort(function (a, b) {
          // Get nested values from objects
          var newA = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["e" /* getValueByPath */])(a, key);
          var newB = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["e" /* getValueByPath */])(b, key); // sort boolean type

          if (typeof newA === 'boolean' && typeof newB === 'boolean') {
            return isAsc ? newA - newB : newB - newA;
          }

          if (!newA && newA !== 0) return 1;
          if (!newB && newB !== 0) return -1;
          if (newA === newB) return 0;
          newA = typeof newA === 'string' ? newA.toUpperCase() : newA;
          newB = typeof newB === 'string' ? newB.toUpperCase() : newB;
          return isAsc ? newA > newB ? 1 : -1 : newA > newB ? -1 : 1;
        });
      }

      return sorted;
    },
    sortMultiColumn: function sortMultiColumn(column) {
      this.currentSortColumn = {};

      if (!this.backendSorting) {
        var existingPriority = this.sortMultipleDataLocal.filter(function (i) {
          return i.field === column.field;
        })[0];

        if (existingPriority) {
          existingPriority.order = existingPriority.order === 'desc' ? 'asc' : 'desc';
        } else {
          this.sortMultipleDataLocal.push({
            field: column.field,
            order: column.isAsc
          });
        }

        this.doSortMultiColumn();
      }
    },
    doSortMultiColumn: function doSortMultiColumn() {
      var formattedSortingPriority = this.sortMultipleDataLocal.map(function (i) {
        return (i.order && i.order === 'desc' ? '-' : '') + i.field;
      });
      this.newData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["g" /* multiColumnSort */])(this.newData, formattedSortingPriority);
    },

    /**
    * Sort the column.
    * Toggle current direction on column if it's sortable
    * and not just updating the prop.
    */
    sort: function sort(column) {
      var updatingData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if ( // if backend sorting is enabled, just emit the sort press like usual
      // if the correct key combination isnt pressed, sort like usual
      !this.backendSorting && this.sortMultiple && (this.sortMultipleKey && event[this.sortMultipleKey] || !this.sortMultipleKey)) {
        this.sortMultiColumn(column);
      } else {
        if (!column || !column.sortable) return; // sort multiple is enabled but the correct key combination isnt pressed so reset

        if (this.sortMultiple) {
          this.sortMultipleDataLocal = [];
        }

        if (!updatingData) {
          this.isAsc = column === this.currentSortColumn ? !this.isAsc : this.defaultSortDirection.toLowerCase() !== 'desc';
        }

        if (!this.firstTimeSort) {
          this.$emit('sort', column.field, this.isAsc ? 'asc' : 'desc', event);
        }

        if (!this.backendSorting) {
          this.doSortSingleColumn(column);
        }

        this.currentSortColumn = column;
      }
    },
    doSortSingleColumn: function doSortSingleColumn(column) {
      this.newData = this.sortBy(this.newData, column.field, column.customSort, this.isAsc);
    },

    /**
    * Check if the row is checked (is added to the array).
    */
    isRowChecked: function isRowChecked(row) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["f" /* indexOf */])(this.newCheckedRows, row, this.customIsChecked) >= 0;
    },

    /**
    * Remove a checked row from the array.
    */
    removeCheckedRow: function removeCheckedRow(row) {
      var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["f" /* indexOf */])(this.newCheckedRows, row, this.customIsChecked);

      if (index >= 0) {
        this.newCheckedRows.splice(index, 1);
      }
    },

    /**
    * Header checkbox click listener.
    * Add or remove all rows in current page.
    */
    checkAll: function checkAll() {
      var _this5 = this;

      var isAllChecked = this.isAllChecked;
      this.visibleData.forEach(function (currentRow) {
        if (_this5.isRowCheckable(currentRow)) {
          _this5.removeCheckedRow(currentRow);
        }

        if (!isAllChecked) {
          if (_this5.isRowCheckable(currentRow)) {
            _this5.newCheckedRows.push(currentRow);
          }
        }
      });
      this.$emit('check', this.newCheckedRows);
      this.$emit('check-all', this.newCheckedRows); // Emit checked rows to update user variable

      this.$emit('update:checkedRows', this.newCheckedRows);
    },

    /**
    * Row checkbox click listener.
    */
    checkRow: function checkRow(row, index, event) {
      if (!this.isRowCheckable(row)) return;
      var lastIndex = this.lastCheckedRowIndex;
      this.lastCheckedRowIndex = index;

      if (event.shiftKey && lastIndex !== null && index !== lastIndex) {
        this.shiftCheckRow(row, index, lastIndex);
      } else if (!this.isRowChecked(row)) {
        this.newCheckedRows.push(row);
      } else {
        this.removeCheckedRow(row);
      }

      this.$emit('check', this.newCheckedRows, row); // Emit checked rows to update user variable

      this.$emit('update:checkedRows', this.newCheckedRows);
    },

    /**
     * Check row when shift is pressed.
     */
    shiftCheckRow: function shiftCheckRow(row, index, lastCheckedRowIndex) {
      var _this6 = this;

      // Get the subset of the list between the two indicies
      var subset = this.visibleData.slice(Math.min(index, lastCheckedRowIndex), Math.max(index, lastCheckedRowIndex) + 1); // Determine the operation based on the state of the clicked checkbox

      var shouldCheck = !this.isRowChecked(row);
      subset.forEach(function (item) {
        _this6.removeCheckedRow(item);

        if (shouldCheck && _this6.isRowCheckable(item)) {
          _this6.newCheckedRows.push(item);
        }
      });
    },

    /**
    * Row click listener.
    * Emit all necessary events.
    */
    selectRow: function selectRow(row, index) {
      this.$emit('click', row);
      if (this.selected === row) return;
      if (!this.isRowSelectable(row)) return; // Emit new and old row

      this.$emit('select', row, this.selected); // Emit new row to update user variable

      this.$emit('update:selected', row);
    },

    /**
    * Paginator change listener.
    */
    pageChanged: function pageChanged(page) {
      this.newCurrentPage = page > 0 ? page : 1;
      this.$emit('page-change', this.newCurrentPage);
      this.$emit('update:currentPage', this.newCurrentPage);
    },

    /**
    * Toggle to show/hide details slot
    */
    toggleDetails: function toggleDetails(obj) {
      var found = this.isVisibleDetailRow(obj);

      if (found) {
        this.closeDetailRow(obj);
        this.$emit('details-close', obj);
      } else {
        this.openDetailRow(obj);
        this.$emit('details-open', obj);
      } // Syncs the detailed rows with the parent component


      this.$emit('update:openedDetailed', this.visibleDetailRows);
    },
    openDetailRow: function openDetailRow(obj) {
      var index = this.handleDetailKey(obj);
      this.visibleDetailRows.push(index);
    },
    closeDetailRow: function closeDetailRow(obj) {
      var index = this.handleDetailKey(obj);
      var i = this.visibleDetailRows.indexOf(index);
      this.visibleDetailRows.splice(i, 1);
    },
    isVisibleDetailRow: function isVisibleDetailRow(obj) {
      var index = this.handleDetailKey(obj);
      var result = this.visibleDetailRows.indexOf(index) >= 0;
      return result;
    },
    isActiveDetailRow: function isActiveDetailRow(row) {
      return this.detailed && !this.customDetailRow && this.isVisibleDetailRow(row);
    },
    isActiveCustomDetailRow: function isActiveCustomDetailRow(row) {
      return this.detailed && this.customDetailRow && this.isVisibleDetailRow(row);
    },
    isRowFiltered: function isRowFiltered(row) {
      for (var key in this.filters) {
        // remove key if empty
        if (!this.filters[key]) {
          delete this.filters[key];
          return true;
        }

        var value = this.getValueByPath(row, key);
        if (value == null) return false;

        if (Number.isInteger(value)) {
          if (value !== Number(this.filters[key])) return false;
        } else {
          var re = new RegExp(this.filters[key], 'i');
          if (typeof value === 'boolean') value = "".concat(value);
          if (!value.match(re)) return false;
        }
      }

      return true;
    },

    /**
        * When the detailKey is defined we use the object[detailKey] as index.
        * If not, use the object reference by default.
        */
    handleDetailKey: function handleDetailKey(index) {
      var key = this.detailKey;
      return !key.length || !index ? index : index[key];
    },
    checkPredefinedDetailedRows: function checkPredefinedDetailedRows() {
      var defaultExpandedRowsDefined = this.openedDetailed.length > 0;

      if (defaultExpandedRowsDefined && !this.detailKey.length) {
        throw new Error('If you set a predefined opened-detailed, you must provide a unique key using the prop "detail-key"');
      }
    },

    /**
    * Call initSort only first time (For example async data).
    */
    checkSort: function checkSort() {
      if (this.newColumns.length && this.firstTimeSort) {
        this.initSort();
        this.firstTimeSort = false;
      } else if (this.newColumns.length) {
        if (Object.keys(this.currentSortColumn).length > 0) {
          for (var i = 0; i < this.newColumns.length; i++) {
            if (this.newColumns[i].field === this.currentSortColumn.field) {
              this.currentSortColumn = this.newColumns[i];
              break;
            }
          }
        }
      }
    },

    /**
    * Check if footer slot has custom content.
    */
    hasCustomFooterSlot: function hasCustomFooterSlot() {
      if (this.$slots.footer.length > 1) return true;
      var tag = this.$slots.footer[0].tag;
      if (tag !== 'th' && tag !== 'td') return false;
      return true;
    },

    /**
    * Check if bottom-left slot exists.
    */
    hasBottomLeftSlot: function hasBottomLeftSlot() {
      return typeof this.$slots['bottom-left'] !== 'undefined';
    },

    /**
    * Table arrow keys listener, change selection.
    */
    pressedArrow: function pressedArrow(pos) {
      if (!this.visibleData.length) return;
      var index = this.visibleData.indexOf(this.selected) + pos; // Prevent from going up from first and down from last

      index = index < 0 ? 0 : index > this.visibleData.length - 1 ? this.visibleData.length - 1 : index;
      var row = this.visibleData[index];

      if (!this.isRowSelectable(row)) {
        var newIndex = null;

        if (pos > 0) {
          for (var i = index; i < this.visibleData.length && newIndex === null; i++) {
            if (this.isRowSelectable(this.visibleData[i])) newIndex = i;
          }
        } else {
          for (var _i = index; _i >= 0 && newIndex === null; _i--) {
            if (this.isRowSelectable(this.visibleData[_i])) newIndex = _i;
          }
        }

        if (newIndex >= 0) {
          this.selectRow(this.visibleData[newIndex]);
        }
      } else {
        this.selectRow(row);
      }
    },

    /**
    * Focus table element if has selected prop.
    */
    focus: function focus() {
      if (!this.focusable) return;
      this.$el.querySelector('table').focus();
    },

    /**
    * Initial sorted column based on the default-sort prop.
    */
    initSort: function initSort() {
      var _this7 = this;

      if (!this.backendSorting) {
        if (this.sortMultiple && this.sortMultipleData) {
          this.sortMultipleData.forEach(function (column) {
            _this7.sortMultiColumn(column);
          });
        } else {
          if (!this.defaultSort) return;
          var sortField = '';
          var sortDirection = this.defaultSortDirection;

          if (Array.isArray(this.defaultSort)) {
            sortField = this.defaultSort[0];

            if (this.defaultSort[1]) {
              sortDirection = this.defaultSort[1];
            }
          } else {
            sortField = this.defaultSort;
          }

          var sortColumn = this.newColumns.filter(function (column) {
            return column.field === sortField;
          })[0];

          if (sortColumn) {
            this.isAsc = sortDirection.toLowerCase() !== 'desc';
            this.sort(sortColumn, true);
          }
        }
      }
    },

    /**
    * Emits drag start event
    */
    handleDragStart: function handleDragStart(event, row, index) {
      this.$emit('dragstart', {
        event: event,
        row: row,
        index: index
      });
    },

    /**
    * Emits drag leave event
    */
    handleDragEnd: function handleDragEnd(event, row, index) {
      this.$emit('dragend', {
        event: event,
        row: row,
        index: index
      });
    },

    /**
    * Emits drop event
    */
    handleDrop: function handleDrop(event, row, index) {
      this.$emit('drop', {
        event: event,
        row: row,
        index: index
      });
    },

    /**
    * Emits drag over event
    */
    handleDragOver: function handleDragOver(event, row, index) {
      this.$emit('dragover', {
        event: event,
        row: row,
        index: index
      });
    },

    /**
    * Emits drag leave event
    */
    handleDragLeave: function handleDragLeave(event, row, index) {
      this.$emit('dragleave', {
        event: event,
        row: row,
        index: index
      });
    }
  },
  mounted: function mounted() {
    this.checkPredefinedDetailedRows();
    this.checkSort();
  },
  beforeDestroy: function beforeDestroy() {
    this.newData = [];
    this.newColumns = [];
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-table",class:_vm.rooClasses},[(_vm.mobileCards && _vm.hasSortablenewColumns)?_c('b-table-mobile-sort',{attrs:{"current-sort-column":_vm.currentSortColumn,"sort-multiple":_vm.sortMultiple,"sort-multiple-data":_vm.sortMultipleDataComputed,"is-asc":_vm.isAsc,"columns":_vm.newColumns,"placeholder":_vm.mobileSortPlaceholder,"icon-pack":_vm.iconPack,"sort-icon":_vm.sortIcon,"sort-icon-size":_vm.sortIconSize},on:{"sort":function (column, event) { return _vm.sort(column, null, event); },"removePriority":function (column) { return _vm.removeSortingPriority(column); }}}):_vm._e(),_vm._v(" "),(_vm.paginated && (_vm.paginationPosition === 'top' || _vm.paginationPosition === 'both'))?_c('div',{staticClass:"top level"},[_c('div',{staticClass:"level-left"},[_vm._t("top-left")],2),_vm._v(" "),_c('div',{staticClass:"level-right"},[(_vm.paginated)?_c('div',{staticClass:"level-item"},[_c('b-pagination',{attrs:{"icon-pack":_vm.iconPack,"total":_vm.newDataTotal,"per-page":_vm.perPage,"simple":_vm.paginationSimple,"size":_vm.paginationSize,"current":_vm.newCurrentPage,"aria-next-label":_vm.ariaNextLabel,"aria-previous-label":_vm.ariaPreviousLabel,"aria-page-label":_vm.ariaPageLabel,"aria-current-label":_vm.ariaCurrentLabel},on:{"change":_vm.pageChanged}})],1):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-wrapper",class:_vm.tableWrapperClasses,style:({
                height: _vm.height === undefined ? null :
                (isNaN(_vm.height) ? _vm.height : _vm.height + 'px')
            })},[_c('table',{staticClass:"table",class:_vm.tableClasses,attrs:{"tabindex":!_vm.focusable ? false : 0},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }if($event.target !== $event.currentTarget){ return null; }$event.preventDefault();_vm.pressedArrow(-1);},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }if($event.target !== $event.currentTarget){ return null; }$event.preventDefault();_vm.pressedArrow(1);}]}},[(_vm.newColumns.length)?_c('thead',[_c('tr',[(_vm.showDetailRowIcon)?_c('th',{attrs:{"width":"40px"}}):_vm._e(),_vm._v(" "),(_vm.checkable && _vm.checkboxPosition === 'left')?_c('th',{staticClass:"checkbox-cell"},[(_vm.headerCheckable)?[_c('b-checkbox',{attrs:{"value":_vm.isAllChecked,"disabled":_vm.isAllUncheckable},nativeOn:{"change":function($event){return _vm.checkAll($event)}}})]:_vm._e()],2):_vm._e(),_vm._v(" "),_vm._l((_vm.visibleColumns),function(column,index){return _c('th',{key:index,class:[column.headerClass, {
                                'is-current-sort': !_vm.sortMultiple && _vm.currentSortColumn === column,
                                'is-sortable': column.sortable,
                                'is-sticky': column.sticky,
                                'is-unselectable': !column.headerSelectable
                            }],style:({
                                width: column.width === undefined ? null :
                                (isNaN(column.width) ? column.width : column.width + 'px')
                            }),on:{"click":function($event){$event.stopPropagation();_vm.sort(column, null, $event);}}},[_c('div',{staticClass:"th-wrap",class:{
                                    'is-numeric': column.numeric,
                                    'is-centered': column.centered
                            }},[(column.$scopedSlots && column.$scopedSlots.header)?[_c('b-slot-component',{attrs:{"component":column,"scoped":true,"name":"header","tag":"span","props":{ column: column, index: index }}})]:(_vm.$scopedSlots.header)?[_vm._t("header",null,{column:column,index:index})]:[_vm._v(_vm._s(column.label))],_vm._v(" "),(_vm.sortMultiple &&
                                        _vm.sortMultipleDataComputed &&
                                        _vm.sortMultipleDataComputed.length > 0 &&
                                        _vm.sortMultipleDataComputed.filter(function (i) { return i.field === column.field; }).length > 0)?[_c('b-icon',{class:{
                                            'is-desc': _vm.sortMultipleDataComputed.filter(function (i) { return i.field === column.field; })[0].order === 'desc'
                                        },attrs:{"icon":_vm.sortIcon,"pack":_vm.iconPack,"both":"","size":_vm.sortIconSize}}),_vm._v("\r\n                                    "+_vm._s(_vm.findIndexOfSortData(column))+"\r\n                                    "),_c('button',{staticClass:"delete is-small multi-sort-cancel-icon",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.removeSortingPriority(column);}}})]:(column.sortable && !_vm.sortMultiple)?_c('b-icon',{class:{
                                        'is-desc': !_vm.isAsc,
                                        'is-invisible': _vm.currentSortColumn !== column
                                    },attrs:{"icon":_vm.sortIcon,"pack":_vm.iconPack,"both":"","size":_vm.sortIconSize}}):_vm._e()],2)])}),_vm._v(" "),(_vm.checkable && _vm.checkboxPosition === 'right')?_c('th',{staticClass:"checkbox-cell"},[(_vm.headerCheckable)?[_c('b-checkbox',{attrs:{"value":_vm.isAllChecked,"disabled":_vm.isAllUncheckable},nativeOn:{"change":function($event){return _vm.checkAll($event)}}})]:_vm._e()],2):_vm._e()],2),_vm._v(" "),(_vm.hasCustomSubheadings)?_c('tr',{staticClass:"is-subheading"},[(_vm.showDetailRowIcon)?_c('th',{attrs:{"width":"40px"}}):_vm._e(),_vm._v(" "),(_vm.checkable && _vm.checkboxPosition === 'left')?_c('th'):_vm._e(),_vm._v(" "),_vm._l((_vm.visibleColumns),function(column,index){return _c('th',{key:index,style:({
                                width: column.width === undefined ? null
                            : (isNaN(column.width) ? column.width : column.width + 'px') })},[_c('div',{staticClass:"th-wrap",class:{
                                    'is-numeric': column.numeric,
                                    'is-centered': column.centered
                            }},[(column.$scopedSlots && column.$scopedSlots.subheading)?[_c('b-slot-component',{attrs:{"component":column,"scoped":true,"name":"subheading","tag":"span","props":{ column: column, index: index }}})]:(_vm.$scopedSlots.subheading)?[_vm._t("subheading",null,{column:column,index:index})]:[_vm._v(_vm._s(column.subheading))]],2)])}),_vm._v(" "),(_vm.checkable && _vm.checkboxPosition === 'right')?_c('th'):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.hasSearchablenewColumns)?_c('tr',[(_vm.showDetailRowIcon)?_c('th',{attrs:{"width":"40px"}}):_vm._e(),_vm._v(" "),(_vm.checkable && _vm.checkboxPosition === 'left')?_c('th'):_vm._e(),_vm._v(" "),_vm._l((_vm.visibleColumns),function(column,index){return _c('th',{key:index,style:({
                                width: column.width === undefined ? null
                            : (isNaN(column.width) ? column.width : column.width + 'px') })},[_c('div',{staticClass:"th-wrap"},[(column.searchable)?[(column.$scopedSlots
                                        && column.$scopedSlots.searchable)?[_c('b-slot-component',{attrs:{"component":column,"scoped":true,"name":"searchable","tag":"span","props":{ column: column, filters: _vm.filters }}})]:_c('b-input',{attrs:{"type":column.numeric ? 'number' : 'text'},nativeOn:{"[filtersEvent]":function($event){return _vm.onFiltersEvent($event)}},model:{value:(_vm.filters[column.field]),callback:function ($$v) {_vm.$set(_vm.filters, column.field, $$v);},expression:"filters[column.field]"}})]:_vm._e()],2)])}),_vm._v(" "),(_vm.checkable && _vm.checkboxPosition === 'right')?_c('th'):_vm._e()],2):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.visibleData.length)?_c('tbody',[_vm._l((_vm.visibleData),function(row,index){return [_c('tr',{key:_vm.customRowKey ? row[_vm.customRowKey] : index,class:[_vm.rowClass(row, index), {
                                'is-selected': row === _vm.selected,
                                'is-checked': _vm.isRowChecked(row),
                            }],attrs:{"draggable":_vm.draggable},on:{"click":function($event){_vm.selectRow(row);},"dblclick":function($event){_vm.$emit('dblclick', row);},"mouseenter":function($event){_vm.$listeners.mouseenter ? _vm.$emit('mouseenter', row) : null;},"mouseleave":function($event){_vm.$listeners.mouseleave ? _vm.$emit('mouseleave', row) : null;},"contextmenu":function($event){_vm.$emit('contextmenu', row, $event);},"dragstart":function($event){_vm.handleDragStart($event, row, index);},"dragend":function($event){_vm.handleDragEnd($event, row, index);},"drop":function($event){_vm.handleDrop($event, row, index);},"dragover":function($event){_vm.handleDragOver($event, row, index);},"dragleave":function($event){_vm.handleDragLeave($event, row, index);}}},[(_vm.showDetailRowIcon)?_c('td',{staticClass:"chevron-cell"},[(_vm.hasDetailedVisible(row))?_c('a',{attrs:{"role":"button"},on:{"click":function($event){$event.stopPropagation();_vm.toggleDetails(row);}}},[_c('b-icon',{class:{'is-expanded': _vm.isVisibleDetailRow(row)},attrs:{"icon":"chevron-right","pack":_vm.iconPack,"both":""}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.checkable && _vm.checkboxPosition === 'left')?_c('td',{staticClass:"checkbox-cell"},[_c('b-checkbox',{attrs:{"disabled":!_vm.isRowCheckable(row),"value":_vm.isRowChecked(row)},nativeOn:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.checkRow(row, index, $event);}}})],1):_vm._e(),_vm._v(" "),(_vm.$scopedSlots.default)?_vm._t("default",null,{row:row,index:index}):_vm._l((_vm.newColumns),function(column){return _c('BTableColumn',_vm._b({key:column.customKey || column.label,attrs:{"internal":""}},'BTableColumn',column,false),[(column.renderHtml)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.getValueByPath(row, column.field))}}):[_vm._v("\r\n                                        "+_vm._s(_vm.getValueByPath(row, column.field))+"\r\n                                    ")]],2)}),_vm._v(" "),(_vm.checkable && _vm.checkboxPosition === 'right')?_c('td',{staticClass:"checkbox-cell"},[_c('b-checkbox',{attrs:{"disabled":!_vm.isRowCheckable(row),"value":_vm.isRowChecked(row)},nativeOn:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.checkRow(row, index, $event);}}})],1):_vm._e()],2),_vm._v(" "),(_vm.isActiveDetailRow(row))?_c('tr',{staticClass:"detail"},[_c('td',{attrs:{"colspan":_vm.columnCount}},[_c('div',{staticClass:"detail-container"},[_vm._t("detail",null,{row:row,index:index})],2)])]):_vm._e(),_vm._v(" "),(_vm.isActiveCustomDetailRow(row))?_vm._t("detail",null,{row:row,index:index}):_vm._e()]})],2):_c('tbody',[_c('tr',{staticClass:"is-empty"},[_c('td',{attrs:{"colspan":_vm.columnCount}},[_vm._t("empty")],2)])]),_vm._v(" "),(_vm.$slots.footer !== undefined)?_c('tfoot',[_c('tr',{staticClass:"table-footer"},[(_vm.hasCustomFooterSlot())?_vm._t("footer"):_c('th',{attrs:{"colspan":_vm.columnCount}},[_vm._t("footer")],2)],2)]):_vm._e()])]),_vm._v(" "),((_vm.checkable && _vm.hasBottomLeftSlot()) ||
            (_vm.paginated && (_vm.paginationPosition === 'bottom' || _vm.paginationPosition === 'both')))?_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-left"},[_vm._t("bottom-left")],2),_vm._v(" "),_c('div',{staticClass:"level-right"},[(_vm.paginated)?_c('div',{staticClass:"level-item"},[_c('b-pagination',{attrs:{"icon-pack":_vm.iconPack,"total":_vm.newDataTotal,"per-page":_vm.perPage,"simple":_vm.paginationSimple,"size":_vm.paginationSize,"current":_vm.newCurrentPage,"aria-next-label":_vm.ariaNextLabel,"aria-previous-label":_vm.ariaPreviousLabel,"aria-page-label":_vm.ariaPageLabel,"aria-current-label":_vm.ariaCurrentLabel},on:{"change":_vm.pageChanged}})],1):_vm._e()])]):_vm._e()],1)};
var __vue_staticRenderFns__$2 = [];

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Table = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["d" /* r */])(Vue, Table);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["d" /* r */])(Vue, TableColumn);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "FZ+f":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "FeBl":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "FtD3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("t8qj");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "Ftan":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BProgress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__ = __webpack_require__("rhEV");


//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'BProgress',
  props: {
    type: {
      type: [String, Object],
      default: 'is-darkgrey'
    },
    size: String,
    value: {
      type: Number,
      default: undefined
    },
    max: {
      type: Number,
      default: 100
    },
    showValue: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: 'raw',
      validator: function validator(value) {
        return ['raw', 'percent'].indexOf(value) >= 0;
      }
    },
    precision: {
      type: Number,
      default: 2
    },
    keepTrailingZeroes: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isIndeterminate: function isIndeterminate() {
      return this.value === undefined || this.value === null;
    },
    newType: function newType() {
      return [this.size, this.type];
    },
    newValue: function newValue() {
      if (this.value === undefined || this.value === null || isNaN(this.value)) {
        return undefined;
      }

      if (this.format === 'percent') {
        var _val = this.toFixed(this.value * 100 / this.max);

        return "".concat(_val, "%");
      }

      var val = this.toFixed(this.value);
      return val;
    }
  },
  watch: {
    value: function value(_value) {
      this.setValue(_value);
    }
  },
  methods: {
    /**
    * When value is changed back to undefined, value of native progress get reset to 0.
    * Need to add and remove the value attribute to have the indeterminate or not.
    */
    setValue: function setValue(value) {
      if (this.isIndeterminate) {
        this.$refs.progress.removeAttribute('value');
      } else {
        this.$refs.progress.setAttribute('value', value);
      }
    },
    // Custom function that imitate the javascript toFixed method with improved rounding
    toFixed: function toFixed(num) {
      var fixed = (+"".concat(Math.round(+"".concat(num, "e").concat(this.precision)), "e").concat(-this.precision)).toFixed(this.precision);

      if (!this.keepTrailingZeroes) {
        fixed = fixed.replace(/\.?0+$/, '');
      }

      return fixed;
    }
  },
  mounted: function mounted() {
    this.setValue(this.value);
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-wrapper"},[_c('progress',{ref:"progress",staticClass:"progress",class:_vm.newType,attrs:{"max":_vm.max}},[_vm._v(_vm._s(_vm.newValue))]),_vm._v(" "),(_vm.showValue)?_c('p',{staticClass:"progress-value"},[_vm._t("default",[_vm._v(_vm._s(_vm.newValue))])],2):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Progress = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["d" /* r */])(Vue, Progress);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "GHBc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ "HE5t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BCarousel */
/* unused harmony export BCarouselItem */
/* unused harmony export BCarouselList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__ = __webpack_require__("rhEV");






var script = {
  name: 'BCarousel',
  components: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({}, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */]),
  props: {
    value: {
      type: Number,
      default: 0
    },
    animated: {
      type: String,
      default: 'slide'
    },
    interval: Number,
    hasDrag: {
      type: Boolean,
      default: true
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    pauseHover: {
      type: Boolean,
      default: true
    },
    pauseInfo: {
      type: Boolean,
      default: true
    },
    pauseInfoType: {
      type: String,
      default: 'is-white'
    },
    pauseText: {
      type: String,
      default: 'Pause'
    },
    arrow: {
      type: Boolean,
      default: true
    },
    arrowBoth: {
      type: Boolean,
      default: true
    },
    arrowHover: {
      type: Boolean,
      default: true
    },
    repeat: {
      type: Boolean,
      default: true
    },
    iconPack: String,
    iconSize: String,
    iconPrev: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultIconPrev;
      }
    },
    iconNext: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultIconNext;
      }
    },
    indicator: {
      type: Boolean,
      default: true
    },
    indicatorBackground: Boolean,
    indicatorCustom: Boolean,
    indicatorCustomSize: {
      type: String,
      default: 'is-small'
    },
    indicatorInside: {
      type: Boolean,
      default: true
    },
    indicatorMode: {
      type: String,
      default: 'click'
    },
    indicatorPosition: {
      type: String,
      default: 'is-bottom'
    },
    indicatorStyle: {
      type: String,
      default: 'is-dots'
    },
    overlay: Boolean,
    progress: Boolean,
    progressType: {
      type: String,
      default: 'is-primary'
    },
    withCarouselList: Boolean
  },
  data: function data() {
    return {
      _isCarousel: true,
      activeItem: this.value,
      carouselItems: [],
      isPause: false,
      dragX: 0,
      timer: null
    };
  },
  computed: {
    indicatorClasses: function indicatorClasses() {
      return [{
        'has-background': this.indicatorBackground,
        'has-custom': this.indicatorCustom,
        'is-inside': this.indicatorInside
      }, this.indicatorCustom && this.indicatorCustomSize, this.indicatorInside && this.indicatorPosition];
    }
  },
  watch: {
    /**
     * When v-model is changed set the new active item.
     */
    value: function value(_value) {
      if (_value < this.activeItem) {
        this.changeItem(_value);
      } else {
        this.changeItem(_value, false);
      }
    },

    /**
     * When carousel-items are updated, set active one.
     */
    carouselItems: function carouselItems() {
      if (this.activeItem < this.carouselItems.length) {
        this.carouselItems[this.activeItem].isActive = true;
      }
    },

    /**
     *  When autoplay is change, set by status
     */
    autoplay: function autoplay(status) {
      status ? this.startTimer() : this.pauseTimer();
    }
  },
  methods: {
    startTimer: function startTimer() {
      var _this = this;

      if (!this.autoplay || this.timer) return;
      this.isPause = false;
      this.timer = setInterval(function () {
        if (!_this.repeat && _this.activeItem === _this.carouselItems.length - 1) {
          _this.pauseTimer();
        } else {
          _this.next();
        }
      }, this.interval || __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultCarouselInterval);
    },
    pauseTimer: function pauseTimer() {
      this.isPause = true;

      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    checkPause: function checkPause() {
      if (this.pauseHover && this.autoplay) {
        return this.pauseTimer();
      }
    },

    /**
     * Change the active item and emit change event.
     * action only for animated slide, there true = next, false = prev
     */
    changeItem: function changeItem(newIndex) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (this.activeItem === newIndex) return;

      if (this.activeItem < this.carouselItems.length) {
        this.carouselItems[this.activeItem].status(false, action);
      }

      this.carouselItems[newIndex].status(true, action);
      this.activeItem = newIndex;
      this.$emit('change', newIndex);
    },
    // Indicator trigger when change active item.
    modeChange: function modeChange(trigger, value) {
      if (this.indicatorMode === trigger) {
        this.$emit('input', value);
        return value < this.activeItem ? this.changeItem(value) : this.changeItem(value, false);
      }
    },
    prev: function prev() {
      if (this.activeItem === 0) {
        if (this.repeat) this.changeItem(this.carouselItems.length - 1);
      } else {
        this.changeItem(this.activeItem - 1);
      }
    },
    next: function next() {
      if (this.activeItem === this.carouselItems.length - 1) {
        if (this.repeat) this.changeItem(0, false);
      } else {
        this.changeItem(this.activeItem + 1, false);
      }
    },
    // checking arrow between both
    checkArrow: function checkArrow(value) {
      if (this.arrowBoth) return true;
      if (this.activeItem !== value) return true;
    },
    // handle drag event
    dragStart: function dragStart(event) {
      if (!this.hasDrag) return;
      this.dragx = event.touches ? event.changedTouches[0].pageX : event.pageX;

      if (event.touches) {
        this.pauseTimer();
      } else {
        event.preventDefault();
      }
    },
    dragEnd: function dragEnd(event) {
      if (!this.hasDrag) return;
      var detected = event.touches ? event.changedTouches[0].pageX : event.pageX;
      var diffX = detected - this.dragx;

      if (Math.abs(diffX) > 50) {
        if (diffX < 0) {
          this.next();
        } else {
          this.prev();
        }
      }

      if (event.touches) {
        this.startTimer();
      }
    }
  },
  mounted: function mounted() {
    if (this.activeItem < this.carouselItems.length) {
      this.carouselItems[this.activeItem].isActive = true;
    }

    this.startTimer();
  },
  beforeDestroy: function beforeDestroy() {
    this.pauseTimer();
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel",class:{'is-overlay': _vm.overlay},on:{"mouseenter":_vm.pauseTimer,"mouseleave":_vm.startTimer}},[(_vm.progress)?_c('progress',{staticClass:"progress",class:_vm.progressType,attrs:{"max":_vm.carouselItems.length - 1},domProps:{"value":_vm.activeItem}},[_vm._v("\r\n            "+_vm._s(_vm.carouselItems.length - 1)+"\r\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"carousel-items",on:{"mousedown":_vm.dragStart,"mouseup":_vm.dragEnd,"touchstart":function($event){$event.stopPropagation();return _vm.dragStart($event)},"touchend":function($event){$event.stopPropagation();return _vm.dragEnd($event)}}},[_vm._t("default"),_vm._v(" "),(_vm.arrow)?_c('div',{staticClass:"carousel-arrow",class:{'is-hovered': _vm.arrowHover}},[(_vm.checkArrow(0))?_c('b-icon',{staticClass:"has-icons-left",attrs:{"pack":_vm.iconPack,"icon":_vm.iconPrev,"size":_vm.iconSize,"both":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.prev($event)}}}):_vm._e(),_vm._v(" "),(_vm.checkArrow(_vm.carouselItems.length - 1))?_c('b-icon',{staticClass:"has-icons-right",attrs:{"pack":_vm.iconPack,"icon":_vm.iconNext,"size":_vm.iconSize,"both":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.next($event)}}}):_vm._e()],1):_vm._e()],2),_vm._v(" "),(_vm.autoplay && _vm.pauseHover && _vm.pauseInfo && _vm.isPause)?_c('div',{staticClass:"carousel-pause"},[_c('span',{staticClass:"tag",class:_vm.pauseInfoType},[_vm._v("\r\n                "+_vm._s(_vm.pauseText)+"\r\n            ")])]):_vm._e(),_vm._v(" "),(_vm.withCarouselList && !_vm.indicator)?[_vm._t("list",null,{active:_vm.activeItem,switch:_vm.changeItem})]:_vm._e(),_vm._v(" "),(_vm.indicator)?_c('div',{staticClass:"carousel-indicator",class:_vm.indicatorClasses},_vm._l((_vm.carouselItems),function(item,index){return _c('a',{key:index,staticClass:"indicator-item",class:{'is-active': index === _vm.activeItem},on:{"mouseover":function($event){_vm.modeChange('hover', index);},"click":function($event){_vm.modeChange('click', index);}}},[_vm._t("indicators",[_c('span',{staticClass:"indicator-style",class:_vm.indicatorStyle})],{i:index})],2)})):_vm._e(),_vm._v(" "),(_vm.overlay)?[_vm._t("overlay")]:_vm._e()],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Carousel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
var script$1 = {
  name: 'BCarouselItem',
  data: function data() {
    return {
      isActive: false,
      transitionName: null
    };
  },
  computed: {
    transition: function transition() {
      if (this.$parent.animated === 'fade') {
        return 'fade';
      } else {
        return this.transitionName;
      }
    }
  },
  methods: {
    /**
    * Status of item, alter animation name based on action.
    */
    status: function status(value, action) {
      this.transitionName = action ? 'slide-next' : 'slide-prev';
      this.isActive = value;
    }
  },
  created: function created() {
    if (!this.$parent.$data._isCarousel) {
      this.$destroy();
      throw new Error('You should wrap bCarouselItem on a bCarousel');
    }

    this.$parent.carouselItems.push(this);
  },
  beforeDestroy: function beforeDestroy() {
    var index = this.$parent.carouselItems.indexOf(this);

    if (index >= 0) {
      this.$parent.carouselItems.splice(index, 1);
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"carousel-item"},[_vm._t("default")],2)])};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var CarouselItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

var script$2 = {
  name: 'BCarouselList',
  components: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({}, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */]),
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: Number,
      default: 0
    },
    hasDrag: {
      type: Boolean,
      default: true
    },
    hasGrayscale: Boolean,
    hasOpacity: Boolean,
    repeat: Boolean,
    itemsToShow: {
      type: Number,
      default: 4
    },
    itemsToList: {
      type: Number,
      default: 1
    },
    asIndicator: Boolean,
    arrow: {
      type: Boolean,
      default: true
    },
    arrowHover: {
      type: Boolean,
      default: true
    },
    iconPack: String,
    iconSize: String,
    iconPrev: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultIconPrev;
      }
    },
    iconNext: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultIconNext;
      }
    },
    refresh: Boolean
  },
  data: function data() {
    return {
      activeItem: this.value,
      breakpoints: {},
      delta: 0,
      dragging: false,
      hold: 0,
      itemWidth: 0,
      settings: {}
    };
  },
  computed: {
    listClass: function listClass() {
      return [{
        'has-grayscale': this.settings.hasGrayscale || this.hasGrayscale,
        'has-opacity': this.settings.hasOpacity || this.hasOpacity,
        'is-dragging': this.dragging
      }];
    },
    itemStyle: function itemStyle() {
      return "width: ".concat(this.itemWidth, "px;");
    },
    transformStyle: function transformStyle() {
      var translate = this.delta + 1 * (this.activeItem * this.itemWidth);
      var result = this.dragging ? -translate : -Math.abs(translate);
      return "transform: translateX(".concat(result, "px);");
    },
    total: function total() {
      return this.data.length - 1;
    }
  },
  watch: {
    /**
     * When v-model is changed set the new active item.
     */
    value: function value(_value) {
      this.switchTo(_value);
    },

    /**
     * Only for overlay and as indicator.
     * when call overlay with click.
     */
    refresh: function refresh(status) {
      if (status && this.asIndicator) {
        this.getWidth();
      }
    },
    '$props': {
      handler: function handler(value) {
        this.initConfig();
        this.update();
      },
      deep: true
    }
  },
  methods: {
    initConfig: function initConfig() {
      this.breakpoints = this.config.breakpoints;
      this.settings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* merge */])(this.$props, this.config, true);
    },
    getWidth: function getWidth() {
      var rect = this.$el.getBoundingClientRect();
      this.itemWidth = rect.width / this.settings.itemsToShow;
    },
    update: function update() {
      if (this.breakpoints) {
        this.updateConfig();
      }

      this.getWidth();
    },
    updateConfig: function updateConfig() {
      var _this = this;

      var breakpoints = Object.keys(this.breakpoints).sort(function (a, b) {
        return b - a;
      });
      var checking;
      breakpoints.some(function (breakpoint) {
        checking = window.matchMedia("(min-width: ".concat(breakpoint, "px)")).matches;

        if (checking) {
          _this.settings = _this.config.breakpoints[breakpoint];
          return true;
        }
      });

      if (!checking) {
        this.settings = this.config;
      }
    },
    switchTo: function switchTo(newIndex) {
      if (newIndex < 0 || this.activeItem === newIndex || !this.repeat && newIndex > this.total) return;
      var result = this.repeat && newIndex > this.total ? 0 : newIndex;
      this.activeItem = result;
      this.$emit('switch', result);
    },
    next: function next() {
      this.switchTo(this.activeItem + this.itemsToList);
    },
    prev: function prev() {
      this.switchTo(this.activeItem - this.itemsToList);
    },
    checkArrow: function checkArrow(value) {
      if (this.repeat || this.activeItem !== value) return true;
    },
    checkAsIndicator: function checkAsIndicator(value, e) {
      if (!this.asIndicator) return;
      var timeCheck = new Date().getTime(); // al solution: holding, 100 - 400 not 100% but 200 is better!

      if (!e.touches && timeCheck - this.hold > 200) return;
      this.switchTo(value);
    },
    // handle drag event
    dragStart: function dragStart(event) {
      if (!this.hasDrag || event.button !== 0 && event.type !== 'touchstart') return;
      this.hold = new Date().getTime();
      this.dragging = true;
      this.dragStartX = event.touches ? event.touches[0].clientX : event.clientX;
      window.addEventListener(event.touches ? 'touchmove' : 'mousemove', this.dragMove);
      window.addEventListener(event.touches ? 'touchend' : 'mouseup', this.dragEnd);
    },
    dragMove: function dragMove(event) {
      this.dragEndX = event.touches ? event.touches[0].clientX : event.clientX;
      var deltaX = this.dragEndX - this.dragStartX;
      this.delta = deltaX < 0 ? Math.abs(deltaX) : -Math.abs(deltaX);

      if (!event.touches) {
        event.preventDefault();
      }
    },
    dragEnd: function dragEnd(event) {
      var signCheck = 1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["h" /* sign */])(this.delta);
      var results = Math.round(Math.abs(this.delta / this.itemWidth) + 0.15); // Hack

      this.switchTo(this.activeItem + signCheck * results);
      this.dragging = false;
      this.delta = 0;
      window.removeEventListener(event.touches ? 'touchmove' : 'mousemove', this.dragMove);
      window.removeEventListener(event.touches ? 'touchend' : 'mouseup', this.dragEnd);
    }
  },
  created: function created() {
    this.initConfig();

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.update);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.update();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.update);
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel-list",class:{'has-shadow': _vm.activeItem > 0},on:{"mousedown":function($event){$event.stopPropagation();$event.preventDefault();return _vm.dragStart($event)},"touchstart":_vm.dragStart}},[_c('div',{staticClass:"carousel-slides",class:_vm.listClass,style:(_vm.transformStyle)},_vm._l((_vm.data),function(list,index){return _c('div',{key:index,staticClass:"carousel-slide",class:{'is-active': _vm.activeItem === index},style:(_vm.itemStyle),on:{"click":function($event){_vm.checkAsIndicator(index, $event);}}},[_vm._t("item",[_c('figure',{staticClass:"image"},[_c('img',{attrs:{"src":list.image,"title":list.title}})])],{list:list,index:index,active:_vm.activeItem})],2)})),_vm._v(" "),(_vm.arrow)?_c('div',{staticClass:"carousel-arrow",class:{'is-hovered': _vm.arrowHover}},[_c('b-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeItem > 0),expression:"activeItem > 0"}],staticClass:"has-icons-left",attrs:{"pack":_vm.iconPack,"icon":_vm.iconPrev,"size":_vm.iconSize,"both":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.prev($event)}}}),_vm._v(" "),_c('b-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkArrow(_vm.total)),expression:"checkArrow(total)"}],staticClass:"has-icons-right",attrs:{"pack":_vm.iconPack,"icon":_vm.iconNext,"size":_vm.iconSize,"both":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.next($event)}}})],1):_vm._e()])};
var __vue_staticRenderFns__$2 = [];

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var CarouselList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, Carousel);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, CarouselItem);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, CarouselList);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "I6hQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BTabItem */
/* unused harmony export BTabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_0e3f4fb5_js__ = __webpack_require__("ji3u");







var _components;
var script = {
  name: 'BTabs',
  components: (_components = {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_5__chunk_0e3f4fb5_js__["a" /* S */].name, __WEBPACK_IMPORTED_MODULE_5__chunk_0e3f4fb5_js__["a" /* S */]), _components),
  props: {
    value: [Number, String],
    expanded: Boolean,
    type: String,
    size: String,
    position: String,
    animated: {
      type: Boolean,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultTabsAnimated;
      }
    },
    destroyOnHide: {
      type: Boolean,
      default: false
    },
    vertical: Boolean,
    multiline: Boolean
  },
  data: function data() {
    return {
      activeTab: 0,
      defaultSlots: [],
      contentHeight: 0,
      isTransitioning: false,
      _isTabs: true // Used internally by TabItem

    };
  },
  computed: {
    mainClasses: function mainClasses() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({
        'is-fullwidth': this.expanded,
        'is-vertical': this.vertical,
        'is-multiline': this.multiline
      }, this.position, this.position && this.vertical);
    },
    navClasses: function navClasses() {
      var _ref2;

      return [this.type, this.size, (_ref2 = {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_ref2, this.position, this.position && !this.vertical), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_ref2, 'is-fullwidth', this.expanded), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_ref2, 'is-toggle-rounded is-toggle', this.type === 'is-toggle-rounded'), _ref2)];
    },
    tabItems: function tabItems() {
      return this.defaultSlots.filter(function (vnode) {
        return vnode.componentInstance && vnode.componentInstance.$data && vnode.componentInstance.$data._isTabItem;
      }).map(function (vnode) {
        return vnode.componentInstance;
      });
    }
  },
  watch: {
    /**
    * When v-model is changed set the new active tab.
    */
    value: function value(_value) {
      var index = this.getIndexByValue(_value, _value);
      this.changeTab(index);
    },

    /**
    * When tab-items are updated, set active one.
    */
    tabItems: function tabItems() {
      var _this = this;

      if (this.activeTab < this.tabItems.length) {
        var previous = this.activeTab;
        this.tabItems.map(function (tab, idx) {
          if (tab.isActive) {
            previous = idx;

            if (previous < _this.tabItems.length) {
              _this.tabItems[previous].isActive = false;
            }
          }
        });
        this.tabItems[this.activeTab].isActive = true;
      } else if (this.activeTab > 0) {
        this.changeTab(this.activeTab - 1);
      }
    }
  },
  methods: {
    /**
    * Change the active tab and emit change event.
    */
    changeTab: function changeTab(newIndex) {
      if (this.activeTab === newIndex || this.tabItems[newIndex] === undefined) return;

      if (this.activeTab < this.tabItems.length) {
        this.tabItems[this.activeTab].deactivate(this.activeTab, newIndex);
      }

      this.tabItems[newIndex].activate(this.activeTab, newIndex);
      this.activeTab = newIndex;
      this.$emit('change', this.getValueByIndex(newIndex));
    },

    /**
    * Tab click listener, emit input event and change active tab.
    */
    tabClick: function tabClick(index) {
      if (this.activeTab === index) return;
      this.$emit('input', this.getValueByIndex(index));
      this.changeTab(index);
    },
    refreshSlots: function refreshSlots() {
      this.defaultSlots = this.$slots.default || [];
    },
    getIndexByValue: function getIndexByValue(value) {
      var index = this.tabItems.map(function (t) {
        return t.$options.propsData ? t.$options.propsData.value : undefined;
      }).indexOf(value);
      return index >= 0 ? index : value;
    },
    getValueByIndex: function getValueByIndex(index) {
      var propsData = this.tabItems[index].$options.propsData;
      return propsData && propsData.value ? propsData.value : index;
    }
  },
  mounted: function mounted() {
    this.activeTab = this.getIndexByValue(this.value || 0);

    if (this.activeTab < this.tabItems.length) {
      this.tabItems[this.activeTab].isActive = true;
    }

    this.refreshSlots();
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-tabs",class:_vm.mainClasses},[_c('nav',{staticClass:"tabs",class:_vm.navClasses},[_c('ul',_vm._l((_vm.tabItems),function(tabItem,index){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(tabItem.visible),expression:"tabItem.visible"}],key:index,class:{ 'is-active': _vm.activeTab === index, 'is-disabled': tabItem.disabled }},[(tabItem.$slots.header)?_c('b-slot-component',{attrs:{"component":tabItem,"name":"header","tag":"a"},nativeOn:{"click":function($event){_vm.tabClick(index);}}}):_c('a',{on:{"click":function($event){_vm.tabClick(index);}}},[(tabItem.icon)?_c('b-icon',{attrs:{"icon":tabItem.icon,"pack":tabItem.iconPack,"size":_vm.size}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(tabItem.label))])],1)],1)}))]),_vm._v(" "),_c('section',{staticClass:"tab-content",class:{'is-transitioning': _vm.isTransitioning}},[_vm._t("default")],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Tabs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var script$1 = {
  name: 'BTabItem',
  props: {
    label: String,
    icon: String,
    iconPack: String,
    disabled: Boolean,
    visible: {
      type: Boolean,
      default: true
    },
    value: [String, Number]
  },
  data: function data() {
    return {
      isActive: false,
      transitionName: null,
      _isTabItem: true // Used internally by Tab

    };
  },
  methods: {
    /**
    * Activate tab, alter animation name based on the index.
    */
    activate: function activate(oldIndex, index) {
      this.transitionName = index < oldIndex ? this.$parent.vertical ? 'slide-down' : 'slide-next' : this.$parent.vertical ? 'slide-up' : 'slide-prev';
      this.isActive = true;
    },

    /**
    * Deactivate tab, alter animation name based on the index.
    */
    deactivate: function deactivate(oldIndex, index) {
      this.transitionName = index < oldIndex ? this.$parent.vertical ? 'slide-down' : 'slide-next' : this.$parent.vertical ? 'slide-up' : 'slide-prev';
      this.isActive = false;
    }
  },
  created: function created() {
    if (!this.$parent.$data._isTabs) {
      this.$destroy();
      throw new Error('You should wrap bTabItem on a bTabs');
    }

    this.$parent.refreshSlots();
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.refreshSlots();
  },
  render: function render(createElement) {
    var _this = this;

    // if destroy apply v-if
    if (this.$parent.destroyOnHide) {
      if (!this.isActive || !this.visible) {
        return;
      }
    }

    var vnode = createElement('div', {
      directives: [{
        name: 'show',
        value: this.isActive && this.visible
      }],
      class: 'tab-item'
    }, this.$slots.default); // check animated prop

    if (this.$parent.animated) {
      return createElement('transition', {
        props: {
          'name': this.transitionName
        },
        on: {
          'before-enter': function beforeEnter() {
            _this.$parent.isTransitioning = true;
          },
          'after-enter': function afterEnter() {
            _this.$parent.isTransitioning = false;
          }
        }
      }, [vnode]);
    }

    return vnode;
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = undefined;
  /* style inject */
  
  /* style inject SSR */
  

  
  var TabItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    {},
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, Tabs);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, TabItem);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "IHYB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_eb60b35a_js__ = __webpack_require__("RbWz");
/* unused harmony reexport BField */






var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["d" /* r */])(Vue, __WEBPACK_IMPORTED_MODULE_3__chunk_eb60b35a_js__["a" /* F */]);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);


/***/ }),

/***/ "IXWv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BClockpicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_d0a313ea_js__ = __webpack_require__("EmVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__ = __webpack_require__("QR9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chunk_1196ee55_js__ = __webpack_require__("iBFZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chunk_42f463e6_js__ = __webpack_require__("mMDG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__chunk_4d76806f_js__ = __webpack_require__("t4YS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__chunk_eb60b35a_js__ = __webpack_require__("RbWz");












//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// These should match the variables in clockpicker.scss
var indicatorSize = 40;
var paddingInner = 5;
var script = {
  name: 'BClockpickerFace',
  props: {
    pickerSize: Number,
    min: Number,
    max: Number,
    double: Boolean,
    value: Number,
    faceNumbers: Array,
    disabledValues: Function
  },
  data: function data() {
    return {
      isDragging: false,
      inputValue: this.value,
      prevAngle: 720
    };
  },
  computed: {
    /**
    * How many number indicators are shown on the face
    */
    count: function count() {
      return this.max - this.min + 1;
    },

    /**
    * How many number indicators are shown per ring on the face
    */
    countPerRing: function countPerRing() {
      return this.double ? this.count / 2 : this.count;
    },

    /**
    * Radius of the clock face
    */
    radius: function radius() {
      return this.pickerSize / 2;
    },

    /**
    * Radius of the outer ring of number indicators
    */
    outerRadius: function outerRadius() {
      return this.radius - paddingInner - indicatorSize / 2;
    },

    /**
    * Radius of the inner ring of number indicators
    */
    innerRadius: function innerRadius() {
      return Math.max(this.outerRadius * 0.6, this.outerRadius - paddingInner - indicatorSize); // 48px gives enough room for the outer ring of numbers
    },

    /**
    * The angle for each selectable value
    * For hours this ends up being 30 degrees, for minutes 6 degrees
    */
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.countPerRing;
    },

    /**
    * Used for calculating x/y grid location based on degrees
    */
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },

    /**
    * Calculates the angle the clock hand should be rotated for the
    * selected value
    */
    handRotateAngle: function handRotateAngle() {
      var currentAngle = this.prevAngle;

      while (currentAngle < 0) {
        currentAngle += 360;
      }

      var targetAngle = this.calcHandAngle(this.displayedValue);
      var degreesDiff = this.shortestDistanceDegrees(currentAngle, targetAngle);
      var angle = this.prevAngle + degreesDiff;
      return angle;
    },

    /**
    * Determines how long the selector hand is based on if the
    * selected value is located along the outer or inner ring
    */
    handScale: function handScale() {
      return this.calcHandScale(this.displayedValue);
    },
    handStyle: function handStyle() {
      return {
        transform: "rotate(".concat(this.handRotateAngle, "deg) scaleY(").concat(this.handScale, ")"),
        transition: '.3s cubic-bezier(.25,.8,.50,1)'
      };
    },

    /**
    * The value the hand should be pointing at
    */
    displayedValue: function displayedValue() {
      return this.inputValue == null ? this.min : this.inputValue;
    }
  },
  watch: {
    value: function value(_value) {
      if (_value !== this.inputValue) {
        this.prevAngle = this.handRotateAngle;
      }

      this.inputValue = _value;
    }
  },
  methods: {
    isDisabled: function isDisabled(value) {
      return this.disabledValues && this.disabledValues(value);
    },

    /**
    * Calculates the distance between two points
    */
    euclidean: function euclidean(p0, p1) {
      var dx = p1.x - p0.x;
      var dy = p1.y - p0.y;
      return Math.sqrt(dx * dx + dy * dy);
    },
    shortestDistanceDegrees: function shortestDistanceDegrees(start, stop) {
      var modDiff = (stop - start) % 360;
      var shortestDistance = 180 - Math.abs(Math.abs(modDiff) - 180);
      return (modDiff + 360) % 360 < 180 ? shortestDistance * 1 : shortestDistance * -1;
    },

    /**
    * Calculates the angle of the line from the center point
    * to the given point.
    */
    coordToAngle: function coordToAngle(center, p1) {
      var value = 2 * Math.atan2(p1.y - center.y - this.euclidean(center, p1), p1.x - center.x);
      return Math.abs(value * 180 / Math.PI);
    },

    /**
    * Generates the inline style translate() property for a
    * number indicator, which determines it's location on the
    * clock face
    */
    getNumberTranslate: function getNumberTranslate(value) {
      var _this$getNumberCoords = this.getNumberCoords(value),
          x = _this$getNumberCoords.x,
          y = _this$getNumberCoords.y;

      return "translate(".concat(x, "px, ").concat(y, "px)");
    },

    /***
    * Calculates the coordinates on the clock face for a number
    * indicator value
    */
    getNumberCoords: function getNumberCoords(value) {
      var radius = this.isInnerRing(value) ? this.innerRadius : this.outerRadius;
      return {
        x: Math.round(radius * Math.sin((value - this.min) * this.degrees)),
        y: Math.round(-radius * Math.cos((value - this.min) * this.degrees))
      };
    },
    getFaceNumberClasses: function getFaceNumberClasses(num) {
      return {
        'active': num.value === this.displayedValue,
        'disabled': this.isDisabled(num.value)
      };
    },

    /**
    * Determines if a value resides on the inner ring
    */
    isInnerRing: function isInnerRing(value) {
      return this.double && value - this.min >= this.countPerRing;
    },
    calcHandAngle: function calcHandAngle(value) {
      var angle = this.degreesPerUnit * (value - this.min);
      if (this.isInnerRing(value)) angle -= 360;
      return angle;
    },
    calcHandScale: function calcHandScale(value) {
      return this.isInnerRing(value) ? this.innerRadius / this.outerRadius : 1;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;

      if (!this.isDisabled(this.inputValue)) {
        this.$emit('change', this.inputValue);
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var _this$$refs$clock$get = this.$refs.clock.getBoundingClientRect(),
          width = _this$$refs$clock$get.width,
          top = _this$$refs$clock$get.top,
          left = _this$$refs$clock$get.left;

      var _ref = 'touches' in e ? e.touches[0] : e,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      var center = {
        x: width / 2,
        y: -width / 2
      };
      var coords = {
        x: clientX - left,
        y: top - clientY
      };
      var handAngle = Math.round(this.coordToAngle(center, coords) + 360) % 360;
      var insideClick = this.double && this.euclidean(center, coords) < (this.outerRadius + this.innerRadius) / 2 - 16;
      var value = Math.round(handAngle / this.degreesPerUnit) + this.min + (insideClick ? this.countPerRing : 0); // Necessary to fix edge case when selecting left part of max value

      if (handAngle >= 360 - this.degreesPerUnit / 2) {
        value = insideClick ? this.max : this.min;
      }

      this.update(value);
    },
    update: function update(value) {
      if (this.inputValue !== value && !this.isDisabled(value)) {
        this.prevAngle = this.handRotateAngle;
        this.inputValue = value;
        this.$emit('input', value);
      }
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-clockpicker-face",on:{"mousedown":_vm.onMouseDown,"mouseup":_vm.onMouseUp,"mousemove":_vm.onDragMove,"touchstart":_vm.onMouseDown,"touchend":_vm.onMouseUp,"touchmove":_vm.onDragMove}},[_c('div',{ref:"clock",staticClass:"b-clockpicker-face-outer-ring"},[_c('div',{staticClass:"b-clockpicker-face-hand",style:(_vm.handStyle)}),_vm._v(" "),_vm._l((_vm.faceNumbers),function(num,index){return _c('span',{key:index,staticClass:"b-clockpicker-face-number",class:_vm.getFaceNumberClasses(num),style:({ transform: _vm.getNumberTranslate(num.value) })},[_c('span',[_vm._v(_vm._s(num.label))])])})],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var ClockpickerFace = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var _components;
var outerPadding = 12;
var script$1 = {
  name: 'BClockpicker',
  components: (_components = {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, ClockpickerFace.name, ClockpickerFace), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__["a" /* I */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_10__chunk_eb60b35a_js__["a" /* F */].name, __WEBPACK_IMPORTED_MODULE_10__chunk_eb60b35a_js__["a" /* F */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__["a" /* I */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_9__chunk_4d76806f_js__["a" /* D */].name, __WEBPACK_IMPORTED_MODULE_9__chunk_4d76806f_js__["a" /* D */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_9__chunk_4d76806f_js__["b" /* a */].name, __WEBPACK_IMPORTED_MODULE_9__chunk_4d76806f_js__["b" /* a */]), _components),
  mixins: [__WEBPACK_IMPORTED_MODULE_7__chunk_1196ee55_js__["a" /* T */]],
  props: {
    pickerSize: {
      type: Number,
      default: 290
    },
    hourFormat: {
      type: String,
      default: '12',
      validator: function validator(value) {
        return value === '24' || value === '12';
      }
    },
    incrementMinutes: {
      type: Number,
      default: 5
    },
    autoSwitch: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'is-primary'
    },
    hoursLabel: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultClockpickerHoursLabel || 'Hours';
      }
    },
    minutesLabel: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultClockpickerMinutesLabel || 'Min';
      }
    }
  },
  data: function data() {
    return {
      isSelectingHour: true,
      isDragging: false,
      _isClockpicker: true
    };
  },
  computed: {
    hoursDisplay: function hoursDisplay() {
      if (this.hoursSelected == null) return '--';
      if (this.isHourFormat24) return this.pad(this.hoursSelected);
      var display = this.hoursSelected;
      if (this.meridienSelected === this.PM) display -= 12;
      if (display === 0) display = 12;
      return display;
    },
    minutesDisplay: function minutesDisplay() {
      return this.minutesSelected == null ? '--' : this.pad(this.minutesSelected);
    },
    minFaceValue: function minFaceValue() {
      return this.isSelectingHour && !this.isHourFormat24 && this.meridienSelected === this.PM ? 12 : 0;
    },
    maxFaceValue: function maxFaceValue() {
      return this.isSelectingHour ? !this.isHourFormat24 && this.meridienSelected === this.AM ? 11 : 23 : 59;
    },
    faceSize: function faceSize() {
      return this.pickerSize - outerPadding * 2;
    },
    faceDisabledValues: function faceDisabledValues() {
      return this.isSelectingHour ? this.isHourDisabled : this.isMinuteDisabled;
    }
  },
  methods: {
    onClockInput: function onClockInput(value) {
      if (this.isSelectingHour) {
        this.hoursSelected = value;
        this.onHoursChange(value);
      } else {
        this.minutesSelected = value;
        this.onMinutesChange(value);
      }
    },
    onClockChange: function onClockChange(value) {
      if (this.autoSwitch && this.isSelectingHour) {
        this.isSelectingHour = !this.isSelectingHour;
      }
    },
    onMeridienClick: function onMeridienClick(value) {
      if (this.meridienSelected !== value) {
        this.meridienSelected = value;
        this.onMeridienChange(value);
      }
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-clockpicker control",class:[_vm.size, _vm.type, {'is-expanded': _vm.expanded}]},[(!_vm.isMobile || _vm.inline)?_c('b-dropdown',{ref:"dropdown",attrs:{"position":_vm.position,"disabled":_vm.disabled,"inline":_vm.inline,"append-to-body":_vm.appendToBody,"append-to-body-copy-parent":""},on:{"active-change":_vm.onActiveChange}},[(!_vm.inline)?_c('b-input',_vm._b({ref:"input",attrs:{"slot":"trigger","autocomplete":"off","value":_vm.formatValue(_vm.computedValue),"placeholder":_vm.placeholder,"size":_vm.size,"icon":_vm.icon,"icon-pack":_vm.iconPack,"loading":_vm.loading,"disabled":_vm.disabled,"readonly":!_vm.editable,"rounded":_vm.rounded,"use-html5-validation":_vm.useHtml5Validation},on:{"focus":_vm.handleOnFocus,"blur":function($event){_vm.onBlur() && _vm.checkHtml5Validity();}},nativeOn:{"click":function($event){$event.stopPropagation();_vm.toggle(true);},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.toggle(true);},"change":function($event){return _vm.onChangeNativePicker($event)}},slot:"trigger"},'b-input',_vm.$attrs,false)):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card",attrs:{"disabled":_vm.disabled,"custom":""}},[(_vm.inline)?_c('header',{staticClass:"card-header"},[_c('div',{staticClass:"b-clockpicker-header card-header-title"},[_c('div',{staticClass:"b-clockpicker-time"},[_c('span',{staticClass:"b-clockpicker-btn",class:{ active: _vm.isSelectingHour },on:{"click":function($event){_vm.isSelectingHour = true;}}},[_vm._v(_vm._s(_vm.hoursDisplay))]),_vm._v(" "),_c('span',[_vm._v(":")]),_vm._v(" "),_c('span',{staticClass:"b-clockpicker-btn",class:{ active: !_vm.isSelectingHour },on:{"click":function($event){_vm.isSelectingHour = false;}}},[_vm._v(_vm._s(_vm.minutesDisplay))])]),_vm._v(" "),(!_vm.isHourFormat24)?_c('div',{staticClass:"b-clockpicker-period"},[_c('div',{staticClass:"b-clockpicker-btn",class:{ active: _vm.meridienSelected == _vm.AM },on:{"click":function($event){_vm.onMeridienClick(_vm.AM);}}},[_vm._v("am")]),_vm._v(" "),_c('div',{staticClass:"b-clockpicker-btn",class:{ active: _vm.meridienSelected == _vm.PM },on:{"click":function($event){_vm.onMeridienClick(_vm.PM);}}},[_vm._v("pm")])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"b-clockpicker-body",style:({ width: _vm.faceSize + 'px', height: _vm.faceSize + 'px' })},[(!_vm.inline)?_c('div',{staticClass:"b-clockpicker-time"},[_c('div',{staticClass:"b-clockpicker-btn",class:{ active: _vm.isSelectingHour },on:{"click":function($event){_vm.isSelectingHour = true;}}},[_vm._v(_vm._s(_vm.hoursLabel))]),_vm._v(" "),_c('span',{staticClass:"b-clockpicker-btn",class:{ active: !_vm.isSelectingHour },on:{"click":function($event){_vm.isSelectingHour = false;}}},[_vm._v(_vm._s(_vm.minutesLabel))])]):_vm._e(),_vm._v(" "),(!_vm.isHourFormat24 && !_vm.inline)?_c('div',{staticClass:"b-clockpicker-period"},[_c('div',{staticClass:"b-clockpicker-btn",class:{ active: _vm.meridienSelected == _vm.AM },on:{"click":function($event){_vm.onMeridienClick(_vm.AM);}}},[_vm._v(_vm._s(_vm.AM))]),_vm._v(" "),_c('div',{staticClass:"b-clockpicker-btn",class:{ active: _vm.meridienSelected == _vm.PM },on:{"click":function($event){_vm.onMeridienClick(_vm.PM);}}},[_vm._v(_vm._s(_vm.PM))])]):_vm._e(),_vm._v(" "),_c('b-clockpicker-face',{attrs:{"picker-size":_vm.faceSize,"min":_vm.minFaceValue,"max":_vm.maxFaceValue,"face-numbers":_vm.isSelectingHour ? _vm.hours : _vm.minutes,"disabled-values":_vm.faceDisabledValues,"double":_vm.isSelectingHour && _vm.isHourFormat24,"value":_vm.isSelectingHour ? _vm.hoursSelected : _vm.minutesSelected},on:{"input":_vm.onClockInput,"change":_vm.onClockChange}})],1)]),_vm._v(" "),(_vm.$slots.default !== undefined && _vm.$slots.default.length)?_c('footer',{staticClass:"b-clockpicker-footer card-footer"},[_vm._t("default")],2):_vm._e()])],1):_c('b-input',_vm._b({ref:"input",attrs:{"type":"time","autocomplete":"off","value":_vm.formatHHMMSS(_vm.computedValue),"placeholder":_vm.placeholder,"size":_vm.size,"icon":_vm.icon,"icon-pack":_vm.iconPack,"loading":_vm.loading,"max":_vm.formatHHMMSS(_vm.maxTime),"min":_vm.formatHHMMSS(_vm.minTime),"disabled":_vm.disabled,"readonly":false,"use-html5-validation":_vm.useHtml5Validation},on:{"focus":_vm.handleOnFocus,"blur":function($event){_vm.onBlur() && _vm.checkHtml5Validity();}},nativeOn:{"click":function($event){$event.stopPropagation();_vm.toggle(true);},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.toggle(true);},"change":function($event){return _vm.onChangeNativePicker($event)}}},'b-input',_vm.$attrs,false))],1)};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Clockpicker = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["d" /* r */])(Vue, Clockpicker);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "Ibhu":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("D2L2");
var toIObject = __webpack_require__("TcQ7");
var arrayIndexOf = __webpack_require__("vFc/")(false);
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "IvMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BCheckboxButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_2793447b_js__ = __webpack_require__("gNW3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_7bdbd626_js__ = __webpack_require__("QBkZ");
/* unused harmony reexport BCheckbox */





//
var script = {
  name: 'BCheckboxButton',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__chunk_2793447b_js__["a" /* C */]],
  props: {
    type: {
      type: String,
      default: 'is-primary'
    },
    expanded: Boolean
  },
  data: function data() {
    return {
      isFocused: false
    };
  },
  computed: {
    checked: function checked() {
      if (Array.isArray(this.newValue)) {
        return this.newValue.indexOf(this.nativeValue) >= 0;
      }

      return this.newValue === this.nativeValue;
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control",class:{ 'is-expanded': _vm.expanded }},[_c('label',{ref:"label",staticClass:"b-checkbox checkbox button",class:[_vm.checked ? _vm.type : null, _vm.size, {
                'is-disabled': _vm.disabled,
                'is-focused': _vm.isFocused
            }],attrs:{"disabled":_vm.disabled},on:{"click":_vm.focus,"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();_vm.$refs.label.click();}}},[_vm._t("default"),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.computedValue),expression:"computedValue"}],ref:"input",attrs:{"type":"checkbox","disabled":_vm.disabled,"required":_vm.required,"name":_vm.name},domProps:{"value":_vm.nativeValue,"checked":Array.isArray(_vm.computedValue)?_vm._i(_vm.computedValue,_vm.nativeValue)>-1:(_vm.computedValue)},on:{"click":function($event){$event.stopPropagation();},"focus":function($event){_vm.isFocused = true;},"blur":function($event){_vm.isFocused = false;},"change":function($event){var $$a=_vm.computedValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.nativeValue,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.computedValue=$$a.concat([$$v]));}else{$$i>-1&&(_vm.computedValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else{_vm.computedValue=$$c;}}}})],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var CheckboxButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["d" /* r */])(Vue, __WEBPACK_IMPORTED_MODULE_2__chunk_7bdbd626_js__["a" /* C */]);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["d" /* r */])(Vue, CheckboxButton);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "JP+z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "K/Lq":
/***/ (function(module, exports, __webpack_require__) {

(function () {
    Number.isInteger = Number.isInteger || function (value) {
        return typeof value === 'number' &&
            isFinite(value) &&
            Math.floor(value) === value;
    };
    var Cookie = __webpack_require__("2DS2");

    var VueCookie = {

        install: function (Vue) {
            Vue.prototype.$cookie = this;
            Vue.cookie = this;
        },
        set: function (name, value, daysOrOptions) {
            var opts = daysOrOptions;
            if(Number.isInteger(daysOrOptions)) {
                opts = {expires: daysOrOptions};
            }
            return Cookie.set(name, value, opts);
        },

        get: function (name) {
            return Cookie.get(name);
        },

        delete: function (name, options) {
            var opts = {expires: -1};
            if(options !== undefined) {
                opts = Object.assign(options, opts);
            }
            this.set(name, '', opts);
        }
    };

    if (true) {
        module.exports = VueCookie;
    } else if (typeof define == "function" && define.amd) {
        define([], function(){ return VueCookie; })
    } else if (window.Vue) {
        window.VueCookie = VueCookie;
        Vue.use(VueCookie);
    }

})();


/***/ }),

/***/ "KCLY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("cGG2");
var normalizeHeaderName = __webpack_require__("5VQ+");
var enhanceError = __webpack_require__("t8qj");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("7GwW");
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__("7GwW");
  }
  return adapter;
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "L42u":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("+ZMJ");
var invoke = __webpack_require__("knuC");
var html = __webpack_require__("RPLV");
var cel = __webpack_require__("ON07");
var global = __webpack_require__("7KvD");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("R9M2")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "LPeZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createAbsoluteElement; });
/* unused harmony export createNewEvent */
/* unused harmony export escapeRegExpChars */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getValueByPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return indexOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return merge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return multiColumnSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sign; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");


/**
 * +/- function to native math sign
 */
function signPoly(value) {
  if (value < 0) return -1;
  return value > 0 ? 1 : 0;
}

var sign = Math.sign || signPoly;
/**
 * Get value of an object property/path even if it's nested
 */

function getValueByPath(obj, path) {
  var value = path.split('.').reduce(function (o, i) {
    return o ? o[i] : null;
  }, obj);
  return value;
}
/**
 * Extension of indexOf method by equality function if specified
 */

function indexOf(array, obj, fn) {
  if (!array) return -1;
  if (!fn || typeof fn !== 'function') return array.indexOf(obj);

  for (var i = 0; i < array.length; i++) {
    if (fn(array[i], obj)) {
      return i;
    }
  }

  return -1;
}
/**
 * Merge function to replace Object.assign with deep merging possibility
 */

var isObject = function isObject(item) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["a" /* b */])(item) === 'object' && !Array.isArray(item);
};

var mergeFn = function mergeFn(target, source) {
  var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (deep || !Object.assign) {
    var isDeep = function isDeep(prop) {
      return isObject(source[prop]) && target !== null && target.hasOwnProperty(prop) && isObject(target[prop]);
    };

    var replaced = Object.getOwnPropertyNames(source).map(function (prop) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({}, prop, isDeep(prop) ? mergeFn(target[prop], source[prop], deep) : source[prop]);
    }).reduce(function (a, b) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["c" /* a */])({}, a, {}, b);
    }, {});
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["c" /* a */])({}, target, {}, replaced);
  } else {
    return Object.assign(target, source);
  }
};

var merge = mergeFn;
/**
 * Mobile detection
 * https://www.abeautifulsite.net/detecting-mobile-devices-with-javascript
 */

var isMobile = {
  Android: function Android() {
    return typeof window !== 'undefined' && window.navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function BlackBerry() {
    return typeof window !== 'undefined' && window.navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function iOS() {
    return typeof window !== 'undefined' && window.navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function Opera() {
    return typeof window !== 'undefined' && window.navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function Windows() {
    return typeof window !== 'undefined' && window.navigator.userAgent.match(/IEMobile/i);
  },
  any: function any() {
    return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
  }
};
function removeElement(el) {
  if (typeof el.remove !== 'undefined') {
    el.remove();
  } else if (typeof el.parentNode !== 'undefined' && el.parentNode !== null) {
    el.parentNode.removeChild(el);
  }
}
function createAbsoluteElement(el) {
  var root = document.createElement('div');
  root.style.position = 'absolute';
  root.style.left = '0px';
  root.style.top = '0px';
  var wrapper = document.createElement('div');
  root.appendChild(wrapper);
  wrapper.appendChild(el);
  document.body.appendChild(root);
  return root;
}
/**
 * Escape regex characters
 * http://stackoverflow.com/a/6969486
 */

function escapeRegExpChars(value) {
  if (!value) return value; // eslint-disable-next-line

  return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
function multiColumnSort(inputArray, sortingPriority) {
  // clone it to prevent the any watchers from triggering every sorting iteration
  var array = JSON.parse(JSON.stringify(inputArray));

  var fieldSorter = function fieldSorter(fields) {
    return function (a, b) {
      return fields.map(function (o) {
        var dir = 1;

        if (o[0] === '-') {
          dir = -1;
          o = o.substring(1);
        }

        return a[o] > b[o] ? dir : a[o] < b[o] ? -dir : 0;
      }).reduce(function (p, n) {
        return p || n;
      }, 0);
    };
  };

  return array.sort(fieldSorter(sortingPriority));
}
function createNewEvent(eventName) {
  var event;

  if (typeof Event === 'function') {
    event = new Event(eventName);
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, true, true);
  }

  return event;
}




/***/ }),

/***/ "M3yv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BDialog */
/* unused harmony export DialogProgrammatic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_42f463e6_js__ = __webpack_require__("mMDG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chunk_0cb0546b_js__ = __webpack_require__("aGWY");








var script = {
  name: 'BDialog',
  components: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({}, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */]),
  directives: {
    trapFocus: __WEBPACK_IMPORTED_MODULE_5__chunk_42f463e6_js__["a" /* t */]
  },
  extends: __WEBPACK_IMPORTED_MODULE_6__chunk_0cb0546b_js__["a" /* M */],
  props: {
    title: String,
    message: String,
    icon: String,
    iconPack: String,
    hasIcon: Boolean,
    type: {
      type: String,
      default: 'is-primary'
    },
    size: String,
    confirmText: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDialogConfirmText ? __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDialogConfirmText : 'OK';
      }
    },
    cancelText: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDialogCancelText ? __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDialogCancelText : 'Cancel';
      }
    },
    hasInput: Boolean,
    // Used internally to know if it's prompt
    inputAttrs: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    onConfirm: {
      type: Function,
      default: function _default() {}
    },
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    container: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultContainerElement;
      }
    },
    focusOn: {
      type: String,
      default: 'confirm'
    },
    trapFocus: {
      type: Boolean,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultTrapFocus;
      }
    },
    ariaRole: {
      type: String,
      validator: function validator(value) {
        return ['dialog', 'alertdialog'].indexOf(value) >= 0;
      }
    },
    ariaModal: Boolean
  },
  data: function data() {
    var prompt = this.hasInput ? this.inputAttrs.value || '' : '';
    return {
      prompt: prompt,
      isActive: false,
      validationMessage: ''
    };
  },
  computed: {
    dialogClass: function dialogClass() {
      return [this.size, {
        'has-custom-container': this.container !== null
      }];
    },

    /**
    * Icon name (MDI) based on the type.
    */
    iconByType: function iconByType() {
      switch (this.type) {
        case 'is-info':
          return 'information';

        case 'is-success':
          return 'check-circle';

        case 'is-warning':
          return 'alert';

        case 'is-danger':
          return 'alert-circle';

        default:
          return null;
      }
    },
    showCancel: function showCancel() {
      return this.cancelOptions.indexOf('button') >= 0;
    }
  },
  methods: {
    /**
    * If it's a prompt Dialog, validate the input.
    * Call the onConfirm prop (function) and close the Dialog.
    */
    confirm: function confirm() {
      var _this = this;

      if (this.$refs.input !== undefined) {
        if (!this.$refs.input.checkValidity()) {
          this.validationMessage = this.$refs.input.validationMessage;
          this.$nextTick(function () {
            return _this.$refs.input.select();
          });
          return;
        }
      }

      this.onConfirm(this.prompt, this);
      if (this.closeOnConfirm) this.close();
    },

    /**
    * Close the Dialog.
    */
    close: function close() {
      var _this2 = this;

      this.isActive = false; // Timeout for the animation complete before destroying

      setTimeout(function () {
        _this2.$destroy();

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["b" /* removeElement */])(_this2.$el);
      }, 150);
    }
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    // Insert the Dialog component in the element container
    if (typeof window !== 'undefined') {
      this.$nextTick(function () {
        var container = document.querySelector(_this3.container) || document.body;
        container.appendChild(_this3.$el);
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.isActive = true;

    if (typeof this.inputAttrs.required === 'undefined') {
      this.$set(this.inputAttrs, 'required', true);
    }

    this.$nextTick(function () {
      // Handle which element receives focus
      if (_this4.hasInput) {
        _this4.$refs.input.focus();
      } else if (_this4.focusOn === 'cancel' && _this4.showCancel) {
        _this4.$refs.cancelButton.focus();
      } else {
        _this4.$refs.confirmButton.focus();
      }
    });
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.animation}},[(_vm.isActive)?_c('div',{directives:[{name:"trap-focus",rawName:"v-trap-focus",value:(_vm.trapFocus),expression:"trapFocus"}],staticClass:"dialog modal is-active",class:_vm.dialogClass,attrs:{"role":_vm.ariaRole,"aria-modal":_vm.ariaModal}},[_c('div',{staticClass:"modal-background",on:{"click":function($event){_vm.cancel('outside');}}}),_vm._v(" "),_c('div',{staticClass:"modal-card animation-content"},[(_vm.title)?_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"modal-card-body",class:{ 'is-titleless': !_vm.title, 'is-flex': _vm.hasIcon }},[_c('div',{staticClass:"media"},[(_vm.hasIcon && (_vm.icon || _vm.iconByType))?_c('div',{staticClass:"media-left"},[_c('b-icon',{attrs:{"icon":_vm.icon ? _vm.icon : _vm.iconByType,"pack":_vm.iconPack,"type":_vm.type,"both":!_vm.icon,"size":"is-large"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),(_vm.hasInput)?_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[(((_vm.inputAttrs).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.prompt),expression:"prompt"}],ref:"input",staticClass:"input",class:{ 'is-danger': _vm.validationMessage },attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.prompt)?_vm._i(_vm.prompt,null)>-1:(_vm.prompt)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirm($event)},"change":function($event){var $$a=_vm.prompt,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.prompt=$$a.concat([$$v]));}else{$$i>-1&&(_vm.prompt=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else{_vm.prompt=$$c;}}}},'input',_vm.inputAttrs,false)):(((_vm.inputAttrs).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.prompt),expression:"prompt"}],ref:"input",staticClass:"input",class:{ 'is-danger': _vm.validationMessage },attrs:{"type":"radio"},domProps:{"checked":_vm._q(_vm.prompt,null)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirm($event)},"change":function($event){_vm.prompt=null;}}},'input',_vm.inputAttrs,false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.prompt),expression:"prompt"}],ref:"input",staticClass:"input",class:{ 'is-danger': _vm.validationMessage },attrs:{"type":(_vm.inputAttrs).type},domProps:{"value":(_vm.prompt)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirm($event)},"input":function($event){if($event.target.composing){ return; }_vm.prompt=$event.target.value;}}},'input',_vm.inputAttrs,false))]),_vm._v(" "),_c('p',{staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.validationMessage))])]):_vm._e()])])]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[(_vm.showCancel)?_c('button',{ref:"cancelButton",staticClass:"button",on:{"click":function($event){_vm.cancel('button');}}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),_c('button',{ref:"confirmButton",staticClass:"button",class:_vm.type,on:{"click":_vm.confirm}},[_vm._v(_vm._s(_vm.confirmText))])])])]):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Dialog = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var localVueInstance;

function open(propsData) {
  var vm = typeof window !== 'undefined' && window.Vue ? window.Vue : localVueInstance || __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["d" /* V */];
  var DialogComponent = vm.extend(Dialog);
  return new DialogComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
}

var DialogProgrammatic = {
  alert: function alert(params) {
    if (typeof params === 'string') {
      params = {
        message: params
      };
    }

    var defaultParam = {
      canCancel: false
    };
    var propsData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* merge */])(defaultParam, params);
    return open(propsData);
  },
  confirm: function confirm(params) {
    var defaultParam = {};
    var propsData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* merge */])(defaultParam, params);
    return open(propsData);
  },
  prompt: function prompt(params) {
    var defaultParam = {
      hasInput: true,
      confirmText: 'Done'
    };
    var propsData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* merge */])(defaultParam, params);
    return open(propsData);
  }
};
var Plugin = {
  install: function install(Vue) {
    localVueInstance = Vue;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, Dialog);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["a"])(Vue, 'dialog', DialogProgrammatic);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "M6a0":
/***/ (function(module, exports) {



/***/ }),

/***/ "MU5D":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("R9M2");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "Mhyx":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("/bQp");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "MmMw":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("EqjI");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "NWt+":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("+ZMJ");
var call = __webpack_require__("msXi");
var isArrayIter = __webpack_require__("Mhyx");
var anObject = __webpack_require__("77Pl");
var toLength = __webpack_require__("QRG4");
var getIterFn = __webpack_require__("3fs2");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "O4g8":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "O9Pj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BTaglist */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_7292bea2_js__ = __webpack_require__("vNXG");
/* unused harmony reexport BTag */




//
//
//
//
//
//
var script = {
  name: 'BTaglist',
  props: {
    attached: Boolean
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags",class:{ 'has-addons': _vm.attached }},[_vm._t("default")],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Taglist = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["d" /* r */])(Vue, __WEBPACK_IMPORTED_MODULE_1__chunk_7292bea2_js__["a" /* T */]);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["d" /* r */])(Vue, Taglist);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "OGWA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_bd608559_js__ = __webpack_require__("lZGu");
/* unused harmony reexport BPagination */
/* unused harmony reexport BPaginationButton */








var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, __WEBPACK_IMPORTED_MODULE_5__chunk_bd608559_js__["a" /* P */]);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, __WEBPACK_IMPORTED_MODULE_5__chunk_bd608559_js__["b" /* a */]);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);


/***/ }),

/***/ "ON07":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
var document = __webpack_require__("7KvD").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "Oi+a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__("dIwP");
var combineURLs = __webpack_require__("qRfI");

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ "P1Pc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BSidebar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__ = __webpack_require__("rhEV");




//
var script = {
  name: 'BSidebar',
  props: {
    open: Boolean,
    type: [String, Object],
    overlay: Boolean,
    position: {
      type: String,
      default: 'fixed',
      validator: function validator(value) {
        return ['fixed', 'absolute', 'static'].indexOf(value) >= 0;
      }
    },
    fullheight: Boolean,
    fullwidth: Boolean,
    right: Boolean,
    mobile: {
      type: String
    },
    reduce: Boolean,
    expandOnHover: Boolean,
    expandOnHoverFixed: Boolean,
    canCancel: {
      type: [Array, Boolean],
      default: function _default() {
        return ['escape', 'outside'];
      }
    },
    onCancel: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      isOpen: this.open,
      transitionName: null,
      animating: true
    };
  },
  computed: {
    rootClasses: function rootClasses() {
      return [this.type, {
        'is-fixed': this.isFixed,
        'is-static': this.isStatic,
        'is-absolute': this.isAbsolute,
        'is-fullheight': this.fullheight,
        'is-fullwidth': this.fullwidth,
        'is-right': this.right,
        'is-mini': this.reduce,
        'is-mini-expand': this.expandOnHover,
        'is-mini-expand-fixed': this.expandOnHover && this.expandOnHoverFixed,
        'is-mini-mobile': this.mobile === 'reduce',
        'is-hidden-mobile': this.mobile === 'hide',
        'is-fullwidth-mobile': this.mobile === 'fullwidth'
      }];
    },
    cancelOptions: function cancelOptions() {
      return typeof this.canCancel === 'boolean' ? this.canCancel ? ['escape', 'outside'] : [] : this.canCancel;
    },
    isStatic: function isStatic() {
      return this.position === 'static';
    },
    isFixed: function isFixed() {
      return this.position === 'fixed';
    },
    isAbsolute: function isAbsolute() {
      return this.position === 'absolute';
    },

    /**
     * White-listed items to not close when clicked.
     * Add sidebar content and all children.
     */
    whiteList: function whiteList() {
      var whiteList = [];
      whiteList.push(this.$refs.sidebarContent); // Add all chidren from dropdown

      if (this.$refs.sidebarContent !== undefined) {
        var children = this.$refs.sidebarContent.querySelectorAll('*');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var child = _step.value;
            whiteList.push(child);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      return whiteList;
    }
  },
  watch: {
    open: {
      handler: function handler(value) {
        this.isOpen = value;
        var open = this.right ? !value : value;
        this.transitionName = !open ? 'slide-prev' : 'slide-next';
      },
      immediate: true
    }
  },
  methods: {
    /**
    * Keypress event that is bound to the document.
    */
    keyPress: function keyPress(event) {
      // Esc key
      if (this.isFixed) {
        if (this.isOpen && event.keyCode === 27) this.cancel('escape');
      }
    },

    /**
    * Close the Sidebar if canCancel and call the onCancel prop (function).
    */
    cancel: function cancel(method) {
      if (this.cancelOptions.indexOf(method) < 0) return;
      if (this.isStatic) return;
      this.onCancel.apply(null, arguments);
      this.close();
    },

    /**
    * Call the onCancel prop (function) and emit events
    */
    close: function close() {
      this.isOpen = false;
      this.$emit('close');
      this.$emit('update:open', false);
    },

    /**
     * Close fixed sidebar if clicked outside.
     */
    clickedOutside: function clickedOutside(event) {
      if (this.isFixed) {
        if (this.isOpen && !this.animating) {
          if (this.whiteList.indexOf(event.target) < 0) {
            this.cancel('outside');
          }
        }
      }
    },

    /**
    * Transition before-enter hook
    */
    beforeEnter: function beforeEnter() {
      this.animating = true;
    },

    /**
    * Transition after-leave hook
    */
    afterEnter: function afterEnter() {
      this.animating = false;
    }
  },
  created: function created() {
    if (typeof window !== 'undefined') {
      document.addEventListener('keyup', this.keyPress);
      document.addEventListener('click', this.clickedOutside);
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (this.isFixed) {
        document.body.appendChild(this.$el);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      document.removeEventListener('keyup', this.keyPress);
      document.removeEventListener('click', this.clickedOutside);
    }

    if (this.isFixed) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["b" /* removeElement */])(this.$el);
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-sidebar"},[(_vm.overlay && _vm.isOpen)?_c('div',{staticClass:"sidebar-background"}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transitionName},on:{"before-enter":_vm.beforeEnter,"after-enter":_vm.afterEnter}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],ref:"sidebarContent",staticClass:"sidebar-content",class:_vm.rootClasses},[_vm._t("default")],2)])],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Sidebar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["d" /* r */])(Vue, Sidebar);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "PzxK":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("D2L2");
var toObject = __webpack_require__("sB3e");
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "QBkZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_2793447b_js__ = __webpack_require__("gNW3");



//
var script = {
  name: 'BCheckbox',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__chunk_2793447b_js__["a" /* C */]],
  props: {
    indeterminate: Boolean,
    trueValue: {
      type: [String, Number, Boolean, Function, Object, Array],
      default: true
    },
    falseValue: {
      type: [String, Number, Boolean, Function, Object, Array],
      default: false
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{ref:"label",staticClass:"b-checkbox checkbox",class:[_vm.size, { 'is-disabled': _vm.disabled }],attrs:{"disabled":_vm.disabled},on:{"click":_vm.focus,"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();_vm.$refs.label.click();}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.computedValue),expression:"computedValue"}],ref:"input",attrs:{"type":"checkbox","disabled":_vm.disabled,"required":_vm.required,"name":_vm.name,"true-value":_vm.trueValue,"false-value":_vm.falseValue},domProps:{"indeterminate":_vm.indeterminate,"value":_vm.nativeValue,"checked":Array.isArray(_vm.computedValue)?_vm._i(_vm.computedValue,_vm.nativeValue)>-1:_vm._q(_vm.computedValue,_vm.trueValue)},on:{"click":function($event){$event.stopPropagation();},"change":function($event){var $$a=_vm.computedValue,$$el=$event.target,$$c=$$el.checked?(_vm.trueValue):(_vm.falseValue);if(Array.isArray($$a)){var $$v=_vm.nativeValue,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.computedValue=$$a.concat([$$v]));}else{$$i>-1&&(_vm.computedValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else{_vm.computedValue=$$c;}}}}),_vm._v(" "),_c('span',{staticClass:"check",class:_vm.type}),_vm._v(" "),_c('span',{staticClass:"control-label"},[_vm._t("default")],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Checkbox = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );




/***/ }),

/***/ "QR9R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Input; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_d0a313ea_js__ = __webpack_require__("EmVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__ = __webpack_require__("rhEV");






var script = {
  name: 'BInput',
  components: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({}, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */]),
  mixins: [__WEBPACK_IMPORTED_MODULE_2__chunk_d0a313ea_js__["a" /* F */]],
  inheritAttrs: false,
  props: {
    value: [Number, String],
    type: {
      type: String,
      default: 'text'
    },
    passwordReveal: Boolean,
    iconClickable: Boolean,
    hasCounter: {
      type: Boolean,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultInputHasCounter;
      }
    },
    customClass: {
      type: String,
      default: ''
    },
    iconRight: String,
    iconRightClickable: Boolean
  },
  data: function data() {
    return {
      newValue: this.value,
      newType: this.type,
      newAutocomplete: this.autocomplete || __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultInputAutocomplete,
      isPasswordVisible: false,
      _elementRef: this.type === 'textarea' ? 'textarea' : 'input'
    };
  },
  computed: {
    computedValue: {
      get: function get() {
        return this.newValue;
      },
      set: function set(value) {
        this.newValue = value;
        this.$emit('input', value);
        !this.isValid && this.checkHtml5Validity();
      }
    },
    rootClasses: function rootClasses() {
      return [this.iconPosition, this.size, {
        'is-expanded': this.expanded,
        'is-loading': this.loading,
        'is-clearfix': !this.hasMessage
      }];
    },
    inputClasses: function inputClasses() {
      return [this.statusType, this.size, {
        'is-rounded': this.rounded
      }];
    },
    hasIconRight: function hasIconRight() {
      return this.passwordReveal || this.loading || this.statusTypeIcon || this.iconRight;
    },
    rightIcon: function rightIcon() {
      if (this.passwordReveal) {
        return this.passwordVisibleIcon;
      } else if (this.iconRight) {
        return this.iconRight;
      }

      return this.statusTypeIcon;
    },
    rightIconType: function rightIconType() {
      if (this.passwordReveal) {
        return 'is-primary';
      } else if (this.iconRight) {
        return null;
      }

      return this.statusType;
    },

    /**
    * Position of the icon or if it's both sides.
    */
    iconPosition: function iconPosition() {
      if (this.icon && this.hasIconRight) {
        return 'has-icons-left has-icons-right';
      } else if (!this.icon && this.hasIconRight) {
        return 'has-icons-right';
      } else if (this.icon) {
        return 'has-icons-left';
      }
    },

    /**
    * Icon name (MDI) based on the type.
    */
    statusTypeIcon: function statusTypeIcon() {
      switch (this.statusType) {
        case 'is-success':
          return 'check';

        case 'is-danger':
          return 'alert-circle';

        case 'is-info':
          return 'information';

        case 'is-warning':
          return 'alert';
      }
    },

    /**
    * Check if have any message prop from parent if it's a Field.
    */
    hasMessage: function hasMessage() {
      return !!this.statusMessage;
    },

    /**
    * Current password-reveal icon name.
    */
    passwordVisibleIcon: function passwordVisibleIcon() {
      return !this.isPasswordVisible ? 'eye' : 'eye-off';
    },

    /**
    * Get value length
    */
    valueLength: function valueLength() {
      if (typeof this.computedValue === 'string') {
        return this.computedValue.length;
      } else if (typeof this.computedValue === 'number') {
        return this.computedValue.toString().length;
      }

      return 0;
    }
  },
  watch: {
    /**
    * When v-model is changed:
    *   1. Set internal value.
    */
    value: function value(_value) {
      this.newValue = _value;
    }
  },
  methods: {
    /**
    * Toggle the visibility of a password-reveal input
    * by changing the type and focus the input right away.
    */
    togglePasswordVisibility: function togglePasswordVisibility() {
      var _this = this;

      this.isPasswordVisible = !this.isPasswordVisible;
      this.newType = this.isPasswordVisible ? 'text' : 'password';
      this.$nextTick(function () {
        _this.$refs[_this.$data._elementRef].focus();
      });
    },

    /**
    * Input's 'input' event listener, 'nextTick' is used to prevent event firing
    * before ui update, helps when using masks (Cleavejs and potentially others).
    */
    onInput: function onInput(event) {
      var _this2 = this;

      this.$nextTick(function () {
        if (event.target) {
          _this2.computedValue = event.target.value;
        }
      });
    },
    iconClick: function iconClick(emit, event) {
      var _this3 = this;

      this.$emit(emit, event);
      this.$nextTick(function () {
        _this3.$refs[_this3.$data._elementRef].focus();
      });
    },
    rightIconClick: function rightIconClick(event) {
      if (this.passwordReveal) {
        this.togglePasswordVisibility();
      } else if (this.iconRightClickable) {
        this.iconClick('icon-right-click', event);
      }
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control",class:_vm.rootClasses},[(_vm.type !== 'textarea')?_c('input',_vm._b({ref:"input",staticClass:"input",class:[_vm.inputClasses, _vm.customClass],attrs:{"type":_vm.newType,"autocomplete":_vm.newAutocomplete,"maxlength":_vm.maxlength},domProps:{"value":_vm.computedValue},on:{"input":_vm.onInput,"blur":_vm.onBlur,"focus":_vm.onFocus}},'input',_vm.$attrs,false)):_c('textarea',_vm._b({ref:"textarea",staticClass:"textarea",class:[_vm.inputClasses, _vm.customClass],attrs:{"maxlength":_vm.maxlength},domProps:{"value":_vm.computedValue},on:{"input":_vm.onInput,"blur":_vm.onBlur,"focus":_vm.onFocus}},'textarea',_vm.$attrs,false)),_vm._v(" "),(_vm.icon)?_c('b-icon',{staticClass:"is-left",class:{'is-clickable': _vm.iconClickable},attrs:{"icon":_vm.icon,"pack":_vm.iconPack,"size":_vm.iconSize},nativeOn:{"click":function($event){_vm.iconClick('icon-click', $event);}}}):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.hasIconRight)?_c('b-icon',{staticClass:"is-right",class:{ 'is-clickable': _vm.passwordReveal || _vm.iconRightClickable },attrs:{"icon":_vm.rightIcon,"pack":_vm.iconPack,"size":_vm.iconSize,"type":_vm.rightIconType,"both":""},nativeOn:{"click":function($event){return _vm.rightIconClick($event)}}}):_vm._e(),_vm._v(" "),(_vm.maxlength && _vm.hasCounter && _vm.type !== 'number')?_c('small',{staticClass:"help counter",class:{ 'is-invisible': !_vm.isFocused }},[_vm._v("\r\n            "+_vm._s(_vm.valueLength)+" / "+_vm._s(_vm.maxlength)+"\r\n        ")]):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Input = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );




/***/ }),

/***/ "QRG4":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("UuGF");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "R9M2":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "RPLV":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7KvD").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "RY/4":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("R9M2");
var TAG = __webpack_require__("dSzd")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "RbWz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Field; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__ = __webpack_require__("rhEV");




var script = {
  name: 'BFieldBody',
  props: {
    message: {
      type: [String, Array]
    },
    type: {
      type: [String, Object]
    }
  },
  render: function render(createElement) {
    var _this = this;

    var first = true;
    return createElement('div', {
      attrs: {
        'class': 'field-body'
      }
    }, this.$slots.default.map(function (element) {
      // skip returns and comments
      if (!element.tag) {
        return element;
      }

      var message;

      if (first) {
        message = _this.message;
        first = false;
      }

      return createElement('b-field', {
        attrs: {
          type: _this.type,
          message: message
        }
      }, [element]);
    }));
  }
};

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  

  
  var FieldBody = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["c" /* _ */])(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var script$1 = {
  name: 'BField',
  components: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({}, FieldBody.name, FieldBody),
  props: {
    type: [String, Object],
    label: String,
    labelFor: String,
    message: [String, Array, Object],
    grouped: Boolean,
    groupMultiline: Boolean,
    position: String,
    expanded: Boolean,
    horizontal: Boolean,
    addons: {
      type: Boolean,
      default: true
    },
    customClass: String,
    labelPosition: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultFieldLabelPosition;
      }
    }
  },
  data: function data() {
    return {
      newType: this.type,
      newMessage: this.message,
      fieldLabelSize: null,
      _isField: true // Used internally by Input and Select

    };
  },
  computed: {
    rootClasses: function rootClasses() {
      return [this.newPosition, {
        'is-expanded': this.expanded,
        'is-grouped-multiline': this.groupMultiline,
        'is-horizontal': this.horizontal,
        'is-floating-in-label': this.hasLabel && !this.horizontal && this.labelPosition === 'inside',
        'is-floating-label': this.hasLabel && !this.horizontal && this.labelPosition === 'on-border'
      }, this.numberInputClasses];
    },

    /**
    * Correct Bulma class for the side of the addon or group.
    *
    * This is not kept like the others (is-small, etc.),
    * because since 'has-addons' is set automatically it
    * doesn't make sense to teach users what addons are exactly.
    */
    newPosition: function newPosition() {
      if (this.position === undefined) return;
      var position = this.position.split('-');
      if (position.length < 1) return;
      var prefix = this.grouped ? 'is-grouped-' : 'has-addons-';
      if (this.position) return prefix + position[1];
    },

    /**
    * Formatted message in case it's an array
    * (each element is separated by <br> tag)
    */
    formattedMessage: function formattedMessage() {
      if (typeof this.newMessage === 'string') {
        return [this.newMessage];
      }

      var messages = [];

      if (Array.isArray(this.newMessage)) {
        this.newMessage.forEach(function (message) {
          if (typeof message === 'string') {
            messages.push(message);
          } else {
            for (var key in message) {
              if (message[key]) {
                messages.push(key);
              }
            }
          }
        });
      } else {
        for (var key in this.newMessage) {
          if (this.newMessage[key]) {
            messages.push(key);
          }
        }
      }

      return messages.filter(function (m) {
        if (m) return m;
      });
    },
    hasLabel: function hasLabel() {
      return this.label || this.$slots.label;
    },
    hasMessage: function hasMessage() {
      return this.newMessage || this.$slots.message;
    },
    numberInputClasses: function numberInputClasses() {
      if (this.$slots.default) {
        var numberinput = this.$slots.default.filter(function (node) {
          return node.tag && node.tag.toLowerCase().indexOf('numberinput') >= 0;
        })[0];

        if (numberinput) {
          var classes = ['has-numberinput'];
          var controlsPosition = numberinput.componentOptions.propsData.controlsPosition;
          var size = numberinput.componentOptions.propsData.size;

          if (controlsPosition) {
            classes.push("has-numberinput-".concat(controlsPosition));
          }

          if (size) {
            classes.push("has-numberinput-".concat(size));
          }

          return classes;
        }
      }

      return null;
    }
  },
  watch: {
    /**
    * Set internal type when prop change.
    */
    type: function type(value) {
      this.newType = value;
    },

    /**
    * Set internal message when prop change.
    */
    message: function message(value) {
      this.newMessage = value;
    }
  },
  methods: {
    /**
    * Field has addons if there are more than one slot
    * (element / component) in the Field.
    * Or is grouped when prop is set.
    * Is a method to be called when component re-render.
    */
    fieldType: function fieldType() {
      if (this.grouped) return 'is-grouped';
      var renderedNode = 0;

      if (this.$slots.default) {
        renderedNode = this.$slots.default.reduce(function (i, node) {
          return node.tag ? i + 1 : i;
        }, 0);
      }

      if (renderedNode > 1 && this.addons && !this.horizontal) {
        return 'has-addons';
      }
    }
  },
  mounted: function mounted() {
    if (this.horizontal) {
      // Bulma docs: .is-normal for any .input or .button
      var elements = this.$el.querySelectorAll('.input, .select, .button, .textarea, .b-slider');

      if (elements.length > 0) {
        this.fieldLabelSize = 'is-normal';
      }
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field",class:[_vm.rootClasses, _vm.fieldType()]},[(_vm.horizontal)?_c('div',{staticClass:"field-label",class:[_vm.customClass, _vm.fieldLabelSize]},[(_vm.hasLabel)?_c('label',{staticClass:"label",class:_vm.customClass,attrs:{"for":_vm.labelFor}},[(_vm.$slots.label)?_vm._t("label"):[_vm._v(_vm._s(_vm.label))]],2):_vm._e()]):[(_vm.hasLabel)?_c('label',{staticClass:"label",class:_vm.customClass,attrs:{"for":_vm.labelFor}},[(_vm.$slots.label)?_vm._t("label"):[_vm._v(_vm._s(_vm.label))]],2):_vm._e()],_vm._v(" "),(_vm.horizontal)?_c('b-field-body',{attrs:{"message":_vm.newMessage ? _vm.formattedMessage : '',"type":_vm.newType}},[_vm._t("default")],2):[_vm._t("default")],_vm._v(" "),(_vm.hasMessage && !_vm.horizontal)?_c('p',{staticClass:"help",class:_vm.newType},[(_vm.$slots.message)?_vm._t("message"):[_vm._l((_vm.formattedMessage),function(mess,i){return [_vm._v("\r\n                    "+_vm._s(mess)+"\r\n                    "),((i + 1) < _vm.formattedMessage.length)?_c('br',{key:i}):_vm._e()]})]],2):_vm._e()],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Field = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );




/***/ }),

/***/ "S82l":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "SLDG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ "SdYw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BToast */
/* unused harmony export ToastProgrammatic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_53640c15_js__ = __webpack_require__("kGGF");






//
var script = {
  name: 'BToast',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__chunk_53640c15_js__["a" /* N */]],
  data: function data() {
    return {
      newDuration: this.duration || __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultToastDuration
    };
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"enter-active-class":_vm.transition.enter,"leave-active-class":_vm.transition.leave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"toast",class:[_vm.type, _vm.position],attrs:{"aria-hidden":!_vm.isActive,"role":"alert"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}})])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Toast = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var localVueInstance;
var ToastProgrammatic = {
  open: function open(params) {
    var parent;

    if (typeof params === 'string') {
      params = {
        message: params
      };
    }

    var defaultParam = {
      position: __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultToastPosition || 'is-top'
    };

    if (params.parent) {
      parent = params.parent;
      delete params.parent;
    }

    var propsData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* merge */])(defaultParam, params);
    var vm = typeof window !== 'undefined' && window.Vue ? window.Vue : localVueInstance || __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["d" /* V */];
    var ToastComponent = vm.extend(Toast);
    return new ToastComponent({
      parent: parent,
      el: document.createElement('div'),
      propsData: propsData
    });
  }
};
var Plugin = {
  install: function install(Vue) {
    localVueInstance = Vue;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["a"])(Vue, 'toast', ToastProgrammatic);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "SfB7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("+E39") && !__webpack_require__("S82l")(function () {
  return Object.defineProperty(__webpack_require__("ON07")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "SldL":
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ "TBek":
/***/ (function(module, exports) {

module.exports=function(A){var O={};function I(E){if(O[E])return O[E].exports;var N=O[E]={i:E,l:!1,exports:{}};return A[E].call(N.exports,N,N.exports,I),N.l=!0,N.exports}return I.m=A,I.c=O,I.d=function(A,O,E){I.o(A,O)||Object.defineProperty(A,O,{enumerable:!0,get:E})},I.r=function(A){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(A,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(A,"__esModule",{value:!0})},I.t=function(A,O){if(1&O&&(A=I(A)),8&O)return A;if(4&O&&"object"==typeof A&&A&&A.__esModule)return A;var E=Object.create(null);if(I.r(E),Object.defineProperty(E,"default",{enumerable:!0,value:A}),2&O&&"string"!=typeof A)for(var N in A)I.d(E,N,function(O){return A[O]}.bind(null,N));return E},I.n=function(A){var O=A&&A.__esModule?function(){return A.default}:function(){return A};return I.d(O,"a",O),O},I.o=function(A,O){return Object.prototype.hasOwnProperty.call(A,O)},I.p="",I(I.s=2)}([function(A,O,I){"use strict";Object.defineProperty(O,"__esModule",{value:!0}),O.COMUNI=void 0;O.COMUNI=[["A001","PD","ABANO BAGNI",0],["A001","PD","ABANO TERME",1],["A002","CO","ABBADIA",0],["A003","TO","ABBADIA",0],["A003","TO","ABBADIA ALPINA",0],["A004","LO","ABBADIA CERRETO",1],["A005","LC","ABBADIA LARIANA",1],["A006","SI","ABBADIA SAN SALVATORE",1],["A002","CO","ABBADIA SOPRA ADDA",0],["A007","OR","ABBASANTA",1],["A008","PE","ABBATEGGIO",1],["A009","FM","ABBAZIA",0],["A010","MI","ABBIATEGRASSO",1],["A011","VA","ABBIATEGUAZZONE",0],["A012","PT","ABETONE",0],["M376","PT","ABETONE CUTIGLIANO",1],["A013","PZ","ABRIOLA",1],["A014","RG","ACATE",1],["A015","FG","ACCADIA",1],["A016","CN","ACCEGLIO",1],["A017","MT","ACCETTURA",1],["A018","AQ","ACCIANO",1],["A019","RI","ACCUMOLI",1],["A020","PZ","ACERENZA",1],["A021","BZ","ACERETO",0],["A022","BZ","ACERNES",0],["A023","SA","ACERNO",1],["A024","NA","ACERRA",1],["A025","CT","ACI BONACCORSI",1],["A026","CT","ACI CASTELLO",1],["A027","CT","ACI CATENA",1],["A029","CT","ACI SANT'ANTONIO",1],["A028","CT","ACIREALE",1],["A030","SO","ACQUA",0],["A031","MC","ACQUACANINA",0],["A032","FR","ACQUAFONDATA",1],["A033","CS","ACQUAFORMOSA",1],["A034","BS","ACQUAFREDDA",1],["A035","PU","ACQUALAGNA",1],["A036","BS","ACQUALUNGA",0],["A037","CR","ACQUALUNGA BADONA",0],["A038","BS","ACQUANEGRA",0],["A039","CR","ACQUANEGRA",0],["A039","CR","ACQUANEGRA CREMONESE",1],["A038","MN","ACQUANEGRA SUL CHIESE",1],["A040","VT","ACQUAPENDENTE",1],["A041","CS","ACQUAPPESA",1],["A042","LE","ACQUARICA DEL CAPO",0],["A043","VV","ACQUARO",1],["A044","AP","ACQUASANTA",0],["A044","AP","ACQUASANTA TERME",1],["A045","TR","ACQUASPARTA",1],["A046","CO","ACQUATE",0],["A047","AP","ACQUAVIVA",0],["A048","BA","ACQUAVIVA",0],["A049","CL","ACQUAVIVA",0],["A050","CB","ACQUAVIVA COLLECROCE",1],["A051","IS","ACQUAVIVA D'ISERNIA",1],["A048","BA","ACQUAVIVA DELLE FONTI",1],["A047","AP","ACQUAVIVA PICENA",1],["A049","CL","ACQUAVIVA PLATANI",1],["M211","ME","ACQUEDOLCI",1],["A052","AL","ACQUI",0],["A052","AL","ACQUI TERME",1],["A053","CS","ACRI",1],["A054","FR","ACUTO",1],["A055","BA","ADELFIA",1],["A056","CT","ADERNO",0],["A056","CT","ADRANO",1],["A057","BG","ADRARA SAN MARTINO",1],["A058","BG","ADRARA SAN ROCCO",1],["A059","RO","ADRIA",1],["A060","BS","ADRO",1],["A061","VR","AFFI",1],["A062","RM","AFFILE",1],["A063","MI","AFFORI",0],["Z200","EE","AFGHANISTAN",0],["A064","NA","AFRAGOLA",1],["Z300","EE","AFRICA DEL SUD-OVEST",0],["A065","RC","AFRICO",1],["A066","NO","AGARO",0],["A067","PC","AGAZZANO",1],["A068","NA","AGEROLA",1],["A069","SS","AGGIUS",1],["A070","EN","AGIRA",1],["A071","PT","AGLIANA",1],["A072","AT","AGLIANO",0],["A072","AT","AGLIANO TERME",1],["A073","MI","AGLIATE",0],["A074","TO","AGLIE'",1],["H848","SS","AGLIENTU",1],["A075","PD","AGNA",1],["A076","CR","AGNADELLO",1],["A077","RC","AGNANA CALABRA",1],["A078","NO","AGNELLENGO",0],["A079","VC","AGNONA",0],["A080","IS","AGNONE",1],["A081","CE","AGNONE",0],["A082","BS","AGNOSINE",1],["A083","BL","AGORDO",1],["A084","RM","AGOSTA",1],["A085","VA","AGRA",1],["A086","NO","AGRANO",0],["A087","MI","AGRATE",0],["A088","NO","AGRATE",0],["A087","MB","AGRATE BRIANZA",1],["A087","MI","AGRATE BRIANZA",0],["A088","NO","AGRATE CONTURBIA",1],["A089","AG","AGRIGENTO",1],["A090","TN","AGRONE",0],["A091","SA","AGROPOLI",1],["A092","AN","AGUGLIANO",1],["A093","VI","AGUGLIARO",1],["A094","AO","AIAS",0],["A095","GO","AIBA",0],["A096","MB","AICURZIO",1],["A096","MI","AICURZIO",0],["A097","OR","AIDOMAGGIORE",1],["A098","EN","AIDONE",1],["A099","GO","AIDUSSINA",0],["A100","AQ","AIELLI",1],["A101","AV","AIELLO",0],["A102","CS","AIELLO CALABRO",1],["A103","UD","AIELLO DEL FRIULI",1],["A101","AV","AIELLO DEL SABATO",1],["A104","CS","AIELLO IN CALABRIA",0],["A105","CS","AIETA",1],["A106","CE","AILANO",1],["A107","BI","AILOCHE",1],["A108","AO","AIMAVILLA",0],["A109","TO","AIRASCA",1],["A110","BN","AIROLA",1],["A111","IM","AIROLE",1],["A112","LC","AIRUNO",1],["A113","CN","AISONE",1],["A114","CO","AIZURRO",0],["A115","SS","ALA",0],["A116","TN","ALA",1],["A117","TO","ALA DI STURA",1],["A115","SS","ALA' DEI SARDI",1],["A118","PV","ALAGNA",1],["A119","VC","ALAGNA",0],["A119","VC","ALAGNA VALSESIA",1],["A120","PE","ALANNO",1],["A121","BL","ALANO",0],["A121","BL","ALANO DI PIAVE",1],["A122","SV","ALASSIO",1],["A123","FR","ALATRI",1],["A124","CN","ALBA",1],["A125","TE","ALBA ADRIATICA",1],["A126","OR","ALBAGIARA",1],["A127","MI","ALBAIRATE",1],["A128","SA","ALBANELLA",1],["Z100","EE","ALBANIA",0],["A129","BG","ALBANO",0],["A130","NO","ALBANO",0],["A131","PZ","ALBANO",0],["A132","RM","ALBANO",0],["A131","PZ","ALBANO DI LUCANIA",1],["A132","RM","ALBANO LAZIALE",1],["A129","BG","ALBANO SANT'ALESSANDRO",1],["A130","VC","ALBANO VERCELLESE",1],["A133","CE","ALBANOVA",0],["A134","PV","ALBAREDO",0],["A135","SO","ALBAREDO",0],["A136","TV","ALBAREDO",0],["A137","VR","ALBAREDO",0],["A134","PV","ALBAREDO ARNABOLDI",1],["A137","VR","ALBAREDO D'ADIGE",1],["A135","SO","ALBAREDO PER SAN MARCO",1],["A138","PR","ALBARETO",1],["A138","PR","ALBARETO DI BORGOTARO",0],["A139","CN","ALBARETTO",0],["A140","CN","ALBARETTO",0],["A139","CN","ALBARETTO DELLA TORRE",1],["A140","CN","ALBARETTO VALLE DI MACRA",0],["A141","TS","ALBARO VESCOVA",0],["A142","CO","ALBATE",0],["A143","CO","ALBAVILLA",1],["A144","BG","ALBEGNO",0],["A145","SV","ALBENGA",1],["A148","TS","ALBER DI SESANA",0],["A146","AL","ALBERA",0],["A147","CR","ALBERA",0],["A146","AL","ALBERA LIGURE",1],["A149","BA","ALBEROBELLO",1],["A150","FG","ALBERONA",1],["A151","BZ","ALBES",0],["A152","CO","ALBESE",0],["A153","CO","ALBESE CON CASSANO",1],["A154","VI","ALBETTONE",1],["A155","CZ","ALBI",1],["A156","MS","ALBIANO",0],["A157","TO","ALBIANO",0],["A158","TN","ALBIANO",1],["A157","TO","ALBIANO D'IVREA",1],["A156","MS","ALBIANO MAGRA",0],["A159","MB","ALBIATE",1],["A159","MI","ALBIATE",0],["A160","CS","ALBIDONA",1],["A161","PD","ALBIGNASEGO",1],["A162","RE","ALBINEA",1],["A163","BG","ALBINO",1],["A164","CO","ALBIOLO",1],["A166","SV","ALBISOLA SUPERIORE",1],["A165","SV","ALBISSOLA MARINA",1],["A167","VA","ALBIZZATE",1],["A168","CO","ALBOGASIO",0],["A169","NO","ALBOGNO",0],["A170","PL","ALBONA",0],["A171","PV","ALBONESE",1],["A172","SO","ALBOSAGGIA",1],["A173","AT","ALBUGNANO",1],["A174","MI","ALBUSCIAGO",0],["A175","PV","ALBUZZANO",1],["A176","TP","ALCAMO",1],["A177","ME","ALCARA LI FUSI",1],["A178","TN","ALDENO",1],["A179","BZ","ALDINO",1],["A180","OR","ALES",1],["A181","AG","ALESSANDRIA",0],["A182","AL","ALESSANDRIA",1],["A183","CS","ALESSANDRIA",0],["A183","CS","ALESSANDRIA DEL CARRETTO",1],["A181","AG","ALESSANDRIA DELLA ROCCA",1],["A184","LE","ALESSANO",1],["A185","LE","ALEZIO",1],["A186","SA","ALFANO",1],["A187","AQ","ALFEDENA",1],["A188","BS","ALFIANELLO",1],["A189","AL","ALFIANO",0],["A190","CR","ALFIANO",0],["A190","CR","ALFIANO ED UNITI",0],["A189","AL","ALFIANO NATTA",1],["A191","RA","ALFONSINE",1],["Z301","EE","ALGERIA",0],["A192","SS","ALGHERO",1],["A193","BG","ALGUA",1],["A193","BG","ALGUA DI COSTA SERINA",0],["A194","ME","ALI'",1],["A201","ME","ALI' MARINA",0],["A194","ME","ALI' SUPERIORE",0],["A201","ME","ALI' TERME",1],["A195","PA","ALIA",1],["A196","MT","ALIANO",1],["A197","AL","ALICE",0],["A198","NO","ALICE",0],["A197","AL","ALICE BEL COLLE",1],["A198","VC","ALICE CASTELLO",1],["A199","TO","ALICE SUPERIORE",0],["A200","CE","ALIFE",1],["A202","PA","ALIMENA",1],["A203","PA","ALIMINUSA",1],["A204","OR","ALLAI",1],["A205","AO","ALLAIN",0],["A206","BL","ALLEGHE",1],["A205","AO","ALLEIN",1],["A205","AO","ALLENO",0],["A207","TR","ALLERONA",1],["A208","LE","ALLISTE",1],["A209","BZ","ALLIZ",0],["A210","RM","ALLUMIERE",1],["A211","AL","ALLUVIONI CAMBIO'",0],["M397","AL","ALLUVIONI PIOVERA",1],["A212","CN","ALMA",0],["A213","TN","ALMAZZAGO",0],["A214","BG","ALME'",1],["M305","BG","ALME' CON VILLA",0],["A216","BG","ALMENNO SAN BARTOLOMEO",1],["A217","BG","ALMENNO SAN SALVATORE",1],["A218","TO","ALMESE",1],["A219","BS","ALONE",0],["A220","VI","ALONTE",1],["M375","BL","ALPAGO",1],["A221","TO","ALPETTE",1],["A222","TO","ALPIGNANO",1],["A223","PC","ALSENO",1],["A224","CO","ALSERIO",1],["M386","PC","ALTA VAL TIDONE",1],["M383","CO","ALTA VALLE INTELVI",1],["A225","BA","ALTAMURA",1],["A226","SV","ALTARE",1],["M349","TN","ALTAVALLE",1],["A227","AL","ALTAVILLA",0],["A228","AV","ALTAVILLA",0],["A229","PA","ALTAVILLA",0],["A230","SA","ALTAVILLA",0],["A231","VI","ALTAVILLA",0],["A228","AV","ALTAVILLA IRPINA",1],["A229","PA","ALTAVILLA MILICIA",1],["A227","AL","ALTAVILLA MONFERRATO",1],["A230","SA","ALTAVILLA SILENTINA",1],["A231","VI","ALTAVILLA VICENTINA",1],["A232","AP","ALTETA",0],["A233","AP","ALTIDONA",0],["A233","FM","ALTIDONA",1],["A234","CS","ALTILIA",1],["A235","CH","ALTINO",1],["A236","VI","ALTISSIMO",1],["A237","TV","ALTIVOLE",1],["A238","CN","ALTO",1],["M369","BO","ALTO RENO TERME",1],["M389","VC","ALTO SERMENZA",1],["A239","PA","ALTOFONTE",1],["A240","CS","ALTOMONTE",1],["A241","LU","ALTOPASCIO",1],["M350","TN","ALTOPIANO DELLA VIGOLANA",1],["A242","TR","ALVIANO",1],["A243","CE","ALVIGNANO",1],["A244","FR","ALVITO",1],["A245","AL","ALZANO",0],["A246","BG","ALZANO LOMBARDO",1],["A247","BG","ALZANO MAGGIORE",0],["A245","AL","ALZANO SCRIVIA",1],["A248","BG","ALZANO SOPRA",0],["A249","CO","ALZATE",0],["A250","NO","ALZATE",0],["A249","CO","ALZATE BRIANZA",1],["A250","NO","ALZATE CON LINDUNO",0],["A249","CO","ALZATE CON VERZAGO",0],["A251","SA","AMALFI",1],["A252","AP","AMANDOLA",0],["A252","FM","AMANDOLA",1],["A253","CS","AMANTEA",1],["A254","UD","AMARO",1],["A255","CZ","AMARONI",1],["A256","FR","AMASENO",1],["A257","CZ","AMATO",1],["A258","RI","AMATRICE",1],["A259","BG","AMBIVERE",1],["A260","TN","AMBLAR",0],["M351","TN","AMBLAR-DON",1],["A261","SP","AMEGLIA",1],["A262","TR","AMELIA",1],["A263","CS","AMENDOLARA",1],["A264","NO","AMENO",1],["A265","BN","AMOROSI",1],["A266","BL","AMPEZZO",0],["A267","UD","AMPEZZO",1],["A268","NA","ANACAPRI",1],["A269","FR","ANAGNI",1],["A270","TE","ANCARANO",1],["A271","AN","ANCONA",1],["A272","CZ","ANDALI",1],["A273","SO","ANDALO",0],["A274","TN","ANDALO",1],["A273","SO","ANDALO VALTELLINO",1],["A275","TO","ANDEZENO",1],["A276","TN","ANDOGNO",0],["A277","CN","ANDONNO",0],["A278","SV","ANDORA",1],["A279","VC","ANDORNO CACCIORNA",0],["A280","BI","ANDORNO MICCA",1],["Z101","EE","ANDORRA",0],["A281","LE","ANDRANO",1],["A282","TO","ANDRATE",1],["A283","PN","ANDREIS",1],["A284","AV","ANDRETTA",1],["A285","BA","ANDRIA",0],["A285","BT","ANDRIA",1],["A286","BZ","ANDRIANO",1],["A287","SS","ANELA",1],["A288","BS","ANFO",1],["A289","BS","ANFURRO",0],["A290","VA","ANGERA",1],["A291","AR","ANGHIARI",1],["A292","VR","ANGIARI",1],["Z302","EE","ANGOLA",0],["A293","BS","ANGOLO",0],["A293","BS","ANGOLO TERME",1],["A294","SA","ANGRI",1],["A295","TO","ANGROGNA",1],["Z529","EE","ANGUILLA (ISOLA)",0],["A296","PD","ANGUILLARA",0],["A297","RM","ANGUILLARA",0],["A297","RM","ANGUILLARA SABAZIA",1],["A296","PD","ANGUILLARA VENETA",1],["A298","GO","ANICOVA CORADA",0],["A299","CR","ANNICCO",1],["A300","AL","ANNONE",0],["A301","CO","ANNONE",0],["A302","VE","ANNONE",0],["A301","LC","ANNONE DI BRIANZA",1],["A302","VE","ANNONE VENETO",1],["A303","RC","ANOIA",1],["A304","BG","ANTEGNATE",1],["A305","AO","ANTEI SANT'ANDREA",0],["A306","BZ","ANTERIVO",1],["A307","BZ","ANTERSELVA",0],["A308","TO","ANTEY LA MAGDELEINE",0],["A305","AO","ANTEY-SAINT-ANDRE'",1],["A309","RM","ANTICOLI",0],["A309","RM","ANTICOLI CORRADO",1],["A310","FR","ANTICOLI DI CAMPAGNA",0],["A311","PL","ANTIGNANA",0],["A312","AT","ANTIGNANO",1],["Z532","EE","ANTIGUA E BARBUDA",0],["Z500","EE","ANTILLE BRITANNICHE",0],["Z521","EE","ANTILLE BRITANNICHE",0],["Z523","EE","ANTILLE BRITANNICHE",0],["Z501","EE","ANTILLE OLANDESI",0],["A313","ME","ANTILLO",1],["A314","RC","ANTONIMINA",1],["A315","RI","ANTRODOCO",1],["A317","VB","ANTRONA SCHIERANCO",1],["A316","NO","ANTRONAPIANA",0],["A318","AQ","ANVERSA",0],["A318","AQ","ANVERSA DEGLI ABRUZZI",1],["A319","CO","ANZANO",0],["A320","FG","ANZANO",0],["A320","FG","ANZANO DEGLI IRPINI",0],["A319","CO","ANZANO DEL PARCO",1],["A320","FG","ANZANO DI PUGLIA",1],["A321","PZ","ANZI",1],["A322","NO","ANZINO",0],["A323","RM","ANZIO",1],["A324","BO","ANZOLA",0],["A325","NO","ANZOLA",0],["A325","VB","ANZOLA D'OSSOLA",1],["A324","BO","ANZOLA DELL'EMILIA",1],["A326","AO","AOSTA",1],["A327","PU","APECCHIO",1],["A328","BN","APICE",1],["A329","MC","APIRO",1],["A330","BN","APOLLOSA",1],["A331","GE","APPARIZIONE",0],["A332","BZ","APPIANO",0],["A333","CO","APPIANO",0],["A333","CO","APPIANO GENTILE",1],["A332","BZ","APPIANO SULLA STRADA DEL VINO",1],["A334","MC","APPIGNANO",1],["A335","AP","APPIGNANO DEL TRONTO",1],["A335","AP","APPIGNANO DI OFFIDA",0],["A336","FM","APRIANO",0],["A337","SO","APRICA",1],["A338","IM","APRICALE",1],["A339","FG","APRICENA",1],["A340","CS","APRIGLIANO",1],["A341","LT","APRILIA",1],["A342","MS","APUANIA",0],["A343","SA","AQUARA",1],["A344","IM","AQUILA",0],["A345","AQ","AQUILA",0],["A344","IM","AQUILA D'ARROSCIA",1],["A345","AQ","AQUILA DEGLI ABRUZZI",0],["A346","UD","AQUILEIA",1],["A347","AV","AQUILONIA",1],["A348","FR","AQUINO",1],["A349","NO","ARA",0],["Z201","EE","ARABIA MERIDIONALE FEDERAZIONE",0],["Z202","EE","ARABIA MERIDIONALE PROTETTORATO",0],["Z203","EE","ARABIA SAUDITA",0],["A350","LE","ARADEO",1],["A351","AG","ARAGONA",1],["A352","AT","ARAMENGO",1],["A353","VC","ARANCO",0],["A354","PN","ARBA",1],["A355","NU","ARBATAX DI TORTOLI",0],["A356","VA","ARBIZZO",0],["A357","OR","ARBOREA",1],["A358","VC","ARBORIO",1],["A359","CA","ARBUS",0],["A359","SU","ARBUS",1],["A360","TV","ARCADE",1],["A361","MI","ARCAGNA",0],["A362","MI","ARCAGNANO",0],["A363","FR","ARCE",1],["A364","CO","ARCELLASCO",0],["A365","BG","ARCENE",1],["A366","AN","ARCEVIA",1],["A367","CH","ARCHI",1],["A368","CA","ARCIDANO",0],["A369","GR","ARCIDOSSO",1],["A370","RM","ARCINAZZO ROMANO",1],["A371","VA","ARCISATE",1],["A372","TN","ARCO",1],["A373","SP","ARCOLA",1],["A374","VR","ARCOLE",1],["A375","MI","ARCONATE",1],["A376","MB","ARCORE",1],["A376","MI","ARCORE",0],["A377","VI","ARCUGNANO",1],["A378","VA","ARCUMEGGIA",0],["A379","SS","ARDARA",1],["A380","OR","ARDAULI",1],["M213","RM","ARDEA",1],["A381","VA","ARDENA",0],["A382","SO","ARDENNO",1],["A383","BG","ARDESIO",1],["A384","CR","ARDOLE SAN MARINO",0],["A385","RC","ARDORE",1],["A386","VV","ARENA",1],["A387","PV","ARENA",0],["A387","PV","ARENA PO",1],["A388","GE","ARENZANO",1],["A389","MI","ARESE",1],["A390","AR","AREZZO",1],["A391","CO","ARGEGNO",1],["A392","BO","ARGELATO",1],["A393","FE","ARGENTA",1],["A394","CN","ARGENTERA",1],["Z600","EE","ARGENTINA",0],["A395","PV","ARGINE",0],["A395","PV","ARGINE PO",0],["A396","CN","ARGUELLO",1],["A397","CZ","ARGUSTO",1],["A398","CH","ARI",1],["A399","AV","ARIANO",0],["A400","RO","ARIANO",0],["A399","AV","ARIANO DI PUGLIA",0],["A399","AV","ARIANO IRPINO",1],["A400","RO","ARIANO NEL POLESINE",1],["A401","RM","ARICCIA",1],["A402","CH","ARIELLI",1],["A403","CE","ARIENZO",1],["A404","CE","ARIENZO SANFELICE",0],["A405","TO","ARIGNANO",1],["A406","AQ","ARISCHIA",0],["A407","NU","ARITZO",1],["A408","CA","ARIXI",0],["A409","NO","ARIZZANO",0],["A409","VB","ARIZZANO",1],["A410","NO","ARIZZANO INFERIORE",0],["A411","NO","ARIZZANO SUPERIORE",0],["A412","RM","ARLENA",0],["A412","VT","ARLENA DI CASTRO",1],["A413","MI","ARLUNO",1],["Z137","EE","ARMENIA",0],["Z252","EE","ARMENIA",0],["A414","NO","ARMENO",1],["A415","PZ","ARMENTO",1],["A416","VA","ARMIO",0],["A417","BS","ARMO",0],["A418","IM","ARMO",1],["A419","CA","ARMUNGIA",0],["A419","SU","ARMUNGIA",1],["A424","AO","ARNAD",1],["A420","TN","ARNAGO",0],["A421","FR","ARNARA",1],["A422","SV","ARNASCO",1],["A423","MI","ARNATE",0],["A424","AO","ARNAZ",0],["A425","LE","ARNESANO",1],["A426","TN","ARNO",0],["A427","VB","AROLA",1],["A428","VA","AROLO",0],["A429","NO","ARONA",1],["A430","CO","AROSIO",1],["A431","BN","ARPAIA",1],["A432","BN","ARPAISE",1],["A433","FR","ARPINO",1],["A434","PD","ARQUA'",0],["A435","RO","ARQUA'",0],["A434","PD","ARQUA' PETRARCA",1],["A435","RO","ARQUA' POLESINE",1],["A436","AL","ARQUATA",0],["A437","AP","ARQUATA",0],["A437","AP","ARQUATA DEL TRONTO",1],["A436","AL","ARQUATA SCRIVIA",1],["A438","PD","ARRE",1],["A439","TR","ARRONE",1],["A440","BG","ARSAGO",0],["A441","MI","ARSAGO",0],["A441","VA","ARSAGO SEPRIO",1],["A442","PL","ARSIA",0],["A443","BL","ARSIE'",1],["A444","VI","ARSIERO",1],["A445","TE","ARSITA",1],["A446","RM","ARSOLI",1],["A447","UD","ARTA",0],["A447","UD","ARTA TERME",1],["A448","UD","ARTEGNA",1],["A449","RM","ARTENA",1],["A450","NO","ARTO'",0],["A451","BS","ARTOGNE",1],["A452","AO","ARVIE",0],["A452","AO","ARVIER",1],["A453","SS","ARZACHENA",1],["A440","BG","ARZAGO D'ADDA",1],["A454","NU","ARZANA",1],["A455","NA","ARZANO",1],["A456","PN","ARZENE",0],["A457","IM","ARZENO D'ONEGLIA",0],["A458","PD","ARZERGRANDE",1],["A459","VI","ARZIGNANO",1],["A460","SA","ASCEA",1],["A461","SI","ASCIANO",1],["A462","AP","ASCOLI",0],["A463","FG","ASCOLI",0],["A462","AP","ASCOLI PICENO",1],["A463","FG","ASCOLI SATRIANO",1],["A464","RI","ASCREA",1],["A465","VI","ASIAGO",1],["A466","VC","ASIGLIANO",0],["A467","VI","ASIGLIANO",0],["A467","VI","ASIGLIANO VENETO",1],["A466","VC","ASIGLIANO VERCELLESE",1],["A468","SI","ASINALUNGA",0],["A469","CO","ASNAGO",0],["A470","MN","ASOLA",1],["A471","TV","ASOLO",1],["A472","RI","ASPRA",0],["A472","RI","ASPRA SABINA",0],["A473","MI","ASSAGO",1],["A474","CA","ASSEMINI",1],["A475","PG","ASSISI",1],["A476","CO","ASSO",1],["A477","OR","ASSOLO",1],["A477","CA","ASSOLO NURECI",0],["A478","EN","ASSORO",1],["A479","AT","ASTI",1],["A480","OR","ASUNI",1],["A481","AQ","ATELETA",1],["A482","PZ","ATELLA",1],["A483","CE","ATELLA DI NAPOLI",0],["A484","SA","ATENA",0],["A484","SA","ATENA LUCANA",1],["A485","CH","ATESSA",1],["A486","FR","ATINA",1],["A487","SA","ATRANI",1],["A488","TE","ATRI",1],["A489","AV","ATRIPALDA",1],["A490","TR","ATTIGLIANO",1],["A491","UD","ATTIMIS",1],["A492","NU","ATZARA",1],["A493","PU","AUDITORE",0],["A494","SR","AUGUSTA",1],["A495","SA","AULETTA",1],["A496","MS","AULLA",1],["A497","VB","AURANO",1],["A498","TS","AUREMO DI SOPRA",0],["A499","IM","AURIGO",1],["A500","TS","AURISINA",0],["A501","BL","AURONZO",0],["A501","BL","AURONZO DI CADORE",1],["A502","FR","AUSONIA",1],["A503","NU","AUSTIS",1],["Z700","EE","AUSTRALIA",0],["Z102","EE","AUSTRIA",0],["A504","NO","AUZATE",0],["A505","GO","AUZZA",0],["A506","GE","AVEGNO",1],["A507","BZ","AVELENGO",1],["A507","BZ","AVELIGNA",0],["A508","AV","AVELLA",1],["A509","AV","AVELLINO",1],["A510","BS","AVENONE",0],["A511","BG","AVERARA",1],["A512","CE","AVERSA",1],["A513","VR","AVESA",0],["A514","TA","AVETRANA",1],["A515","AQ","AVEZZANO",1],["A516","PN","AVIANO",1],["A517","BG","AVIATICO",1],["A518","TO","AVIGLIANA",1],["A519","PZ","AVIGLIANO",1],["M258","TR","AVIGLIANO UMBRO",1],["A520","TN","AVIO",1],["A521","AO","AVISE",1],["A522","SR","AVOLA",1],["A523","AL","AVOLASCA",1],["A524","TO","AVUGLIONE E VERNONE",0],["A094","AO","AYAS",1],["A108","AO","AYMAVILLES",1],["A525","TO","AZEGLIO",1],["Z141","EE","AZERBAIGIAN",0],["Z253","EE","AZERBAIGIAN",0],["A526","CR","AZZANELLO",1],["A527","AL","AZZANO",0],["A528","BG","AZZANO",0],["A529","BS","AZZANO",0],["A530","UD","AZZANO",0],["A527","AT","AZZANO D'ASTI",1],["A530","PN","AZZANO DECIMO",1],["A527","AL","AZZANO DEL TANARO",0],["A529","BS","AZZANO MELLA",1],["A528","BG","AZZANO SAN PAOLO",1],["A531","VA","AZZATE",1],["A532","VA","AZZIO",1],["A533","BG","AZZONE",1],["A534","VB","BACENO",1],["A535","NA","BACOLI",1],["A445","TE","BACUCCO",0],["A536","IM","BADALUCCO",1],["M214","SS","BADESI",1],["A537","BZ","BADIA",1],["A538","PV","BADIA",0],["A539","RO","BADIA",0],["A540","VR","BADIA CALAVENA",1],["A538","PV","BADIA PAVESE",1],["A539","RO","BADIA POLESINE",1],["A541","AR","BADIA TEDALDA",1],["A542","CZ","BADOLATO",1],["A543","CO","BAGAGGERA",0],["A544","RC","BAGALADI",1],["A545","MI","BAGGIO",0],["A546","PA","BAGHERIA",1],["A547","RA","BAGNACAVALLO",1],["A548","VT","BAGNAIA",0],["A549","BN","BAGNARA",0],["A550","PV","BAGNARA",0],["A551","RA","BAGNARA",0],["A552","RC","BAGNARA",0],["A552","RC","BAGNARA CALABRA",1],["A549","BN","BAGNARA DI BENEVENTO",0],["A551","RA","BAGNARA DI ROMAGNA",1],["A550","PV","BAGNARIA",1],["A553","UD","BAGNARIA",0],["A553","UD","BAGNARIA ARSA",1],["A554","CR","BAGNAROLO",0],["A555","CN","BAGNASCO",1],["A556","AL","BAGNASCO D'ASTI",0],["A557","BG","BAGNATICA",1],["A558","BO","BAGNI DELLA PORRETTA",0],["A559","PI","BAGNI DI CASCIANA",0],["A560","LU","BAGNI DI LUCCA",1],["A561","PT","BAGNI DI MONTECATINI",0],["A562","PI","BAGNI SAN GIULIANO",0],["A563","AQ","BAGNO",0],["A560","LU","BAGNO A CORSENA",0],["A564","FI","BAGNO A RIPOLI",1],["A565","FC","BAGNO DI ROMAGNA",1],["A566","AV","BAGNOLI",0],["A567","CB","BAGNOLI",0],["A568","PD","BAGNOLI",0],["A567","IS","BAGNOLI DEL TRIGNO",1],["A568","PD","BAGNOLI DI SOPRA",1],["A566","AV","BAGNOLI IRPINO",1],["A569","BS","BAGNOLO",0],["A570","CR","BAGNOLO",0],["A571","CN","BAGNOLO",0],["A572","LE","BAGNOLO",0],["A573","RE","BAGNOLO",0],["A574","RO","BAGNOLO",0],["A570","CR","BAGNOLO CREMASCO",1],["A572","LE","BAGNOLO DEL SALENTO",1],["A574","RO","BAGNOLO DI PO",1],["A573","RE","BAGNOLO IN PIANO",1],["A569","BS","BAGNOLO MELLA",1],["A571","CN","BAGNOLO PIEMONTE",1],["A575","MN","BAGNOLO SAN VITO",1],["A576","MS","BAGNONE",1],["A577","VT","BAGNOREA",0],["A577","VT","BAGNOREGIO",1],["A578","BS","BAGOLINO",1],["Z502","EE","BAHAMA (ISOLE)",0],["Z502","EE","BAHAMAS",0],["Z204","EE","BAHREIN",0],["A579","CE","BAIA E LATINA",1],["A580","AV","BAIANO",1],["A581","IM","BAIARDO",0],["A582","CO","BAIEDO",0],["A583","TO","BAIO",0],["A583","TO","BAIO DORA",0],["A584","TO","BAIRO",1],["A585","AO","BAIRO TORRE",0],["A586","RE","BAISO",1],["A581","IM","BAJARDO",1],["A587","TO","BALANGERO",1],["M215","TN","BALBIDO",0],["A588","AT","BALDICHIERI D'ASTI",1],["A589","CN","BALDISSERO",0],["A590","TO","BALDISSERO",0],["A591","TO","BALDISSERO",0],["A590","TO","BALDISSERO CANAVESE",1],["A589","CN","BALDISSERO D'ALBA",1],["A591","TO","BALDISSERO TORINESE",1],["A592","PA","BALESTRATE",1],["A593","SV","BALESTRINO",1],["A594","LC","BALLABIO",1],["A595","CO","BALLABIO INFERIORE",0],["A596","CO","BALLABIO SUPERIORE",0],["A597","CA","BALLAO",0],["A597","SU","BALLAO",1],["A598","VA","BALLARATE",0],["M216","TN","BALLINO",0],["A599","TO","BALME",1],["A600","VC","BALMUCCIA",1],["A601","VC","BALOCCO",1],["A602","MI","BALSAMO",0],["A603","AQ","BALSORANO",1],["A604","PZ","BALVANO",1],["A605","AL","BALZOLA",1],["A606","SS","BANARI",1],["A607","TO","BANCHETTE",1],["A608","TN","BANCO",0],["Z249","EE","BANGLADESH",0],["A609","CA","BANNARI",0],["A609","CA","BANNARI DI USELLUS",0],["A610","NO","BANNIO",0],["A610","VB","BANNIO ANZINO",1],["A611","SS","BANTINE",0],["A612","PZ","BANZI",1],["A613","PD","BAONE",1],["A614","OR","BARADILI",1],["A615","PZ","BARAGIANO",1],["A616","CB","BARANELLO",1],["A617","NA","BARANO",0],["A617","NA","BARANO D'ISCHIA",1],["A618","MI","BARANZATE",1],["A619","VA","BARASSO",1],["A620","MI","BARATE",0],["A621","CA","BARATILI",0],["A621","OR","BARATILI SAN PIETRO",1],["A622","TO","BARATONIA",0],["Z522","EE","BARBADOS",0],["A623","MI","BARBAIANA",0],["A624","PL","BARBANA D'ISTRIA",0],["A625","TO","BARBANIA",1],["A626","AN","BARBARA",1],["A627","VI","BARBARANO",0],["A628","VT","BARBARANO",0],["M401","VI","BARBARANO MOSSANO",1],["A628","VT","BARBARANO ROMANO",1],["A627","VI","BARBARANO VICENTINO",0],["A629","CN","BARBARESCO",1],["A630","BS","BARBARIGA",1],["A631","BG","BARBATA",1],["A632","FI","BARBERINO DI MUGELLO",1],["M408","FI","BARBERINO TAVARNELLE",1],["A633","FI","BARBERINO VAL D'ELSA",0],["A634","PV","BARBIANELLO",1],["A635","BZ","BARBIANO",1],["A636","CR","BARBISELLE",0],["A637","PD","BARBONA",1],["A638","ME","BARCELLONA POZZO DI GOTTO",1],["M217","TN","BARCESINO",0],["A639","PU","BARCHI",0],["A640","PN","BARCIS",1],["A641","BS","BARCO",0],["A642","CO","BARCONE",0],["A643","AO","BARD",1],["A644","TO","BARDASSANO",0],["A645","VA","BARDELLO",1],["A646","PR","BARDI",1],["A647","SV","BARDINETO",1],["A648","SV","BARDINO NUOVO",0],["A649","SV","BARDINO VECCHIO",0],["A650","VR","BARDOLINO",1],["A651","TO","BARDONECCHIA",1],["A652","MI","BAREGGIO",1],["A653","NO","BARENGO",1],["A654","BG","BARESI",0],["A655","OR","BARESSA",1],["A656","AQ","BARETE",1],["A657","LU","BARGA",1],["A658","GE","BARGAGLI",1],["A659","MI","BARGANO",0],["A660","CN","BARGE",1],["A661","BS","BARGHE",1],["A662","BA","BARI",1],["A663","CA","BARI",0],["A662","BA","BARI DELLE PUGLIE",0],["A663","NU","BARI SARDO",1],["A664","BG","BARIANO",1],["A665","BO","BARICELLA",1],["A666","PZ","BARILE",1],["A667","AQ","BARISCIANO",1],["A668","MB","BARLASSINA",1],["A668","MI","BARLASSINA",0],["A669","BA","BARLETTA",0],["A669","BT","BARLETTA",1],["A670","CO","BARNI",1],["A671","CN","BAROLO",1],["A672","PV","BARONA",0],["A673","TO","BARONE CANAVESE",1],["A674","SA","BARONISSI",1],["A675","NA","BARRA",0],["A676","EN","BARRAFRANCA",1],["A677","CA","BARRALI",0],["A677","SU","BARRALI",1],["A678","AQ","BARREA",1],["A680","CO","BARTESATE",0],["A681","CA","BARUMINI",0],["A681","SU","BARUMINI",1],["A682","VA","BARZA",0],["A683","LC","BARZAGO",1],["A684","BG","BARZANA",1],["A685","CR","BARZANIGA",0],["A686","LC","BARZANO'",1],["A687","LC","BARZIO",1],["A679","BG","BARZIZZA",0],["A688","VA","BARZOLA",0],["A689","AL","BASALUZZO",1],["A690","PV","BASCAPE'",1],["A691","TR","BASCHI",1],["A692","TE","BASCIANO",1],["A693","TN","BASELGA",0],["A694","TN","BASELGA DI PINE'",1],["A693","TN","BASELGA DI VEZZANO",0],["A695","PV","BASELICA BOLOGNA",0],["A696","BN","BASELICE",1],["A697","MI","BASIANO",1],["A698","ME","BASICO'",1],["A699","MI","BASIGLIO",1],["A700","UD","BASILIANO",1],["A701","VT","BASSANELLO",0],["A702","BS","BASSANO",0],["A703","VI","BASSANO",0],["A702","BS","BASSANO BRESCIANO",1],["A703","VI","BASSANO DEL GRAPPA",1],["A704","VT","BASSANO DI SUTRI",0],["A705","CO","BASSANO DI TRONZANO",0],["A706","VT","BASSANO IN TEVERINA",1],["A704","VT","BASSANO ROMANO",1],["A707","LT","BASSIANO",1],["A708","AL","BASSIGNANA",1],["A709","CN","BASTIA",0],["A709","CN","BASTIA MONDOVI'",1],["A710","PG","BASTIA UMBRA",1],["A711","PV","BASTIDA DE' DOSSI",0],["A712","PV","BASTIDA PANCARANA",1],["A713","MO","BASTIGLIA",1],["Z303","EE","BASUTOLAND-SUD AFRICA BRITANNICO",0],["A714","PD","BATTAGLIA",0],["A715","GO","BATTAGLIA DELLA BAINSIZZA",0],["A714","PD","BATTAGLIA TERME",1],["A716","CN","BATTIFOLLO",1],["A717","SA","BATTIPAGLIA",1],["A718","PV","BATTUDA",1],["A719","PA","BAUCINA",1],["A720","FR","BAUCO",0],["A721","OR","BAULADU",1],["A722","NU","BAUNEI",1],["A723","ME","BAUSO",0],["A724","GE","BAVARI",0],["A725","VB","BAVENO",1],["A726","BO","BAZZANO",0],["A727","TO","BEAULARD",0],["Z304","EE","BECIUANIA-SUD AFRICA BRITANNICO",0],["A728","VA","BEDERO VALCUVIA",1],["A729","BS","BEDIZZOLE",1],["A730","TN","BEDOLLO",1],["A731","PR","BEDONIA",1],["A732","BG","BEDULITA",1],["A733","VB","BEE",1],["A734","TO","BEINASCO",1],["A735","CN","BEINETTE",1],["A767","BS","BEL PRATO",0],["A736","CZ","BELCASTRO",1],["A737","VR","BELFIORE",1],["A737","VR","BELFIORE DI PORCILE",0],["A738","AL","BELFORTE",0],["A739","MC","BELFORTE",0],["A740","PU","BELFORTE",0],["A740","PU","BELFORTE ALL'ISAURO",1],["A739","MC","BELFORTE DEL CHIENTI",1],["A739","MC","BELFORTE DEL CHIENTO",0],["A738","AL","BELFORTE MONFERRATO",1],["Z103","EE","BELGIO",0],["A741","PV","BELGIOIOSO",1],["A742","VB","BELGIRATE",1],["Z512","EE","BELIZE",0],["A743","PZ","BELLA",1],["A744","CO","BELLAGIO",0],["M335","CO","BELLAGIO",1],["A745","LC","BELLANO",1],["A746","TE","BELLANTE",1],["A747","RN","BELLARIA-IGEA MARINA",1],["A748","CO","BELLEDO",0],["A749","RM","BELLEGRA",1],["A750","CN","BELLINO",1],["A751","MI","BELLINZAGO",0],["A752","NO","BELLINZAGO",0],["A751","MI","BELLINZAGO LOMBARDO",1],["A752","NO","BELLINZAGO NOVARESE",1],["A753","AV","BELLIZZI",0],["M294","SA","BELLIZZI",1],["A753","AV","BELLIZZI IRPINO",0],["A754","RO","BELLOMBRA",0],["A755","CE","BELLONA",1],["A756","SA","BELLOSGUARDO",1],["A757","BL","BELLUNO",1],["A758","VR","BELLUNO VERONESE",0],["A759","MB","BELLUSCO",1],["A759","MI","BELLUSCO",0],["A760","AP","BELMONTE",0],["A761","CB","BELMONTE",0],["A762","CS","BELMONTE",0],["A763","FR","BELMONTE",0],["A764","PA","BELMONTE",0],["A765","RI","BELMONTE",0],["A762","CS","BELMONTE CALABRO",1],["A763","FR","BELMONTE CASTELLO",1],["A761","IS","BELMONTE DEL SANNIO",1],["A765","RI","BELMONTE IN SABINA",1],["A764","PA","BELMONTE MEZZAGNO",1],["A760","AP","BELMONTE PICENO",0],["A760","FM","BELMONTE PICENO",1],["A766","CT","BELPASSO",1],["A768","CS","BELSITO",1],["A769","AN","BELVEDERE",0],["A770","AT","BELVEDERE",0],["A771","BO","BELVEDERE",0],["A772","CZ","BELVEDERE",0],["A773","CS","BELVEDERE",0],["A774","CN","BELVEDERE",0],["A775","PV","BELVEDERE",0],["A775","PV","BELVEDERE AL PO",0],["A772","KR","BELVEDERE DI SPINELLO",1],["A774","CN","BELVEDERE LANGHE",1],["A773","CS","BELVEDERE MARITTIMO",1],["A769","AN","BELVEDERE OSTRENSE",1],["A770","AT","BELVEGLIO",1],["A776","NU","BELVI",0],["A776","NU","BELVI'",1],["A777","SO","BEMA",1],["A778","CO","BENE",0],["A779","CN","BENE",0],["A778","CO","BENE LARIO",1],["A779","CN","BENE VAGIENNA",1],["A780","RC","BENESTARE",1],["A781","SS","BENETUTTI",1],["A782","CN","BENEVELLO",1],["A783","BN","BENEVENTO",1],["Z314","EE","BENIN",0],["A784","BI","BENNA",1],["A785","BO","BENTIVOGLIO",1],["A786","BG","BERBENNO",1],["A787","SO","BERBENNO",0],["A787","SO","BERBENNO DI VALTELLINA",1],["A788","PR","BERCETO",1],["A789","SS","BERCHIDDA",1],["A790","FM","BERDO SAN GIOVANNI",0],["A791","CO","BEREGAZZO",0],["A791","CO","BEREGAZZO CON FIGLIARO",1],["A792","PV","BEREGUARDO",1],["A793","AL","BERGAMASCO",1],["A794","BG","BERGAMO",1],["A795","RO","BERGANTINO",1],["A796","SV","BERGEGGI",1],["A797","GO","BERGOGNA",0],["A798","CN","BERGOLO",1],["A799","BS","BERLINGO",1],["Z400","EE","BERMUDA (ISOLE)",0],["A800","CO","BERNAGA",0],["A801","MT","BERNALDA",1],["A802","MB","BERNAREGGIO",1],["A802","MI","BERNAREGGIO",0],["A803","CO","BERNATE",0],["A804","MI","BERNATE",0],["A803","CO","BERNATE DI COMO",0],["A803","CO","BERNATE ROSALES",0],["A804","MI","BERNATE TICINO",1],["A805","CN","BERNEZZO",1],["A806","FE","BERRA",0],["A807","CN","BERSEZIO",0],["A808","TN","BERSONE",0],["A809","FC","BERTINORO",1],["A810","UD","BERTIOLO",1],["A811","LO","BERTONICO",1],["A812","AL","BERZANO",0],["A813","AL","BERZANO",0],["A812","AT","BERZANO DI SAN PIETRO",1],["A813","AL","BERZANO DI TORTONA",1],["A815","BG","BERZO",0],["A816","BS","BERZO DEMO",1],["A817","BS","BERZO INFERIORE",1],["A815","BG","BERZO SAN FERMO",1],["A818","MI","BESANA",0],["A818","MB","BESANA IN BRIANZA",1],["A818","MI","BESANA IN BRIANZA",0],["A819","VA","BESANO",1],["A820","MI","BESATE",1],["A821","TN","BESENELLO",1],["A822","TN","BESENO",0],["A823","PC","BESENZONE",1],["A824","FM","BESERZIO DEL CARNARO",0],["A825","VA","BESNATE",1],["A826","VA","BESOZZO",1],["A827","SS","BESSUDE",1],["A828","IM","BESTAGNO",0],["A829","MI","BESTAZZO",0],["A830","CR","BETTENESCO",0],["A831","PC","BETTOLA",1],["A832","PG","BETTONA",1],["A833","NO","BEURA",0],["A834","VB","BEURA-CARDEZZA",1],["A835","PG","BEVAGNA",1],["A836","SP","BEVERINO",1],["A837","VR","BEVILACQUA",1],["A838","VR","BEVILACQUA BOSCHI",0],["A839","TN","BEZZECCA",0],["Z205","EE","BHUTAN",0],["A840","TN","BIACESA",0],["A841","CT","BIANCAVILLA",1],["A842","CS","BIANCHI",1],["A843","RC","BIANCO",1],["A844","NO","BIANDRATE",1],["A845","VA","BIANDRONNO",1],["A846","BG","BIANZANO",1],["A847","VC","BIANZE'",1],["A848","SO","BIANZONE",1],["A849","MB","BIASSONO",1],["A849","MI","BIASSONO",0],["A850","RE","BIBBIANO",1],["A851","AR","BIBBIENA",1],["A852","LI","BIBBONA",1],["A853","TO","BIBIANA",1],["A854","FG","BICCARI",1],["A855","UD","BICINICCO",1],["A856","OR","BIDONI'",1],["A857","VT","BIEDA",0],["A858","VA","BIEGNO",0],["A859","BI","BIELLA",1],["Z139","EE","BIELORUSSIA",0],["Z139","EE","BIELORUSSIA=RUSSIA BIANCA",0],["A860","MI","BIENATE",0],["A861","BS","BIENNO",1],["A862","NO","BIENO",0],["A863","TN","BIENO",1],["A864","PI","BIENTINA",1],["A865","SV","BIESTRO",0],["A866","MN","BIGARELLO",0],["A867","GO","BIGLIA",0],["A868","GO","BIGLIANA",0],["A869","CO","BIGLIO",0],["A870","CO","BINAGO",1],["A871","CR","BINANUOVA",0],["A872","MI","BINASCO",1],["A873","CO","BINDO",0],["A874","BA","BINETTO",1],["A875","MI","BINZAGO",0],["A876","BI","BIOGLIO",1],["A877","AO","BIONA",0],["A877","AO","BIONAZ",1],["A878","BS","BIONE",1],["A879","MI","BIRAGO",0],["Z206","EE","BIRMANIA",0],["A880","NU","BIRORI",1],["A881","AV","BISACCIA",1],["A882","PA","BISACQUINO",1],["A014","RG","BISCARI",0],["A883","BA","BISCEGLIE",0],["A883","BT","BISCEGLIE",1],["A884","AQ","BISEGNA",1],["A885","TE","BISENTI",1],["A886","MI","BISENTRATE",0],["A887","CS","BISIGNANO",1],["A888","AL","BISIO",0],["A889","AL","BISTAGNO",1],["A890","FM","BISTERZA",0],["A891","VA","BISUSCHIO",1],["A892","BA","BITETTO",1],["A893","BA","BITONTO",1],["A894","BA","BITRITTO",1],["A895","NU","BITTI",1],["A896","AG","BIVONA",1],["A897","RC","BIVONGI",1],["A898","CO","BIZZARONE",1],["A899","VA","BIZZOZERO",0],["A900","TN","BLEGGIO",0],["A901","TN","BLEGGIO INFERIORE",0],["A902","TN","BLEGGIO SUPERIORE",1],["A903","BG","BLELLO",1],["A857","VT","BLERA",1],["A904","CO","BLESSAGNO",1],["A905","CO","BLEVIO",1],["M268","PA","BLUFI",1],["A906","PD","BOARA",0],["A907","RO","BOARA",0],["A906","PD","BOARA PISANI",1],["A907","RO","BOARA POLESINE",0],["A908","VA","BOBBIATE",0],["A909","PC","BOBBIO",1],["A910","TO","BOBBIO PELLICE",1],["A911","NO","BOCA",1],["A912","CS","BOCCHIGLIERO",1],["A913","PG","BOCCHIGNANO",0],["A914","VC","BOCCIOLETO",1],["A915","PR","BOCCOLO DEI TASSI",0],["A916","TN","BOCENAGO",1],["A917","VA","BODIO",0],["A918","VA","BODIO LOMNAGO",1],["A919","MI","BOFFALORA",0],["A920","MI","BOFFALORA",0],["A919","LO","BOFFALORA D'ADDA",1],["A919","MI","BOFFALORA D'ADDA",0],["A920","MI","BOFFALORA SOPRA TICINO",1],["A921","SO","BOFFETTO",0],["A922","GE","BOGLIASCO",1],["A923","GE","BOGLIASCO PIEVE",0],["A924","PL","BOGLIUNO",0],["A925","VB","BOGNANCO",1],["A926","NO","BOGNANCO DENTRO",0],["A927","NO","BOGNANCO FUORI",0],["A928","VA","BOGNO",0],["A929","NO","BOGOGNO",1],["A930","CB","BOIANO",0],["A930","CB","BOIANO (corr. BOJANO)",0],["A931","SV","BOISSANO",1],["A930","CB","BOJANO",1],["A932","SP","BOLANO",1],["A933","TN","BOLBENO",0],["A934","MI","BOLDINASCO",0],["A935","TN","BOLENTINA",0],["A936","NO","BOLETO",0],["A937","BG","BOLGARE",1],["A938","MI","BOLGIANO",0],["Z601","EE","BOLIVIA",0],["A939","MI","BOLLADELLO",0],["A940","MI","BOLLATE",1],["A941","TO","BOLLENGO",1],["A942","MT","BOLLITA",0],["A943","TN","BOLLONE",0],["A944","BO","BOLOGNA",1],["A945","PE","BOLOGNANO",1],["A946","PA","BOLOGNETTA",1],["A947","MC","BOLOGNOLA",1],["A948","NU","BOLOTANA",1],["A949","VT","BOLSENA",1],["A950","BG","BOLTIERE",1],["A951","GE","BOLZANETO",0],["A952","BZ","BOLZANO",1],["A953","NO","BOLZANO",0],["A954","VI","BOLZANO",0],["A953","NO","BOLZANO NOVARESE",1],["A954","VI","BOLZANO VICENTINO",1],["A955","VT","BOMARZO",1],["A956","CH","BOMBA",1],["A957","CL","BOMPENSIERE",1],["A958","PA","BOMPIETRO",1],["A959","MO","BOMPORTO",1],["A960","OR","BONARCADO",1],["A961","SP","BONASSOLA",1],["A963","BG","BONATE SOPRA",1],["A962","BG","BONATE SOTTO",1],["A964","VR","BONAVIGO",1],["A965","FE","BONDENO",1],["A966","BG","BONDIONE",0],["A967","TN","BONDO",0],["A426","TN","BONDO BREGUZZO",0],["A969","BG","BONDO PETELLO",0],["A968","TN","BONDONE",1],["M218","TN","BONDONE STORO",0],["A970","BN","BONEA",1],["A971","CB","BONEFRO",1],["A972","CR","BONEMERSE",1],["A973","CS","BONIFATI",1],["A974","MI","BONIROLA",0],["A975","AV","BONITO",1],["A976","SS","BONNANARO",1],["A977","SS","BONO",1],["M219","TN","BONO",0],["A978","SS","BONORVA",1],["A979","CN","BONVICINO",1],["A980","TO","BONZO",0],["Z364","EE","BOPHUTHATSWANA",0],["A981","RI","BORBONA",1],["A982","BL","BORCA",0],["A982","BL","BORCA DI CADORE",1],["A983","UD","BORDANO",1],["A984","IM","BORDIGHERA",1],["A985","BG","BORDOGNA",0],["A986","CR","BORDOLANO",1],["A987","PR","BORE",1],["A988","RE","BORETTO",1],["A989","PV","BORGARELLO",1],["A990","TO","BORGARO TORINESE",1],["A991","PA","BORGETTO",1],["A992","GE","BORGHETTO",0],["A993","IM","BORGHETTO",0],["A994","IM","BORGHETTO",0],["A995","MI","BORGHETTO",0],["A996","RI","BORGHETTO",0],["A997","TN","BORGHETTO",0],["A993","IM","BORGHETTO D'ARROSCIA",1],["A998","AL","BORGHETTO DI BORBERA",1],["A992","SP","BORGHETTO DI VARA",1],["A995","LO","BORGHETTO LODIGIANO",1],["A994","IM","BORGHETTO SAN NICOLO'",0],["A999","SV","BORGHETTO SANTO SPIRITO",1],["B001","FC","BORGHI",1],["B002","CZ","BORGIA",1],["B003","TO","BORGIALLO",1],["B004","SV","BORGIO",0],["B005","SV","BORGIO VEREZZI",1],["B006","TN","BORGO",0],["B007","LU","BORGO A MOZZANO",1],["B007","LU","BORGO A MOZZANO E CERRETO DI SOTTO",0],["M352","TN","BORGO CHIESE",1],["B009","VC","BORGO D'ALE",1],["M429","TN","BORGO D'ANAUNIA",1],["B010","BG","BORGO DI TERZO",1],["M353","TN","BORGO LARES",1],["B017","MI","BORGO LITTORIO",0],["M396","MN","BORGO MANTOVANO",1],["B026","PU","BORGO PACE",1],["B027","BO","BORGO PANIGALE",0],["B028","PV","BORGO PRIOLO",1],["B032","PC","BORGO SAN BERNARDINO",0],["B033","CN","BORGO SAN DALMAZZO",1],["B034","PR","BORGO SAN DONNINO",0],["B035","BS","BORGO SAN GIACOMO",1],["B017","LO","BORGO SAN GIOVANNI",1],["B036","FI","BORGO SAN LORENZO",1],["B037","AL","BORGO SAN MARTINO",1],["B038","PV","BORGO SAN SIRO",1],["B039","IM","BORGO SANT'AGATA",0],["B043","NO","BORGO TICINO",1],["B044","BO","BORGO TOSSIGNANO",1],["B042","PR","BORGO VAL DI TARO",1],["M421","BL","BORGO VALBELLUNA",1],["B006","TN","BORGO VALSUGANA",1],["A996","RI","BORGO VELINO",1],["M402","PD","BORGO VENETO",1],["B046","VC","BORGO VERCELLI",1],["M340","MN","BORGO VIRGILIO",1],["M406","MN","BORGOCARBONARA",1],["B008","RI","BORGOCOLLEFEGATO",0],["B011","MN","BORGOFORTE",0],["B012","MN","BORGOFORTE A DESTRA",0],["B013","MN","BORGOFRANCO",0],["B014","PV","BORGOFRANCO",0],["B015","TO","BORGOFRANCO",0],["B015","TO","BORGOFRANCO D'IVREA",1],["B013","MN","BORGOFRANCO SUL PO",0],["B016","NO","BORGOLAVEZZARO",1],["B018","CN","BORGOMALE",1],["B019","NO","BORGOMANERO",1],["B020","IM","BORGOMARO",1],["B021","TO","BORGOMASINO",1],["M370","VB","BORGOMEZZAVALLE",1],["B022","BS","BORGONATO",0],["B023","NO","BORGONE",0],["B024","TO","BORGONE",0],["B023","NO","BORGONE D'OSSOLA",0],["B024","TO","BORGONE SUSA",1],["B025","PC","BORGONOVO VAL TIDONE",1],["A831","PC","BORGONURE",0],["B029","AL","BORGORATTO",0],["B030","PV","BORGORATTO",0],["B029","AL","BORGORATTO ALESSANDRINO",1],["B030","PV","BORGORATTO MORMOROLO",1],["B031","PD","BORGORICCO",1],["B008","RI","BORGOROSE",1],["B040","BS","BORGOSATOLLO",1],["B041","VC","BORGOSESIA",1],["B042","PR","BORGOTARO",0],["B045","BG","BORGOUNITO",0],["B047","GO","BORIANO",0],["B048","SV","BORMIDA",1],["B049","SO","BORMIO",1],["B050","MI","BORNAGO",0],["B051","PV","BORNASCO",1],["B052","VC","BORNATE",0],["B053","BS","BORNATO",0],["B054","BS","BORNO",1],["B055","OR","BORONEDDU",1],["B056","NU","BORORE",1],["B057","CH","BORRELLO",1],["B058","BI","BORRIANA",1],["B059","MI","BORSANO",0],["B060","RO","BORSEA",0],["B061","TV","BORSO",0],["B061","TV","BORSO DEL GRAPPA",1],["B062","NU","BORTIGALI",1],["B063","SS","BORTIGIADAS",1],["B064","SS","BORUTTA",1],["B065","TN","BORZAGO",0],["B066","GE","BORZOLI",0],["B067","GE","BORZONASCA",1],["B068","NU","BOSA",0],["B068","OR","BOSA",1],["B069","RO","BOSARO",1],["B070","VR","BOSCHI SANT'ANNA",1],["A598","CO","BOSCO",0],["B071","AL","BOSCO",0],["B072","CO","BOSCO",0],["B073","VR","BOSCO CHIESANUOVA",1],["A598","CO","BOSCO DI GAVIRATE",0],["B071","AL","BOSCO MARENGO",1],["B072","VA","BOSCO VALTRAVAGLIA",0],["B074","IM","BOSCOMARE",0],["B075","TO","BOSCONERO",1],["B076","NA","BOSCOREALE",1],["B077","NA","BOSCOTRECASE",1],["B078","TN","BOSENTINO",0],["B079","CN","BOSIA",1],["B080","AL","BOSIO",1],["B081","CO","BOSISIO",0],["B081","LC","BOSISIO PARINI",1],["B082","PV","BOSNASCO",1],["Z153","EE","BOSNIA ED ERZEGOVINA",0],["B083","BG","BOSSICO",1],["B084","CN","BOSSOLASCO",1],["B085","CZ","BOTRICELLO",1],["B086","LE","BOTRUGNO",1],["Z358","EE","BOTSWANA",0],["B087","CR","BOTTAIANO",0],["B088","BG","BOTTANUCO",1],["B089","PV","BOTTARONE",0],["B090","MI","BOTTEDO",0],["B091","BS","BOTTICINO",1],["B092","BS","BOTTICINO MATTINA",0],["B093","BS","BOTTICINO SERA",0],["B094","SS","BOTTIDDA",1],["B095","RO","BOTTRIGHE",0],["B096","TO","BOUSSON",0],["B097","RC","BOVA",1],["B099","RC","BOVA MARINA",1],["B098","RC","BOVALINO",1],["B100","BS","BOVEGNO",1],["B101","CN","BOVES",1],["B102","BS","BOVEZZO",1],["B103","TO","BOVILE",0],["M299","RM","BOVILLE",0],["A720","FR","BOVILLE ERNICA",1],["B104","FG","BOVINO",1],["B105","MI","BOVISIO",0],["B105","MB","BOVISIO-MASCIAGO",1],["B105","MI","BOVISIO-MASCIAGO",0],["B106","PD","BOVOLENTA",1],["B107","VR","BOVOLONE",1],["B108","TN","BOZZANA",0],["B109","AL","BOZZOLE",1],["B110","MN","BOZZOLO",1],["B111","CN","BRA",1],["B112","BG","BRACCA",1],["B113","BG","BRACCA DI COSTA SERINA",0],["B114","RM","BRACCIANO",1],["B115","SA","BRACIGLIANO",1],["B116","BZ","BRAIES",1],["B117","PV","BRALLO DI PREGOLA",1],["B118","RC","BRANCALEONE",1],["B119","CR","BRANCERE",0],["M220","TN","BRANCOLINO",0],["B120","BS","BRANDICO",1],["B121","TO","BRANDIZZO",1],["B122","PV","BRANDUZZO",0],["B123","BG","BRANZI",1],["B124","BS","BRAONE",1],["Z602","EE","BRASILE",0],["B125","GO","BRAZZANO",0],["B126","VA","BREBBIA",1],["B127","CO","BRECCIA",0],["B128","TV","BREDA",0],["B129","CR","BREDA DE' BUGNI",0],["B128","TV","BREDA DI PIAVE",1],["B130","CR","BREDA GUAZZONE",0],["B131","VA","BREGANO",1],["B132","VI","BREGANZE",1],["B133","CO","BREGLIA",0],["B134","CO","BREGNANO",1],["B135","TN","BREGUZZO",0],["B136","VC","BREIA",0],["B137","BG","BREMBATE",1],["B138","BG","BREMBATE DI SOPRA",1],["B139","BG","BREMBATE DI SOTTO",0],["B140","BG","BREMBILLA",0],["B141","LO","BREMBIO",1],["B142","PV","BREME",1],["B143","VI","BRENDOLA",1],["B144","CO","BRENNA",1],["B145","BZ","BRENNERO",1],["B146","CO","BRENNO",0],["B147","CO","BRENNO",0],["B147","CO","BRENNO DELLA TORRE",0],["B146","VA","BRENNO USERIA",0],["B148","BG","BRENO",0],["B149","BS","BRENO",1],["B150","VA","BRENTA",1],["B151","VR","BRENTINO",0],["B152","VR","BRENTINO BELLUNO",1],["B153","TN","BRENTONICO",1],["B154","VR","BRENZONE",0],["B154","VR","BRENZONE SUL GARDA",1],["B155","VR","BREONIO",0],["B156","RE","BRESCELLO",1],["B157","BS","BRESCIA",1],["B158","TN","BRESIMO",1],["A395","PV","BRESSANA",0],["B159","PV","BRESSANA BOTTARONE",1],["B160","BZ","BRESSANONE",1],["B161","VI","BRESSANVIDO",1],["B162","MI","BRESSO",1],["B163","GO","BRESTOVIZZA IN VALLE",0],["B164","GO","BRETTO",0],["B165","TN","BREZ",0],["B166","VA","BREZZO DI BEDERO",1],["B167","CN","BRIAGLIA",1],["B168","CO","BRIANZOLA",0],["B169","VV","BRIATICO",1],["B170","MI","BRIAVACCA",0],["B171","TO","BRICHERASIO",1],["B172","CO","BRIENNO",1],["B173","PZ","BRIENZA",1],["B174","CN","BRIGA",0],["B175","CN","BRIGA ALTA",1],["B174","CN","BRIGA MARITTIMA",0],["B176","NO","BRIGA NOVARESE",1],["B177","AL","BRIGNANO",0],["B178","BG","BRIGNANO",0],["B177","AL","BRIGNANO DEL CURONE",0],["B178","BG","BRIGNANO GERA D'ADDA",1],["B179","AL","BRIGNANO-FRASCATA",1],["B180","BR","BRINDISI",1],["B181","PZ","BRINDISI",0],["B181","PZ","BRINDISI MONTAGNA",1],["B182","VA","BRINZIO",1],["B183","NO","BRIONA",1],["B184","BS","BRIONE",1],["B185","TN","BRIONE",0],["B186","PL","BRIONI MAGGIORE",0],["B187","MB","BRIOSCO",1],["B187","MI","BRIOSCO",0],["B188","RA","BRISIGHELLA",1],["B189","NO","BRISINO",0],["B190","VA","BRISSAGO",0],["B191","VA","BRISSAGO-VALTRAVAGLIA",1],["B192","AO","BRISSOGNE",1],["B193","PE","BRITTOLI",1],["B194","LC","BRIVIO",1],["B195","FR","BROCCO",0],["B195","FR","BROCCOSTELLA",1],["B196","VI","BROGLIANO",1],["B197","VV","BROGNATURO",1],["B198","ME","BROLO",1],["B199","CR","BROLPASINO",0],["B200","CN","BRONDELLO",1],["B201","PV","BRONI",1],["B202","CT","BRONTE",1],["B203","BZ","BRONZOLO",1],["B204","CN","BROSSASCO",1],["B205","TO","BROSSO",1],["B206","NO","BROVELLO",0],["B207","VB","BROVELLO-CARPUGNINO",1],["B208","SV","BROVIDA",0],["B209","TO","BROZOLO",1],["B210","FI","BROZZI",0],["B211","BS","BROZZO",0],["B212","MB","BRUGHERIO",1],["B212","MI","BRUGHERIO",0],["B213","PD","BRUGINE",1],["B214","SP","BRUGNATO",1],["B215","PN","BRUGNERA",1],["B216","TO","BRUINO",1],["B217","BG","BRUMANO",1],["B218","CO","BRUNATE",1],["Z207","EE","BRUNEI",0],["B219","VA","BRUNELLO",1],["B220","BZ","BRUNICO",1],["B221","AT","BRUNO",1],["B222","BG","BRUNTINO",0],["B223","BG","BRUSAPORTO",1],["B224","AL","BRUSASCHETTO",0],["B225","TO","BRUSASCO",1],["B226","TO","BRUSASCO CAVAGNOLO",0],["B227","NA","BRUSCIANO",1],["B228","VA","BRUSIMPIANO",1],["M221","TN","BRUSINO",0],["B229","BI","BRUSNENGO",1],["B230","AO","BRUSSON",1],["B230","AO","BRUSSONE",0],["B231","MI","BRUSUGLIO",0],["B232","TO","BRUZOLO",1],["B233","MI","BRUZZANO",0],["B234","RC","BRUZZANO",0],["B233","MI","BRUZZANO DEI DUE BORGHI",0],["B234","RC","BRUZZANO ZEFFIRIO",1],["B235","MI","BUBBIANO",1],["B236","AT","BUBBIO",1],["B237","SR","BUCCHERI",1],["B238","CH","BUCCHIANICO",1],["B239","BN","BUCCIANO",1],["B240","MI","BUCCINASCO",1],["B241","CO","BUCCINIGO",0],["B242","SA","BUCCINO",1],["B243","AR","BUCINE",1],["B244","TS","BUCUIE",0],["B245","GO","BUDAGNE",0],["B246","SS","BUDDUSO'",1],["B247","PN","BUDOIA",1],["B248","NU","BUDONI",0],["B248","SS","BUDONI",1],["B249","BO","BUDRIO",1],["B250","CA","BUGGERRU",0],["B250","SU","BUGGERRU",1],["B251","PT","BUGGIANO",1],["B252","CO","BUGGIOLO",0],["B253","CO","BUGIALLO",0],["B254","NO","BUGLIO",0],["B255","SO","BUGLIO",0],["B255","SO","BUGLIO IN MONTE",1],["B256","AQ","BUGNARA",1],["B257","NO","BUGNATE",0],["B258","VA","BUGUGGIATE",1],["B260","PL","BUIE D'ISTRIA",0],["B259","UD","BUJA",1],["B259","UD","BUJA ( corretto BUIA)",0],["B261","LC","BULCIAGO",1],["Z104","EE","BULGARIA",0],["B262","CO","BULGAROGRASSO",1],["B263","CO","BULGORELLO",0],["B264","SS","BULTEI",1],["B265","SS","BULZI",1],["A958","PA","BUOMPIETRO",0],["B266","SA","BUONABITACOLO",1],["B267","BN","BUONALBERGO",1],["B268","CH","BUONANOTTE",0],["B269","SI","BUONCONVENTO",1],["B270","CS","BUONVICINO",1],["B271","BS","BURAGO",0],["B272","MI","BURAGO",0],["B272","MB","BURAGO DI MOLGORA",1],["B272","MI","BURAGO DI MOLGORA",0],["B271","BS","BURAGO RIVIERA",0],["B273","VE","BURANO",0],["B274","CA","BURCEI",0],["B274","SU","BURCEI",1],["B275","AG","BURGIO",1],["B276","SS","BURGOS",1],["B277","BZ","BURGUSIO",0],["B278","TO","BURIASCO",1],["Z354","EE","BURKINA",0],["Z354","EE","BURKINA FASO",0],["B279","TO","BUROLO",1],["B280","VC","BURONZO",1],["Z305","EE","BURUNDI",0],["B281","OR","BUSACHI",1],["B282","GE","BUSALLA",1],["B283","RE","BUSANA",0],["B284","TO","BUSANO",1],["B285","CN","BUSCA",1],["B286","MI","BUSCATE",1],["B287","SR","BUSCEMI",1],["B288","TP","BUSETO PALIZZOLO",1],["B289","MB","BUSNAGO",1],["B289","MI","BUSNAGO",0],["B290","RO","BUSO",0],["B290","RO","BUSO SARZANO",0],["B291","IM","BUSSANA",0],["B292","MI","BUSSERO",1],["B293","PR","BUSSETO",1],["B294","AQ","BUSSI",0],["B294","PE","BUSSI SUL TIRINO",1],["B295","CB","BUSSO",1],["B296","VR","BUSSOLENGO",1],["B297","TO","BUSSOLENO",1],["B298","TO","BUSSOLINO",0],["B298","TO","BUSSOLINO GASSINESE",0],["B299","MI","BUSTIGHERA",0],["B300","VA","BUSTO ARSIZIO",1],["B301","MI","BUSTO GAROLFO",1],["B302","CL","BUTERA",1],["B303","PI","BUTI",1],["B304","VR","BUTTAPIETRA",1],["B305","TO","BUTTIGLIERA",0],["B305","TO","BUTTIGLIERA ALTA",1],["B306","AT","BUTTIGLIERA D'ASTI",1],["B307","PV","BUTTIRAGO",0],["B308","NO","BUTTOGNO",0],["B309","UD","BUTTRIO",1],["B310","BG","BUZZONE SAN PAOLO",0],["B320","CR","CA' D'ANDREA",0],["B322","CR","CA' DE' BONAVOGLI",0],["B323","CR","CA' DE' CAGGI",0],["B324","CR","CA' DE' CORTI",0],["B331","MI","CA' DE' MAZZI",0],["B333","CR","CA' DE' QUINZANI",0],["B336","CR","CA' DE' SFONDRATI",0],["B337","CR","CA' DE' SORESINI",0],["B338","CR","CA' DE' STAOLI",0],["B339","CR","CA' DE' STEFANI",0],["B340","PV","CA' DE' TEDIOLI",0],["B341","MI","CA' DE' ZECCHI",0],["B327","MI","CA' DEI BOLLI",0],["B329","MI","CA' DELL'ACQUA",0],["B330","PV","CA' DELLA TERRA",0],["B342","VR","CA' DI DAVID",0],["B348","RO","CA' EMO",0],["B930","GO","CA' SANTO SPIRITO DELLA BAINSIZZA",0],["B311","AL","CABELLA LIGURE",1],["B312","VA","CABIAGLIO",0],["B313","CO","CABIATE",1],["B314","OR","CABRAS",1],["B315","PA","CACCAMO",1],["B316","BS","CACCAVERO",0],["B317","CB","CACCAVONE",0],["B318","TS","CACCIA",0],["B319","KR","CACCURI",1],["B321","NO","CADDO",0],["B325","VA","CADEGLIANO",0],["B326","VA","CADEGLIANO-VICONAGO",1],["B328","RE","CADELBOSCO DI SOPRA",1],["B332","PC","CADEO",1],["B334","VA","CADERO CON GRAGLIO",0],["B335","TN","CADERZONE",0],["B335","TN","CADERZONE TERME",1],["B343","BS","CADIGNANO",0],["B344","TN","CADINE",0],["B345","PD","CADONEGHE",1],["B346","CO","CADORAGO",1],["B347","VA","CADREZZATE",0],["M425","VA","CADREZZATE CON OSMATE",1],["B349","TV","CAERANO",0],["B349","TV","CAERANO DI SAN MARCO",1],["B350","TO","CAFASSE",1],["B351","SA","CAGGIANO",1],["B352","PU","CAGLI",1],["B353","CO","CAGLIANO",0],["B354","CA","CAGLIARI",1],["B355","CO","CAGLIO",1],["B356","GE","CAGNA",0],["B357","FG","CAGNANO",0],["B358","AQ","CAGNANO",0],["B358","AQ","CAGNANO AMITERNO",1],["B357","FG","CAGNANO VARANO",1],["B359","CO","CAGNO",0],["B360","TN","CAGNO'",0],["B361","CE","CAIANELLO",1],["B362","CE","CAIAZZO",1],["B363","MI","CAIDATE",0],["B364","BZ","CAINES",1],["B365","BS","CAINO",1],["B366","SO","CAIOLO",1],["B367","AV","CAIRANO",1],["B368","VA","CAIRATE",1],["B369","GE","CAIRO",0],["B370","PV","CAIRO",0],["B370","PV","CAIRO LOMELLINO",0],["B369","SV","CAIRO MONTENOTTE",1],["B371","NA","CAIVANO",1],["B372","MI","CAJELLO",0],["B373","BS","CAJONVICO",0],["B401","GO","CAL DI CANALE",0],["B374","AV","CALABRITTO",1],["B375","BL","CALALZO",0],["B375","BL","CALALZO DI CADORE",1],["B376","AT","CALAMANDRANA",1],["B377","AG","CALAMONACI",1],["B378","SS","CALANGIANUS",1],["B379","RC","CALANNA",1],["B380","NO","CALASCA",0],["B380","VB","CALASCA-CASTIGLIONE",1],["B380","EN","CALASCIBETTA",0],["B381","EN","CALASCIBETTA",1],["B381","AQ","CALASCIO",0],["B382","AQ","CALASCIO",1],["B382","CA","CALASETTA",0],["B383","CA","CALASETTA",0],["B383","SU","CALASETTA",1],["B383","CT","CALATABIANO",0],["B384","CT","CALATABIANO",1],["B384","TP","CALATAFIMI",0],["B385","TP","CALATAFIMI",0],["B385","TP","CALATAFIMI SEGESTA",0],["B385","TP","CALATAFIMI-SEGESTA",1],["B385","TN","CALAVINO",0],["B386","TN","CALAVINO",0],["B386","PV","CALCABABBIO",0],["B387","VT","CALCATA",0],["B388","VT","CALCATA",1],["B388","TN","CALCERANICA",0],["B389","TN","CALCERANICA AL LAGO",1],["B389","PI","CALCI",0],["B390","PI","CALCI",1],["B390","MT","CALCIANO",0],["B391","MT","CALCIANO",1],["B391","PI","CALCINAIA",0],["B392","PI","CALCINAIA",1],["B392","BG","CALCINATE",0],["B393","BG","CALCINATE",1],["B393","BS","CALCINATO",0],["B394","BS","CALCINATO",1],["B394","BG","CALCIO",0],["B395","BG","CALCIO",1],["B396","LC","CALCO",1],["B396","BZ","CALDARO",0],["B397","BZ","CALDARO SULLA STRADA DEL VINO",1],["B397","MC","CALDAROLA",0],["B398","MC","CALDAROLA",1],["B398","BO","CALDERARA",0],["B399","BO","CALDERARA DI RENO",1],["B399","TN","CALDES",0],["B400","TN","CALDES",1],["B400","VR","CALDIERO",0],["B402","VR","CALDIERO",1],["B402","VI","CALDOGNO",0],["B403","VI","CALDOGNO",1],["B403","TN","CALDONAZZO",0],["B404","TN","CALDONAZZO",1],["B404","PC","CALENDASCO",0],["B405","PC","CALENDASCO",1],["B405","FI","CALENZANO",0],["B406","FI","CALENZANO",1],["B406","BG","CALEPIO",0],["B407","PR","CALESTANO",0],["B408","PR","CALESTANO",1],["B408","GE","CALICE",0],["B409","MS","CALICE",0],["B410","SP","CALICE AL CORNOVIGLIO",1],["B409","SV","CALICE LIGURE",1],["B410","SV","CALICE LIGURE",0],["B409","NO","CALICE OSSOLANO",0],["B411","PV","CALIGNANO",0],["B412","LE","CALIMERA",0],["B413","LE","CALIMERA",1],["B413","BS","CALINO",0],["B414","AV","CALITRI",0],["B415","AV","CALITRI",1],["B415","SV","CALIZZANO",0],["B416","SV","CALIZZANO",1],["B417","BI","CALLABIANA",1],["B418","AT","CALLIANO",1],["B419","TN","CALLIANO",1],["B420","MI","CALO'",0],["B421","NO","CALOGNA",0],["B423","BG","CALOLZIO",0],["B423","LC","CALOLZIOCORTE",1],["B424","CS","CALOPEZZATI",1],["B425","AT","CALOSSO",1],["B426","CS","CALOVETO",1],["B427","AG","CALTABELLOTTA",1],["B428","CT","CALTAGIRONE",1],["B429","CL","CALTANISSETTA",1],["B430","PA","CALTAVUTURO",1],["B431","NO","CALTIGNAGA",1],["B432","RO","CALTO",1],["B433","VI","CALTRANO",1],["B434","BG","CALUSCO",0],["B434","BG","CALUSCO D'ADDA",1],["B435","TO","CALUSO",1],["B436","BS","CALVAGESE",0],["B436","BS","CALVAGESE DELLA RIVIERA",1],["B437","SA","CALVANICO",1],["B438","ME","CALVARUSO",0],["B439","CR","CALVATONE",1],["B440","PZ","CALVELLO",1],["B441","VI","CALVENE",1],["B442","BG","CALVENZANO",1],["B443","PZ","CALVERA",1],["B444","BN","CALVI",1],["B445","CE","CALVI",0],["B446","TR","CALVI",0],["B446","TR","CALVI DELL'UMBRIA",1],["B445","CE","CALVI RISORTA",1],["B449","BN","CALVI SAN NAZZARO",0],["B447","PV","CALVIGNANO",1],["B448","MI","CALVIGNASCO",1],["B450","BS","CALVISANO",1],["B451","GE","CALVISIO",0],["B452","NA","CALVIZZANO",1],["B454","TO","CAMAGNA",0],["B454","TO","CAMAGNA DI TORINO",0],["B453","AL","CAMAGNA MONFERRATO",1],["B455","LU","CAMAIORE",1],["B456","LO","CAMAIRAGO",0],["B457","BI","CAMANDONA",1],["B458","AQ","CAMARDA",0],["B459","VC","CAMASCO",0],["B460","AG","CAMASTRA",1],["B461","MI","CAMBIAGO",1],["B462","TO","CAMBIANO",1],["B463","VB","CAMBIASCA",1],["B464","PV","CAMBIO'",0],["Z208","EE","CAMBOGIA",0],["B465","BI","CAMBURZANO",1],["B466","CB","CAMELI",0],["B467","CN","CAMERANA",1],["B468","AN","CAMERANO",1],["B469","AT","CAMERANO CASASCO",1],["B470","AN","CAMERATA",0],["B471","BG","CAMERATA",0],["B472","RM","CAMERATA",0],["B471","BG","CAMERATA CORNELLO",1],["B472","RM","CAMERATA NUOVA",1],["B470","AN","CAMERATA PICENA",1],["B473","NO","CAMERI",1],["B474","MC","CAMERINO",1],["B475","CO","CAMERLATA",0],["B476","SA","CAMEROTA",1],["Z306","EE","CAMERUN",0],["B477","CE","CAMIGLIANO",1],["B793","GO","CAMIGNA",0],["B478","BS","CAMIGNONE",0],["B479","PC","CAMINATA",0],["B480","BZ","CAMINATA DI TURES",0],["B481","RC","CAMINI",1],["B482","AL","CAMINO",1],["B483","UD","CAMINO AL TAGLIAMENTO",1],["B483","UD","CAMINO DI CODROIPO",0],["B484","CR","CAMISANO",1],["B485","VI","CAMISANO",0],["B485","VI","CAMISANO VICENTINO",1],["B486","AG","CAMMARATA",1],["B487","CO","CAMNAGO",0],["B488","CO","CAMNAGO D'UGGIATE",0],["B488","CO","CAMNAGO FALOPPIA",0],["B487","CO","CAMNAGO SAN MARTINO",0],["B487","CO","CAMNAGO VOLTA",0],["B489","CN","CAMO",0],["B490","GE","CAMOGLI",1],["B491","AO","CAMOSIO",0],["B492","SA","CAMPAGNA",1],["B493","VE","CAMPAGNA",0],["B493","VE","CAMPAGNA LUPIA",1],["B494","CE","CAMPAGNANO",0],["B495","CO","CAMPAGNANO",0],["B496","RM","CAMPAGNANO",0],["B496","RM","CAMPAGNANO DI ROMA",1],["B495","VA","CAMPAGNANO VEDASCA",0],["B497","GR","CAMPAGNATICO",1],["B498","CR","CAMPAGNOLA",0],["B499","RE","CAMPAGNOLA",0],["B498","CR","CAMPAGNOLA CREMASCA",1],["B499","RE","CAMPAGNOLA EMILIA",1],["B500","CS","CAMPANA",1],["B501","MB","CAMPARADA",1],["B501","MI","CAMPARADA",0],["B502","RE","CAMPEGINE",1],["B503","NO","CAMPELLO",0],["B504","PG","CAMPELLO",0],["B503","NO","CAMPELLO MONTI",0],["B504","PG","CAMPELLO SUL CLITUNNO",1],["B505","VC","CAMPERTOGNO",1],["B506","LE","CAMPI",0],["B507","FI","CAMPI BISENZIO",1],["B506","LE","CAMPI SALENTINA",1],["B508","NO","CAMPIGLIA",0],["B509","PI","CAMPIGLIA",0],["B510","TO","CAMPIGLIA",0],["B511","VI","CAMPIGLIA",0],["B508","BI","CAMPIGLIA CERVO",0],["M373","BI","CAMPIGLIA CERVO",1],["B511","VI","CAMPIGLIA DEI BERICI",1],["B509","LI","CAMPIGLIA MARITTIMA",1],["B510","AO","CAMPIGLIA SOANA",0],["B512","TO","CAMPIGLIONE",0],["B512","TO","CAMPIGLIONE FENILE",1],["B513","CO","CAMPIONE",0],["B513","CO","CAMPIONE D'ITALIA",1],["B514","TN","CAMPITELLO",0],["B514","TN","CAMPITELLO DI FASSA",1],["B515","TE","CAMPLI",1],["B516","RC","CAMPO",0],["B517","TO","CAMPO",0],["B518","TN","CAMPO",0],["B516","RC","CAMPO CALABRO",1],["B517","TO","CAMPO CANAVESE",0],["B516","RC","CAMPO DI CALABRIA",0],["B526","AQ","CAMPO DI GIOVE",1],["B529","BZ","CAMPO DI TRENS",1],["B540","AO","CAMPO LARIS",0],["B538","GE","CAMPO LIGURE",1],["B553","LI","CAMPO NELL'ELBA",1],["B558","PV","CAMPO RINALDO",0],["B564","PD","CAMPO SAN MARTINO",1],["B570","BZ","CAMPO TURES",1],["B519","CB","CAMPOBASSO",1],["B520","AG","CAMPOBELLO DI LICATA",1],["B521","TP","CAMPOBELLO DI MAZARA",1],["B522","CB","CAMPOCHIARO",1],["B523","SV","CAMPOCHIESA",0],["B524","PD","CAMPODARSEGO",1],["B525","TN","CAMPODENNO",1],["B527","LT","CAMPODIMELE",1],["B528","CB","CAMPODIPIETRA",1],["B530","SO","CAMPODOLCINO",1],["B531","PD","CAMPODORO",1],["B532","PA","CAMPOFELICE",0],["B533","PA","CAMPOFELICE DI FITALIA",1],["B532","PA","CAMPOFELICE DI ROCCELLA",1],["B534","AP","CAMPOFILONE",0],["B534","FM","CAMPOFILONE",1],["B535","PA","CAMPOFIORITO",1],["B536","UD","CAMPOFORMIDO",1],["B537","CL","CAMPOFRANCO",1],["B538","GE","CAMPOFREDDO",0],["B539","MO","CAMPOGALLIANO",1],["B541","BN","CAMPOLATTARO",1],["B542","BN","CAMPOLI",0],["B543","CE","CAMPOLI",0],["B543","FR","CAMPOLI APPENNINO",1],["B542","BN","CAMPOLI DEL MONTE TABURNO",1],["B544","CB","CAMPOLIETO",1],["B545","UD","CAMPOLONGO",0],["B546","VE","CAMPOLONGO",0],["B547","VI","CAMPOLONGO",0],["B545","UD","CAMPOLONGO AL TORRE",0],["B546","VE","CAMPOLONGO MAGGIORE",1],["B547","VI","CAMPOLONGO SUL BRENTA",0],["M311","UD","CAMPOLONGO TAPOGLIANO",1],["B548","MI","CAMPOLUNGO",0],["B549","PZ","CAMPOMAGGIORE",1],["B550","CB","CAMPOMARINO",1],["B551","GE","CAMPOMORONE",1],["B552","PV","CAMPOMORTO",0],["B554","VE","CAMPONOGARA",1],["B555","SA","CAMPORA",1],["B556","PA","CAMPOREALE",1],["B557","LU","CAMPORGIANO",1],["B559","IM","CAMPOROSSO",1],["B560","UD","CAMPOROSSO",0],["B560","UD","CAMPOROSSO IN VALCANALE",0],["B561","CT","CAMPOROTONDO",0],["B562","MC","CAMPOROTONDO",0],["B562","MC","CAMPOROTONDO DI FIASTRONE",1],["B561","CT","CAMPOROTONDO ETNEO",1],["B563","PD","CAMPOSAMPIERO",1],["B565","NA","CAMPOSANO",1],["B566","MO","CAMPOSANTO",1],["B567","PV","CAMPOSPINOSO",1],["B568","PV","CAMPOSPINOSO ALBAREDO",0],["B569","AQ","CAMPOTOSTO",1],["B316","BS","CAMPOVERDE",0],["B571","SO","CAMPOVICO",0],["B572","BO","CAMUGNANO",1],["Z401","EE","CANADA",0],["B577","TN","CANAL SAN BOVO",1],["B573","CN","CANALE",1],["M222","TN","CANALE",0],["B574","BL","CANALE D'AGORDO",1],["B575","GO","CANALE D'ISONZO",0],["B576","RM","CANALE E MONTEVIRGINIO",0],["B576","RM","CANALE MONTERANO",1],["B578","RO","CANARO",1],["B579","TN","CANAZEI",1],["B580","PZ","CANCELLARA",1],["B581","CE","CANCELLO ED ARNONE",1],["B582","RO","CANDA",1],["B583","IM","CANDEASCO",0],["B584","FG","CANDELA",1],["B585","PU","CANDELARA",0],["B586","BI","CANDELO",1],["B587","PV","CANDIA",0],["B588","TO","CANDIA",0],["B588","TO","CANDIA CANAVESE",1],["B587","PV","CANDIA LOMELLINA",1],["B589","PD","CANDIANA",1],["B590","AV","CANDIDA",1],["B591","RC","CANDIDONI",1],["B592","TO","CANDIOLO",1],["B593","MI","CANEGRATE",1],["B594","AT","CANELLI",1],["B595","RI","CANEMORTO",0],["B596","GE","CANEPA",0],["B597","VT","CANEPINA",1],["B598","PN","CANEVA",1],["B599","PV","CANEVINO",0],["B600","TN","CANEZZA",0],["B601","PL","CANFANARO",0],["B602","AG","CANICATTI'",1],["B603","SR","CANICATTINI BAGNI",1],["B604","VT","CANINO",1],["B605","TO","CANISCHIO",1],["B606","AQ","CANISTRO",1],["B607","CS","CANNA",1],["B608","SA","CANNALONGA",1],["B609","PG","CANNARA",1],["B610","NO","CANNERO",0],["B610","VB","CANNERO RIVIERA",1],["B611","BA","CANNETO",0],["B612","BS","CANNETO",0],["B611","BA","CANNETO DI BARI",0],["B613","PV","CANNETO PAVESE",1],["B612","MN","CANNETO SULL'OGLIO",1],["B614","RC","CANNITELLO",0],["B615","VB","CANNOBIO",1],["B616","LE","CANNOLE",1],["B617","RC","CANOLO",1],["B618","BG","CANONICA D'ADDA",1],["B619","BA","CANOSA",0],["B620","CH","CANOSA",0],["B619","BA","CANOSA DI PUGLIA",0],["B619","BT","CANOSA DI PUGLIA",1],["B620","CH","CANOSA SANNITA",1],["B621","CN","CANOSIO",1],["C669","RE","CANOSSA",1],["B622","CR","CANOVA DEL MORBASCO",0],["B623","CR","CANOVA OLZANO",0],["B624","AQ","CANSANO",1],["B625","CR","CANSERO",0],["B626","PO","CANTAGALLO",1],["B627","RI","CANTALICE",1],["B628","TO","CANTALUPA",1],["B629","AL","CANTALUPO",0],["B630","CB","CANTALUPO",0],["B631","RI","CANTALUPO",0],["B632","RM","CANTALUPO BARDELLA",0],["B631","RI","CANTALUPO IN SABINA",1],["B629","AL","CANTALUPO LIGURE",1],["B630","IS","CANTALUPO NEL SANNIO",1],["B633","AT","CANTARANA",1],["B634","VA","CANTELLO",1],["B635","RM","CANTERANO",1],["B636","PU","CANTIANO",1],["B637","TO","CANTOIRA",1],["B638","MI","CANTONALE",0],["B639","CO","CANTU'",1],["B640","TE","CANZANO",1],["B641","CO","CANZO",1],["B642","VE","CAORLE",1],["B643","PC","CAORSO",1],["B644","SA","CAPACCIO",0],["B644","SA","CAPACCIO PAESTUM",1],["B645","PA","CAPACI",1],["B646","GR","CAPALBIO",1],["B647","PI","CAPANNOLI",1],["B648","LU","CAPANNORI",1],["B649","RM","CAPENA",1],["B650","CR","CAPERGNANICA",1],["B651","AQ","CAPESTRANO",1],["B652","CO","CAPIAGO",0],["B653","CO","CAPIAGO INTIMIANO",1],["B654","CO","CAPIATE",0],["B655","VV","CAPISTRANO",1],["B656","AQ","CAPISTRELLO",1],["B657","SA","CAPITELLO",0],["B658","AQ","CAPITIGNANO",1],["B659","PG","CAPITONE",0],["B660","ME","CAPIZZI",1],["B661","BG","CAPIZZONE",1],["B666","ME","CAPO D'ORLANDO",1],["B664","BS","CAPO DI PONTE",1],["Z307","EE","CAPO VERDE",0],["Z307","EE","CAPO VERDE (ISOLE)",0],["B663","VT","CAPODIMONTE",1],["B662","BL","CAPODIPONTE",0],["B665","PL","CAPODISTRIA",0],["B667","CE","CAPODRISE",1],["B668","VA","CAPOLAGO",0],["B669","LI","CAPOLIVERI",1],["B670","AR","CAPOLONA",1],["B671","MB","CAPONAGO",1],["B671","MI","CAPONAGO",0],["B672","AQ","CAPORCIANO",1],["B673","GO","CAPORETTO",0],["B674","AV","CAPOSELE",1],["B675","CA","CAPOTERRA",1],["B676","BS","CAPOVALLE",1],["B677","AQ","CAPPADOCIA",1],["B678","TV","CAPPELLA",0],["B679","CR","CAPPELLA CANTONE",1],["B679","CR","CAPPELLA CANTONE CON OSCASALE",0],["B680","CR","CAPPELLA DE' PICENARDI",1],["B678","TV","CAPPELLA MAGGIORE",1],["B681","PE","CAPPELLE",0],["B681","PE","CAPPELLE SUL TAVO",1],["B682","IS","CAPRACOTTA",1],["B683","AP","CAPRADOSSO",0],["B684","FI","CAPRAIA",0],["B684","FI","CAPRAIA E LIMITE",1],["B685","LI","CAPRAIA ISOLA",1],["B686","CR","CAPRALBA",1],["B686","CR","CAPRALBA CON FARINATE",0],["B687","RM","CAPRANICA",0],["B688","VT","CAPRANICA",1],["B687","RM","CAPRANICA PRENESTINA",1],["B689","BO","CAPRARA SOPRA PANICO",0],["B690","LE","CAPRARICA DI LECCE",1],["B691","VT","CAPRAROLA",1],["B692","CN","CAPRAUNA",1],["B693","AR","CAPRESE",0],["B693","AR","CAPRESE MICHELANGELO",1],["B694","VB","CAPREZZO",1],["B695","ME","CAPRI",0],["B696","NA","CAPRI",1],["B695","ME","CAPRI LEONE",1],["B697","TN","CAPRIANA",1],["B698","BS","CAPRIANO",0],["B699","MI","CAPRIANO",0],["B698","BS","CAPRIANO DEL COLLE",1],["B699","MI","CAPRIANO DI BRIANZA",0],["B700","BS","CAPRIANO-AZZANO",0],["B701","AL","CAPRIATA",0],["B701","AL","CAPRIATA D'ORBA",1],["B702","BG","CAPRIATE",0],["B702","BG","CAPRIATE D'ADDA",0],["B703","BG","CAPRIATE SAN GERVASIO",1],["B704","CE","CAPRIATI",0],["B704","CE","CAPRIATI A VOLTURNO",1],["B705","TO","CAPRIE",1],["B706","AV","CAPRIGLIA IRPINA",1],["B707","AT","CAPRIGLIO",1],["B708","BI","CAPRILE",1],["B709","VR","CAPRINO",0],["B710","BG","CAPRINO BERGAMASCO",1],["B709","VR","CAPRINO VERONESE",1],["B711","BS","CAPRIOLO",1],["B712","GO","CAPRIVA",0],["B713","TS","CAPRIVA DEL CARSO",0],["B712","GO","CAPRIVA DEL FRIULI",1],["B712","GO","CAPRIVA DI CORMONS",0],["B714","VA","CAPRONNO",0],["B715","CE","CAPUA",1],["B716","BA","CAPURSO",1],["B717","CZ","CARAFFA",0],["B718","RC","CARAFFA",0],["B718","RC","CARAFFA DEL BIANCO",1],["B717","CZ","CARAFFA DI CATANZARO",1],["B719","CN","CARAGLIO",1],["B720","CN","CARAMAGNA",0],["B721","IM","CARAMAGNA",0],["B721","IM","CARAMAGNA LIGURE",0],["B720","CN","CARAMAGNA PIEMONTE",1],["B722","PE","CARAMANICO",0],["B722","PE","CARAMANICO TERME",1],["B723","TN","CARANO",0],["B724","FG","CARAPELLE",1],["B725","AQ","CARAPELLE",0],["B725","AQ","CARAPELLE CALVISIO",1],["B726","GE","CARASCO",1],["B727","AP","CARASSAI",1],["B728","CO","CARATE",0],["B729","MI","CARATE",0],["B729","MB","CARATE BRIANZA",1],["B729","MI","CARATE BRIANZA",0],["B728","CO","CARATE LARIO",0],["B730","CO","CARATE URIO",1],["B731","BG","CARAVAGGIO",1],["B732","VA","CARAVATE",1],["B733","TO","CARAVINO",1],["B734","IM","CARAVONICA",1],["B735","VT","CARBOGNANO",1],["A347","AV","CARBONARA",0],["B736","AL","CARBONARA",0],["B737","BA","CARBONARA",0],["B738","CA","CARBONARA",0],["B739","MN","CARBONARA",0],["B740","NA","CARBONARA",0],["B741","PV","CARBONARA",0],["B741","PV","CARBONARA AL TICINO",1],["B737","BA","CARBONARA DI BARI",0],["B740","NA","CARBONARA DI NOLA",1],["B739","MN","CARBONARA DI PO",0],["B736","AL","CARBONARA SCRIVIA",1],["B742","CO","CARBONATE",1],["B743","PZ","CARBONE",1],["B744","TV","CARBONERA",1],["B745","CA","CARBONIA",0],["B745","SU","CARBONIA",1],["B746","CT","CARCACI",0],["B747","CO","CARCANO",0],["B748","SV","CARCARE",1],["B749","PD","CARCERI",1],["B750","TN","CARCIATO",0],["B751","BS","CARCINA",0],["B752","VC","CARCOFORO",1],["B753","VA","CARDANA",0],["B754","VA","CARDANO",0],["B754","VA","CARDANO AL CAMPO",1],["B755","CN","CARDE'",1],["M285","NU","CARDEDU",1],["B756","RC","CARDETO",1],["B757","NO","CARDEZZA",0],["B758","CZ","CARDINALE",1],["B759","NA","CARDITO",1],["B760","LU","CAREGGINE",1],["B761","CO","CARELLA CON MARIAGA",0],["B762","TO","CAREMA",1],["B763","LC","CARENNO",1],["B764","CO","CARENO",0],["B765","AL","CARENTINO",1],["B766","RC","CARERI",1],["M223","TN","CARES",0],["B767","VC","CARESANA",1],["B768","VC","CARESANABLOT",1],["B769","AL","CAREZZANO",1],["B769","AL","CAREZZANO INFERIORE",0],["B769","AL","CAREZZANO MAGGIORE",0],["B770","AL","CAREZZANO SUPERIORE",0],["B771","KR","CARFIZZI",1],["B772","SS","CARGEGHE",1],["B773","NO","CARGIAGO",0],["B774","CS","CARIATI",1],["B775","RC","CARIDA'",0],["B776","AV","CARIFE",1],["B777","TO","CARIGNANO",1],["B778","CO","CARIMATE",1],["B779","CE","CARINARO",1],["B780","PA","CARINI",1],["B781","CE","CARINOLA",1],["B782","VC","CARISIO",1],["B783","TN","CARISOLO",1],["B784","FG","CARLANTINO",1],["B785","CO","CARLAZZO",1],["B786","CO","CARLAZZO VALSOLDA",0],["B787","SR","CARLENTINI",1],["B788","UD","CARLINO",1],["B789","CA","CARLOFORTE",0],["B789","SU","CARLOFORTE",1],["B790","CZ","CARLOPOLI",1],["B791","TO","CARMAGNOLA",1],["B792","LE","CARMIANO",1],["B794","PO","CARMIGNANO",1],["B795","PD","CARMIGNANO",0],["B795","PD","CARMIGNANO DI BRENTA",1],["B796","VA","CARNAGO",1],["B797","PG","CARNAIOLA",0],["B798","MB","CARNATE",1],["B798","MI","CARNATE",0],["B799","BZ","CARNEDO",0],["B800","BG","CAROBBIO",0],["B801","BG","CAROBBIO DEGLI ANGELI",1],["B802","CS","CAROLEI",1],["Z701","EE","CAROLINE (ISOLE)",0],["B803","BG","CARONA",1],["B804","ME","CARONIA",1],["B805","MI","CARONNO",0],["B806","VA","CARONNO CORBELLARO",0],["B807","VA","CARONNO GHIRINGHELLO",0],["B805","VA","CARONNO MILANESE",0],["B805","VA","CARONNO PERTUSELLA",1],["B807","VA","CARONNO VARESINO",1],["B808","TA","CAROSINO",1],["B809","BR","CAROVIGNO",1],["B810","IS","CAROVILLI",1],["B811","CR","CARPANETA CON DOSIMO",0],["B812","PC","CARPANETO",0],["B812","PC","CARPANETO PIACENTINO",1],["B813","CS","CARPANZANO",1],["B814","IM","CARPASIO",0],["B815","GE","CARPE",0],["B816","PU","CARPEGNA",1],["B817","BS","CARPENEDOLO",1],["B818","AL","CARPENETO",1],["B819","MO","CARPI",1],["B820","MI","CARPIANO",1],["B821","PV","CARPIGNAGO",0],["B822","LE","CARPIGNANO",0],["B823","NO","CARPIGNANO",0],["B824","PV","CARPIGNANO",0],["B822","LE","CARPIGNANO SALENTINO",1],["B823","NO","CARPIGNANO SESIA",1],["B825","RE","CARPINETI",1],["B826","CH","CARPINETO",0],["B827","PE","CARPINETO",0],["B828","RM","CARPINETO",0],["B827","PE","CARPINETO DELLA NORA",1],["B828","RM","CARPINETO ROMANO",1],["B826","CH","CARPINETO SINELLO",1],["B829","FG","CARPINO",1],["B830","IS","CARPINONE",1],["B831","NO","CARPUGNINO",0],["B832","MS","CARRARA",1],["B833","PD","CARRARA SAN GIORGIO",0],["B834","PD","CARRARA SANTO STEFANO",0],["B835","VI","CARRE'",1],["B836","AL","CARREGA LIGURE",1],["B837","GE","CARRETTO",0],["B838","SP","CARRO",1],["B839","SP","CARRODANO",1],["B840","AL","CARROSIO",1],["B841","CN","CARRU'",1],["B842","AQ","CARSOLI",1],["B843","IM","CARTARI E CALDERARA",0],["B844","VI","CARTIGLIANO",1],["B845","CN","CARTIGNANO",1],["B846","PU","CARTOCETO",1],["B847","AL","CARTOSIO",1],["B848","PD","CARTURA",1],["B849","CR","CARUBERTO",0],["B850","MI","CARUGATE",1],["B851","CO","CARUGO",1],["B852","CO","CARUGO AROSIO",0],["B852","CO","CARUGO CON AROSIO",0],["B853","CH","CARUNCHIO",1],["B854","BG","CARVICO",1],["B855","BS","CARZAGO",0],["B855","BS","CARZAGO DELLA RIVIERA",0],["B856","TN","CARZANO",1],["B857","KR","CASABONA",1],["B858","CB","CASACALENDA",1],["B859","CH","CASACANDITELLA",1],["B860","CE","CASAGIOVE",1],["B870","AL","CASAL CERMELLI",1],["B872","CE","CASAL DI PRINCIPE",1],["B912","PD","CASAL SER UGO",0],["B895","SA","CASAL VELINO",1],["B861","CH","CASALANGUIDA",1],["B862","FR","CASALATTICO",1],["B863","CE","CASALBA",0],["B864","NO","CASALBELTRAME",1],["B865","CH","CASALBORDINO",1],["B866","AV","CASALBORE",1],["B867","TO","CASALBORGONE",1],["B868","SA","CASALBUONO",1],["B869","CR","CASALBUTTANO",0],["B869","CR","CASALBUTTANO ED UNITI",1],["B871","CB","CASALCIPRANO",1],["B873","BN","CASALDUNI",1],["B874","CR","CASALE",0],["B875","MI","CASALE",0],["B876","NO","CASALE",0],["B877","PD","CASALE",0],["B878","PI","CASALE",0],["B879","TV","CASALE",0],["B876","VB","CASALE CORTE CERRO",1],["B874","CR","CASALE CREMASCO",0],["B881","CR","CASALE CREMASCO-VIDOLASCO",1],["B877","PD","CASALE DI SCODOSIA",1],["B878","PI","CASALE DI VAL DI CECINA",0],["B875","VA","CASALE LITTA",1],["B878","PI","CASALE MARITTIMO",1],["B885","AL","CASALE MONFERRATO",1],["B879","TV","CASALE SUL SILE",1],["B880","BO","CASALECCHIO DI RENO",1],["B882","AL","CASALEGGIO",0],["B883","NO","CASALEGGIO",0],["B882","AL","CASALEGGIO BOIRO",1],["B884","NO","CASALEGGIO CASTELLAZZO",0],["B883","NO","CASALEGGIO NOVARA",1],["B886","VR","CASALEONE",1],["B887","MI","CASALETTO",0],["B888","SA","CASALETTO",0],["B889","CR","CASALETTO CEREDANO",1],["B890","CR","CASALETTO DI SOPRA",1],["B887","LO","CASALETTO LODIGIANO",1],["B888","SA","CASALETTO SPARTANO",1],["B891","CR","CASALETTO VAPRIO",1],["B892","BO","CASALFIUMANESE",1],["B893","RE","CASALGRANDE",1],["B894","CN","CASALGRASSO",1],["M385","CS","CASALI DEL MANCO",1],["B895","SA","CASALICCHIO",0],["B896","CH","CASALINCONTRADA",1],["B897","NO","CASALINO",1],["B898","CR","CASALMAGGIORE",1],["B899","LO","CASALMAIOCCO",1],["B900","CR","CASALMORANO",1],["B901","MN","CASALMORO",1],["B902","AL","CASALNOCETO",1],["A698","ME","CASALNUOVO",0],["B868","SA","CASALNUOVO",0],["B903","CS","CASALNUOVO",0],["B904","FG","CASALNUOVO",0],["B905","NA","CASALNUOVO",0],["B906","PZ","CASALNUOVO",0],["B905","NA","CASALNUOVO DI NAPOLI",1],["B906","PZ","CASALNUOVO LUCANO",0],["B904","FG","CASALNUOVO MONTEROTARO",1],["B907","MN","CASALOLDO",1],["B908","CR","CASALORZO GEROLDI",0],["B909","MN","CASALPOGLIO",0],["B910","LO","CASALPUSTERLENGO",1],["B911","MN","CASALROMANO",1],["B912","PD","CASALSERUGO",1],["B913","CR","CASALSIGONE",0],["B914","CR","CASALSIGONE ED UNITI",0],["B915","FG","CASALTRINITA",0],["B916","CE","CASALUCE",1],["B917","FG","CASALVECCHIO",0],["B918","ME","CASALVECCHIO",0],["B917","FG","CASALVECCHIO DI PUGLIA",1],["B918","ME","CASALVECCHIO SICULO",1],["B919","FR","CASALVIERI",1],["B920","NO","CASALVOLONE",1],["B921","VA","CASALZUIGNO",1],["B922","NA","CASAMARCIANO",1],["B923","BA","CASAMASSIMA",1],["B924","NA","CASAMICCIOLA",0],["B924","NA","CASAMICCIOLA TERME",1],["B925","NA","CASANDRINO",1],["B860","CE","CASANOVA",0],["B926","CO","CASANOVA",0],["B927","GE","CASANOVA",0],["B928","NO","CASANOVA",0],["M224","CR","CASANOVA DEL MORBASCO",0],["B926","CO","CASANOVA DI UGGIATE",0],["B860","CE","CASANOVA E COCCAGNA",0],["B928","VC","CASANOVA ELVO",1],["B926","CO","CASANOVA LANZA",0],["B927","SV","CASANOVA LERRONE",1],["B929","PV","CASANOVA LONATI",1],["B931","CR","CASANUOVA OFFREDI",0],["B932","RM","CASAPE",1],["M260","CE","CASAPESENNA",1],["B933","BI","CASAPINTA",1],["B934","RI","CASAPROTA",1],["B935","CE","CASAPULLA",1],["B936","LE","CASARANO",1],["B937","LC","CASARGO",1],["B938","MI","CASARILE",1],["B940","UD","CASARSA",0],["B940","PN","CASARSA DELLA DELIZIA",1],["B939","GE","CASARZA",0],["B939","GE","CASARZA LIGURE",1],["B941","AL","CASASCO",1],["B942","CO","CASASCO",0],["B942","CO","CASASCO D'INTELVI",0],["B943","LC","CASATENOVO",1],["B944","PV","CASATICO",0],["B945","PV","CASATISMA",1],["B946","NA","CASAVATORE",1],["B947","BG","CASAZZA",1],["B948","PG","CASCIA",1],["B949","VA","CASCIAGO",1],["A559","PI","CASCIANA TERME",0],["M327","PI","CASCIANA TERME LARI",1],["B950","PI","CASCINA",1],["C026","CR","CASCINE",0],["B951","VC","CASCINE DI STRA",0],["C029","CR","CASCINE GANDINI",0],["B952","VC","CASCINE SAN GIACOMO",0],["B953","TO","CASCINETTE D'IVREA",1],["B954","PV","CASEI GEROLA",1],["B955","TO","CASELETTE",1],["B956","GE","CASELLA",1],["B957","MI","CASELLE",0],["B958","MI","CASELLE",0],["B959","SA","CASELLE",0],["B960","TO","CASELLE",0],["B957","MI","CASELLE D'OZERO",0],["B959","SA","CASELLE IN PITTARI",1],["B961","LO","CASELLE LANDI",1],["B958","LO","CASELLE LURANI",1],["B960","TO","CASELLE TORINESE",1],["B962","FI","CASELLINA E TORRI",0],["B963","CE","CASERTA",1],["B964","TN","CASEZ",0],["B965","TV","CASIER",1],["B966","RC","CASIGNANA",1],["B967","RE","CASINA",1],["B968","CZ","CASINO",0],["B969","BO","CASIO E CASOLA",0],["B970","CO","CASIRAGO",0],["B971","BG","CASIRATE",0],["B972","MI","CASIRATE",0],["B971","BG","CASIRATE D'ADDA",1],["B972","MI","CASIRATE OLONA",0],["B973","CO","CASLETTO",0],["B974","CO","CASLINO",0],["B975","CO","CASLINO",0],["B975","CO","CASLINO AL PIANO",0],["B974","CO","CASLINO D'ERBA",1],["B974","CO","CASLINO PIANO D'ERBA",0],["B976","CO","CASNATE",0],["B977","CO","CASNATE CON BERNATE",1],["B978","BG","CASNIGO",1],["B979","MS","CASOLA",0],["B980","NA","CASOLA",0],["B980","NA","CASOLA DI NAPOLI",1],["B979","MS","CASOLA IN LUNIGIANA",1],["B982","RA","CASOLA VALSENIO",1],["B981","MI","CASOLATE",0],["B983","CS","CASOLE",0],["B984","SI","CASOLE",0],["B983","CS","CASOLE BRUZIO",0],["B984","SI","CASOLE D'ELSA",1],["B985","CH","CASOLI",1],["B986","MI","CASONE",0],["B987","MI","CASORATE",0],["B988","PV","CASORATE",0],["B988","PV","CASORATE PRIMO",1],["B987","VA","CASORATE SEMPIONE",1],["B989","MI","CASOREZZO",1],["B990","NA","CASORIA",1],["B991","AT","CASORZO",1],["B992","VI","CASOTTO",0],["A472","RI","CASPERIA",1],["B993","SO","CASPOGGIO",1],["B994","UD","CASSACCO",1],["B995","CO","CASSAGO",0],["B996","LC","CASSAGO BRIANZA",1],["B997","AV","CASSANO",0],["B998","BA","CASSANO",0],["B999","CO","CASSANO",0],["C001","CO","CASSANO",0],["C002","CS","CASSANO",0],["C001","CO","CASSANO ALBESE",0],["C002","CS","CASSANO ALL'IONIO",1],["C002","CS","CASSANO ALLO IONIO",0],["C003","MI","CASSANO D'ADDA",1],["B998","BA","CASSANO DELLE MURGE",1],["B997","AV","CASSANO IRPINO",1],["C004","VA","CASSANO MAGNAGO",1],["C005","AL","CASSANO SPINOLA",0],["M388","AL","CASSANO SPINOLA",1],["B999","VA","CASSANO VALCUVIA",1],["C006","SR","CASSARO",1],["C007","BG","CASSIGLIO",1],["C008","MI","CASSINA ALIPRANDI",0],["C009","MI","CASSINA AMATA",0],["C010","MI","CASSINA BARAGGIA",0],["C011","CO","CASSINA DE' BRACCHI",0],["C012","MI","CASSINA DE' GATTI",0],["C014","MI","CASSINA DE' PECCHI",1],["C013","MI","CASSINA DEL PERO",0],["C015","MI","CASSINA FERRARA",0],["C016","CO","CASSINA MARIAGA",0],["C017","MI","CASSINA NUOVA",0],["C018","MI","CASSINA PERTUSELLA",0],["C019","MI","CASSINA POBBIA",0],["C020","CO","CASSINA RIZZARDI",1],["C021","MI","CASSINA SAVINA",0],["C023","MI","CASSINA TRIULZA",0],["C024","LC","CASSINA VALSASSINA",1],["C025","MI","CASSINA VERGHERA",0],["C022","AT","CASSINASCO",1],["C027","AL","CASSINE",1],["C028","PV","CASSINE CALDERARI",0],["C031","PV","CASSINE SIRIGARI",0],["C032","PV","CASSINE TOLENTINE",0],["C030","AL","CASSINELLE",1],["C033","MI","CASSINETTA DI LUGAGNANO",1],["C034","FR","CASSINO",1],["C035","PV","CASSINO",0],["C036","MI","CASSINO D'ALBERI",0],["C035","PV","CASSINO PO",0],["C037","VI","CASSOLA",1],["C038","PV","CASSOLNOVO",1],["C039","CZ","CASTAGNA",0],["C040","TE","CASTAGNA",0],["C041","VR","CASTAGNARO",1],["C042","MI","CASTAGNATE OLONA",0],["C043","TN","CASTAGNE'",0],["C044","PI","CASTAGNETO",0],["C045","TO","CASTAGNETO",0],["C044","LI","CASTAGNETO CARDUCCI",1],["C044","PI","CASTAGNETO MARITTIMO",0],["C045","TO","CASTAGNETO PO",1],["C046","CN","CASTAGNITO",1],["C047","AL","CASTAGNOLE",0],["C048","TO","CASTAGNOLE",0],["C049","AT","CASTAGNOLE DELLE LANZE",1],["C047","AT","CASTAGNOLE MONFERRATO",1],["C048","TO","CASTAGNOLE PIEMONTE",1],["C050","PV","CASTANA",1],["C051","ME","CASTANIA",0],["C052","MI","CASTANO",0],["C052","MI","CASTANO PRIMO",1],["C053","PV","CASTEGGIO",1],["C054","MI","CASTEGNATE",0],["C054","MI","CASTEGNATE OLONA",0],["C055","BS","CASTEGNATO",1],["C056","VI","CASTEGNERO",1],["C058","AV","CASTEL BARONIA",1],["C064","AT","CASTEL BOGLIONE",1],["C065","RA","CASTEL BOLOGNESE",1],["B494","CE","CASTEL CAMPAGNANO",1],["C040","TE","CASTEL CASTAGNA",1],["C068","VT","CASTEL CELLESI",0],["C070","AP","CASTEL CLEMENTINO",0],["C071","AN","CASTEL COLONNA",0],["C183","TN","CASTEL CONDINO",1],["C075","BO","CASTEL D'AIANO",1],["C076","MN","CASTEL D'ARIO",1],["C078","VR","CASTEL D'AZZANO",1],["C079","BG","CASTEL DE' CONTI",0],["C087","AL","CASTEL DE' RATTI",0],["C082","IS","CASTEL DEL GIUDICE",1],["C083","AQ","CASTEL DEL MONTE",1],["C084","UD","CASTEL DEL MONTE UDINESE",0],["C085","GR","CASTEL DEL PIANO",1],["C086","BO","CASTEL DEL RIO",1],["B969","BO","CASTEL DI CASIO",1],["C088","AP","CASTEL DI CROCE",0],["C090","AQ","CASTEL DI IERI",1],["C091","CT","CASTEL DI IUDICA",1],["C092","PG","CASTEL DI LAGO",0],["C093","AP","CASTEL DI LAMA",1],["C094","ME","CASTEL DI LUCIO",1],["C096","AQ","CASTEL DI SANGRO",1],["C097","CE","CASTEL DI SASSO",1],["C098","RI","CASTEL DI TORA",1],["C099","GO","CASTEL DOBRA",0],["C102","AR","CASTEL FOCOGNANO",1],["C114","CH","CASTEL FRENTANO",1],["C115","CR","CASTEL GABBIANO",1],["C116","RM","CASTEL GANDOLFO",1],["C117","TR","CASTEL GIORGIO",1],["C118","MN","CASTEL GOFFREDO",1],["C121","BO","CASTEL GUELFO",0],["C121","BO","CASTEL GUELFO DI BOLOGNA",1],["C124","FM","CASTEL IABLANIZZA",0],["M354","TN","CASTEL IVANO",1],["C131","PV","CASTEL LAMBRO",0],["C203","RM","CASTEL MADAMA",1],["C204","BO","CASTEL MAGGIORE",1],["C208","BS","CASTEL MELLA",1],["C210","ME","CASTEL MOLA",0],["C211","CE","CASTEL MORRONE",1],["C252","PG","CASTEL RITALDI",1],["C252","PG","CASTEL RITALDI E SAN GIOVANNI",0],["C253","AT","CASTEL ROCCHERO",1],["C255","BG","CASTEL ROZZONE",1],["C256","SA","CASTEL RUGGERO",0],["C257","PG","CASTEL SAN BENEDETTO REATINO",0],["C258","PG","CASTEL SAN FELICE",0],["C259","SA","CASTEL SAN GIORGIO",1],["C260","PG","CASTEL SAN GIOVANNI",0],["C261","PC","CASTEL SAN GIOVANNI",1],["C260","PG","CASTEL SAN GIOVANNI DI SPOLETO",0],["C262","SA","CASTEL SAN LORENZO",1],["C263","AR","CASTEL SAN NICCOLO'",1],["C264","AL","CASTEL SAN PIETRO",0],["C265","BO","CASTEL SAN PIETRO",0],["C266","RM","CASTEL SAN PIETRO",0],["C264","AL","CASTEL SAN PIETRO MONFERRATO",0],["C265","BO","CASTEL SAN PIETRO NELL'EMILIA",0],["C266","RM","CASTEL SAN PIETRO ROMANO",1],["C265","BO","CASTEL SAN PIETRO TERME",1],["C270","IS","CASTEL SAN VINCENZO",1],["C268","RI","CASTEL SANT'ANGELO",1],["C269","VT","CASTEL SANT'ELIA",1],["C114","CH","CASTEL TRENTANO",0],["C282","AO","CASTEL VERRES",0],["C289","TR","CASTEL VISCARDO",1],["C110","IM","CASTEL VITTORIO",1],["C291","CE","CASTEL VOLTURNO",1],["C057","PD","CASTELBALDO",1],["C059","MN","CASTELBELFORTE",1],["C060","AN","CASTELBELLINO",1],["C061","BZ","CASTELBELLO",0],["C062","BZ","CASTELBELLO CIARDES",0],["C062","BZ","CASTELBELLO-CIARDES",1],["C063","SV","CASTELBIANCO",1],["C066","CB","CASTELBOTTACCIO",1],["C067","PA","CASTELBUONO",1],["C069","SA","CASTELCIVITA",1],["C072","BS","CASTELCOVATI",1],["C073","TV","CASTELCUCCO",1],["C074","PA","CASTELDACCIA",1],["C077","BZ","CASTELDARNE",0],["C080","PU","CASTELDELCI",0],["C080","RN","CASTELDELCI",1],["C081","CN","CASTELDELFINO",1],["C089","CR","CASTELDIDONE",1],["C095","PU","CASTELDIMEZZO",0],["C100","AN","CASTELFIDARDO",1],["C101","FI","CASTELFIORENTINO",1],["C103","TN","CASTELFONDO",0],["C104","LT","CASTELFORTE",1],["C105","AV","CASTELFRANCI",1],["C106","BN","CASTELFRANCO",0],["C107","BO","CASTELFRANCO",0],["C108","CS","CASTELFRANCO",0],["C109","CR","CASTELFRANCO",0],["C110","IM","CASTELFRANCO",0],["C111","TV","CASTELFRANCO",0],["C109","CR","CASTELFRANCO D'OGLIO",0],["C112","AR","CASTELFRANCO DI SOPRA",0],["C113","PI","CASTELFRANCO DI SOTTO",1],["C107","MO","CASTELFRANCO EMILIA",1],["C106","BN","CASTELFRANCO IN MISCANO",1],["C107","MO","CASTELFRANCO NELL'EMILIA",0],["M322","AR","CASTELFRANCO PIANDISCO'",1],["C111","TV","CASTELFRANCO VENETO",1],["M393","LO","CASTELGERUNDO",1],["C119","VI","CASTELGOMBERTO",1],["C120","PZ","CASTELGRANDE",1],["C122","RO","CASTELGUGLIELMO",1],["C123","CH","CASTELGUIDONE",1],["C127","AT","CASTELL'ALFERO",1],["C145","PC","CASTELL'ARQUATO",1],["C147","GR","CASTELL'AZZARA",1],["C051","ME","CASTELL'UMBERTO",1],["C125","SA","CASTELLABATE",1],["C126","AQ","CASTELLAFIUME",1],["C128","TE","CASTELLALTO",1],["C129","NA","CASTELLAMARE",0],["C132","PE","CASTELLAMMARE",0],["C132","PE","CASTELLAMMARE ADRIATICO",0],["C130","TP","CASTELLAMMARE DEL GOLFO",1],["C129","NA","CASTELLAMMARE DI STABIA",1],["C133","TO","CASTELLAMONTE",1],["C134","BA","CASTELLANA",0],["C134","BA","CASTELLANA GROTTE",1],["C135","PA","CASTELLANA SICULA",1],["C136","TA","CASTELLANETA",1],["C137","AL","CASTELLANIA",0],["C137","AL","CASTELLANIA COPPI",1],["C138","TN","CASTELLANO",0],["C139","VA","CASTELLANZA",1],["C140","CN","CASTELLAR",0],["C142","AL","CASTELLAR GUIDOBONO",1],["C141","RE","CASTELLARANO",1],["C076","MN","CASTELLARO",0],["C143","IM","CASTELLARO",1],["C144","PV","CASTELLARO DE' GIORGI",0],["C146","BL","CASTELLAVAZZO",0],["C148","AL","CASTELLAZZO",0],["C149","NO","CASTELLAZZO",0],["C148","AL","CASTELLAZZO BORMIDA",1],["C150","MI","CASTELLAZZO DE' BARZI",0],["C149","NO","CASTELLAZZO NOVARESE",1],["C151","VC","CASTELLENGO",0],["C152","AN","CASTELLEONE",0],["C153","CR","CASTELLEONE",1],["C152","AN","CASTELLEONE DI SUASA",1],["C154","AT","CASTELLERO",1],["B154","VR","CASTELLETTO",0],["C164","PV","CASTELLETTO",0],["C155","BI","CASTELLETTO CERVO",1],["C156","AL","CASTELLETTO D'ERRO",1],["C158","AL","CASTELLETTO D'ORBA",1],["C157","PV","CASTELLETTO DI BRANDUZZO",1],["B154","VR","CASTELLETTO DI BRENZONE",0],["C159","MI","CASTELLETTO MENDOSIO",0],["C160","AL","CASTELLETTO MERLI",1],["C161","AT","CASTELLETTO MOLINA",1],["C162","AL","CASTELLETTO MONFERRATO",1],["C163","CN","CASTELLETTO MONFORTE",0],["C164","PV","CASTELLETTO PO",0],["C162","AL","CASTELLETTO SCAZZOSO",0],["C166","NO","CASTELLETTO SOPRA TICINO",1],["C165","CN","CASTELLETTO STURA",1],["C167","CN","CASTELLETTO UZZONE",1],["C168","VC","CASTELLETTO VILLA",0],["C169","TE","CASTELLI",1],["C079","BG","CASTELLI CALEPIO",1],["C171","NO","CASTELLI CUSIANI",0],["C172","SI","CASTELLINA IN CHIANTI",1],["C174","PI","CASTELLINA MARITTIMA",1],["C173","CN","CASTELLINALDO",0],["C173","CN","CASTELLINALDO D'ALBA",1],["C175","CB","CASTELLINO",0],["C176","CN","CASTELLINO",0],["C175","CB","CASTELLINO DEL BIFERNO",1],["C176","CN","CASTELLINO TANARO",1],["C177","FR","CASTELLIRI",1],["C178","CE","CASTELLO",0],["C179","CO","CASTELLO",0],["C180","CO","CASTELLO",0],["C181","CO","CASTELLO",0],["C182","TN","CASTELLO",0],["C183","TN","CASTELLO",0],["B312","VA","CASTELLO CABIAGLIO",1],["C184","PV","CASTELLO D'AGOGNA",1],["C178","CE","CASTELLO D'ALIFE",0],["C185","BO","CASTELLO D'ARGILE",1],["C178","CE","CASTELLO DEL MATESE",1],["C186","SO","CASTELLO DELL'ACQUA",1],["A300","AT","CASTELLO DI ANNONE",1],["C187","LC","CASTELLO DI BRIANZA",1],["B494","CE","CASTELLO DI CAMPAGNANO",0],["C188","NA","CASTELLO DI CISTERNA",1],["C189","TN","CASTELLO DI FIEMME",0],["C190","TV","CASTELLO DI GODEGO",1],["C077","BZ","CASTELLO DI PUSTERIA",0],["C191","BO","CASTELLO DI SERRAVALLE",0],["C180","CO","CASTELLO SOPRA LECCO",0],["C194","TN","CASTELLO TESINO",1],["C179","CO","CASTELLO VALSOLDA",0],["C181","VA","CASTELLO VALTRAVAGLIA",0],["C189","TN","CASTELLO-MOLINA DI FIEMME",1],["C192","CB","CASTELLONE AL VOLTURNO",0],["C193","LT","CASTELLONORATO",0],["C195","MN","CASTELLUCCHIO",1],["C069","SA","CASTELLUCCIA",0],["C094","ME","CASTELLUCCIO",0],["C177","CE","CASTELLUCCIO",0],["C196","PZ","CASTELLUCCIO",0],["C197","CB","CASTELLUCCIO ACQUABORRANO",0],["C198","FG","CASTELLUCCIO DEI SAURI",1],["C177","CE","CASTELLUCCIO DI SORA",0],["C200","CB","CASTELLUCCIO IN VERRINO",0],["C199","PZ","CASTELLUCCIO INFERIORE",1],["C201","PZ","CASTELLUCCIO SUPERIORE",1],["C202","FG","CASTELLUCCIO VALMAGGIORE",1],["C205","CN","CASTELMAGNO",1],["C206","CO","CASTELMARTE",1],["C207","RO","CASTELMASSA",1],["C197","CB","CASTELMAURO",1],["C209","PZ","CASTELMEZZANO",1],["C210","ME","CASTELMOLA",1],["C212","MI","CASTELNOVATE",0],["C213","PV","CASTELNOVETTO",1],["C214","CN","CASTELNOVO",0],["C215","RO","CASTELNOVO",0],["C216","TN","CASTELNOVO",0],["C217","UD","CASTELNOVO",0],["C215","RO","CASTELNOVO BARIANO",1],["C217","PN","CASTELNOVO DEL FRIULI",1],["C218","RE","CASTELNOVO DI SOTTO",1],["C219","RE","CASTELNOVO NE' MONTI",1],["C114","CH","CASTELNUOVO",0],["C208","BS","CASTELNUOVO",0],["C216","TN","CASTELNUOVO",1],["C220","CO","CASTELNUOVO",0],["C221","CR","CASTELNUOVO",0],["C222","FG","CASTELNUOVO",0],["C223","FR","CASTELNUOVO",0],["C224","RI","CASTELNUOVO",0],["C225","VR","CASTELNUOVO",0],["C220","CO","CASTELNUOVO BAZENTE",0],["C226","AT","CASTELNUOVO BELBO",1],["C227","SI","CASTELNUOVO BERARDENGA",1],["C228","LO","CASTELNUOVO BOCCA D'ADDA",1],["C229","AL","CASTELNUOVO BORMIDA",1],["C220","CO","CASTELNUOVO BOZZENTE",1],["C230","AT","CASTELNUOVO CALCEA",1],["C231","SA","CASTELNUOVO CILENTO",1],["C221","CR","CASTELNUOVO CREMASCO",0],["C232","AL","CASTELNUOVO D'ASTI",0],["C238","FM","CASTELNUOVO D'ISTRIA",0],["C225","VR","CASTELNUOVO DEL GARDA",1],["C233","CR","CASTELNUOVO DEL VESCOVO",0],["C234","CR","CASTELNUOVO DEL ZAPPA",0],["C222","FG","CASTELNUOVO DELLA DAUNIA",1],["C214","CN","CASTELNUOVO DI CEVA",1],["C235","SA","CASTELNUOVO DI CONZA",1],["C224","RI","CASTELNUOVO DI FARFA",1],["C236","LU","CASTELNUOVO DI GARFAGNANA",1],["C237","RM","CASTELNUOVO DI PORTO",1],["C244","PI","CASTELNUOVO DI VAL DI CECINA",1],["C225","VR","CASTELNUOVO DI VERONA",0],["C232","AT","CASTELNUOVO DON BOSCO",1],["C239","CR","CASTELNUOVO GHERARDI",0],["C240","SP","CASTELNUOVO MAGRA",1],["C241","TO","CASTELNUOVO NIGRA",1],["C223","FR","CASTELNUOVO PARANO",1],["C242","MO","CASTELNUOVO RANGONE",1],["C243","AL","CASTELNUOVO SCRIVIA",1],["C244","PI","CASTELNUOVO VAL DI CECINA",0],["C245","BN","CASTELPAGANO",1],["C246","IS","CASTELPETROSO",1],["M225","TN","CASTELPIETRA",0],["C247","IS","CASTELPIZZUTO",1],["C248","AN","CASTELPLANIO",1],["C249","CR","CASTELPONZONE",0],["C250","BN","CASTELPOTO",1],["C251","MC","CASTELRAIMONDO",1],["C254","BZ","CASTELROTTO",1],["C267","MC","CASTELSANTANGELO",0],["C267","MC","CASTELSANTANGELO SUL NERA",1],["C271","PZ","CASTELSARACENO",1],["C272","SS","CASTELSARDO",1],["C273","VA","CASTELSEPRIO",1],["B968","KR","CASTELSILANO",1],["C274","AL","CASTELSPINA",1],["C275","AG","CASTELTERMINI",1],["C181","VA","CASTELVECCANA",1],["C098","PG","CASTELVECCHIO",0],["C276","GE","CASTELVECCHIO",0],["C277","IM","CASTELVECCHIO",0],["C278","AQ","CASTELVECCHIO CALVISIO",1],["C276","SV","CASTELVECCHIO DI ROCCA BARBENA",1],["C277","IM","CASTELVECCHIO DI SANTA MARIA MAGGIORE",0],["C279","AQ","CASTELVECCHIO SUBEQUO",1],["C280","BN","CASTELVENERE",1],["B129","CR","CASTELVERDE",1],["C064","AL","CASTELVERO",0],["C281","AL","CASTELVERO",0],["C281","AL","CASTELVERO D'ASTI",0],["C200","IS","CASTELVERRINO",1],["C283","AV","CASTELVETERE",0],["C284","BN","CASTELVETERE",0],["C285","RC","CASTELVETERE",0],["C283","AV","CASTELVETERE DI CALORE",0],["C284","BN","CASTELVETERE IN VAL FORTORE",1],["C283","AV","CASTELVETERE SUL CALORE",1],["C286","TP","CASTELVETRANO",1],["C287","MO","CASTELVETRO",0],["C288","PC","CASTELVETRO",0],["C287","MO","CASTELVETRO DI MODENA",1],["C288","PC","CASTELVETRO PIACENTINO",1],["C290","CR","CASTELVISCONTI",1],["C292","BO","CASTENASO",1],["C293","BS","CASTENEDOLO",1],["M288","CA","CASTIADAS",0],["M288","SU","CASTIADAS",1],["C294","AO","CASTIGLION DORA",0],["C318","AR","CASTIGLION FIBOCCHI",1],["C319","AR","CASTIGLION FIORENTINO",1],["C320","AR","CASTIGLION UBERTINI",0],["C295","AL","CASTIGLIONE",0],["C296","BO","CASTIGLIONE",0],["C297","CT","CASTIGLIONE",0],["C298","CH","CASTIGLIONE",0],["C299","CO","CASTIGLIONE",0],["C300","CO","CASTIGLIONE",0],["C301","CS","CASTIGLIONE",0],["C302","GE","CASTIGLIONE",0],["C303","MS","CASTIGLIONE",0],["C304","MI","CASTIGLIONE",0],["C305","NO","CASTIGLIONE",0],["C306","SA","CASTIGLIONE",0],["C307","TO","CASTIGLIONE",0],["C308","PE","CASTIGLIONE A CASAURIA",1],["C308","TE","CASTIGLIONE ALLA PESCARA",0],["C302","GE","CASTIGLIONE CHIAVARESE",1],["C301","CS","CASTIGLIONE COSENTINO",1],["C304","LO","CASTIGLIONE D'ADDA",1],["C295","AL","CASTIGLIONE D'ASTI",0],["C299","CO","CASTIGLIONE D'INTELVI",0],["C313","SI","CASTIGLIONE D'ORCIA",1],["C305","NO","CASTIGLIONE D'OSSOLA",0],["C296","BO","CASTIGLIONE DEI PEPOLI",1],["C306","SA","CASTIGLIONE DEL GENOVESI",1],["C309","PG","CASTIGLIONE DEL LAGO",1],["C310","GR","CASTIGLIONE DELLA PESCAIA",1],["C311","TE","CASTIGLIONE DELLA VALLE",0],["C312","MN","CASTIGLIONE DELLE STIVIERE",1],["C303","LU","CASTIGLIONE DI GARFAGNANA",1],["C297","CT","CASTIGLIONE DI SICILIA",1],["C314","CN","CASTIGLIONE FALLETTO",1],["C315","VT","CASTIGLIONE IN TEVERINA",1],["C298","CH","CASTIGLIONE MESSER MARINO",1],["C316","TE","CASTIGLIONE MESSER RAIMONDO",1],["C300","VA","CASTIGLIONE OLONA",1],["C317","CN","CASTIGLIONE TINELLA",1],["C307","TO","CASTIGLIONE TORINESE",1],["C321","AP","CASTIGNANO",1],["C322","TE","CASTILENTI",1],["C323","CN","CASTINO",1],["C324","BG","CASTIONE",0],["C325","SO","CASTIONE",0],["C326","VR","CASTIONE",0],["C325","SO","CASTIONE ANDEVENNO",1],["C324","BG","CASTIONE DELLA PRESOLANA",1],["C326","VR","CASTIONE VERONESE",0],["C327","UD","CASTIONS DI STRADA",1],["C328","MI","CASTIRAGA DA REGGIO",0],["C329","LO","CASTIRAGA VIDARDO",1],["C330","BS","CASTO",1],["C331","AP","CASTORANO",1],["C332","BS","CASTREZZATO",1],["C333","BS","CASTREZZONE",0],["C334","LE","CASTRI DI LECCE",1],["C334","LE","CASTRI FRANCONE",0],["C335","LE","CASTRIGNANO DE' GRECI",1],["C336","LE","CASTRIGNANO DEL CAPO",1],["C337","BG","CASTRO",1],["C338","RM","CASTRO",0],["M261","LE","CASTRO",1],["C338","FR","CASTRO DEI VOLSCI",1],["C339","FC","CASTROCARO E TERRA DEL SOLE",0],["C339","FC","CASTROCARO TERME E TERRA DEL SOLE",1],["C340","FR","CASTROCIELO",1],["C341","AG","CASTROFILIPPO",1],["C342","EN","CASTROGIOVANNI",0],["C108","CS","CASTROLIBERO",1],["C343","VA","CASTRONNO",1],["C344","PA","CASTRONOVO",0],["C344","PA","CASTRONOVO DI SICILIA",1],["C345","PZ","CASTRONUOVO",0],["C345","PZ","CASTRONUOVO DI SANT'ANDREA",1],["C346","CB","CASTROPIGNANO",1],["C347","ME","CASTROREALE",1],["C348","CS","CASTROREGIO",1],["C349","CS","CASTROVILLARI",1],["C350","RC","CATAFORIO",0],["C351","CT","CATANIA",1],["C352","CZ","CATANZARO",1],["C353","EN","CATENANUOVA",1],["C354","PE","CATIGNANO",1],["C355","RC","CATONA",0],["C356","AG","CATTOLICA",0],["C357","RN","CATTOLICA",1],["C356","AG","CATTOLICA ERACLEA",1],["C285","RC","CAULONIA",1],["C358","TN","CAURIA",0],["C359","BN","CAUTANO",1],["C360","PV","CAVA",0],["C361","SA","CAVA",0],["B824","PV","CAVA CARPIGNANO",0],["C361","SA","CAVA DE' TIRRENI",1],["C360","PV","CAVA MANARA",1],["C386","CR","CAVA TIGOZZI",0],["C362","LO","CAVACURTA",0],["C363","BI","CAVAGLIA'",1],["C364","NO","CAVAGLIETTO",1],["C365","NO","CAVAGLIO",0],["C366","NO","CAVAGLIO",0],["C365","NO","CAVAGLIO D'AGOGNA",1],["C366","NO","CAVAGLIO SAN DONNINO",0],["C367","VB","CAVAGLIO-SPOCCIA",0],["C368","PV","CAVAGNERA",0],["C369","TO","CAVAGNOLO",1],["C370","VR","CAVAION",0],["C370","VR","CAVAION VERONESE",1],["C371","MI","CAVAIONE",0],["C372","TN","CAVALESE",1],["C373","CR","CAVALLARA",0],["C374","CO","CAVALLASCA",0],["C375","CN","CAVALLERLEONE",1],["C376","CN","CAVALLERMAGGIORE",1],["C377","LE","CAVALLINO",1],["M308","VE","CAVALLINO-TREPORTI",1],["C378","NO","CAVALLIRIO",1],["C379","NO","CAVANDONE",0],["C380","TN","CAVARENO",1],["C381","CO","CAVARGNA",1],["C382","VA","CAVARIA CON PREMEZZO",1],["C382","MI","CAVARIA ED UNITI",0],["C383","VE","CAVARZERE",1],["C384","TV","CAVASO",0],["C384","TV","CAVASO DEL TOMBA",1],["C385","UD","CAVASSO",0],["C385","PN","CAVASSO NUOVO",1],["C387","AL","CAVATORE",1],["C388","VE","CAVAZUCCHERINA",0],["C389","UD","CAVAZZO",0],["C389","UD","CAVAZZO CARNICO",1],["C390","RM","CAVE",1],["C391","TS","CAVE AUREMIANE",0],["C392","TN","CAVEDAGO",1],["C393","TN","CAVEDINE",1],["C394","MI","CAVENAGO",0],["C395","MI","CAVENAGO",0],["C394","LO","CAVENAGO D'ADDA",1],["C395","MB","CAVENAGO DI BRIANZA",1],["C395","MI","CAVENAGO DI BRIANZA",0],["C396","BG","CAVERNAGO",1],["C397","CO","CAVERSACCIO",0],["C398","MO","CAVEZZO",1],["C399","MI","CAVIAGA",0],["C400","TN","CAVIZZANA",1],["C401","BZ","CAVOLANO",0],["C402","VA","CAVONA",0],["C403","TO","CAVORETTO",0],["C404","TO","CAVOUR",1],["M226","TN","CAVRASTO",0],["C405","RE","CAVRIAGO",1],["C406","MN","CAVRIANA",1],["C407","AR","CAVRIGLIA",1],["Z530","EE","CAYMAN (ISOLE)",0],["C408","BS","CAZZAGO",0],["C409","CO","CAZZAGO",0],["C409","VA","CAZZAGO BRABBIA",1],["C408","BS","CAZZAGO SAN MARTINO",1],["C410","BG","CAZZANO",0],["C411","MI","CAZZANO",0],["C412","VR","CAZZANO",0],["C411","MI","CAZZANO BEFANA",0],["C411","MI","CAZZANO BESANA",0],["C412","VR","CAZZANO DI TRAMIGNA",1],["C410","BG","CAZZANO SANT'ANDREA",1],["B017","MI","CAZZIMANI",0],["B634","VA","CAZZONE",0],["Z156","EE","CECA REPUBBLICA",0],["C413","FR","CECCANO",1],["C414","PV","CECIMA",1],["C415","LI","CECINA",1],["C416","GO","CECONICO",0],["Z105","EE","CECOSLOVACCHIA",0],["C417","BS","CEDEGOLO",1],["C418","SO","CEDRASCO",1],["C419","MI","CEDRATE",0],["C420","PA","CEFALA' DIANA",1],["C421","PA","CEFALU'",1],["C422","VE","CEGGIA",1],["C423","BA","CEGLIE",0],["C424","BR","CEGLIE",0],["C425","FM","CEGLIE",0],["C423","BA","CEGLIE DEL CAMPO",0],["C424","BR","CEGLIE MESSAPICA",1],["C424","BR","CEGLIE MESSAPICO",0],["C426","AQ","CELANO",1],["C427","TN","CELENTINO",0],["C428","CH","CELENZA",0],["C429","FG","CELENZA",0],["C428","CH","CELENZA SUL FRIGNO",0],["C428","CH","CELENZA SUL TRIGNO",1],["C429","FG","CELENZA VALFORTORE",1],["C430","CS","CELICO",1],["C431","VA","CELINA",0],["C432","AL","CELLA",0],["C433","CR","CELLA",0],["C434","PV","CELLA",0],["C435","CR","CELLA DATI",1],["C434","PV","CELLA DI BOBBIO",0],["C432","AL","CELLA MONTE",1],["C436","BA","CELLAMARE",1],["C437","CS","CELLARA",1],["C438","AT","CELLARENGO",1],["C439","BS","CELLATICA",1],["C440","AL","CELLE",0],["C441","CN","CELLE",0],["C442","FG","CELLE",0],["C443","GE","CELLE",0],["C444","SA","CELLE",0],["C444","SA","CELLE DI BULGHERIA",1],["C441","CN","CELLE DI MACRA",1],["C442","FG","CELLE DI SAN VITO",1],["C440","AT","CELLE ENOMONDO",1],["C443","SV","CELLE LIGURE",1],["C442","FG","CELLE SAN VITO",0],["C445","TN","CELLEDIZZO",0],["C446","VT","CELLENO",1],["C447","VT","CELLERE",1],["C448","BR","CELLINO",0],["C449","TE","CELLINO",0],["C449","TE","CELLINO ATTANASIO",1],["C448","BR","CELLINO SAN MARCO",1],["C450","VC","CELLIO",0],["M398","VC","CELLIO CON BREIA",1],["M262","CE","CELLOLE",1],["C451","PV","CELPENCHIO",0],["C452","TN","CEMBRA",0],["M355","TN","CEMBRA LISIGNAGO",1],["C453","CZ","CENADI",1],["C454","BG","CENATE",0],["C455","BG","CENATE D'ARGON",0],["C456","BG","CENATE DI SOPRA",0],["C457","BG","CENATE DI SOTTO",0],["C456","BG","CENATE SOPRA",1],["C457","BG","CENATE SOTTO",1],["C458","BL","CENCENIGHE",0],["C458","BL","CENCENIGHE AGORDINO",1],["C459","BG","CENE",1],["C460","TV","CENEDA",0],["C461","RO","CENESELLI",1],["C462","SV","CENESI",0],["C463","SV","CENGIO",1],["C464","BZ","CENGLES",0],["C465","IM","CENOVA",0],["C467","TN","CENTA SAN NICOLO'",0],["C466","CN","CENTALLO",1],["C468","CO","CENTEMERO",0],["C469","FE","CENTO",1],["C470","SA","CENTOLA",1],["C471","EN","CENTORBI",0],["C472","CZ","CENTRACHE",1],["Z308","EE","CENTRAFRICANA REPUBBLICA",0],["C473","BG","CENTRISOLA",0],["M394","CO","CENTRO VALLE INTELVI",1],["Z308","EE","CENTROAFRICANA REPUBBLICA",0],["Z308","EE","CENTROAFRICANO IMPERO",0],["C471","EN","CENTURIPE",1],["C471","EN","CENTURUPI",0],["C474","PE","CEPAGATTI",1],["C475","BG","CEPINO",0],["C476","BN","CEPPALONI",1],["C477","MI","CEPPEDA",0],["C478","VB","CEPPO MORELLI",1],["C479","FR","CEPRANO",1],["C480","EN","CERAMI",1],["C481","GE","CERANESI",1],["C482","CO","CERANO",0],["C483","NO","CERANO",1],["C482","CO","CERANO D'INTELVI",1],["C484","PV","CERANOVA",1],["C485","SA","CERASO",1],["C486","CB","CERCEMAGGIORE",1],["C487","TO","CERCENASCO",1],["C488","CB","CERCEPICCOLA",1],["C489","CS","CERCHIARA",0],["C490","RI","CERCHIARA",0],["C489","CS","CERCHIARA DI CALABRIA",1],["C490","RI","CERCHIARA DI SABINA",0],["C491","MI","CERCHIATE",0],["C492","AQ","CERCHIO",1],["C493","SO","CERCINO",1],["C494","UD","CERCIVENTO",1],["C495","NA","CERCOLA",1],["C496","PA","CERDA",1],["C497","TO","CERE",0],["C498","VR","CEREA",1],["C499","CO","CEREDA",0],["C500","RO","CEREGNANO",1],["C501","KR","CERENZIA",1],["C497","TO","CERES",1],["C502","MN","CERESARA",1],["C503","AL","CERESETO",1],["C504","CN","CERESOLE",0],["C505","TO","CERESOLE",0],["C504","CN","CERESOLE ALBA",1],["C505","TO","CERESOLE REALE",1],["C506","BG","CERETE",1],["C507","AL","CERETTO",0],["C507","AL","CERETTO GRUE",0],["C508","PV","CERETTO LOMELLINA",1],["C509","PV","CERGNAGO",1],["C510","SV","CERIALE",1],["C511","IM","CERIANA",1],["C512","MI","CERIANO",0],["C512","MB","CERIANO LAGHETTO",1],["C512","MI","CERIANO LAGHETTO",0],["C513","PC","CERIGNALE",1],["C514","FG","CERIGNOLA",1],["C515","CS","CERISANO",1],["C516","CO","CERMENATE",1],["A022","BZ","CERMES",1],["C517","TE","CERMIGNANO",1],["C518","RM","CERNETO",0],["C519","GO","CERNIZZA GORIZIANA",0],["C520","CO","CERNOBBIO",1],["C523","MI","CERNUSCO ASINARIO",0],["C521","CO","CERNUSCO LOMBARDONE",0],["C521","LC","CERNUSCO LOMBARDONE",1],["C522","CO","CERNUSCO MONTEVECCHIA",0],["C523","MI","CERNUSCO SUL NAVIGLIO",1],["C518","RM","CERRETO",0],["C524","AN","CERRETO",0],["C525","BN","CERRETO",0],["C526","NO","CERRETO",0],["C527","PG","CERRETO",0],["C526","BI","CERRETO CASTELLO",0],["C528","AT","CERRETO D'ASTI",1],["C524","AN","CERRETO D'ESI",1],["C527","PG","CERRETO DI SPOLETO",1],["C507","AL","CERRETO GRUE",1],["C529","FI","CERRETO GUIDI",1],["C518","RM","CERRETO LAZIALE",1],["C525","BN","CERRETO SANNITA",1],["C508","PV","CERRETTO",0],["C528","AL","CERRETTO",0],["C530","CN","CERRETTO",0],["C530","CN","CERRETTO DELLE LANGHE",0],["C530","CN","CERRETTO LANGHE",1],["C508","PV","CERRETTO LOMELLINO",0],["C531","AL","CERRINA",0],["C531","AL","CERRINA MONFERRATO",1],["C532","BI","CERRIONE",1],["C533","AL","CERRO",0],["C534","CB","CERRO",0],["C535","CO","CERRO",0],["C536","MI","CERRO",0],["C537","MI","CERRO",0],["C538","VR","CERRO",0],["C536","MI","CERRO AL LAMBRO",1],["C534","IS","CERRO AL VOLTURNO",1],["C535","VA","CERRO LAGO MAGGIORE",0],["C537","MI","CERRO MAGGIORE",1],["C533","AT","CERRO TANARO",1],["C538","VR","CERRO VERONESE",1],["C539","PZ","CERSOSIMO",1],["C540","FI","CERTALDO",1],["C541","PV","CERTOSA DI PAVIA",1],["C542","CZ","CERVA",1],["C543","RM","CERVARA",0],["C543","RM","CERVARA DI ROMA",1],["C544","PD","CERVARESE SANTA CROCE",1],["C545","FR","CERVARO",1],["C546","VC","CERVAROLO",0],["C547","CN","CERVASCA",1],["C548","VC","CERVATTO",1],["C549","BS","CERVENO",1],["C550","CN","CERVERE",1],["C551","PV","CERVESINA",1],["C552","RM","CERVETERI",1],["C553","RA","CERVIA",1],["C554","CS","CERVICATI",1],["C555","MI","CERVIGNANO",0],["C556","UD","CERVIGNANO",0],["C555","LO","CERVIGNANO D'ADDA",1],["C556","UD","CERVIGNANO DEL FRIULI",1],["C557","AV","CERVINARA",1],["C558","CE","CERVINO",1],["C559","IM","CERVO",1],["C560","CS","CERZETO",1],["C561","CE","CESA",1],["C562","BL","CESANA",0],["C563","CO","CESANA",0],["C564","TO","CESANA",0],["C563","LC","CESANA BRIANZA",1],["C563","CO","CESANA DI BRIANZA",0],["C564","TO","CESANA TORINESE",1],["C565","MI","CESANO BOSCONE",1],["C566","MB","CESANO MADERNO",1],["C566","MI","CESANO MADERNO",0],["C567","VB","CESARA",1],["C568","ME","CESARO'",1],["C569","MI","CESATE",1],["C570","UD","CESCLANS",0],["C571","PG","CESELLI",0],["C572","CO","CESELLO BRIANZA",0],["C573","FC","CESENA",1],["C574","FC","CESENATICO",1],["C575","PG","CESI",0],["C576","AV","CESINALI",1],["C577","BL","CESIO",0],["C578","IM","CESIO",1],["C577","BL","CESIOMAGGIORE",1],["C579","TO","CESNOLA",0],["C580","TV","CESSALTO",1],["C581","VV","CESSANITI",1],["C582","MC","CESSAPALOMBO",1],["C583","AT","CESSOLE",1],["C584","SA","CETARA",1],["C585","BS","CETO",1],["C586","BS","CETO-CERVENO",0],["C587","SI","CETONA",1],["C588","CS","CETRARO",1],["C589","CN","CEVA",1],["C590","BZ","CEVES",0],["C591","BS","CEVO",1],["Z209","EE","CEYLON",0],["C593","AO","CHALLAND-SAINT-ANSELME",1],["C594","AO","CHALLAND-SAINT-VICTOR",1],["C592","AO","CHALLANT",0],["C593","AO","CHALLANT SAINT ANSELME",0],["C594","AO","CHALLANT SAINT VICTOR",0],["C595","AO","CHAMBAVE",1],["B491","AO","CHAMOIS",1],["C596","AO","CHAMPDEPRAZ",1],["C597","TO","CHAMPLAS DU COL",0],["B540","AO","CHAMPORCHER",1],["C598","AO","CHARVENSOD",1],["C294","AO","CHATILLON",1],["C599","CN","CHERASCO",1],["C600","SS","CHEREMULE",1],["C601","PL","CHERSO",0],["C602","TO","CHIABRANO",0],["C603","NA","CHIAIANO",0],["C603","NA","CHIAIANO ED UNITI",0],["C604","TO","CHIALAMBERTO",1],["C605","VI","CHIAMPO",1],["C606","AV","CHIANCHE",1],["C607","AV","CHIANCHETELLE",0],["C608","SI","CHIANCIANO",0],["C608","SI","CHIANCIANO TERME",1],["C609","PI","CHIANNI",1],["C610","TO","CHIANOC",0],["C610","TO","CHIANOCCO",1],["C611","GO","CHIAPOVANO",0],["C612","SR","CHIARAMONTE",0],["C612","RG","CHIARAMONTE GULFI",1],["C613","SS","CHIARAMONTI",1],["C614","TV","CHIARANO",1],["C615","AN","CHIARAVALLE",1],["C616","CZ","CHIARAVALLE",0],["C617","MI","CHIARAVALLE",0],["C616","CZ","CHIARAVALLE CENTRALE",1],["C617","MI","CHIARAVALLE MILANESE",0],["C618","BS","CHIARI",1],["C619","PZ","CHIAROMONTE",1],["C620","IS","CHIAUCI",1],["C621","GE","CHIAVARI",1],["C622","VC","CHIAVAZZA",0],["C623","SO","CHIAVENNA",1],["C624","TO","CHIAVERANO",1],["B705","TO","CHIAVRIE",0],["C625","BZ","CHIENES",1],["C626","TN","CHIENIS",0],["C627","TO","CHIERI",1],["C630","BL","CHIES D'ALPAGO",1],["C628","SO","CHIESA",0],["C628","SO","CHIESA IN VALMALENCO",1],["C629","TO","CHIESANOVA",0],["C629","TO","CHIESANUOVA",1],["C631","PT","CHIESINA UZZANESE",1],["C632","CH","CHIETI",1],["C633","FG","CHIEUTI",1],["C634","CR","CHIEVE",1],["C635","BG","CHIGNOLO",0],["C636","NO","CHIGNOLO",0],["C637","PV","CHIGNOLO",0],["C635","BG","CHIGNOLO D'ISOLA",1],["C637","PV","CHIGNOLO PO",1],["C636","NO","CHIGNOLO VERBANO",0],["C638","VE","CHIOGGIA",1],["C639","TO","CHIOMONTE",1],["C640","PN","CHIONS",1],["C641","UD","CHIOPRIS VISCONE",0],["C641","UD","CHIOPRIS-VISCONE",1],["C642","MI","CHIOSI D'ADDA VIGADORE",0],["C643","MI","CHIOSI DI PORTA D'ADDA",0],["C644","MI","CHIOSI PORTA CREMONESE",0],["C645","MI","CHIOSI PORTA REGALE",0],["C646","MI","CHIOSI UNITI CON BOTTEDO",0],["C647","VE","CHIRIGNAGO",0],["C648","AR","CHITIGNANO",1],["C649","BG","CHIUDUNO",1],["C650","VI","CHIUPPANO",1],["C651","SO","CHIURO",1],["C652","BZ","CHIUSA",1],["C653","CN","CHIUSA",0],["C654","PA","CHIUSA",0],["C655","TO","CHIUSA",0],["C656","UD","CHIUSA",0],["C652","BZ","CHIUSA ALL'ISARCO",0],["C653","CN","CHIUSA DI PESIO",1],["C655","TO","CHIUSA DI SAN MICHELE",1],["C654","PA","CHIUSA SCLAFANI",1],["C656","UD","CHIUSAFORTE",1],["C657","IM","CHIUSANICO",1],["C658","AL","CHIUSANO",0],["C659","AV","CHIUSANO",0],["C658","AT","CHIUSANO D'ASTI",1],["C659","AV","CHIUSANO DI SAN DOMENICO",1],["C660","IM","CHIUSAVECCHIA",1],["C661","SI","CHIUSDINO",1],["C662","SI","CHIUSI",1],["C663","AR","CHIUSI DELLA VERNA",1],["C663","AR","CHIUSI IN CASENTINO",0],["C664","CO","CHIUSO",0],["C665","TO","CHIVASSO",1],["C666","TN","CHIZZOLA",0],["Z702","EE","CHRISTMAS (ISOLA)",0],["C294","AO","CH�TILLON",0],["Z309","EE","CIAD",0],["C667","TN","CIAGO",0],["C595","AO","CIAMBAVE",0],["M272","RM","CIAMPINO",1],["C668","AG","CIANCIANA",1],["C669","RE","CIANO",0],["C669","RE","CIANO D'ENZA",0],["C670","TV","CIANO-NOGARE'",0],["C671","BZ","CIARDES",0],["C671","BZ","CIARS",0],["C672","BL","CIBIANA",0],["C672","BL","CIBIANA DI CADORE",1],["C673","GE","CICAGNA",1],["C674","CZ","CICALA",1],["C675","NA","CICCIANO",1],["C676","SA","CICERALE",1],["C677","RM","CICILIANO",1],["C678","CR","CICOGNOLO",1],["C679","TO","CICONIO",1],["C680","VC","CIGLIANO",1],["C681","CN","CIGLIE'",1],["C682","BS","CIGNANO",0],["C683","CR","CIGNONE",0],["C684","PV","CIGOGNOLA",1],["C685","BS","CIGOLE",1],["C686","PV","CILAVEGNA",1],["Z603","EE","CILE",0],["C687","BS","CILIVERGHE",0],["C688","CO","CIMA",0],["C689","TV","CIMADOLMO",1],["C690","NO","CIMAMULERA",0],["C691","BS","CIMBERGO",1],["C692","BS","CIMBERGO-PASPARDO",0],["C693","MI","CIMBRO",0],["C694","TN","CIMEGO",0],["C695","RC","CIMINA'",1],["C696","PA","CIMINNA",1],["C697","NA","CIMITILE",1],["C698","BS","CIMMO",0],["C699","PN","CIMOLAIS",1],["C700","TN","CIMONE",1],["Z217","EE","CINA NAZIONALE",0],["Z210","EE","CINA REPUBBLICA POPOLARE",0],["C701","AT","CINAGLIO",1],["C702","RM","CINETO ROMANO",1],["C703","CR","CINGIA DE' BOTTI",1],["C704","MC","CINGOLI",1],["C705","GR","CINIGIANO",1],["C706","MI","CINISELLO",0],["C707","MI","CINISELLO BALSAMO",1],["C708","PA","CINISI",1],["C709","SO","CINO",1],["C710","RC","CINQUEFRONDI",1],["C711","TO","CINTANO",1],["C712","TN","CINTE TESINO",1],["C713","PD","CINTO",0],["C714","VE","CINTO",0],["C714","VE","CINTO CAOMAGGIORE",1],["C713","PD","CINTO EUGANEO",1],["C715","TO","CINZANO",1],["C716","CE","CIORLANO",1],["C717","CS","CIPOLLINA",0],["C718","IM","CIPRESSA",1],["Z211","EE","CIPRO",0],["C719","BN","CIRCELLO",1],["C720","GO","CIRCHINA",0],["C721","NO","CIREGGIO",0],["C722","TO","CIRIE'",1],["C723","MT","CIRIGLIANO",1],["C724","CO","CIRIMIDO",1],["C725","KR","CIRO'",1],["C726","CZ","CIRO' MARINA",0],["C726","KR","CIRO' MARINA",1],["C727","TN","CIS",1],["C728","BG","CISANO",0],["C729","GE","CISANO",0],["C728","BG","CISANO BERGAMASCO",1],["C729","SV","CISANO SUL NEVA",1],["C730","BG","CISERANO",1],["C731","UD","CISERIIS",0],["Z367","EE","CISKEI",0],["C732","VA","CISLAGO",1],["C733","MI","CISLIANO",1],["C734","VI","CISMON",0],["C734","VI","CISMON DEL GRAPPA",0],["C735","TV","CISON",0],["C735","TV","CISON DI VALMARINO",1],["C736","NO","CISORE",0],["C737","BZ","CISSICO",0],["C738","CN","CISSONE",1],["C188","NA","CISTERNA",0],["C739","AL","CISTERNA",0],["C740","RM","CISTERNA",0],["C739","AT","CISTERNA D'ASTI",1],["C740","LT","CISTERNA DI LATINA",1],["C740","LT","CISTERNA DI LITTORIA",0],["C740","LT","CISTERNA DI ROMA",0],["C741","BR","CISTERNINO",1],["C742","PG","CITERNA",1],["Z106","EE","CITTA' DEL VATICANO",0],["C744","PG","CITTA' DELLA PIEVE",1],["C745","PG","CITTA' DI CASTELLO",1],["C750","PE","CITTA' SANT'ANGELO",1],["C743","PD","CITTADELLA",1],["C746","RI","CITTADUCALE",1],["C747","RC","CITTANOVA",1],["C748","PL","CITTANOVA D'ISTRIA",0],["C749","RI","CITTAREALE",1],["C751","VA","CITTIGLIO",1],["C752","LC","CIVATE",1],["C753","CO","CIVELLO",0],["C754","CO","CIVENNA",0],["C755","IM","CIVEZZA",1],["C756","TN","CIVEZZANO",1],["C757","VC","CIVIASCO",1],["C758","UD","CIVIDALE DEL FRIULI",1],["C759","BG","CIVIDATE",0],["C759","BG","CIVIDATE AL PIANO",1],["C760","BS","CIVIDATE CAMUNO",1],["C761","BS","CIVIDATE-MALEGNO",0],["C762","CO","CIVIGLIO",0],["C763","CS","CIVITA",1],["C765","VT","CIVITA CASTELLANA",1],["C766","AQ","CIVITA D'ANTINO",1],["C767","RM","CIVITA LAVINIA",0],["C764","CB","CIVITACAMPOMARANO",1],["C760","BS","CIVITADE",0],["C760","BS","CIVITADE ALPINO",0],["C768","CH","CIVITALUPARELLA",1],["C769","CB","CIVITANOVA",0],["C770","MC","CIVITANOVA",0],["C769","IS","CIVITANOVA DEL SANNIO",1],["C770","MC","CIVITANOVA MARCHE",1],["C771","PE","CIVITAQUANA",1],["C772","CB","CIVITAVECCHIA",0],["C773","RM","CIVITAVECCHIA",1],["A749","RM","CIVITELLA",0],["C774","AR","CIVITELLA",0],["C775","BN","CIVITELLA",0],["C776","CH","CIVITELLA",0],["C777","FC","CIVITELLA",0],["C778","AQ","CIVITELLA ALFEDENA",1],["C779","PE","CIVITELLA CASANOVA",1],["C780","VT","CIVITELLA D'AGLIANO",1],["C781","TE","CIVITELLA DEL TRONTO",1],["C777","FC","CIVITELLA DI ROMAGNA",1],["C774","AR","CIVITELLA IN VAL DI CHIANA",1],["C775","BN","CIVITELLA LICINIO",0],["C776","CH","CIVITELLA MESSER RAIMONDO",1],["C782","GR","CIVITELLA PAGANICO",1],["C783","AQ","CIVITELLA ROVETO",1],["C784","RM","CIVITELLA SAN PAOLO",1],["A749","RM","CIVITELLA SAN SISTO",0],["C785","SO","CIVO",1],["C786","BS","CIZZAGO",0],["C787","CO","CLAINO CON OSTENO",1],["C788","FM","CLANA",0],["C789","BG","CLANEZZO",0],["C790","PN","CLAUT",1],["C791","PN","CLAUZETTO",1],["C792","CN","CLAVESANA",1],["C793","TO","CLAVIERE",1],["C793","TO","CLAVIERES",0],["C794","TN","CLES",1],["C795","CS","CLETO",1],["C796","VA","CLIVIO",1],["C797","TN","CLOZ",0],["C798","BS","CLUSANE",0],["C798","BS","CLUSANE SUL LAGO",0],["C799","BZ","CLUSIO",0],["C800","BG","CLUSONE",1],["C801","TO","COASSOLO",0],["C801","TO","COASSOLO TORINESE",1],["C802","MI","COAZZANO",0],["C803","TO","COAZZE",1],["C804","AT","COAZZOLO",1],["C805","GO","COBBIA",0],["C806","BS","COCCAGLIO",1],["C807","AT","COCCONATO",1],["C808","AL","COCCONITO",0],["Z212","EE","COCOS (ISOLE)",0],["C809","VA","COCQUIO",0],["C810","VA","COCQUIO-TREVISAGO",1],["C811","AQ","COCULLO",1],["C812","PD","CODEVIGO",1],["C813","PV","CODEVILLA",1],["C814","FE","CODIGORO",1],["C815","TV","CODOGNE'",1],["C816","LO","CODOGNO",1],["C817","UD","CODROIPO",1],["C818","SS","CODRONGIANOS",1],["C818","SS","CODRONGIANUS",0],["C819","BI","COGGIOLA",1],["C820","MB","COGLIATE",1],["C820","MI","COGLIATE",0],["C821","AO","COGNE",1],["C822","TN","COGNOLA",0],["C823","GE","COGOLETO",1],["C824","VI","COGOLLO",0],["C824","VI","COGOLLO DEL CENGIO",1],["C825","TN","COGOLO",0],["C826","GE","COGORNO",1],["C827","NO","COIMO",0],["C828","NO","COIRO",0],["C828","NO","COIROMONTE",0],["C906","TO","COL SAN GIOVANNI",0],["C829","NO","COLAZZA",1],["C830","PU","COLBORDOLO",0],["C831","AT","COLCAVAGNO",0],["M426","VI","COLCERESA",1],["C832","CO","COLCIAGO",0],["C833","BZ","COLDERANO",0],["C834","IM","COLDIRODI",0],["C833","BZ","COLDRANO",0],["C835","BG","COLERE",1],["C836","FR","COLFELICE",1],["C837","BZ","COLFOSCO",0],["C838","PC","COLI",1],["C839","LC","COLICO",1],["C834","IM","COLLA",0],["C840","RE","COLLAGNA",0],["C841","PG","COLLALTO",0],["C842","UD","COLLALTO",0],["C842","UD","COLLALTO DELLA SOIMA",0],["C841","RI","COLLALTO SABINO",1],["C844","AQ","COLLARMELE",1],["C845","PG","COLLAZZONE",1],["C846","BN","COLLE",0],["C847","SI","COLLE",0],["C848","TV","COLLE",0],["C851","LC","COLLE BRIANZA",1],["C854","CB","COLLE D'ANCHISE",1],["C857","RI","COLLE DI TORA",1],["C847","SI","COLLE DI VAL D'ELSA",1],["C861","BZ","COLLE IN CASIES",0],["M306","BZ","COLLE ISARCO",0],["C870","FR","COLLE SAN MAGNO",1],["C846","BN","COLLE SANNITA",1],["C872","BL","COLLE SANTA LUCIA",1],["C848","TV","COLLE UMBERTO",1],["C849","PG","COLLEBACCARO",0],["C850","BS","COLLEBEATO",1],["C852","PR","COLLECCHIO",1],["C853","PE","COLLECORVINO",1],["C311","TE","COLLEDARA",1],["C855","CH","COLLEDIMACINE",1],["C856","CH","COLLEDIMEZZO",1],["C858","RM","COLLEFERRO",1],["C859","RI","COLLEGIOVE",1],["C860","TO","COLLEGNO",1],["C862","AQ","COLLELONGO",1],["C863","PG","COLLEMANCIO",0],["C864","FR","COLLEPARDO",1],["C865","LE","COLLEPASSO",1],["C866","AQ","COLLEPIETRO",1],["C867","TO","COLLERETTO CASTELNUOVO",1],["C868","TO","COLLERETTO GIACOSA",1],["C868","TO","COLLERETTO PARELLA",0],["C869","LI","COLLESALVETTI",1],["C871","PA","COLLESANO",1],["C873","TR","COLLESCIPOLI",0],["C874","TR","COLLESTATTE",0],["C875","CB","COLLETORTO",1],["C876","RI","COLLEVECCHIO",1],["C877","AP","COLLI",0],["C878","CB","COLLI",0],["C878","IS","COLLI A VOLTURNO",1],["M380","PU","COLLI AL METAURO",1],["C877","AP","COLLI DEL TRONTO",1],["C880","RI","COLLI DI LABRO",0],["C881","BZ","COLLI IN PUSTERIA",0],["C880","RI","COLLI SUL VELINO",1],["M419","PV","COLLI VERDI",1],["C879","SA","COLLIANO",1],["C882","CA","COLLINAS",0],["C882","SU","COLLINAS",1],["C883","BS","COLLIO",1],["C884","VC","COLLOBIANO",1],["C885","UD","COLLOREDO DI MONTE ALBANO",1],["C886","MC","COLMURANO",1],["C887","MI","COLNAGO",0],["C888","MT","COLOBRARO",1],["C889","CO","COLOGNA",0],["C890","VR","COLOGNA",0],["C892","TN","COLOGNA",0],["C891","TN","COLOGNA CAVAZZO",0],["C890","VR","COLOGNA VENETA",1],["C893","BS","COLOGNE",1],["B899","MI","COLOGNO",0],["C894","BG","COLOGNO",0],["C895","MI","COLOGNO",0],["C894","BG","COLOGNO AL SERIO",1],["C895","MI","COLOGNO MONZESE",1],["C896","BG","COLOGNOLA",0],["C897","VR","COLOGNOLA",0],["C897","VR","COLOGNOLA AI COLLI",1],["C896","BG","COLOGNOLA DEL PIANO",0],["C898","BS","COLOMBARO",0],["C899","CR","COLOMBAROLO",0],["Z604","EE","COLOMBIA",0],["C900","RM","COLONNA",1],["C901","TE","COLONNELLA",1],["C902","CO","COLONNO",1],["C903","SO","COLORINA",1],["C904","PR","COLORNO",1],["C905","CS","COLOSIMI",1],["C907","BZ","COLSANO",0],["C908","MI","COLTURANO",1],["M336","CO","COLVERDE",1],["C909","MI","COLZANO",0],["C910","BG","COLZATE",1],["C911","VA","COMABBIO",1],["C912","FE","COMACCHIO",1],["C913","PV","COMAIRANO",0],["C914","MS","COMANO",1],["C915","TN","COMANO",0],["M314","TN","COMANO TERME",1],["C916","TN","COMASINE",0],["C917","LO","COMAZZO",1],["C918","UD","COMEGLIANS",1],["C919","BL","COMELICO INFERIORE",0],["C920","BL","COMELICO SUPERIORE",1],["C921","GO","COMENO",0],["C922","VA","COMERIO",1],["C923","BS","COMERO",0],["C924","BS","COMEZZANO",0],["C925","BS","COMEZZANO-CIZZAGO",1],["M227","TN","COMIGHELLO",0],["C926","NO","COMIGNAGO",1],["C927","RG","COMISO",1],["C928","AG","COMITINI",1],["C929","NA","COMIZIANO",1],["C930","MN","COMMESSAGGIO",1],["C931","TN","COMMEZZADURA",1],["C932","NO","COMNAGO",0],["C933","CO","COMO",1],["Z310","EE","COMORE",0],["Z310","EE","COMORE (ISOLE)",0],["C934","PR","COMPIANO",1],["C937","BG","COMUN NUOVO",1],["C935","AP","COMUNANZA",1],["C935","AP","COMUNANZA DEL LITTORIO",0],["C936","CO","COMUNE DELLA VALSOLDA",0],["C938","VE","CONA",1],["C939","CE","CONCA",0],["C940","SA","CONCA",0],["C941","IS","CONCA CASALE",1],["C940","SA","CONCA DEI MARINI",1],["C939","CE","CONCA DELLA CAMPANIA",1],["C940","SA","CONCA MARINI",0],["C942","RO","CONCADIRAME",0],["C943","VR","CONCAMARISE",1],["C944","TN","CONCEI",0],["C945","CO","CONCENEDO",0],["C946","RI","CONCERVIANO",1],["C947","MI","CONCESA",0],["C948","BS","CONCESIO",1],["C949","VI","CONCO",0],["C950","VE","CONCORDIA",0],["C950","VE","CONCORDIA SAGITARIA",0],["C950","VE","CONCORDIA SAGITTARIA",1],["C951","MO","CONCORDIA SULLA SECCHIA",1],["C952","MB","CONCOREZZO",1],["C952","MI","CONCOREZZO",0],["C953","TN","CONDINO",0],["C954","RC","CONDOFURI",1],["C955","TO","CONDOVE",1],["C956","ME","CONDRO'",1],["C957","TV","CONEGLIANO",1],["C958","PV","CONFIENZA",1],["C959","RI","CONFIGNI",1],["C960","CZ","CONFLENTI",1],["Z311","EE","CONGO BRAZZAVILLE",0],["Z312","EE","CONGO LEOPOLDVILLE",0],["Z312","EE","CONGO REPUBBLICA DEMOCRATICA",0],["Z311","EE","CONGO REPUBBLICA POPOLARE",0],["C961","IM","CONIO",0],["C962","AL","CONIOLO",1],["C963","RA","CONSELICE",1],["C964","PD","CONSELVE",1],["C965","CO","CONSIGLIO DI RUMO",0],["C966","CO","CONSONNO",0],["M356","TN","CONTA'",1],["C967","RO","CONTARINA",0],["C967","TV","CONTARINA",0],["C968","PA","CONTESSA",0],["C968","PA","CONTESSA ENTELLINA",1],["C969","RI","CONTIGLIANO",1],["C970","CO","CONTRA",0],["C971","AV","CONTRADA",1],["C972","TE","CONTROGUERRA",1],["C973","SA","CONTRONE",1],["C974","SA","CONTURSI TERME",1],["C975","BA","CONVERSANO",1],["C976","AV","CONZA DELLA CAMPANIA",1],["C977","AL","CONZANO",1],["Z703","EE","COOK (ISOLE)",0],["C978","LE","COPERTINO",1],["C979","PV","COPIANO",1],["C980","FE","COPPARO",1],["C981","MI","COPRENO",0],["C982","PV","CORANA",1],["C983","BA","CORATO",1],["C984","SA","CORBARA",1],["C985","PV","CORBESATE",0],["C986","MI","CORBETTA",1],["C987","RO","CORBOLA",1],["D083","BZ","CORCES",0],["C988","VT","CORCHIANO",1],["C989","NO","CORCIAGO",0],["C990","PG","CORCIANO",1],["C991","PN","CORDENONS",1],["C992","TV","CORDIGNANO",1],["C993","PN","CORDOVADO",1],["Z214","EE","COREA DEL NORD",0],["Z213","EE","COREA DEL SUD",0],["C994","TN","COREDO",0],["C995","GE","COREGLIA",0],["C996","LU","COREGLIA",0],["C996","LU","COREGLIA ANTELMINELLI",1],["C995","GE","COREGLIA DI FONTANABUONA",0],["C995","GE","COREGLIA LIGURE",1],["C997","CO","CORENNO",0],["C997","CO","CORENNO PLINIO",0],["C998","FR","CORENO",0],["C998","FR","CORENO AUSONIO",1],["C999","AQ","CORFINIO",1],["D001","MI","CORGENO",0],["D002","TS","CORGNALE",0],["D003","LT","CORI",1],["D004","RN","CORIANO",1],["D005","CS","CORIGLIANO",0],["D006","LE","CORIGLIANO",0],["D005","CS","CORIGLIANO CALABRO",0],["D006","LE","CORIGLIANO D'OTRANTO",1],["M403","CS","CORIGLIANO-ROSSANO",1],["D007","AN","CORINALDO",1],["D008","TO","CORIO",1],["D009","PA","CORLEONE",1],["D010","PZ","CORLETO",0],["D011","SA","CORLETO",0],["D011","SA","CORLETO MONFORTE",1],["D010","PZ","CORLETO PERTICARA",1],["D012","AO","CORMAIORE",0],["D013","MI","CORMANO",1],["D014","GO","CORMONS",1],["D015","BG","CORNA IMAGNA",1],["D016","BG","CORNALBA",1],["D017","PV","CORNALE",0],["M338","PV","CORNALE E BASTIDA",1],["D018","MI","CORNAREDO",1],["D019","MI","CORNATE",0],["D019","MB","CORNATE D'ADDA",1],["D019","MI","CORNATE D'ADDA",0],["B799","BZ","CORNEDO",0],["D020","VI","CORNEDO",0],["B799","BZ","CORNEDO ALL'ISARCO",1],["D020","VI","CORNEDO VICENTINO",1],["D021","MI","CORNEGLIANO",0],["D021","LO","CORNEGLIANO LAUDENSE",1],["D022","CN","CORNELIANO",0],["D023","MI","CORNELIANO",0],["D023","MI","CORNELIANO BERTARIO",0],["D022","CN","CORNELIANO D'ALBA",1],["D024","RM","CORNETO",0],["D024","RM","CORNETO TARQUINIA",0],["D025","GE","CORNIGLIANO",0],["D025","GE","CORNIGLIANO LIGURE",0],["D026","PR","CORNIGLIO",1],["D027","UD","CORNO DI ROSAZZO",1],["D028","LO","CORNO GIOVINE",1],["D029","LO","CORNOVECCHIO",1],["D030","TV","CORNUDA",1],["D031","GO","CORONA",0],["D032","BZ","CORONA ALLA MUTA",0],["D033","MI","CORONATE",0],["D034","CR","CORPI SANTI DI CREMONA",0],["D035","MI","CORPI SANTI DI MILANO",0],["D036","PV","CORPI SANTI DI PAVIA",0],["D037","RE","CORREGGIO",1],["D038","MB","CORREZZANA",1],["D038","MI","CORREZZANA",0],["D039","VR","CORREZZO",0],["D040","PD","CORREZZOLA",1],["D041","CO","CORRIDO",1],["D042","MC","CORRIDONIA",1],["D043","TE","CORROPOLI",1],["D044","LE","CORSANO",1],["D045","MI","CORSICO",1],["D046","AT","CORSIONE",1],["D047","CO","CORTABBIO",0],["D048","BZ","CORTACCIA",0],["D048","BZ","CORTACCIA SULLA STRADA DEL VINO",1],["D049","CZ","CORTALE",1],["D050","AT","CORTANDONE",1],["D051","AT","CORTANZE",1],["D052","AT","CORTAZZONE",1],["D053","BG","CORTE",0],["D054","PC","CORTE BRUGNATELLA",1],["D055","CR","CORTE DE' CORTESI",0],["D056","CR","CORTE DE' CORTESI CON CIGNONE",1],["D057","CR","CORTE DE' FRATI",1],["D058","BS","CORTE FRANCA",1],["D059","BZ","CORTE IN PUSTERIA",0],["D060","CR","CORTE MADAMA",0],["D068","LO","CORTE PALASIO",1],["D070","MI","CORTE SANT'ANDREA",0],["D061","PC","CORTEMAGGIORE",1],["D062","CN","CORTEMILIA",1],["D063","BS","CORTENEDOLO",0],["D064","BS","CORTENO",0],["D064","BS","CORTENO GOLGI",1],["D065","LC","CORTENOVA",1],["D066","BG","CORTENUOVA",1],["D067","PV","CORTEOLONA",0],["M372","PV","CORTEOLONA E GENZONE",1],["D069","AL","CORTERANZO",0],["D071","CR","CORTETANO",0],["D059","BZ","CORTI IN PUSTERIA",0],["D072","AL","CORTICELLE",0],["D073","BS","CORTICELLE",0],["D073","BS","CORTICELLE PIEVE",0],["D072","AT","CORTIGLIONE",1],["D074","PR","CORTILE SAN MARTINO",0],["D075","BZ","CORTINA ALL'ADIGE",0],["A266","BL","CORTINA D'AMPEZZO",1],["D075","BZ","CORTINA SULLA STRADA DEL VINO",1],["D076","TE","CORTINO",1],["D077","AR","CORTONA",1],["D078","PE","CORVARA",1],["D079","BZ","CORVARA IN BADIA",1],["D080","BZ","CORVARA IN PASSIRIA",0],["D081","PV","CORVINO",0],["D081","PV","CORVINO SAN QUIRICO",1],["D082","BS","CORZANO",1],["D084","GO","COSBANA",0],["D084","GO","COSBANA NEL COLLIO",0],["D085","UD","COSEANO",1],["D086","CS","COSENZA",1],["D087","IM","COSIO",0],["D088","SO","COSIO",0],["D087","IM","COSIO D'ARROSCIA",1],["D088","SO","COSIO VALTELLINO",1],["D089","RC","COSOLETO",1],["D090","TS","COSSANA",0],["D091","CO","COSSANO",0],["D092","TO","COSSANO",0],["D093","CN","COSSANO BELBO",1],["D092","TO","COSSANO CANAVESE",1],["D094","BI","COSSATO",1],["D095","SV","COSSERIA",1],["D096","AP","COSSIGNANO",1],["D097","VC","COSSILA",0],["D098","BS","COSSIRANO",0],["D099","VB","COSSOGNO",1],["D100","SS","COSSOINE",1],["D101","AT","COSSOMBRATO",1],["D102","AL","COSTA",0],["D103","BG","COSTA",0],["D104","IM","COSTA",0],["D105","RO","COSTA",0],["D106","MI","COSTA AL LAMBRO",0],["Z313","EE","COSTA D'AVORIO",0],["D109","PV","COSTA DE' NOBILI",1],["Z215","EE","COSTA DEI PIRATI=TRUCIAL STATES",0],["D110","BG","COSTA DI MEZZATE",1],["D110","BG","COSTA DI MONTICELLI",0],["D104","IM","COSTA DI ONEGLIA",0],["D105","RO","COSTA DI ROVIGO",1],["D111","BG","COSTA DI SERINA",0],["D106","MI","COSTA LOMBARDA",0],["D112","LC","COSTA MASNAGA",1],["D114","IM","COSTA RAINERA",0],["Z503","EE","COSTA RICA",0],["D109","PV","COSTA SAN ZENONE",0],["D115","CR","COSTA SANT'ABRAMO",0],["D111","BG","COSTA SERINA",1],["D103","BG","COSTA VALLE IMAGNA",1],["D102","AL","COSTA VESCOVATO",1],["D117","BG","COSTA VOLPINO",1],["D107","VI","COSTABISSARA",1],["D108","PG","COSTACCIARO",1],["D113","VC","COSTANZANA",1],["D114","IM","COSTARAINERA",1],["D116","TN","COSTASAVINA",0],["D118","VR","COSTERMANO",0],["D118","VR","COSTERMANO SUL GARDA",1],["D119","AT","COSTIGLIOLE D'ASTI",1],["D120","CN","COSTIGLIOLE SALUZZO",1],["D121","RA","COTIGNOLA",1],["D122","CZ","COTRONE",0],["D123","KR","COTRONEI",1],["D124","RI","COTTANELLO",1],["D012","AO","COURMAYEUR",1],["C401","BZ","COVELANO",0],["D125","TN","COVELO",0],["D126","BG","COVO",1],["D127","PV","COZZO",1],["D128","MT","CRACO",1],["D129","NO","CRANA",0],["D130","NO","CRANA CATTUGNO",0],["D131","CO","CRANDOLA",0],["D131","LC","CRANDOLA VALSASSINA",1],["D132","VC","CRAVAGLIANA",1],["D133","CN","CRAVANZANA",1],["D134","VB","CRAVEGGIA",1],["D135","NO","CRAVEGNA",0],["D136","VI","CREAZZO",1],["D137","CH","CRECCHIO",1],["D138","GO","CREDA",0],["D139","BG","CREDARO",1],["D140","CR","CREDERA",0],["M252","CR","CREDERA CON ROVERETO",0],["D141","CR","CREDERA RUBBIANO",1],["D142","CR","CREMA",1],["D143","LC","CREMELLA",1],["D144","VA","CREMENAGA",1],["D145","LC","CREMENO",1],["D146","BS","CREMEZZANO",0],["D147","CO","CREMIA",1],["D148","CO","CREMNAGO",0],["D149","AL","CREMOLINO",1],["D150","CR","CREMONA",1],["D150","CR","CREMONA ED UNITI",0],["D151","CR","CREMOSANO",1],["D152","VA","CRENNA",0],["D153","TS","CRENOVIZZA",0],["D154","VC","CRESCENTINO",1],["D155","MI","CRESCENZAGO",0],["D156","VI","CRESPADORO",1],["D157","TV","CRESPANO",0],["D157","TV","CRESPANO DEL GRAPPA",0],["D157","TV","CRESPANO VENETO",0],["D158","BO","CRESPELLANO",0],["D159","LO","CRESPIATICA",1],["D160","PI","CRESPINA",0],["M328","PI","CRESPINA LORENZANA",1],["D161","RO","CRESPINO",1],["D162","NO","CRESSA",1],["D163","CO","CRESSOGNO",0],["D164","TN","CRETO",0],["D165","BI","CREVACUORE",1],["D166","BO","CREVALCORE",1],["D167","CO","CREVENNA",0],["D168","NO","CREVOLA",0],["D169","VC","CREVOLA",0],["D168","NO","CREVOLA D'OSSOLA",0],["D169","VC","CREVOLA SESIA",0],["D168","VB","CREVOLADOSSOLA",1],["D170","NA","CRISPANO",1],["D171","TA","CRISPIANO",1],["D172","CN","CRISSOLO",1],["Z149","EE","CROAZIA",0],["D173","CO","CROCE",0],["D174","VC","CROCE DI MOSSO",0],["D175","GE","CROCEFIESCHI",1],["D176","RO","CROCETTA",0],["C670","TV","CROCETTA DEL MONTELLO",1],["C670","TV","CROCETTA TREVIGIANA",0],["D177","VB","CRODO",1],["D177","NO","CRODO MOZZIO",0],["D178","TE","CROGNALETO",0],["D179","TE","CROGNALETO",1],["D179","CS","CROPALATI",0],["D180","CS","CROPALATI",1],["D180","CZ","CROPANI",0],["D181","CZ","CROPANI",1],["D182","BI","CROSA",0],["D183","VI","CROSARA",0],["D184","CS","CROSIA",1],["D185","VA","CROSIO DELLA VALLE",1],["D122","KR","CROTONE",1],["D186","CR","CROTTA D'ADDA",1],["D187","VC","CROVA",1],["D188","TN","CROVIANA",1],["D189","KR","CRUCOLI",1],["D190","MI","CRUGNOLA",0],["D191","NO","CRUSINALLO",0],["D192","VA","CUASSO AL MONTE",1],["Z504","EE","CUBA",0],["D193","VR","CUCCA",0],["D194","AL","CUCCARO",0],["D195","SA","CUCCARO",0],["D194","AL","CUCCARO MONFERRATO",0],["D195","SA","CUCCARO VETERE",1],["D196","CO","CUCCIAGO",1],["D197","TO","CUCEGLIO",1],["D198","MI","CUGGIONO",1],["D199","VA","CUGLIATE",0],["D199","VA","CUGLIATE-FABIASCO",1],["D200","OR","CUGLIERI",1],["D201","PE","CUGNOLI",1],["C840","RE","CULAGNA",0],["D202","TO","CUMIANA",1],["C929","NA","CUMIGNANO",0],["D203","CR","CUMIGNANO",0],["C929","NA","CUMIGNANO E GALLO DI NOLA",0],["D203","CR","CUMIGNANO SUL NAVIGLIO",1],["D204","VA","CUNARDO",1],["D205","CN","CUNEO",1],["D206","TN","CUNEVO",0],["D207","AT","CUNICO",1],["D208","TO","CUORGNE'",1],["D209","CH","CUPELLO",1],["D210","AP","CUPRA MARITTIMA",1],["D211","AN","CUPRAMONTANA",1],["D212","AL","CUQUELLO",0],["B824","PV","CURA CARPIGNANO",1],["D213","BZ","CURACES",0],["D214","OR","CURCURIS",1],["D215","BG","CURDOMO",0],["D216","NO","CUREGGIO",1],["D217","VA","CURIGLIA",0],["D217","VA","CURIGLIA CON MONTEVIASCO",1],["D218","CZ","CURINGA",1],["D219","BI","CURINO",1],["D220","BG","CURNASCO",0],["D221","BG","CURNO",1],["D032","BZ","CURON",0],["D222","BZ","CURON VENOSTA",1],["D223","LE","CURSI",1],["D224","NO","CURSOLO",0],["D225","VB","CURSOLO-ORASSO",0],["D226","PD","CURTAROLO",1],["D227","MN","CURTATONE",1],["D228","CE","CURTI",1],["D229","MI","CUSAGO",1],["D230","BN","CUSANO",0],["D231","MI","CUSANO",0],["D231","MI","CUSANO MILANINO",1],["D230","BN","CUSANO MUTRI",1],["D231","MI","CUSANO SUL SEVESO",0],["D232","CO","CUSINO",1],["D233","BG","CUSIO",1],["D234","TP","CUSTONACI",1],["D235","PT","CUTIGLIANO",0],["D236","KR","CUTRO",1],["D237","LE","CUTROFIANO",1],["D238","VA","CUVEGLIO",1],["D238","VA","CUVEGLIO IN VALLE",0],["D239","VA","CUVIO",1],["D240","MI","CUVIRONE",0],["D241","NO","CUZZAGO",0],["D242","NO","DAGNENTE",0],["Z314","EE","DAHOMEY=BENIN",0],["D243","TN","DAIANO",0],["D244","MI","DAIRAGO",1],["D245","BG","DALMINE",1],["D246","TN","DAMBEL",1],["Z107","EE","DANIMARCA",0],["D247","BL","DANTA",0],["D247","BL","DANTA DI CADORE",1],["D248","TN","DAONE",0],["D249","TN","DARDINE",0],["D250","TN","DARE'",0],["D251","BS","DARFO",0],["D251","BS","DARFO BOARIO TERME",1],["D252","TN","DARZO",0],["D253","VV","DASA'",1],["M228","TN","DASINDO",0],["D254","CO","DASIO",0],["D255","GE","DAVAGNA",1],["D256","VA","DAVERIO",1],["D257","CZ","DAVOLI",1],["D258","SO","DAZIO",1],["D259","CA","DECIMOMANNU",1],["D260","CA","DECIMOPUTZU",0],["D260","SU","DECIMOPUTZU",1],["D261","CZ","DECOLLATURA",1],["D262","BS","DEGAGNA",0],["D263","TN","DEGGIANO",0],["D264","SV","DEGO",1],["D265","SP","DEIVA",0],["D265","SP","DEIVA MARINA",1],["D266","SO","DELEBIO",1],["D267","CL","DELIA",1],["D268","RC","DELIANUOVA",1],["D269","FG","DELICETO",1],["D270","BS","DELLO",1],["D271","CN","DEMONTE",1],["D272","AL","DENICE",1],["D273","TN","DENNO",1],["D274","TN","DERCOLO",0],["D275","MI","DERGANO",0],["D276","TN","DERMULO",0],["D277","AL","DERNICE",1],["D278","CR","DEROVERE",1],["D279","PG","DERUTA",1],["D280","LC","DERVIO",1],["D281","VC","DESANA",1],["D282","GO","DESCLA",0],["D283","BG","DESENZANO",0],["D284","BS","DESENZANO",0],["D283","BG","DESENZANO AL SERIO",0],["D284","BS","DESENZANO DEL GARDA",1],["D284","BS","DESENZANO SUL LAGO",0],["D285","TO","DESERTES",0],["D286","MB","DESIO",1],["D286","MI","DESIO",0],["D287","NU","DESULO",1],["D288","BG","DEZZO DI SCALVE",0],["D289","CS","DIAMANTE",1],["D290","CS","DIANO",0],["D291","CN","DIANO",0],["D292","SA","DIANO",0],["D293","IM","DIANO ARENTINO",1],["D294","IM","DIANO BORELLO",0],["D295","IM","DIANO CALDERINA",0],["D296","IM","DIANO CASTELLO",1],["D291","CN","DIANO D'ALBA",1],["D297","IM","DIANO MARINA",1],["D298","IM","DIANO SAN PIETRO",1],["D299","FI","DICOMANO",1],["D300","UD","DIGNANO",1],["D301","PL","DIGNANO D'ISTRIA",0],["D302","TN","DIMARO",0],["M366","TN","DIMARO FOLGARIDA",1],["D303","VV","DINAMI",1],["Z900","EE","DIPENDENZE AUSTRALIANE",0],["Z901","EE","DIPENDENZE BRITANNICHE",0],["Z800","EE","DIPENDENZE CANADESI",0],["Z902","EE","DIPENDENZE FRANCESI",0],["Z903","EE","DIPENDENZE NEOZELANDESI",0],["Z904","EE","DIPENDENZE NORVEGESI ANTARTICHE",0],["Z801","EE","DIPENDENZE NORVEGESI ARTICHE",0],["Z802","EE","DIPENDENZE RUSSE",0],["Z802","EE","DIPENDENZE SOVIETICHE",0],["Z905","EE","DIPENDENZE STATUNITENSI",0],["Z906","EE","DIPENDENZE SUDAFRICANE",0],["D304","CS","DIPIGNANO",1],["D305","LE","DISO",1],["D306","NO","DISSIMO",0],["D307","TS","DIVACCIA GROTTE DEL TIMAVO",0],["D308","TS","DIVACCIA SAN CANZIANO",0],["D309","NO","DIVIGNANO",1],["D310","CO","DIZZASCO",1],["D311","BZ","DOBBIACO",1],["D312","GO","DOBERDO'",0],["D312","GO","DOBERDO' DEL LAGO",1],["D313","VC","DOCCIO",0],["D314","CN","DOGLIANI",1],["D315","CH","DOGLIOLA",1],["D316","UD","DOGNA",1],["D322","GO","DOL GRANDE",0],["D326","GO","DOL OTTELZA",0],["D317","VR","DOLCE'",1],["D318","IM","DOLCEACQUA",1],["D319","IM","DOLCEDO",1],["D320","GO","DOLE",0],["D321","GO","DOLEGNA",0],["D321","GO","DOLEGNA DEL COLLIO",1],["D323","CA","DOLIANOVA",0],["D323","SU","DOLIANOVA",1],["D324","TS","DOLINA",0],["D325","VE","DOLO",1],["D327","LC","DOLZAGO",1],["D328","CS","DOMANICO",1],["D329","CO","DOMASO",1],["D330","BL","DOMEGGE",0],["D330","BL","DOMEGGE DI CADORE",1],["D331","AV","DOMICELLA",1],["Z526","EE","DOMINICA",0],["Z505","EE","DOMINICANA REPUBBLICA",0],["D332","VB","DOMODOSSOLA",1],["D333","CA","DOMUS DE MARIA",0],["D333","SU","DOMUS DE MARIA",1],["D334","CA","DOMUSNOVAS",0],["D334","SU","DOMUSNOVAS",1],["D335","CA","DOMUSNOVAS CANALES",0],["D336","TN","DON",0],["D337","RO","DONADA",0],["D338","AO","DONAS",0],["D339","BI","DONATO",1],["D340","PV","DONELASCO",0],["D341","CO","DONGO",1],["D342","CA","DONIGALA",0],["D343","CA","DONIGALA",0],["D342","CA","DONIGALA FENUGHEDU",0],["D343","CA","DONIGALA SIURGUS",0],["D338","AO","DONNAS",1],["D338","AO","DONNAZ",0],["D344","CA","DONORI",0],["D344","SU","DONORI",1],["D345","NU","DORGALI",1],["D346","LC","DORIO",1],["D347","NO","DORMELLETTO",1],["D348","PV","DORNO",1],["D349","TN","DORSINO",0],["D350","BI","DORZANO",1],["D351","MN","DOSOLO",1],["D352","BG","DOSSENA",1],["D353","CR","DOSSO BAROARDO",0],["D354","CR","DOSSO DE' FRATI",0],["D355","CO","DOSSO DEL LIRO",1],["D356","AO","DOUES",1],["D357","FC","DOVADOLA",1],["D358","CR","DOVERA",1],["D356","AO","DOVIA D'AOSTA",0],["D359","CO","DOZIO",0],["D360","BO","DOZZA",1],["D361","CE","DRAGONI",1],["D362","PL","DRAGUCCIO",0],["D363","CO","DRANO",0],["D364","VV","DRAPIA",1],["D365","TN","DRENA",1],["D366","UD","DRENCHIA",1],["D367","MI","DRESANO",1],["D368","GO","DRESENZA",0],["D369","CO","DREZZO",0],["D370","CR","DRIZZONA",0],["D371","TN","DRO",1],["D372","CN","DRONERO",1],["D373","TO","DRUENT",0],["D373","TO","DRUENTO",1],["D374","VB","DRUOGNO",1],["D375","AO","DRUSACCO",0],["D376","NU","DUALCHI",1],["D377","SO","DUBINO",1],["M300","PD","DUE CARRARE",1],["C318","AR","DUE COMUNI DI LATERINA",0],["D091","VA","DUE COSSANI",0],["D378","CR","DUEMIGLIA",0],["D379","VI","DUEVILLE",1],["D380","BN","DUGENTA",1],["D381","MI","DUGNANO",0],["D382","TS","DUINO",0],["D383","TS","DUINO AURISINA",1],["D383","TS","DUINO-AURISINA",0],["D384","VA","DUMENZA",1],["D385","VA","DUNO",1],["D386","BN","DURAZZANO",1],["C772","CB","DURONIA",1],["D387","AT","DUSINO",0],["D388","AT","DUSINO SAN MICHELE",1],["D389","TS","DUTTOGLIANO",0],["M229","TN","DUVREDO",0],["D390","SA","EBOLI",1],["Z605","EE","ECUADOR",0],["D391","BS","EDOLO",1],["Z336","EE","EGITTO",0],["D392","BZ","EGNA",1],["Z506","EE","EL SALVADOR",0],["D393","RM","ELENA",0],["D394","PE","ELICE",1],["D395","NU","ELINI",1],["D396","BZ","ELLE",0],["D397","SV","ELLERA",0],["D398","LC","ELLO",1],["D399","CA","ELMAS",1],["D400","FM","ELSANE",0],["D401","CN","ELVA",1],["D402","AO","EMARE'SE",0],["D402","AO","EMARESE",1],["Z215","EE","EMIRATI ARABI UNITI",0],["D403","FI","EMPOLI",1],["D404","BG","ENDENNA",0],["D405","BG","ENDINE",0],["D406","BG","ENDINE GAIANO",1],["D407","VI","ENEGO",1],["D408","UD","ENEMONZO",1],["D409","TN","ENGUISO",0],["C342","EN","ENNA",1],["D410","CN","ENTRACQUE",1],["D410","CN","ENTRAQUE",0],["D411","BG","ENTRATICO",1],["D412","CN","ENVIE",1],["D413","BZ","EORES",0],["D414","PZ","EPISCOPIA",1],["D415","VE","ERACLEA",1],["D416","CO","ERBA",1],["D417","CO","ERBA INCINO",0],["D418","BS","ERBANNO",0],["D419","VR","ERBE'",1],["D420","VR","ERBEZZO",1],["D421","BS","ERBUSCO",1],["D422","BR","ERCHIE",1],["H243","NA","ERCOLANO",1],["D423","TP","ERICE",1],["Z368","EE","ERITREA",0],["D424","SV","ERLI",1],["D425","PL","ERPELLE-COSINA",0],["D427","GO","ERSEL IN MONTE",0],["D426","PN","ERTO E CASSO",1],["M292","SS","ERULA",1],["D428","LC","ERVE",1],["D429","MC","ESANATOGLIA",1],["D430","NU","ESCALAPLANO",0],["D430","SU","ESCALAPLANO",1],["D431","NU","ESCOLCA",0],["D431","SU","ESCOLCA",1],["D432","CA","ESCOVEDU",0],["D433","TO","ESILLE",0],["D434","BS","ESINE",1],["D435","CO","ESINO INFERIORE",0],["D436","LC","ESINO LARIO",1],["D437","CO","ESINO SUPERIORE",0],["D438","NO","ESIO",0],["D439","BG","ESMATE",0],["D440","FR","ESPERIA",1],["D441","SS","ESPORLATU",1],["D442","PD","ESTE",1],["D443","NU","ESTERZILI",0],["D443","SU","ESTERZILI",1],["Z144","EE","ESTONIA",0],["Z315","EE","ETIOPIA",0],["D444","AO","ETROBLE",0],["D444","AO","ETROUBLES",1],["D445","CO","EUPILIO",1],["D433","TO","EXILLES",1],["D447","AL","FABBRICA",0],["D448","CO","FABBRICA",0],["D447","AL","FABBRICA CURONE",1],["D448","CO","FABBRICA DURINI",0],["D449","LU","FABBRICHE DI VALLICO",0],["M319","LU","FABBRICHE DI VERGEMOLI",1],["D450","RE","FABBRICO",1],["D446","VA","FABIASCO",0],["D451","AN","FABRIANO",1],["D452","RM","FABRICA",0],["D452","VT","FABRICA DI ROMA",1],["D453","VV","FABRIZIA",1],["D454","TR","FABRO",1],["D455","UD","FAEDIS",1],["D456","SO","FAEDO",0],["D457","TN","FAEDO",0],["D456","SO","FAEDO VALTELLINO",1],["D458","RA","FAENZA",1],["Z108","EE","FAER OER (ISOLE)",0],["D459","FG","FAETO",1],["D460","TO","FAETTO",0],["D461","UD","FAGAGNA",1],["D462","CO","FAGGETO LARIO",1],["D463","TA","FAGGIANO",1],["D464","CS","FAGNANO",0],["D465","AQ","FAGNANO",0],["D466","MI","FAGNANO",0],["D467","MI","FAGNANO",0],["D465","AQ","FAGNANO ALTO",1],["D464","CS","FAGNANO CASTELLO",1],["D467","VA","FAGNANO OLONA",1],["D466","MI","FAGNANO SUL NAVIGLIO",0],["D468","TN","FAI",0],["D468","TN","FAI DELLA PAGANELLA",1],["D469","BN","FAICCHIO",1],["D470","BL","FALCADE",1],["D471","CE","FALCIANO DEL MASSICO",1],["D472","AN","FALCONARA",0],["D473","CS","FALCONARA",0],["D473","CS","FALCONARA ALBANESE",1],["D472","AN","FALCONARA MARITTIMA",1],["D474","ME","FALCONE",1],["D475","VT","FALERIA",1],["D476","CZ","FALERNA",1],["D477","AP","FALERONE",0],["D477","FM","FALERONE",1],["D478","TN","FALESINA",0],["Z609","EE","FALKLAND (ISOLE)",0],["D479","CH","FALLASCOSO",0],["D480","CH","FALLO",1],["D481","VB","FALMENTA",0],["D482","CO","FALOPPIO",1],["D483","FR","FALVATERRA",1],["D484","BZ","FALZES",1],["D485","TS","FAMIE",0],["D486","MO","FANANO",1],["D487","PN","FANNA",1],["D488","PU","FANO",1],["D489","TE","FANO ADRIANO",1],["D519","BZ","FAOGNA DI SOTTO",0],["D490","BG","FARA",0],["D491","BG","FARA",0],["D492","NO","FARA",0],["D493","RI","FARA",0],["D490","BG","FARA D'ADDA",0],["D494","CH","FARA FILIORUM PETRI",1],["D490","BG","FARA GERA D'ADDA",1],["D493","RI","FARA IN SABINA",1],["D492","NO","FARA NOVARESE",1],["D491","BG","FARA OLIVANA CON SOLA",1],["D495","CH","FARA SAN MARTINO",1],["D496","VI","FARA VICENTINO",1],["D497","PZ","FARDELLA",1],["D498","BS","FARFENGO",0],["D499","CN","FARIGLIANO",1],["D500","CR","FARINATE",0],["D501","PE","FARINDOLA",1],["D502","PC","FARINI",1],["D502","PC","FARINI D'OLMO",0],["D503","VT","FARNESE",1],["D504","GO","FARRA",0],["D505","TV","FARRA",0],["D506","BL","FARRA D'ALPAGO",0],["D504","GO","FARRA D'ISONZO",1],["D505","TV","FARRA DI SOLIGO",1],["D507","PL","FASANA",0],["B348","RO","FASANA POLESINE",0],["D508","BR","FASANO",1],["D509","GE","FASCIA",1],["D510","PI","FAUGLIA",1],["D511","CN","FAULE",1],["D512","GE","FAVALE",0],["D513","PZ","FAVALE",0],["D512","GE","FAVALE DI MALVARO",1],["D513","PZ","FAVALE SAN CATULDO",0],["D514","AG","FAVARA",1],["D515","VE","FAVARO",0],["D515","VE","FAVARO VENETO",0],["D516","TN","FAVER",0],["D517","BS","FAVERZANO",0],["D518","TP","FAVIGNANA",1],["D519","BZ","FAVOGNA DI SOTTO",0],["D520","TO","FAVRIA",1],["D521","TO","FAVRIA-OGLIANICO",0],["M230","TN","FAVRIO",0],["D537","AO","FE'NIS",0],["Z154","EE","FEDERAZIONE RUSSA",0],["D290","CS","FEGGIANO",0],["D522","SV","FEGLINO",0],["D523","CN","FEISOGLIO",1],["D524","TO","FELETTO",1],["D525","UD","FELETTO",0],["D525","UD","FELETTO UMBERTO",0],["D526","PR","FELINO",1],["D527","SA","FELITTO",1],["D528","AL","FELIZZANO",1],["D529","MN","FELONICA",0],["D530","BL","FELTRE",1],["D531","CO","FENEGRO'",1],["D532","TO","FENESTRELLE",1],["D533","CR","FENGO",0],["D534","PU","FENIGLI",0],["D535","TO","FENILE",0],["D536","TO","FENILS",0],["D537","AO","FENIS",1],["D538","TR","FERENTILLO",1],["D539","FR","FERENTINO",1],["D540","SR","FERLA",1],["D541","PU","FERMIGNANO",1],["D542","AP","FERMO",0],["D542","FM","FERMO",1],["D543","VA","FERNO",1],["D544","CZ","FEROLETO ANTICO",1],["D545","RC","FEROLETO DELLA CHIESA",1],["D546","CZ","FEROLETO PIANO",0],["D547","MT","FERRANDINA",1],["D548","FE","FERRARA",1],["D549","VR","FERRARA DI MONTE BALDO",1],["D550","CB","FERRAZZANO",1],["D551","CO","FERRERA",0],["D552","PV","FERRERA",0],["D553","TO","FERRERA",0],["D553","TO","FERRERA CENISIO",0],["D551","VA","FERRERA DI VARESE",1],["D552","PV","FERRERA ERBOGNONE",1],["D554","AT","FERRERE",1],["D555","PC","FERRIERE",1],["D556","VC","FERRUTA",0],["D557","RC","FERRUZZANO",1],["D558","CE","FERTILIA",0],["D559","AL","FIACCONE",0],["D560","RI","FIAMIGNANO",1],["D561","RM","FIANO",0],["D562","TO","FIANO",1],["D561","RM","FIANO ROMANO",1],["D563","PL","FIANONA",0],["D564","MC","FIASTRA",1],["D565","TN","FIAVE'",1],["D566","MC","FICANO",0],["D567","PA","FICARAZZI",1],["D568","RO","FICAROLO",1],["D569","ME","FICARRA",1],["D570","TR","FICULLE",1],["B034","PR","FIDENZA",1],["D571","BZ","FIE'",0],["D571","BZ","FIE' ALLO SCILIAR",1],["D572","TN","FIERA DI PRIMIERO",0],["D573","TN","FIEROZZO",1],["D574","CR","FIESCO",1],["D575","FI","FIESOLE",1],["D576","BS","FIESSE",1],["D577","RO","FIESSO",0],["D578","VE","FIESSO",0],["D578","VE","FIESSO D'ARTICO",1],["D577","RO","FIESSO UMBERTIANO",1],["Z704","EE","FIGI=VITI",0],["D579","CO","FIGINO",0],["D580","MI","FIGINO",0],["D580","MI","FIGINO DI MILANO",0],["D579","CO","FIGINO SERENZA",1],["D581","CO","FIGLIARO",0],["D582","CS","FIGLINE",0],["D583","FI","FIGLINE",0],["M321","FI","FIGLINE E INCISA VALDARNO",1],["D583","FI","FIGLINE VALDARNO",0],["D582","CS","FIGLINE VEGLIATURO",1],["D584","CA","FIGU",0],["D585","CA","FIGU-GONNOSNO'",0],["D586","RM","FILACCIANO",1],["D587","VV","FILADELFIA",1],["D588","BG","FILAGO",1],["D589","VV","FILANDARI",1],["D590","MS","FILATTIERA",1],["D591","FR","FILETTINO",1],["D591","FR","FILETTINO GRAZIANI",0],["D592","CH","FILETTO",1],["D593","PZ","FILIANO",1],["D594","PV","FILIGHERA",1],["D595","IS","FILIGNANO",1],["Z216","EE","FILIPPINE",0],["D596","VV","FILOGASO",1],["D597","AN","FILOTTRANO",1],["D598","SV","FINALBORGO",0],["D599","MO","FINALE",0],["D599","MO","FINALE EMILIA",1],["D600","SV","FINALE LIGURE",1],["D599","MO","FINALE NELL'EMILIA",0],["D601","SV","FINALMARINA",0],["D602","SV","FINALPIA",0],["D603","NO","FINERO",0],["Z109","EE","FINLANDIA",0],["D604","BG","FINO",0],["D605","CO","FINO",0],["D604","BG","FINO DEL MONTE",1],["D605","CO","FINO MORNASCO",1],["D606","BG","FIORANO",0],["D607","MO","FIORANO",0],["D608","TO","FIORANO",0],["D606","BG","FIORANO AL SERIO",1],["D608","TO","FIORANO CANAVESE",1],["D607","MO","FIORANO MODENESE",1],["D609","MC","FIORDIMONTE",0],["D610","PU","FIORENZUOLA",0],["D611","PC","FIORENZUOLA",0],["D611","PC","FIORENZUOLA D'ARDA",1],["D610","PU","FIORENZUOLA DI FOCARA",0],["D612","FI","FIRENZE",1],["D613","FI","FIRENZUOLA",1],["D614","CS","FIRMO",1],["M323","FE","FISCAGLIA",1],["D615","SA","FISCIANO",1],["D616","TN","FISTO",0],["C415","PI","FITTO DI CECINA",0],["A310","FR","FIUGGI",1],["D617","MO","FIUMALBO",1],["D618","FC","FIUMANA",0],["D619","RC","FIUMARA",1],["D620","FM","FIUME",0],["D621","UD","FIUME",0],["D621","PN","FIUME VENETO",1],["D622","ME","FIUMEDINISI",1],["D623","CT","FIUMEFREDDO",0],["D624","CS","FIUMEFREDDO",0],["D624","CS","FIUMEFREDDO BRUZIO",1],["D623","CT","FIUMEFREDDO DI SICILIA",1],["D625","BG","FIUMENERO",0],["D626","BS","FIUMICELLO",0],["D627","UD","FIUMICELLO",0],["D626","BS","FIUMICELLO URAGO",0],["M400","UD","FIUMICELLO VILLA VICENTINA",1],["M297","RM","FIUMICINO",1],["D628","MC","FIUMINATA",1],["D629","MS","FIVIZZANO",1],["D630","UD","FLAIBANO",1],["D631","TN","FLAVON",0],["D632","VC","FLECCHIA",0],["D633","BZ","FLERES",0],["D634","BS","FLERO",1],["D635","ME","FLORESTA",1],["D636","SR","FLORIDIA",1],["D637","SS","FLORINAS",1],["D638","AV","FLUMERI",1],["D639","CA","FLUMINIMAGGIORE",0],["D639","SU","FLUMINIMAGGIORE",1],["D640","NU","FLUSSIO",0],["D640","OR","FLUSSIO",1],["D641","VC","FOBELLO",1],["D642","GE","FOCE",0],["D643","FG","FOGGIA",1],["D644","BN","FOGLIANISE",1],["D645","TS","FOGLIANO DI MONFALCONE",0],["D645","GO","FOGLIANO REDIPUGLIA",1],["D646","TO","FOGLIZZO",1],["D647","SA","FOGNA",0],["D648","BZ","FOIANA",0],["D649","AR","FOIANO",0],["D650","BN","FOIANO",0],["D649","AR","FOIANO DELLA CHIANA",1],["D650","BN","FOIANO DI VAL FORTORE",1],["H249","TN","FOLAS-REVIAN",0],["D651","TN","FOLGARIA",1],["D652","AP","FOLIGNANO",1],["D653","PG","FOLIGNO",1],["D654","TV","FOLLINA",1],["D655","SP","FOLLO",1],["D656","GR","FOLLONICA",1],["D657","NO","FOLSOGNO",0],["D658","BS","FOLZANO",0],["D659","NO","FOMARCO",0],["D660","LO","FOMBIO",1],["D661","ME","FONDACHELLI-FANTINA",1],["D662","LT","FONDI",1],["D663","TN","FONDO",0],["D664","BG","FONDRA",0],["D665","NU","FONNI",1],["D666","AO","FONTAINEMORE",1],["D667","FR","FONTANA",0],["D668","RA","FONTANA",0],["D669","FM","FONTANA DEL CONTE",0],["D668","BO","FONTANA ELICE",0],["D667","FR","FONTANA LIRI",1],["D670","PN","FONTANAFREDDA",1],["D671","AV","FONTANAROSA",1],["D668","BO","FONTANELICE",1],["D672","BG","FONTANELLA",1],["D673","PR","FONTANELLATO",1],["D674","TV","FONTANELLE",1],["D675","NO","FONTANETO D'AGOGNA",1],["D675","NO","FONTANETTO",0],["D676","NO","FONTANETTO",0],["D676","VC","FONTANETTO DA PO",0],["D676","VC","FONTANETTO PO",1],["D677","GE","FONTANIGORDA",1],["D678","AT","FONTANILE",1],["D679","PD","FONTANIVA",1],["D680","TV","FONTE",1],["M309","RM","FONTE NUOVA",1],["D681","AQ","FONTECCHIO",1],["D682","FR","FONTECHIARI",1],["D683","CE","FONTEGRECA",1],["D684","BG","FONTENO",1],["D685","PR","FONTEVIVO",1],["D686","BL","FONZASO",1],["D687","PV","FOPPA",0],["D688","BG","FOPPOLO",1],["D689","RI","FORANO",1],["D690","CH","FORCABOBOLINA",0],["D691","AP","FORCE",1],["D692","CR","FORCELLO",0],["D693","BN","FORCHIA",1],["D694","SO","FORCOLA",1],["D695","OR","FORDONGIANUS",1],["D696","PZ","FORENZA",1],["D697","BG","FORESTO",0],["D698","NO","FORESTO",0],["D699","TO","FORESTO",0],["D699","TO","FORESTO DI SUSA",0],["D698","VC","FORESTO SESIA",0],["D697","BG","FORESTO SPARSO",1],["D700","UD","FORGARIA",0],["D700","UD","FORGARIA NEL FRIULI",1],["D701","AV","FORINO",1],["D702","NA","FORIO",1],["D703","CB","FORLI'",0],["D704","FC","FORLI'",1],["D703","IS","FORLI' DEL SANNIO",1],["D705","FC","FORLIMPOPOLI",1],["D706","VB","FORMAZZA",1],["D707","RM","FORMELLO",1],["D708","LT","FORMIA",1],["D709","CE","FORMICOLA",1],["D710","CR","FORMIGARA",1],["D711","MO","FORMIGINE",1],["D712","VC","FORMIGLIANA",1],["D713","FE","FORMIGNANA",0],["Z217","EE","FORMOSA=TAIWAN",0],["D714","TN","FORNACE",1],["D715","IS","FORNELLI",1],["D716","NO","FORNERO",0],["D717","VI","FORNI",0],["D718","UD","FORNI AVOLTRI",1],["D719","UD","FORNI DI SOPRA",1],["D720","UD","FORNI DI SOTTO",1],["D721","VI","FORNI IN VAL D'ASTICO",0],["D722","NO","FORNO",0],["D723","TN","FORNO",0],["D724","TO","FORNO ALPI GRAIE",0],["D725","TO","FORNO CANAVESE",1],["B574","BL","FORNO DI CANALE",0],["D725","TO","FORNO DI RIVARA",0],["D726","BL","FORNO DI ZOLDO",0],["D724","TO","FORNO GROSCAVALLO",0],["D727","BG","FORNOVO",0],["D728","PR","FORNOVO",0],["D727","BG","FORNOVO DI SAN GIOVANNI",0],["D728","PR","FORNOVO DI TARO",1],["D727","BG","FORNOVO SAN GIOVANNI",1],["D729","AL","FOROTONDO",0],["C882","CA","FORRU",0],["D730","LU","FORTE DEI MARMI",1],["D731","BZ","FORTEZZA",1],["D732","PV","FORTUNAGO",1],["D733","ME","FORZA D'AGRO'",1],["D734","LU","FOSCIANDORA",1],["D735","MS","FOSDINOVO",1],["D736","AQ","FOSSA",1],["D739","CR","FOSSA GUAZZONA",0],["D683","CE","FOSSACECA",0],["D737","CB","FOSSACECA",0],["D738","CH","FOSSACECA",0],["D738","CH","FOSSACESIA",1],["D740","VE","FOSSALTA",0],["D741","VE","FOSSALTA",0],["D740","VE","FOSSALTA DI PIAVE",1],["D741","VE","FOSSALTA DI PORTOGRUARO",1],["D737","CB","FOSSALTO",1],["D742","CN","FOSSANO",1],["D743","PV","FOSSARMATO",0],["D744","CZ","FOSSATO",0],["D745","PG","FOSSATO",0],["D746","RC","FOSSATO CALABRO",0],["D745","PG","FOSSATO DI VICO",1],["D744","CZ","FOSSATO SERRALTA",1],["D747","NO","FOSSENO",0],["D748","VE","FOSSO'",1],["D749","PU","FOSSOMBRONE",1],["D750","VI","FOZA",1],["D751","CN","FRABOSA SOPRANA",1],["D752","CN","FRABOSA SOTTANA",1],["D753","CR","FRACCHIA",0],["D559","AL","FRACONALTO",1],["D754","TA","FRAGAGNANO",1],["D755","BN","FRAGNETO L'ABATE",1],["D756","BN","FRAGNETO MONFORTE",1],["D757","CH","FRAINE",1],["D758","SP","FRAMURA",1],["D759","AL","FRANCAVILLA",0],["D760","AP","FRANCAVILLA",0],["D761","BR","FRANCAVILLA",0],["D762","CZ","FRANCAVILLA",0],["D763","CH","FRANCAVILLA",0],["D764","CS","FRANCAVILLA",0],["D765","ME","FRANCAVILLA",0],["D766","PZ","FRANCAVILLA",0],["D763","CH","FRANCAVILLA AL MARE",1],["D762","VV","FRANCAVILLA ANGITOLA",1],["D759","AL","FRANCAVILLA BISIO",1],["D760","AP","FRANCAVILLA D'ETE",0],["D760","FM","FRANCAVILLA D'ETE",1],["D765","ME","FRANCAVILLA DI SICILIA",1],["D761","BR","FRANCAVILLA FONTANA",1],["D766","PZ","FRANCAVILLA IN SINNI",1],["D764","CS","FRANCAVILLA MARITTIMA",1],["Z110","EE","FRANCIA",0],["D767","VV","FRANCICA",1],["D768","SR","FRANCOFONTE",1],["D769","CE","FRANCOLISE",1],["D770","AL","FRASCARO",1],["D771","PV","FRASCAROLO",1],["D772","AL","FRASCATA",0],["D773","RM","FRASCATI",1],["D774","CS","FRASCINETO",1],["D775","TN","FRASSILONGO",1],["D776","RO","FRASSINELLE",0],["D776","RO","FRASSINELLE POLESINE",1],["D777","AL","FRASSINELLO",0],["D777","AL","FRASSINELLO MONFERRATO",1],["D778","AL","FRASSINELLO-OLIVOLA",0],["D779","TO","FRASSINERE",0],["D780","AL","FRASSINETO PO",1],["D781","TO","FRASSINETTO",1],["D782","CN","FRASSINO",1],["D783","MO","FRASSINORO",1],["D784","BN","FRASSO",0],["D785","RI","FRASSO",0],["D785","RI","FRASSO SABINO",1],["D784","BN","FRASSO TELESINO",1],["D786","PG","FRATTA",0],["D787","PG","FRATTA",0],["D788","RO","FRATTA",0],["D788","RO","FRATTA POLESINE",1],["D787","PG","FRATTA TODINA",1],["D789","NA","FRATTAMAGGIORE",1],["D790","NA","FRATTAMINORE",1],["A502","FR","FRATTE",0],["D791","PU","FRATTE",0],["D791","PU","FRATTE ROSA",1],["D792","TN","FRAVEGGIO",0],["D793","ME","FRAZZANO'",1],["D794","TV","FREGONA",1],["D795","BG","FREROLA",0],["D796","CH","FRESAGRANDINARIA",1],["D797","AL","FRESONARA",1],["D798","AV","FRIGENTO",1],["D799","CE","FRIGNANO",1],["D800","CE","FRIGNANO MAGGIORE",0],["D801","CE","FRIGNANO PICCOLO",0],["D802","AT","FRINCO",1],["D803","CH","FRISA",1],["D804","PN","FRISANCO",1],["D805","TO","FRONT",1],["D806","BS","FRONTIGNANO",0],["D807","PU","FRONTINO",1],["D808","PU","FRONTONE",1],["D809","PU","FRONTONE-SERRA",0],["D810","FR","FROSINONE",1],["D811","IS","FROSOLONE",1],["D812","TO","FROSSASCO",1],["D813","AL","FRUGAROLO",1],["D814","AL","FUBINE",0],["D814","AL","FUBINE MONFERRATO",1],["D815","FI","FUCECCHIO",1],["D816","BG","FUIPIANO",0],["D816","BG","FUIPIANO AL BREMBO",0],["D817","BG","FUIPIANO VALLE IMAGNA",1],["D818","VR","FUMANE",1],["D819","FR","FUMONE",1],["D820","BZ","FUNDOLES",0],["D820","BZ","FUNDRES",0],["D821","BZ","FUNES",1],["D822","MI","FURATO",0],["D823","CH","FURCI",1],["D824","ME","FURCI SICULO",1],["D825","ME","FURNARI",1],["D826","SA","FURORE",1],["D827","CA","FURTEI",0],["D827","SU","FURTEI",1],["D828","CS","FUSCALDO",1],["D829","RA","FUSIGNANO",1],["D830","SO","FUSINE",1],["D831","UD","FUSINE IN VALROMANA",0],["D832","SA","FUTANI",1],["B035","BS","GABBIANO",0],["C115","CR","GABBIANO",0],["D833","CR","GABBIONETA",0],["D834","CR","GABBIONETA BINANUOVA",0],["D834","CR","GABBIONETA-BINANUOVA",1],["D835","AL","GABIANO",1],["D836","PU","GABICCE",0],["D836","PU","GABICCE MARE",1],["Z316","EE","GABON",0],["D837","GO","GABRIA",0],["D838","GO","GABROVIZZA",0],["D839","AO","GABY",1],["D840","CR","GADESCO",0],["D841","CR","GADESCO PIEVE DELMONA",0],["D841","CR","GADESCO-PIEVE DELMONA",1],["D842","NU","GADONI",1],["D843","LT","GAETA",1],["D844","ME","GAGGI",1],["D845","MI","GAGGIANO",1],["D846","CO","GAGGINO",0],["D847","BO","GAGGIO MONTANO",1],["D848","BI","GAGLIANICO",1],["D849","CT","GAGLIANO",0],["D850","AQ","GAGLIANO",0],["D851","LE","GAGLIANO",0],["D850","AQ","GAGLIANO ATERNO",1],["D849","EN","GAGLIANO CASTELFERRATO",1],["D851","LE","GAGLIANO DEL CAPO",1],["D852","CZ","GAGLIATO",1],["D853","MC","GAGLIOLE",1],["D854","TV","GAIARINE",1],["D855","RO","GAIBA",1],["D856","CN","GAIOLA",1],["D857","CN","GAIOLA-MOIOLA",0],["D858","SI","GAIOLE",0],["D858","SI","GAIOLE IN CHIANTI",1],["D859","NU","GAIRO",1],["D860","BZ","GAIS",1],["D861","ME","GALATI",0],["D861","ME","GALATI MAMERTINO",1],["D862","LE","GALATINA",1],["D863","LE","GALATONE",1],["D864","RC","GALATRO",1],["D865","LC","GALBIATE",1],["D866","SA","GALDO",0],["D867","FC","GALEATA",1],["D868","LO","GALGAGNANO",1],["D869","VA","GALLARATE",1],["D870","VT","GALLESE",1],["D871","CO","GALLIATE",0],["D872","NO","GALLIATE",1],["D871","VA","GALLIATE LOMBARDO",1],["D873","PV","GALLIAVOLA",1],["D874","LU","GALLICANO",1],["D875","RM","GALLICANO",0],["D875","RM","GALLICANO NEL LAZIO",1],["D876","PZ","GALLICCHIO",1],["D877","RC","GALLICO",0],["D878","BO","GALLIERA",1],["D879","PD","GALLIERA",0],["D879","PD","GALLIERA VENETA",1],["D880","RC","GALLINA",0],["D881","FR","GALLINARO",1],["D882","VI","GALLIO",1],["D883","LE","GALLIPOLI",1],["D884","CE","GALLO",0],["D884","CE","GALLO MATESE",1],["D885","ME","GALLODORO",1],["D886","CE","GALLUCCIO",1],["D887","FI","GALLUZZO",0],["D888","NU","GALTELLI",0],["D888","NU","GALTELLI'",1],["D889","PD","GALZIGNANO",0],["D889","PD","GALZIGNANO TERME",1],["D890","AL","GAMALERO",1],["D891","BS","GAMBARA",1],["D892","PV","GAMBARANA",1],["D893","VE","GAMBARARE",0],["D894","CN","GAMBASCA",1],["D895","FI","GAMBASSI",0],["D895","FI","GAMBASSI TERME",1],["D896","CB","GAMBATESA",1],["D897","VI","GAMBELLARA",1],["D898","CH","GAMBERALE",1],["D899","FC","GAMBETTOLA",1],["Z317","EE","GAMBIA",0],["D900","CR","GAMBINA BARCHETTI",0],["D901","PV","GAMBOLO'",1],["D902","VI","GAMBUGLIANO",1],["D903","BG","GANDELLINO",1],["D904","CR","GANDINI",0],["D905","BG","GANDINO",1],["D906","BG","GANDOSSO",1],["D907","PA","GANGI",1],["D908","VA","GARABIOLO",0],["D909","MT","GARAGUSO",1],["D910","AL","GARBAGNA",1],["D911","NO","GARBAGNA",0],["D911","NO","GARBAGNA NOVARESE",1],["D912","MI","GARBAGNATE",0],["D912","MI","GARBAGNATE MILANESE",1],["D913","LC","GARBAGNATE MONASTERO",1],["D914","MI","GARBATOLA",0],["D915","VR","GARDA",1],["D916","TN","GARDOLO",0],["D917","BS","GARDONE RIVIERA",1],["D918","BS","GARDONE VAL TROMPIA",1],["D919","MI","GAREGNANO",0],["D920","CN","GARESSIO",1],["D921","NO","GARGALLO",1],["D922","GO","GARGARO",0],["D923","BZ","GARGAZZONE",1],["D924","BS","GARGNANO",1],["D925","PV","GARLASCO",1],["D926","LC","GARLATE",1],["D927","SV","GARLENDA",1],["D928","TN","GARNIGA",0],["D928","TN","GARNIGA TERME",1],["D929","SS","GAROFAI",0],["D930","CO","GARZENO",1],["D931","TO","GARZIGLIANA",1],["D932","CZ","GASPERINA",1],["D933","TO","GASSINO",0],["D933","TO","GASSINO TORINESE",1],["D934","RE","GATTATICO",1],["D935","FC","GATTEO",1],["D936","MI","GATTERA MAIOCCA",0],["D937","NO","GATTICO",0],["M416","NO","GATTICO-VERUNO",1],["D938","VC","GATTINARA",1],["D939","AO","GAUNA",0],["D940","BS","GAVARDO",1],["D941","AL","GAVAZZANA",0],["D942","RO","GAVELLO",1],["D943","BG","GAVERINA",0],["D943","BG","GAVERINA TERME",1],["D944","AL","GAVI",1],["D945","RM","GAVIGNANO",1],["D946","VA","GAVIRATE",1],["D947","NU","GAVOI",1],["D948","GR","GAVORRANO",1],["Z218","EE","GAZA (TERRITORIO DI)",0],["D949","MN","GAZOLDO DEGLI IPPOLITI",1],["D950","VA","GAZZADA",0],["D951","VA","GAZZADA SCHIANNO",1],["D952","BG","GAZZANIGA",1],["D953","RE","GAZZANO",0],["D954","IM","GAZZELLI",0],["D955","CR","GAZZO",0],["D956","PD","GAZZO",1],["D957","VR","GAZZO",0],["D956","PD","GAZZO PADOVANO",0],["D957","VR","GAZZO VERONESE",1],["D958","PC","GAZZOLA",1],["D949","MN","GAZZOLDO",0],["D959","MN","GAZZUOLO",1],["D960","CL","GELA",1],["D961","RN","GEMMANO",1],["D962","UD","GEMONA",0],["D962","UD","GEMONA DEL FRIULI",1],["D963","VA","GEMONIO",1],["D964","RM","GENAZZANO",1],["D965","AN","GENGA",1],["D966","CR","GENIVOLTA",1],["D967","CN","GENOLA",1],["D968","NU","GENONI",0],["D968","SU","GENONI",1],["D969","GE","GENOVA",1],["D970","CA","GENURI",0],["D970","SU","GENURI",1],["D971","MT","GENZANO",0],["D972","RM","GENZANO",0],["D971","PZ","GENZANO DI LUCANIA",1],["D972","RM","GENZANO DI ROMA",1],["D973","PV","GENZONE",0],["Z136","EE","GEORGIA",0],["Z254","EE","GEORGIA",0],["D974","CO","GERA",0],["D974","CO","GERA LARIO",1],["D975","RC","GERACE",1],["D976","RC","GERACE MARINA",0],["D975","RC","GERACE SUPERIORE",0],["D977","PA","GERACI",0],["D977","PA","GERACI SICULO",1],["D978","RM","GERANO",1],["D979","CR","GERE DEL PESCE",0],["D980","PV","GERENZAGO",1],["D981","VA","GERENZANO",1],["D982","NU","GERGEI",0],["D982","SU","GERGEI",1],["D983","TO","GERMAGNANO",1],["D984","VB","GERMAGNO",1],["D985","CO","GERMANEDO",0],["Z112","EE","GERMANIA",0],["Z111","EE","GERMANIA REPUBBLICA DEMOCRATICA",0],["Z112","EE","GERMANIA REPUBBLICA FEDERALE",0],["D986","CO","GERMASINO",0],["D987","VA","GERMIGNAGA",1],["D988","VV","GEROCARNE",1],["D989","BS","GEROLA",0],["D990","SO","GEROLA",0],["D990","SO","GEROLA ALTA",1],["D989","BS","GEROLANUOVA",0],["D991","BG","GEROSA",0],["D992","PV","GERRE CHIOZZO",0],["D993","CR","GERRE DE' CAPRIOLI",1],["D994","CA","GESICO",0],["D994","SU","GESICO",1],["D995","MI","GESSATE",1],["D996","CH","GESSOPALENA",1],["D997","CA","GESTURI",0],["D997","SU","GESTURI",1],["D998","AV","GESUALDO",1],["Z318","EE","GHANA",0],["D999","BS","GHEDI",1],["E001","NO","GHEMME",1],["E002","NO","GHEVIO",0],["E003","VB","GHIFFA",1],["E004","OR","GHILARZA",1],["E005","CA","GHILARZA-ABBASANTA",0],["E006","BG","GHISALBA",1],["E007","VC","GHISLARENGO",1],["E008","RO","GIACCIANO CON BARUCHELLA",1],["E009","TO","GIAGLIONE",1],["Z507","EE","GIAMAICA",0],["E010","BS","GIANICO",1],["E011","CE","GIANO",0],["E012","PG","GIANO",0],["E012","PG","GIANO DELL'UMBRIA",1],["E011","CE","GIANO VETUSTO",1],["Z219","EE","GIAPPONE",0],["E013","PA","GIARDINELLO",1],["E014","ME","GIARDINI",0],["E014","ME","GIARDINI-NAXOS",1],["E015","AL","GIAROLE",1],["E016","RG","GIARRATANA",1],["E017","CT","GIARRE",1],["E018","CT","GIARRE-RIPOSTO",0],["E019","SS","GIAVE",1],["E020","TO","GIAVENO",1],["E021","TV","GIAVERA DEL MONTELLO",1],["E022","CA","GIBA",0],["E022","SU","GIBA",1],["E023","TP","GIBELLINA",1],["Z113","EE","GIBILTERRA",0],["Z361","EE","GIBUTI",0],["E024","BI","GIFFLENGA",1],["E025","RC","GIFFONE",1],["E026","SA","GIFFONI SEI CASALI",1],["E027","SA","GIFFONI VALLE PIANA",1],["E028","VB","GIGNESE",1],["E029","AO","GIGNOD",1],["Z705","EE","GILBERT E ELLICE (ISOLE)",0],["E030","CB","GILDONE",1],["E031","CZ","GIMIGLIANO",1],["E032","PL","GIMINO",0],["E033","PZ","GINESTRA",1],["E034","BN","GINESTRA DEGLI SCHIAVONI",1],["E035","PU","GINESTRETO",0],["E036","TA","GINOSA",1],["E037","SA","GIOI",1],["E038","BA","GIOIA",0],["E039","CE","GIOIA",0],["E040","AQ","GIOIA",0],["E041","RC","GIOIA",0],["E040","AQ","GIOIA DEI MARSI",1],["E038","BA","GIOIA DEL COLLE",1],["E039","CE","GIOIA SANNITICA",1],["E041","RC","GIOIA TAURO",1],["E042","GO","GIOIACI",0],["E043","ME","GIOIOSA",0],["E044","RC","GIOIOSA",0],["E044","RC","GIOIOSA IONICA",1],["E043","ME","GIOIOSA MAREA",1],["Z220","EE","GIORDANIA",0],["E045","TR","GIOVE",1],["E046","PV","GIOVENZANO",0],["E047","BA","GIOVINAZZO",1],["E048","TN","GIOVO",1],["E049","NU","GIRASOLE",1],["A089","AG","GIRGENTI",0],["E050","CZ","GIRIFALCO",1],["E051","CO","GIRONICO",0],["E052","CH","GISSI",1],["E053","LE","GIUGGIANELLO",1],["E054","NA","GIUGLIANO IN CAMPANIA",1],["E055","PA","GIULIANA",1],["E054","NA","GIULIANO",0],["E056","CH","GIULIANO",0],["E057","RM","GIULIANO",0],["E057","FR","GIULIANO DI ROMA",1],["E054","NA","GIULIANO IN CAMPANIA",0],["E056","CH","GIULIANO TEATINO",1],["E058","TE","GIULIANOVA",1],["E059","LU","GIUNCUGNANO",0],["E060","SA","GIUNGANO",1],["E061","LE","GIURDIGNANO",1],["E062","PV","GIUSSAGO",1],["E063","MB","GIUSSANO",1],["E063","MI","GIUSSANO",0],["E064","SV","GIUSTENICE",1],["E065","TN","GIUSTINO",1],["E066","SV","GIUSVALLA",1],["E067","TO","GIVOLETTO",1],["E068","CZ","GIZZERIA",1],["E069","BZ","GLORENZA",1],["E265","PV","GNIGNANO",0],["E070","SP","GODANO",0],["E071","TV","GODEGA",0],["E071","TV","GODEGA DI SANT'URBANO",1],["C190","TV","GODEGO",0],["M231","TN","GODENZO",0],["E072","PV","GODIASCO",0],["E072","PV","GODIASCO SALICE TERME",1],["E073","GO","GODOVICI",0],["E074","PA","GODRANO",1],["E075","BS","GOGLIONE SOPRA",0],["E076","BS","GOGLIONE SOTTO",0],["E077","PV","GOIDO",0],["E078","MN","GOITO",1],["E079","VA","GOLASECCA",1],["E080","PR","GOLESE",0],["E081","PV","GOLFERENZO",1],["M274","SS","GOLFO ARANCI",1],["E082","CR","GOMBITO",1],["E083","UD","GONARS",1],["E084","CA","GONI",0],["E084","SU","GONI",1],["E086","CA","GONNESA",0],["E086","SU","GONNESA",1],["E087","OR","GONNOSCODINA",1],["E085","CA","GONNOSFANADIGA",0],["E085","SU","GONNOSFANADIGA",1],["D585","OR","GONNOSNO'",1],["E088","OR","GONNOSTRAMATZA",1],["E089","MN","GONZAGA",1],["E090","SO","GORDONA",1],["E091","RM","GORGA",1],["E092","TV","GORGO",0],["E092","TV","GORGO AL MONTICANO",1],["E093","MT","GORGOGLIONE",1],["E094","MI","GORGONZOLA",1],["E095","GO","GORIANO",0],["E096","AQ","GORIANO SICOLI",1],["E097","AQ","GORIANO VALLI",0],["E098","GO","GORIZIA",1],["E099","MI","GORLA",0],["E101","VA","GORLA MAGGIORE",1],["E102","VA","GORLA MINORE",1],["E099","MI","GORLA PRECOTTO",0],["E099","MI","GORLA PRIMO",0],["E100","BG","GORLAGO",1],["E103","BG","GORLE",1],["E104","VA","GORNATE INFERIORE",0],["E104","VA","GORNATE OLONA",1],["E105","VA","GORNATE SUPERIORE",0],["E104","VA","GORNATE-OLONA",0],["E106","BG","GORNO",1],["E107","FE","GORO",1],["E108","GE","GORRA",0],["E109","GE","GORRETO",1],["E110","CN","GORRINO",0],["E111","CN","GORZEGNO",1],["E112","BS","GORZONE",0],["E113","BL","GOSALDO",1],["E114","PC","GOSSOLENGO",1],["E115","CN","GOTTASECCA",1],["E116","BS","GOTTOLENGO",1],["E117","CO","GOTTRO",0],["E118","CN","GOVONE",1],["E119","GO","GOZZA",0],["E120","NO","GOZZANO",1],["E121","GO","GRACOVA SERRAVALLE",0],["E122","PU","GRADARA",1],["E123","CR","GRADELLA",0],["E124","GO","GRADISCA",0],["E124","GO","GRADISCA D'ISONZO",1],["E125","GO","GRADO",1],["E126","VT","GRADOLI",1],["E127","LO","GRAFFIGNANA",1],["E128","VT","GRAFFIGNANO",1],["E129","NO","GRAGLIA",0],["E130","BI","GRAGLIA",1],["E129","NO","GRAGLIA PIANA",0],["B334","CO","GRAGLIO CON CADERO",0],["E131","NA","GRAGNANO",1],["E132","PC","GRAGNANO",0],["E132","PC","GRAGNANO TREBBIENSE",1],["E133","CT","GRAMMICHELE",1],["Z114","EE","GRAN BRETAGNA E IRLANDA DEL NORD",0],["E134","AT","GRANA",1],["E135","BO","GRANAGLIONE",0],["E136","BO","GRANAROLO DELL'EMILIA",1],["E137","MI","GRANCINO",0],["E138","VI","GRANCONA",0],["E139","CO","GRANDATE",1],["E140","CO","GRANDOLA",0],["E141","CO","GRANDOLA ED UNITI",1],["E142","ME","GRANITI",1],["E143","NO","GRANOZZO CON MONTICELLO",1],["E144","VA","GRANTOLA",1],["E145","PD","GRANTORTO",1],["E146","PD","GRANZE",1],["E147","MT","GRASSANO",1],["E148","BG","GRASSOBBIO",1],["E149","PA","GRATTERI",1],["E150","TN","GRAUNO",0],["E151","CO","GRAVEDONA",0],["M315","CO","GRAVEDONA ED UNITI",1],["E152","PV","GRAVELLONA LOMELLINA",1],["E153","VB","GRAVELLONA TOCE",1],["E154","TO","GRAVERE",1],["E155","BA","GRAVINA",0],["E156","CT","GRAVINA",0],["E156","CT","GRAVINA DI CATANIA",1],["E155","BA","GRAVINA IN PUGLIA",1],["E157","MI","GRAZZANELLO",0],["E158","CE","GRAZZANISE",1],["E159","AL","GRAZZANO",0],["E159","AT","GRAZZANO BADOGLIO",1],["E159","AT","GRAZZANO MONFERRATO",0],["E160","RI","GRECCIO",1],["E161","AV","GRECI",1],["Z115","EE","GRECIA",0],["E162","MI","GRECO MILANESE",0],["E163","VC","GREGGIO",1],["E164","AL","GREMIASCO",1],["Z524","EE","GRENADA",0],["E165","AO","GRESSAN",1],["E166","AO","GRESSONEI",0],["E166","AO","GRESSONEY",0],["E167","AO","GRESSONEY-LA-TRINITE'",1],["E168","AO","GRESSONEY-SAINT-JEAN",1],["E169","FI","GREVE",0],["E169","FI","GREVE IN CHIANTI",1],["C417","BS","GREVO",0],["E170","MI","GREZZAGO",1],["E171","VR","GREZZANA",1],["E172","CO","GRIANTE",1],["E173","CE","GRICIGNANO",0],["E173","CE","GRICIGNANO DI AVERSA",1],["E174","BZ","GRIES",0],["E174","BZ","GRIES DI BOLZANO",0],["E175","BG","GRIGNANO",0],["E176","RO","GRIGNANO",0],["E176","RO","GRIGNANO DI POLESINE",0],["E177","NO","GRIGNASCO",1],["E178","TN","GRIGNO",1],["E179","UD","GRIMACCO",1],["E180","CS","GRIMALDI",1],["E181","BZ","GRIMALDO",0],["E182","CN","GRINZANE",0],["E182","CN","GRINZANE CAVOUR",1],["E183","PL","GRISIGNANA",0],["E184","VI","GRISIGNANO",0],["E184","VI","GRISIGNANO DI ZOCCO",1],["D415","VE","GRISOLERA",0],["E185","CS","GRISOLIA",1],["E186","CS","GRISOLIA CIPOLLINA",0],["E187","BO","GRIZZANA",0],["E187","BO","GRIZZANA MORANDI",1],["Z402","EE","GROENLANDIA",0],["E188","AL","GROGNARDO",1],["E189","BG","GROMO",1],["E190","CO","GRONA",0],["E191","AL","GRONDONA",1],["E192","BG","GRONE",1],["E193","CR","GRONTARDO",1],["E194","CR","GRONTORTO",0],["E195","PV","GROPELLO CAIROLI",1],["E195","PV","GROPELLO LOMELLINO",0],["E196","PC","GROPPARELLO",1],["E195","PV","GROPPELLO",0],["E197","MI","GROPPELLO",0],["E197","MI","GROPPELLO D'ADDA",0],["E198","AL","GROPPO",0],["E199","TO","GROSCAVALLO",1],["E200","SO","GROSIO",1],["E201","SO","GROSOTTO",1],["E202","GR","GROSSETO",1],["E203","TO","GROSSO",1],["E204","RM","GROTTAFERRATA",1],["E205","TA","GROTTAGLIE",1],["E206","AV","GROTTAMINARDA",1],["E207","AP","GROTTAMMARE",1],["E208","AP","GROTTAZZOLINA",0],["E208","FM","GROTTAZZOLINA",1],["E209","AG","GROTTE",1],["E210","VT","GROTTE DI CASTRO",1],["E211","VT","GROTTE DI SANTO STEFANO",0],["E212","RC","GROTTERIA",1],["E213","MT","GROTTOLE",1],["E214","AV","GROTTOLELLA",1],["E215","VE","GRUARO",1],["E216","TO","GRUGLIASCO",1],["E217","CR","GRUMELLO",0],["E217","CR","GRUMELLO CON FARFENGO CREMONESE",0],["E217","CR","GRUMELLO CREMONESE ED UNITI",1],["E218","BG","GRUMELLO DEI ZANCHI",0],["E219","BG","GRUMELLO DEL MONTE",1],["E220","BG","GRUMELLO DEL PIANO",0],["E221","PZ","GRUMENTO NOVA",1],["E222","TN","GRUMES",0],["E223","BA","GRUMO",0],["E224","NA","GRUMO",0],["E225","TN","GRUMO",0],["E223","BA","GRUMO APPULA",1],["E224","NA","GRUMO NEVANO",1],["E226","VI","GRUMOLO DELLE ABBADESSE",1],["Z508","EE","GUADALUPA",0],["E227","LE","GUAGNANO",1],["E228","MC","GUALDO",1],["E229","PG","GUALDO CATTANEO",1],["E230","PG","GUALDO TADINO",1],["E231","PV","GUALDRASCO",0],["E232","RE","GUALTIERI",1],["E233","ME","GUALTIERI SICAMINO'",1],["Z706","EE","GUAM (ISOLA)",0],["E234","CA","GUAMAGGIORE",0],["E234","SU","GUAMAGGIORE",1],["E235","CO","GUANZATE",1],["E236","FR","GUARCINO",1],["E240","RO","GUARDA VENETA",1],["E237","VC","GUARDABOSONE",1],["E238","LO","GUARDAMIGLIO",1],["E239","CZ","GUARDAVALLE",1],["E241","TR","GUARDEA",1],["E242","CS","GUARDIA",0],["E245","AV","GUARDIA LOMBARDI",1],["E246","PZ","GUARDIA PERTICARA",1],["E242","CS","GUARDIA PIEMONTESE",1],["E247","CS","GUARDIA PIEMONTESE TERME",0],["E249","BN","GUARDIA SANFRAMONDI",1],["E243","CH","GUARDIAGRELE",1],["E244","CB","GUARDIALFIERA",1],["E248","CB","GUARDIAREGIA",1],["E250","PI","GUARDISTALLO",1],["E251","CN","GUARENE",1],["E252","CA","GUASILA",0],["E252","SU","GUASILA",1],["E253","RE","GUASTALLA",1],["Z509","EE","GUATEMALA",0],["Z608","EE","GUAYANA OLANDESE",0],["Z607","EE","GUAYANA=GUYANA FRANCESE",0],["E254","MI","GUAZZINA",0],["E255","AL","GUAZZORA",1],["E256","PG","GUBBIO",1],["E258","MI","GUDO VISCONTI",1],["E257","BZ","GUDON",0],["E259","CB","GUGLIONESI",1],["E260","MI","GUGNANO",0],["Z607","EE","GUIANA FRANCESE",0],["E261","MN","GUIDIZZOLO",1],["E262","ME","GUIDOMANDRI",0],["E263","RM","GUIDONIA MONTECELIO",1],["E264","MO","GUIGLIA",1],["E266","CH","GUILMI",1],["Z319","EE","GUINEA",0],["Z320","EE","GUINEA BISSAU",0],["Z321","EE","GUINEA EQUATORIALE",0],["Z320","EE","GUINEA PORTOGHESE",0],["Z321","EE","GUINEA SPAGNOLA",0],["E267","PV","GUINZANO",0],["E268","VA","GURONE",0],["E269","VB","GURRO",1],["E270","CA","GUSPINI",0],["E270","SU","GUSPINI",1],["E271","BS","GUSSAGO",1],["E272","CR","GUSSOLA",1],["Z606","EE","GUYANA",0],["Z606","EE","GUYANA BRITANNICA",0],["Z510","EE","HAITI",0],["B676","BS","HANO",0],["Z511","EE","HONDURAS",0],["Z512","EE","HONDURAS BRITANNICO",0],["E273","AO","HONE",1],["Z221","EE","HONG KONG",0],["E273","AO","H�NE",0],["E275","RC","IATRINOLI",0],["E277","GO","IDRESCA D'ISONZO",0],["E278","GO","IDRIA",0],["E279","GO","IDRIA DI SOTTO",0],["E280","BS","IDRO",1],["Z323","EE","IFNI",0],["E281","CA","IGLESIAS",0],["E281","SU","IGLESIAS",1],["E282","CN","IGLIANO",1],["E283","NU","ILBONO",1],["E284","VR","ILLASI",1],["E285","SS","ILLORAI",1],["E286","CO","IMBERIDO",0],["E287","LC","IMBERSAGO",1],["E288","TN","IMER",1],["E289","BO","IMOLA",1],["E290","IM","IMPERIA",1],["E291","FI","IMPRUNETA",1],["E292","VA","INARZO",1],["E293","CO","INCINO",0],["E294","MI","INCIRANO",0],["E295","AL","INCISA",0],["E296","FI","INCISA",0],["E295","AL","INCISA BELBO",0],["E296","FI","INCISA IN VAL D'ARNO",0],["E295","AT","INCISA SCAPACCINO",1],["E297","BS","INCUDINE",1],["Z222","EE","INDIA",0],["Z223","EE","INDONESIA",0],["E298","CO","INDOVERO",0],["E299","CO","INDUNO",0],["E300","MI","INDUNO",0],["E299","VA","INDUNO OLONA",1],["E300","MI","INDUNO TICINO",0],["E301","TO","INGRIA",1],["E302","CO","INTIMIANO",0],["E303","NO","INTRA",0],["E304","VB","INTRAGNA",1],["E305","LC","INTROBIO",1],["E306","AO","INTROD",1],["E307","AQ","INTRODACQUA",1],["E308","LC","INTROZZO",0],["E309","CO","INVERIGO",1],["E310","PV","INVERNO",0],["E310","PV","INVERNO E MONTELEONE",1],["E311","TO","INVERSO PINASCA",1],["E312","TO","INVERSO PORTE",0],["E313","MI","INVERUNO",1],["E314","NO","INVORIO",1],["E315","NO","INVORIO INFERIORE",0],["E316","NO","INVORIO SUPERIORE",0],["E317","MI","INZAGO",1],["E318","BS","INZINO",0],["E319","UD","IOANNIS",0],["E319","UD","IOANNIZ",0],["E321","VV","IONADI",1],["E018","CT","IONIA",0],["E322","UD","IPPLIS",0],["Z224","EE","IRAN",0],["Z225","EE","IRAQ",0],["E323","NU","IRGOLI",1],["E324","NU","IRGOLI DI GALTELLI",0],["Z707","EE","IRIAN OCCIDENTALE",0],["Z116","EE","IRLANDA",0],["E325","BS","IRMA",1],["E326","MT","IRSINA",1],["E327","CN","ISASCA",1],["E328","CZ","ISCA SULLO IONIO",1],["E329","NA","ISCHIA",1],["E330","RM","ISCHIA",0],["E331","TN","ISCHIA",0],["E330","VT","ISCHIA DI CASTRO",1],["E332","FG","ISCHITELLA",1],["E333","BS","ISEO",1],["E334","TN","ISERA",1],["E335","IS","ISERNIA",1],["E336","NU","ISILI",0],["E336","SU","ISILI",1],["Z117","EE","ISLANDA",0],["E337","PA","ISNELLO",1],["E338","AL","ISOLA",0],["E339","CZ","ISOLA",0],["E340","FR","ISOLA",0],["E341","GE","ISOLA",0],["E342","SO","ISOLA",0],["E343","TE","ISOLA",0],["E344","MI","ISOLA BALBA",0],["E347","CO","ISOLA COMACINA",0],["E338","AT","ISOLA D'ASTI",1],["E355","PL","ISOLA D'ISTRIA",0],["E341","GE","ISOLA DEL CANTONE",1],["E348","GR","ISOLA DEL GIGLIO",1],["E343","TE","ISOLA DEL GRAN SASSO D'ITALIA",1],["E340","FR","ISOLA DEL LIRI",1],["E351","PU","ISOLA DEL PIANO",1],["E349","VR","ISOLA DELLA SCALA",1],["E350","PA","ISOLA DELLE FEMMINE",1],["E339","KR","ISOLA DI CAPO RIZZUTO",1],["E352","PU","ISOLA DI FANO",0],["E353","BG","ISOLA DI FONDRA",1],["E354","VI","ISOLA DI MALO",0],["E356","CR","ISOLA DOVARESE",1],["E357","CR","ISOLA PESCAROLI",0],["E358","VR","ISOLA PORCARIZZA",0],["E340","FR","ISOLA PRESSO SORA",0],["E358","VR","ISOLA RIZZA",1],["E359","NO","ISOLA SAN GIULIO",0],["E360","AL","ISOLA SANT'ANTONIO",1],["E354","VI","ISOLA VICENTINA",1],["E345","TO","ISOLABELLA",1],["E346","IM","ISOLABONA",1],["E342","SO","ISOLATO",0],["Z721","EE","ISOLE CILENE (PASQUA E SALA Y GOMEZ)",0],["Z124","EE","ISOLE DEL CANALE",0],["Z727","EE","ISOLE DELL'UNIONE",0],["E363","FG","ISOLE TREMITI",1],["E361","VC","ISOLELLA",0],["E362","CR","ISOLELLO",0],["E364","BS","ISORELLA",1],["E365","SA","ISPANI",1],["E366","RG","ISPICA",1],["E367","VA","ISPRA",1],["Z226","EE","ISRAELE",0],["C737","BZ","ISSENGO",0],["E368","TO","ISSIGLIO",1],["E369","AO","ISSIME",1],["E370","BG","ISSO",1],["E371","AO","ISSOGNE",1],["E372","CH","ISTONIO",0],["E373","TV","ISTRANA",1],["E374","ME","ITALA",1],["E375","LT","ITRI",1],["E376","SS","ITTIREDDU",1],["E377","SS","ITTIRI",1],["Z118","EE","IUGOSLAVIA",0],["E378","TN","IVANO FRACENA",0],["E379","TO","IVREA",1],["E380","CR","IZANO",1],["E274","CZ","JACURSO",1],["E276","TN","JAVRE'",0],["E381","CB","JELSI",1],["E382","RM","JENNE",1],["E383","MI","JERAGO",0],["E384","MI","JERAGO CON BESNATE",0],["E385","MI","JERAGO CON BESNATE ED ORAGO",0],["E386","VA","JERAGO CON ORAGO",1],["E387","NU","JERZU",1],["E388","AN","JESI",1],["C388","VE","JESOLO",1],["E320","FE","JOLANDA DI SAVOIA",1],["E389","VV","JOPPOLO",1],["E390","AG","JOPPOLO GIANCAXIO",1],["E391","AO","JOVENCAN",1],["E391","AO","JOVEN�AN",0],["D844","ME","KAGGI",0],["Z255","EE","KAZAKHSTAN",0],["Z152","EE","KAZAKISTAN",0],["Z255","EE","KAZAKISTAN",0],["Z322","EE","KENYA",0],["Z142","EE","KIRGHIZISTAN",0],["Z256","EE","KIRGHIZISTAN",0],["Z731","EE","KIRIBATI",0],["Z160","EE","KOSOVO",0],["Z227","EE","KUWAIT",0],["A345","AQ","L'AQUILA",1],["E394","TO","LA CASSA",1],["E423","TO","LA LOGGIA",1],["E425","SS","LA MADDALENA",1],["A308","AO","LA MADDALENA D'AOSTA",0],["A308","AO","LA MAGDELEINE",1],["E430","CN","LA MORRA",1],["Z324","EE","LA REUNION (ISOLA)",0],["E458","AO","LA SALLE",1],["E463","SP","LA SPEZIA",1],["E470","AO","LA THUILE",1],["E490","BL","LA VALLE",0],["E491","BZ","LA VALLE",1],["E490","BL","LA VALLE AGORDINA",1],["M348","LC","LA VALLETTA BRIANZA",1],["E392","RM","LABICO",1],["E393","RI","LABRO",1],["E395","MI","LACCHIARELLA",1],["E396","NA","LACCO",0],["E396","NA","LACCO AMENO",1],["E397","AV","LACEDONIA",1],["E398","BZ","LACES",1],["E399","BZ","LACIGNO",0],["E399","BZ","LACINIGO",0],["E400","NU","LACONI",0],["E400","OR","LACONI",1],["D079","BZ","LADINIA",0],["M212","RM","LADISPOLI",1],["E401","SS","LAERRU",1],["E402","RC","LAGANADI",1],["E403","VI","LAGHI",1],["E404","UD","LAGLESIE SAN LEOPOLDO",0],["E405","CO","LAGLIO",1],["E405","CO","LAGLIO BRIENNO",0],["E406","CN","LAGNASCO",1],["E407","CS","LAGO",1],["E408","TV","LAGO",0],["E409","PZ","LAGONEGRO",1],["E410","FE","LAGOSANTO",1],["E411","ZA","LAGOSTA",0],["M232","TN","LAGUNA MUSTE'",0],["E412","BZ","LAGUNDO",1],["E414","SV","LAIGUEGLIA",1],["E415","MI","LAINATE",1],["E416","CO","LAINO",1],["E417","CS","LAINO BORGO",1],["E418","CS","LAINO BRUZIO",0],["E419","CS","LAINO CASTELLO",1],["E420","BZ","LAION",1],["E421","BZ","LAIVES",1],["E413","PI","LAJATICO",1],["E422","BG","LALLIO",1],["C093","AP","LAMA",0],["E424","CH","LAMA",0],["E424","CH","LAMA DEI PELIGNI",1],["E426","MO","LAMA MOCOGNO",1],["E427","MI","LAMBRATE",0],["E428","CO","LAMBRUGO",1],["M208","CZ","LAMEZIA TERME",1],["E429","BL","LAMON",1],["E431","AG","LAMPEDUSA",0],["E431","AG","LAMPEDUSA E LINOSA",1],["E432","PT","LAMPORECCHIO",1],["E433","VC","LAMPORO",1],["E434","BZ","LANA",1],["E435","CH","LANCIANO",1],["E436","NO","LANDIONA",1],["E437","PV","LANDRIANO",1],["E438","PR","LANGHIRANO",1],["E439","PV","LANGOSCO",1],["E440","PL","LANISCHIE MONT'AQUILA",0],["E441","NU","LANUSEI",1],["C767","RM","LANUVIO",1],["E442","ME","LANZA",0],["E443","SO","LANZADA",1],["E444","CO","LANZO",0],["E445","TO","LANZO",0],["E444","CO","LANZO D'INTELVI",0],["E445","TO","LANZO TORINESE",1],["E446","CO","LAORCA",0],["Z228","EE","LAOS",0],["E447","AP","LAPEDONA",0],["E447","FM","LAPEDONA",1],["E448","AV","LAPIO",1],["E449","BZ","LAPPAGO",0],["E450","CS","LAPPANO",1],["E451","PT","LARCIANO",1],["E452","TN","LARDARO",0],["E453","MI","LARDERA",0],["E454","PV","LARDIRAGO",1],["E455","PI","LARI",0],["M207","RM","LARIANO",1],["M233","TN","LARIDO",0],["E456","CB","LARINO",1],["B551","GE","LARVEGO",0],["E464","CA","LAS PLASSAS",0],["E464","SU","LAS PLASSAS",1],["E457","BZ","LASA",1],["E459","PA","LASCARI",1],["E460","TS","LASE",0],["M234","TN","LASES",0],["E461","TN","LASINO",0],["E462","CO","LASNIGO",1],["E465","VI","LASTEBASSE",1],["E466","FI","LASTRA A SIGNA",1],["E467","VT","LATERA",1],["E468","AR","LATERINA",0],["M392","AR","LATERINA PERGINE VALDARNO",1],["E469","TA","LATERZA",1],["E471","BR","LATIANO",1],["E472","LT","LATINA",1],["E473","UD","LATISANA",1],["E474","PZ","LATRONICO",1],["E475","CS","LATTARICO",1],["E476","UD","LAUCO",1],["E477","BZ","LAUDES",0],["E478","FM","LAURANA",0],["E479","RC","LAUREANA",0],["E480","SA","LAUREANA",0],["E480","SA","LAUREANA CILENTO",1],["E479","RC","LAUREANA DI BORELLO",0],["E479","RC","LAUREANA DI BORRELLO",1],["E481","BZ","LAUREGNO",1],["E482","PZ","LAURENZANA",1],["E483","PZ","LAURIA",1],["E484","TO","LAURIANO",1],["E485","SA","LAURINO",1],["E486","SA","LAURITO",1],["E487","AV","LAURO",1],["E488","GE","LAVAGNA",1],["E489","VR","LAVAGNO",1],["E492","TN","LAVARONE",1],["E493","PZ","LAVELLO",1],["E494","VA","LAVENA",0],["E494","VA","LAVENA PONTE TRESA",1],["E495","VA","LAVENO",0],["E496","VA","LAVENO-MOMBELLO",1],["E497","BS","LAVENONE",1],["E498","SA","LAVIANO",1],["E499","IM","LAVINA",0],["E500","TN","LAVIS",1],["E501","BZ","LAZFONS",0],["E502","VR","LAZISE",1],["E503","AL","LAZZARONE",0],["E504","MB","LAZZATE",1],["E504","MI","LAZZATE",0],["E320","FE","LE VENEZIE",0],["E505","AQ","LECCE",0],["E506","LE","LECCE",1],["E505","AQ","LECCE NEI MARSI",1],["E507","LC","LECCO",1],["E508","GO","LEDINE",0],["M313","TN","LEDRO",1],["E509","BG","LEFFE",1],["E510","VA","LEGGIUNO",1],["E511","VA","LEGGIUNO-SANGIANO",0],["E512","VR","LEGNAGO",1],["E513","FI","LEGNAIA",0],["E514","MI","LEGNANO",1],["E515","PD","LEGNARO",1],["E516","TN","LEGOS",0],["E517","NU","LEI",1],["E518","TO","LEINI",1],["E519","GE","LEIVI",1],["E520","TO","LEMIE",1],["E521","CO","LEMNA",0],["E522","RO","LENDINARA",1],["E523","ME","LENI",1],["E524","BG","LENNA",1],["E525","CO","LENNO",0],["E526","BS","LENO",1],["E527","LT","LENOLA",1],["E528","VC","LENTA",1],["E529","CO","LENTATE",0],["E530","MI","LENTATE",0],["E530","MB","LENTATE SUL SEVESO",1],["E530","MI","LENTATE SUL SEVESO",0],["E529","CO","LENTATE VERBANO",0],["E531","CH","LENTELLA",1],["C562","BL","LENTIAI",0],["E532","SR","LENTINI",1],["E533","TN","LENZIMA",0],["E534","TN","LENZUMO",0],["E535","RI","LEONESSA",1],["E536","EN","LEONFORTE",1],["E537","TA","LEPORANO",1],["B649","RM","LEPRIGNANO",0],["E538","LE","LEQUILE",1],["E539","CN","LEQUIO",0],["E540","CN","LEQUIO",0],["E540","CN","LEQUIO BERRIA",1],["E539","CN","LEQUIO TANARO",1],["E541","PA","LERCARA FRIDDI",1],["E542","SP","LERICI",1],["E543","AL","LERMA",1],["E544","NO","LESA",1],["E545","NO","LESA-BELGIRATE",0],["E546","CN","LESEGNO",1],["E547","PR","LESIGNANO DE' BAGNI",1],["E548","PR","LESIGNANO DI PALMIA",0],["E549","FG","LESINA",1],["E550","MB","LESMO",1],["E550","MI","LESMO",0],["Z359","EE","LESOTHO",0],["E551","TO","LESSOLO",1],["E552","BI","LESSONA",0],["M371","BI","LESSONA",1],["E553","UD","LESTIZZA",1],["E554","CE","LETINO",1],["E555","ME","LETOJANNI",1],["E556","ME","LETOJANNI GALLODORO",0],["E557","NA","LETTERE",1],["E558","PE","LETTOMANOPPELLO",1],["Z145","EE","LETTONIA",0],["E559","CH","LETTOPALENA",1],["E560","SP","LEVANTO",1],["E561","CR","LEVATA",0],["E562","BG","LEVATE",1],["E563","LE","LEVERANO",1],["E564","CN","LEVICE",1],["E565","TN","LEVICO",0],["E565","TN","LEVICO TERME",1],["E566","TO","LEVONE",1],["E567","BS","LEVRANGE",0],["E518","TO","LEYNI",0],["E568","CO","LEZZA",0],["E569","CO","LEZZENO",1],["Z229","EE","LIBANO",0],["E570","CE","LIBERI",1],["Z325","EE","LIBERIA",0],["Z326","EE","LIBIA",0],["E571","ME","LIBRIZZI",1],["E572","GO","LIBUSSINA",0],["E573","AG","LICATA",1],["E574","MS","LICCIANA",0],["E574","MS","LICCIANA NARDI",1],["E575","CR","LICENGO",0],["E576","RM","LICENZA",1],["E577","NA","LICIGNANO",0],["E577","NA","LICIGNANO DI NAPOLI",0],["E578","CT","LICODIA",0],["E578","CT","LICODIA EUBEA",1],["E579","PV","LICONASCO",0],["E580","SA","LICUSATI",0],["Z119","EE","LIECHTENSTEIN",0],["E581","LC","LIERNA",1],["E582","CO","LIETO COLLE",0],["E583","VC","LIGNANA",1],["E584","UD","LIGNANO SABBIADORO",1],["E585","RE","LIGONCHIO",0],["E586","UD","LIGOSULLO",0],["E587","AO","LILLIANA",0],["E587","AO","LILLIANES",1],["E588","BL","LIMANA",1],["E589","BN","LIMATOLA",1],["E590","VV","LIMBADI",1],["E591","MB","LIMBIATE",1],["E591","MI","LIMBIATE",0],["E592","PD","LIMENA",1],["E593","CO","LIMIDO",0],["E593","CO","LIMIDO COMASCO",1],["E594","ME","LIMINA",1],["E595","MI","LIMITO",0],["E596","BS","LIMONE",0],["E597","CN","LIMONE",0],["E596","BS","LIMONE DI SAN GIOVANNI",0],["E597","CN","LIMONE PIEMONTE",1],["E596","BS","LIMONE SUL GARDA",1],["E598","CO","LIMONTA",0],["E599","CB","LIMOSANO",1],["E600","PV","LINAROLO",1],["E601","MI","LINATE AL LAMBRO",0],["E602","CT","LINGUAGLOSSA",1],["E603","IM","LINGUEGLIETTA",0],["E604","CO","LINZANICO",0],["E605","AV","LIONI",1],["E606","ME","LIPARI",1],["E607","CO","LIPOMO",1],["E608","PV","LIRIO",1],["E609","VA","LISANZA",0],["E610","MI","LISCATE",1],["E611","CH","LISCIA",1],["E612","AP","LISCIANO",0],["E613","PG","LISCIANO",0],["E612","AP","LISCIANO DEL TRONTO",0],["E613","PG","LISCIANO NICCONE",1],["E614","TN","LISIGNAGO",0],["E615","CN","LISIO",1],["E616","VA","LISSAGO",0],["E617","MB","LISSONE",1],["E617","MI","LISSONE",0],["E472","RM","LITTORIA",0],["E618","CL","LITTORIA NISSENA",0],["Z146","EE","LITUANIA",0],["E619","BS","LIVEMMO",0],["E620","NA","LIVERI",1],["E621","SO","LIVIGNO",1],["E622","BL","LIVINALLONGO",0],["E622","BL","LIVINALLONGO DEL COL DI LANA",1],["E623","CO","LIVO",1],["E624","TN","LIVO",1],["E625","LI","LIVORNO",1],["E626","VC","LIVORNO FERRARIS",1],["E626","NO","LIVORNO PIEMONTE",0],["E626","NO","LIVORNO VERCELLESE",0],["E627","LO","LIVRAGA",1],["E628","TN","LIZZANA",0],["E629","LE","LIZZANELLO",1],["E630","TA","LIZZANO",1],["A771","BO","LIZZANO IN BELVEDERE",1],["E631","BG","LIZZOLA",0],["E632","SV","LOANO",1],["E633","AT","LOAZZOLO",1],["E634","ME","LOCADI",0],["E635","TO","LOCANA",1],["E636","VC","LOCARNO",0],["E637","BG","LOCATE",0],["E638","CO","LOCATE",0],["E639","MI","LOCATE",0],["E637","BG","LOCATE BERGAMASCO",0],["E639","MI","LOCATE DI TRIULZI",1],["E638","CO","LOCATE VARESINO",1],["E640","BG","LOCATELLO",1],["E641","GO","LOCAVIZZA DI AIDUSSINA",0],["E642","GO","LOCAVIZZA DI CANALE",0],["E643","TN","LOCCA",0],["E644","NU","LOCERI",1],["E645","BA","LOCOROTONDO",1],["D976","RC","LOCRI",1],["E646","NU","LOCULI",1],["E647","NU","LODE'",1],["E648","LO","LODI",1],["E651","LO","LODI VECCHIO",1],["E649","NU","LODINE",1],["E650","GE","LODISIO",0],["E652","BS","LODRINO",1],["E653","TN","LODRONE",0],["E654","BS","LOGRATO",1],["E655","BO","LOIANO",1],["M275","SS","LOIRI PORTO SAN PAOLO",1],["E656","LC","LOMAGNA",1],["E657","CO","LOMANIGA",0],["E658","TN","LOMASO",0],["E659","CO","LOMAZZO",1],["E660","TO","LOMBARDORE",1],["E661","TO","LOMBRIASCO",1],["E662","PV","LOMELLO",1],["A918","VA","LOMNAGO",0],["E663","TN","LON",0],["M235","TN","LONA",0],["E664","TN","LONA LASES",0],["E664","TN","LONA-LASES",1],["E665","VA","LONATE CEPPINO",1],["E666","VA","LONATE POZZOLO",1],["E667","BS","LONATO",0],["M312","BS","LONATO DEL GARDA",1],["E668","FI","LONDA",1],["E669","IS","LONGANO",1],["E670","CR","LONGARDORE",0],["E671","VI","LONGARE",1],["E672","BL","LONGARONE",0],["M342","BL","LONGARONE",1],["E673","BS","LONGHENA",1],["E674","ME","LONGI",1],["E675","FC","LONGIANO",1],["E676","BZ","LONGIARU'",0],["E677","CS","LONGOBARDI",1],["E678","CS","LONGOBUCCO",1],["E679","CO","LONGONE",0],["E680","LI","LONGONE",0],["E681","RI","LONGONE",0],["E679","CO","LONGONE AL SEGRINO",1],["E681","RI","LONGONE DI SAN SALVATORE MAGGIORE",0],["E681","RI","LONGONE SABINO",1],["E682","VI","LONIGO",1],["E683","TO","LORANZE'",1],["E684","PD","LOREGGIA",1],["E685","VB","LOREGLIA",1],["E686","BG","LORENTINO",0],["E687","BL","LORENZAGO",0],["E687","BL","LORENZAGO DI CADORE",1],["E688","PI","LORENZANA",0],["E689","RO","LOREO",1],["E690","AN","LORETO",1],["E691","PE","LORETO",0],["E691","PE","LORETO APRUTINO",1],["E692","TV","LORIA",1],["E693","AR","LORO",0],["E694","MC","LORO",0],["E693","AR","LORO CIUFFENNA",1],["E694","MC","LORO PICENO",1],["E695","GE","LORSICA",1],["E696","GO","LOSE",0],["E697","BA","LOSETO",0],["E698","BS","LOSINE",1],["E699","CN","LOTTULO",0],["E700","NU","LOTZORAI",1],["E701","BS","LOVENO",0],["E702","CO","LOVENO",0],["E701","BS","LOVENO GRUMELLO",0],["E702","CO","LOVENO SOPRA MENAGGIO",0],["E703","TN","LOVER",0],["E704","BG","LOVERE",1],["E705","SO","LOVERO",1],["E706","BS","LOZIO",1],["E707","VA","LOZZA",1],["E708","BL","LOZZO",0],["E709","PD","LOZZO",0],["E710","VA","LOZZO",0],["E709","PD","LOZZO ATESTINO",1],["E708","BL","LOZZO CADORE",0],["E708","BL","LOZZO DI CADORE",1],["E711","VC","LOZZOLO",1],["E712","AL","LU",0],["M420","AL","LU E CUCCARO MONFERRATO",1],["E713","VT","LUBRIANO",1],["E714","AG","LUCCA",0],["E715","LU","LUCCA",1],["E714","AG","LUCCA SICULA",1],["E716","FG","LUCERA",1],["E717","MI","LUCERNATE",0],["E718","AR","LUCIGNANO",1],["E719","IM","LUCINASCO",1],["E720","GO","LUCINICO",0],["E721","CO","LUCINO",0],["E722","CB","LUCITO",1],["E723","AQ","LUCO DEI MARSI",1],["E724","AQ","LUCOLI",1],["E725","BS","LUDRIANO",0],["C033","MI","LUGAGNANO",0],["E726","PC","LUGAGNANO",0],["E726","PC","LUGAGNANO VAL D'ARDA",1],["E727","TO","LUGNACCO",0],["E392","RM","LUGNANO",0],["E728","RI","LUGNANO",0],["E729","TR","LUGNANO",0],["E728","RI","LUGNANO DI VILLA TROIANA",0],["E729","TR","LUGNANO IN TEVERINA",1],["E392","RM","LUGNANO LABICANO",0],["E730","RA","LUGO",1],["E731","VI","LUGO",0],["E731","VI","LUGO DI VICENZA",1],["E732","GO","LUICO",0],["E733","CR","LUIGNANO",0],["E734","VA","LUINO",1],["E735","CO","LUISAGO",1],["E736","NU","LULA",1],["E737","GE","LUMARZO",1],["E738","BS","LUMEZZANE",1],["E739","BS","LUMEZZANE PIEVE",0],["E740","BS","LUMEZZANE SAN SEBASTIANO",0],["E741","BS","LUMEZZANE SANT'APOLLONIO",0],["E742","CA","LUNAMATRONA",0],["E742","SU","LUNAMATRONA",1],["E743","PU","LUNANO",1],["E744","TN","LUNDO",0],["B387","PV","LUNGAVILLA",1],["E745","CS","LUNGRO",1],["G143","SP","LUNI",1],["E746","AV","LUOGOSANO",1],["E747","SS","LUOGOSANTO",1],["E748","CB","LUPARA",1],["E749","CO","LURAGO",0],["E749","CO","LURAGO D'ERBA",1],["E750","CO","LURAGO MARINONE",1],["E751","BG","LURANO",1],["E752","SS","LURAS",1],["E753","CO","LURATE ABBATE",0],["E753","CO","LURATE CACCIVIO",1],["E754","CE","LUSCIANO",1],["E755","CE","LUSCIANO E DUCENTA",0],["E756","TO","LUSERNA",0],["E757","TN","LUSERNA",1],["E758","TO","LUSERNA SAN GIOVANNI",1],["E759","TO","LUSERNETTA",1],["E760","UD","LUSEVERA",1],["E761","RO","LUSIA",1],["E762","VI","LUSIANA",0],["M427","VI","LUSIANA CONCO",1],["E763","TO","LUSIGLIE'",1],["E764","BZ","LUSON",1],["Z120","EE","LUSSEMBURGO",0],["E765","PL","LUSSINGRANDE",0],["E766","PL","LUSSINPICCOLO",0],["E767","SA","LUSTRA",1],["E768","BZ","LUTAGO",0],["E769","VA","LUVINATE",1],["E734","CO","LUVINO",0],["E770","BG","LUZZANA",1],["E771","BN","LUZZANO",0],["E772","RE","LUZZARA",1],["E773","CS","LUZZI",1],["E774","NO","LUZZOGNO",0],["Z231","EE","MACAO",0],["E775","VA","MACCAGNO",0],["M339","VA","MACCAGNO CON PINO E VEDDASCA",1],["E776","VA","MACCAGNO INFERIORE",0],["E775","VA","MACCAGNO SUPERIORE",0],["E777","LO","MACCASTORNA",1],["E778","IS","MACCHIA D'ISERNIA",1],["E780","CB","MACCHIA VALFORTORE",1],["E779","IS","MACCHIAGODENA",1],["E781","CO","MACCIO",0],["Z148","EE","MACEDONIA",0],["Z148","EE","MACEDONIA DEL NORD",0],["E782","TO","MACELLO",1],["E783","MC","MACERATA",1],["E784","NA","MACERATA",0],["E784","CE","MACERATA CAMPANIA",1],["E785","PU","MACERATA FELTRIA",1],["E784","CE","MACERATA MARCIANISE",0],["E786","MB","MACHERIO",1],["E786","MI","MACHERIO",0],["E787","BS","MACLODIO",1],["E788","NU","MACOMER",1],["Z708","EE","MACQUARIE (ISOLE)",0],["E789","CN","MACRA",1],["E790","VB","MACUGNAGA",1],["Z327","EE","MADAGASCAR",0],["E791","CE","MADDALONI",1],["E792","BS","MADERNO",0],["E342","SO","MADESIMO",1],["M236","TN","MADICE",0],["E793","CR","MADIGNANO",1],["E794","BG","MADONE",1],["E795","VB","MADONNA DEL SASSO",1],["E796","TN","MADRANO",0],["E797","TN","MADRUZZO",0],["M357","TN","MADRUZZO",1],["E798","LT","MAENZA",1],["E799","CB","MAFALDA",1],["E800","BS","MAGASA",1],["E801","MI","MAGENTA",1],["E802","CO","MAGGIANICO",0],["E803","NO","MAGGIORA",1],["E804","PV","MAGHERNO",1],["E805","PG","MAGIONE",1],["E806","CZ","MAGISANO",1],["E807","AP","MAGLIANO",0],["E808","CN","MAGLIANO",0],["E809","CN","MAGLIANO",0],["E810","GR","MAGLIANO",0],["E811","AQ","MAGLIANO",0],["E812","RI","MAGLIANO",0],["E809","CN","MAGLIANO ALFIERI",1],["E808","CN","MAGLIANO ALPI",1],["E809","CN","MAGLIANO D'ALBA",0],["E811","AQ","MAGLIANO DE' MARSI",1],["E807","AP","MAGLIANO DI TENNA",0],["E807","FM","MAGLIANO DI TENNA",1],["E810","GR","MAGLIANO IN TOSCANA",1],["E813","RM","MAGLIANO ROMANO",1],["E812","RI","MAGLIANO SABINA",1],["E814","SA","MAGLIANO VETERE",1],["E815","LE","MAGLIE",1],["E816","SV","MAGLIOLO",1],["E817","TO","MAGLIONE",1],["E818","MN","MAGNACAVALLO",1],["E819","MI","MAGNAGO",1],["E820","UD","MAGNANO",0],["E821","BI","MAGNANO",1],["E820","UD","MAGNANO IN RIVIERA",1],["E823","BS","MAGNO SOPRA INZINO",0],["E822","GE","MAGNONE",0],["E824","NO","MAGOGNINO",0],["E825","NU","MAGOMADAS",0],["E825","OR","MAGOMADAS",1],["E826","TN","MAGRAS",0],["E828","VI","MAGRE",0],["E828","VI","MAGRE VICENTINO",0],["E827","TN","MAGRE'",0],["E829","BZ","MAGRE' ALL'ADIGE",0],["E829","BZ","MAGRE' SULLA STRADA DEL VINO",1],["E830","CO","MAGREGLIO",1],["E831","BZ","MAIA ALTA",0],["E832","BZ","MAIA BASSA",0],["E834","CZ","MAIDA",1],["E835","CS","MAIERA'",1],["E836","VV","MAIERATO",1],["E837","AN","MAIOLATI",0],["E837","AN","MAIOLATI SPONTINI",1],["E838","PU","MAIOLO",0],["E838","RN","MAIOLO",1],["E839","SA","MAIORI",1],["E840","LO","MAIRAGO",1],["E841","BS","MAIRANO",1],["E842","SP","MAISSANA",1],["E833","UD","MAJANO",1],["M237","TN","MALA",0],["E843","CR","MALAGNINO",1],["E844","BO","MALALBERGO",1],["E845","VE","MALAMOCCO",0],["Z328","EE","MALAWI",0],["Z230","EE","MALAYSIA",0],["Z247","EE","MALAYSIA",0],["E846","UD","MALBORGHETTO",0],["E847","UD","MALBORGHETTO VALBRUNA",1],["E847","UD","MALBORGHETTO-VALBRUNA",0],["E848","VR","MALCESINE",1],["E849","TS","MALCHINA",0],["Z232","EE","MALDIVE",0],["E850","TN","MALE'",1],["E851","BS","MALEGNO",1],["E852","LO","MALEO",1],["E853","VB","MALESCO",1],["E854","CT","MALETTO",1],["E855","ME","MALFA",1],["E856","VA","MALGESSO",1],["E857","TN","MALGOLO",0],["E858","LC","MALGRATE",1],["Z329","EE","MALI",0],["E859","CS","MALITO",1],["E860","SV","MALLARE",1],["E861","BZ","MALLES",0],["E862","BZ","MALLES VENOSTA",1],["E863","VA","MALNATE",1],["E864","VI","MALO",1],["E865","BS","MALONNO",1],["E866","TN","MALOSCO",0],["E867","CN","MALPOTREMO",0],["Z121","EE","MALTA",0],["E868","AP","MALTIGNANO",1],["E869","ME","MALVAGNA",1],["E870","AL","MALVICINO",1],["Z609","EE","MALVINE=FALKLAND (ISOLE)",0],["E871","AL","MALVINO",0],["E872","CS","MALVITO",1],["E873","RC","MAMMOLA",1],["E874","NU","MAMOIADA",1],["Z122","EE","MAN (ISOLA)",0],["E875","GR","MANCIANO",1],["E876","ME","MANDANICI",1],["E877","CA","MANDAS",0],["E877","SU","MANDAS",1],["E878","CS","MANDATORICCIO",1],["B632","RM","MANDELA",1],["E879","CO","MANDELLO",0],["E880","NO","MANDELLO",0],["E879","LC","MANDELLO DEL LARIO",1],["E880","NO","MANDELLO VITTA",1],["E881","PV","MANDRINO",0],["E882","TA","MANDURIA",1],["E883","BS","MANERBA",0],["E883","BS","MANERBA DEL GARDA",1],["E884","BS","MANERBIO",1],["E885","FG","MANFREDONIA",1],["E886","PV","MANGIALUPO",0],["E887","CN","MANGO",1],["E888","CS","MANGONE",1],["M283","CT","MANIACE",1],["E889","PN","MANIAGO",1],["E890","TO","MANIGLIA",0],["E891","AV","MANOCALZATI",1],["E892","PE","MANOPPELLO",1],["E893","TV","MANSUE'",1],["E894","CN","MANTA",1],["E895","BZ","MANTANA",0],["E896","SO","MANTELLO",1],["E897","MN","MANTOVA",1],["E898","TN","MANZANO",0],["E899","UD","MANZANO",1],["E900","RM","MANZIANA",1],["E901","BG","MAPELLO",1],["M316","TO","MAPPANO",1],["E902","SS","MARA",1],["E903","CA","MARACALAGONIS",1],["E904","MO","MARANELLO",1],["D210","AP","MARANO",0],["E905","MO","MARANO",0],["E906","NA","MARANO",0],["E907","NO","MARANO",0],["E908","RM","MARANO",0],["E909","TN","MARANO",0],["E910","UD","MARANO",0],["E911","VR","MARANO",0],["E912","VI","MARANO",0],["E906","NA","MARANO DI NAPOLI",1],["E911","VR","MARANO DI VALPOLICELLA",1],["E908","RM","MARANO EQUO",1],["E910","UD","MARANO LACUNARE",0],["E910","UD","MARANO LAGUNARE",1],["E914","CS","MARANO MARCHESATO",1],["E915","CS","MARANO PRINCIPATO",1],["E905","MO","MARANO SUL PANARO",1],["E907","NO","MARANO TICINO",1],["E912","VI","MARANO VICENTINO",1],["E913","LT","MARANOLA",0],["E916","BZ","MARANZA",0],["E916","BZ","MARANZA IN PUSTERIA",0],["E917","AT","MARANZANA",1],["E918","GE","MARASSI",0],["E919","PZ","MARATEA",1],["E920","MI","MARCALLO",0],["E921","MI","MARCALLO CON CASONE",1],["E922","MN","MARCARIA",1],["E923","CZ","MARCEDUSA",1],["E924","RM","MARCELLINA",1],["E925","CZ","MARCELLINARA",1],["E926","VR","MARCELLISE",0],["E927","RI","MARCETELLI",1],["E928","BS","MARCHENO",1],["E929","VA","MARCHIROLO",1],["E930","LI","MARCIANA",1],["E931","LI","MARCIANA MARINA",1],["E932","CE","MARCIANISE",1],["E933","AR","MARCIANO DELLA CHIANA",1],["E934","PV","MARCIGNAGO",1],["E935","TN","MARCO",0],["E936","VE","MARCON",1],["E937","TO","MARCORENGO",0],["Z709","EE","MARCUS (ISOLE)",0],["E938","BZ","MAREBBE",1],["E939","CN","MARENE",1],["E940","TV","MARENO",0],["E940","TV","MARENO DI PIAVE",1],["E941","TO","MARENTINO",1],["E942","PL","MARESEGO",0],["E943","BZ","MARETA",0],["E944","AT","MARETTO",1],["E945","CN","MARGARITA",1],["E946","BT","MARGHERITA DI SAVOIA",1],["E946","FG","MARGHERITA DI SAVOIA",0],["E947","LC","MARGNO",1],["E948","TN","MARGONE",0],["E949","MN","MARIANA",0],["E949","MN","MARIANA MANTOVANA",1],["Z710","EE","MARIANNE (ISOLE)",0],["E950","BG","MARIANO",0],["E951","CO","MARIANO",0],["E952","GO","MARIANO",0],["E950","BG","MARIANO AL BREMBO",0],["E951","CO","MARIANO COMENSE",1],["E952","GO","MARIANO DEL FRIULI",1],["E953","CL","MARIANOPOLI",1],["E954","NA","MARIGLIANELLA",1],["E955","NA","MARIGLIANO",1],["E956","RC","MARINA DI GIOIOSA IONICA",1],["E957","PA","MARINEO",1],["E958","RM","MARINO",1],["E959","BZ","MARLENGO",1],["E960","PT","MARLIANA",1],["E961","BS","MARMENTINO",1],["E962","MN","MARMIROLO",1],["E963","CN","MARMORA",1],["E964","AT","MARMORITO",0],["E965","VA","MARNATE",1],["D588","BG","MARNE",0],["E966","IM","MARO CASTELLO",0],["Z330","EE","MAROCCO",0],["E967","BS","MARONE",1],["E968","RC","MAROPATI",1],["E969","PR","MARORE",0],["E970","VI","MAROSTICA",1],["E971","FI","MARRADI",1],["E972","OR","MARRUBIU",1],["E973","CN","MARSAGLIA",1],["E974","TP","MARSALA",1],["E975","PG","MARSCIANO",1],["Z711","EE","MARSHALL",0],["Z711","EE","MARSHALL (ISOLE)",0],["E976","PZ","MARSICO NUOVO",1],["E977","PZ","MARSICOVETERE",1],["E978","VT","MARTA",1],["E979","LE","MARTANO",1],["E980","VE","MARTELLAGO",1],["E981","BZ","MARTELLO",1],["E982","UD","MARTIGNACCO",1],["E983","CR","MARTIGNANA",0],["E983","CR","MARTIGNANA DI PO",1],["E984","LE","MARTIGNANO",1],["E985","GE","MARTINA",0],["E986","TA","MARTINA",0],["E986","TA","MARTINA FRANCA",1],["E985","SV","MARTINA OLBA",0],["E987","BG","MARTINENGO",1],["E988","CN","MARTINIANA",0],["E988","CN","MARTINIANA PO",1],["Z513","EE","MARTINICA",0],["E989","TE","MARTINSICURO",1],["E990","CZ","MARTIRANO",1],["E991","CZ","MARTIRANO LOMBARDO",1],["E992","SS","MARTIS",1],["E993","RC","MARTONE",1],["E994","LO","MARUDO",1],["E995","TA","MARUGGIO",1],["B689","BO","MARZABOTTO",1],["E996","CR","MARZALENGO",0],["E997","AV","MARZANO",0],["E998","CE","MARZANO",0],["E999","PV","MARZANO",1],["E998","CE","MARZANO APPIO",1],["E997","AV","MARZANO DI NOLA",1],["F001","CS","MARZI",1],["F002","VA","MARZIO",1],["M270","CA","MASAINAS",0],["M270","SU","MASAINAS",1],["F003","MI","MASATE",1],["F004","CT","MASCALI",1],["F005","CT","MASCALUCIA",1],["F006","PZ","MASCHITO",1],["F007","CO","MASCIAGO",0],["F008","MI","MASCIAGO",0],["F008","MI","MASCIAGO MILANESE",0],["F007","VA","MASCIAGO PRIMO",1],["F009","TV","MASER",1],["F010","VB","MASERA",1],["F011","PD","MASERA'",0],["F011","PD","MASERA' DI PADOVA",1],["F012","TV","MASERADA",0],["F012","TV","MASERADA SUL PIAVE",1],["F013","PD","MASI",1],["F014","TN","MASI DI VIGO",0],["F016","FE","MASI TORELLO",1],["B733","TO","MASINO",0],["F015","AL","MASIO",1],["F017","CO","MASLIANICO",1],["F018","VA","MASNAGO",0],["F019","VI","MASON",0],["F019","VI","MASON VICENTINO",0],["F020","GE","MASONE",1],["F021","AP","MASSA",0],["F022","AQ","MASSA",0],["F023","MS","MASSA",1],["F024","PG","MASSA",0],["F022","AQ","MASSA D'ALBE",1],["C495","NA","MASSA DI SOMMA",0],["M289","NA","MASSA DI SOMMA",1],["F025","PT","MASSA E COZZILE",1],["F021","AP","MASSA FERMANA",0],["F021","FM","MASSA FERMANA",1],["F026","FE","MASSA FISCAGLIA",0],["F029","RA","MASSA LOMBARDA",1],["F030","NA","MASSA LUBRENSE",1],["F032","GR","MASSA MARITTIMA",1],["F024","PG","MASSA MARTANA",1],["F036","RO","MASSA SUPERIORE",0],["F023","MS","MASSA-CARRARA",0],["D211","AN","MASSACCIO",0],["F027","TA","MASSAFRA",1],["F028","LO","MASSALENGO",1],["F031","CA","MASSAMA",0],["F033","PD","MASSANZAGO",1],["F034","BG","MASSARI-MELZI",0],["F035","LU","MASSAROSA",1],["F037","BI","MASSAZZA",1],["F038","SI","MASSE DEL TERZO DI CITTA'",0],["F038","SI","MASSE DI CITTA'",0],["F039","SI","MASSE DI SAN MARTINO",0],["F040","SI","MASSE DI SIENA",0],["F041","TO","MASSELLO",1],["F042","BI","MASSERANO",1],["F043","NA","MASSERIE",0],["F044","AP","MASSIGNANO",1],["F045","TN","MASSIMENO",1],["F046","SV","MASSIMINO",1],["F047","NO","MASSINO",0],["F047","NO","MASSINO VISCONTI",1],["F048","VB","MASSIOLA",1],["F049","TN","MASTELLINA",0],["F050","OR","MASULLAS",1],["F051","MC","MATELICA",1],["F052","MT","MATERA",1],["F053","TO","MATHI",1],["F053","TO","MATI",0],["F054","LE","MATINO",1],["F055","CB","MATRICE",1],["F056","TN","MATTARELLO",0],["F057","FM","MATTERIA",0],["F058","TO","MATTIE",1],["F059","FG","MATTINATA",1],["F060","FM","MATTUGLIE",0],["E849","TS","MAUCHINIE",0],["Z331","EE","MAURITANIA",0],["Z332","EE","MAURIZIO",0],["Z332","EE","MAURIZIO (ISOLE)",0],["Z360","EE","MAYOTTE (ISOLA)",0],["F061","TP","MAZARA",0],["F061","TP","MAZARA DEL VALLO",1],["F062","BZ","MAZIA",0],["F063","BS","MAZZANO",1],["F064","RM","MAZZANO",0],["F064","RM","MAZZANO ROMANO",1],["F066","ME","MAZZARA'",0],["F065","CL","MAZZARINO",1],["F066","ME","MAZZARRA' SANT'ANDREA",1],["M271","CT","MAZZARRONE",1],["F067","TO","MAZZE'",1],["F068","TN","MAZZIN",1],["F069","MI","MAZZO",0],["F070","SO","MAZZO",0],["F070","SO","MAZZO DI VALTELLINA",1],["F069","MI","MAZZO MILANESE",0],["F071","BG","MAZZOLENI E FALGHERA",0],["F072","BS","MAZZUNNO",0],["F073","CA","MEANA",0],["F074","TO","MEANA",0],["F074","TO","MEANA DI SUSA",1],["F073","NU","MEANA SARDO",1],["F075","TO","MEANO",0],["F076","TN","MEANO",0],["F077","TN","MECHEL",0],["F078","MB","MEDA",1],["F078","MI","MEDA",0],["F079","GO","MEDANA",0],["F080","PV","MEDE",1],["F081","GO","MEDEA",1],["F082","PR","MEDESANO",1],["F083","BO","MEDICINA",1],["F084","MI","MEDIGLIA",1],["F085","BG","MEDOLAGO",1],["F086","MN","MEDOLE",1],["F087","MO","MEDOLLA",1],["F088","TV","MEDUNA",0],["F088","TV","MEDUNA DI LIVENZA",1],["F089","PN","MEDUNO",1],["F090","PG","MEGGIANO",0],["F091","PD","MEGLIADINO SAN FIDENZIO",0],["F092","PD","MEGLIADINO SAN VITALE",1],["F093","NO","MEINA",1],["F094","BL","MEL",0],["F095","RO","MELARA",1],["F096","AL","MELAZZO",1],["F097","FC","MELDOLA",1],["F098","GE","MELE",1],["F099","MI","MELEGNANELLO",0],["F100","MI","MELEGNANO",1],["F101","LE","MELENDUGNO",1],["F102","LO","MELETI",1],["F103","TO","MELEZET",0],["F104","PZ","MELFI",1],["F105","RC","MELICUCCA'",1],["F106","RC","MELICUCCO",1],["F107","SR","MELILLI",1],["F108","KR","MELISSA",1],["F109","LE","MELISSANO",1],["F110","AV","MELITO",0],["F111","NA","MELITO",0],["F112","RC","MELITO",0],["F111","NA","MELITO DI NAPOLI",1],["F112","RC","MELITO DI PORTO SALVO",1],["F110","AV","MELITO IRPINO",1],["F110","AV","MELITO VALLE BONITO",0],["F113","BN","MELIZZANO",1],["F114","CN","MELLE",1],["F115","SO","MELLO",1],["F116","TV","MELMA",0],["F117","LE","MELPIGNANO",1],["F118","BZ","MELTINA",1],["F119","MI","MELZO",1],["F120","CO","MENAGGIO",1],["F121","SO","MENAROLA",0],["M238","TN","MENAS",0],["F122","PV","MENCONICO",1],["F123","IM","MENDATICA",1],["F124","IM","MENDATICA-MONTEGROSSO",0],["F125","CS","MENDICINO",1],["B986","MI","MENEDRAGO",0],["F126","AG","MENFI",1],["F127","RM","MENTANA",1],["F128","TO","MENTOULLES",0],["F129","MI","MENZAGO",0],["F130","VE","MEOLO",1],["F131","AL","MERANA",1],["F132","BZ","MERANO",1],["F133","LC","MERATE",1],["F134","VA","MERCALLO",1],["F135","PU","MERCATELLO",0],["F135","PU","MERCATELLO SUL METAURO",1],["F136","PU","MERCATINO CONCA",1],["F137","PU","MERCATINO MARECCHIA",0],["F138","SA","MERCATO",0],["F138","SA","MERCATO SAN SEVERINO",1],["F139","FC","MERCATO SARACENO",1],["F140","TO","MERCENASCO",1],["F141","AV","MERCOGLIANO",1],["F142","MI","MERCUGNANO",0],["F143","NO","MERCURAGO",0],["F144","UD","MERETO DI TOMBA",1],["F144","UD","MERETTO DI TOMBA",0],["F145","AN","MERGO",1],["F146","VB","MERGOZZO",1],["F147","ME","MERI'",1],["F148","PD","MERLARA",1],["F149","LO","MERLINO",1],["F150","GO","MERNA",0],["F151","CO","MERONE",1],["F152","BR","MESAGNE",1],["F153","SO","MESE",1],["F154","VA","MESENZANA",1],["F155","MI","MESERO",1],["F156","FE","MESOLA",1],["F157","KR","MESORACA",1],["Z514","EE","MESSICO",0],["F158","ME","MESSINA",1],["F159","VE","MESTRE",0],["F160","TN","MESTRIAGO",0],["F161","PD","MESTRINO",1],["F162","NA","META",1],["A987","PR","METTI E POZZOLO",0],["F163","MI","METTONE",0],["F164","TO","MEUGLIANO",0],["F165","MB","MEZZAGO",1],["F165","MI","MEZZAGO",0],["F166","MI","MEZZANA",0],["F167","NO","MEZZANA",0],["F168","TN","MEZZANA",1],["F169","VA","MEZZANA",0],["F170","PV","MEZZANA BIGLI",1],["F166","MI","MEZZANA CASATI",0],["B089","PV","MEZZANA CORTI BOTTARONE",0],["F167","BI","MEZZANA MORTIGLIENGO",1],["F171","PV","MEZZANA RABATTONE",1],["F169","VA","MEZZANA SUPERIORE",0],["F172","VR","MEZZANE DI SOTTO",1],["F173","GE","MEZZANEGO",1],["F174","PR","MEZZANI",0],["F175","PV","MEZZANINO",1],["F176","TN","MEZZANO",1],["F180","PV","MEZZANO",0],["F177","TN","MEZZANO IMER",0],["F178","PV","MEZZANO PARPANESE",0],["F179","MI","MEZZANO PASSONE",0],["F180","PV","MEZZANO SICCOMARIO",0],["D731","BZ","MEZZASELVA",0],["D731","BZ","MEZZASELVA ALL'ISARCO",0],["E601","MI","MEZZATE",0],["F181","CO","MEZZEGRA",0],["F182","TO","MEZZENILE",1],["F183","TN","MEZZOCORONA",1],["F184","PA","MEZZOJUSO",1],["F185","TN","MEZZOLAGO",0],["F186","BG","MEZZOLDO",1],["F187","TN","MEZZOLOMBARDO",1],["F188","NO","MEZZOMERICO",1],["F189","BI","MIAGLIANO",1],["F190","TV","MIANE",1],["F191","NO","MIASINO",1],["F192","VB","MIAZZINA",1],["F193","RI","MICIGLIANO",1],["Z735","EE","MICRONESIA STATI FEDERATI",0],["Z712","EE","MIDWAY (ISOLE)",0],["F194","LE","MIGGIANO",1],["F195","NO","MIGIANDONE",0],["F196","CH","MIGLIANICO",1],["F197","AV","MIGLIANO",0],["F198","FE","MIGLIARINO",0],["F199","FE","MIGLIARO",0],["F200","CZ","MIGLIERINA",1],["F201","MT","MIGLIONICO",1],["F202","GE","MIGNANEGO",1],["F203","CE","MIGNANO",0],["F203","CE","MIGNANO MONTE LUNGO",1],["F204","MI","MIGNETE",0],["F204","MI","MIGNETTES",0],["F205","MI","MILANO",1],["F206","ME","MILAZZO",1],["E618","CL","MILENA",1],["F207","VV","MILETO",1],["F208","OR","MILIS",1],["F209","CT","MILITELLO",0],["F210","ME","MILITELLO",0],["F209","CT","MILITELLO IN VAL DI CATANIA",1],["F210","ME","MILITELLO ROSMARINO",1],["F211","BZ","MILLAN-SARNES",0],["F212","TO","MILLAURES",0],["F213","SV","MILLESIMO",1],["F214","CT","MILO",1],["E618","CL","MILOCCA",0],["F215","BS","MILZANELLO",0],["F216","BS","MILZANO",1],["F217","CT","MINEO",1],["F218","VR","MINERBE",1],["F219","BO","MINERBIO",1],["F220","BA","MINERVINO",0],["F221","LE","MINERVINO",0],["F221","LE","MINERVINO DI LECCE",1],["F220","BA","MINERVINO MURGE",0],["F220","BT","MINERVINO MURGE",1],["F222","CO","MINOPRIO",0],["F223","SA","MINORI",1],["F224","LT","MINTURNO",1],["F225","LU","MINUCCIANO",1],["F226","SV","MIOGLIA",1],["F227","TN","MIOLA",0],["F228","UD","MIONE",0],["F229","VE","MIRA",1],["F229","VE","MIRA ED ORIAGO",0],["F230","AV","MIRABELLA",0],["F231","CT","MIRABELLA",0],["F230","AV","MIRABELLA ECLANO",1],["F231","CT","MIRABELLA IMBACCARI",1],["F232","AL","MIRABELLO",0],["F233","CB","MIRABELLO",0],["F234","CR","MIRABELLO",0],["F235","FE","MIRABELLO",0],["F236","MI","MIRABELLO",0],["F237","PV","MIRABELLO",0],["F234","CR","MIRABELLO CIRIA",0],["D581","CO","MIRABELLO COMASCO",0],["F237","PV","MIRABELLO ED UNITI DI PAVIA",0],["F232","AL","MIRABELLO MONFERRATO",1],["F236","MI","MIRABELLO SAN BERNARDINO",0],["F233","CB","MIRABELLO SANNITICO",1],["F238","PV","MIRADOLO",0],["F238","PV","MIRADOLO TERME",1],["F239","IS","MIRANDA",1],["F240","MO","MIRANDOLA",1],["F241","VE","MIRANO",1],["F242","ME","MIRTO",1],["F243","BG","MISANO",0],["F244","FC","MISANO",0],["F245","PV","MISANO",0],["F244","RN","MISANO ADRIATICO",1],["F243","BG","MISANO DI GERA D'ADDA",1],["F244","FC","MISANO IN VILLA VITTORIA",0],["F245","PV","MISANO OLONA",0],["F246","PA","MISILMERI",1],["F247","MB","MISINTO",1],["F247","MI","MISINTO",0],["F248","LC","MISSAGLIA",1],["F249","PZ","MISSANELLO",1],["F250","CT","MISTERBIANCO",1],["F251","ME","MISTRETTA",1],["F252","VR","MIZZOLE",0],["F253","IM","MOANO",0],["F254","AT","MOASCA",1],["F255","TO","MOCCHIE",0],["F256","GE","MOCONESI",1],["F257","MO","MODENA",1],["F258","RG","MODICA",1],["F259","FC","MODIGLIANA",1],["F260","MI","MODIGNANO",0],["F261","NU","MODOLO",0],["F261","OR","MODOLO",1],["F262","BA","MODUGNO",1],["F263","TN","MOENA",1],["F264","TN","MOERNA",0],["F265","LC","MOGGIO",1],["F266","UD","MOGGIO UDINESE",1],["F267","MN","MOGLIA",1],["F268","MC","MOGLIANO",1],["F269","TV","MOGLIANO",0],["F269","TV","MOGLIANO VENETO",1],["F270","OR","MOGORELLA",1],["F271","CA","MOGORELLA RUINAS",0],["F272","OR","MOGORO",1],["F273","CO","MOIANA",0],["F274","BN","MOIANO",1],["F275","UD","MOIMACCO",1],["F276","BG","MOIO",0],["F277","ME","MOIO",0],["F278","SA","MOIO",0],["F277","ME","MOIO ALCANTARA",1],["F276","BG","MOIO DE' CALVI",1],["F278","SA","MOIO DELLA CIVITELLA",1],["F279","CN","MOIOLA",1],["C210","ME","MOLA",0],["F280","BA","MOLA DI BARI",1],["D708","LT","MOLA E CASTELLONE",0],["F281","AL","MOLARE",1],["F282","GE","MOLASSANA",0],["F283","LU","MOLAZZANA",1],["Z140","EE","MOLDAVIA",0],["F284","BA","MOLFETTA",1],["F285","CO","MOLINA",0],["M255","AQ","MOLINA ATERNO",1],["F286","TN","MOLINA DI LEDRO",0],["F287","BN","MOLINARA",1],["F288","BO","MOLINELLA",1],["F289","BG","MOLINI DI COLOGNOLA",0],["F290","IM","MOLINI DI TRIORA",1],["F291","BZ","MOLINI DI TURES",0],["F292","AL","MOLINO ALZANO",0],["F293","AL","MOLINO DEI TORTI",1],["F294","CB","MOLISE",1],["F295","PZ","MOLITERNO",1],["F296","TN","MOLLARO",0],["F297","VC","MOLLIA",1],["F298","TO","MOLLIERES",0],["F299","AG","MOLO",0],["F300","AL","MOLO",0],["F300","AL","MOLO DI BORBERA",0],["F301","RC","MOLOCHIO",1],["B947","BG","MOLOGNO",0],["F302","IM","MOLTEDO INFERIORE",0],["F303","IM","MOLTEDO SUPERIORE",0],["F304","LC","MOLTENO",1],["F305","CO","MOLTRASIO",1],["F306","VI","MOLVENA",0],["F307","TN","MOLVENO",1],["F308","AT","MOMBALDONE",1],["F309","CN","MOMBARCARO",1],["F310","PU","MOMBAROCCIO",1],["F311","AT","MOMBARUZZO",1],["F312","CN","MOMBASIGLIO",1],["F313","AL","MOMBELLO",0],["F314","CO","MOMBELLO",0],["F315","TO","MOMBELLO",0],["F315","TO","MOMBELLO DI TORINO",1],["F314","VA","MOMBELLO LAGO MAGGIORE",0],["F313","AL","MOMBELLO MONFERRATO",1],["F316","AT","MOMBERCELLI",1],["F317","NO","MOMO",1],["F318","TO","MOMPANTERO",1],["F319","RI","MOMPEO",1],["F320","AL","MOMPERONE",1],["F321","BS","MOMPIANO",0],["F322","CB","MONACILIONI",1],["Z123","EE","MONACO",0],["F323","AT","MONALE",1],["F324","RC","MONASTERACE",1],["F325","AL","MONASTERO",0],["F326","CN","MONASTERO",0],["F327","TO","MONASTERO",0],["F325","AT","MONASTERO BORMIDA",1],["F327","TO","MONASTERO DI LANZO",1],["F326","CN","MONASTERO DI VASCO",1],["F328","BG","MONASTEROLO",0],["F329","CN","MONASTEROLO",0],["F330","CN","MONASTEROLO",0],["F331","TO","MONASTEROLO",0],["F329","CN","MONASTEROLO CASOTTO",1],["F329","CN","MONASTEROLO CASSOTO",0],["F328","BG","MONASTEROLO DEL CASTELLO",1],["F330","CN","MONASTEROLO DI SAVIGLIANO",1],["F331","TO","MONASTEROLO TORINESE",0],["F332","TV","MONASTIER",0],["F332","TV","MONASTIER DI TREVISO",1],["F333","CA","MONASTIR",0],["F333","SU","MONASTIR",1],["F334","VA","MONATE",0],["F335","TO","MONCALIERI",1],["F336","AT","MONCALVO",1],["D553","TO","MONCENISIO",1],["F337","AL","MONCESTINO",1],["F338","CN","MONCHIERO",1],["F339","CN","MONCHIERO NOVELLO",0],["F340","PR","MONCHIO",0],["F340","PR","MONCHIO DELLE CORTI",1],["F341","TN","MONCLASSICO",0],["F342","VC","MONCRIVELLO",1],["F343","AL","MONCUCCO",0],["F344","MI","MONCUCCO",0],["F345","MI","MONCUCCO",0],["F345","MI","MONCUCCO DI MONZA",0],["F343","AT","MONCUCCO TORINESE",1],["F344","MI","MONCUCCO VECCHIO",0],["F346","RN","MONDAINO",1],["F347","PU","MONDAVIO",1],["F348","PU","MONDOLFO",1],["F349","CO","MONDONICO",0],["F350","AL","MONDONIO",0],["F351","CN","MONDOVI'",1],["F352","CE","MONDRAGONE",1],["F353","TO","MONDRONE",0],["F354","GE","MONEGLIA",1],["F355","CN","MONESIGLIO",1],["F356","GO","MONFALCONE",1],["F357","MO","MONFESTINO IN SERRA MAZZONI",0],["F357","MO","MONFESTINO IN SERRAMAZZONI",0],["F358","CN","MONFORTE",0],["F359","ME","MONFORTE",0],["F358","CN","MONFORTE D'ALBA",1],["F359","ME","MONFORTE SAN GIORGIO",1],["A449","RM","MONFORTINO",0],["F360","TV","MONFUMO",1],["F361","AT","MONGARDINO",1],["F362","BZ","MONGHEZZO DI FUORI",0],["F362","BZ","MONGHEZZO ESTERNO",0],["F363","BO","MONGHIDORO",1],["F364","VV","MONGIANA",1],["F365","AL","MONGIARDINO",0],["F366","MI","MONGIARDINO",0],["F365","AL","MONGIARDINO LIGURE",1],["F366","MI","MONGIARDINO SILLARO",0],["F367","AO","MONGIOVE",0],["F368","ME","MONGIUFFI MELIA",1],["Z233","EE","MONGOLIA",0],["F369","BI","MONGRANDO",1],["F370","CS","MONGRASSANO",1],["F371","BZ","MONGUELFO",0],["F371","BZ","MONGUELFO-TESIDO",1],["F372","CO","MONGUZZO",1],["F373","BS","MONIGA",0],["F373","BS","MONIGA DEL GARDA",1],["F374","AL","MONLEALE",1],["F375","BS","MONNO",1],["F376","BA","MONOPOLI",1],["F377","PA","MONREALE",1],["F378","TS","MONRUPINO",1],["F379","AP","MONSAMPIETRO MORICO",0],["F379","FM","MONSAMPIETRO MORICO",1],["F380","AP","MONSAMPOLO",0],["F380","AP","MONSAMPOLO DEL TRONTO",1],["F381","AN","MONSANO",1],["F382","PD","MONSELICE",1],["F383","CA","MONSERRATO",1],["F384","PT","MONSUMMANO",0],["F384","PT","MONSUMMANO TERME",1],["F385","CN","MONTA'",1],["F386","AT","MONTABONE",1],["F387","AL","MONTACUTO",1],["F388","AP","MONTACUTO",0],["F389","AP","MONTADAMO",0],["F390","AT","MONTAFIA",1],["F391","CB","MONTAGANO",1],["F392","BZ","MONTAGNA",1],["F393","SO","MONTAGNA",0],["F393","SO","MONTAGNA IN VALTELLINA",1],["F394","PD","MONTAGNANA",1],["F395","ME","MONTAGNAREALE",1],["F396","TN","MONTAGNE",0],["F397","AV","MONTAGUTO",1],["F398","FI","MONTAIONE",1],["F399","MT","MONTALBANO",0],["F400","ME","MONTALBANO",0],["F400","ME","MONTALBANO DI ELICONA",0],["F400","ME","MONTALBANO ELICONA",1],["F399","MT","MONTALBANO JONICO",1],["F401","AN","MONTALBODDO",0],["F402","SI","MONTALCINO",0],["M378","SI","MONTALCINO",1],["F403","AL","MONTALDEO",1],["F404","AL","MONTALDO",0],["F405","CN","MONTALDO",0],["F406","IM","MONTALDO",0],["F407","TO","MONTALDO",0],["F404","AL","MONTALDO BORMIDA",1],["F405","CN","MONTALDO DI MONDOVI'",1],["F406","IM","MONTALDO LIGURE",0],["F408","CN","MONTALDO ROERO",1],["F409","AT","MONTALDO SCARAMPI",1],["F407","TO","MONTALDO TORINESE",1],["F410","PT","MONTALE",1],["E895","BZ","MONTALE IN PUSTERIA",0],["F411","TO","MONTALENGHE",1],["F412","AL","MONTALERO",0],["F413","PU","MONTALFOGLIO",0],["F414","AG","MONTALLEGRO",1],["F415","AP","MONTALTO",0],["F416","CS","MONTALTO",0],["F417","PV","MONTALTO",0],["F418","PU","MONTALTO",0],["F419","RM","MONTALTO",0],["F420","TO","MONTALTO",0],["F416","CS","MONTALTO AFFUGO",0],["M387","IM","MONTALTO CARPASIO",1],["F415","AP","MONTALTO DELLE MARCHE",1],["F419","VT","MONTALTO DI CASTRO",1],["F420","TO","MONTALTO DORA",1],["F406","IM","MONTALTO LIGURE",0],["F417","PV","MONTALTO PAVESE",1],["F418","PU","MONTALTO TARUGO",0],["F416","CS","MONTALTO UFFUGO",1],["F421","CR","MONTANARA",0],["F422","TO","MONTANARO",1],["F423","MI","MONTANASO",0],["F423","LO","MONTANASO LOMBARDO",1],["F424","CN","MONTANERA",1],["F425","CO","MONTANO",0],["F426","SA","MONTANO",0],["F426","SA","MONTANO ANTILIA",1],["F425","CO","MONTANO COMASCO",0],["F427","CO","MONTANO LUCINO",1],["F428","AP","MONTAPPONE",0],["F428","FM","MONTAPPONE",1],["F429","IS","MONTAQUILA",1],["F430","RI","MONTASOLA",1],["F431","BZ","MONTASSILO",0],["F431","BZ","MONTASSILONE",0],["F432","CZ","MONTAURO",1],["F433","CH","MONTAZZOLI",1],["F434","CR","MONTE",0],["F435","MI","MONTE",0],["F436","BZ","MONTE A MEZZODI'",0],["F438","BZ","MONTE A TRAMONTANA",0],["F437","GR","MONTE ARGENTARIO",1],["F444","PV","MONTE BOLOGNOLA",0],["F456","PG","MONTE CASTELLO",0],["F456","PG","MONTE CASTELLO DI VIBIO",1],["F460","MC","MONTE CAVALLO",1],["F467","PU","MONTE CERIGNONE",1],["F476","RN","MONTE COLOMBO",0],["F477","RM","MONTE COMPATRI",1],["F434","CR","MONTE CREMASCO",1],["F485","PL","MONTE DI CAPODISTRIA",0],["F486","VI","MONTE DI MALO",1],["F436","BZ","MONTE DI MEZZODI'",0],["F488","NA","MONTE DI PROCIDA",1],["F438","BZ","MONTE DI TRAMONTANA",0],["F517","AP","MONTE GIBERTO",0],["F517","FM","MONTE GIBERTO",1],["F524","PU","MONTE GRIMANO",0],["F524","PU","MONTE GRIMANO TERME",1],["F532","BS","MONTE ISOLA",1],["F561","LC","MONTE MARENZO",1],["F571","PU","MONTE MONTANARO",0],["F583","CO","MONTE OLIMPINO",0],["F584","NO","MONTE OSSOLANO",0],["F589","PU","MONTE PORZIO",1],["F590","RM","MONTE PORZIO",0],["F590","RM","MONTE PORZIO CATONE",1],["F599","AP","MONTE RINALDO",0],["F599","FM","MONTE RINALDO",1],["F600","AN","MONTE ROBERTO",1],["F603","VT","MONTE ROMANO",1],["F616","LT","MONTE SAN BIAGIO",1],["F617","BZ","MONTE SAN CANDIDO",0],["F618","SA","MONTE SAN GIACOMO",1],["F619","PG","MONTE SAN GIOVANNI",0],["F620","RM","MONTE SAN GIOVANNI",0],["F620","FR","MONTE SAN GIOVANNI CAMPANO",1],["F619","RI","MONTE SAN GIOVANNI IN SABINA",1],["D423","TP","MONTE SAN GIULIANO",0],["F621","MC","MONTE SAN GIUSTO",1],["F622","MC","MONTE SAN MARTINO",1],["F626","AP","MONTE SAN PIETRANGELI",0],["F626","FM","MONTE SAN PIETRANGELI",1],["F627","BO","MONTE SAN PIETRO",1],["F460","MC","MONTE SAN POLO",0],["F628","AR","MONTE SAN SAVINO",1],["F616","RM","MONTE SAN VITO",0],["F634","AN","MONTE SAN VITO",1],["F635","GO","MONTE SAN VITO",0],["F631","FG","MONTE SANT'ANGELO",1],["F629","AR","MONTE SANTA MARIA",0],["F630","PG","MONTE SANTA MARIA",0],["F630","PG","MONTE SANTA MARIA IN SABINA",0],["F629","PG","MONTE SANTA MARIA TIBERINA",1],["F652","GO","MONTE URABICE",0],["F653","AP","MONTE URANO",0],["F653","FM","MONTE URANO",1],["F664","AP","MONTE VIDON COMBATTE",0],["F664","FM","MONTE VIDON COMBATTE",1],["F665","AP","MONTE VIDON CORRADO",0],["F665","FM","MONTE VIDON CORRADO",1],["D746","RC","MONTEBELLO",0],["F439","PU","MONTEBELLO",0],["F440","PV","MONTEBELLO",0],["F441","PE","MONTEBELLO",0],["F442","VI","MONTEBELLO",0],["F440","PV","MONTEBELLO DELLA BATTAGLIA",1],["F441","PE","MONTEBELLO DI BERTONA",1],["D746","RC","MONTEBELLO IONICO",0],["D746","RC","MONTEBELLO JONICO",1],["F439","PU","MONTEBELLO METAURENSE",0],["B268","CH","MONTEBELLO SUL SANGRO",1],["F442","VI","MONTEBELLO VICENTINO",1],["F443","TV","MONTEBELLUNA",1],["F445","GE","MONTEBRUNO",1],["B254","NO","MONTEBUGLIO",0],["F446","RI","MONTEBUONO",1],["F447","AP","MONTECALVO",0],["F448","AV","MONTECALVO",0],["F449","PV","MONTECALVO",0],["F450","PU","MONTECALVO",0],["F447","AP","MONTECALVO DEL CASTELLANO",0],["F450","PU","MONTECALVO IN FOGLIA",1],["F448","AV","MONTECALVO IRPINO",1],["F449","PV","MONTECALVO VERSIGGIA",1],["F451","FI","MONTECALVOLI",0],["F452","LU","MONTECARLO",1],["F453","AN","MONTECAROTTO",1],["F454","MC","MONTECASSIANO",1],["F455","AL","MONTECASTELLO",1],["F457","TR","MONTECASTRILLI",1],["A561","PT","MONTECATINI TERME",0],["F458","PI","MONTECATINI VAL DI CECINA",1],["F459","PT","MONTECATINI VAL DI NIEVOLE",0],["A561","PT","MONTECATINI-TERME",1],["F461","VR","MONTECCHIA DI CROSARA",1],["F462","TR","MONTECCHIO",1],["F463","RE","MONTECCHIO EMILIA",1],["F464","VI","MONTECCHIO MAGGIORE",1],["F465","VI","MONTECCHIO PRECALCINO",1],["F466","RM","MONTECELIO",0],["F468","AL","MONTECHIARO",0],["F469","AL","MONTECHIARO",0],["F470","BZ","MONTECHIARO",0],["F471","BS","MONTECHIARO",0],["F469","AL","MONTECHIARO D'ACQUI",1],["F468","AT","MONTECHIARO D'ASTI",1],["F472","AL","MONTECHIARO DENICE",0],["F471","BS","MONTECHIARO SUL CHIESE",0],["F473","PR","MONTECHIARUGOLO",1],["F474","PU","MONTECICCARDO",1],["F475","CB","MONTECILFONE",1],["F477","RM","MONTECOMPATRI",0],["F478","PU","MONTECOPIOLO",1],["F479","SA","MONTECORICE",1],["F480","SA","MONTECORVINO PUGLIANO",1],["F481","SA","MONTECORVINO ROVELLA",1],["F482","MC","MONTECOSARO",1],["F483","VB","MONTECRESTESE",1],["F484","MO","MONTECRETO",1],["F487","AP","MONTEDINOVE",1],["F489","CL","MONTEDORO",1],["F490","PU","MONTEFABBRI",0],["F491","AV","MONTEFALCIONE",1],["F492","PG","MONTEFALCO",1],["F493","AP","MONTEFALCONE",0],["F494","BN","MONTEFALCONE",0],["F495","CB","MONTEFALCONE",0],["F493","AP","MONTEFALCONE APPENNINO",0],["F493","FM","MONTEFALCONE APPENNINO",1],["F494","BN","MONTEFALCONE DI VAL FORTORE",1],["F495","CB","MONTEFALCONE NEL SANNIO",1],["F496","MC","MONTEFANO",1],["F497","PU","MONTEFELCINO",1],["F498","CH","MONTEFERRANTE",1],["F499","VT","MONTEFIASCONE",1],["F500","TE","MONTEFINO",1],["F501","AP","MONTEFIORE",0],["F502","FC","MONTEFIORE",0],["F502","RN","MONTEFIORE CONCA",1],["F501","AP","MONTEFIORE DELL'ASO",1],["F503","MO","MONTEFIORINO",1],["F502","FC","MONTEFIORITO",0],["F504","RM","MONTEFLAVIO",1],["F505","BZ","MONTEFONTANA",0],["F506","AV","MONTEFORTE",0],["F507","SA","MONTEFORTE",0],["F508","VR","MONTEFORTE",0],["F507","SA","MONTEFORTE CILENTO",1],["F508","VR","MONTEFORTE D'ALPONE",1],["F506","AV","MONTEFORTE IRPINO",1],["A449","RM","MONTEFORTINO",0],["F509","AP","MONTEFORTINO",0],["F509","FM","MONTEFORTINO",1],["F510","TR","MONTEFRANCO",1],["F511","AV","MONTEFREDANE",1],["F512","AV","MONTEFUSCO",1],["F513","TR","MONTEGABBIONE",1],["F514","VI","MONTEGALDA",1],["F515","VI","MONTEGALDELLA",1],["F516","AP","MONTEGALLO",1],["F518","AL","MONTEGIOCO",1],["F519","CS","MONTEGIORDANO",1],["F520","AP","MONTEGIORGIO",0],["F520","FM","MONTEGIORGIO",1],["F521","PG","MONTEGIOVE",0],["F522","AP","MONTEGRANARO",0],["F522","FM","MONTEGRANARO",1],["F302","IM","MONTEGRAZIE",0],["F523","RN","MONTEGRIDOLFO",1],["F525","VA","MONTEGRINO",0],["F526","VA","MONTEGRINO VALTRAVAGLIA",1],["F527","AL","MONTEGROSSO",0],["F528","IM","MONTEGROSSO",0],["F527","AT","MONTEGROSSO D'ASTI",1],["F528","IM","MONTEGROSSO PIAN LATTE",1],["F529","PD","MONTEGROTTO TERME",1],["F530","PU","MONTEGUIDUCCIO",0],["F531","TA","MONTEIASI",1],["F533","PU","MONTELABBATE",1],["F534","RM","MONTELANICO",1],["F535","CH","MONTELAPIANO",1],["F536","AP","MONTELEONE",0],["F537","CZ","MONTELEONE",0],["F538","FG","MONTELEONE",0],["F539","PV","MONTELEONE",0],["F540","PG","MONTELEONE",0],["F541","RI","MONTELEONE",0],["F542","SS","MONTELEONE",0],["F543","TR","MONTELEONE",0],["F543","TR","MONTELEONE D'ORVIETO",1],["F537","CZ","MONTELEONE DI CALABRIA",0],["F536","AP","MONTELEONE DI FERMO",0],["F536","FM","MONTELEONE DI FERMO",1],["F538","FG","MONTELEONE DI PUGLIA",1],["F540","PG","MONTELEONE DI SPOLETO",1],["F542","SS","MONTELEONE ROCCA DORIA",1],["F541","RI","MONTELEONE SABINO",1],["F539","PV","MONTELEONE SUI COLLI PAVESI",0],["F544","PA","MONTELEPRE",1],["F545","RM","MONTELIBRETTI",1],["F546","AV","MONTELLA",1],["F547","BG","MONTELLO",1],["F548","CB","MONTELONGO",1],["F549","AP","MONTELPARO",0],["F549","FM","MONTELPARO",1],["F550","CN","MONTELUPO",0],["F551","FI","MONTELUPO",0],["F550","CN","MONTELUPO ALBESE",1],["F551","FI","MONTELUPO FIORENTINO",1],["F552","MC","MONTELUPONE",1],["F553","PA","MONTEMAGGIORE",0],["F554","PU","MONTEMAGGIORE",0],["F555","PU","MONTEMAGGIORE",0],["F555","PU","MONTEMAGGIORE AL METAURO",0],["F553","PA","MONTEMAGGIORE BELSITO",1],["F556","AT","MONTEMAGNO",1],["F557","AV","MONTEMALE",0],["F558","CN","MONTEMALE",0],["F558","CN","MONTEMALE DI CUNEO",1],["F559","AV","MONTEMARANO",1],["F560","AN","MONTEMARCIANO",1],["F562","AL","MONTEMARZINO",1],["F563","TA","MONTEMESOLA",1],["F564","CO","MONTEMEZZO",1],["F565","AR","MONTEMIGNAIO",1],["F566","AV","MONTEMILETTO",1],["F567","MC","MONTEMILONE",0],["F568","PZ","MONTEMILONE",1],["F569","CB","MONTEMITRO",1],["F570","AP","MONTEMONACO",1],["F572","PO","MONTEMURLO",1],["F573","PZ","MONTEMURRO",1],["F574","UD","MONTENARS",1],["F575","MI","MONTENATE",0],["Z159","EE","MONTENEGRO",0],["F577","GO","MONTENERO D'IDRIA",0],["F576","CB","MONTENERO DI BISACCIA",1],["F579","RI","MONTENERO SABINO",1],["F580","IS","MONTENERO VAL COCCHIARA",1],["F578","CH","MONTENERODOMO",1],["F581","AN","MONTENOVO",0],["F582","CH","MONTEODORISIO",1],["F585","TE","MONTEPAGANO",0],["F586","CZ","MONTEPAONE",1],["F587","TA","MONTEPARANO",1],["E326","MT","MONTEPELOSO",0],["F588","BZ","MONTEPONENTE",0],["F591","AP","MONTEPRANDONE",1],["F592","SI","MONTEPULCIANO",1],["F593","AN","MONTERADO",0],["F594","AR","MONTERCHI",1],["F595","AQ","MONTEREALE",1],["F596","UD","MONTEREALE",0],["F596","UD","MONTEREALE CELLINA",0],["F596","PN","MONTEREALE VALCELLINA",1],["F597","BO","MONTERENZIO",1],["F598","SI","MONTERIGGIONI",1],["F601","IS","MONTERODUNI",1],["F602","PU","MONTEROLO",0],["F604","LE","MONTERONI",0],["F605","SI","MONTERONI",0],["F605","SI","MONTERONI D'ARBIA",1],["F604","LE","MONTERONI DI LECCE",1],["F606","VT","MONTEROSI",1],["F607","CZ","MONTEROSSO",0],["F608","CN","MONTEROSSO",0],["F609","GE","MONTEROSSO",0],["F610","RG","MONTEROSSO",0],["F609","SP","MONTEROSSO AL MARE",1],["F610","RG","MONTEROSSO ALMO",1],["F607","VV","MONTEROSSO CALABRO",1],["F608","CN","MONTEROSSO GRANA",1],["F611","RM","MONTEROTONDO",1],["F612","GR","MONTEROTONDO MARITTIMO",1],["F613","PG","MONTERUBBIAGLIO",0],["F614","AP","MONTERUBBIANO",0],["F614","FM","MONTERUBBIANO",1],["C518","RM","MONTERUFO",0],["F615","TN","MONTES",0],["F623","LE","MONTESANO",0],["F624","PV","MONTESANO",0],["F625","SA","MONTESANO",0],["F624","PV","MONTESANO AL PIANO",0],["F623","LE","MONTESANO SALENTINO",1],["F625","SA","MONTESANO SULLA MARCELLANA",1],["F632","MC","MONTESANTO",0],["F633","PG","MONTESANTO",0],["F633","PG","MONTESANTO VIEZI",0],["F633","PG","MONTESANTO VIGI",0],["F636","BN","MONTESARCHIO",1],["F637","MT","MONTESCAGLIOSO",1],["F638","PV","MONTESCANO",1],["F639","VB","MONTESCHENO",1],["F640","PI","MONTESCUDAIO",1],["F641","RN","MONTESCUDO",0],["M368","RN","MONTESCUDO-MONTE COLOMBO",1],["F641","FC","MONTESCUDOLO",0],["F642","MO","MONTESE",1],["F500","TE","MONTESECCO",0],["F643","PU","MONTESECCO",0],["F643","PU","MONTESECCO ANTICO",0],["F644","PV","MONTESEGALE",1],["F645","AN","MONTESICURO",0],["F646","PE","MONTESILVANO",1],["F647","PE","MONTESILVANO MARINA",0],["F435","MI","MONTESIRO",0],["F648","FI","MONTESPERTOLI",1],["F649","GO","MONTESPINO",0],["F650","TO","MONTESTRUTTO",0],["F651","TO","MONTEU DA PO",1],["F654","CN","MONTEU ROERO",1],["M239","TN","MONTEVACCINO",0],["F655","AG","MONTEVAGO",1],["F656","AR","MONTEVARCHI",1],["F657","CO","MONTEVECCHIA",0],["F657","LC","MONTEVECCHIA",1],["F658","PU","MONTEVECCHIO",0],["F659","BO","MONTEVEGLIO",0],["F660","AV","MONTEVERDE",1],["F661","PI","MONTEVERDI",0],["F661","PI","MONTEVERDI MARITTIMO",1],["F662","VI","MONTEVIALE",1],["F663","VA","MONTEVIASCO",0],["F666","CN","MONTEZEMOLO",1],["F667","SS","MONTI",1],["F668","FC","MONTIANO",1],["F466","RM","MONTICELLI",0],["F547","BG","MONTICELLI",0],["F669","CN","MONTICELLI",0],["F670","PV","MONTICELLI",0],["F671","PC","MONTICELLI",0],["F669","CN","MONTICELLI ALBA",0],["F672","BS","MONTICELLI BRUSATI",1],["F671","PC","MONTICELLI D'ONGINA",1],["F547","BG","MONTICELLI DI BORGOGNA",0],["F670","PV","MONTICELLI PAVESE",1],["F673","CR","MONTICELLI RIPA D'OGLIO",0],["F616","RM","MONTICELLO",0],["F674","LC","MONTICELLO BRIANZA",1],["F675","VI","MONTICELLO CONTE OTTO",1],["F669","CN","MONTICELLO D'ALBA",1],["F471","BS","MONTICHIARI",1],["F676","SI","MONTICIANO",1],["F677","GR","MONTIERI",1],["F678","AT","MONTIGLIO",0],["M302","AT","MONTIGLIO MONFERRATO",1],["F679","MS","MONTIGNOSO",1],["F680","BS","MONTIRONE",1],["F367","AO","MONTJOVET",1],["F681","CR","MONTODINE",1],["F682","GE","MONTOGGIO",1],["F683","PL","MONTONA",0],["F684","VA","MONTONATE",0],["F685","PG","MONTONE",1],["F686","PI","MONTOPOLI",0],["F687","RI","MONTOPOLI",0],["F687","RI","MONTOPOLI DI SABINA",1],["F686","PI","MONTOPOLI IN VAL D'ARNO",1],["F688","CO","MONTORFANO",1],["F689","CB","MONTORIO",0],["F690","TE","MONTORIO",0],["F691","VR","MONTORIO",0],["F690","TE","MONTORIO AL VOMANO",1],["F689","CB","MONTORIO NEI FRENTANI",1],["F692","RM","MONTORIO ROMANO",1],["F691","VR","MONTORIO VERONESE",0],["M330","AV","MONTORO",1],["F693","AV","MONTORO INFERIORE",0],["F694","AV","MONTORO SUPERIORE",0],["F695","BN","MONTORSO",0],["F696","VI","MONTORSO VICENTINO",1],["F697","AP","MONTOTTONE",0],["F697","FM","MONTOTTONE",1],["F698","NU","MONTRESTA",0],["F698","OR","MONTRESTA",1],["F699","NO","MONTRIGIASCO",0],["F700","BA","MONTRONE",0],["Z531","EE","MONTSERRAT",0],["F701","PV","MONTU' BECCARIA",1],["F702","PV","MONTU' BERCHIELLI",0],["B613","PV","MONTU' DEI GABBI",0],["F703","VA","MONVALLE",1],["F704","MB","MONZA",1],["F704","MI","MONZA",0],["F705","MN","MONZAMBANO",1],["F706","BO","MONZUNO",1],["F707","AL","MORANO",0],["F708","CS","MORANO",0],["F708","CS","MORANO CALABRO",1],["F707","AL","MORANO SUL PO",1],["F709","AT","MORANSENGO",1],["F710","GO","MORARO",1],["F711","VA","MORAZZONE",1],["F712","SO","MORBEGNO",1],["F713","AL","MORBELLO",1],["F714","VC","MORCA",0],["F715","FC","MORCIANO",0],["F716","LE","MORCIANO",0],["F716","LE","MORCIANO DI LEUCA",1],["F715","RN","MORCIANO DI ROMAGNA",1],["F717","BN","MORCONE",1],["F718","BO","MORDANO",1],["F719","AP","MOREGNANO",0],["F720","BG","MORENGO",1],["F721","SS","MORES",1],["F722","AP","MORESCO",0],["F722","FM","MORESCO",1],["F723","CN","MORETTA",1],["F724","PC","MORFASSO",1],["F725","TV","MORGANO",1],["F726","AO","MORGEX",1],["F727","OR","MORGONGIORI",1],["F728","TN","MORI",1],["F729","TV","MORIAGO",0],["F729","TV","MORIAGO DELLA BATTAGLIA",1],["F730","RM","MORICONE",1],["F731","SA","MORIGERATI",1],["D033","MI","MORIMONDO",1],["F732","AQ","MORINO",1],["F733","TO","MORIONDO TORINESE",1],["F734","RM","MORLUPO",1],["F735","CS","MORMANNO",1],["F736","VA","MORNAGO",1],["F737","AL","MORNESE",1],["F738","BG","MORNICO",0],["F739","PV","MORNICO",0],["F738","BG","MORNICO AL SERIO",1],["F739","PV","MORNICO LOSANA",1],["F740","FR","MOROLO",1],["F741","VC","MORONDO",0],["F742","VA","MOROSOLO",0],["F743","CN","MOROZZO",1],["E430","CN","MORRA",0],["F744","AV","MORRA",0],["F744","AV","MORRA DE SANCTIS",1],["F744","AV","MORRA IRPINO",0],["F745","AN","MORRO",0],["F746","RI","MORRO",0],["F747","TE","MORRO",0],["F745","AN","MORRO D'ALBA",1],["F747","TE","MORRO D'ORO",1],["F746","RI","MORRO REATINO",1],["C211","CE","MORRONE",0],["F748","CB","MORRONE",0],["F748","CB","MORRONE DEL SANNIO",1],["F749","MC","MORROVALLE",1],["F750","PN","MORSANO AL TAGLIAMENTO",1],["F751","AL","MORSASCO",1],["F752","MI","MORSENCHIO",0],["F753","FC","MORTANO",0],["F754","PV","MORTARA",1],["F755","TN","MORTASO",0],["F756","UD","MORTEGLIANO",1],["F757","BZ","MORTER",0],["F758","LC","MORTERONE",1],["F759","PC","MORTIZZA",0],["F760","UD","MORUZZO",1],["F761","CR","MOSCAZZANO",1],["F762","AV","MOSCHIANO",1],["F763","FM","MOSCHIENA",0],["F381","AN","MOSCIANO",0],["F764","TE","MOSCIANO",0],["F764","TE","MOSCIANO SANT'ANGELO",1],["F765","PE","MOSCUFO",1],["F766","BZ","MOSO",0],["F766","BZ","MOSO IN PASSIRIA",1],["F767","GO","MOSSA",1],["F768","VI","MOSSANO",0],["M304","BI","MOSSO",0],["F769","BI","MOSSO SANTA MARIA",0],["F770","TV","MOTTA",0],["F771","CR","MOTTA BALUFFI",1],["F772","ME","MOTTA CAMASTRA",1],["F773","ME","MOTTA D'AFFERMO",1],["F774","VC","MOTTA DE' CONTI",1],["F770","TV","MOTTA DI LIVENZA",1],["F777","FG","MOTTA MONTECORVINO",1],["F778","PV","MOTTA SAN DAMIANO",0],["F779","RC","MOTTA SAN GIOVANNI",1],["F781","CT","MOTTA SANT'ANASTASIA",1],["F780","CZ","MOTTA SANTA LUCIA",1],["F782","MI","MOTTA VIGANA",0],["F783","MI","MOTTA VISCONTI",1],["F775","CS","MOTTAFOLLONE",1],["F776","BI","MOTTALCIATA",1],["B012","MN","MOTTEGGIANA",1],["F784","TA","MOTTOLA",1],["Z333","EE","MOZAMBICO",0],["F785","CH","MOZZAGROGNA",1],["F786","BG","MOZZANICA",1],["F787","AP","MOZZANO",0],["F788","CO","MOZZATE",1],["F789","VR","MOZZECANE",1],["F790","NO","MOZZIO",0],["F791","BG","MOZZO",1],["F792","BS","MU",0],["F793","MC","MUCCIA",1],["F794","VA","MUCENO",0],["F795","TS","MUGGIA",1],["F796","MI","MUGGIANO",0],["F797","MB","MUGGIO'",1],["F797","MI","MUGGIO'",0],["F797","MB","MUGGI�",0],["F798","AV","MUGNANO",0],["F799","NA","MUGNANO",0],["F798","AV","MUGNANO DEL CARDINALE",1],["F799","NA","MUGNANO DI NAPOLI",1],["F800","CA","MULARGIA",0],["F801","LO","MULAZZANO",1],["F802","MS","MULAZZO",1],["F803","BZ","MULES",0],["F804","MN","MULO",0],["F805","GE","MULTEDO",0],["F806","BS","MURA",1],["F807","VE","MURANO",0],["F808","CA","MURAVERA",0],["F808","SU","MURAVERA",1],["F809","CN","MURAZZANO",1],["F810","VI","MURE",0],["F811","CN","MURELLO",1],["F812","AO","MURIAGLIO",0],["F813","SV","MURIALDO",1],["F814","AL","MURISENGO",1],["F815","SI","MURLO",1],["F816","LE","MURO",0],["F817","PZ","MURO",0],["F816","LE","MURO LECCESE",1],["F817","PZ","MURO LUCANO",1],["F818","SS","MUROS",1],["F819","VA","MUSADINO",0],["F820","BS","MUSCOLINE",1],["F821","UD","MUSCOLO-STRASSOLDO",0],["F822","CA","MUSEI",0],["F822","SU","MUSEI",1],["F823","PE","MUSELLARO",0],["F824","BO","MUSIANO",0],["F825","VA","MUSIGNANO",0],["F826","VE","MUSILE",0],["F826","VE","MUSILE DI PIAVE",1],["F827","MI","MUSOCCO",0],["F828","CO","MUSSO",1],["F829","VI","MUSSOLENTE",1],["A357","CA","MUSSOLINIA",0],["F830","CL","MUSSOMELI",1],["F831","TE","MUTIGNANO",0],["F832","UD","MUZZANA",0],["F832","UD","MUZZANA DEL TURGNANO",1],["F833","BI","MUZZANO",1],["Z206","EE","MYANMAR",0],["A500","TS","NABRESINA",0],["F834","TS","NACLA SAN MAURIZIO",0],["F835","TN","NAGO-TORBOLE",1],["F836","BZ","NALLES",1],["Z300","EE","NAMIBIA",0],["Z300","EE","NAMIBIA=AFRICA DEL SUD OVEST",0],["F837","TN","NANNO",0],["F838","VI","NANTO",1],["F839","NA","NAPOLI",1],["F840","OR","NARBOLIA",1],["F841","CA","NARCAO",0],["F841","SU","NARCAO",1],["F842","LE","NARDO'",1],["F843","VV","NARDODIPACE",1],["F844","TR","NARNI",1],["F845","AG","NARO",1],["E298","CO","NARRO",0],["F846","CN","NARZOLE",1],["F847","SV","NASINO",1],["F848","ME","NASO",1],["F849","BZ","NATURNO",1],["Z713","EE","NAURU",0],["Z713","EE","NAURU (ISOLE)",0],["F850","CO","NAVA",0],["F851","BS","NAVE",1],["F853","TN","NAVE SAN ROCCO",0],["F852","AQ","NAVELLI",1],["F854","BS","NAVONO",0],["F855","BZ","NAZ",0],["F856","BZ","NAZ SCIAVES",0],["F856","BZ","NAZ-SCIAVES",1],["F857","RM","NAZZANO",1],["F858","GE","NE",1],["F859","NO","NEBBIUNO",1],["F860","VR","NEGARINE",0],["F861","VR","NEGRAR",0],["F861","VR","NEGRAR DI VALPOLICELLA",1],["F862","GE","NEIRONE",1],["F863","CN","NEIVE",1],["F864","BG","NEMBRO",1],["F865","RM","NEMI",1],["F866","PZ","NEMOLI",1],["F867","OR","NEONELI",1],["Z234","EE","NEPAL",0],["F868","VT","NEPI",1],["F869","PL","NERESINE",0],["F870","TE","NERETO",1],["F871","RM","NEROLA",1],["F872","TV","NERVESA",0],["F872","TV","NERVESA DELLA BATTAGLIA",1],["F873","GE","NERVI",0],["F874","MI","NERVIANO",1],["F875","BG","NESE",0],["F876","RI","NESPOLO",1],["F877","CO","NESSO",1],["F878","BI","NETRO",1],["F879","RM","NETTUNIA",0],["F880","RM","NETTUNO",1],["F881","LE","NEVIANO",1],["F882","PR","NEVIANO DEGLI ARDUINI",1],["F883","CN","NEVIGLIE",1],["F884","BS","NIARDO",1],["F885","PC","NIBBIANO",0],["F886","NO","NIBBIOLA",1],["F887","LC","NIBIONNO",1],["Z515","EE","NICARAGUA",0],["F888","CZ","NICASTRO",0],["F889","TO","NICHELINO",1],["F890","CT","NICOLOSI",1],["F891","PV","NICORVO",1],["F892","EN","NICOSIA",1],["F893","VV","NICOTERA",1],["F894","CN","NIELLA BELBO",1],["F895","CN","NIELLA TANARO",1],["Z334","EE","NIGER",0],["Z335","EE","NIGERIA",0],["F896","BS","NIGOLINE",0],["F896","BS","NIGOLINE-BONOMELLI",0],["F897","MI","NIGUARDA",0],["F898","UD","NIMIS",1],["F899","CL","NISCEMI",1],["F900","EN","NISSORIA",1],["Z714","EE","NIUE=SAVAGE (ISOLE)",0],["F901","ME","NIZZA DI SICILIA",1],["F902","AT","NIZZA MONFERRATO",1],["F903","VA","NIZZOLINA",0],["F904","VE","NOALE",1],["F905","TN","NOARNA",0],["F906","TO","NOASCA",1],["F907","CS","NOCARA",1],["F908","PE","NOCCIANO",1],["F909","NO","NOCCO",0],["F910","CZ","NOCERA",0],["F911","PG","NOCERA",0],["F912","SA","NOCERA INFERIORE",1],["F913","SA","NOCERA SUPERIORE",1],["F910","CZ","NOCERA TERINESE",1],["F911","PG","NOCERA UMBRA",1],["F914","PR","NOCETO",1],["F855","BZ","NOCI",0],["F915","BA","NOCI",1],["F916","LE","NOCIGLIA",1],["F917","PZ","NOEPOLI",1],["F918","VR","NOGARA",1],["F919","TN","NOGARE'",0],["F920","TN","NOGAREDO",1],["F921","VR","NOGAROLE",0],["F922","VI","NOGAROLE",0],["F921","VR","NOGAROLE ROCCA",1],["F922","VI","NOGAROLE VICENTINO",1],["F917","PZ","NOIA",0],["F923","BA","NOICATTARO",1],["F923","BA","NOJA",0],["F924","NA","NOLA",1],["F925","TO","NOLE",1],["F926","SV","NOLI",1],["F927","TO","NOMAGLIO",1],["F928","TN","NOMESINO",0],["F929","TN","NOMI",1],["F930","MO","NONANTOLA",1],["F931","TO","NONE",1],["F932","VB","NONIO",1],["F933","NU","NORAGUGUME",1],["F934","OR","NORBELLO",1],["F935","PG","NORCIA",1],["Z715","EE","NORFOLK (ISOLE E ISOLE DEL MAR DEI CORALLI)",0],["F934","CA","NORGHIDDO",0],["F936","TN","NORIGLIO",0],["F937","LT","NORMA",1],["Z124","EE","NORMANNE (ISOLE)=ISOLE DEL CANALE",0],["Z125","EE","NORVEGIA",0],["F938","CR","NOSADELLO",0],["F939","MI","NOSATE",1],["F940","MI","NOSEDO",0],["F941","BG","NOSSA",0],["F942","TE","NOTARESCO",1],["F943","SR","NOTO",1],["F944","MI","NOVA",0],["F949","BZ","NOVA LEVANTE",1],["F944","MB","NOVA MILANESE",1],["F944","MI","NOVA MILANESE",0],["F950","BZ","NOVA PONENTE",1],["A942","MT","NOVA SIRI",1],["F945","BZ","NOVACELLA",0],["F137","PU","NOVAFELTRIA",0],["F137","RN","NOVAFELTRIA",1],["F946","VI","NOVALE",0],["F947","TN","NOVALEDO",1],["F948","TO","NOVALESA",1],["F951","ME","NOVARA",0],["F952","NO","NOVARA",1],["F951","ME","NOVARA DI SICILIA",1],["F953","AO","NOVAREGLIA",0],["F954","CO","NOVATE",0],["F955","MI","NOVATE",0],["F956","SO","NOVATE",0],["F954","CO","NOVATE BRIANZA",0],["F956","SO","NOVATE MEZZOLA",1],["F955","MI","NOVATE MILANESE",1],["F957","VI","NOVE",1],["F958","CO","NOVEDRATE",1],["F959","MI","NOVEGRO",0],["M430","TN","NOVELLA",1],["F960","RE","NOVELLARA",1],["F961","CN","NOVELLO",1],["F339","CN","NOVELLO MONCHIERO",0],["F962","PD","NOVENTA",0],["F963","VE","NOVENTA",0],["F963","VE","NOVENTA DI PIAVE",1],["F962","PD","NOVENTA PADOVANA",1],["F964","VI","NOVENTA VICENTINA",1],["F965","AL","NOVI",0],["F966","MO","NOVI",0],["F967","SA","NOVI",0],["F966","MO","NOVI DI MODENA",1],["F965","AL","NOVI LIGURE",1],["F965","AL","NOVI PIEMONTE",0],["F967","SA","NOVI VELIA",1],["F968","MI","NOVIGLIO",1],["F969","PU","NOVILARA",0],["F970","LE","NOVOLI",1],["F971","BS","NOZZA",0],["F972","CN","NUCETTO",1],["F973","SS","NUCHIS",0],["F974","CA","NUGHEDU",0],["F975","SS","NUGHEDU",0],["F975","SS","NUGHEDU SAN NICOLO'",1],["F974","OR","NUGHEDU SANTA VITTORIA",1],["F976","SS","NULE",1],["F977","SS","NULVI",1],["F978","AN","NUMANA",1],["F979","NU","NUORO",1],["Z716","EE","NUOVA CALEDONIA (ISOLE E DIPENDENZE)",0],["Z718","EE","NUOVA GUINEA",0],["Z719","EE","NUOVA ZELANDA",0],["Z717","EE","NUOVE EBRIDI (ISOLE CONDOMINIO FRANCO-INGLESE)",0],["F980","OR","NURACHI",1],["F981","NU","NURAGUS",0],["F981","SU","NURAGUS",1],["F982","NU","NURALLAO",0],["F982","SU","NURALLAO",1],["F983","CA","NURAMINIS",0],["F983","SU","NURAMINIS",1],["F984","CA","NURAXINIEDDU",0],["F985","OR","NURECI",1],["F986","NU","NURRI",0],["F986","SU","NURRI",1],["F987","AO","NUS",1],["F988","AV","NUSCO",1],["F989","BS","NUVOLENTO",1],["F990","BS","NUVOLERA",1],["F991","CA","NUXIS",0],["F991","SU","NUXIS",1],["F992","BI","OCCHIEPPO INFERIORE",1],["F993","BI","OCCHIEPPO SUPERIORE",1],["F994","RO","OCCHIOBELLO",1],["F995","AL","OCCIMIANO",1],["F996","AQ","OCRE",1],["F997","AL","ODALENGO GRANDE",1],["F998","AL","ODALENGO PICCOLO",1],["F999","TV","ODERZO",1],["G001","BS","ODOLO",1],["G002","AQ","OFENA",1],["G003","AN","OFFAGNA",1],["G004","CR","OFFANENGO",1],["G005","AP","OFFIDA",1],["G006","BS","OFFLAGA",1],["G007","VB","OGGEBBIO",1],["G008","VA","OGGIONA",0],["G008","VA","OGGIONA CON SANTO STEFANO",1],["G009","LC","OGGIONO",1],["G010","TO","OGLIANICO",1],["A946","PA","OGLIASTRO",0],["G011","SA","OGLIASTRO",0],["G011","SA","OGLIASTRO CILENTO",1],["G012","AO","OIASSE",0],["G013","CO","OLATE",0],["G014","SV","OLBA",0],["G015","SS","OLBIA",1],["G016","VC","OLCENENGO",1],["G017","CO","OLCIO",0],["G018","VC","OLDENICO",1],["G019","NO","OLEGGIO",1],["G020","NO","OLEGGIO CASTELLO",1],["G021","PV","OLEVANO",0],["G022","RM","OLEVANO",0],["G023","SA","OLEVANO",0],["G021","PV","OLEVANO DI LOMELLINA",1],["G022","RM","OLEVANO ROMANO",1],["G023","SA","OLEVANO SUL FUSCIANO",0],["G023","SA","OLEVANO SUL TUSCIANO",1],["G024","NO","OLGIA",0],["G025","CO","OLGIATE",0],["G026","CO","OLGIATE",0],["G027","CO","OLGIATE CALCO",0],["G025","CO","OLGIATE COMASCO",1],["G026","LC","OLGIATE MOLGORA",1],["G028","VA","OLGIATE OLONA",1],["G029","VA","OLGINASIO",0],["G030","LC","OLGINATE",1],["G031","NU","OLIENA",1],["G032","PV","OLIVA",0],["G033","TO","OLIVA",0],["G032","PV","OLIVA GESSI",1],["G034","CZ","OLIVADI",1],["G035","IM","OLIVASTRI",0],["G036","ME","OLIVERI",1],["G037","MT","OLIVETO",0],["G038","PG","OLIVETO",0],["G039","SA","OLIVETO",0],["G039","SA","OLIVETO CITRA",1],["G038","PG","OLIVETO IN SABINA",0],["G040","LC","OLIVETO LARIO",1],["G037","MT","OLIVETO LUCANO",1],["G041","IM","OLIVETTA SAN MICHELE",1],["G042","AL","OLIVOLA",1],["A126","CA","OLLASTA",0],["G043","OR","OLLASTRA",1],["G043","OR","OLLASTRA SIMAXIS",0],["A126","CA","OLLASTRA USELLUS",0],["G044","NU","OLLOLAI",1],["G045","AO","OLLOMONT",1],["G045","AO","OLLOMONTE",0],["G046","SS","OLMEDO",1],["G047","CR","OLMENETA",1],["G048","AL","OLMO",0],["G049","BG","OLMO",0],["G049","BG","OLMO AL BREMBO",1],["G048","AT","OLMO GENTILE",1],["G050","BG","OLTRE IL COLLE",1],["G051","BG","OLTREPOVO",0],["G052","TN","OLTRESARCA",0],["G053","GO","OLTRESONZIA",0],["G054","BG","OLTRESSENDA ALTA",1],["G055","BG","OLTRESSENDA BASSA",0],["G056","CO","OLTRONA",0],["G057","VA","OLTRONA",0],["G057","VA","OLTRONA AL LAGO",0],["G056","CO","OLTRONA DI SAN MAMETTE",1],["G058","NU","OLZAI",1],["Z235","EE","OMAN",0],["G059","MI","OMATE",0],["G060","CR","OMBRIANO",0],["G061","BS","OME",1],["G062","VB","OMEGNA",1],["G063","SA","OMIGNANO",1],["G064","NU","ONANI",0],["G064","NU","ONANI'",1],["G065","VT","ONANO",1],["G066","CN","ONCINO",1],["G067","IM","ONEGLIA",0],["G068","BG","ONETA",1],["G069","BZ","ONIES",0],["G070","NU","ONIFAI",1],["G071","NU","ONIFERI",1],["G072","CO","ONNO",0],["G073","BS","ONO",0],["G074","BS","ONO",0],["G073","BS","ONO DEGNO",0],["G074","BS","ONO SAN PIETRO",1],["G075","BG","ONORE",1],["G076","SV","ONZO",1],["G077","GO","OPACCHIASELLA",0],["G078","MI","OPERA",1],["G079","AQ","OPI",1],["G080","VR","OPPEANO",1],["G081","PZ","OPPIDO",0],["G082","RC","OPPIDO",0],["G081","PZ","OPPIDO LUCANO",1],["G082","RC","OPPIDO MAMERTINA",1],["G083","BZ","ORA",1],["C382","VA","ORAGO",0],["G084","NU","ORANI",1],["G085","NO","ORASSO",0],["G086","CB","ORATINO",1],["G087","TO","ORBASSANO",1],["G088","GR","ORBETELLO",1],["G089","PU","ORCIANO DI PESARO",0],["G090","PI","ORCIANO PISANO",1],["G091","GE","ORCO",0],["D522","SV","ORCO FEGLINO",1],["M266","FG","ORDONA",1],["G092","MI","ORENO",0],["G093","GE","ORERO",1],["G094","BG","OREZZO",0],["G095","VI","ORGIANO",1],["G096","MI","ORGNAGA",0],["G097","NU","ORGOSOLO",1],["G098","BR","ORIA",1],["G099","BS","ORIANO",0],["G100","CO","ORIANO",0],["G101","MI","ORIANO",0],["G100","CO","ORIANO DI BRIANZA",0],["G101","MI","ORIANO SOPRA TICINO",0],["G102","AQ","ORICOLA",1],["G103","VA","ORIGGIO",1],["G104","PV","ORIGIOSO",0],["G105","VA","ORINO",1],["G106","VA","ORINO AZZIO",0],["G107","MI","ORIO",0],["G108","BG","ORIO",0],["G109","TO","ORIO",0],["G108","BG","ORIO AL SERIO",1],["G109","TO","ORIO CANAVESE",1],["G107","LO","ORIO LITTA",1],["G110","CS","ORIOLO",1],["G111","RM","ORIOLO",0],["G111","VT","ORIOLO ROMANO",1],["G112","BZ","ORIS",0],["G113","OR","ORISTANO",1],["G114","CN","ORMEA",1],["G115","TV","ORMELLE",1],["G116","MB","ORNAGO",1],["G116","MI","ORNAGO",0],["G117","VB","ORNAVASSO",1],["G118","BG","ORNICA",1],["G119","NU","OROSEI",1],["G120","NU","OROTELLI",1],["G121","SA","ORRIA",1],["G122","NU","ORROLI",0],["G122","SU","ORROLI",1],["G123","TV","ORSAGO",1],["G124","AL","ORSARA",0],["G125","AV","ORSARA",0],["G124","AL","ORSARA BORMIDA",1],["G125","FG","ORSARA DI PUGLIA",1],["G125","AV","ORSARA-DAUNO IRPINA",0],["G126","CO","ORSENIGO",1],["G127","PL","ORSERA",0],["G128","CH","ORSOGNA",1],["G129","CS","ORSOMARSO",1],["G130","CE","ORTA",0],["G131","FG","ORTA",0],["G132","NO","ORTA",0],["G130","CE","ORTA DI ATELLA",1],["G131","FG","ORTA NOVA",1],["G132","NO","ORTA NOVARESE",0],["G134","NO","ORTA SAN GIULIO",1],["G133","CA","ORTACESUS",0],["G133","SU","ORTACESUS",1],["G135","VT","ORTE",1],["G136","LE","ORTELLE",1],["G137","AP","ORTEZZANO",0],["G137","FM","ORTEZZANO",1],["G138","RC","ORTI",0],["G139","AR","ORTIGNANO",0],["G139","AR","ORTIGNANO RAGGIOLO",1],["M240","TN","ORTISE'",0],["G140","BZ","ORTISEI",1],["F479","SA","ORTODONICO",0],["G141","CH","ORTONA",1],["G142","AQ","ORTONA DEI MARSI",1],["G143","SP","ORTONOVO",0],["G144","SV","ORTOVERO",1],["G145","AQ","ORTUCCHIO",1],["G146","NU","ORTUERI",1],["G147","NU","ORUNE",1],["G148","TR","ORVIETO",1],["B595","RI","ORVINIO",1],["G149","BS","ORZINUOVI",1],["G150","BS","ORZIVECCHI",1],["G151","TO","OSASCO",1],["G152","TO","OSASIO",1],["G153","SS","OSCHIRI",1],["G154","NU","OSIDDA",1],["G155","SV","OSIGLIA",1],["G156","SS","OSILO",1],["G157","AN","OSIMO",1],["G158","NU","OSINI",1],["G159","BG","OSIO SOPRA",1],["G160","BG","OSIO SOTTO",1],["E529","VA","OSMATE",0],["E529","VA","OSMATE-LENTATE",0],["G161","LC","OSNAGO",1],["G162","AP","OSOLI",0],["G163","UD","OSOPPO",1],["G164","IM","OSPEDALETTI",1],["G165","AV","OSPEDALETTO",0],["G166","MI","OSPEDALETTO",0],["G167","PD","OSPEDALETTO",0],["G168","TN","OSPEDALETTO",1],["G165","AV","OSPEDALETTO D'ALPINOLO",1],["G167","PD","OSPEDALETTO EUGANEO",1],["G166","LO","OSPEDALETTO LODIGIANO",1],["G169","BL","OSPITALE",0],["G169","BL","OSPITALE DI CADORE",1],["G170","BS","OSPITALETTO",1],["G171","LO","OSSAGO LODIGIANO",1],["G172","CR","OSSALENGO",0],["G173","TN","OSSANA",1],["G174","BG","OSSANESGA",0],["G175","GO","OSSECCA VITTUGLIA",0],["G176","GO","OSSEGLIANO SAN MICHELE",0],["G177","PL","OSSERO",0],["G178","SS","OSSI",1],["G179","BS","OSSIMO",1],["G180","CR","OSSOLARO",0],["G181","MI","OSSONA",1],["G182","CO","OSSUCCIO",0],["G183","CN","OSTANA",1],["G184","FE","OSTELLATO",1],["G185","CR","OSTIANO",1],["G186","MN","OSTIGLIA",1],["F401","AN","OSTRA",1],["F581","AN","OSTRA VETERE",1],["G187","BR","OSTUNI",1],["G188","LE","OTRANTO",1],["G189","TR","OTRICOLI",1],["G190","NA","OTTAIANO",0],["G191","NU","OTTANA",1],["G192","SA","OTTATI",1],["G190","NA","OTTAVIANO",1],["G193","AL","OTTIGLIO",1],["G194","PV","OTTOBIANO",1],["G195","PC","OTTONE",1],["G196","TO","OULX",1],["G197","AL","OVADA",1],["G198","UD","OVARO",1],["G199","AL","OVIGLIO",1],["G200","AQ","OVINDOLI",1],["G201","NU","OVODDA",1],["G012","AO","OYACE",1],["G202","TO","OZEGNA",1],["G203","SS","OZIERI",1],["G204","AL","OZZANO",0],["G205","BO","OZZANO",0],["G205","BO","OZZANO DELL'EMILIA",1],["G204","AL","OZZANO DI ROBIANO",0],["G204","AL","OZZANO MONFERRATO",1],["G206","MI","OZZERO",1],["G207","CA","PABILLONIS",0],["G207","SU","PABILLONIS",1],["G209","ME","PACE DEL MELA",1],["G208","TP","PACECO",1],["G210","AQ","PACENTRO",1],["G211","SR","PACHINO",1],["G212","PG","PACIANO",1],["G213","BS","PADENGHE",0],["G213","BS","PADENGHE SUL GARDA",1],["G214","TN","PADERGNONE",0],["G215","AL","PADERNA",1],["G216","BS","PADERNELLO",0],["G217","BS","PADERNO",0],["G218","CO","PADERNO",0],["G219","CR","PADERNO",0],["G220","MI","PADERNO",0],["G221","TV","PADERNO",0],["G219","CR","PADERNO CREMONESE",0],["G218","LC","PADERNO D'ADDA",1],["G221","TV","PADERNO D'ASOLO",0],["G221","TV","PADERNO DEL GRAPPA",0],["G220","MI","PADERNO DUGNANO",1],["G219","CR","PADERNO FASOLARO",0],["G217","BS","PADERNO FRANCIACORTA",1],["G220","MI","PADERNO MILANESE",0],["G222","CR","PADERNO OSSOLARO",0],["G222","CR","PADERNO PONCHIELLI",1],["G223","CO","PADERNO ROBBIATE",0],["G224","PD","PADOVA",1],["G225","SS","PADRIA",1],["M301","SS","PADRU",1],["G226","SA","PADULA",1],["G227","BN","PADULI",1],["G228","CN","PAESANA",1],["G229","TV","PAESE",1],["Z126","EE","PAESI BASSI",0],["G230","SA","PAGANI",1],["G231","AQ","PAGANICA",0],["C782","GR","PAGANICO",0],["G232","RI","PAGANICO SABINO",1],["G233","BG","PAGAZZANO",1],["G234","ME","PAGLIARA",1],["G235","AP","PAGLIARE",0],["G236","CN","PAGLIERES",0],["G237","CH","PAGLIETA",1],["G238","UD","PAGNACCO",1],["G239","CO","PAGNANO",0],["G239","CO","PAGNANO VALSASSINA",0],["G240","CN","PAGNO",1],["G241","LC","PAGNONA",1],["G242","AV","PAGO",0],["G243","BN","PAGO",0],["G242","AV","PAGO DEL VALLO DI LAURO",1],["G243","BN","PAGO VEIANO",1],["G244","MI","PAINA",0],["G245","PV","PAIRANA",0],["G246","BS","PAISCO",0],["G247","BS","PAISCO LOVENO",1],["G248","BS","PAITONE",1],["Z236","EE","PAKISTAN",0],["G249","BG","PALADINA",1],["G250","MO","PALAGANO",1],["G251","TA","PALAGIANELLO",1],["G252","TA","PALAGIANO",1],["G253","CT","PALAGONIA",1],["G254","PI","PALAIA",1],["G255","PR","PALANZANO",1],["G256","CO","PALANZO",0],["G257","CB","PALATA",1],["G258","SS","PALAU",1],["Z734","EE","PALAU",0],["Z734","EE","PALAU REPUBBLICA",0],["G259","BG","PALAZZAGO",1],["G260","CR","PALAZZO",0],["G261","PZ","PALAZZO",0],["G262","TO","PALAZZO",0],["G263","PA","PALAZZO ADRIANO",1],["G262","TO","PALAZZO CANAVESE",1],["G260","CR","PALAZZO PIGNANO",1],["G269","TO","PALAZZO PIVERONE",0],["G260","CR","PALAZZO PUGNANO",0],["G261","PZ","PALAZZO SAN GERVASIO",1],["C340","FR","PALAZZOLO",0],["G264","BS","PALAZZOLO",0],["G265","MI","PALAZZOLO",0],["G266","NO","PALAZZOLO",0],["G267","SR","PALAZZOLO",0],["G268","UD","PALAZZOLO",0],["G267","SR","PALAZZOLO ACREIDE",1],["G268","UD","PALAZZOLO DELLO STELLA",1],["C340","CE","PALAZZOLO DI CASTROCIELO",0],["G265","MI","PALAZZOLO MILANESE",0],["G264","BS","PALAZZOLO SULL'OGLIO",1],["G266","VC","PALAZZOLO VERCELLESE",1],["G270","FI","PALAZZUOLO",0],["G270","FI","PALAZZUOLO DI ROMAGNA",0],["G270","FI","PALAZZUOLO SUL SENIO",1],["G271","CH","PALENA",1],["G272","CZ","PALERMITI",1],["G273","PA","PALERMO",1],["G274","RM","PALESTRINA",1],["G275","PV","PALESTRO",1],["G276","FR","PALIANO",1],["G277","RC","PALIZZI",1],["G278","KR","PALLAGORIO",1],["G279","NO","PALLANZA",0],["G280","VB","PALLANZENO",1],["G281","SV","PALLARE",1],["G282","AG","PALMA",0],["G283","CE","PALMA",0],["G283","NA","PALMA CAMPANIA",1],["G282","AG","PALMA DI MONTECHIARO",1],["G284","UD","PALMANOVA",1],["G285","LE","PALMARIGGI",1],["G286","CA","PALMAS",0],["G287","CA","PALMAS",0],["G286","OR","PALMAS ARBOREA",1],["G287","CA","PALMAS SUERGIU",0],["G288","RC","PALMI",1],["G289","AP","PALMIANO",1],["G081","PZ","PALMIRA",0],["G290","CH","PALMOLI",1],["G291","BA","PALO",0],["G292","SA","PALO",0],["G291","BA","PALO DEL COLLE",1],["G293","RM","PALOMBARA",0],["G293","RM","PALOMBARA SABINA",1],["G294","CH","PALOMBARO",1],["G292","SA","PALOMONTE",1],["G295","BG","PALOSCO",1],["G296","TN","PALU'",0],["G297","VR","PALU'",1],["G296","TN","PALU' DEL FERSINA",1],["G298","CS","PALUDI",1],["G299","BZ","PALUS",0],["G300","UD","PALUZZA",1],["G301","CR","PALVARETO",0],["G302","CN","PAMPARATO",1],["Z516","EE","PANAMA",0],["Z517","EE","PANAMA ZONA DEL CANALE",0],["Z516","EE","PANAMA'",0],["G303","TO","PANCALIERI",1],["G304","PV","PANCARANA",1],["G305","TN","PANCHIA'",1],["G306","CR","PANDINO",1],["G307","CS","PANETTIERI",1],["G308","PG","PANICALE",1],["G309","NA","PANICOCOLI",0],["G310","GO","PANIQUA",0],["G311","BN","PANNARANO",1],["G312","FG","PANNI",1],["G313","TN","PANNONE",0],["G314","IM","PANTASINA",0],["G315","TP","PANTELLERIA",1],["G316","MI","PANTIGLIATE",1],["G317","CS","PAOLA",1],["G318","BN","PAOLISI",1],["G319","TP","PAPARELLA SAN MARCO",0],["G320","CS","PAPASIDERO",1],["G321","PV","PAPIAGO",0],["G322","TR","PAPIGNO",0],["G323","RO","PAPOZZE",1],["Z730","EE","PAPUA NUOVA GUINEA",0],["Z720","EE","PAPUASIA",0],["G324","MI","PARABIAGO",1],["G325","LE","PARABITA",1],["G326","RC","PARACORIO",0],["Z610","EE","PARAGUAY",0],["G327","BS","PARATICO",1],["G328","BZ","PARCINES",1],["A239","PA","PARCO",0],["G329","CO","PARE'",0],["G330","TO","PARELLA",1],["G331","CS","PARENTI",1],["G332","PL","PARENZO",0],["G333","CE","PARETE",1],["G334","AL","PARETO",1],["G335","VV","PARGHELIA",1],["C782","GR","PARI",0],["G336","LC","PARLASCO",1],["G337","PR","PARMA",1],["G338","AL","PARODI",0],["G338","AL","PARODI LIGURE",1],["G339","CN","PAROLDO",1],["G340","AV","PAROLISE",1],["G341","VR","PARONA",0],["G342","PV","PARONA",1],["G341","VR","PARONA ALL'ADIGE",0],["G341","VR","PARONA DI VALPOLICELLA",0],["G343","VC","PARONE",0],["G344","TR","PARRANO",1],["G345","CO","PARRAVICINO",0],["G346","BG","PARRE",1],["G347","TP","PARTANNA",1],["G348","PA","PARTINICO",1],["G349","NO","PARUZZARO",1],["G350","BG","PARZANICA",1],["G351","PG","PASCELUPO",0],["G352","UD","PASIAN DI PRATO",1],["A700","UD","PASIAN SCHIAVONESCO",0],["G353","PN","PASIANO DI PORDENONE",1],["G354","BS","PASPARDO",1],["Z721","EE","PASQUA (ISOLA)",0],["G355","CR","PASSARERA",0],["G356","UD","PASSARIANO",0],["G357","AL","PASSERANO",0],["G358","AT","PASSERANO MARMORITO",1],["G359","PG","PASSIGNANO",0],["G359","PG","PASSIGNANO SUL TRASIMENO",1],["G360","MI","PASSIRANA",0],["G360","MI","PASSIRANA MILANESE",0],["G361","BS","PASSIRANO",1],["G362","FR","PASTENA",1],["G363","BN","PASTENE",0],["G364","CE","PASTORANO",1],["G365","VR","PASTRENGO",1],["G366","MI","PASTURAGO",0],["G367","AL","PASTURANA",1],["G368","LC","PASTURO",1],["G369","AN","PATERNO",0],["G370","AV","PATERNO",0],["G372","CS","PATERNO",0],["M269","PZ","PATERNO",1],["G372","CS","PATERNO CALABRO",1],["G369","AN","PATERNO D'ANCONA",0],["G371","CT","PATERNO'",1],["G370","AV","PATERNOPOLI",1],["G373","TN","PATONE",0],["G374","FR","PATRICA",1],["G375","AP","PATRIGNONE",0],["G376","SS","PATTADA",1],["G377","ME","PATTI",1],["G378","LE","PATU'",1],["G379","OR","PAU",1],["G380","TS","PAUGNANO",0],["G381","UD","PAULARO",1],["G382","CA","PAULI ARBAREI",0],["G382","SU","PAULI ARBAREI",1],["G383","CA","PAULI GERREI",0],["F383","CA","PAULI MONSERRATO",0],["F383","CA","PAULI PIRRI",0],["G384","OR","PAULILATINO",1],["G385","MI","PAULLO",1],["G386","BN","PAUPISI",1],["D042","MC","PAUSULA",0],["G387","TO","PAVAROLO",1],["G388","PV","PAVIA",1],["G389","UD","PAVIA",0],["G389","UD","PAVIA DI UDINE",1],["G390","AL","PAVONE",0],["G391","BS","PAVONE",0],["G392","TO","PAVONE",0],["G392","TO","PAVONE CANAVESE",1],["G390","AL","PAVONE D'ALESSANDRIA",0],["G391","BS","PAVONE DEL MELLA",1],["G393","MO","PAVULLO",0],["G393","MO","PAVULLO NEL FRIGNANO",1],["G394","RC","PAZZANO",1],["G395","PI","PECCIOLI",1],["G396","TO","PECCO",0],["G397","AL","PECETTO",0],["G397","AL","PECETTO DI VALENZA",1],["G398","TO","PECETTO TORINESE",1],["G399","PC","PECORARA",0],["G400","CS","PEDACE",0],["G401","AO","PEDANEA",0],["G402","CT","PEDARA",1],["G403","AP","PEDASO",0],["G403","FM","PEDASO",1],["G404","BL","PEDAVENA",1],["G405","RC","PEDAVOLI",0],["G406","VI","PEDEMONTE",1],["G407","BS","PEDERGNAGA",0],["G407","BS","PEDERGNAGA-ORIANO",0],["G408","TV","PEDEROBBA",1],["G409","TN","PEDERSANO",0],["G410","SO","PEDESINA",1],["G411","CS","PEDIVIGLIANO",1],["G412","BG","PEDRENGO",1],["G413","MI","PEDRIANO",0],["G414","GE","PEGLI",0],["G415","CO","PEGLIO",1],["G416","PU","PEGLIO",1],["G417","MN","PEGOGNAGA",1],["G418","BG","PEIA",1],["G419","TN","PEIO",1],["G419","TN","PEJO",0],["G420","FI","PELAGO",1],["G421","NO","PELLA",1],["G422","RC","PELLARO",0],["G423","FI","PELLEGRINO",0],["G424","PR","PELLEGRINO",0],["G423","FI","PELLEGRINO DA CAREGGI",0],["G424","PR","PELLEGRINO PARMENSE",1],["G425","VE","PELLESTRINA",0],["G426","SA","PELLEZZANO",1],["A910","TO","PELLICE",0],["G427","CO","PELLIO INTELVI",0],["G428","TN","PELLIZZANO",1],["G429","TN","PELUGO",1],["G430","AT","PENANGO",1],["G431","SO","PENDOLASCO",0],["G041","IM","PENNA",0],["G432","TR","PENNA",0],["G432","TR","PENNA IN TEVERINA",1],["G436","MC","PENNA SAN GIOVANNI",1],["G437","TE","PENNA SANT'ANDREA",1],["G433","PU","PENNABILLI",0],["G433","RN","PENNABILLI",1],["G434","CH","PENNADOMO",1],["G435","CH","PENNAPIEDIMONTE",1],["G438","PE","PENNE",1],["C999","AQ","PENTIMA",0],["G439","CZ","PENTONE",1],["G440","CO","PENZANO",0],["G464","TN","PERA",0],["G441","CH","PERANO",1],["G442","BL","PERAROLO",0],["G442","BL","PERAROLO DI CADORE",1],["G443","BZ","PERCA",1],["G444","RM","PERCILE",1],["G445","NU","PERDASDEFOGU",1],["G446","CA","PERDAXIUS",0],["G446","SU","PERDAXIUS",1],["G447","SA","PERDIFUMO",1],["G448","LC","PEREGO",0],["G449","AQ","PERETO",1],["G450","SS","PERFUGAS",1],["G443","BZ","PERGA",0],["G451","AR","PERGINE",0],["G452","TN","PERGINE",0],["G451","AR","PERGINE VALDARNO",0],["G452","TN","PERGINE VALSUGANA",1],["G453","PU","PERGOLA",1],["G454","IM","PERINALDO",1],["G455","SA","PERITO",1],["G456","LC","PERLEDO",1],["G457","CN","PERLETTO",1],["G458","CN","PERLO",1],["G459","AO","PERLOZ",1],["G460","CN","PERNO",0],["G461","PD","PERNUMIA",1],["C013","MI","PERO",1],["G462","TO","PEROSA",0],["G463","TO","PEROSA",0],["G463","TO","PEROSA ARGENTINA",1],["G462","TO","PEROSA CANAVESE",1],["G465","TO","PERRERO",1],["G466","BN","PERRILLO",0],["G467","BO","PERSICETO",0],["G468","CR","PERSICO",0],["G469","CR","PERSICO DOSIMO",1],["G470","TN","PERSONE",0],["G471","VC","PERTENGO",1],["G472","UD","PERTEOLE",0],["G473","GE","PERTI",0],["G474","BS","PERTICA ALTA",1],["G475","BS","PERTICA BASSA",1],["G476","SA","PERTOSA",1],["G477","TO","PERTUSIO",1],["Z611","EE","PERU'",0],["G478","PG","PERUGIA",1],["G479","PU","PESARO",1],["G480","LU","PESCAGLIA",1],["G481","VR","PESCANTINA",1],["G482","PE","PESCARA",1],["G483","CR","PESCAROLO",0],["G483","CR","PESCAROLO ED UNITI",1],["G484","AQ","PESCASSEROLI",1],["G485","LC","PESCATE",1],["G486","IS","PESCHE",1],["G487","FG","PESCHICI",1],["G488","MI","PESCHIERA",0],["G489","VR","PESCHIERA",0],["G488","MI","PESCHIERA BORROMEO",1],["G490","BS","PESCHIERA D'ISEO",0],["G489","VR","PESCHIERA DEL GARDA",1],["G490","BS","PESCHIERA MARAGLIO",0],["G489","VR","PESCHIERA SUL LAGO DI GARDA",0],["G491","PT","PESCIA",1],["G492","AQ","PESCINA",1],["G494","BN","PESCO SANNITA",1],["G493","AQ","PESCOCOSTANZO",1],["G494","BN","PESCOLAMAZZA",0],["G495","IS","PESCOLANCIANO",1],["G496","PZ","PESCOPAGANO",1],["G497","IS","PESCOPENNATARO",1],["G498","RI","PESCOROCCHIANO",1],["G499","PE","PESCOSANSONESCO",1],["G500","FR","PESCOSOLIDO",1],["G501","MI","PESSANO",0],["G502","MI","PESSANO CON BORNAGO",1],["G503","CO","PESSINA",0],["G504","CR","PESSINA",0],["G504","CR","PESSINA CREMONESE",1],["G504","CR","PESSINA CREMONESE ED UNITI",0],["G503","CO","PESSINA VALSASSINA",0],["G505","TO","PESSINETTO",1],["G506","CB","PETACCIATO",1],["G507","RI","PETESCIA",0],["G508","KR","PETILIA POLICASTRO",1],["G509","SA","PETINA",1],["G510","PA","PETRALIA SOPRANA",1],["G511","PA","PETRALIA SOTTANA",1],["G512","CB","PETRELLA",0],["G513","RI","PETRELLA",0],["G513","RI","PETRELLA SALTO",1],["G512","CB","PETRELLA TIFERNINA",1],["G514","PU","PETRIANO",1],["G515","MC","PETRIOLO",1],["G516","AP","PETRITOLI",0],["G516","FM","PETRITOLI",1],["G517","CZ","PETRIZZI",1],["G518","CZ","PETRONA'",1],["M281","TP","PETROSINO",1],["G519","AV","PETRURO",0],["G519","AV","PETRURO IRPINO",1],["G520","NO","PETTENASCO",1],["G521","BI","PETTINENGO",1],["G522","ME","PETTINEO",1],["G523","IS","PETTORANELLO DEL MOLISE",1],["G523","CB","PETTORANELLO DI MOLISE",0],["G523","CB","PETTORANO",0],["G524","AQ","PETTORANO",0],["G524","AQ","PETTORANO SUL GIZIO",1],["G525","RO","PETTORAZZA GRIMANI",1],["G526","CN","PEVERAGNO",1],["G527","MI","PEVERANZA",0],["G528","VC","PEZZANA",1],["G529","BS","PEZZAZE",1],["G530","MI","PEZZOLO DE' CODAZZI",0],["G531","MI","PEZZOLO DI TAVAZZANO",0],["G532","CN","PEZZOLO VALLE UZZONE",1],["G533","BS","PEZZORO",0],["G534","PD","PIACENZA",0],["G535","PC","PIACENZA",1],["G534","PD","PIACENZA D'ADIGE",1],["G536","CR","PIADENA",0],["M418","CR","PIADENA DRIZZONA",1],["G537","PU","PIAGGE",0],["G538","SA","PIAGGINE",1],["G539","SA","PIAGGINE SOPRANE",0],["G540","SA","PIAGGINE SOTTANE",0],["G546","BS","PIAN CAMUNO",1],["G550","BS","PIAN D'ARTOGNE",0],["F136","PU","PIAN DI CASTELLO",0],["G552","AR","PIAN DI SCO",0],["G562","BG","PIAN GAIANO",0],["G541","CE","PIANA",0],["G542","GE","PIANA",0],["G542","SV","PIANA CRIXIA",1],["G543","PA","PIANA DEGLI ALBANESI",1],["G543","PA","PIANA DEI GRECI",0],["G541","CE","PIANA DI CAIAZZO",0],["G541","CE","PIANA DI MONTE VERNA",1],["G544","IM","PIANAVIA",0],["G545","AO","PIANBOSETO",0],["G547","SI","PIANCASTAGNAIO",1],["G548","VC","PIANCERI",0],["G549","BS","PIANCOGNO",1],["G551","PU","PIANDIMELETO",1],["G553","CS","PIANE",0],["G554","NO","PIANE",0],["G553","CS","PIANE CRATI",1],["G554","NO","PIANE DI SERRAVALLE SESIA",0],["G554","NO","PIANE SESIA",0],["G555","PE","PIANELLA",1],["G556","CO","PIANELLO",0],["G557","PC","PIANELLO",0],["G556","CO","PIANELLO DEL LARIO",1],["G557","PC","PIANELLO VAL TIDONE",1],["G558","CR","PIANENGO",1],["G559","TO","PIANEZZA",1],["G560","VI","PIANEZZE",1],["G561","CN","PIANFEI",1],["G563","IM","PIANI",0],["G564","BG","PIANICO",1],["G565","VE","PIANIGA",1],["G546","BS","PIANO",0],["G566","BO","PIANO",0],["G567","CO","PIANO",0],["G568","NA","PIANO",0],["G569","TN","PIANO",0],["G566","BO","PIANO DEL VOGLIO",0],["G568","NA","PIANO DI SORRENTO",1],["F766","BZ","PIANO IN PASSIRIA",0],["G567","CO","PIANO PORLEZZA",0],["D546","CZ","PIANOPOLI",1],["G570","BO","PIANORO",1],["G571","VT","PIANSANO",1],["G572","SO","PIANTEDO",1],["G573","NA","PIANURA",0],["G574","BG","PIARIO",1],["G575","CN","PIASCO",1],["G576","SO","PIATEDA",1],["G577","BI","PIATTO",1],["G578","TV","PIAVON",0],["G579","BG","PIAZZA",0],["G580","CL","PIAZZA",0],["G581","CO","PIAZZA",0],["G582","MS","PIAZZA",0],["G582","LU","PIAZZA AL SERCHIO",1],["G580","EN","PIAZZA ARMERINA",1],["G579","BG","PIAZZA BREMBANA",1],["G581","CO","PIAZZA SANTO STEFANO",0],["G583","BG","PIAZZATORRE",1],["G584","TO","PIAZZO",0],["G585","BG","PIAZZO ALTO",0],["G586","BG","PIAZZO BASSO",0],["G587","PD","PIAZZOLA",0],["G587","PD","PIAZZOLA SUL BRENTA",1],["G588","BG","PIAZZOLO",1],["G589","PE","PICCIANO",1],["G590","PZ","PICERNO",1],["G591","FR","PICINISCO",1],["G592","FR","PICO",1],["G593","AT","PIEA",1],["G594","BI","PIEDICAVALLO",1],["G595","TR","PIEDILUCO",0],["G596","CE","PIEDIMONTE",0],["G597","CT","PIEDIMONTE",0],["G598","FR","PIEDIMONTE",0],["G596","CE","PIEDIMONTE D'ALIFE",0],["G599","GO","PIEDIMONTE DEL CALVARIO",0],["G597","CT","PIEDIMONTE ETNEO",1],["G596","CE","PIEDIMONTE MATESE",1],["G598","FR","PIEDIMONTE SAN GERMANO",1],["G600","VB","PIEDIMULERA",1],["F090","PG","PIEDIPATERNO SUL NERA",0],["G601","PG","PIEGARO",1],["M296","PL","PIEMONTE D'ISTRIA",0],["G041","IM","PIENA",0],["G602","SI","PIENZA",1],["G603","CR","PIERANICA",1],["G604","FG","PIETRA",0],["G605","GE","PIETRA",0],["G612","PV","PIETRA DE' GIORGI",1],["G617","PV","PIETRA GAVINA",0],["G605","SV","PIETRA LIGURE",1],["G619","AL","PIETRA MARAZZI",1],["G606","IS","PIETRABBONDANTE",1],["G607","IM","PIETRABRUNA",1],["G608","TE","PIETRACAMELA",1],["G609","CB","PIETRACATELLA",1],["G610","CB","PIETRACUPA",1],["G611","AV","PIETRADEFUSI",1],["G613","CH","PIETRAFERRAZZANA",1],["G614","PZ","PIETRAFESA",0],["G615","CS","PIETRAFITTA",1],["G616","PZ","PIETRAGALLA",1],["G618","PG","PIETRALUNGA",1],["C795","CS","PIETRAMALA",0],["G620","CE","PIETRAMELARA",1],["G604","FG","PIETRAMONTECORVINO",1],["G621","PE","PIETRANICO",1],["G622","CS","PIETRAPAOLA",1],["G623","PZ","PIETRAPERTOSA",1],["G624","EN","PIETRAPERZIA",1],["G625","CN","PIETRAPORZIO",1],["G626","BN","PIETRAROJA",1],["G627","PU","PIETRARUBBIA",1],["G628","LU","PIETRASANTA",1],["G629","AV","PIETRASTORNINA",1],["G630","CE","PIETRAVAIRANO",1],["G631","BN","PIETRELCINA",1],["G632","IM","PIEVE",0],["G633","MN","PIEVE",0],["G634","MI","PIEVE",0],["G636","PT","PIEVE A NIEVOLE",1],["G635","PV","PIEVE ALBIGNOLA",1],["G638","BL","PIEVE D'ALPAGO",0],["G647","CR","PIEVE D'OLMI",1],["G639","PV","PIEVE DEL CAIRO",1],["M422","TV","PIEVE DEL GRAPPA",1],["G640","CR","PIEVE DELMONA",0],["G641","TN","PIEVE DI BONO",0],["M365","TN","PIEVE DI BONO-PREZZO",1],["G642","BL","PIEVE DI CADORE",1],["G643","BO","PIEVE DI CENTO",1],["G633","MN","PIEVE DI CORIANO",0],["G644","TN","PIEVE DI LEDRO",0],["G645","TV","PIEVE DI SOLIGO",1],["G646","GE","PIEVE DI SORI",0],["G632","IM","PIEVE DI TECO",1],["G634","MI","PIEVE EMANUELE",1],["G096","LO","PIEVE FISSIRAGA",1],["G648","LU","PIEVE FOSCIANA",1],["G646","GE","PIEVE LIGURE",1],["G650","PV","PIEVE PORTO MORONE",1],["G651","CR","PIEVE SAN GIACOMO",1],["G652","CR","PIEVE SAN MAURIZIO",0],["G654","RE","PIEVE SAN VINCENZO",0],["G653","AR","PIEVE SANTO STEFANO",1],["G655","CR","PIEVE TERZAGNI",0],["G656","TN","PIEVE TESINO",1],["G657","MC","PIEVE TORINA",1],["G658","VB","PIEVE VERGONTE",1],["G637","MC","PIEVEBOVIGLIANA",0],["G649","MO","PIEVEPELAGO",1],["G659","FR","PIGLIO",1],["G660","IM","PIGNA",1],["G661","CE","PIGNATARO",0],["G662","FR","PIGNATARO",0],["G662","FR","PIGNATARO INTERAMNA",1],["G661","CE","PIGNATARO MAGGIORE",1],["G663","PZ","PIGNOLA",1],["G663","PZ","PIGNOLA DI BASILICATA",0],["G664","SP","PIGNONE",1],["G665","CO","PIGRA",1],["G666","VC","PILA",1],["G667","TN","PILCANTE",0],["G668","BS","PILZONE",0],["G669","CA","PIMENTEL",0],["G669","SU","PIMENTEL",1],["G670","NA","PIMONTE",1],["G671","PV","PINAROLO",0],["G671","PV","PINAROLO PO",1],["G672","TO","PINASCA",1],["G673","RO","PINCARA",1],["G674","TO","PINEROLO",1],["F831","TE","PINETO",1],["G675","PL","PINGUENTE",0],["G676","AL","PINO",0],["G677","CO","PINO",0],["G676","AT","PINO D'ASTI",1],["G678","TO","PINO DI CHIERI",0],["G677","VA","PINO SULLA SPONDA DEL LAGO MAGGIORE",0],["G678","TO","PINO TORINESE",1],["G679","MI","PINZANO",0],["G680","UD","PINZANO",0],["G680","PN","PINZANO AL TAGLIAMENTO",1],["G681","TN","PINZOLO",1],["G682","PU","PIOBBICO",1],["G683","CN","PIOBESI",0],["G684","TO","PIOBESI",0],["G683","CN","PIOBESI D'ALBA",1],["G684","TO","PIOBESI TORINESE",1],["G685","VC","PIODE",1],["G686","MI","PIOLTELLO",1],["G687","LI","PIOMBINO",1],["G688","PD","PIOMBINO",0],["G688","PD","PIOMBINO DESE",1],["G689","PR","PIONE",0],["G690","MC","PIORACO",1],["G691","TO","PIOSSASCO",1],["G692","AT","PIOVA'",0],["G692","AT","PIOVA' MASSAIA",1],["G693","PD","PIOVE DI SACCO",1],["G694","VI","PIOVENE",0],["G694","VI","PIOVENE ROCCHETTE",1],["G695","AL","PIOVERA",0],["G696","PC","PIOZZANO",1],["G697","CN","PIOZZO",1],["G698","RM","PIPERNO",0],["G699","ME","PIRAINO",1],["G700","PL","PIRANO",0],["G701","CA","PIRRI",0],["G702","PI","PISA",1],["G703","NO","PISANO",1],["G704","RM","PISCIANO",0],["G705","TO","PISCINA",1],["M291","CA","PISCINAS",0],["M291","SU","PISCINAS",1],["G706","NA","PISCINOLA",0],["G707","SA","PISCIOTTA",1],["G708","CZ","PISCOPIO",0],["G709","PL","PISINO",0],["G710","BS","PISOGNE",1],["G704","RM","PISONIANO",1],["G711","PV","PISSARELLO",0],["G712","MT","PISTICCI",1],["G713","PT","PISTOIA",1],["G714","BI","PISTOLESA",0],["Z722","EE","PITCAIRN (E DIPENDENZE)",0],["G715","PT","PITEGLIO",0],["G716","GR","PITIGLIANO",1],["G717","MN","PIUBEGA",1],["G718","SO","PIURO",1],["G719","TO","PIVERONE",1],["G720","PV","PIZZALE",1],["G721","CR","PIZZIGHETTONE",1],["G722","VV","PIZZO",1],["G723","PV","PIZZOCORNO",0],["G724","CH","PIZZOFERRATO",1],["G725","MI","PIZZOLANO",0],["G726","AQ","PIZZOLI",1],["G727","IS","PIZZONE",1],["G728","VV","PIZZONI",1],["G729","RC","PLACANICA",1],["G730","BZ","PLAGNOLO",0],["G731","GO","PLANINA",0],["G730","BZ","PLANOL",0],["G732","BZ","PLATA",0],["G733","CS","PLATACI",1],["G734","CZ","PLATANIA",1],["G732","BZ","PLATEA",0],["G735","RC","PLATI'",1],["G736","UD","PLATISCHIS",0],["G299","BZ","PLAUS",1],["G737","CO","PLESIO",1],["G738","GO","PLEZZO",0],["G739","GO","PLISCOVIZZA DELLA MADONNA",0],["G740","SS","PLOAGHE",1],["G741","SV","PLODIO",1],["G742","CN","POCAPAGLIA",1],["G743","UD","POCENIA",1],["G744","GO","POCRAI DEL PERO",0],["G745","RC","PODARGONI",0],["G746","MS","PODENZANA",1],["G747","PC","PODENZANO",1],["G599","UD","PODGORA",0],["G748","GO","PODRAGA",0],["G749","FR","POFI",1],["G750","IM","POGGI",0],["G751","LE","POGGIARDO",1],["G752","SI","POGGIBONSI",1],["G753","MN","POGGIO",0],["G754","PO","POGGIO A CAIANO",1],["G755","RN","POGGIO BERNI",0],["G756","RI","POGGIO BUSTONE",1],["G757","RI","POGGIO CATINO",1],["G759","RI","POGGIO FIDONI",0],["G761","FG","POGGIO IMPERIALE",1],["G763","RI","POGGIO MIRTETO",1],["G764","RI","POGGIO MOIANO",1],["G765","RI","POGGIO NATIVO",1],["G766","AQ","POGGIO PICENZE",1],["G768","FE","POGGIO RENATICO",1],["G753","MN","POGGIO RUSCO",1],["G770","RI","POGGIO SAN LORENZO",1],["G771","AN","POGGIO SAN MARCELLO",1],["D566","MC","POGGIO SAN VICINO",1],["B317","IS","POGGIO SANNITA",1],["M324","RN","POGGIO TORRIANA",1],["G758","PG","POGGIODOMO",1],["G760","CH","POGGIOFIORITO",1],["G762","NA","POGGIOMARINO",1],["G767","TP","POGGIOREALE",1],["G769","BA","POGGIORSINI",1],["G431","SO","POGGIRIDENTI",1],["G772","MI","POGLIANO",0],["G772","MI","POGLIANO MILANESE",1],["G773","CO","POGNANA",0],["G773","CO","POGNANA LARIO",1],["G774","BG","POGNANO",1],["G775","NO","POGNO",1],["M241","TN","POIA",0],["G776","VI","POIANA MAGGIORE",0],["G777","TO","POIRINO",1],["G776","VI","POJANA MAGGIORE",1],["G778","PL","POLA",0],["G779","BS","POLAVENO",1],["G780","PN","POLCENIGO",1],["G781","CR","POLENGO",0],["G782","RO","POLESELLA",1],["G783","PR","POLESINE",0],["G783","PR","POLESINE PARMENSE",0],["M367","PR","POLESINE ZIBELLO",1],["G784","RM","POLI",1],["G785","VV","POLIA",1],["G508","CZ","POLICASTRO",0],["B657","SA","POLICASTRO DEL GOLFO",0],["G786","MT","POLICORO",1],["G787","BA","POLIGNANO",0],["G788","PC","POLIGNANO",0],["G787","BA","POLIGNANO A MARE",1],["G788","PC","POLIGNANO PIACENTINO",0],["G789","MO","POLINAGO",1],["Z723","EE","POLINESIA FRANCESE (ISOLE)",0],["G790","TR","POLINO",1],["G791","RC","POLISTENA",1],["G792","PA","POLIZZI",0],["G792","PA","POLIZZI GENEROSA",1],["G793","SA","POLLA",1],["G794","AO","POLLEIN",1],["G795","NA","POLLENA TROCCHIA",1],["F567","MC","POLLENZA",1],["G796","SA","POLLICA",1],["G797","PA","POLLINA",1],["G798","BI","POLLONE",1],["G799","CH","POLLUTRI",1],["G800","CN","POLONGHERA",1],["Z127","EE","POLONIA",0],["G801","BS","POLPENAZZE DEL GARDA",1],["G802","PD","POLVERARA",1],["G803","AN","POLVERIGI",1],["G804","PI","POMARANCE",1],["G805","TO","POMARETTO",1],["G806","MT","POMARICO",1],["G696","PC","POMARO",0],["G807","AL","POMARO",0],["G807","AL","POMARO MONFERRATO",1],["G696","PC","POMARO PIACENTINO",0],["G808","TN","POMAROLO",1],["G809","NO","POMBIA",1],["G810","PV","POMETO",0],["G811","RM","POMEZIA",1],["G812","NA","POMIGLIANO D'ARCO",1],["D790","NA","POMIGLIANO D'ATELLA",0],["G813","NA","POMPEI",1],["G814","IM","POMPEIANA",1],["G815","BS","POMPIANO",1],["G816","MN","POMPONESCO",1],["G817","CA","POMPU",0],["G817","OR","POMPU",1],["G818","BS","PONCARALE",1],["G819","BS","PONCARALE FLERO",0],["G820","BI","PONDERANO",1],["G821","CO","PONNA",1],["G822","PI","PONSACCO",1],["G823","PD","PONSO",1],["G545","AO","PONT BOZET",0],["G826","TO","PONT CANAVESE",0],["G826","TO","PONT-CANAVESE",1],["G854","AO","PONT-SAINT-MARTIN",1],["G824","BS","PONTAGNA",0],["G825","FI","PONTASSIEVE",1],["G545","AO","PONTBOSET",1],["G827","BN","PONTE",1],["G828","CO","PONTE",0],["G829","SO","PONTE",0],["G830","BZ","PONTE ALL'ISARCO",0],["G833","PT","PONTE BUGGIANESE",1],["G835","PV","PONTE CARATE",0],["B589","PD","PONTE CASALE",0],["G842","PC","PONTE DELL'OLIO",1],["G844","BS","PONTE DI LEGNO",1],["G845","BG","PONTE DI NOSSA",0],["G846","TV","PONTE DI PIAVE",1],["G830","BZ","PONTE GARDENA",1],["G829","SO","PONTE IN VALTELLINA",1],["G847","CO","PONTE LAMBRO",1],["B662","BL","PONTE NELLE ALPI",1],["G851","PV","PONTE NIZZA",1],["F941","BG","PONTE NOSSA",1],["G854","AO","PONTE SAN MARTINO",0],["G855","PD","PONTE SAN NICOLO'",1],["G856","BG","PONTE SAN PIETRO",1],["G831","UD","PONTEBBA",1],["G832","UD","PONTEBBA NOVA",0],["G834","SA","PONTECAGNANO FAIANO",1],["G836","RO","PONTECCHIO",0],["G836","RO","PONTECCHIO POLESINE",1],["G837","CN","PONTECHIANALE",1],["G838","FR","PONTECORVO",1],["G839","AL","PONTECURONE",1],["G840","IM","PONTEDASSIO",1],["G841","GE","PONTEDECIMO",0],["G843","PI","PONTEDERA",1],["G832","UD","PONTEFELLA",0],["G848","BN","PONTELANDOLFO",1],["G849","CE","PONTELATONE",1],["G847","CO","PONTELEZZA",0],["G850","PD","PONTELONGO",1],["G852","PC","PONTENURE",1],["G853","BG","PONTERANICA",1],["G857","MI","PONTESESTO",0],["G858","AL","PONTESTURA",1],["G859","BS","PONTEVICO",1],["G860","AO","PONTEY",1],["G861","AL","PONTI",1],["G862","VR","PONTI",0],["G862","MN","PONTI SUL MINCIO",1],["G863","NA","PONTICELLI",0],["G864","BG","PONTIDA",1],["G865","LT","PONTINIA",1],["G866","SV","PONTINVREA",1],["G867","BG","PONTIROLO",0],["G868","CR","PONTIROLO",0],["G868","CR","PONTIROLO CAPREDONI",0],["G867","BG","PONTIROLO NUOVO",1],["G864","BG","PONTITA",0],["G869","BS","PONTOGLIO",1],["G870","MS","PONTREMOLI",1],["A370","RM","PONZA",0],["G871","LT","PONZA",1],["A370","RM","PONZA D'ARCINAZZO",0],["G872","AL","PONZANO",0],["G873","AP","PONZANO",0],["G874","RM","PONZANO",0],["G875","TV","PONZANO",0],["G873","AP","PONZANO DI FERMO",0],["G873","FM","PONZANO DI FERMO",1],["G872","AL","PONZANO MONFERRATO",1],["G874","RM","PONZANO ROMANO",1],["G875","TV","PONZANO VENETO",1],["G876","CO","PONZATE",0],["G877","AL","PONZONE",1],["G878","PE","POPOLI",1],["G879","AR","POPPI",1],["G880","TN","POR",0],["G881","TR","PORANO",1],["G882","LU","PORCARI",1],["G883","AP","PORCHIA",0],["G884","TR","PORCHIANO",0],["G885","AP","PORCHIANO ASCOLI",0],["G884","TR","PORCHIANO DEL MONTE",0],["G885","AP","PORCHIANO DELL'ASCENSIONE",0],["G886","PN","PORCIA",1],["G887","SA","PORCILI",0],["G888","PN","PORDENONE",1],["G889","CO","PORLEZZA",1],["G890","IM","PORNASSIO",1],["G891","UD","PORPETTO",1],["A558","BO","PORRETTA",0],["A558","BO","PORRETTA TERME",0],["G892","FI","PORTA AL BORGO",0],["G893","FI","PORTA CARRATICA",0],["E470","AO","PORTA LITTORIA",0],["G896","FI","PORTA LUCCHESE",0],["G897","CR","PORTA OMBRIANO",0],["G899","FI","PORTA SAN MARCO",0],["G894","AT","PORTACOMARO",1],["G895","PV","PORTALBERA",1],["G898","PG","PORTARIA",0],["G900","TO","PORTE",1],["M358","TN","PORTE DI RENDENA",1],["G901","BS","PORTESE",0],["G902","NA","PORTICI",1],["G903","CE","PORTICO",0],["G904","FI","PORTICO",0],["G903","CE","PORTICO DI CASERTA",1],["G904","FI","PORTICO DI ROMAGNA",0],["G904","FC","PORTICO E SAN BENEDETTO",1],["G905","RC","PORTIGLIOLA",1],["E822","GE","PORTIO",0],["G906","CO","PORTO",0],["G907","CO","PORTO",0],["G908","MI","PORTO",0],["E680","LI","PORTO AZZURRO",1],["G906","VA","PORTO CERESIO",1],["M263","LE","PORTO CESAREO",1],["G911","MC","PORTO CIVITANOVA",0],["G908","MI","PORTO D'ADDA",0],["F299","AG","PORTO EMPEDOCLE",1],["E680","LI","PORTO LONGONE",0],["G917","MN","PORTO MANTOVANO",1],["G918","IM","PORTO MAURIZIO",0],["G919","MC","PORTO RECANATI",1],["G920","AP","PORTO SAN GIORGIO",0],["G920","FM","PORTO SAN GIORGIO",1],["G921","AP","PORTO SANT'ELPIDIO",0],["G921","FM","PORTO SANT'ELPIDIO",1],["G923","RO","PORTO TOLLE",1],["G924","SS","PORTO TORRES",1],["G907","VA","PORTO VALTRAVAGLIA",1],["G926","RO","PORTO VIRO",1],["G909","TV","PORTOBUFFOLE'",1],["G910","CB","PORTOCANNONE",1],["G912","LI","PORTOFERRAIO",1],["G913","GE","PORTOFINO",1],["Z128","EE","PORTOGALLO",0],["G914","VE","PORTOGRUARO",1],["G915","PL","PORTOLE",0],["G916","FE","PORTOMAGGIORE",1],["M257","SR","PORTOPALO DI CAPO PASSERO",1],["G922","CA","PORTOSCUSO",0],["G922","SU","PORTOSCUSO",1],["G925","SP","PORTOVENERE",1],["G927","BI","PORTULA",1],["G928","BS","PORZANO",0],["G929","NU","POSADA",1],["G930","BG","POSCANTE",0],["G931","VI","POSINA",1],["G932","SA","POSITANO",1],["G933","TV","POSSAGNO",1],["G934","RI","POSTA",1],["G935","FR","POSTA FIBRENO",1],["G936","BZ","POSTAL",1],["G937","SO","POSTALESIO",1],["G938","PG","POSTICCIOLA",0],["G939","SA","POSTIGLIONE",1],["G940","VC","POSTUA",1],["G941","TS","POSTUMIA GROTTE",0],["G942","PZ","POTENZA",1],["F632","MC","POTENZA PICENA",1],["G943","VI","POVE",0],["G943","VI","POVE DEL GRAPPA",1],["G944","TV","POVEGLIANO",1],["G945","VR","POVEGLIANO VERONESE",1],["G946","TS","POVERIO",0],["G947","RE","POVIGLIO",1],["G948","TN","POVO",0],["G949","UD","POVOLETTO",1],["G950","TN","POZZA",0],["G950","TN","POZZA DI FASSA",0],["G951","PG","POZZAGLIA",0],["G951","RI","POZZAGLIA SABINA",1],["G952","CR","POZZAGLIO",0],["B914","CR","POZZAGLIO ED UNITI",1],["G953","RG","POZZALLO",1],["G954","IS","POZZILLI",1],["G955","MI","POZZO",0],["G956","PU","POZZO",0],["G957","VI","POZZO",0],["G956","PU","POZZO ALTO",0],["G958","CR","POZZO BARONZIO",0],["G955","MI","POZZO D'ADDA",1],["G960","AL","POZZOL GROPPO",1],["G959","BS","POZZOLENGO",1],["G957","VI","POZZOLEONE",1],["G961","AL","POZZOLO FORMIGARO",1],["G962","SS","POZZOMAGGIORE",1],["G963","PD","POZZONOVO",1],["G964","NA","POZZUOLI",1],["G965","MI","POZZUOLO",0],["G966","UD","POZZUOLO",0],["G966","UD","POZZUOLO DEL FRIULI",1],["G965","MI","POZZUOLO MARTESANA",1],["G967","GE","PRA",0],["G968","BG","PRADALUNGA",1],["G969","UD","PRADAMANO",1],["G970","CN","PRADLEVE",0],["G970","CN","PRADLEVES",1],["G971","PV","PRADO",0],["G972","BO","PRADURO E SASSO",0],["G973","TO","PRAGELATO",1],["G975","CS","PRAIA A MARE",1],["G976","SA","PRAIANO",1],["G977","BS","PRALBOINO",1],["G978","TO","PRALI",1],["G979","TO","PRALORMO",1],["G980","BI","PRALUNGO",1],["G978","TO","PRALY",0],["G981","VE","PRAMAGGIORE",1],["G982","TO","PRAMOLLO",1],["G983","BS","PRANDAGLIO",0],["G984","TN","PRANZO",0],["G985","VC","PRAROLO",1],["G986","TO","PRAROSTINO",1],["G987","AL","PRASCO",1],["G988","TO","PRASCORSANO",1],["G989","TN","PRASO",0],["G990","AV","PRATA",0],["G991","CE","PRATA",0],["G992","AQ","PRATA",0],["G993","SO","PRATA",0],["G994","UD","PRATA",0],["G993","SO","PRATA CAMPORTACCIO",1],["G992","AQ","PRATA D'ANSIDONIA",1],["G994","PN","PRATA DI PORDENONE",1],["G990","AV","PRATA DI PRINCIPATO ULTRA",1],["G991","CE","PRATA SANNITA",1],["G995","CE","PRATELLA",1],["G996","BZ","PRATI",0],["G997","TO","PRATIGLIONE",1],["A767","BS","PRATO",0],["G998","CR","PRATO",0],["G999","PO","PRATO",1],["H001","NO","PRATO",0],["H002","UD","PRATO",0],["H003","BZ","PRATO ALLA DRAVA",0],["H004","BZ","PRATO ALLO STELVIO",1],["H002","UD","PRATO CARNICO",1],["G999","FI","PRATO IN TOSCANA",0],["H004","BZ","PRATO IN VENOSTA",0],["G998","CR","PRATO MUZIO",0],["H001","NO","PRATO SESIA",1],["H004","BZ","PRATO VENOSTA",0],["H006","AV","PRATOLA",0],["H007","AQ","PRATOLA",0],["H007","AQ","PRATOLA PELIGNA",1],["H006","AV","PRATOLA SERRA",1],["H008","AR","PRATOVECCHIO",0],["M329","AR","PRATOVECCHIO STIA",1],["H009","AR","PRATOVECCHIO-STIA",0],["H010","PN","PRAVISDOMINI",1],["G974","BI","PRAY",1],["H011","CN","PRAZZO",1],["H012","TN","PRE'",0],["H042","AO","PRE'-SAINT-DIDIER",1],["H013","RC","PRECACORE",0],["H014","UD","PRECENICCO",1],["H015","PG","PRECI",1],["H016","MI","PRECOTTO",0],["M344","TN","PREDAIA",1],["H017","FC","PREDAPPIO",1],["H017","FC","PREDAPPIO NUOVA",0],["H018","TN","PREDAZZO",1],["H019","BZ","PREDOI",1],["H020","BG","PREDORE",1],["H021","AL","PREDOSA",1],["H022","TV","PREGANZIOL",1],["H023","TN","PREGASINA",0],["H024","TN","PREGHENA",0],["H025","NO","PREGLIA",0],["H026","MI","PREGNANA",0],["H026","MI","PREGNANA MILANESE",1],["B117","PV","PREGOLA",0],["H027","IM","PRELA'",1],["H028","LC","PREMANA",1],["H029","UD","PREMARIACCO",1],["H030","VB","PREMENO",1],["H031","MI","PREMENUGO",0],["H032","MI","PREMEZZO",0],["H033","VB","PREMIA",1],["H034","FC","PREMILCUORE",1],["H035","TN","PREMIONE",0],["H036","BG","PREMOLO",1],["H037","NO","PREMOSELLO",0],["H037","VB","PREMOSELLO-CHIOVENDA",1],["H038","UD","PREONE",1],["H039","TN","PREORE",0],["H040","UD","PREPOTTO",1],["H041","NO","PREQUARTERA",0],["H043","BS","PRESEGLIE",1],["H044","BS","PRESEGNO",0],["H045","CE","PRESENZANO",1],["H046","BG","PRESEZZO",1],["H047","LE","PRESICCE",0],["M428","LE","PRESICCE-ACQUARICA",1],["H048","VR","PRESSANA",1],["H049","TN","PRESSON",0],["H050","BS","PRESTINE",0],["H051","NO","PRESTINONE",0],["H052","CH","PRETORO",1],["H053","AQ","PRETURO",0],["H054","GO","PREVACINA",0],["H055","BS","PREVALLE",1],["H056","AQ","PREZZA",1],["H057","TN","PREZZO",0],["H058","TO","PRIACCO",0],["H059","CN","PRIERO",1],["H060","CN","PRIERO-MONTEZEMOLO",0],["H061","MO","PRIGNANO",0],["H062","SA","PRIGNANO",0],["H062","SA","PRIGNANO CILENTO",1],["H061","MO","PRIGNANO SULLA SECCHIA",1],["H063","LC","PRIMALUNA",1],["H064","FM","PRIMANO",0],["H065","AL","PRIMEGLIO SCHIERANO",0],["H066","TN","PRIMIERO",0],["M359","TN","PRIMIERO SAN MARTINO DI CASTROZZA",1],["H067","TN","PRIO'",0],["H068","CN","PRIOCCA",1],["H069","CN","PRIOLA",1],["M279","SR","PRIOLO GARGALLO",1],["G698","LT","PRIVERNO",1],["H070","PA","PRIZZI",1],["H071","VT","PROCENO",1],["H072","NA","PROCIDA",1],["H073","GE","PROPATA",1],["H074","CO","PROSERPIO",1],["H075","MI","PROSPIANO",0],["H076","LT","PROSSEDI",1],["H077","BS","PROVAGLIO",0],["H078","BS","PROVAGLIO D'ISEO",1],["H079","BS","PROVAGLIO SOPRA",0],["H080","BS","PROVAGLIO SOTTO",0],["H077","BS","PROVAGLIO VAL SABBIA",1],["H081","BZ","PROVES",1],["H082","BS","PROVEZZE",0],["H083","CB","PROVVIDENTI",1],["H084","VR","PRUN",0],["H085","CN","PRUNETTO",1],["H086","BS","PUEGNAGO",0],["H086","BS","PUEGNAGO DEL GARDA",1],["H086","BS","PUEGNAGO SUL GARDA",0],["Z518","EE","PUERTO RICO",0],["H087","BN","PUGLIANELLO",1],["C435","CR","PUGNOLO",0],["H088","CA","PULA",1],["H089","UD","PULFERO",1],["H090","TA","PULSANO",1],["H091","BG","PUMENENGO",1],["H092","BL","PUOS D'ALPAGO",0],["H093","CO","PURIA",0],["H094","CO","PUSIANO",1],["H095","SS","PUTIFIGARI",1],["H096","BA","PUTIGNANO",1],["Z237","EE","QATAR",0],["H097","AV","QUADRELLE",1],["H098","CH","QUADRI",1],["H099","AV","QUAGLIETTA",0],["H100","TO","QUAGLIUZZO",1],["H101","NA","QUALIANO",1],["H102","AT","QUARANTI",1],["D213","BZ","QUARAZZE",0],["H103","BI","QUAREGNA",0],["M414","BI","QUAREGNA CERRETO",1],["H104","AL","QUARGNENTO",1],["H105","NO","QUARNA",0],["H106","VB","QUARNA SOPRA",1],["H107","VB","QUARNA SOTTO",1],["H108","VC","QUARONA",1],["H109","PT","QUARRATA",1],["H110","AO","QUART",1],["H111","AL","QUARTI",0],["H112","MI","QUARTIANO",0],["H113","AL","QUARTO",0],["H114","NA","QUARTO",1],["H115","GE","QUARTO AL MARE",0],["H113","AL","QUARTO ASTESE",0],["H116","MI","QUARTO CAGNINO",0],["H117","VE","QUARTO D'ALTINO",1],["H115","GE","QUARTO DEI MILLE",0],["H110","AO","QUARTO PRAETORIA",0],["H118","CA","QUARTU",0],["H118","CA","QUARTU SANT'ELENA",1],["H119","CA","QUARTUCCIU",1],["H120","TO","QUASSOLO",1],["H121","AL","QUATTORDIO",1],["H122","RE","QUATTRO CASTELLA",1],["H123","MN","QUATTROVILLE",0],["H124","BL","QUERO",0],["M332","BL","QUERO VAS",1],["H125","TN","QUETTA",0],["H126","SV","QUILIANO",1],["H127","TO","QUINCINETTO",1],["H128","AV","QUINDICI",1],["H129","MN","QUINGENTOLE",1],["H130","CR","QUINTANO",1],["H131","TV","QUINTO",0],["H132","VC","QUINTO",0],["H133","VR","QUINTO",0],["H134","VI","QUINTO",0],["H135","GE","QUINTO AL MARE",0],["H131","TV","QUINTO DI TREVISO",1],["H133","VR","QUINTO DI VALPANTENA",0],["H137","MI","QUINTO ROMANO",0],["H132","VC","QUINTO VERCELLESE",1],["H134","VI","QUINTO VICENTINO",1],["H136","AP","QUINTODECIMO",0],["H138","MI","QUINTOSOLE",0],["H139","BS","QUINZANELLO",0],["H140","BS","QUINZANO",0],["H141","MI","QUINZANO",0],["H142","VR","QUINZANO",0],["H140","BS","QUINZANO D'OGLIO",1],["H141","MI","QUINZANO SAN PIETRO",0],["H142","VR","QUINZANO VERONESE",0],["H143","MN","QUISTELLO",1],["H144","CR","QUISTRO",0],["H145","BI","QUITTENGO",0],["H146","TN","RABBI",1],["H147","LE","RACALE",1],["H148","AG","RACALMUTO",1],["H149","UD","RACCOLANA",0],["H150","CN","RACCONIGI",1],["H151","ME","RACCUJA",1],["H152","BZ","RACIGNES",0],["H152","BZ","RACINES",1],["H153","SI","RADDA",0],["H153","SI","RADDA IN CHIANTI",1],["H154","CT","RADDUSA",1],["H155","RC","RADICENA",0],["H156","SI","RADICOFANI",1],["H157","SI","RADICONDOLI",1],["H158","BS","RAFFA",0],["H159","AG","RAFFADALI",1],["M287","CT","RAGALNA",1],["H160","AR","RAGGIOLO",0],["H161","UD","RAGOGNA",1],["H162","TN","RAGOLI",0],["H163","RG","RAGUSA",1],["H164","RG","RAGUSA IBLA",0],["H164","RG","RAGUSA INFERIORE",0],["H165","CE","RAIANO",0],["H166","AQ","RAIANO",1],["H167","BZ","RAISSA",0],["H168","CT","RAMACCA",1],["G654","RE","RAMISETO",0],["H169","RO","RAMO DI PALO",0],["H170","CO","RAMPONIO",0],["H171","CO","RAMPONIO VERNA",0],["H172","CO","RANCIO",0],["H173","CO","RANCIO",0],["H172","CO","RANCIO DI LECCO",0],["H173","VA","RANCIO VALCUVIA",1],["H174","VA","RANCO",1],["H175","CT","RANDAZZO",1],["M242","TN","RANGO",0],["H176","BG","RANICA",1],["H177","BG","RANZANICO",1],["H179","SV","RANZI PIETRA",0],["H178","GO","RANZIANO",0],["H180","IM","RANZO",1],["H181","TN","RANZO",0],["H182","AP","RAPAGNANO",0],["H182","FM","RAPAGNANO",1],["H183","GE","RAPALLO",1],["H184","CH","RAPINO",1],["H185","SI","RAPOLANO",0],["H185","SI","RAPOLANO TERME",1],["H186","PZ","RAPOLLA",1],["H187","PZ","RAPONE",1],["H188","VC","RASSA",1],["H189","BZ","RASUN ANTERSELVA",0],["H190","BZ","RASUN DI SOPRA",0],["H191","BZ","RASUN DI SOTTO",0],["M307","BZ","RASUN VALDAORA",0],["H189","BZ","RASUN-ANTERSELVA",1],["H192","SO","RASURA",1],["H193","FM","RATECEVO IN MONTE",0],["H194","AG","RAVANUSA",1],["H195","MO","RAVARINO",1],["H196","UD","RAVASCLETTO",1],["H197","CO","RAVELLINO",0],["H198","SA","RAVELLO",1],["H199","RA","RAVENNA",1],["H200","UD","RAVEO",1],["H201","TN","RAVINA",0],["H202","CE","RAVISCANINA",1],["H203","VB","RE",1],["H204","PV","REA",1],["H205","AG","REALMONTE",1],["H206","UD","REANA",0],["H206","UD","REANA DEL ROIALE",0],["H206","UD","REANA DEL ROJALE",1],["H207","TO","REANO",1],["H208","CO","REBBIO",0],["H209","SS","REBECCU",0],["H210","CE","RECALE",1],["H211","MC","RECANATI",1],["H212","GE","RECCO",1],["H213","NO","RECETTO",1],["H214","VI","RECOARO",0],["H214","VI","RECOARO TERME",1],["H215","CR","RECORFANO",0],["H216","PV","REDAVALLE",1],["H217","BG","REDONA",0],["H218","MN","REDONDESCO",1],["H219","AT","REFRANCORE",1],["H220","TV","REFRONTOLO",1],["H221","EN","REGALBUTO",1],["H222","FI","REGGELLO",1],["H223","RE","REGGIO",0],["H224","RC","REGGIO DI CALABRIA",1],["H223","RE","REGGIO NELL'EMILIA",1],["H225","RE","REGGIOLO",1],["H226","MI","REGINA FITTAREZZA",0],["Z114","EE","REGNO UNITO",0],["H227","BN","REINO",1],["H228","ME","REITANO",1],["H229","UD","REMANZACCO",1],["H230","BS","REMEDELLO",1],["H231","BS","REMEDELLO SOPRA",0],["H232","BS","REMEDELLO SOTTO",0],["H233","MB","RENATE",1],["H233","MI","RENATE",0],["H234","MI","RENATE VEDUGGIO",0],["H235","CS","RENDE",1],["H236","BZ","RENON",1],["H237","TS","REPNO",0],["Z156","EE","REPUBBLICA CECA",0],["Z213","EE","REPUBBLICA DI COREA",0],["Z127","EE","REPUBBLICA DI POLONIA",0],["Z505","EE","REPUBBLICA DOMINICANA",0],["H238","TV","RESANA",1],["H239","MI","RESCALDA",0],["H240","MI","RESCALDINA",1],["H241","BZ","RESIA",0],["H242","UD","RESIA",1],["H241","BZ","RESIA ALL'ADIGE",0],["H243","NA","RESINA",0],["H244","UD","RESIUTTA",1],["H245","CL","RESUTTANO",1],["H246","PV","RETORBIDO",1],["H247","CN","REVELLO",1],["H248","MN","REVERE",0],["H250","AL","REVIGLIASCO",0],["H251","TO","REVIGLIASCO",0],["H250","AT","REVIGLIASCO D'ASTI",1],["H251","TO","REVIGLIASCO TORINESE",0],["H252","TV","REVINE",0],["H253","TV","REVINE LAGO",1],["H254","TN","REVO'",0],["H255","CO","REZZAGO",1],["H256","BS","REZZATO",1],["H257","IM","REZZO",1],["H259","CO","REZZO CAVARGNA",0],["H258","GE","REZZOAGLIO",1],["H260","CO","REZZONICO",0],["H261","AO","RHEMES",0],["H262","AO","RHEMES-NOTRE-DAME",1],["H263","AO","RHEMES-SAINT-GEORGES",1],["H264","MI","RHO",1],["Z337","EE","RHODESIA",0],["H262","AO","RH�MES-NOTRE-DAME",0],["H263","AO","RH�MES-SAINT-GEORGES",0],["H265","RC","RIACE",1],["H266","SV","RIALTO",1],["H267","RM","RIANO",1],["H268","CE","RIARDO",1],["H269","AG","RIBERA",1],["H270","TO","RIBORDONE",1],["H271","VV","RICADI",1],["H272","AL","RICALDONE",1],["H273","CB","RICCIA",1],["H274","RN","RICCIONE",1],["H275","GE","RICCO'",0],["H275","SP","RICCO' DEL GOLFO DI SPEZIA",1],["H276","CR","RICENGO",1],["H277","SA","RICIGLIANO",1],["H278","TO","RICLARETTO",0],["H279","BZ","RIDANNA",0],["H280","TV","RIESE",0],["H280","TV","RIESE PIO X",1],["H281","CL","RIESI",1],["H282","RI","RIETI",1],["H283","GO","RIFEMBERGO",0],["H284","BZ","RIFIANO",1],["H285","CN","RIFREDDO",1],["H286","FI","RIGNANO",0],["H287","FG","RIGNANO",0],["H288","RM","RIGNANO",0],["H288","RM","RIGNANO FLAMINIO",1],["H287","FG","RIGNANO GARGANICO",1],["H286","FI","RIGNANO SULL'ARNO",1],["H289","UD","RIGOLATO",1],["H290","BG","RIGOSA",0],["H291","VC","RIMA SAN GIUSEPPE",0],["H292","VC","RIMASCO",0],["H293","VC","RIMELLA",1],["H294","RN","RIMINI",1],["H295","BZ","RINA",0],["H296","AL","RINCO",0],["H295","BZ","RINNA",0],["H297","LI","RIO",0],["H298","RE","RIO",0],["M391","LI","RIO",1],["H299","BZ","RIO DI PUSTERIA",1],["H305","LI","RIO MARINA",0],["H306","BZ","RIO MOLINO",0],["H297","LI","RIO NELL'ELBA",0],["H298","RE","RIO SALICETO",1],["H300","RM","RIOFREDDO",1],["H301","CA","RIOLA",0],["H301","OR","RIOLA SARDO",1],["H302","RA","RIOLO",0],["H302","RA","RIOLO DEI BAGNI",0],["H302","RA","RIOLO TERME",1],["H303","MO","RIOLUNATO",1],["H304","SP","RIOMAGGIORE",1],["H307","PZ","RIONERO",0],["H308","CB","RIONERO",0],["H307","PZ","RIONERO IN VOLTURE",0],["H307","PZ","RIONERO IN VULTURE",1],["H308","IS","RIONERO SANNITICO",1],["H309","MI","RIOZZO",0],["H320","CH","RIPA TEATINA",1],["H310","AP","RIPABERARDA",0],["H311","CB","RIPABOTTONI",1],["H312","PZ","RIPACANDIDA",1],["E799","CB","RIPALDA",0],["H313","CB","RIPALIMOSANI",1],["H314","CR","RIPALTA ARPINA",1],["H315","CR","RIPALTA CREMASCA",1],["H316","CR","RIPALTA GUERINA",1],["H317","CR","RIPALTA NUOVA",0],["E799","CB","RIPALTA SUL TRIGNO",0],["H318","CR","RIPALTA VECCHIA",0],["H319","PI","RIPARBELLA",1],["H321","AP","RIPATRANSONE",1],["H322","AN","RIPE",0],["H323","MC","RIPE SAN GINESIO",1],["H324","FR","RIPI",1],["H325","CT","RIPOSTO",1],["H167","BZ","RISCONE",0],["H326","CN","RITTANA",1],["H327","BL","RIVA",0],["H328","IM","RIVA",0],["H329","NO","RIVA",0],["H330","TN","RIVA",0],["H330","TN","RIVA DEL GARDA",1],["M410","FE","RIVA DEL PO",1],["H331","BG","RIVA DI SOLTO",1],["H332","BZ","RIVA DI TURES",0],["H332","BZ","RIVA IN VALLE",0],["H328","IM","RIVA LIGURE",1],["H337","TO","RIVA PRESSO CHIERI",1],["H345","IM","RIVA SANTO STEFANO",0],["H329","VC","RIVA VALDOBBIA",0],["H333","TO","RIVALBA",1],["D958","PC","RIVALTA",0],["H334","AL","RIVALTA",0],["H335","TO","RIVALTA",0],["H334","AL","RIVALTA BORMIDA",1],["H335","TO","RIVALTA DI TORINO",1],["D958","PC","RIVALTA TREBBIA",0],["H327","BL","RIVAMONTE",0],["H327","BL","RIVAMONTE AGORDINO",1],["H336","PV","RIVANAZZANO",0],["H336","PV","RIVANAZZANO TERME",1],["H338","TO","RIVARA",1],["H339","GE","RIVAROLO",0],["H340","TO","RIVAROLO",0],["H340","TO","RIVAROLO CANAVESE",1],["H341","CR","RIVAROLO CREMONESE",0],["H341","CR","RIVAROLO DEL RE ED UNITI",1],["H342","MN","RIVAROLO FUORI",0],["H339","GE","RIVAROLO LIGURE",0],["H342","MN","RIVAROLO MANTOVANO",1],["H343","AL","RIVARONE",1],["H344","TO","RIVAROSSA",1],["H346","VC","RIVE",1],["H347","UD","RIVE D'ARCANO",1],["H348","PZ","RIVELLO",1],["H349","TO","RIVERA",0],["H350","PC","RIVERGARO",1],["H351","BG","RIVIERA D'ADDA",0],["H352","UD","RIVIGNANO",0],["M317","UD","RIVIGNANO TEOR",1],["H353","AQ","RIVISONDOLI",1],["H354","RI","RIVODUTRI",1],["H355","TO","RIVOLI",1],["H356","VR","RIVOLI",0],["H356","VR","RIVOLI VERONESE",1],["H357","CR","RIVOLTA",0],["H357","CR","RIVOLTA D'ADDA",1],["H358","BS","RIVOLTELLA SUL GARDA",0],["G356","UD","RIVOLTO",0],["H359","RC","RIZZICONI",1],["H360","FE","RO",0],["H361","VI","ROANA",1],["H362","CN","ROASCHIA",1],["H363","CN","ROASCIO",1],["H364","VC","ROASENDA",0],["H365","VC","ROASIO",1],["H366","AT","ROATTO",1],["H367","TO","ROBASSOMERO",1],["H368","MI","ROBBIANO",0],["G223","LC","ROBBIATE",1],["G223","CO","ROBBIATE PADERNO",0],["H369","PV","ROBBIO",1],["H370","MI","ROBECCHETTO",0],["H371","MI","ROBECCHETTO CON INDUNO",1],["H372","CR","ROBECCO",0],["H373","MI","ROBECCO",0],["H374","MI","ROBECCO",0],["H375","PV","ROBECCO",0],["H372","CR","ROBECCO D'OGLIO",1],["H374","MI","ROBECCO LODIGIANO",0],["H375","PV","ROBECCO PAVESE",1],["H373","MI","ROBECCO SUL NAVIGLIO",1],["H376","AT","ROBELLA",1],["H377","CN","ROBILANTE",1],["H378","CN","ROBURENT",1],["H378","CN","ROBURENTO",0],["H379","BL","ROCCA",0],["H380","ME","ROCCA",0],["H381","NO","ROCCA",0],["H386","TO","ROCCA CANAVESE",1],["H387","RM","ROCCA CANTERANO",1],["H391","CN","ROCCA CIGLIE'",1],["H379","BL","ROCCA D'AGORDO",0],["H392","AT","ROCCA D'ARAZZO",1],["H393","FR","ROCCA D'ARCE",1],["H398","CE","ROCCA D'EVANDRO",1],["H395","CN","ROCCA DE' BALDI",1],["H396","PV","ROCCA DE' GIORGI",1],["H397","BG","ROCCA DEL COLLE",0],["H399","AQ","ROCCA DI BOTTE",1],["H400","AQ","ROCCA DI CAMBIO",1],["H401","RM","ROCCA DI CAVE",1],["H386","TO","ROCCA DI CORIO",0],["H402","AQ","ROCCA DI MEZZO",1],["H403","KR","ROCCA DI NETO",1],["H404","RM","ROCCA DI PAPA",1],["H403","CZ","ROCCA FERDINANDEA",0],["H414","AL","ROCCA GRIMALDA",1],["H416","CS","ROCCA IMPERIALE",1],["H421","LT","ROCCA MASSIMA",1],["H429","AQ","ROCCA PIA",1],["H379","BL","ROCCA PIETORE",1],["H381","NO","ROCCA PIETRA",0],["H432","RM","ROCCA PRIORA",1],["H437","FC","ROCCA SAN CASCIANO",1],["H438","AV","ROCCA SAN FELICE",1],["H439","CH","ROCCA SAN GIOVANNI",1],["H440","TE","ROCCA SANTA MARIA",1],["H441","RM","ROCCA SANTO STEFANO",1],["H446","RI","ROCCA SINIBALDA",1],["H450","PV","ROCCA SUSELLA",1],["H382","AV","ROCCABASCERANA",1],["H383","KR","ROCCABERNARDA",1],["H384","PR","ROCCABIANCA",1],["H385","CN","ROCCABRUNA",1],["H388","PE","ROCCACARAMANICO",0],["H389","AQ","ROCCACASALE",1],["H390","AP","ROCCACASAREGNANA",0],["H393","FR","ROCCADARCE",0],["H394","SA","ROCCADASPIDE",1],["H405","ME","ROCCAFIORITA",1],["H390","AP","ROCCAFLUVIONE",1],["H406","AL","ROCCAFORTE",0],["H407","CN","ROCCAFORTE",0],["H408","RC","ROCCAFORTE",0],["H408","RC","ROCCAFORTE DEL GRECO",1],["H406","AL","ROCCAFORTE LIGURE",1],["H407","CN","ROCCAFORTE MONDOVI'",1],["H409","TA","ROCCAFORZATA",1],["H410","BS","ROCCAFRANCA",1],["H411","RM","ROCCAGIOVINE",1],["H412","SA","ROCCAGLORIOSA",1],["H413","LT","ROCCAGORGA",1],["H415","FR","ROCCAGUGLIELMA",0],["D831","UD","ROCCALBA",0],["H417","GR","ROCCALBEGNA",1],["H418","ME","ROCCALUMERA",1],["H419","VT","ROCCALVECCE",0],["H420","IS","ROCCAMANDOLFI",1],["H422","PA","ROCCAMENA",1],["H423","CE","ROCCAMONFINA",1],["H424","CH","ROCCAMONTEPIANO",1],["H425","PE","ROCCAMORICE",1],["H426","PZ","ROCCANOVA",1],["H427","RI","ROCCANTICA",1],["H428","PA","ROCCAPALUMBA",1],["H430","TO","ROCCAPIATTA",0],["H431","SA","ROCCAPIEMONTE",1],["H433","NA","ROCCARAINOLA",1],["H434","AQ","ROCCARASO",1],["H435","AP","ROCCAREONILE",0],["H436","CE","ROCCAROMANA",1],["H442","CH","ROCCASCALEGNA",1],["H443","FR","ROCCASECCA",1],["H444","RM","ROCCASECCA",0],["H444","LT","ROCCASECCA DEI VOLSCI",1],["H445","IS","ROCCASICURA",1],["H447","CN","ROCCASPARVERA",1],["H448","CH","ROCCASPINALVETI",1],["H449","GR","ROCCASTRADA",1],["H380","ME","ROCCAVALDINA",1],["H429","AQ","ROCCAVALLEOSCURA",0],["H451","AT","ROCCAVERANO",1],["H452","SV","ROCCAVIGNALE",1],["H453","CN","ROCCAVIONE",1],["H454","CB","ROCCAVIVARA",1],["H455","ME","ROCCELLA",0],["H456","RC","ROCCELLA",0],["H456","RC","ROCCELLA IONICA",1],["H455","ME","ROCCELLA VALDEMONE",1],["H457","TO","ROCCHEMOLLES",0],["H458","CB","ROCCHETTA",0],["H459","CE","ROCCHETTA",0],["H460","IM","ROCCHETTA",0],["H461","MS","ROCCHETTA",0],["H458","IS","ROCCHETTA A VOLTURNO",1],["H462","CN","ROCCHETTA BELBO",1],["H463","GE","ROCCHETTA CAIRO",0],["H464","SV","ROCCHETTA CENGIO",0],["H461","SP","ROCCHETTA DI VARA",1],["H459","CE","ROCCHETTA E CROCE",1],["H465","AL","ROCCHETTA LIGURE",1],["H460","IM","ROCCHETTA NERVINA",1],["H466","AT","ROCCHETTA PALAFEA",1],["H467","FG","ROCCHETTA SANT'ANTONIO",1],["H468","AT","ROCCHETTA TANARO",1],["H469","PG","ROCCHETTE IN SABINA",0],["H470","MI","RODANO",1],["H471","UD","RODDA",0],["H472","CN","RODDI",1],["H473","CN","RODDINO",1],["H474","CN","RODELLO",1],["H475","BZ","RODENGO",1],["H476","BS","RODENGO",0],["H477","BS","RODENGO SAIANO",1],["H477","BS","RODENGO-SAIANO",0],["H478","CO","RODERO",1],["H480","FG","RODI GARGANICO",1],["H479","ME","RODI'",0],["H479","ME","RODI' MILICI",1],["H481","MN","RODIGO",1],["H482","TS","RODITTI",0],["H483","TO","RODORETTO",0],["H484","BS","ROE' VOLCIANO",1],["H485","SA","ROFRANO",1],["H486","LC","ROGENO",1],["H487","CO","ROGGIANO",0],["H488","CS","ROGGIANO GRAVINA",1],["H487","VA","ROGGIANO VALTRAVAGLIA",0],["H489","RC","ROGHUDI",1],["H488","CS","ROGIANO",0],["H490","CS","ROGLIANO",1],["H491","PV","ROGNANO",1],["H492","BG","ROGNO",1],["H493","SO","ROGOLO",1],["H494","RM","ROIATE",1],["H495","CH","ROIO",0],["H496","AQ","ROIO",0],["H495","CH","ROIO DEL SANGRO",1],["H496","AQ","ROIO PIANO",0],["H497","AO","ROISAN",1],["H498","TO","ROLETTO",1],["H499","TO","ROLLIERES",0],["H500","RE","ROLO",1],["H501","RM","ROMA",1],["H502","NO","ROMAGNANO",0],["H503","SA","ROMAGNANO",0],["H504","TN","ROMAGNANO",0],["H503","SA","ROMAGNANO AL MONTE",1],["H502","NO","ROMAGNANO SESIA",1],["H505","PV","ROMAGNESE",1],["H506","TN","ROMALLO",0],["H507","SS","ROMANA",1],["H508","CR","ROMANENGO",1],["Z129","EE","ROMANIA",0],["H509","BG","ROMANO",0],["H510","CO","ROMANO",0],["H511","TO","ROMANO",0],["H512","VI","ROMANO",0],["H510","CO","ROMANO BRIANZA",0],["H511","TO","ROMANO CANAVESE",1],["H512","VI","ROMANO D'EZZELINO",1],["H509","BG","ROMANO DI LOMBARDIA",1],["H513","GO","ROMANS",0],["H514","GO","ROMANS D'ISONZO",1],["H515","TN","ROMARZOLLO",0],["H516","VV","ROMBIOLO",1],["H517","TN","ROMENO",1],["H518","NO","ROMENTINO",1],["H519","ME","ROMETTA",1],["H520","CR","ROMPREZZAGNO",0],["H521","CO","RONAGO",1],["H524","CR","RONCA DE' GOLFERANI",0],["H522","VR","RONCA'",1],["H523","TV","RONCADE",1],["H525","BS","RONCADELLE",1],["H526","CR","RONCADELLO",0],["H526","CR","RONCADELLO D'ADDA",0],["H527","PV","RONCARO",1],["H528","TN","RONCEGNO",0],["H528","TN","RONCEGNO TERME",1],["H529","MB","RONCELLO",1],["H529","MI","RONCELLO",0],["H530","MI","RONCHETTO",0],["H531","GO","RONCHI",0],["H532","TN","RONCHI",0],["H531","GO","RONCHI DEI LEGIONARI",1],["M243","TN","RONCHI DI ALA",0],["H531","GO","RONCHI DI MONFALCONE",0],["H532","TN","RONCHI VALSUGANA",1],["H533","UD","RONCHIS",1],["H534","VT","RONCIGLIONE",1],["H535","BG","RONCO",0],["H536","GE","RONCO",0],["H537","MI","RONCO",0],["H538","NO","RONCO",0],["H539","TO","RONCO",0],["H540","VR","RONCO",0],["H540","VR","RONCO ALL'ADIGE",1],["H538","BI","RONCO BIELLESE",1],["H537","MB","RONCO BRIANTINO",1],["H537","MI","RONCO BRIANTINO",0],["H539","TO","RONCO CANAVESE",1],["H536","GE","RONCO SCRIVIA",1],["H535","BG","RONCOBELLO",1],["H541","MN","RONCOFERRARO",1],["H542","FC","RONCOFREDDO",1],["H543","TN","RONCOGNO",0],["H544","BG","RONCOLA",1],["H545","TN","RONCONE",0],["H546","GE","RONDANINA",1],["H547","TO","RONDISSONE",1],["H548","CO","RONGIO",0],["H549","VC","RONSECCO",1],["H550","GO","RONZINA",0],["H551","TN","RONZO",0],["M303","TN","RONZO-CHIENIS",1],["H552","TN","RONZONE",1],["H553","BI","ROPPOLO",1],["H554","TO","RORA'",1],["H555","TO","RORETO",0],["H555","TO","RORETO CHISONE",0],["H556","VI","ROSA'",1],["H557","RC","ROSALI",0],["H558","RC","ROSARNO",1],["H559","PV","ROSASCO",1],["H560","MI","ROSATE",1],["H561","BI","ROSAZZA",1],["H562","PE","ROSCIANO",1],["H563","BG","ROSCIATE",0],["H564","SA","ROSCIGNO",1],["H565","CS","ROSE",1],["H566","CH","ROSELLO",1],["H567","MI","ROSERIO",0],["H568","FG","ROSETO",0],["H572","CS","ROSETO CAPO SPULICO",1],["F585","TE","ROSETO DEGLI ABRUZZI",1],["H568","FG","ROSETO VALFORTORE",1],["H569","AL","ROSIGNANO",0],["H570","PI","ROSIGNANO",0],["H570","LI","ROSIGNANO MARITTIMO",1],["H569","AL","ROSIGNANO MONFERRATO",1],["H571","AL","ROSINGO",0],["H572","CS","ROSITO",0],["H572","CS","ROSITO CAPO SPULICO",0],["H573","RO","ROSOLINA",1],["H574","SR","ROSOLINI",1],["H575","AN","ROSORA",1],["H576","AN","ROSORA MERGO",0],["H577","VC","ROSSA",1],["H578","CN","ROSSANA",1],["H579","CS","ROSSANO",0],["H580","VI","ROSSANO",0],["H580","VI","ROSSANO VENETO",1],["H581","GE","ROSSIGLIONE",1],["H582","BG","ROSSINO",0],["D255","GE","ROSSO",0],["H583","TO","ROSTA",1],["H584","BG","ROTA",0],["H585","CS","ROTA",0],["H584","BG","ROTA D'IMAGNA",1],["H586","BG","ROTA DENTRO",0],["H587","BG","ROTA FUORI",0],["H585","CS","ROTA GRECA",1],["H588","AP","ROTELLA",1],["H589","CB","ROTELLO",1],["H590","PZ","ROTONDA",1],["H591","MT","ROTONDELLA",1],["H592","AV","ROTONDI",1],["H593","PC","ROTTOFRENO",1],["H594","VI","ROTZO",1],["H555","TO","ROURE",1],["H595","MI","ROVAGNASCO",0],["H596","LC","ROVAGNATE",0],["H364","VC","ROVASENDA",1],["H597","VA","ROVATE",0],["H598","BS","ROVATO",1],["H599","GE","ROVEGNO",1],["H600","NO","ROVEGRO",0],["H601","CO","ROVELLASCA",1],["H602","CO","ROVELLO",0],["H602","CO","ROVELLO PORRO",1],["H603","CO","ROVENNA",0],["H605","TN","ROVER CARBONARE",0],["H604","MN","ROVERBELLA",1],["H606","VR","ROVERCHIARA",1],["H607","TN","ROVERE' DELLA LUNA",1],["H608","VR","ROVERE' DI VELO",0],["H608","VR","ROVERE' VERONESE",1],["H609","UD","ROVEREDO",0],["H610","VR","ROVEREDO",0],["H610","VR","ROVEREDO DI GUA'",1],["H609","PN","ROVEREDO IN PIANO",1],["H611","CR","ROVERETO",0],["H612","TN","ROVERETO",1],["H613","FC","ROVERSANO",0],["H614","PV","ROVESCALA",1],["H615","BG","ROVETTA",1],["H616","BG","ROVETTA CON FINO",0],["H617","FI","ROVEZZANO",0],["H601","CO","ROVI PORRO",0],["H618","RM","ROVIANO",1],["H619","PL","ROVIGNO D'ISTRIA",0],["H620","RO","ROVIGO",1],["H621","CS","ROVITO",1],["H622","PD","ROVOLON",1],["H623","MI","ROZZANO",1],["H624","PL","ROZZO",0],["Z338","EE","RUANDA",0],["H625","PD","RUBANO",1],["H626","CR","RUBBIANO",0],["H627","TO","RUBIANA",1],["H628","RE","RUBIERA",1],["H629","UD","RUDA",1],["H630","BS","RUDIANO",1],["H631","TO","RUEGLIO",1],["H632","LE","RUFFANO",1],["H633","CN","RUFFIA",1],["H634","TN","RUFFRE'",0],["H634","TN","RUFFRE'-MENDOLA",1],["H635","FI","RUFINA",1],["H636","MI","RUGINELLO",0],["F271","OR","RUINAS",1],["H637","PV","RUINO",0],["H638","NO","RUMIANCA",0],["H639","TN","RUMO",1],["H640","VA","RUNO",0],["H641","PZ","RUOTI",1],["H237","TS","RUPINGRANDE",0],["H642","RA","RUSSI",1],["Z154","EE","RUSSIA=FEDERAZIONE RUSSA",0],["H643","BA","RUTIGLIANO",1],["H644","SA","RUTINO",1],["H165","CE","RUVIANO",1],["H645","BA","RUVO",0],["H646","PZ","RUVO",0],["H646","PZ","RUVO DEL MONTE",1],["H645","BA","RUVO DI PUGLIA",1],["Z238","EE","RYUKYU (ISOLE)",0],["H647","LT","SABAUDIA",1],["H648","VC","SABBIA",0],["H649","BG","SABBIO",0],["H650","BS","SABBIO",0],["H649","BG","SABBIO BERGAMASCO",0],["H650","BS","SABBIO CHIESE",1],["H651","CO","SABBIONCELLO",0],["H652","MN","SABBIONETA",1],["H653","GO","SABLE GRANDE",0],["H654","SA","SACCO",1],["M244","TN","SACCO",0],["H655","PD","SACCOLONGO",1],["H656","VA","SACCONAGO",0],["H657","PN","SACILE",1],["H658","RM","SACROFANO",1],["H659","NU","SADALI",0],["H659","SU","SADALI",1],["H660","GO","SAGA",0],["H661","NU","SAGAMA",0],["H661","OR","SAGAMA",1],["H662","NO","SAGLIANO",0],["H663","PV","SAGLIANO",0],["H663","PV","SAGLIANO DI CRENNA",0],["H662","BI","SAGLIANO MICCA",1],["H664","FM","SAGORIA",0],["H665","GO","SAGRADO",1],["H666","TN","SAGRON MIS",1],["H667","RO","SAGUEDO",0],["Z362","EE","SAHARA MERIDIONALE",0],["Z363","EE","SAHARA SETTENTRIONALE",0],["Z339","EE","SAHARA SPAGNOLO",0],["H668","BS","SAIANO",0],["Z533","EE","SAINT KITTS E NEVIS",0],["Z533","EE","SAINT KITTS E NEVIS=SAINT CHRISTOPHER E NEVIS",0],["Z527","EE","SAINT LUCIA",0],["Z403","EE","SAINT PIERRE ET MIQUELON (ISOLE)",0],["Z528","EE","SAINT VINCENT E GRENADINE",0],["H669","AO","SAINT-CHRISTOPHE",1],["H670","AO","SAINT-DENIS",1],["H671","AO","SAINT-MARCEL",1],["H672","AO","SAINT-NICOLAS",1],["H673","AO","SAINT-OYEN",1],["H674","AO","SAINT-PIERRE",1],["H675","AO","SAINT-RHE'MY-EN-BOSSES",0],["H675","AO","SAINT-RHEMY-EN-BOSSES",1],["H676","AO","SAINT-VINCENT",1],["H677","AL","SALA",0],["H678","BO","SALA",0],["H679","CO","SALA",0],["H680","CO","SALA",0],["H681","NO","SALA",0],["H682","PR","SALA",0],["H683","SA","SALA",0],["H680","CO","SALA AL BARRO",0],["H682","PR","SALA BAGANZA",1],["H681","BI","SALA BIELLESE",1],["H678","BO","SALA BOLOGNESE",1],["H679","CO","SALA COMACINA",1],["H683","SA","SALA CONSILINA",1],["H686","SA","SALA DI GIOI",0],["E458","AO","SALA DORA",0],["H677","AL","SALA MONFERRATO",1],["H684","TO","SALABERTANO",0],["H685","AL","SALABUE",0],["H687","MT","SALANDRA",1],["H688","TP","SALAPARUTA",1],["H689","RO","SALARA",1],["H690","VC","SALASCO",1],["H691","TO","SALASSA",1],["H684","TO","SALBERTRAND",1],["H692","GO","SALCANO",0],["F810","VI","SALCEDO",1],["H693","CB","SALCITO",1],["H694","AL","SALE",1],["H695","CN","SALE",0],["H696","TO","SALE CANISCHIO",0],["H697","AO","SALE CASTELNUOVO",0],["H695","CN","SALE DELLE LANGHE",1],["H699","BS","SALE MARASINO",1],["H704","CN","SALE SAN GIOVANNI",1],["H698","NO","SALECCHIO",0],["H700","TP","SALEMI",1],["H686","SA","SALENTO",1],["H701","MI","SALERANO",0],["H702","TO","SALERANO",0],["H702","TO","SALERANO CANAVESE",1],["H701","LO","SALERANO SUL LAMBRO",1],["H703","SA","SALERNO",1],["H705","PD","SALETTO",0],["H706","TV","SALGAREDA",1],["H707","NO","SALI",0],["H707","VC","SALI VERCELLESE",1],["H708","LE","SALICE",0],["H709","RC","SALICE",0],["H709","RC","SALICE CALABRO",0],["H708","LE","SALICE SALENTINO",1],["H710","CN","SALICETO",1],["H711","ME","SALINA",0],["H712","VR","SALINE",0],["E946","FG","SALINE DI BARLETTA",0],["H713","RI","SALISANO",1],["H714","VR","SALIZZOLE",1],["H715","PE","SALLE",1],["H716","CN","SALMORE",0],["H716","CN","SALMOUR",1],["H717","BS","SALO'",1],["Z724","EE","SALOMONE",0],["Z724","EE","SALOMONE (ISOLE)",0],["H718","GO","SALONA D'ISONZO",0],["H719","BZ","SALORNO",0],["H719","BZ","SALORNO SULLA STRADA DEL VINO",1],["H720","PR","SALSOMAGGIORE",0],["H720","PR","SALSOMAGGIORE TERME",1],["H721","PU","SALTARA",0],["E857","TN","SALTER MALGOLO",0],["H722","TO","SALTO",0],["H723","VA","SALTRIO",1],["H724","RN","SALUDECIO",1],["H725","VC","SALUGGIA",1],["H726","BI","SALUSSOLA",1],["H727","CN","SALUZZO",1],["B653","CO","SALVADERA",0],["H728","RO","SALVATERRA",0],["H729","LE","SALVE",1],["H730","PZ","SALVIA",0],["H731","CR","SALVIROLA",1],["H731","CR","SALVIROLA CREMASCA",0],["H732","SA","SALVITELLE",1],["H733","AV","SALZA",0],["H734","TO","SALZA",0],["H734","TO","SALZA DI PINEROLO",1],["H733","AV","SALZA IRPINA",1],["H735","VE","SALZANO",1],["H736","VA","SAMARATE",1],["H737","GO","SAMARIA",0],["H738","CA","SAMASSI",0],["H738","SU","SAMASSI",1],["H739","CA","SAMATZAI",0],["H739","SU","SAMATZAI",1],["H740","GO","SAMBASSO",0],["H741","RC","SAMBATELLO",0],["H742","CZ","SAMBIASE",0],["H743","AG","SAMBUCA",0],["H744","FI","SAMBUCA",0],["H743","AG","SAMBUCA DI SICILIA",1],["H743","AG","SAMBUCA LABAT",0],["H744","PT","SAMBUCA PISTOIESE",1],["H743","AG","SAMBUCA ZABUT",0],["H745","RM","SAMBUCI",1],["H746","CN","SAMBUCO",1],["H747","CN","SAMBUCO PIETRAPORZIO",0],["H748","NO","SAMBUGHETTO",0],["H749","BA","SAMMICHELE DI BARI",1],["H013","RC","SAMO",1],["H751","RC","SAMO DI CALABRIA",0],["Z726","EE","SAMOA",0],["Z725","EE","SAMOA AMERICANE (ISOLE)",0],["H750","TN","SAMOCLEVO",0],["H752","SO","SAMOLACO",1],["H753","TO","SAMONE",1],["H754","TN","SAMONE",1],["H755","CN","SAMPEIRE",0],["H755","CN","SAMPEYRE",1],["H756","OR","SAMUGHEO",1],["H758","AV","SAN BARBATO",0],["H759","BS","SAN BARTOLOMEO",0],["H760","CO","SAN BARTOLOMEO",0],["H761","CO","SAN BARTOLOMEO",0],["H762","NO","SAN BARTOLOMEO",0],["H761","CO","SAN BARTOLOMEO AL BOSCO",0],["H763","IM","SAN BARTOLOMEO AL MARE",1],["H763","IM","SAN BARTOLOMEO DEL CERVO",0],["A457","IM","SAN BARTOLOMEO ED ARZENO",0],["H764","BN","SAN BARTOLOMEO IN GALDO",1],["H760","CO","SAN BARTOLOMEO VAL CAVARGNA",1],["H762","NO","SAN BARTOLOMEO VALMARA",0],["H765","CS","SAN BASILE",1],["H766","CA","SAN BASILIO",0],["H766","SU","SAN BASILIO",1],["H767","CR","SAN BASSANO",1],["H768","RO","SAN BELLINO",1],["C257","PG","SAN BENEDETTO",0],["H769","AP","SAN BENEDETTO",0],["H770","CN","SAN BENEDETTO",0],["H771","MN","SAN BENEDETTO",0],["H770","CN","SAN BENEDETTO BELBO",1],["H772","AQ","SAN BENEDETTO DEI MARSI",1],["H769","AP","SAN BENEDETTO DEL TRONTO",1],["H773","AQ","SAN BENEDETTO IN PERILLIS",1],["H771","MN","SAN BENEDETTO PO",1],["H774","CS","SAN BENEDETTO ULLANO",1],["G566","BO","SAN BENEDETTO VAL DI SAMBRO",1],["H775","TO","SAN BENIGNO CANAVESE",1],["H776","CR","SAN BERNARDINO",0],["H777","VB","SAN BERNARDINO VERBANO",1],["H778","AG","SAN BIAGIO",0],["H779","CE","SAN BIAGIO",0],["H780","IM","SAN BIAGIO",0],["H780","IM","SAN BIAGIO DELLA CIMA",1],["H781","TV","SAN BIAGIO DI CALLALTA",1],["H778","AG","SAN BIAGIO PLATANI",1],["H779","FR","SAN BIAGIO SARACINISCO",1],["H782","CB","SAN BIASE",1],["H783","VR","SAN BONIFACIO",1],["H784","CH","SAN BUONO",1],["H785","VV","SAN CALOGERO",1],["H786","BZ","SAN CANDIDO",1],["H787","GO","SAN CANZIAN D'ISONZO",1],["H787","GO","SAN CANZIANO",0],["H788","NO","SAN CARLO",0],["H789","TO","SAN CARLO",0],["H789","TO","SAN CARLO CANAVESE",1],["H788","NO","SAN CARLO D'OSSOLA",0],["H789","TO","SAN CARLO DI CIRIE'",0],["H790","SI","SAN CASCIANO DEI BAGNI",1],["H791","FI","SAN CASCIANO IN VAL DI PESA",1],["M264","LE","SAN CASSIANO",1],["H792","CL","SAN CATALDO",1],["M295","RM","SAN CESAREO",1],["H793","LE","SAN CESARIO",0],["H794","MO","SAN CESARIO",0],["H793","LE","SAN CESARIO DI LECCE",1],["H794","MO","SAN CESARIO SUL PANARO",1],["H795","PZ","SAN CHIRICO NUOVO",1],["H796","PZ","SAN CHIRICO RAPARO",1],["H797","PA","SAN CIPIRELLO",1],["H798","CE","SAN CIPRIANO",0],["H799","PV","SAN CIPRIANO",0],["H800","SA","SAN CIPRIANO",0],["H798","CE","SAN CIPRIANO D'AVERSA",1],["H800","SA","SAN CIPRIANO PICENTINO",1],["H799","PV","SAN CIPRIANO PO",1],["H801","RN","SAN CLEMENTE",1],["H802","GE","SAN COLOMBANO",0],["H803","MI","SAN COLOMBANO",0],["H804","TO","SAN COLOMBANO",0],["H803","MI","SAN COLOMBANO AL LAMBRO",1],["H804","TO","SAN COLOMBANO BELMONTE",1],["H802","GE","SAN COLOMBANO CERTENOLI",1],["H805","CT","SAN CONO",1],["H806","CS","SAN COSMO",0],["H806","CS","SAN COSMO ALBANESE",1],["H807","CZ","SAN COSTANTINO",0],["H808","PZ","SAN COSTANTINO",0],["H808","PZ","SAN COSTANTINO ALBANESE",1],["H807","VV","SAN COSTANTINO CALABRO",1],["H809","PU","SAN COSTANZO",1],["H810","AL","SAN CRISTOFORO",1],["H811","AL","SAN DAMIANO",0],["H812","CN","SAN DAMIANO",0],["H813","MI","SAN DAMIANO",0],["H814","PV","SAN DAMIANO",0],["H814","PV","SAN DAMIANO AL COLLE",1],["H811","AT","SAN DAMIANO D'ASTI",1],["H813","MI","SAN DAMIANO DI MONZA",0],["H812","CN","SAN DAMIANO MACRA",1],["H815","CR","SAN DANIELE",0],["H816","UD","SAN DANIELE",0],["H817","GO","SAN DANIELE DEL CARSO",0],["H816","UD","SAN DANIELE DEL FRIULI",1],["H815","CR","SAN DANIELE PO",1],["H815","CR","SAN DANIELE RIPA PO",0],["H818","CS","SAN DEMETRIO",0],["H819","AQ","SAN DEMETRIO",0],["H818","CS","SAN DEMETRIO CORONE",1],["H819","AQ","SAN DEMETRIO NE' VESTINI",1],["H042","AO","SAN DESIDERIO TERME",0],["H820","TO","SAN DIDERO",1],["H823","VE","SAN DONA' DI PIAVE",1],["H822","BR","SAN DONACI",1],["H824","CE","SAN DONATO",0],["H825","CS","SAN DONATO",0],["H826","LE","SAN DONATO",0],["H827","MI","SAN DONATO",0],["H828","PR","SAN DONATO",0],["H828","PR","SAN DONATO D'ENZA",0],["H826","LE","SAN DONATO DI LECCE",1],["H825","CS","SAN DONATO DI NINEA",1],["H827","MI","SAN DONATO MILANESE",1],["H824","FR","SAN DONATO VAL DI COMINO",1],["D324","TS","SAN DORLIGO DELLA VALLE",1],["H830","CO","SAN FEDELE",0],["H830","CO","SAN FEDELE INTELVI",0],["H831","PZ","SAN FELE",1],["H832","BS","SAN FELICE",0],["H833","CB","SAN FELICE",0],["H834","CE","SAN FELICE",0],["H835","MO","SAN FELICE",0],["H836","RM","SAN FELICE",0],["H837","BZ","SAN FELICE",0],["H834","CE","SAN FELICE A CANCELLO",1],["H836","LT","SAN FELICE CIRCEO",1],["H838","BS","SAN FELICE DEL BENACO",1],["H833","CB","SAN FELICE DEL LITTORIO",0],["H833","CB","SAN FELICE DEL MOLISE",1],["H832","BS","SAN FELICE DI SCOVOLO",0],["H833","CB","SAN FELICE SLAVO",0],["H835","MO","SAN FELICE SUL PANARO",1],["F901","ME","SAN FERDINANDO",0],["H839","FG","SAN FERDINANDO",0],["M277","RC","SAN FERDINANDO",1],["H839","BT","SAN FERDINANDO DI PUGLIA",1],["H839","FG","SAN FERDINANDO DI PUGLIA",0],["H840","CO","SAN FERMO DELLA BATTAGLIA",1],["H841","CS","SAN FILI",1],["H842","ME","SAN FILIPPO DEL MELA",1],["H843","TV","SAN FIOR",1],["H844","LO","SAN FIORANO",1],["H845","UD","SAN FLORIANO",0],["H845","GO","SAN FLORIANO DEL COLLIO",1],["H846","CZ","SAN FLORO",1],["H847","TO","SAN FRANCESCO AL CAMPO",1],["H848","SS","SAN FRANCESCO D'AGLIENTU",0],["H849","GE","SAN FRANCESCO D'ALBARO",0],["H850","ME","SAN FRATELLO",1],["H853","GE","SAN FRUTTUOSO",0],["H854","BG","SAN GALLO",0],["H856","CA","SAN GAVINO",0],["H856","CA","SAN GAVINO MONREALE",0],["H856","SU","SAN GAVINO MONREALE",1],["H857","TR","SAN GEMINI",1],["H858","BZ","SAN GENESIO",0],["H859","PV","SAN GENESIO",0],["H858","BZ","SAN GENESIO ATESINO",1],["H859","PV","SAN GENESIO ED UNITI",1],["H860","NA","SAN GENNARO",0],["H860","NA","SAN GENNARO VESUVIANO",1],["C034","FR","SAN GERMANO",0],["H861","NO","SAN GERMANO",0],["H862","TO","SAN GERMANO",0],["H863","VI","SAN GERMANO",0],["H862","TO","SAN GERMANO CHISONE",1],["H863","VI","SAN GERMANO DEI BERICI",0],["H861","VC","SAN GERMANO VERCELLESE",1],["H864","BG","SAN GERVASIO",0],["H865","BS","SAN GERVASIO",0],["H865","BS","SAN GERVASIO BRESCIANO",1],["H864","BG","SAN GERVASIO D'ADDA",0],["F618","SA","SAN GIACOMO",0],["H866","BZ","SAN GIACOMO",0],["H867","CB","SAN GIACOMO",0],["H868","SO","SAN GIACOMO",0],["H869","TN","SAN GIACOMO",0],["H867","CB","SAN GIACOMO DEGLI SCHIAVONI",1],["H870","MN","SAN GIACOMO DELLE SEGNATE",1],["H868","SO","SAN GIACOMO FILIPPO",1],["H871","TS","SAN GIACOMO IN COLLE",0],["H866","BZ","SAN GIACOMO IN VALLE AURINA",0],["B952","VC","SAN GIACOMO VERCELLESE",1],["H873","TO","SAN GILLIO",1],["H874","TO","SAN GILLIO TORINESE",0],["H875","SI","SAN GIMIGNANO",1],["H876","MC","SAN GINESIO",1],["C259","SA","SAN GIORGIO",0],["E408","TV","SAN GIORGIO",0],["H878","AL","SAN GIORGIO",0],["H879","BZ","SAN GIORGIO",0],["H880","CE","SAN GIORGIO",0],["H881","CS","SAN GIORGIO",0],["H882","LE","SAN GIORGIO",0],["H883","MN","SAN GIORGIO",0],["H884","MI","SAN GIORGIO",0],["H885","PV","SAN GIORGIO",0],["H886","PU","SAN GIORGIO",0],["H887","PC","SAN GIORGIO",0],["H888","PZ","SAN GIORGIO",0],["H889","RC","SAN GIORGIO",0],["H890","TO","SAN GIORGIO",0],["H891","UD","SAN GIORGIO",0],["H892","NA","SAN GIORGIO A CREMANO",1],["H880","FR","SAN GIORGIO A LIRI",1],["H881","CS","SAN GIORGIO ALBANESE",1],["H883","MN","SAN GIORGIO BIGARELLO",1],["H890","TO","SAN GIORGIO CANAVESE",1],["H894","BN","SAN GIORGIO DEL SANNIO",1],["H891","PN","SAN GIORGIO DELLA RICHINVELDA",1],["H893","PD","SAN GIORGIO DELLE PERTICHE",1],["E408","TV","SAN GIORGIO DI LAGO",0],["H885","PV","SAN GIORGIO DI LOMELLINA",1],["H883","MN","SAN GIORGIO DI MANTOVA",0],["H895","UD","SAN GIORGIO DI NOGARO",1],["H886","PU","SAN GIORGIO DI PESARO",0],["H896","BO","SAN GIORGIO DI PIANO",1],["H897","PD","SAN GIORGIO IN BOSCO",1],["H879","BZ","SAN GIORGIO IN VAL TURES",0],["H882","TA","SAN GIORGIO IONICO",1],["H898","BN","SAN GIORGIO LA MOLARA",1],["H894","BN","SAN GIORGIO LA MONTAGNA",0],["H888","MT","SAN GIORGIO LUCANO",1],["H878","AL","SAN GIORGIO MONFERRATO",1],["H889","RC","SAN GIORGIO MORGETO",1],["H887","PC","SAN GIORGIO PIACENTINO",1],["H899","AT","SAN GIORGIO SCARAMPI",1],["H882","TA","SAN GIORGIO SOTTO TARANTO",0],["H884","MI","SAN GIORGIO SU LEGNANO",1],["H900","TO","SAN GIORIO DI SUSA",1],["H901","AR","SAN GIOVANNI",0],["H902","BZ","SAN GIOVANNI",0],["H903","RC","SAN GIOVANNI",0],["H904","TO","SAN GIOVANNI",0],["H907","SA","SAN GIOVANNI A PIRO",1],["H908","NA","SAN GIOVANNI A TEDUCCIO",0],["H906","UD","SAN GIOVANNI AL NATISONE",1],["H905","CO","SAN GIOVANNI ALLA CASTAGNA",0],["H909","GE","SAN GIOVANNI BATTISTA",0],["H910","BG","SAN GIOVANNI BIANCO",1],["H911","SI","SAN GIOVANNI D'ASSO",0],["H912","MN","SAN GIOVANNI DEL DOSSO",1],["H913","VT","SAN GIOVANNI DI BIEDA",0],["H914","AG","SAN GIOVANNI DI CAMMARATA",0],["M390","TN","SAN GIOVANNI DI FASSA",1],["H915","CT","SAN GIOVANNI DI GALERNO",0],["H903","RC","SAN GIOVANNI DI GERACE",1],["H906","UD","SAN GIOVANNI DI MANZANO",0],["H914","AG","SAN GIOVANNI GEMINI",1],["H916","VR","SAN GIOVANNI ILARIONE",1],["H918","CR","SAN GIOVANNI IN CROCE",1],["H919","CS","SAN GIOVANNI IN FIORE",1],["H920","CB","SAN GIOVANNI IN GALDO",1],["H921","RN","SAN GIOVANNI IN MARIGNANO",1],["G467","BO","SAN GIOVANNI IN PERSICETO",1],["H902","BZ","SAN GIOVANNI IN VALLE AURINA",0],["H917","FR","SAN GIOVANNI INCARICO",1],["H922","CT","SAN GIOVANNI LA PUNTA",1],["H923","CH","SAN GIOVANNI LIPIONI",1],["H924","VR","SAN GIOVANNI LUPATOTO",1],["H904","TO","SAN GIOVANNI PELLICE",0],["H925","PG","SAN GIOVANNI REATINO",0],["H926","FG","SAN GIOVANNI ROTONDO",1],["G287","CA","SAN GIOVANNI SUERGIU",0],["G287","SU","SAN GIOVANNI SUERGIU",1],["D690","CH","SAN GIOVANNI TEATINO",1],["H901","AR","SAN GIOVANNI VALDARNO",1],["H927","MI","SAN GIULIANO",0],["H928","CB","SAN GIULIANO DEL SANNIO",1],["H929","CB","SAN GIULIANO DI PUGLIA",1],["H928","CB","SAN GIULIANO DI SEPINO",0],["H930","MI","SAN GIULIANO MILANESE",1],["A562","PI","SAN GIULIANO TERME",1],["H931","NA","SAN GIUSEPPE",0],["H932","NO","SAN GIUSEPPE",0],["H933","PA","SAN GIUSEPPE",0],["H934","RC","SAN GIUSEPPE",0],["H932","VC","SAN GIUSEPPE DI CASTO",0],["H933","PA","SAN GIUSEPPE JATO",1],["H931","NA","SAN GIUSEPPE VESUVIANO",1],["H935","PG","SAN GIUSTINO",1],["F621","MC","SAN GIUSTO",0],["H936","TO","SAN GIUSTO",0],["H936","TO","SAN GIUSTO CANAVESE",1],["H937","FI","SAN GODENZO",1],["H938","BL","SAN GREGORIO",0],["H939","CE","SAN GREGORIO",0],["H940","CT","SAN GREGORIO",0],["H941","CZ","SAN GREGORIO",0],["H942","RM","SAN GREGORIO",0],["H943","SA","SAN GREGORIO",0],["H941","VV","SAN GREGORIO D'IPPONA",1],["H942","RM","SAN GREGORIO DA SASSOLA",1],["H940","CT","SAN GREGORIO DI CATANIA",1],["H943","SA","SAN GREGORIO MAGNO",1],["H939","CE","SAN GREGORIO MATESE",1],["H938","BL","SAN GREGORIO NELLE ALPI",1],["H945","BO","SAN LAZZARO",0],["H946","IM","SAN LAZZARO",0],["H947","PC","SAN LAZZARO",0],["H947","PC","SAN LAZZARO ALBERONI",0],["H945","BO","SAN LAZZARO DI SAVENA",1],["H948","PR","SAN LAZZARO PARMENSE",0],["H946","IM","SAN LAZZARO REALE",0],["H949","PU","SAN LEO",0],["H949","RN","SAN LEO",1],["H950","BZ","SAN LEONARDO",0],["H951","UD","SAN LEONARDO",1],["H952","BZ","SAN LEONARDO IN PASSIRIA",1],["E404","UD","SAN LEOPOLDO ALAGLESIE",0],["H953","BN","SAN LEUCIO",0],["H954","NA","SAN LEUCIO",0],["H953","BN","SAN LEUCIO DEL SANNIO",1],["H955","BN","SAN LORENZELLO",1],["A256","RM","SAN LORENZO",0],["H956","BZ","SAN LORENZO",0],["H957","IM","SAN LORENZO",0],["H958","PU","SAN LORENZO",0],["H959","RC","SAN LORENZO",1],["H957","IM","SAN LORENZO AL MARE",1],["H960","CR","SAN LORENZO AROLDO",0],["H961","CS","SAN LORENZO BELLIZZI",1],["H963","CR","SAN LORENZO DE' PICENARDI",0],["H962","CS","SAN LORENZO DEL VALLO",1],["H964","GO","SAN LORENZO DI MOSSA",0],["H956","BZ","SAN LORENZO DI SEBATO",1],["M345","TN","SAN LORENZO DORSINO",1],["H965","CR","SAN LORENZO GUAZZONE",0],["H966","TN","SAN LORENZO IN BANALE",0],["H958","PU","SAN LORENZO IN CAMPO",1],["H956","BZ","SAN LORENZO IN PUSTERIA",0],["H964","GO","SAN LORENZO ISONTINO",1],["H967","BN","SAN LORENZO MAGGIORE",1],["H968","CR","SAN LORENZO MONDINARI",0],["H969","VT","SAN LORENZO NUOVO",1],["H970","RC","SAN LUCA",1],["H971","CS","SAN LUCIDO",1],["H972","TN","SAN LUGANO",0],["H973","BN","SAN LUPO",1],["H975","AV","SAN MANGO",0],["H976","CZ","SAN MANGO",0],["H977","SA","SAN MANGO",0],["H976","CZ","SAN MANGO D'AQUINO",1],["H977","SA","SAN MANGO PIEMONTE",1],["H975","AV","SAN MANGO SUL CALORE",1],["H978","CE","SAN MARCELLINO",1],["H979","AN","SAN MARCELLO",1],["H980","FI","SAN MARCELLO",0],["H980","PT","SAN MARCELLO PISTOIESE",0],["M377","PT","SAN MARCELLO PITEGLIO",1],["H981","CS","SAN MARCO",0],["H982","ME","SAN MARCO",0],["H983","BN","SAN MARCO A MONTI",0],["H981","CS","SAN MARCO ARGENTANO",1],["H982","ME","SAN MARCO D'ALFONSIO",0],["H982","ME","SAN MARCO D'ALUNZIO",1],["H984","BN","SAN MARCO DEI CAVOTI",1],["F043","CE","SAN MARCO EVANGELISTA",1],["F043","NA","SAN MARCO EVANGELISTA",0],["H985","FG","SAN MARCO IN LAMIS",1],["H986","FG","SAN MARCO LA CATOLA",1],["Z130","EE","SAN MARINO",0],["H987","AL","SAN MARTINO",0],["H988","BZ","SAN MARTINO",0],["H989","BZ","SAN MARTINO",0],["H990","CB","SAN MARTINO",0],["H991","CH","SAN MARTINO",0],["H992","CS","SAN MARTINO",0],["H993","PL","SAN MARTINO",0],["H994","PZ","SAN MARTINO",0],["H995","RM","SAN MARTINO",0],["H996","RO","SAN MARTINO",0],["H997","TO","SAN MARTINO",0],["H998","TO","SAN MARTINO",0],["H999","UD","SAN MARTINO",0],["H995","VT","SAN MARTINO AL CIMINO",0],["I001","BZ","SAN MARTINO AL MONTE",0],["H999","PN","SAN MARTINO AL TAGLIAMENTO",1],["H987","AL","SAN MARTINO AL TANARO",0],["H987","AT","SAN MARTINO ALFIERI",1],["I002","BN","SAN MARTINO AVE GRATIA PLOENA",0],["I003","VR","SAN MARTINO BUON ALBERGO",1],["H997","TO","SAN MARTINO CANAVESE",1],["H994","PZ","SAN MARTINO D'AGRI",1],["I004","GE","SAN MARTINO D'ALBARO",0],["I005","MN","SAN MARTINO DALL'ARGINE",1],["I006","BG","SAN MARTINO DE' CALVI",0],["I007","CR","SAN MARTINO DEL LAGO",1],["H992","CS","SAN MARTINO DI FINITA",1],["I008","PD","SAN MARTINO DI LUPARI",1],["H998","TO","SAN MARTINO DI PERRERO",0],["H996","RO","SAN MARTINO DI VENEZZE",1],["H988","BZ","SAN MARTINO IN BADIA",1],["I009","CR","SAN MARTINO IN BELISETO",0],["I010","BZ","SAN MARTINO IN CASIES",0],["H989","BZ","SAN MARTINO IN PASSIRIA",1],["H990","CB","SAN MARTINO IN PENSILIS",1],["I011","RE","SAN MARTINO IN RIO",1],["I012","LO","SAN MARTINO IN STRADA",1],["H993","PL","SAN MARTINO IN VALLE",0],["I013","GO","SAN MARTINO QUISCA",0],["I002","BN","SAN MARTINO SANNITA",1],["I014","PV","SAN MARTINO SICCOMARIO",1],["I015","PR","SAN MARTINO SINZANO",0],["H991","CH","SAN MARTINO SULLA MARRUCINA",1],["I016","AV","SAN MARTINO VALLE CAUDINA",1],["I017","AL","SAN MARZANO",0],["I018","LE","SAN MARZANO",0],["I019","SA","SAN MARZANO",0],["I018","TA","SAN MARZANO DI SAN GIUSEPPE",1],["I020","AL","SAN MARZANO MOASCA",0],["I017","AT","SAN MARZANO OLIVETO",1],["I019","SA","SAN MARZANO SUL SARNO",1],["I021","AL","SAN MARZANOTTO",0],["I022","VR","SAN MASSIMO",0],["I023","CB","SAN MASSIMO",1],["I022","VR","SAN MASSIMO ALL'ADIGE",0],["E003","NO","SAN MAURIZIO",0],["I024","TO","SAN MAURIZIO CANAVESE",1],["I025","NO","SAN MAURIZIO D'OPAGLIO",1],["I026","CZ","SAN MAURO",0],["I027","FC","SAN MAURO",0],["I028","PA","SAN MAURO",0],["I029","PZ","SAN MAURO",0],["I030","TO","SAN MAURO",0],["I028","PA","SAN MAURO CASTELVERDE",1],["I031","SA","SAN MAURO CILENTO",1],["I027","FC","SAN MAURO DI ROMA",0],["I027","FC","SAN MAURO DI ROMAGNA",0],["H712","VR","SAN MAURO DI SALINE",1],["I029","MT","SAN MAURO FORTE",1],["I032","SA","SAN MAURO LA BRUCA",1],["I026","KR","SAN MAURO MARCHESATO",1],["I027","FC","SAN MAURO PASCOLI",1],["I030","TO","SAN MAURO TORINESE",1],["H749","BA","SAN MICHELE",0],["I033","AL","SAN MICHELE",0],["I034","AV","SAN MICHELE",0],["I035","CT","SAN MICHELE",0],["I036","CR","SAN MICHELE",0],["I037","CN","SAN MICHELE",0],["I038","CN","SAN MICHELE",0],["I039","RM","SAN MICHELE",0],["I040","VE","SAN MICHELE",0],["I041","VR","SAN MICHELE",0],["I040","VE","SAN MICHELE AL TAGLIAMENTO",1],["I042","TN","SAN MICHELE ALL'ADIGE",1],["I036","CR","SAN MICHELE CREMASCO",0],["I033","AT","SAN MICHELE D'ASTI",0],["H117","VE","SAN MICHELE DEL QUARTO",0],["I043","PD","SAN MICHELE DELLE BADESSE",0],["I035","CT","SAN MICHELE DI GANZARIA",1],["I044","TS","SAN MICHELE DI POSTUMIA",0],["I034","AV","SAN MICHELE DI SERINO",1],["I041","VR","SAN MICHELE EXTRA",0],["I039","VT","SAN MICHELE IN TEVERINA",0],["I037","CN","SAN MICHELE MONDOVI'",1],["I038","CN","SAN MICHELE PRAZZO",0],["I045","BR","SAN MICHELE SALENTINO",1],["I046","PI","SAN MINIATO",1],["I024","TO","SAN MORIZIO",0],["I024","TO","SAN MORIZIO CANAVESE",0],["I047","VI","SAN NAZARIO",0],["I049","BN","SAN NAZZARO",1],["I050","BS","SAN NAZZARO",0],["I051","CO","SAN NAZZARO",0],["B449","BN","SAN NAZZARO CALVI",0],["I050","BS","SAN NAZZARO MELLA",0],["I052","NO","SAN NAZZARO SESIA",1],["I051","CO","SAN NAZZARO VAL CAVARGNA",1],["I053","BA","SAN NICANDRO",0],["I054","FG","SAN NICANDRO",0],["I055","AQ","SAN NICANDRO",0],["I055","AQ","SAN NICANDRO D'AQUILA",0],["I054","FG","SAN NICANDRO GARGANICO",1],["G923","RO","SAN NICCOLO",0],["I056","CE","SAN NICOLA",0],["I057","CZ","SAN NICOLA",0],["I058","CZ","SAN NICOLA",0],["I060","CS","SAN NICOLA ARCELLA",1],["I061","AV","SAN NICOLA BARONIA",1],["I058","VV","SAN NICOLA DA CRISSA",1],["I057","KR","SAN NICOLA DELL'ALTO",1],["I056","CE","SAN NICOLA LA STRADA",1],["I062","BN","SAN NICOLA MANFREDI",1],["I063","BL","SAN NICOLO'",0],["A368","OR","SAN NICOLO' D'ARCIDANO",1],["I063","BL","SAN NICOLO' DI COMELICO",1],["G383","CA","SAN NICOLO' GERREI",0],["G383","SU","SAN NICOLO' GERREI",1],["I064","MI","SAN NOVO",0],["I065","BZ","SAN PANCRAZIO",1],["I066","LE","SAN PANCRAZIO",0],["I067","MI","SAN PANCRAZIO",0],["I068","PR","SAN PANCRAZIO",0],["I067","MI","SAN PANCRAZIO AL COLLE",0],["I068","PR","SAN PANCRAZIO PARMENSE",0],["I066","BR","SAN PANCRAZIO SALENTINO",1],["I069","CA","SAN PANTALEO",0],["G407","BS","SAN PAOLO",1],["I070","AL","SAN PAOLO",0],["I071","AN","SAN PAOLO",0],["I072","FG","SAN PAOLO",0],["I073","NA","SAN PAOLO",0],["I074","NO","SAN PAOLO",0],["B906","PZ","SAN PAOLO ALBANESE",1],["I073","NA","SAN PAOLO BEL SITO",1],["I074","BI","SAN PAOLO CERVO",0],["B310","BG","SAN PAOLO D'ARGON",1],["I070","AL","SAN PAOLO DELLA VALLE",0],["I072","FG","SAN PAOLO DI CIVITATE",1],["I071","AN","SAN PAOLO DI JESI",1],["I075","CR","SAN PAOLO RIPA D'OGLIO",0],["I076","AT","SAN PAOLO SOLBRITO",1],["I077","MI","SAN PEDRINO",0],["I078","TS","SAN PELAGIO",0],["I079","BG","SAN PELLEGRINO",0],["I079","BG","SAN PELLEGRINO TERME",1],["I080","PV","SAN PERONE",0],["I081","GE","SAN PIER D'ARENA",0],["I082","GO","SAN PIER D'ISONZO",1],["I083","RC","SAN PIER FEDELE",0],["I084","ME","SAN PIER MONFORTE",0],["I084","ME","SAN PIER NICETO",1],["I085","FI","SAN PIERO A SIEVE",0],["I086","ME","SAN PIERO PATTI",1],["I083","RC","SAN PIETRO",0],["I087","BZ","SAN PIETRO",0],["I088","BL","SAN PIETRO",0],["I089","SA","SAN PIETRO",0],["I090","TO","SAN PIETRO",0],["I091","UD","SAN PIETRO",0],["I093","CZ","SAN PIETRO A MAIDA",1],["I094","NA","SAN PIETRO A PATIERNO",0],["I095","CZ","SAN PIETRO A TIRIOLO",0],["I092","UD","SAN PIETRO AL NATISONE",1],["I089","SA","SAN PIETRO AL TANAGRO",1],["I095","CZ","SAN PIETRO APOSTOLO",1],["I096","IS","SAN PIETRO AVELLANA",1],["I097","MI","SAN PIETRO BESTAZZO",0],["I088","BL","SAN PIETRO CADORE",0],["I098","CT","SAN PIETRO CLARENZA",1],["I099","MI","SAN PIETRO CUSICO",0],["I106","BG","SAN PIETRO D'ORZIO",0],["I092","UD","SAN PIETRO DEGLI SCHIAVI",0],["I100","TS","SAN PIETRO DEL CARSO",0],["I082","TS","SAN PIETRO DELL'ISONZO",0],["I101","TV","SAN PIETRO DI BARBOZZA",0],["I088","BL","SAN PIETRO DI CADORE",1],["I102","RC","SAN PIETRO DI CARIDA'",1],["I103","TV","SAN PIETRO DI FELETTO",1],["I091","GO","SAN PIETRO DI GORIZIA",0],["I104","CN","SAN PIETRO DI MONTEROSSO",0],["I105","VR","SAN PIETRO DI MORUBIO",1],["I107","PD","SAN PIETRO ENGU",0],["I108","CS","SAN PIETRO IN AMANTEA",1],["I109","VR","SAN PIETRO IN CARIANO",1],["I110","BO","SAN PIETRO IN CASALE",1],["G788","PC","SAN PIETRO IN CERRO",1],["I111","CE","SAN PIETRO IN CUROLIS",0],["I107","PD","SAN PIETRO IN GU",1],["I114","CS","SAN PIETRO IN GUARANO",1],["I115","LE","SAN PIETRO IN LAMA",1],["I087","BZ","SAN PIETRO IN VALLE AURINA",0],["I112","NA","SAN PIETRO INDELICATO",0],["I113","CE","SAN PIETRO INFINE",1],["I112","AV","SAN PIETRO IRPINO",0],["F529","PD","SAN PIETRO MONTAGNON",0],["I116","NO","SAN PIETRO MOSEZZO",1],["I117","VI","SAN PIETRO MUSSOLINO",1],["I118","CA","SAN PIETRO PULA",0],["I086","ME","SAN PIETRO SOPRA PATTI",0],["I090","TO","SAN PIETRO VAL LEMINA",1],["I119","BR","SAN PIETRO VERNOTICO",1],["I120","PD","SAN PIETRO VIMINARIO",1],["I121","AQ","SAN PIO DELLE CAMERE",1],["I122","CB","SAN POLO",0],["I123","RE","SAN POLO",0],["I124","TV","SAN POLO",0],["I123","RE","SAN POLO D'ENZA",1],["I123","RE","SAN POLO D'ENZA IN CAVIANO",0],["I125","RM","SAN POLO DEI CAVALIERI",1],["I124","TV","SAN POLO DI PIAVE",1],["I122","CB","SAN POLO MATESE",1],["I122","CB","SAN POLOMATESE",0],["I126","TO","SAN PONSO",1],["I126","AO","SAN PONSO CANAVESE",0],["I127","PV","SAN PONZO",0],["I127","PV","SAN PONZO SEMOLA",0],["I128","MO","SAN POSSIDONIO",1],["I129","AV","SAN POTITO",0],["I130","CE","SAN POTITO",0],["I130","CE","SAN POTITO SANNITICO",1],["I129","AV","SAN POTITO ULTRA",1],["I131","CE","SAN PRISCO",1],["I132","RC","SAN PROCOPIO",1],["I133","MO","SAN PROSPERO",1],["I134","GE","SAN QUIRICO",0],["I135","SI","SAN QUIRICO",0],["I135","SI","SAN QUIRICO D'ORCIA",1],["I134","GE","SAN QUIRICO IN VAL DI POLCEVERA",0],["I136","PN","SAN QUIRINO",1],["I137","TO","SAN RAFFAELE CIMENA",1],["H675","AO","SAN REMIGIO",0],["I138","IM","SAN REMO",0],["I139","RC","SAN ROBERTO",1],["I140","LO","SAN ROCCO AL PORTO",1],["I142","LU","SAN ROMANO IN GARFAGNANA",1],["E519","GE","SAN RUFINO",0],["I143","SA","SAN RUFO",1],["I144","AL","SAN SALVATORE",0],["I145","BN","SAN SALVATORE",0],["I146","CR","SAN SALVATORE",0],["I147","ME","SAN SALVATORE",0],["I147","ME","SAN SALVATORE DI FITALIA",1],["I144","AL","SAN SALVATORE MONFERRATO",1],["I145","BN","SAN SALVATORE TELESINO",1],["I148","CH","SAN SALVO",1],["I149","CR","SAN SAVINO",0],["I150","AL","SAN SEBASTIANO",0],["I151","NA","SAN SEBASTIANO",0],["I152","TO","SAN SEBASTIANO",0],["I151","NA","SAN SEBASTIANO AL VESUVIO",1],["I150","AL","SAN SEBASTIANO CURONE",1],["I152","TO","SAN SEBASTIANO DA PO",1],["I153","PR","SAN SECONDO",0],["I154","TO","SAN SECONDO",0],["I154","TO","SAN SECONDO DI PINEROLO",1],["I153","PR","SAN SECONDO PARMENSE",1],["I156","MC","SAN SEVERINO",0],["I157","PZ","SAN SEVERINO",0],["I157","PZ","SAN SEVERINO LUCANO",1],["I156","MC","SAN SEVERINO MARCHE",1],["F138","SA","SAN SEVERINO ROTA",0],["I158","FG","SAN SEVERO",1],["I159","BZ","SAN SIGISMONDO",0],["I160","CR","SAN SILLO",0],["I161","CH","SAN SILVESTRO",0],["I162","CO","SAN SIRO",1],["I163","AV","SAN SOSSIO",0],["I163","AV","SAN SOSSIO BARONIA",1],["I164","CZ","SAN SOSTENE",1],["I165","CS","SAN SOSTI",1],["I166","CA","SAN SPERATE",0],["I166","SU","SAN SPERATE",1],["I373","VE","SAN STINO DI LIVENZA",1],["I261","CE","SAN TAMMARO",1],["I328","ME","SAN TEODORO",1],["I329","NU","SAN TEODORO",0],["I329","SS","SAN TEODORO",1],["I345","BL","SAN TIZIANO DI GOIMNA",0],["I347","BL","SAN TOMASO",0],["I347","BL","SAN TOMASO AGORDINO",1],["I376","CH","SAN VALENTINO",0],["I377","SA","SAN VALENTINO",0],["I379","BZ","SAN VALENTINO",0],["I378","BZ","SAN VALENTINO AL BRENNERO",0],["I379","BZ","SAN VALENTINO ALLA MUTTA",0],["I376","PE","SAN VALENTINO IN ABRUZZO CITERIORE",1],["H019","BZ","SAN VALENTINO IN PREDOI",0],["I377","SA","SAN VALENTINO TORIO",1],["I380","PV","SAN VARESE",0],["I381","TR","SAN VENANZO",1],["I382","TV","SAN VENDEMIANO",1],["I383","CA","SAN VERO CONGIUS",0],["I384","OR","SAN VERO MILIS",1],["I385","BS","SAN VIGILIO",0],["I387","CB","SAN VINCENZO",0],["I388","CS","SAN VINCENZO",0],["I389","AQ","SAN VINCENZO",0],["I390","LI","SAN VINCENZO",1],["I387","CB","SAN VINCENZO A VOLTURNO",0],["H676","AO","SAN VINCENZO DELLA FONTE",0],["I388","CS","SAN VINCENZO LA COSTA",1],["I389","AQ","SAN VINCENZO VALLE ROVETO",1],["I391","NA","SAN VITALIANO",1],["I392","BL","SAN VITO",0],["I393","CZ","SAN VITO",0],["I394","CH","SAN VITO",0],["I395","CR","SAN VITO",0],["I396","LE","SAN VITO",0],["I397","MI","SAN VITO",0],["I398","PG","SAN VITO",0],["I399","PU","SAN VITO",0],["I400","RM","SAN VITO",0],["I401","VI","SAN VITO",0],["I402","CA","SAN VITO",0],["I402","SU","SAN VITO",1],["I403","PN","SAN VITO AL TAGLIAMENTO",1],["I404","UD","SAN VITO AL TORRE",1],["I394","CH","SAN VITO CHIETINO",1],["I396","BR","SAN VITO DEI NORMANNI",1],["I392","BL","SAN VITO DI CADORE",1],["I405","UD","SAN VITO DI FAGAGNA",1],["I401","VI","SAN VITO DI LEGUZZANO",1],["I406","GO","SAN VITO DI VIPACCO",0],["I397","MI","SAN VITO E MARTA",0],["I395","CR","SAN VITO E MODESTO",0],["I398","TR","SAN VITO IN MONTE",0],["I407","TP","SAN VITO LO CAPO",1],["I400","RM","SAN VITO ROMANO",1],["I399","PU","SAN VITO SUL CESANO",0],["I393","CZ","SAN VITO SULLO IONIO",1],["I408","CE","SAN VITTORE",0],["I409","MI","SAN VITTORE",0],["I408","FR","SAN VITTORE DEL LAZIO",1],["I409","MI","SAN VITTORE OLONA",1],["I412","BS","SAN ZENO",0],["I413","PV","SAN ZENO",0],["I414","VR","SAN ZENO DI MONTAGNA",1],["I413","PV","SAN ZENO E FOPPA",0],["I412","BS","SAN ZENO NAVIGLIO",1],["I415","MI","SAN ZENONE",0],["I416","PV","SAN ZENONE",0],["I417","TV","SAN ZENONE",0],["I415","MI","SAN ZENONE AL LAMBRO",1],["I416","PV","SAN ZENONE AL PO",1],["I417","TV","SAN ZENONE DEGLI EZZELINI",1],["H757","LE","SANARICA",1],["H821","BI","SANDIGLIANO",1],["H829","VI","SANDRIGO",1],["H851","CN","SANFRE'",1],["H852","CN","SANFRONT",1],["H852","CN","SANFRONTE",0],["H855","TO","SANGANO",1],["H872","VA","SANGIANO",1],["H877","CS","SANGINETO",1],["H944","VR","SANGUINETTO",1],["H974","CA","SANLURI",0],["H974","SU","SANLURI",1],["I048","PV","SANNAZZARO",0],["I048","PV","SANNAZZARO DE' BURGONDI",1],["I053","BA","SANNICANDRO DI BARI",1],["I054","FG","SANNICANDRO GARGANICO",0],["I059","LE","SANNICOLA",1],["I138","IM","SANREMO",1],["I155","AR","SANSEPOLCRO",1],["I167","CO","SANT'ABBONDIO",0],["I189","IS","SANT'AGAPITO",1],["I190","AL","SANT'AGATA",0],["I191","BO","SANT'AGATA",0],["I192","CS","SANT'AGATA",0],["I193","FG","SANT'AGATA",0],["I194","MI","SANT'AGATA",0],["I195","NO","SANT'AGATA",0],["I196","RA","SANT'AGATA",0],["I191","BO","SANT'AGATA BOLOGNESE",1],["I197","BN","SANT'AGATA DE' GOTI",1],["I198","RC","SANT'AGATA DEL BIANCO",1],["I192","CS","SANT'AGATA DI ESARO",1],["I199","ME","SANT'AGATA DI MILITELLO",1],["I193","FG","SANT'AGATA DI PUGLIA",1],["I200","AV","SANT'AGATA DI SOTTO",0],["I201","PU","SANT'AGATA FELTRIA",0],["I201","RN","SANT'AGATA FELTRIA",1],["I190","AL","SANT'AGATA FOSSILI",1],["I200","AV","SANT'AGATA IRPINA",0],["I202","CT","SANT'AGATA LI BATTIATI",1],["I194","MI","SANT'AGATA MARTESANA",0],["I195","NO","SANT'AGATA SOPRA CANNOBIO",0],["I196","RA","SANT'AGATA SUL SANTERNO",1],["I208","NA","SANT'AGNELLO",1],["I209","FE","SANT'AGOSTINO",0],["I210","CN","SANT'ALBANO",0],["I211","PV","SANT'ALBANO",0],["I211","PV","SANT'ALBANO DI BOBBIO",0],["I210","CN","SANT'ALBANO STURA",1],["I212","BS","SANT'ALESSANDRO",0],["I213","PV","SANT'ALESSIO",0],["I214","RC","SANT'ALESSIO",0],["I213","PV","SANT'ALESSIO CON VIALONE",1],["I214","RC","SANT'ALESSIO IN ASPROMONTE",1],["I215","ME","SANT'ALESSIO SICULO",1],["I216","CT","SANT'ALFIO",1],["I256","CE","SANT'AMBROGIO",0],["I257","CO","SANT'AMBROGIO",0],["I258","TO","SANT'AMBROGIO",0],["I259","VR","SANT'AMBROGIO",0],["I258","TO","SANT'AMBROGIO DI TORINO",1],["I259","VR","SANT'AMBROGIO DI VALPOLICELLA",1],["I256","FR","SANT'AMBROGIO SUL GARIGLIANO",1],["I257","VA","SANT'AMBROGIO-OLONA",0],["I262","NA","SANT'ANASTASIA",1],["D429","MC","SANT'ANATOLIA",0],["I263","PG","SANT'ANATOLIA",0],["I263","PG","SANT'ANATOLIA DI NARCO",1],["I264","AV","SANT'ANDREA",0],["I265","FR","SANT'ANDREA",0],["I266","CZ","SANT'ANDREA",0],["I268","PU","SANT'ANDREA",0],["I269","UD","SANT'ANDREA",0],["I266","CZ","SANT'ANDREA APOSTOLO DELLO IONIO",1],["I265","FR","SANT'ANDREA DEL GARIGLIANO",1],["A136","TV","SANT'ANDREA DI CAVASAGRA",0],["I264","AV","SANT'ANDREA DI CONZA",1],["I269","GO","SANT'ANDREA DI GORIZIA",0],["I268","PU","SANT'ANDREA DI SUASA",0],["I270","CE","SANT'ANDREA DI VALLEFREDDA",0],["I271","CA","SANT'ANDREA FRIUS",0],["I271","SU","SANT'ANDREA FRIUS",1],["I272","BZ","SANT'ANDREA IN MONTE",0],["I273","CE","SANT'ANGELO",0],["I274","MI","SANT'ANGELO",0],["I275","PD","SANT'ANGELO",0],["I276","PV","SANT'ANGELO",0],["I277","BN","SANT'ANGELO A CUPOLO",1],["I278","SA","SANT'ANGELO A FASANELLA",1],["I280","AV","SANT'ANGELO A SCALA",1],["I279","AV","SANT'ANGELO ALL'ESCA",1],["I273","CE","SANT'ANGELO D'ALIFE",1],["I281","AV","SANT'ANGELO DEI LOMBARDI",1],["I282","IS","SANT'ANGELO DEL PESCO",1],["I283","ME","SANT'ANGELO DI BROLO",1],["I275","PD","SANT'ANGELO DI PIOVE DI SACCO",1],["I284","RM","SANT'ANGELO IN CAPOCCIA",0],["I238","CB","SANT'ANGELO IN GROTTE",0],["I285","PU","SANT'ANGELO IN LIZZOLA",0],["I286","MC","SANT'ANGELO IN PONTANO",1],["I287","PU","SANT'ANGELO IN VADO",1],["I288","PZ","SANT'ANGELO LE FRATTE",1],["I289","CB","SANT'ANGELO LIMOSANO",1],["I274","LO","SANT'ANGELO LODIGIANO",1],["I276","PV","SANT'ANGELO LOMELLINA",1],["I290","AG","SANT'ANGELO MUXARO",1],["I284","RM","SANT'ANGELO ROMANO",1],["M209","CA","SANT'ANNA ARRESI",0],["M209","SU","SANT'ANNA ARRESI",1],["I292","VR","SANT'ANNA D'ALFAEDO",1],["I293","NA","SANT'ANTIMO",1],["I294","CA","SANT'ANTIOCO",0],["I294","SU","SANT'ANTIOCO",1],["I295","MI","SANT'ANTONINO",0],["I296","TO","SANT'ANTONINO",0],["I296","TO","SANT'ANTONINO DI SUSA",1],["I295","MI","SANT'ANTONINO TICINO",0],["I297","BG","SANT'ANTONIO",0],["I298","CA","SANT'ANTONIO",0],["I299","PC","SANT'ANTONIO",0],["I299","PC","SANT'ANTONIO A TREBBIA",0],["I300","NA","SANT'ANTONIO ABATE",1],["I297","BG","SANT'ANTONIO D'ADDA",0],["M276","SS","SANT'ANTONIO DI GALLURA",1],["I298","OR","SANT'ANTONIO RUINAS",0],["I302","FR","SANT'APOLLINARE",1],["I303","RO","SANT'APOLLINARE",0],["I303","RO","SANT'APOLLINARE CON SELVA",0],["F557","AV","SANT'ARCANGELO",0],["I304","FC","SANT'ARCANGELO",0],["I305","PZ","SANT'ARCANGELO",1],["I304","FC","SANT'ARCANGELO DI ROMAGNA",0],["F557","BN","SANT'ARCANGELO TRIMONTE",1],["I306","CE","SANT'ARPINO",1],["I307","SA","SANT'ARSENIO",1],["I317","SA","SANT'EGIDIO",0],["I318","TE","SANT'EGIDIO",0],["I318","TE","SANT'EGIDIO ALLA VIBRATA",1],["I317","SA","SANT'EGIDIO DEL MONTE ALBINO",1],["I319","PD","SANT'ELENA",1],["Z340","EE","SANT'ELENA (ISOLA)",0],["B466","IS","SANT'ELENA SANNITA",1],["I320","CB","SANT'ELIA",0],["I321","CE","SANT'ELIA",0],["I322","CZ","SANT'ELIA",0],["I323","PG","SANT'ELIA",0],["I320","CB","SANT'ELIA A PIANISI",1],["I321","FR","SANT'ELIA FIUMERAPIDO",1],["I323","PG","SANT'ELIA REATINO",0],["I324","AP","SANT'ELPIDIO A MARE",0],["I324","FM","SANT'ELPIDIO A MARE",1],["I325","AP","SANT'ELPIDIO MORICO",0],["I331","NA","SANT'ERASMO",0],["B031","PD","SANT'EUFEMIA",0],["I186","BS","SANT'EUFEMIA",0],["I332","CH","SANT'EUFEMIA",0],["I332","PE","SANT'EUFEMIA A MAIELLA",1],["I333","RC","SANT'EUFEMIA D'ASPROMONTE",1],["I186","BS","SANT'EUFEMIA DELLA FONTE",0],["I334","CZ","SANT'EUFEMIA LAMEZIA",0],["H673","AO","SANT'EUGENDO",0],["I335","CH","SANT'EUSANIO",0],["I336","AQ","SANT'EUSANIO",0],["I335","CH","SANT'EUSANIO DEL SANGRO",1],["I336","AQ","SANT'EUSANIO FORCONESE",1],["I340","GE","SANT'ILARIO",0],["I341","RC","SANT'ILARIO",0],["I342","RE","SANT'ILARIO",0],["I342","RE","SANT'ILARIO D'ENZA",1],["I341","RC","SANT'ILARIO DELLO IONIO",1],["I340","GE","SANT'ILARIO LIGURE",0],["I344","PU","SANT'IPPOLITO",1],["D630","UD","SANT'ODORICO",0],["I346","GE","SANT'OLCESE",1],["I348","TE","SANT'OMERO",1],["I349","BG","SANT'OMOBONO IMAGNA",0],["M333","BG","SANT'OMOBONO TERME",1],["I350","VV","SANT'ONOFRIO",1],["I352","RM","SANT'ORESTE",1],["I354","TN","SANT'ORSOLA",0],["I354","TN","SANT'ORSOLA TERME",1],["I375","PD","SANT'URBANO",1],["I168","BG","SANTA BRIGIDA",1],["I169","CL","SANTA CATERINA",0],["I170","CZ","SANTA CATERINA",0],["I171","CS","SANTA CATERINA",0],["I171","CS","SANTA CATERINA ALBANESE",1],["I170","CZ","SANTA CATERINA DELLO IONIO",1],["I169","CL","SANTA CATERINA VILLARMOSA",1],["I172","LE","SANTA CESAREA",0],["I172","LE","SANTA CESAREA TERME",1],["I173","BZ","SANTA CRISTINA",0],["I174","PA","SANTA CRISTINA",0],["I175","PV","SANTA CRISTINA",0],["I176","RC","SANTA CRISTINA",0],["I176","RC","SANTA CRISTINA D'ASPROMONTE",1],["I175","PV","SANTA CRISTINA E BISSONE",1],["I174","PA","SANTA CRISTINA GELA",1],["I173","BZ","SANTA CRISTINA IN GARDENA",0],["I173","BZ","SANTA CRISTINA VALGARDENA",1],["I177","FI","SANTA CROCE",0],["I178","RG","SANTA CROCE",0],["I178","RG","SANTA CROCE CAMERINA",1],["I179","BN","SANTA CROCE DEL SANNIO",1],["I180","GO","SANTA CROCE DI AIDUSSINA",0],["I181","CB","SANTA CROCE DI MAGLIANO",1],["I179","BN","SANTA CROCE DI MORCONE",0],["I177","PI","SANTA CROCE SULL'ARNO",1],["I183","CS","SANTA DOMENICA",0],["I184","ME","SANTA DOMENICA",0],["I183","CS","SANTA DOMENICA TALAO",1],["I184","ME","SANTA DOMENICA VITTORIA",1],["I185","AG","SANTA ELISABETTA",1],["I186","BS","SANTA EUFEMIA",0],["I187","GR","SANTA FIORA",1],["I188","PA","SANTA FLAVIA",1],["I203","PV","SANTA GIULETTA",1],["I204","SV","SANTA GIULIA",0],["I205","OR","SANTA GIUSTA",1],["I206","BL","SANTA GIUSTINA",1],["I207","PD","SANTA GIUSTINA IN COLLE",1],["I217","PI","SANTA LUCE",1],["I218","PI","SANTA LUCE-ORCIANO",0],["I219","AV","SANTA LUCIA",0],["I220","ME","SANTA LUCIA",0],["I221","TV","SANTA LUCIA",0],["I222","GO","SANTA LUCIA D'ISONZO",0],["I220","ME","SANTA LUCIA DEL MELA",1],["I221","TV","SANTA LUCIA DI PIAVE",1],["I219","AV","SANTA LUCIA DI SERINO",1],["I223","BZ","SANTA MADDALENA IN CASIES",0],["I224","AG","SANTA MARGHERITA",0],["I225","GE","SANTA MARGHERITA",0],["I226","PD","SANTA MARGHERITA",0],["I227","PV","SANTA MARGHERITA",0],["I228","PV","SANTA MARGHERITA",0],["I229","TN","SANTA MARGHERITA",0],["I226","PD","SANTA MARGHERITA D'ADIGE",0],["I224","AG","SANTA MARGHERITA DI BELICE",1],["I227","PV","SANTA MARGHERITA DI BOBBIO",0],["I230","PV","SANTA MARGHERITA DI STAFFORA",1],["I225","GE","SANTA MARGHERITA LIGURE",1],["I228","PV","SANTA MARGHERITA PO",0],["C717","CS","SANTA MARIA",0],["I231","AP","SANTA MARIA",0],["I232","PI","SANTA MARIA A MONTE",1],["I233","CE","SANTA MARIA A VICO",1],["I234","CE","SANTA MARIA CAPUA VETERE",1],["M284","SS","SANTA MARIA COGHINAS",1],["C717","CS","SANTA MARIA DEL CEDRO",1],["I238","IS","SANTA MARIA DEL MOLISE",1],["I239","VA","SANTA MARIA DEL MONTE",0],["I231","AP","SANTA MARIA DEL TRONTO",0],["I235","CR","SANTA MARIA DELLA CROCE",0],["I236","PV","SANTA MARIA DELLA STRADA",0],["I237","PV","SANTA MARIA DELLA VERSA",1],["I240","CT","SANTA MARIA DI LICODIA",1],["A946","PA","SANTA MARIA DI OGLIASTRO",0],["I241","CO","SANTA MARIA DI ROVAGNATE",0],["I242","VE","SANTA MARIA DI SALA",1],["I243","LC","SANTA MARIA HOE'",1],["I244","CH","SANTA MARIA IMBARO",1],["A785","BO","SANTA MARIA IN DUNO",0],["I245","MI","SANTA MARIA IN PRATO",0],["I246","VR","SANTA MARIA IN STELLE",0],["M273","NA","SANTA MARIA LA CARITA'",1],["I247","CE","SANTA MARIA LA FOSSA",1],["I248","UD","SANTA MARIA LA LONGA",1],["I234","CE","SANTA MARIA MAGGIORE",0],["I249","VB","SANTA MARIA MAGGIORE",1],["I250","NO","SANTA MARIA MAGGIORE E CRANA",0],["I251","AN","SANTA MARIA NUOVA",1],["I252","CO","SANTA MARIA REZZONICO",0],["I253","SA","SANTA MARINA",1],["I254","ME","SANTA MARINA SALINA",1],["I255","RM","SANTA MARINELLA",1],["I260","SA","SANTA MENNA",0],["I291","TP","SANTA NINFA",1],["I301","AV","SANTA PAOLINA",1],["I308","KR","SANTA SEVERINA",1],["I309","CS","SANTA SOFIA",0],["I310","FC","SANTA SOFIA",1],["I309","CS","SANTA SOFIA D'EPIRO",1],["I311","ME","SANTA TERESA",0],["I312","SS","SANTA TERESA",0],["I311","ME","SANTA TERESA DI RIVA",1],["I312","SS","SANTA TERESA GALLURA",1],["I313","CO","SANTA VALERIA",0],["I314","CT","SANTA VENERINA",1],["I315","AP","SANTA VITTORIA",0],["I316","CN","SANTA VITTORIA",0],["I316","CN","SANTA VITTORIA D'ALBA",1],["I315","AP","SANTA VITTORIA IN MATENANO",0],["I315","FM","SANTA VITTORIA IN MATENANO",1],["I182","CA","SANTADI",0],["I182","SU","SANTADI",1],["I304","RN","SANTARCANGELO DI ROMAGNA",1],["I326","AQ","SANTE MARIE",1],["I327","TO","SANTENA",1],["I330","BA","SANTERAMO",0],["I331","NA","SANTERAMO",0],["I330","BA","SANTERAMO IN COLLE",1],["I337","VC","SANTHIA'",1],["I339","LT","SANTI COSMA E DAMIANO",1],["I338","BS","SANTICOLO",0],["I343","NO","SANTINO",0],["I355","GO","SANTO SPIRITO DELLA BAINSIZZA",0],["I356","AG","SANTO STEFANO",0],["I357","AV","SANTO STEFANO",0],["I358","BG","SANTO STEFANO",0],["I359","CS","SANTO STEFANO",0],["I360","AQ","SANTO STEFANO",0],["I361","MI","SANTO STEFANO",0],["I362","MI","SANTO STEFANO",0],["I363","GE","SANTO STEFANO",0],["I364","RM","SANTO STEFANO",0],["I365","IM","SANTO STEFANO AL MARE",1],["I366","IM","SANTO STEFANO AL MARE CON CASTELLARO",0],["I367","CN","SANTO STEFANO BELBO",1],["I368","GE","SANTO STEFANO D'AVETO",1],["I362","MI","SANTO STEFANO DEL CORNO",0],["I358","BG","SANTO STEFANO DEL MONTE DEGLI ANGELI",0],["I357","AV","SANTO STEFANO DEL SOLE",1],["I369","ME","SANTO STEFANO DI BRIGA",0],["C919","BL","SANTO STEFANO DI CADORE",1],["I370","ME","SANTO STEFANO DI CAMASTRA",1],["I363","SP","SANTO STEFANO DI MAGRA",1],["I359","CS","SANTO STEFANO DI ROGLIANO",1],["I360","AQ","SANTO STEFANO DI SESSANIO",1],["I371","RC","SANTO STEFANO IN ASPROMONTE",1],["I362","LO","SANTO STEFANO LODIGIANO",1],["I356","AG","SANTO STEFANO QUISQUINA",1],["I372","CN","SANTO STEFANO ROERO",1],["I361","MI","SANTO STEFANO TICINO",1],["I373","VE","SANTO STINO DI LIVENZA",0],["I260","SA","SANTOMENNA",1],["I351","FR","SANTOPADRE",1],["I353","VI","SANTORSO",1],["I374","OR","SANTU LUSSURGIU",1],["I386","PL","SANVINCENTI",0],["I410","SA","SANZA",1],["I411","TN","SANZENO",1],["Z341","EE","SAO TOME' E PRINCIPE",0],["Z341","EE","SAO TOME' E PRINCIPE (ISOLE)",0],["I418","PD","SAONARA",1],["I419","TN","SAONE",0],["E221","PZ","SAPONARA",0],["I420","ME","SAPONARA",1],["E221","PZ","SAPONARA DI GRUMENTO",0],["I420","ME","SAPONARA VILLAFRANCA",0],["I421","BL","SAPPADA",0],["I421","UD","SAPPADA",1],["I422","SA","SAPRI",1],["I423","CS","SARACENA",1],["I424","RM","SARACINESCO",1],["I425","VI","SARCEDO",1],["I426","PZ","SARCONI",1],["I427","TN","SARDAGNA",0],["I428","CA","SARDARA",0],["I428","SU","SARDARA",1],["I429","AL","SARDIGLIANO",1],["I430","VI","SAREGO",1],["I431","BZ","SARENTINO",1],["I432","AL","SAREZZANO",1],["I433","BS","SAREZZO",1],["I434","PC","SARMATO",1],["I435","TV","SARMEDE",1],["I436","MC","SARNANO",1],["I437","BG","SARNICO",1],["I438","SA","SARNO",1],["I439","TN","SARNONICO",1],["I440","IM","SAROLA",0],["I441","VA","SARONNO",1],["I442","AO","SARRE",1],["I443","CA","SARROCH",1],["I444","FC","SARSINA",1],["I445","SI","SARTEANO",1],["I446","CO","SARTIRANA",0],["I447","PV","SARTIRANA",0],["I446","CO","SARTIRANA BRIANTEA",0],["I447","PV","SARTIRANA LOMELLINA",1],["I448","NU","SARULE",1],["I449","SP","SARZANA",1],["I450","AQ","SASSA",0],["I451","SA","SASSANO",1],["I452","SS","SASSARI",1],["I453","SV","SASSELLO",1],["I454","LI","SASSETTA",1],["I455","BN","SASSINORO",1],["C097","CE","SASSO",0],["I456","IM","SASSO",0],["I457","PZ","SASSO",0],["I458","TN","SASSO",0],["G972","BO","SASSO BOLOGNESE",0],["I456","IM","SASSO DI BORDIGHERA",0],["I457","PZ","SASSO DI CASTALDA",1],["G972","BO","SASSO MARCONI",1],["I459","PU","SASSOCORVARO",0],["M413","PU","SASSOCORVARO AUDITORE",1],["I460","PU","SASSOFELTRIO",1],["I461","AN","SASSOFERRATO",1],["I462","MO","SASSUOLO",1],["I463","CZ","SATRIANO",1],["G614","PZ","SATRIANO DI LUCANIA",1],["I464","UD","SAURIS",1],["I466","TO","SAUZE D'OULX",1],["I465","TO","SAUZE DI CESANA",1],["I467","TA","SAVA",1],["Z714","EE","SAVAGE (ISOLE)",0],["I468","KR","SAVELLI",1],["I469","NA","SAVIANO",1],["I470","CN","SAVIGLIANO",1],["I471","AV","SAVIGNANO",0],["I472","FC","SAVIGNANO",0],["I473","MO","SAVIGNANO",0],["M245","TN","SAVIGNANO",0],["I471","AV","SAVIGNANO DI PUGLIA",0],["I472","FC","SAVIGNANO DI ROMAGNA",0],["I471","AV","SAVIGNANO IRPINO",1],["I473","MO","SAVIGNANO SUL PANARO",1],["I472","FC","SAVIGNANO SUL RUBICONE",1],["I474","BO","SAVIGNO",0],["I475","GE","SAVIGNONE",1],["I476","BS","SAVIORE",0],["I476","BS","SAVIORE DELL'ADAMELLO",1],["I477","ME","SAVOCA",1],["I478","UD","SAVOGNA",1],["I479","UD","SAVOGNA",0],["I479","GO","SAVOGNA D'ISONZO",1],["H730","PZ","SAVOIA DI LUCANIA",1],["I480","SV","SAVONA",1],["I481","TO","SAVOULX",0],["I482","PE","SCAFA",1],["I483","SA","SCAFATI",1],["I484","CN","SCAGNELLO",1],["I485","CS","SCALA",0],["I486","SA","SCALA",1],["I485","CS","SCALA COELI",1],["I487","PV","SCALDASOLE",1],["I488","BZ","SCALE",0],["I489","CS","SCALEA",1],["I490","TO","SCALENGHE",1],["I488","BZ","SCALERES",0],["I491","CN","SCALETTA",0],["I492","ME","SCALETTA",0],["I491","CN","SCALETTA UZZONE",0],["I492","ME","SCALETTA ZANCLEA",1],["I493","AV","SCAMPITELLA",1],["I494","KR","SCANDALE",1],["I495","AT","SCANDELUZZA",0],["I496","RE","SCANDIANO",1],["B962","FI","SCANDICCI",1],["I497","CR","SCANDOLARA RAVARA",1],["I498","CR","SCANDOLARA RIPA D'OGLIO",1],["I499","RI","SCANDRIGLIA",1],["I500","CR","SCANNABUE",0],["I501","AQ","SCANNO",1],["I502","BG","SCANO",0],["I503","CA","SCANO",0],["I502","BG","SCANO AL BREMBO",0],["I503","OR","SCANO DI MONTIFERRO",1],["I503","NU","SCANO MONTIFERRO",0],["I504","GR","SCANSANO",1],["M256","MT","SCANZANO JONICO",1],["I505","BG","SCANZO",0],["I506","BG","SCANZOROSCIATE",1],["I507","IS","SCAPOLI",1],["I508","CO","SCARENNA",0],["I509","CO","SCARIA",0],["I510","GR","SCARLINO",1],["I511","TO","SCARMAGNO",1],["I512","CN","SCARNAFIGI",1],["I513","CN","SCARNAFIGI-RUFFIA",0],["C702","RM","SCARPA",0],["I514","FI","SCARPERIA",0],["M326","FI","SCARPERIA E SAN PIERO",1],["I515","BS","SCARPIZZOLO",0],["I516","BZ","SCAVES",0],["I517","PU","SCAVOLINO",0],["I519","BZ","SCENA",1],["I520","CH","SCERNI",1],["I521","PG","SCHEGGIA",0],["I522","PG","SCHEGGIA E PASCELUPO",1],["I523","PG","SCHEGGINO",1],["I524","GO","SCHERBINA",0],["I525","VA","SCHIANNO",0],["D682","FR","SCHIAVI",0],["I526","CH","SCHIAVI",0],["I526","CH","SCHIAVI DI ABRUZZO",1],["E570","CE","SCHIAVI DI FORMICOLA",0],["I527","VI","SCHIAVON",1],["I528","NO","SCHIERANCO",0],["I529","CO","SCHIGNANO",1],["I530","BG","SCHILPARIO",1],["I531","VI","SCHIO",1],["I532","MN","SCHIVENOGLIA",1],["I533","AG","SCIACCA",1],["I534","PA","SCIARA",1],["I516","BZ","SCIAVES",0],["I535","RG","SCICLI",1],["I536","RC","SCIDO",1],["D290","CS","SCIGLIANO",1],["I537","RC","SCILLA",1],["I538","PA","SCILLATO",1],["I539","TO","SCIOLZE",1],["I540","NA","SCISCIANO",1],["I541","PA","SCLAFANI",0],["I541","PA","SCLAFANI BAGNI",1],["I518","TN","SCLEMO",0],["I542","UD","SCODAVACCA",0],["I543","AQ","SCONTRONE",1],["I544","VC","SCOPA",1],["I545","VC","SCOPELLO",1],["I546","AQ","SCOPPITO",1],["I547","TS","SCOPPO",0],["I548","CT","SCORDIA",1],["I549","LE","SCORRANO",1],["I550","FC","SCORTICATA",0],["I551","VE","SCORZE'",1],["I552","GO","SCRILLA",0],["H658","RM","SCROFANO",0],["I553","AQ","SCURCOLA",0],["I553","AQ","SCURCOLA MARSICANA",1],["I554","TN","SCURELLE",1],["I555","AT","SCURZOLENGO",1],["M310","ZA","SEBENICO",0],["I556","IM","SEBORGA",1],["I557","GO","SEBREGLIE",0],["I558","AQ","SECINARO",1],["I559","LE","SECLI'",1],["I560","NA","SECONDIGLIANO",0],["I561","LO","SECUGNAGO",1],["I562","UD","SEDEGLIANO",1],["I563","BL","SEDICO",1],["I564","OR","SEDILO",1],["I565","SS","SEDINI",1],["I566","MI","SEDRIANO",1],["I567","BG","SEDRINA",1],["I568","GO","SEDULA",0],["I569","MC","SEFRO",1],["I570","CA","SEGARIU",0],["I570","SU","SEGARIU",1],["I571","GR","SEGGIANO",1],["I572","CO","SEGHEBBIA",0],["C842","UD","SEGNACCO",0],["E162","MI","SEGNANO",0],["I573","RM","SEGNI",1],["I574","SV","SEGNO",0],["I575","TN","SEGNO",0],["I576","TN","SEGONZANO",1],["I577","MI","SEGRATE",1],["I578","TV","SEGUSINO",1],["Z342","EE","SEICELLE",0],["Z342","EE","SEICELLE (ISOLE)",0],["I579","TN","SEIO",0],["I580","CA","SELARGIUS",1],["I581","RI","SELCI",1],["I582","CA","SELEGAS",0],["I582","SU","SELEGAS",1],["I583","BG","SELINO",0],["I584","GO","SELLA DELLE TRINCEE",0],["M360","TN","SELLA GIUDICARIE",1],["I585","PG","SELLANO",1],["I586","MI","SELLANUOVA",0],["I587","BG","SELLERE",0],["I588","BS","SELLERO",1],["I589","CZ","SELLIA",1],["I590","CZ","SELLIA MARINA",1],["I591","BZ","SELVA",0],["I592","BL","SELVA BELLUNESE",0],["I593","BZ","SELVA DEI MOLINI",1],["I592","BL","SELVA DI CADORE",1],["I594","VR","SELVA DI PROGNO",1],["I591","BZ","SELVA DI VAL GARDENA",1],["I591","BZ","SELVA IN GARDENA",0],["I595","PD","SELVAZZANO DENTRO",1],["I596","NO","SELVE",0],["I596","BI","SELVE MARCONE",0],["I597","BG","SELVINO",1],["I598","SS","SEMESTENE",1],["I599","PV","SEMIANA",1],["I600","RC","SEMINARA",1],["I601","GR","SEMPRONIANO",1],["I602","MI","SENAGO",1],["I603","BZ","SENALE",0],["I603","BZ","SENALE-SAN FELICE",1],["I604","BZ","SENALES",1],["I604","BZ","SENALES IN VENOSTA",0],["Z343","EE","SENEGAL",0],["I605","OR","SENEGHE",1],["I606","AV","SENERCHIA",1],["I607","BS","SENIGA",1],["I608","AN","SENIGALLIA",1],["I609","OR","SENIS",1],["I610","PZ","SENISE",1],["I611","CO","SENNA",0],["I612","MI","SENNA",0],["I611","CO","SENNA COMASCO",1],["I612","LO","SENNA LODIGIANA",1],["I613","OR","SENNARIOLO",1],["I614","SS","SENNORI",1],["I615","CA","SENORBI'",0],["I615","SU","SENORBI'",1],["I616","TS","SENOSECCHIA",0],["I617","TN","SEO",0],["I618","CB","SEPINO",1],["I619","VB","SEPPIANA",0],["I620","CO","SEPRIO",0],["I621","PN","SEQUALS",1],["I622","LU","SERAVEZZA",1],["I623","CA","SERBARIU",0],["Z158","EE","SERBIA",0],["Z118","EE","SERBIA E MONTENEGRO",0],["I624","CA","SERDIANA",0],["I624","SU","SERDIANA",1],["I625","MB","SEREGNO",1],["I625","MI","SEREGNO",0],["I626","BL","SEREN",0],["I626","BL","SEREN DEL GRAPPA",1],["I627","CR","SERGNANO",1],["I628","BG","SERIATE",1],["I629","BG","SERINA",1],["I630","AV","SERINO",1],["I631","BS","SERLE",1],["I632","MN","SERMIDE",0],["I632","MN","SERMIDE E FELONICA",1],["I633","BS","SERMIONE",0],["I634","LT","SERMONETA",1],["I635","TV","SERNAGLIA",0],["I635","TV","SERNAGLIA DELLA BATTAGLIA",1],["I636","SO","SERNIO",1],["I637","AT","SEROLE",1],["I638","GO","SERPENIZZA",0],["I639","CZ","SERRA",0],["I640","GE","SERRA",0],["I642","CS","SERRA D'AIELLO",1],["I643","AN","SERRA DE' CONTI",1],["I650","CS","SERRA PEDACE",0],["I640","GE","SERRA RICCO'",1],["I639","VV","SERRA SAN BRUNO",1],["I653","AN","SERRA SAN QUIRICO",1],["I654","PU","SERRA SANT'ABBONDIO",1],["I641","FG","SERRACAPRIOLA",1],["I644","CL","SERRADIFALCO",1],["I645","AL","SERRALUNGA",0],["I646","CN","SERRALUNGA CERESETO",0],["I646","CN","SERRALUNGA D'ALBA",1],["I645","AL","SERRALUNGA DI CREA",1],["I647","CA","SERRAMANNA",0],["I647","SU","SERRAMANNA",1],["F357","MO","SERRAMAZZONI",1],["I648","SA","SERRAMEZZANA",1],["I649","PE","SERRAMONACESCA",1],["I651","MC","SERRAPETRONA",1],["I652","NA","SERRARA FONTANA",1],["I655","CZ","SERRASTRETTA",1],["I656","RC","SERRATA",1],["C191","BO","SERRAVALLE",0],["I657","AL","SERRAVALLE",0],["I658","AL","SERRAVALLE",0],["I659","CN","SERRAVALLE",0],["I660","FI","SERRAVALLE",0],["I661","MC","SERRAVALLE",0],["I662","MN","SERRAVALLE",0],["I663","NO","SERRAVALLE",0],["I664","TV","SERRAVALLE",0],["I662","MN","SERRAVALLE A PO",1],["I665","TN","SERRAVALLE ALL'ADIGE",0],["I658","AT","SERRAVALLE D'ASTI",0],["I659","CN","SERRAVALLE DELLE LANGHE",0],["I661","MC","SERRAVALLE DI CHIENTI",1],["I659","CN","SERRAVALLE LANGHE",1],["I657","AL","SERRAVALLE LIBARNA",0],["I660","PT","SERRAVALLE PISTOIESE",1],["I657","AL","SERRAVALLE SCRIVIA",1],["I663","VC","SERRAVALLE SESIA",1],["I666","SA","SERRE",1],["I667","CA","SERRENTI",0],["I667","SU","SERRENTI",1],["I668","NU","SERRI",0],["I668","SU","SERRI",1],["I669","FR","SERRONE",1],["I670","PU","SERRUNGARINA",0],["I671","CZ","SERSALE",1],["I672","TN","SERSO",0],["C070","AP","SERVIGLIANO",0],["C070","FM","SERVIGLIANO",1],["I673","BL","SERVO",0],["I674","TS","SESANA",0],["I675","MI","SESONA",0],["I676","CE","SESSA",0],["I676","CE","SESSA AURUNCA",1],["I677","SA","SESSA CILENTO",1],["I678","AT","SESSAME",1],["I679","CB","SESSANO",0],["I679","IS","SESSANO DEL MOLISE",1],["I680","AL","SESSANT",0],["E070","SP","SESTA GODANO",1],["I681","AR","SESTINO",1],["I682","CB","SESTO",0],["I683","CR","SESTO",0],["I684","FI","SESTO",0],["I685","MI","SESTO",0],["I686","UD","SESTO",0],["I687","BZ","SESTO",1],["I686","PN","SESTO AL REGHENA",1],["I688","VA","SESTO CALENDE",1],["I682","IS","SESTO CAMPANO",1],["I683","CR","SESTO ED UNITI",1],["I684","FI","SESTO FIORENTINO",1],["I685","MI","SESTO PERGOLA",0],["I690","MI","SESTO SAN GIOVANNI",1],["I691","MI","SESTO ULTERIANO",0],["I689","MO","SESTOLA",1],["I693","GE","SESTRI LEVANTE",1],["I694","GE","SESTRI PONENTE",0],["I692","TO","SESTRIERE",1],["I692","TO","SESTRIERES",0],["I695","CA","SESTU",1],["I696","MI","SETTALA",1],["I697","FR","SETTEFRATI",1],["I698","AT","SETTIME",1],["I699","CA","SETTIMO",0],["I700","MI","SETTIMO",0],["I700","MI","SETTIMO MILANESE",1],["I701","TO","SETTIMO ROTTARO",1],["I699","CA","SETTIMO SAN PIETRO",1],["I702","TO","SETTIMO TAVAGNASCO",0],["I703","TO","SETTIMO TORINESE",1],["I702","TO","SETTIMO VITTONE",1],["I704","CZ","SETTINGIANO",1],["I705","CA","SETZU",0],["I705","SU","SETZU",1],["I706","NU","SEUI",0],["I706","SU","SEUI",1],["I707","NU","SEULO",0],["I707","SU","SEULO",1],["I708","CA","SEUNI",0],["I709","MB","SEVESO",1],["I709","MI","SEVESO",0],["I710","TN","SEVIGNANO",0],["I711","AL","SEZZADIO",1],["I712","LT","SEZZE",1],["I711","AL","SEZZE'",0],["I713","BG","SFORZATICA",0],["I714","TN","SFRUZ",1],["I715","TS","SGONICO",1],["I716","FR","SGURGOLA",1],["I717","OR","SIAMAGGIORE",1],["I718","OR","SIAMANNA",1],["I719","OR","SIAMANNA SIAPICCIA",0],["I720","SA","SIANO",1],["I721","OR","SIAPICCIA",1],["I722","CA","SICCI",0],["I722","CA","SICCI SAN BIAGIO",0],["M253","SA","SICIGNANO",0],["M253","SA","SICIGNANO DEGLI ALBURNI",1],["I723","AG","SICULIANA",1],["I724","CA","SIDDI",0],["I724","SU","SIDDI",1],["I725","RC","SIDERNO",1],["I726","SI","SIENA",1],["Z344","EE","SIERRA LEONE",0],["I727","PG","SIGILLO",1],["I728","FI","SIGNA",1],["Z239","EE","SIKKIM",0],["I729","BZ","SILANDRO",1],["I730","NU","SILANUS",1],["F116","TV","SILEA",1],["I731","CA","SILI",0],["I732","SS","SILIGO",1],["I734","CA","SILIQUA",0],["I734","SU","SILIQUA",1],["I735","CA","SILIUS",0],["I735","SU","SILIUS",1],["I736","NO","SILLA",0],["I737","LU","SILLANO",0],["M347","LU","SILLANO GIUNCUGNANO",1],["I736","NO","SILLAVENGO",1],["I733","PL","SILUM MONT'AQUILA",0],["I739","PV","SILVANO",0],["I738","AL","SILVANO D'ORBA",1],["I739","PV","SILVANO PIETRA",1],["I740","CR","SILVELLA",0],["I741","TE","SILVI",1],["I742","OR","SIMALA",1],["I743","OR","SIMAXIS",1],["I744","VV","SIMBARIO",1],["I745","CZ","SIMERI CRICHI",1],["I746","TS","SINADOLE",0],["I747","ME","SINAGRA",1],["A468","SI","SINALUNGA",1],["I748","NU","SINDIA",1],["Z248","EE","SINGAPORE",0],["I749","OR","SINI",1],["I750","CN","SINIO",1],["I751","NU","SINISCOLA",1],["I752","CA","SINNAI",1],["I753","RC","SINOPOLI",1],["I754","SR","SIRACUSA",1],["Z240","EE","SIRIA",0],["I755","NA","SIRICO",0],["I756","AV","SIRIGNANO",1],["I757","OR","SIRIS",1],["I633","BS","SIRMIONE",1],["I758","AN","SIROLO",1],["I759","LC","SIRONE",1],["I760","TN","SIROR",0],["I761","LC","SIRTORI",1],["I762","CA","SISINI",0],["I763","PR","SISSA",0],["M325","PR","SISSA TRECASALI",1],["I764","CA","SIURGUS",0],["I765","CA","SIURGUS DONIGALA",0],["I765","SU","SIURGUS DONIGALA",1],["I766","BS","SIVIANO",0],["E265","PV","SIZIANO",1],["I767","NO","SIZZANO",1],["I768","GO","SLAPPE-ZORZI",0],["I769","BZ","SLINGIA",0],["I769","BZ","SLINIGA",0],["I770","TS","SLIVIA",0],["I770","TS","SLIVNO",0],["Z155","EE","SLOVACCHIA",0],["Z150","EE","SLOVENIA",0],["I771","BZ","SLUDERNO",1],["I772","TN","SMARANO",0],["I773","FM","SMERIA",0],["I774","AP","SMERILLO",0],["I774","FM","SMERILLO",1],["I775","VR","SOAVE",1],["I776","NA","SOCCAVO",0],["I777","UD","SOCCHIEVE",1],["I778","OR","SODDI'",1],["I780","LE","SOGLIANO",0],["I779","FC","SOGLIANO AL RUBICONE",1],["I780","LE","SOGLIANO CAVOUR",1],["I781","AT","SOGLIO",1],["I782","BS","SOIANO DEL LAGO",1],["I783","VI","SOLAGNA",1],["I784","CA","SOLANAS",0],["I188","PA","SOLANTO",0],["I785","SR","SOLARINO",1],["I786","MI","SOLARO",1],["I787","RA","SOLAROLO",1],["I788","CR","SOLAROLO DEL PERSICO",0],["I789","CR","SOLAROLO MONASTEROLO",0],["I790","CR","SOLAROLO RAINERIO",1],["I791","OR","SOLARUSSA",1],["I792","CO","SOLBIATE",0],["I793","VA","SOLBIATE ARNO",1],["I793","VA","SOLBIATE ARNO E MONTE",0],["M412","CO","SOLBIATE CON CAGNO",1],["I794","VA","SOLBIATE OLONA",1],["I793","MI","SOLBIATE SULL'ARNO",0],["I795","AL","SOLBRITO",0],["I796","IM","SOLDANO",1],["I797","CA","SOLEMINIS",0],["I797","SU","SOLEMINIS",1],["I798","AL","SOLERO",1],["I799","PD","SOLESINO",1],["I800","LE","SOLETO",1],["I801","MN","SOLFERINO",1],["I802","MO","SOLIERA",1],["I803","PR","SOLIGNANO",1],["I804","AQ","SOLMONA",0],["I805","AV","SOLOFRA",1],["I806","NO","SOLOGNO",0],["I807","TO","SOLOMIAC",0],["I808","AL","SOLONGHELLO",1],["I809","BN","SOLOPACA",1],["I810","MI","SOLTARICO",0],["I811","BG","SOLTO",0],["I812","BG","SOLTO COLLINA",1],["I813","BG","SOLZA",1],["I814","CO","SOLZAGO",0],["I815","LO","SOMAGLIA",1],["Z345","EE","SOMALIA",0],["Z346","EE","SOMALIA FRANCESE",0],["I816","CO","SOMANA",0],["I817","CN","SOMANO",1],["B148","BG","SOMBRENO",0],["I818","BG","SOMENDENNA",0],["I819","MI","SOMMA",0],["I820","NA","SOMMA",0],["I819","VA","SOMMA LOMBARDO",1],["I820","NA","SOMMA VESUVIANA",1],["I821","VR","SOMMACAMPAGNA",1],["I822","CN","SOMMARIVA DEL BOSCO",1],["I823","CN","SOMMARIVA PERNO",1],["I824","CL","SOMMATINO",1],["I825","PV","SOMMO",1],["I826","VR","SONA",1],["I827","CR","SONCINO",1],["I828","SO","SONDALO",1],["I829","SO","SONDRIO",1],["I830","BG","SONGAVAZZO",1],["I831","BS","SONICO",1],["I832","LT","SONNINO",1],["I833","GO","SONZIA",0],["I834","TN","SOPRAMONTE",0],["I835","BI","SOPRANA",0],["I836","BS","SOPRAPONTE",0],["I837","BS","SOPRAZOCCO",0],["I838","FR","SORA",1],["I839","TN","SORAGA",0],["I839","TN","SORAGA DI FASSA",1],["I840","PR","SORAGNA",1],["I841","GR","SORANO",1],["I842","FC","SORBANO",0],["I843","AV","SORBO",0],["I844","CZ","SORBO",0],["I844","CZ","SORBO SAN BASILE",1],["I843","AV","SORBO SERPICO",1],["I845","PR","SORBOLO",0],["M411","PR","SORBOLO MEZZANI",1],["I846","PU","SORBOLONGO",0],["I847","BI","SORDEVOLO",1],["I848","LO","SORDIO",1],["I849","CR","SORESINA",1],["I850","VR","SORGA'",1],["I851","NU","SORGONO",1],["I852","GE","SORI",1],["I852","GE","SORI-CANEPA",0],["I853","VV","SORIANELLO",1],["I854","CZ","SORIANO",0],["I855","RM","SORIANO",0],["I854","VV","SORIANO CALABRO",1],["I855","VT","SORIANO NEL CIMINO",1],["I237","PV","SORIASCO",0],["I856","CO","SORICO",1],["I857","NO","SORISO",1],["I858","BG","SORISOLE",1],["I859","AL","SORLI",0],["I860","CO","SORMANO",1],["I861","OR","SORRADILE",1],["I862","NA","SORRENTO",1],["I863","SS","SORSO",1],["I864","SR","SORTINO",1],["I865","CR","SOSPIRO",1],["I866","BL","SOSPIROLO",1],["I867","VI","SOSSANO",1],["I868","BI","SOSTEGNO",1],["I869","BG","SOTTO IL MONTE",0],["I869","BG","SOTTO IL MONTE GIOVANNI XXIII",1],["I870","NO","SOVAZZA",0],["I871","TN","SOVER",1],["I872","CZ","SOVERATO",1],["I873","BG","SOVERE",1],["I874","CZ","SOVERIA MANNELLI",1],["I875","CZ","SOVERIA SIMERI",1],["I876","BL","SOVERZENE",1],["I877","SI","SOVICILLE",1],["I878","MB","SOVICO",1],["I878","MI","SOVICO",0],["I879","VI","SOVIZZO",1],["I673","BL","SOVRAMONTE",1],["I880","NO","SOZZAGO",1],["E366","RG","SPACCAFORNO",0],["I881","ME","SPADAFORA",1],["I882","ME","SPADAFORA SAN MARTINO",0],["I883","ME","SPADAFORA SAN PIETRO",0],["I884","VV","SPADOLA",1],["Z131","EE","SPAGNA",0],["I885","CE","SPARANISE",1],["I886","TO","SPARONE",1],["I887","LE","SPECCHIA",1],["I887","LE","SPECCHIA DE' PRETI",0],["I888","PG","SPELLO",1],["I889","TN","SPERA",0],["I890","TV","SPERCENIGO",0],["I891","EN","SPERLINGA",1],["I892","LT","SPERLONGA",1],["I893","AV","SPERONE",1],["I894","PV","SPESSA",1],["E463","SP","SPEZIA",0],["I895","CS","SPEZZANO ALBANESE",1],["I896","CS","SPEZZANO DELLA SILA",1],["I897","CS","SPEZZANO GRANDE",0],["I898","CS","SPEZZANO PICCOLO",0],["I899","TN","SPIAZZO",1],["I901","AL","SPIGNO",0],["I902","RM","SPIGNO",0],["I901","AL","SPIGNO MONFERRATO",1],["I902","LT","SPIGNO SATURNIA",1],["I903","MO","SPILAMBERTO",1],["I904","PN","SPILIMBERGO",1],["I905","VV","SPILINGA",1],["I906","CR","SPINADESCO",1],["I907","BA","SPINAZZOLA",0],["I907","BT","SPINAZZOLA",1],["I908","VE","SPINEA",1],["I909","CR","SPINEDA",1],["I910","CB","SPINETE",1],["I911","AL","SPINETO",0],["I911","AL","SPINETO SCRIVIA",1],["I912","AP","SPINETOLI",1],["I900","BZ","SPINGA",0],["I913","BG","SPINO",0],["I914","CR","SPINO",0],["I913","BG","SPINO AL BREMBO",0],["I914","CR","SPINO D'ADDA",1],["I915","BG","SPINONE",0],["I916","BG","SPINONE AL LAGO",1],["I916","BG","SPINONE DEI CASTELLI",0],["I917","PZ","SPINOSO",1],["I918","PV","SPIRAGO",0],["I919","BG","SPIRANO",1],["I920","NO","SPOCCIA",0],["I921","PG","SPOLETO",1],["I922","PE","SPOLTORE",1],["I923","LE","SPONGANO",1],["I924","TN","SPORMAGGIORE",1],["I925","TN","SPORMINORE",1],["I926","SV","SPOTORNO",1],["I927","TV","SPRESIANO",1],["I928","SO","SPRIANA",1],["I929","CZ","SQUILLACE",1],["I930","LE","SQUINZANO",1],["Z209","EE","SRI LANKA",0],["I931","BG","STABELLO",0],["D475","RM","STABIA",0],["I932","AN","STAFFOLO",1],["I933","PV","STAGHIGLIONE",0],["I934","GE","STAGLIENO",0],["I935","CR","STAGNO LOMBARDO",1],["I935","CR","STAGNO PAGLIARO",0],["I936","RC","STAITI",1],["I937","CZ","STALETTI",0],["I937","CZ","STALETTI'",1],["I938","PD","STANGHELLA",1],["I939","GO","STARANZANO",1],["Z404","EE","STATI UNITI D'AMERICA",0],["M298","TA","STATTE",1],["I940","BZ","STAVA",0],["I940","BZ","STAVE",0],["I941","AL","STAZZANO",1],["I942","LU","STAZZEMA",1],["I943","CO","STAZZONA",1],["I944","CO","STAZZONA-GERMASINO",0],["I945","VV","STEFANACONI",1],["I946","SV","STELLA",1],["G887","SA","STELLA CILENTO",1],["I947","SV","STELLANELLO",1],["I948","BZ","STELVIO",1],["I949","TN","STENICO",1],["I950","LE","STERNATIA",1],["I951","BG","STEZZANO",1],["I952","AR","STIA",0],["I953","RO","STIENTA",1],["I954","MT","STIGLIANO",1],["I955","RC","STIGNANO",1],["I956","RC","STILO",1],["I957","CR","STILO DE' MARIANI",0],["I958","BZ","STILVES",0],["I959","RI","STIMIGLIANO",1],["M290","SS","STINTINO",1],["I960","SA","STIO",1],["I961","TS","STORIE",0],["I962","FG","STORNARA",1],["I963","FG","STORNARELLA",1],["I964","TN","STORO",1],["I965","VE","STRA",1],["I966","CR","STRACONDOLO",0],["I967","TN","STRADA",0],["I968","PV","STRADELLA",1],["I969","TO","STRAMBINELLO",1],["I970","TO","STRAMBINO",1],["I971","AO","STRAMBINO ROMANO",0],["I972","TN","STRAMENTIZZO",0],["I973","FR","STRANGOLAGALLI",1],["M246","TN","STRAVINO",0],["I974","UD","STREGNA",1],["I975","TN","STREMBO",1],["I976","VB","STRESA",1],["I976","NO","STRESA BORROMEO",0],["I977","AL","STREVI",1],["I978","NA","STRIANO",1],["I979","TN","STRIGNO",0],["I980","BI","STRONA",1],["I981","TR","STRONCONE",1],["I982","KR","STRONGOLI",1],["I983","NO","STROPINO",0],["I984","VC","STROPPIANA",1],["I985","CN","STROPPO",1],["I986","BG","STROZZA",1],["I987","GE","STRUPPA",0],["I988","TN","STUMIAGA",0],["I989","GO","STURIA DELLE FUSINE",0],["I990","AV","STURNO",1],["B014","PV","SUARDI",1],["I991","AR","SUBBIANO",1],["I992","RM","SUBIACO",1],["I993","CE","SUCCIVO",1],["Z907","EE","SUD SUDAN",0],["Z347","EE","SUDAFRICANA REPUBBLICA",0],["Z348","EE","SUDAN",0],["I994","LC","SUEGLIO",1],["I995","CA","SUELLI",0],["I995","SU","SUELLI",1],["I996","LC","SUELLO",1],["I997","BG","SUISIO",1],["I998","MB","SULBIATE",1],["I998","MI","SULBIATE",0],["I999","MI","SULBIATE INFERIORE",0],["L001","MI","SULBIATE SUPERIORE",0],["I804","AQ","SULMONA",1],["L002","BS","SULZANO",1],["L003","VA","SUMIRAGO",1],["L004","AV","SUMMONTE",1],["L005","NO","SUNA",0],["L006","NU","SUNI",0],["L006","OR","SUNI",1],["L007","NO","SUNO",1],["L008","LE","SUPERSANO",1],["L009","FR","SUPINO",1],["L010","LE","SURANO",1],["L011","LE","SURBO",1],["Z608","EE","SURINAME",0],["L013","TO","SUSA",1],["L012","TN","SUSA'",0],["L014","TV","SUSEGANA",1],["L015","MN","SUSTINENTE",1],["L016","CL","SUTERA",1],["L017","VT","SUTRI",1],["L018","UD","SUTRIO",1],["L019","LI","SUVERETO",1],["L020","MN","SUZZARA",1],["Z132","EE","SVEZIA",0],["Z133","EE","SVIZZERA",0],["Z349","EE","SWAZILAND",0],["Z349","EE","SWAZILAND-SUDAFRICA BRITANNICO",0],["L021","BZ","TABLA'",0],["L022","LC","TACENO",1],["L023","OR","TADASUNI",1],["L024","IM","TAGGIA",1],["Z147","EE","TAGIKISTAN",0],["Z257","EE","TAGIKISTAN",0],["L025","AQ","TAGLIACOZZO",1],["L026","RO","TAGLIO DI PO",1],["G926","RO","TAGLIO DI PORTO VIRO",0],["L027","AL","TAGLIOLO",0],["L027","AL","TAGLIOLO MONFERRATO",1],["L028","AL","TAGLIOLO-BELFORTE",0],["L029","BG","TAGLIUNO",0],["L030","BL","TAIBON",0],["L030","BL","TAIBON AGORDINO",1],["L031","MI","TAINATE",0],["L032","VA","TAINO",1],["L033","TN","TAIO",0],["G736","UD","TAIPANA",1],["Z217","EE","TAIWAN",0],["Z217","EE","TAIWAN ( REPUBBLICA DELLA CINA NAZIONALE )",0],["L034","PU","TALAMELLO",0],["L034","RN","TALAMELLO",1],["L035","SO","TALAMONA",1],["L036","NU","TALANA",1],["L037","BG","TALEGGIO",1],["L038","AR","TALLA",1],["L039","UD","TALMASSONS",1],["L040","BL","TAMBRE",1],["L041","BZ","TANAS",0],["Z350","EE","TANGANICA",0],["Z357","EE","TANZANIA",0],["L042","ME","TAORMINA",1],["L043","NO","TAPIGLIANO",0],["L044","UD","TAPOGLIANO",0],["L045","NO","TAPPIA",0],["L046","RI","TARANO",1],["L047","CH","TARANTA",0],["L047","CH","TARANTA PELIGNA",1],["L048","CN","TARANTASCA",1],["L049","TA","TARANTO",1],["L050","UD","TARCENTO",1],["L051","BZ","TARCES",0],["L052","UD","TARCETTA",0],["L053","GO","TARNOVA DELLA SELVA",0],["D024","VT","TARQUINIA",1],["L054","BZ","TARRES",0],["L051","BZ","TARRES DI SOPRA",0],["L054","BZ","TARRES DI SOTTO",0],["L055","CS","TARSIA",1],["L056","SO","TARTANO",1],["L057","UD","TARVISIO",1],["L058","TV","TARZO",1],["L059","AL","TASSAROLO",1],["L060","TN","TASSULLO",0],["L061","AV","TAURANO",1],["L062","AV","TAURASI",1],["L063","RC","TAURIANOVA",1],["L064","LE","TAURISANO",1],["L065","UD","TAVAGNACCO",1],["L066","TO","TAVAGNASCO",1],["L067","FI","TAVARNELLE",0],["L067","FI","TAVARNELLE VAL DI PESA",0],["L068","MI","TAVAZZANO",0],["F260","LO","TAVAZZANO CON VILLAVESCO",1],["L069","CB","TAVENNA",1],["L070","CZ","TAVERNA",1],["L071","CO","TAVERNERIO",1],["G033","TO","TAVERNETTE",0],["E187","BO","TAVERNOLA",0],["L072","AV","TAVERNOLA",0],["L073","BG","TAVERNOLA",0],["L073","BG","TAVERNOLA BERGAMASCA",1],["E187","BO","TAVERNOLA RENO",0],["L072","AV","TAVERNOLA SAN FELICE",0],["C698","BS","TAVERNOLE SUL MELLA",1],["C698","BS","TAVERNOLE-CIMMO",0],["L074","LE","TAVIANO",1],["L075","BI","TAVIGLIANO",1],["L076","TN","TAVODO",0],["L077","IM","TAVOLE",0],["L078","PU","TAVOLETO",1],["L079","TN","TAVON",0],["L080","CO","TAVORDO",0],["L081","PU","TAVULLIA",1],["L082","PZ","TEANA",1],["L083","CE","TEANO",1],["D292","SA","TEGGIANO",1],["L084","SO","TEGLIO",1],["L085","VE","TEGLIO",0],["L085","VE","TEGLIO VENETO",1],["H197","CO","TEGNONE",0],["L086","BN","TELESE",0],["L086","BN","TELESE TERME",1],["L087","BG","TELGATE",1],["L088","SS","TELTI",1],["L089","TN","TELVE",1],["L090","TN","TELVE DI SOPRA",1],["L091","BZ","TELVES",0],["L092","GO","TEMENIZZA",0],["L093","SS","TEMPIO PAUSANIA",1],["L094","BS","TEMU'",1],["L095","CN","TENDA",0],["L096","TN","TENNA",1],["L097","TN","TENNO",1],["L098","BZ","TEODONA",0],["L098","BZ","TEODONE",0],["L099","FC","TEODORANO",0],["L100","PD","TEOLO",1],["L101","UD","TEOR",0],["L102","AV","TEORA",1],["L103","TE","TERAMO",1],["L104","NO","TERDOBBIATE",1],["L105","FR","TERELLE",1],["L106","BZ","TERENTO",1],["E548","PR","TERENZO",1],["M282","SS","TERGU",1],["L107","TN","TERLAGO",0],["L108","BZ","TERLANO",1],["L109","BA","TERLIZZI",1],["M210","ME","TERME VIGLIATORE",1],["L110","TN","TERMENAGO",0],["L111","BZ","TERMENO",0],["L111","BZ","TERMENO SULLA STRADA DEL VINO",1],["L112","PA","TERMINI",0],["L112","PA","TERMINI IMERESE",1],["L113","CB","TERMOLI",1],["L114","TN","TERMON",0],["L115","VA","TERNATE",1],["L116","BI","TERNENGO",1],["L117","TR","TERNI",1],["L118","BG","TERNO",0],["L118","BG","TERNO D'ISOLA",1],["L119","GO","TERNOVA D'ISONZO",0],["C339","FC","TERRA DEL SOLE",0],["C339","FC","TERRA DEL SOLE E CASTROCARO",0],["L120","LT","TERRACINA",1],["L121","TN","TERRAGNOLO",1],["L122","OR","TERRALBA",1],["D960","CL","TERRANOVA",0],["G015","SS","TERRANOVA",0],["L123","AR","TERRANOVA",0],["L124","CS","TERRANOVA",0],["L125","MI","TERRANOVA",0],["L126","PZ","TERRANOVA",0],["L127","RC","TERRANOVA",0],["L124","CS","TERRANOVA DA SIBARI",1],["L125","LO","TERRANOVA DEI PASSERINI",1],["L128","FM","TERRANOVA DI BISTERZA",0],["L126","PZ","TERRANOVA DI POLLINO",1],["D960","CL","TERRANOVA DI SICILIA",0],["G015","SS","TERRANOVA PAUSANIA",0],["L127","RC","TERRANOVA SAPPO MINULIO",1],["L123","AR","TERRANUOVA BRACCIOLINI",1],["L129","MS","TERRAROSSA",0],["L130","PV","TERRASA",0],["L131","PA","TERRASINI",1],["L131","PA","TERRASINI FAVAROTTA",0],["L132","PD","TERRASSA",0],["L132","PD","TERRASSA PADOVANA",1],["L133","CS","TERRATI",0],["L134","CS","TERRAVECCHIA",1],["L135","MI","TERRAZZANO",0],["L136","VR","TERRAZZO",1],["M407","TN","TERRE D'ADIGE",1],["M381","FE","TERRE DEL RENO",1],["M379","PU","TERRE ROVERESCHE",1],["L137","TN","TERRES",0],["L138","PI","TERRICCIOLA",1],["Z161","EE","TERRITORI PALESTINESI",0],["Z346","EE","TERRITORIO FRANCESE DEGLI AFAR E DEGLI ISSA",0],["L139","AL","TERRUGGIA",1],["L140","NU","TERTENIA",1],["L141","BS","TERZANO",0],["L142","NA","TERZIGNO",1],["L143","AL","TERZO",1],["L144","UD","TERZO",0],["L144","UD","TERZO D'AQUILEIA",1],["L144","UD","TERZO DI AQUILEIA",0],["L145","TN","TERZOLAS",1],["L146","IM","TERZORIO",1],["L147","TN","TESERO",1],["L148","BZ","TESIDO",0],["L149","BZ","TESIMO",1],["L150","VT","TESSENNANO",1],["L151","NA","TESTACCIO",0],["L151","NA","TESTACCIO D'ISCHIA",0],["L152","SV","TESTICO",1],["L153","NU","TETI",1],["L154","CA","TEULADA",0],["L154","SU","TEULADA",1],["L155","CE","TEVEROLA",1],["L156","VI","TEZZE",0],["L156","VI","TEZZE SUL BRENTA",1],["Z241","EE","THAILANDIA",0],["L157","VI","THIENE",1],["L158","SS","THIESI",1],["L159","TO","THURES",0],["L160","NU","TIANA",1],["L161","TN","TIARNO",0],["L162","TN","TIARNO DI SOPRA",0],["L163","TN","TIARNO DI SOTTO",0],["L164","CR","TICENGO",1],["L165","AL","TICINETO",1],["L166","LE","TIGGIANO",1],["L167","GE","TIGLIETO",1],["L168","AT","TIGLIOLE",1],["L169","BS","TIGNALE",1],["M247","TN","TIGNERONE",0],["L170","BS","TIMOLINE",0],["Z242","EE","TIMOR (ISOLA)",0],["L171","TO","TINA",0],["L172","NU","TINNURA",0],["L172","OR","TINNURA",1],["L173","AQ","TIONE",0],["L174","TN","TIONE",0],["L173","AQ","TIONE DEGLI ABRUZZI",1],["L174","TN","TIONE DI TRENTO",1],["L175","SO","TIRANO",1],["L176","BZ","TIRES",1],["L177","CZ","TIRIOLO",1],["L178","BZ","TIROLO",1],["L179","BZ","TISA",0],["L179","BZ","TISO",0],["L180","SS","TISSI",1],["L181","PZ","TITO",1],["L182","RM","TIVOLI",1],["H109","PT","TIZZANA",0],["L183","PR","TIZZANO",0],["L183","PR","TIZZANO VAL PARMA",1],["L184","RE","TOANO",1],["L185","BN","TOCCO",0],["L186","CH","TOCCO",0],["L185","BN","TOCCO CAUDIO",1],["L186","PE","TOCCO DA CASAURIA",1],["L187","VB","TOCENO",1],["L188","PG","TODI",1],["L189","RI","TOFFIA",1],["Z351","EE","TOGO",0],["L190","SV","TOIRANO",1],["Z727","EE","TOKELAU=ISOLE DELL'UNIONE",0],["L191","MC","TOLENTINO",1],["L192","RM","TOLFA",1],["L193","BI","TOLLEGNO",1],["L194","CH","TOLLO",1],["L195","UD","TOLMEZZO",1],["L196","GO","TOLMINO",0],["L197","PZ","TOLVE",1],["L198","TS","TOMADIO",0],["L081","PU","TOMBA DI PESARO",0],["C071","AN","TOMBA DI SENIGALLIA",0],["L199","PD","TOMBOLO",1],["L200","TN","TON",1],["L201","TN","TONADICO",0],["L202","NU","TONARA",1],["L203","AT","TONCO",1],["L204","AT","TONENGO",1],["D717","VI","TONEZZA",0],["D717","VI","TONEZZA DEL CIMONE",1],["Z728","EE","TONGA",0],["Z728","EE","TONGA=ISOLE DEGLI AMICI",0],["L205","CE","TORA E PICCILLI",1],["L206","CS","TORANO",0],["L207","TE","TORANO",0],["L206","CS","TORANO CASTELLO",1],["L207","TE","TORANO NUOVO",1],["L208","VA","TORBA",0],["L209","BS","TORBIATO",0],["L210","BS","TORBOLE",0],["L210","BS","TORBOLE CASAGLIA",1],["L211","TN","TORCEGNO",1],["L212","SA","TORCHIARA",1],["L213","BR","TORCHIAROLO",1],["L214","AV","TORELLA",0],["L215","CB","TORELLA",0],["L214","AV","TORELLA DEI LOMBARDI",1],["L215","CB","TORELLA DEL SANNIO",1],["L216","PG","TORGIANO",1],["L217","AO","TORGNON",1],["L217","AO","TORGNONE",0],["L218","CH","TORINO",0],["L219","TO","TORINO",1],["L218","CH","TORINO DI SANGRO",1],["L220","BA","TORITTO",1],["L221","CR","TORLINO",0],["L221","CR","TORLINO VIMERCATI",1],["L222","MI","TORMO",0],["L223","NO","TORNACO",1],["L224","CH","TORNARECCIO",1],["L225","CR","TORNATA",1],["L226","MI","TORNAVENTO",0],["L227","AQ","TORNIMPARTE",1],["L228","CO","TORNO",1],["L229","PR","TORNOLO",1],["L230","CB","TORO",1],["L231","NU","TORPE'",1],["L232","TN","TORRA",0],["L233","SA","TORRACA",1],["L234","PV","TORRADELLO",0],["L235","SS","TORRALBA",1],["L236","IM","TORRAZZA",0],["L237","PV","TORRAZZA COSTE",1],["L238","TO","TORRAZZA PIEMONTE",1],["L239","BI","TORRAZZO",1],["L240","CZ","TORRE",0],["L241","CN","TORRE",0],["L242","PU","TORRE",0],["L243","RM","TORRE",0],["L244","SO","TORRE",0],["L245","NA","TORRE ANNUNZIATA",1],["L247","TO","TORRE BAIRO",0],["L249","PV","TORRE BERETTI",0],["L250","PV","TORRE BERETTI E CASTELLARO",1],["L251","BG","TORRE BOLDONE",1],["L252","CN","TORRE BORMIDA",1],["L243","FR","TORRE CAJETANI",1],["L247","TO","TORRE CANAVESE",1],["L255","CR","TORRE D'ANGIOLINI",0],["L256","PV","TORRE D'ARESE",1],["L269","PV","TORRE D'ISOLA",1],["L257","BG","TORRE DE' BUSI",1],["L257","LC","TORRE DE' BUSI",0],["L262","PV","TORRE DE' NEGRI",1],["L263","PE","TORRE DE' PASSERI",1],["L258","CR","TORRE DE' PICENARDI",1],["L264","AL","TORRE DE' RATTI",0],["L265","BG","TORRE DE' ROVERI",1],["L266","PV","TORRE DE' TORTI",0],["L258","CR","TORRE DEI MALAMBERTI",0],["L259","NA","TORRE DEL GRECO",1],["L260","PV","TORRE DEL MANGANO",0],["L261","PV","TORRE DEL MONTE",0],["L267","VE","TORRE DI MOSTO",1],["L268","AP","TORRE DI PALME",0],["L240","CZ","TORRE DI RUGGIERO",1],["L244","SO","TORRE DI SANTA MARIA",1],["L272","AV","TORRE LE NOCELLE",1],["L241","CN","TORRE MONDOVI'",1],["L274","SA","TORRE ORSAIA",1],["L275","TR","TORRE ORSINA",0],["L276","BG","TORRE PALLAVICINA",1],["L277","TO","TORRE PELLICE",1],["L278","CN","TORRE SAN GIORGIO",1],["L242","PU","TORRE SAN MARCO",0],["L279","AP","TORRE SAN PATRIZIO",0],["L279","FM","TORRE SAN PATRIZIO",1],["L280","BR","TORRE SANTA SUSANNA",1],["L283","CN","TORRE UZZONE",0],["L285","PV","TORRE VECCHIA",0],["L246","UD","TORREANO",1],["L248","VI","TORREBELVICINO",1],["L253","CH","TORREBRUNA",1],["L254","BN","TORRECUSO",1],["L270","PD","TORREGLIA",1],["L271","ME","TORREGROTTA",1],["L273","FG","TORREMAGGIORE",1],["M286","ME","TORRENOVA",1],["L281","CN","TORRESINA",1],["L282","PA","TORRETTA",1],["L284","CH","TORREVECCHIA",0],["L285","PV","TORREVECCHIA PIA",1],["L284","CH","TORREVECCHIA TEATINA",1],["L286","RI","TORRI",0],["L287","VR","TORRI",0],["L287","VR","TORRI DEL BENACO",1],["L297","VI","TORRI DI QUARTESOLO",1],["L286","RI","TORRI IN SABINA",1],["L288","IM","TORRIA",0],["I550","RN","TORRIANA",0],["L289","PV","TORRIANO",0],["L290","FR","TORRICE",1],["L281","CN","TORRICELLA",0],["L291","CH","TORRICELLA",0],["L292","PV","TORRICELLA",0],["L293","RI","TORRICELLA",0],["L294","TA","TORRICELLA",1],["L295","TE","TORRICELLA",0],["L296","CR","TORRICELLA DEL PIZZO",1],["L293","RI","TORRICELLA IN SABINA",1],["L291","CH","TORRICELLA PELIGNA",1],["L295","TE","TORRICELLA SICURA",1],["L292","PV","TORRICELLA VERZATE",1],["L298","GE","TORRIGLIA",1],["L299","PR","TORRILE",1],["L300","PV","TORRINO",0],["L301","AV","TORRIONI",1],["L302","RM","TORRITA",0],["L303","SI","TORRITA",0],["L303","SI","TORRITA DI SIENA",1],["L302","RM","TORRITA TIBERINA",1],["A355","NU","TORTOLI'",1],["L304","AL","TORTONA",1],["L305","CS","TORTORA",1],["L306","SA","TORTORELLA",1],["L307","TE","TORTORETO",1],["L308","ME","TORTORICI",1],["L309","UD","TORVISCOSA",1],["L310","RM","TOSCANELLA",0],["L311","BS","TOSCOLANO",0],["L312","BS","TOSCOLANO-MADERNO",1],["L313","TN","TOSS",0],["L314","TE","TOSSICIA",1],["B044","BO","TOSSIGNANO",0],["L315","GE","TOVO",0],["L316","SO","TOVO",0],["L316","SO","TOVO DI SANT'AGATA",1],["L315","SV","TOVO SAN GIACOMO",1],["L317","PA","TRABIA",1],["L318","BG","TRABUCHELLO",0],["L319","VA","TRADATE",1],["F224","CE","TRAETTO",0],["L320","NO","TRAFFIUME",0],["L321","OR","TRAMATZA",1],["L322","TN","TRAMBILENO",1],["L322","TN","TRAMBILLENO",0],["L323","SA","TRAMONTI",1],["L324","PN","TRAMONTI DI SOPRA",1],["L325","PN","TRAMONTI DI SOTTO",1],["L326","PZ","TRAMUTOLA",1],["L327","TO","TRANA",1],["L328","BA","TRANI",0],["L328","BT","TRANI",1],["L329","TN","TRANSACQUA",0],["Z365","EE","TRANSKEI",0],["L330","SO","TRAONA",1],["L331","TP","TRAPANI",1],["L332","PA","TRAPPETO",1],["L333","NO","TRAREGO",0],["L333","VB","TRAREGO VIGGIONA",1],["L334","AQ","TRASACCO",1],["L335","UD","TRASAGHIS",1],["L336","VB","TRASQUERA",1],["D449","LU","TRASSILICO",0],["L337","CA","TRATALIAS",0],["L337","SU","TRATALIAS",1],["L338","TO","TRAUSELLA",0],["I236","PV","TRAVACO' SICCOMARIO",1],["L339","BS","TRAVAGLIATO",1],["L340","TO","TRAVE",0],["L341","VA","TRAVEDONA",0],["L342","VA","TRAVEDONA-MONATE",1],["L343","CO","TRAVERSA",0],["L344","TO","TRAVERSE",0],["L345","TO","TRAVERSELLA",1],["L346","PR","TRAVERSETOLO",1],["L340","TO","TRAVES",1],["L347","PN","TRAVESIO",1],["L348","PC","TRAVO",1],["M361","TN","TRE VILLE",1],["L349","PD","TREBASELEGHE",1],["L350","PV","TREBBIANO",0],["L350","PV","TREBBIANO NIZZA",0],["L351","PC","TREBECCO",0],["L352","GE","TREBIANO",0],["L352","GE","TREBIANO MAGRA",0],["L353","CS","TREBISACCE",1],["L354","PR","TRECASALI",0],["M280","NA","TRECASE",1],["L355","CT","TRECASTAGNI",1],["M318","AN","TRECASTELLI",1],["L356","NO","TRECATE",1],["L357","PZ","TRECCHINA",1],["L358","MI","TRECELLA",0],["L359","RO","TRECENTA",1],["L360","CR","TREDOSSI",0],["L361","FC","TREDOZIO",1],["L362","MI","TREGASIO",0],["L363","CH","TREGLIO",1],["L364","VR","TREGNAGO",1],["L365","CO","TREGOLO",0],["L366","MC","TREIA",1],["L367","CN","TREISO",1],["L368","LC","TREMENICO",0],["L369","CT","TREMESTIERI",0],["L369","CT","TREMESTIERI ETNEO",1],["L370","CO","TREMEZZINA",0],["M341","CO","TREMEZZINA",1],["L371","CO","TREMEZZO",0],["L372","BS","TREMOSINE",0],["L372","BS","TREMOSINE SUL GARDA",1],["L373","MI","TRENNO",0],["L374","BZ","TRENS",0],["L375","CS","TRENTA",0],["L376","GO","TRENTA D'ISONZO",0],["L377","SA","TRENTINARA",1],["L378","TN","TRENTO",1],["L379","CE","TRENTOLA",0],["L379","CE","TRENTOLA DUCENTA",1],["L380","BS","TRENZANO",1],["L381","UD","TREPPO",0],["L381","UD","TREPPO CARNICO",0],["L382","UD","TREPPO GRANDE",1],["M399","UD","TREPPO LIGOSULLO",1],["L383","LE","TREPUZZI",1],["L384","SI","TREQUANDA",1],["L385","TN","TRES",0],["L386","MS","TRESANA",1],["L387","VI","TRESCHE-CONCA",0],["L388","BG","TRESCORE",0],["L389","CR","TRESCORE",0],["L388","BG","TRESCORE BALNEARIO",1],["L389","CR","TRESCORE CREMASCO",1],["L390","FE","TRESIGALLO",0],["M409","FE","TRESIGNANA",1],["L391","RC","TRESILICO",0],["L392","SO","TRESIVIO",1],["L393","OR","TRESNURAGHES",1],["L394","VI","TRETTO",0],["L395","CO","TREVANO",0],["L396","VR","TREVENZUOLO",1],["L397","PG","TREVI",1],["L398","RM","TREVI",0],["L398","FR","TREVI NEL LAZIO",1],["L399","AV","TREVICO",1],["L400","BG","TREVIGLIO",1],["L401","RM","TREVIGNANO",0],["L402","TV","TREVIGNANO",1],["L401","RM","TREVIGNANO ROMANO",1],["L403","AL","TREVILLE",1],["L404","BG","TREVIOLO",1],["L405","VA","TREVISAGO",0],["L406","BS","TREVISO",0],["L407","TV","TREVISO",1],["L406","BS","TREVISO BRESCIANO",1],["L408","MI","TREZZANO",0],["L409","MI","TREZZANO",0],["L408","MI","TREZZANO ROSA",1],["L409","MI","TREZZANO SUL NAVIGLIO",1],["L410","CN","TREZZO",0],["L411","MI","TREZZO",0],["L411","MI","TREZZO SULL'ADDA",1],["L410","CN","TREZZO TINELLA",1],["L412","CR","TREZZOLASCO",0],["L413","CO","TREZZONE",1],["L414","PD","TRIBANO",1],["L415","MI","TRIBIANO",1],["L416","GE","TRIBOGNA",1],["A147","CR","TRIBURGO",0],["L417","GO","TRIBUSSA",0],["L418","MT","TRICARICO",1],["L419","LE","TRICASE",1],["L420","VC","TRICERRO",1],["L421","UD","TRICESIMO",1],["L422","BL","TRICHIANA",0],["L423","NU","TRIEI",1],["L424","TS","TRIESTE",1],["L425","BA","TRIGGIANO",1],["L426","CR","TRIGOLO",1],["Z612","EE","TRINIDAD E TOBAGO",0],["L427","CN","TRINITA'",1],["L428","SS","TRINITA' D'AGULTU E VIGNOLA",1],["B915","BT","TRINITAPOLI",1],["B915","FG","TRINITAPOLI",0],["L429","VC","TRINO",1],["L429","VC","TRINO VERCELLESE",0],["L430","IM","TRIORA",1],["L431","ME","TRIPI",1],["L432","AL","TRISOBBIO",1],["L433","VI","TRISSINO",1],["L434","MB","TRIUGGIO",1],["L434","MI","TRIUGGIO",0],["L435","CB","TRIVENTO",1],["L436","BI","TRIVERO",0],["L437","FR","TRIVIGLIANO",1],["L438","UD","TRIVIGNANO UDINESE",1],["L439","PZ","TRIVIGNO",1],["L440","PV","TRIVOLZIO",1],["L441","MI","TRIVULZA",0],["L442","MI","TRIVULZINA",0],["L443","NO","TROBASO",0],["L444","BZ","TRODENA",0],["L444","BZ","TRODENA NEL PARCO NATURALE",1],["L445","TO","TROFARELLO",1],["L446","PV","TROGNANO",0],["L447","FG","TROIA",1],["L448","EN","TROINA",1],["L449","PV","TROMELLO",1],["L450","VB","TRONTANO",1],["A705","CO","TRONZANO",0],["L451","NO","TRONZANO",0],["A705","VA","TRONZANO LAGO MAGGIORE",1],["L451","VC","TRONZANO VERCELLESE",1],["L452","VV","TROPEA",1],["L453","PV","TROVO",1],["L454","MI","TRUCCAZZANO",1],["L455","BZ","TUBRE",1],["L456","TN","TUENETTO",0],["L457","TN","TUENNO",0],["L458","CB","TUFARA",1],["L459","CH","TUFILLO",1],["L460","NA","TUFINO",1],["L461","AV","TUFO",1],["L462","LE","TUGLIE",1],["L463","CA","TUILI",0],["L463","SU","TUILI",1],["L464","SS","TULA",1],["L465","BZ","TUNES",0],["Z352","EE","TUNISIA",0],["L466","PG","TUORO",0],["L466","PG","TUORO SUL TRASIMENO",1],["L467","PV","TURAGO BORDONE",0],["G507","RI","TURANIA",1],["L468","BS","TURANO",0],["L469","MI","TURANO",0],["L469","LO","TURANO LODIGIANO",1],["L470","CO","TURATE",1],["L471","MI","TURBIGO",1],["Z243","EE","TURCHIA",0],["L472","BA","TURI",1],["Z151","EE","TURKMENISTAN",0],["Z258","EE","TURKMENISTAN",0],["Z519","EE","TURKS E CAICOS (ISOLE)",0],["L473","CA","TURRI",0],["L473","SU","TURRI",1],["L474","GO","TURRIACO",1],["L475","PE","TURRIVALIGNANI",1],["L476","MI","TURRO",0],["L476","MI","TURRO MILANESE",0],["L477","MT","TURSI",1],["L478","ME","TUSA",1],["L310","VT","TUSCANIA",1],["Z732","EE","TUVALU",0],["L479","IM","UBAGA",0],["C789","BG","UBIALE CLANEZZO",1],["L480","VA","UBOLDO",1],["L481","UD","UCOVIZZA",0],["Z138","EE","UCRAINA",0],["L482","ME","UCRIA",1],["L483","UD","UDINE",1],["Z353","EE","UGANDA",0],["L484","LE","UGENTO",1],["L485","LE","UGGIANO LA CHIESA",1],["L486","CO","UGGIATE",0],["L487","CO","UGGIATE-TREVANO",1],["L481","UD","UGOVIZZA VALBRUNA",0],["L488","CA","ULA'",0],["L488","OR","ULA' TIRSO",1],["L489","NU","ULASSAI",1],["L490","BZ","ULTIMO",1],["G196","TO","ULZIO",0],["L491","PL","UMAGO",0],["F978","AN","UMANA",0],["D786","PG","UMBERTIDE",1],["L492","KR","UMBRIATICO",1],["L493","NO","UNCHIO",0],["Z134","EE","UNGHERIA",0],["Z135","EE","UNIONE REPUBBLICHE SOCIALISTE SOVIETICHE",0],["L494","BS","URAGO D'OGLIO",1],["L495","BS","URAGO MELLA",0],["L496","OR","URAS",1],["L497","PD","URBANA",1],["L498","PU","URBANIA",1],["L499","SV","URBE",1],["L500","PU","URBINO",1],["L501","MC","URBISAGLIA",1],["L501","MC","URBISAGLIA BONSERVIZI",0],["L502","BG","URGNANO",1],["L503","SS","URI",1],["L504","CO","URIO",0],["Z613","EE","URUGUAY",0],["L505","CB","URURI",1],["L506","NU","URZULEI",1],["L507","GE","USCIO",1],["L508","OR","USELLUS",1],["L509","SS","USINI",1],["L510","MI","USMATE",0],["L511","MB","USMATE VELATE",1],["L511","MI","USMATE VELATE",0],["L512","CA","USSANA",0],["L512","SU","USSANA",1],["L513","CA","USSARAMANNA",0],["L513","SU","USSARAMANNA",1],["L514","NU","USSASSAI",1],["L515","TO","USSEAUX",1],["L516","TO","USSEGLIO",1],["L517","MC","USSITA",1],["L518","CN","USSOLO",0],["L519","PA","USTICA",1],["L520","GO","USTIE",0],["L521","CA","UTA",1],["Z143","EE","UZBEKISTAN",0],["Z259","EE","UZBEKISTAN",0],["L522","PT","UZZANO",1],["L523","PV","VACCARIZZA",0],["L524","CS","VACCARIZZO",0],["L524","CS","VACCARIZZO ALBANESE",1],["L525","RI","VACONE",1],["L526","CH","VACRI",1],["L527","BZ","VADENA",1],["L528","GE","VADO",0],["L528","SV","VADO LIGURE",1],["L533","LU","VAGLI SOTTO",1],["L529","FI","VAGLIA",1],["L530","AL","VAGLIERANO",0],["L531","AL","VAGLIO",0],["L532","PZ","VAGLIO",0],["L532","PZ","VAGLIO BASILICATA",1],["L532","PZ","VAGLIO DI BASILICATA",0],["L532","PZ","VAGLIO LUCANO",0],["L531","AT","VAGLIO SERRA",1],["L534","NO","VAGNA",0],["L535","CR","VAIANO",0],["L536","MI","VAIANO",0],["L537","PO","VAIANO",1],["L535","CR","VAIANO CREMASCO",1],["L536","MI","VAIANO VALLE",0],["L538","TO","VAIE",1],["L539","CR","VAILATE",1],["L540","CE","VAIRANO",0],["L541","CR","VAIRANO",0],["L542","PV","VAIRANO",0],["L541","CR","VAIRANO CREMASCO",0],["L540","CE","VAIRANO PATENORA",1],["L542","PV","VAIRANO PAVESE",0],["M265","PN","VAJONT",1],["M334","BG","VAL BREMBILLA",1],["G451","AR","VAL D'AMBRA",0],["L555","TO","VAL DELLA TORRE",1],["M405","TO","VAL DI CHY",1],["L562","PV","VAL DI NIZZA",1],["H261","AO","VAL DI REMA",0],["L564","BZ","VAL DI VIZZE",1],["M374","BL","VAL DI ZOLDO",1],["M384","VI","VAL LIONA",1],["L637","VA","VAL MARCHIROLO",0],["L638","SO","VAL MASINO",1],["H259","CO","VAL REZZO",1],["M254","FM","VAL SANTAMARINA",0],["L543","BZ","VALAS",0],["L544","BG","VALBONDIONE",1],["L545","BG","VALBREMBO",1],["M423","VI","VALBRENTA",1],["L546","GE","VALBREVENNA",1],["L547","CO","VALBRONA",1],["L548","TO","VALCHIUSA",0],["M415","TO","VALCHIUSA",1],["L549","AO","VALCHIUSELLA",0],["L550","TN","VALDA",0],["A179","TN","VALDAGNO",0],["L551","VI","VALDAGNO",1],["A179","TN","VALDAGNO DI TRENTO",0],["M343","TN","VALDAONE",1],["L552","BZ","VALDAORA",1],["L553","PL","VALDARSA",0],["L554","VI","VALDASTICO",1],["L556","BI","VALDENGO",1],["G319","TP","VALDERICE",1],["L557","SO","VALDIDENTRO",1],["L558","CN","VALDIERI",1],["L559","BZ","VALDIGIOVO",0],["L560","AO","VALDIGNA D'AOSTA",0],["M417","BI","VALDILANA",1],["L561","ME","VALDINA",1],["L563","SO","VALDISOTTO",1],["L565","TV","VALDOBBIADENE",1],["L566","VC","VALDUGGIA",1],["L567","VR","VALEGGIO",0],["L568","PV","VALEGGIO",1],["L567","VR","VALEGGIO SUL MINCIO",1],["L569","VT","VALENTANO",1],["L570","AL","VALENZA",1],["L571","BA","VALENZANO",1],["L572","LO","VALERA FRATTA",1],["L573","PG","VALFABBRICA",1],["L574","AT","VALFENERA",1],["L575","TN","VALFLORIANA",1],["M382","MC","VALFORNACE",1],["L576","SO","VALFURVA",1],["L577","VA","VALGANNA",1],["L578","TO","VALGIOIE",1],["L559","BZ","VALGIOVO",0],["L579","BG","VALGOGLIO",1],["L580","CN","VALGRANA",1],["L581","LC","VALGREGHENTINO",1],["L582","AO","VALGRISANCHE",0],["L582","AO","VALGRISENCHE",1],["L582","AO","VALGRISENZA",0],["L583","EN","VALGUARNERA CAROPEPE",1],["L585","BG","VALL'ALTA",0],["L584","BL","VALLADA",0],["L584","BL","VALLADA AGORDINA",1],["L586","BI","VALLANZENGO",1],["L587","BZ","VALLARGA",0],["L588","TN","VALLARSA",1],["L589","AV","VALLATA",1],["L590","BL","VALLE",0],["L591","CE","VALLE",0],["L592","MI","VALLE",0],["L593","PV","VALLE",0],["L594","CE","VALLE AGRICOLA",1],["L595","BZ","VALLE AURINA",1],["M404","VB","VALLE CANNOBINA",1],["L597","TE","VALLE CASTELLANA",1],["L602","PL","VALLE D'ISTRIA",0],["G540","SA","VALLE DELL'ANGELO",1],["L590","BL","VALLE DI CADORE",1],["L601","BZ","VALLE DI CASIES",1],["L591","CE","VALLE DI MADDALONI",1],["L594","CE","VALLE DI PRATA",0],["L592","MI","VALLE GUIDINO",0],["L606","VC","VALLE INFERIORE MOSSO",0],["L593","PV","VALLE LOMELLINA",1],["L606","BI","VALLE MOSSO",0],["L617","PV","VALLE SALIMBENE",1],["L618","TN","VALLE SAN FELICE",0],["L619","TE","VALLE SAN GIOVANNI",0],["L620","BI","VALLE SAN NICOLAO",1],["L621","BZ","VALLE SAN SILVESTRO",0],["L622","VC","VALLE SUPERIORE MOSSO",0],["L596","IM","VALLEBONA",1],["L598","FR","VALLECORSA",1],["L599","IM","VALLECROSIA",1],["L600","IM","VALLECROSIA CON SAN BIAGIO DELLA CIMA",0],["L603","PA","VALLEDOLMO",1],["L604","SS","VALLEDORIA",1],["I322","CZ","VALLEFIORITA",1],["M331","PU","VALLEFOGLIA",1],["L605","FR","VALLEFREDDA",0],["M362","TN","VALLELAGHI",1],["L607","VV","VALLELONGA",1],["L608","BZ","VALLELUNGA",0],["L609","CL","VALLELUNGA",0],["L608","BZ","VALLELUNGA CARLINO",0],["L609","CL","VALLELUNGA PRATAMENO",1],["L605","FR","VALLEMAIO",1],["L610","UD","VALLENONCELLO",0],["L611","RM","VALLEPIETRA",1],["L612","VT","VALLERANO",1],["L613","CA","VALLERMOSA",0],["L613","SU","VALLERMOSA",1],["L614","FR","VALLEROTONDA",1],["L615","BZ","VALLES",0],["L616","AV","VALLESACCARDA",1],["L623","BG","VALLEVE",1],["L624","VI","VALLI DEI SIGNORI",0],["L624","VI","VALLI DEL PASUBIO",1],["L625","RM","VALLINFREDA",1],["L626","BS","VALLIO",0],["L626","BS","VALLIO TERME",1],["L627","PG","VALLO",0],["L628","SA","VALLO",0],["L629","TO","VALLO",0],["L628","SA","VALLO DELLA LUCANIA",1],["L627","PG","VALLO DI NERA",1],["L629","TO","VALLO TORINESE",1],["L630","VI","VALLONARA",0],["L631","CN","VALLORIA",0],["L632","IM","VALLORIA",0],["L632","IM","VALLORIA MARITTIMA",0],["L631","CN","VALLORIATE",1],["L633","AL","VALMACCA",1],["L634","LC","VALMADRERA",1],["L635","VC","VALMAGGIA",0],["L636","CN","VALMALA",0],["L639","RM","VALMONTONE",1],["L640","CO","VALMOREA",1],["L641","PR","VALMOZZOLA",1],["L642","BG","VALNEGRA",1],["L643","AO","VALPELLINA",0],["L643","AO","VALPELLINE",1],["L644","TO","VALPERGA",1],["L645","AO","VALPRATO",0],["B510","TO","VALPRATO SOANA",1],["L646","VI","VALROVINA",0],["M320","BO","VALSAMOGGIA",1],["L647","AO","VALSAVARA",0],["L647","AO","VALSAVARANCHE",0],["L647","AO","VALSAVARENCHE",1],["L648","BS","VALSAVIORE",0],["L649","BG","VALSECCA",0],["D513","MT","VALSINNI",1],["C936","CO","VALSOLDA",1],["L650","VI","VALSTAGNA",0],["L651","VB","VALSTRONA",1],["L652","BG","VALTESSE",0],["L653","PG","VALTOPINA",1],["L654","AO","VALTORNENZA",0],["L655","BG","VALTORTA",1],["L654","AO","VALTOURNANCHE",0],["L654","AO","VALTOURNENCHE",1],["L656","SA","VALVA",1],["M395","LC","VALVARRONE",1],["L657","PN","VALVASONE",0],["M346","PN","VALVASONE ARZENE",1],["L658","CT","VALVERDE",1],["L659","PV","VALVERDE",0],["L468","BS","VALVESTINO",1],["L660","BZ","VANDOIES",1],["L661","BZ","VANDOIES DI SOPRA",0],["L662","BZ","VANDOIES DI SOTTO",0],["L663","BZ","VANGA",0],["Z733","EE","VANUATU",0],["L664","MI","VANZAGHELLO",1],["L665","MI","VANZAGO",1],["L666","NO","VANZONE",0],["L666","VB","VANZONE CON SAN CARLO",1],["L667","MI","VAPRIO",0],["L668","NO","VAPRIO",0],["L667","MI","VAPRIO D'ADDA",1],["L668","NO","VAPRIO D'AGOGNA",1],["L669","VC","VARALLO",1],["L670","NO","VARALLO POMBIA",1],["L671","CO","VARANO",0],["M248","TN","VARANO",0],["L671","VA","VARANO BORGHI",1],["L672","PR","VARANO DE' MELEGARI",1],["L673","RC","VARAPODIO",1],["L674","VA","VARARO",0],["L675","SV","VARAZZE",1],["L676","PG","VARCO",0],["L676","RI","VARCO SABINO",1],["L677","MB","VAREDO",1],["L677","MI","VAREDO",0],["L678","TN","VARENA",0],["L679","AL","VARENGO",0],["L680","LC","VARENNA",1],["L681","GE","VARESE",0],["L682","VA","VARESE",1],["L681","SP","VARESE LIGURE",1],["L683","AL","VARGO",0],["L684","GE","VARIGOTTI",0],["L685","TO","VARISELLA",1],["L686","UD","VARMO",1],["L687","BZ","VARNA",1],["L688","BN","VARONI",0],["L689","PR","VARSI",1],["L690","PV","VARZI",1],["L691","VB","VARZO",1],["L692","BL","VAS",0],["A701","VT","VASANELLO",1],["L693","IM","VASIA",1],["L694","TN","VASIO",0],["L695","CO","VASSENA",0],["E372","CH","VASTO",1],["L696","IS","VASTOGIRARDI",1],["L697","TN","VATTARO",0],["L698","TO","VAUDA CANAVESE",1],["L698","TO","VAUDA DI FRONT",0],["H847","TO","VAUDA SAN MORIZIO",0],["L538","TO","VAYES",0],["E728","RI","VAZIA",0],["L699","VV","VAZZANO",1],["L700","TV","VAZZOLA",1],["L701","VA","VECCANA",0],["L702","PI","VECCHIANO",1],["L703","CO","VEDANO",0],["L704","MI","VEDANO",0],["L704","MB","VEDANO AL LAMBRO",1],["L704","MI","VEDANO AL LAMBRO",0],["L703","VA","VEDANO OLONA",1],["L705","VA","VEDDASCA",0],["L706","TV","VEDELAGO",1],["L707","BG","VEDESETA",1],["L708","MI","VEDUGGIO",0],["L709","MB","VEDUGGIO CON COLZANO",1],["L709","MI","VEDUGGIO CON COLZANO",0],["L710","PD","VEGGIANO",1],["M293","FM","VEGLIA",0],["L711","LE","VEGLIE",1],["L712","BI","VEGLIO",1],["L713","VT","VEJANO",1],["L543","BZ","VELASIO",0],["L511","MI","VELATE",0],["L714","VA","VELATE",0],["L511","MI","VELATE MILANESE",0],["L715","CO","VELESO",1],["L716","PV","VELEZZO",0],["L716","PV","VELEZZO LOMELLINA",1],["L717","PT","VELLANO",0],["L718","SV","VELLEGO",0],["L719","RM","VELLETRI",1],["L720","PV","VELLEZZO",0],["L720","PV","VELLEZZO BELLINI",1],["L721","BS","VELLO",0],["L722","VR","VELO",0],["L723","VI","VELO",0],["L723","VI","VELO D'ASTICO",1],["L722","VR","VELO VERONESE",1],["L724","BZ","VELTURNO",1],["L725","IS","VENAFRO",1],["L726","TO","VENALZIO",0],["L727","TO","VENARIA REALE",1],["L728","AP","VENAROTTA",1],["L729","CN","VENASCA",1],["L726","TO","VENAUS",1],["Z366","EE","VENDA",0],["L730","SV","VENDONE",1],["L731","LC","VENDROGNO",0],["L732","VA","VENEGONO",0],["L733","VA","VENEGONO INFERIORE",1],["L734","VA","VENEGONO SUPERIORE",1],["L735","ME","VENETICO",1],["L736","VE","VENEZIA",1],["Z614","EE","VENEZUELA",0],["L737","CO","VENIANO",1],["L738","PZ","VENOSA",1],["M364","RE","VENTASSO",1],["L739","AV","VENTICANO",1],["L740","PA","VENTIMIGLIA",0],["L741","IM","VENTIMIGLIA",1],["L740","PA","VENTIMIGLIA DI SICILIA",1],["L742","LT","VENTOTENE",1],["L743","UD","VENZONE",1],["L744","MI","VERANO",0],["L745","BZ","VERANO",1],["L744","MB","VERANO BRIANZA",1],["L744","MI","VERANO BRIANZA",0],["L746","VB","VERBANIA",1],["L747","CS","VERBICARO",1],["L748","CO","VERCANA",1],["L749","SO","VERCEIA",1],["L750","VC","VERCELLI",1],["L751","LC","VERCURAGO",1],["L752","BG","VERDELLINO",1],["L753","BG","VERDELLO",1],["L754","CO","VERDERIO",0],["M337","LC","VERDERIO",1],["L755","LC","VERDERIO INFERIORE",0],["L756","LC","VERDERIO SUPERIORE",0],["L757","TN","VERDESINA",0],["L758","CN","VERDUNO",1],["L759","SV","VEREZZI",0],["L760","CO","VERGANO",0],["L761","NO","VERGANO",0],["L761","NO","VERGANO NOVARESE",0],["L762","BO","VERGATO",1],["L763","LU","VERGEMOLI",0],["L764","FC","VERGHERETO",1],["L765","VA","VERGIATE",1],["Z520","EE","VERGINI AMERICANE (ISOLE)",0],["Z525","EE","VERGINI BRITANNICHE (ISOLE)",0],["L766","MI","VERGO",0],["L767","VA","VERGOBBIO",0],["H840","CO","VERGOSA",0],["L768","MI","VERMEZZO",0],["M424","MI","VERMEZZO CON ZELO",1],["L769","TN","VERMIGLIO",1],["L770","CO","VERNA",0],["L771","CN","VERNANTE",1],["L772","PC","VERNASCA",1],["L773","MI","VERNATE",1],["L774","SP","VERNAZZA",1],["L775","PO","VERNIO",1],["L776","LE","VERNOLE",1],["L777","BS","VEROLANUOVA",1],["L778","BS","VEROLAVECCHIA",1],["L779","TO","VEROLENGO",1],["L780","FR","VEROLI",1],["L781","VR","VERONA",1],["D193","VR","VERONELLA",1],["L782","GO","VERPOGLIANO",0],["L783","AO","VERRAYES",1],["C282","AO","VERRE'S",0],["C282","AO","VERRES",1],["L784","PV","VERRETTO",1],["C200","CB","VERRINO",0],["L785","BI","VERRONE",1],["L786","PV","VERRUA",0],["L787","TO","VERRUA",0],["L788","PV","VERRUA PO",1],["L787","TO","VERRUA SAVOIA",1],["L786","PV","VERRUA SICCOMARIO",0],["L789","GO","VERSA",0],["L790","BZ","VERSCIAGO",0],["L791","CO","VERTEMATE",0],["L792","CO","VERTEMATE CON MINOPRIO",1],["L793","PL","VERTENEGLIO",0],["L794","GO","VERTOIBA",0],["L794","GO","VERTOIBA IN CAMPI SANTI",0],["L795","BG","VERTOVA",1],["L796","GO","VERTOVINO",0],["L797","RN","VERUCCHIO",1],["L798","NO","VERUNO",0],["L799","SO","VERVIO",1],["L800","TN","VERVO'",0],["L801","UD","VERZEGNIS",1],["L803","GE","VERZI PIETRA",0],["L802","KR","VERZINO",1],["L804","CN","VERZUOLO",1],["L805","PD","VESCOVANA",1],["L806","CR","VESCOVATO",1],["L807","AT","VESIME",1],["L808","NO","VESPOLATE",1],["L809","IM","VESSALICO",1],["L810","VR","VESTENANOVA",1],["L811","TO","VESTIGNE'",1],["L812","BS","VESTONE",1],["L813","LC","VESTRENO",0],["L814","VT","VETRALLA",1],["L815","RE","VETTO",1],["L816","BS","VEZZA",0],["L817","CN","VEZZA",0],["L817","CN","VEZZA D'ALBA",1],["L816","BS","VEZZA D'OGLIO",1],["L818","BZ","VEZZANO",0],["L819","GE","VEZZANO",0],["L820","RE","VEZZANO",0],["L821","TN","VEZZANO",0],["L818","BZ","VEZZANO IN VENOSTA",0],["L819","SP","VEZZANO LIGURE",1],["L820","RE","VEZZANO SUL CROSTOLO",1],["L822","GE","VEZZI",0],["L823","SV","VEZZI PORTIO",1],["L824","NO","VEZZO",0],["L825","CR","VHO",0],["E136","BO","VIADAGOLA",0],["L826","MN","VIADANA",1],["L827","BG","VIADANICA",1],["L828","CT","VIAGRANDE",1],["L829","AT","VIALE",1],["L829","AT","VIALE D'ASTI",0],["L830","TO","VIALFRE'",1],["L713","RM","VIANO",0],["L831","RE","VIANO",1],["L832","TN","VIARAGO",0],["L833","LU","VIAREGGIO",1],["L834","AT","VIARIGI",1],["F537","VV","VIBO VALENTIA",1],["H930","MI","VIBOLDONE",0],["L835","SA","VIBONATI",1],["L836","FR","VICALVI",1],["L837","PA","VICARI",1],["L838","FI","VICCHIO",1],["L839","NO","VICENO",0],["L840","VI","VICENZA",1],["L548","TO","VICO",0],["L841","CN","VICO",0],["L842","FG","VICO",0],["L843","RM","VICO",0],["L548","TO","VICO CANAVESE",0],["L842","FG","VICO DEL GARGANO",1],["L844","CE","VICO DI PANTANO",0],["L845","NA","VICO EQUENSE",1],["L843","FR","VICO NEL LAZIO",1],["L841","CN","VICOFORTE",1],["L846","PE","VICOLI",1],["L847","NO","VICOLUNGO",1],["L848","PC","VICOMARINO",0],["L849","VA","VICONAGO",0],["L850","PI","VICOPISANO",1],["L851","RM","VICOVARO",1],["L852","MI","VIDARDO",0],["M259","SS","VIDDALBA",1],["L853","CR","VIDICETO CON GURATA",0],["L854","PV","VIDIGULFO",1],["L855","CR","VIDOLASCO",0],["L856","TV","VIDOR",1],["L857","TO","VIDRACCO",1],["L858","FG","VIESTE",1],["Z251","EE","VIETNAM",0],["Z245","EE","VIETNAM DEL NORD",0],["Z244","EE","VIETNAM DEL SUD",0],["L859","PZ","VIETRI",0],["L860","SA","VIETRI",0],["L859","PZ","VIETRI DI POTENZA",1],["L860","SA","VIETRI SUL MARE",1],["L861","MI","VIGADORE",0],["L862","PV","VIGALFO",0],["L863","TN","VIGALZANO",0],["L864","VB","VIGANELLA",0],["L865","BG","VIGANO",0],["L867","MI","VIGANO",0],["L867","MI","VIGANO CERTOSINO",0],["L865","BG","VIGANO SAN MARTINO",1],["L866","LC","VIGANO'",1],["L868","FE","VIGARANO MAINARDA",1],["L869","VR","VIGASIO",1],["L870","PR","VIGATTO",0],["L871","MI","VIGENTINO",0],["L872","PV","VIGEVANO",1],["L873","PZ","VIGGIANELLO",1],["L874","PZ","VIGGIANO",1],["L875","NO","VIGGIONA",0],["L876","VA","VIGGIU'",1],["L876","VA","VIGGIU' ED UNITI",0],["L877","CR","VIGHIZZOLO",0],["L878","PD","VIGHIZZOLO",0],["L878","PD","VIGHIZZOLO D'ESTE",1],["L879","AL","VIGLIANO",0],["L880","NO","VIGLIANO",0],["L880","BI","VIGLIANO BIELLESE",1],["L879","AT","VIGLIANO D'ASTI",1],["L881","AL","VIGNALE MONFERRATO",1],["L882","VT","VIGNANELLO",1],["L883","MI","VIGNATE",1],["G663","PZ","VIGNOLA",0],["L884","TN","VIGNOLA",0],["L885","MO","VIGNOLA",1],["L886","TN","VIGNOLA FALESINA",0],["L886","TN","VIGNOLA-FALESINA",1],["L887","AL","VIGNOLE BORBERA",1],["L888","CN","VIGNOLO",1],["L889","VB","VIGNONE",1],["L890","BL","VIGO",0],["M249","TN","VIGO CAVEDINE",0],["L891","TN","VIGO D'ANAUNIA",0],["L890","BL","VIGO DI CADORE",1],["L893","TN","VIGO DI FASSA",0],["M250","TN","VIGO LOMASO",0],["L903","TN","VIGO RENDENA",0],["L892","PD","VIGODARZERE",1],["L894","BG","VIGOLO",1],["L895","TN","VIGOLO BASELGA",0],["L896","TN","VIGOLO VATTARO",0],["L897","PC","VIGOLZONE",1],["L898","TO","VIGONE",1],["L899","VE","VIGONOVO",1],["L900","PD","VIGONZA",1],["L901","MI","VIGONZINO",0],["L902","PV","VIGONZONE",0],["L904","AL","VIGUZZOLO",1],["L960","CO","VILL'ALBESE",0],["L905","CE","VILLA",0],["L906","NO","VILLA",0],["L907","SO","VILLA",0],["L908","SO","VILLA",0],["L909","UD","VILLA",0],["L910","TN","VILLA AGNEDO",0],["L911","TN","VILLA BANALE",0],["L912","VR","VILLA BARTOLOMEA",1],["L913","LU","VILLA BASILICA",1],["L917","PV","VILLA BISCOSSI",1],["B318","TS","VILLA CACCIA",0],["L919","BS","VILLA CARCINA",1],["L920","BR","VILLA CASTELLI",1],["L921","AO","VILLA CASTELNUOVO",0],["L922","PE","VILLA CELIERA",1],["L925","BS","VILLA COGOZZO",0],["L926","LU","VILLA COLLEMANDINA",1],["L927","AT","VILLA CORSIONE",0],["L928","MI","VILLA CORTESE",1],["L929","BG","VILLA D'ADDA",1],["L918","RO","VILLA D'ADIGE",0],["L930","BS","VILLA D'ALLEGNO",0],["A215","BG","VILLA D'ALME'",1],["L938","BG","VILLA D'OGNA",1],["L941","BZ","VILLA D'UTA",0],["L932","PL","VILLA DECANI",0],["L933","BI","VILLA DEL BOSCO",1],["L934","PD","VILLA DEL CONTE",1],["L935","FM","VILLA DEL NEVOSO",0],["D801","CE","VILLA DI BRIANO",1],["L907","SO","VILLA DI CHIAVENNA",1],["L936","BG","VILLA DI SERIO",1],["L908","SO","VILLA DI TIRANO",1],["L937","PD","VILLA DI VILLA",0],["L940","MI","VILLA DOSIA",0],["L937","PD","VILLA ESTENSE",1],["L943","IM","VILLA FARALDI",1],["L955","IM","VILLA GUARDIA",0],["L956","CO","VILLA GUARDIA",1],["E181","BZ","VILLA IN SELVA",0],["L957","TN","VILLA LAGARINA",1],["A081","FR","VILLA LATINA",1],["L844","CE","VILLA LITERNO",1],["L969","RE","VILLA MINOZZO",1],["L941","BZ","VILLA OTTONE",0],["L996","MI","VILLA PIZZONE",0],["F804","MN","VILLA POMA",0],["L997","MI","VILLA POMPEIANA",0],["M001","MI","VILLA RAVERIO",0],["M006","TN","VILLA RENDENA",0],["M010","CO","VILLA ROMANO",0],["M012","MI","VILLA ROSSA",0],["M017","MI","VILLA SAN FIORANO",0],["M018","RC","VILLA SAN GIOVANNI",1],["H913","VT","VILLA SAN GIOVANNI IN TUSCIA",1],["H934","RC","VILLA SAN GIUSEPPE",0],["I118","CA","VILLA SAN PIETRO",1],["M019","AT","VILLA SAN SECONDO",1],["M023","AQ","VILLA SANT'ANGELO",1],["C592","AO","VILLA SANT'ANSELMO",0],["I298","OR","VILLA SANT'ANTONIO",1],["M020","BZ","VILLA SANTA CATERINA",0],["L905","FR","VILLA SANTA LUCIA",1],["M021","AQ","VILLA SANTA LUCIA DEGLI ABRUZZI",1],["M022","CH","VILLA SANTA MARIA",1],["L909","UD","VILLA SANTINA",1],["I364","FR","VILLA SANTO STEFANO",1],["M024","TS","VILLA SLAVINA",0],["M029","IM","VILLA TALLA",0],["A609","OR","VILLA VERDE",1],["L760","CO","VILLA VERGANO",0],["M033","IM","VILLA VIANI",0],["M034","UD","VILLA VICENTINA",0],["M035","CE","VILLA VOLTURNO",0],["L914","TS","VILLABASSA",0],["L915","BZ","VILLABASSA",1],["L916","PA","VILLABATE",1],["E503","AL","VILLABELLA",0],["L918","RO","VILLABONA",0],["L923","BS","VILLACHIARA",1],["L924","CA","VILLACIDRO",0],["L924","SU","VILLACIDRO",1],["L931","AL","VILLADEATI",1],["L939","RO","VILLADOSE",1],["L906","VB","VILLADOSSOLA",1],["L942","CN","VILLAFALLETTO",1],["L944","AG","VILLAFRANCA",0],["L945","AL","VILLAFRANCA",0],["L946","MS","VILLAFRANCA",0],["L947","PD","VILLAFRANCA",0],["L948","TO","VILLAFRANCA",0],["L949","VR","VILLAFRANCA",0],["L945","AT","VILLAFRANCA D'ASTI",1],["L949","VR","VILLAFRANCA DI VERONA",1],["L946","MS","VILLAFRANCA IN LUNIGIANA",1],["L947","PD","VILLAFRANCA PADOVANA",1],["L948","TO","VILLAFRANCA PIEMONTE",1],["L948","TO","VILLAFRANCA SABAUDA",0],["L944","AG","VILLAFRANCA SICULA",1],["L950","ME","VILLAFRANCA TIRRENA",1],["L951","PA","VILLAFRATI",1],["L952","VI","VILLAGA",1],["L953","NU","VILLAGRANDE STRISAILI",1],["L954","CA","VILLAGRECA",0],["L958","AQ","VILLALAGO",1],["L959","CL","VILLALBA",1],["L961","CH","VILLALFONSINA",1],["L962","PV","VILLALUNGA",0],["L963","AL","VILLALVERNIA",1],["L964","CH","VILLAMAGNA",1],["L965","AV","VILLAMAINA",1],["L966","CA","VILLAMAR",0],["L966","SU","VILLAMAR",1],["L967","RO","VILLAMARZANA",1],["L968","CA","VILLAMASSARGIA",0],["L968","SU","VILLAMASSARGIA",1],["L970","AL","VILLAMIROGLIO",1],["M251","TN","VILLAMONTAGNA",0],["L971","BZ","VILLANDRO",1],["L972","AL","VILLANOVA",0],["L973","AV","VILLANOVA",0],["L974","CN","VILLANOVA",0],["L975","GE","VILLANOVA",0],["L976","MI","VILLANOVA",0],["L978","NO","VILLANOVA",0],["L979","PD","VILLANOVA",0],["L980","PC","VILLANOVA",0],["L981","AO","VILLANOVA BALTEA",0],["L978","BI","VILLANOVA BIELLESE",1],["L982","TO","VILLANOVA CANAVESE",1],["L975","SV","VILLANOVA D'ALBENGA",1],["L983","PV","VILLANOVA D'ARDENGHI",1],["L984","AT","VILLANOVA D'ASTI",1],["L973","AV","VILLANOVA DEL BATTISTA",1],["L985","RO","VILLANOVA DEL GHEBBO",1],["L977","LO","VILLANOVA DEL SILLARO",1],["L979","PD","VILLANOVA DI CAMPOSAMPIERO",1],["L972","AL","VILLANOVA DI CASALE MONFERRATO",0],["L988","RO","VILLANOVA MARCHESANA",1],["L982","TO","VILLANOVA MATHI",0],["L974","CN","VILLANOVA MONDOVI'",1],["L972","AL","VILLANOVA MONFERRATO",1],["L989","SS","VILLANOVA MONTELEONE",1],["L990","CN","VILLANOVA SOLARO",1],["L980","PC","VILLANOVA SULL'ARDA",1],["L991","OR","VILLANOVA TRUSCHEDU",1],["L992","SU","VILLANOVA TULO",1],["L976","MI","VILLANOVA VIMERCATE",0],["L986","CA","VILLANOVAFORRU",0],["L986","SU","VILLANOVAFORRU",1],["L987","CA","VILLANOVAFRANCA",0],["L987","SU","VILLANOVAFRANCA",1],["L992","NU","VILLANOVATULO",0],["L993","CN","VILLANOVAVETTA",0],["L994","PV","VILLANTERIO",1],["L977","MI","VILLANUOVA",0],["L984","AL","VILLANUOVA",0],["L995","BS","VILLANUOVA",0],["L984","AT","VILLANUOVA D'ASTI",0],["L995","BS","VILLANUOVA SUL CLISI",1],["M278","CA","VILLAPERUCCIO",0],["M278","SU","VILLAPERUCCIO",1],["B903","CS","VILLAPIANA",1],["A185","LE","VILLAPICCIOTTI",0],["L998","CA","VILLAPUTZU",0],["L998","SU","VILLAPUTZU",1],["L999","TO","VILLAR ALMESE",0],["L999","TO","VILLAR DORA",1],["M007","TO","VILLAR FOCCHIARDO",1],["M013","TO","VILLAR PELLICE",1],["M014","TO","VILLAR PEROSA",1],["M015","CN","VILLAR SAN COSTANZO",1],["M002","TO","VILLARBASSE",1],["M003","VC","VILLARBOIT",1],["M004","TO","VILLAREGGIA",1],["M005","PV","VILLAREGGIO",0],["G309","NA","VILLARICCA",1],["G760","CH","VILLARIELLI",0],["E022","CA","VILLARIOS",0],["E022","CA","VILLARIOS MASAINAS",0],["M008","CR","VILLAROCCA",0],["M009","AL","VILLAROMAGNANO",1],["M011","EN","VILLAROSA",1],["M016","CA","VILLASALTO",0],["M016","SU","VILLASALTO",1],["M017","MB","VILLASANTA",1],["M017","MI","VILLASANTA",0],["B738","CA","VILLASIMIUS",0],["B738","SU","VILLASIMIUS",1],["M025","CA","VILLASOR",0],["M025","SU","VILLASOR",1],["M026","CA","VILLASPECIOSA",0],["M026","SU","VILLASPECIOSA",1],["M027","TO","VILLASTELLONE",1],["M028","VC","VILLATA",1],["M030","OR","VILLAURBANA",1],["M031","AQ","VILLAVALLELONGA",1],["M032","VI","VILLAVERLA",1],["F260","MI","VILLAVESCO",0],["M036","TN","VILLAZZANO",0],["M363","TN","VILLE D'ANAUNIA",1],["M037","TN","VILLE DEL MONTE",0],["M431","TN","VILLE DI FIEMME",1],["M038","GO","VILLE MONTEVECCHIO",0],["M039","IM","VILLE SAN PIETRO",0],["M040","IM","VILLE SAN SEBASTIANO",0],["L981","AO","VILLENEUVE",1],["M043","GO","VILLESSE",1],["M041","AQ","VILLETTA BARREA",1],["M042","VB","VILLETTE",1],["M044","MN","VILLIMPENTA",1],["M045","BG","VILLONGO",1],["M046","BG","VILLONGO SAN FILASTRO",0],["M047","BG","VILLONGO SANT'ALESSANDRO",0],["M048","TV","VILLORBA",1],["M049","BG","VILMINORE",0],["M050","BG","VILMINORE DI SCALVE",1],["M051","PV","VIMANONE",0],["M052","MB","VIMERCATE",1],["M052","MI","VIMERCATE",0],["M053","MI","VIMODRONE",1],["M054","CO","VIMOGNO",0],["M055","CN","VINADIO",1],["M056","MI","VINAGO",0],["M057","CB","VINCHIATURO",1],["M058","AT","VINCHIO",1],["M059","FI","VINCI",1],["M060","TO","VINOVO",1],["M061","VC","VINTEBBIO",0],["M062","NO","VINZAGLIO",1],["M063","CN","VIOLA",1],["M064","TN","VION",0],["M065","BS","VIONE",1],["M066","GO","VIPACCO",0],["M067","BZ","VIPITENO",1],["H123","MN","VIRGILIO",0],["M068","BS","VIRLE",0],["M069","TO","VIRLE",0],["M069","TO","VIRLE PIEMONTE",1],["M068","BS","VIRLE TRE PONTI",0],["M070","BS","VISANO",1],["M071","TO","VISCHE",1],["M072","NA","VISCIANO",1],["M073","UD","VISCO",1],["M074","PL","VISIGNANO",0],["M075","PL","VISINADA",0],["M076","CO","VISINO",0],["M077","AL","VISONE",1],["M078","MC","VISSO",1],["M079","PV","VISTARINO",1],["M080","TO","VISTRORIO",1],["M081","TP","VITA",1],["M082","VT","VITERBO",1],["Z704","EE","VITI",0],["M083","FR","VITICUSO",1],["M084","CE","VITICUSO E ACQUAFONDATA",0],["M085","PN","VITO D'ASIO",1],["M086","VT","VITORCHIANO",1],["M087","MI","VITTADONE",0],["M088","RG","VITTORIA",1],["M089","TV","VITTORIO",0],["M089","TV","VITTORIO VENETO",1],["M090","AQ","VITTORITO",1],["M091","MI","VITTUONE",1],["M092","CE","VITULACCIO",0],["M093","BN","VITULANO",1],["M092","CE","VITULAZIO",1],["M094","TO","VIU'",1],["M095","RM","VIVARO",0],["M096","PN","VIVARO",1],["M095","RM","VIVARO ROMANO",1],["M097","PV","VIVENTE",0],["M098","BI","VIVERONE",1],["M099","BZ","VIZZE",0],["M100","CT","VIZZINI",1],["M101","MI","VIZZOLA",0],["M101","VA","VIZZOLA TICINO",1],["M102","MI","VIZZOLO",0],["M102","MI","VIZZOLO PREDABISSI",1],["M103","PD","VO",0],["M103","PD","VO'",1],["M104","BS","VOBARNO",1],["M105","GE","VOBBIA",1],["M106","VC","VOCCA",1],["M107","NO","VOCOGNO E PRESTINONE",0],["M108","BL","VODO CADORE",1],["M108","BL","VODO DI CADORE",0],["M109","PV","VOGHERA",1],["M110","FE","VOGHIERA",1],["M111","VB","VOGOGNA",1],["M112","GO","VOISSIZZA DI COMENO",0],["M113","TN","VOLANO",1],["H484","BS","VOLCIANO",0],["M114","VA","VOLDOMINO",0],["M115","NA","VOLLA",1],["M116","CR","VOLONGO",1],["M117","FM","VOLOSCA",0],["M118","TV","VOLPAGO",0],["M118","TV","VOLPAGO DEL MONTELLO",1],["M119","PV","VOLPARA",1],["M120","AL","VOLPEDO",1],["M121","AL","VOLPEGLINO",1],["M122","TO","VOLPIANO",1],["D117","BG","VOLPINO",0],["M125","MN","VOLTA MANTOVANA",1],["Z354","EE","VOLTA=ALTOVOLTA",0],["M123","AL","VOLTAGGIO",1],["M124","BL","VOLTAGO",0],["M124","BL","VOLTAGO AGORDINO",1],["M126","PI","VOLTERRA",1],["M127","CR","VOLTIDO",1],["M128","VA","VOLTORRE",0],["M129","GE","VOLTRI",0],["M130","AV","VOLTURARA",0],["M131","FG","VOLTURARA",0],["M131","FG","VOLTURARA APPULA",1],["M130","AV","VOLTURARA IRPINA",1],["M132","FG","VOLTURINO",1],["M133","TO","VOLVERA",1],["M134","GO","VOLZANA",0],["M135","GO","VOSCHIA",0],["M136","CN","VOTTIGNASCO",1],["Z729","EE","WALLIS E FUTUNA (ISOLE)",0],["M137","TP","XITTA",0],["Z246","EE","YEMEN",0],["Z250","EE","YEMEN REPUBBLICA DEMOCRATICA POPOLARE",0],["M138","VV","ZACCANOPOLI",1],["M139","CT","ZAFFERANA ETNEA",1],["M140","CZ","ZAGARISE",1],["M141","RM","ZAGAROLO",1],["Z312","EE","ZAIRE",0],["M142","TN","ZAMBANA",0],["Z355","EE","ZAMBIA",0],["M143","VV","ZAMBRONE",1],["B938","MI","ZANAVASCO",0],["M144","BG","ZANDOBBIO",1],["M145","VI","ZANE'",1],["M146","CR","ZANENGO",0],["M147","BG","ZANICA",1],["Z356","EE","ZANZIBAR",0],["M148","CR","ZAPPELLO CON BOLZONE",0],["M267","FG","ZAPPONETA",1],["M149","ZA","ZARA",0],["M150","PV","ZAVATTARELLO",1],["M151","PV","ZAVATTARELLO VALVERDE",0],["M152","PV","ZECCONE",1],["M153","OR","ZEDDIANI",1],["C590","BZ","ZEDES",0],["M154","VE","ZELARINO",0],["M155","PV","ZELATA",0],["M156","CO","ZELBIO",1],["M157","CO","ZELBIO VELESO",0],["M158","LO","ZELO BUON PERSICO",1],["M159","MI","ZELO FORAMAGNO",0],["M160","MI","ZELO SURRIGONE",0],["M161","PV","ZEME",1],["M162","PV","ZENEVREDO",1],["M163","TV","ZENSON DI PIAVE",1],["M164","CA","ZEPPARA",0],["M165","PC","ZERBA",1],["M166","PV","ZERBO",1],["M167","PV","ZERBOLO'",1],["M168","OR","ZERFALIU",1],["M169","MS","ZERI",1],["M170","VI","ZERMEGHEDO",1],["M171","TV","ZERO BRANCO",1],["M172","VR","ZEVIO",1],["L848","PC","ZIANO",0],["M173","TN","ZIANO",0],["M173","TN","ZIANO DI FIEMME",1],["L848","PC","ZIANO PIACENTINO",1],["M174","PR","ZIBELLO",0],["M175","PV","ZIBIDO AL LAMBRO",0],["M176","MI","ZIBIDO SAN GIACOMO",1],["M177","SP","ZIGNAGO",1],["Z337","EE","ZIMBABWE",0],["M178","VR","ZIMELLA",1],["M179","BI","ZIMONE",1],["M180","PV","ZINASCO",1],["M181","MI","ZIVIDO",0],["M182","GE","ZOAGLI",1],["M183","MO","ZOCCA",1],["M184","BG","ZOGNO",1],["M185","BO","ZOLA PREDOSA",1],["I345","BL","ZOLDO ALTO",0],["M186","GO","ZOLLA",0],["M187","LE","ZOLLINO",1],["M188","BS","ZONE",1],["M189","BL","ZOPPE'",0],["M189","BL","ZOPPE' DI CADORE",1],["M190","PN","ZOPPOLA",1],["M191","MI","ZORLESCO",0],["M192","NO","ZORNASCO",0],["M193","BG","ZORZINO",0],["M194","VI","ZOVENCEDO",1],["M195","NO","ZOVERALLO",0],["M196","BI","ZUBIENA",1],["M197","SV","ZUCCARELLO",1],["M198","TN","ZUCLO",0],["M199","VI","ZUGLIANO",1],["M200","UD","ZUGLIO",1],["M201","BI","ZUMAGLIA",1],["M202","CS","ZUMPANO",1],["M203","AV","ZUNGOLI",1],["M204","VV","ZUNGRI",1],["M205","MI","ZUNICO",0],["M206","CA","ZURI",0]]},function(A,O,I){"use strict";Object.defineProperty(O,"__esModule",{value:!0}),O.normalizeString=function(A){return A.trim().replace(new RegExp(/[àá]/g),"a'").replace(new RegExp(/[èé]/g),"e'").replace(new RegExp(/[ìí]/g),"i'").replace(new RegExp(/[òó]/g),"o'").replace(new RegExp(/[ùú]/g),"u'").toUpperCase()},O.daysInMonth=L,O.isValidDate=R,O.getValidDate=function(A,O,I){if("string"==typeof A&&void 0===O&&void 0===I)return new Date(A);if(R(A,O,I))return new Date(I,O-1,A,0,0,0,0);throw new Error("The date ".concat(I,"/").concat(O,"/").concat(A," is not a valid date"))},O.extractVowels=function(A){return A.replace(/[^AEIOU]/gi,"")},O.extractConsonants=function(A){return A.replace(/[^BCDFGHJKLMNPQRSTVWXYZ]/gi,"")},O.birthplaceFields=function(A,O){var I=document.querySelector(A),L=document.querySelector(O),R=document.createElement("optgroup"),C=document.createElement("optgroup");C.label="-----------",I.appendChild(R),I.appendChild(C),Object.keys(N.PROVINCE).sort((function(A,O){return N.PROVINCE[A]>N.PROVINCE[O]?1:-1})).forEach((function(A,O){var I=N.PROVINCE[A],E=document.createElement("option");E.value=A,E.textContent=I,"EE"===A?C.appendChild(E):R.appendChild(E)})),I.onchange=function(A){for(var O=I.value;L.firstChild;)L.removeChild(L.firstChild);E.COMUNI.forEach((function(A){var I=A[0],E=A[2];if(A[1]===O){var N=document.createElement("option");N.value=I,N.textContent=E.toLowerCase().replace(/\b\w/g,(function(A){return A.toUpperCase()})),L.appendChild(N)}}))},I.selectedIndex="0",I.onchange()};var E=I(0),N=I(4);function L(A,O){switch(A){case 1:return O%4==0&&O%100!=0||O%400==0?29:28;case 8:case 3:case 5:case 10:return 30;default:return 31}}function R(A,O,I){var E=O-1;return E>=0&&E<12&&A>0&&A<=L(E,I)}},function(A,O,I){"use strict";var E=I(3),N=I(5),L=I(1);function R(A){return function(A){if(Array.isArray(A))return C(A)}(A)||function(A){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(A))return Array.from(A)}(A)||function(A,O){if(!A)return;if("string"==typeof A)return C(A,O);var I=Object.prototype.toString.call(A).slice(8,-1);"Object"===I&&A.constructor&&(I=A.constructor.name);if("Map"===I||"Set"===I)return Array.from(A);if("Arguments"===I||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(I))return C(A,O)}(A)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function C(A,O){(null==O||O>A.length)&&(O=A.length);for(var I=0,E=new Array(O);I<O;I++)E[I]=A[I];return E}function S(A){return(S="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(A){return typeof A}:function(A){return A&&"function"==typeof Symbol&&A.constructor===Symbol&&A!==Symbol.prototype?"symbol":typeof A})(A)}function T(A,O){for(var I=0;I<O.length;I++){var E=O[I];E.enumerable=E.enumerable||!1,E.configurable=!0,"value"in E&&(E.writable=!0),Object.defineProperty(A,E.key,E)}}function G(A,O,I){return O&&T(A.prototype,O),I&&T(A,I),A}var M=function(){function A(O){if(function(A,O){if(!(A instanceof O))throw new TypeError("Cannot call a class as a function")}(this,A),"string"==typeof O){if(O=O.toUpperCase(),!A.check(O))throw new Error("Provided input is not a valid Codice Fiscale");this.code=O,this.reverse()}else{if("object"!==S(O))throw new Error("Comune constructor accept either a valid string or a plain object. Check the documentation");var I=O;this.name=I.name,this.surname=I.surname,this.gender=this.checkGender(I.gender),this.birthday=I.birthday?(0,L.getValidDate)(I.birthday):(0,L.getValidDate)(I.day,I.month,I.year),this.birthplace=new E.Comune(I.birthplace,I.birthplaceProvincia),this.compute()}}return G(A,[{key:"day",get:function(){return this.birthday.getDate()},set:function(A){this.birthday.setDate(A)}},{key:"month",get:function(){return this.birthday.getMonth()+1},set:function(A){this.birthday.setMonth(A-1)}},{key:"year",get:function(){return this.birthday.getFullYear()},set:function(A){this.birthday.setFullYear(A)}},{key:"cf",get:function(){return this.code}},{key:"nameCode",get:function(){return this.code.substr(3,3)}},{key:"surnameCode",get:function(){return this.code.substr(0,3)}},{key:"checkCode",get:function(){return this.code.substr(15,1)}}]),G(A,[{key:"toString",value:function(){return this.code}},{key:"toJSON",value:function(){return{name:this.name,surname:this.surname,gender:this.gender,day:this.birthday.getDate(),year:this.birthday.getFullYear(),month:this.birthday.getMonth()+1,birthday:this.birthday.toISOString().slice(0,10),birthplace:this.birthplace.nome,birthplaceProvincia:this.birthplace.prov,cf:this.code}}},{key:"isValid",value:function(){if("string"!=typeof this.code)return!1;if(this.code=this.code.toUpperCase(),16!==this.code.length)return!1;var O=this.code.charAt(15),I=this.code.slice(0,15);return A.getCheckCode(I).toUpperCase()===O.toUpperCase()}},{key:"omocodie",value:function(){for(var O=[],I=this.code.slice(0,15),E=this.code.length-1;E>=0;E--){var L=this.code[E];null!==L.match(/\d/)&&(I="".concat(I.substr(0,E)).concat(N.OMOCODIA_TABLE[L]).concat(I.substr(E+1)),O.push(I+A.getCheckCode(I)))}return O}},{key:"compute",value:function(){var O=this.getSurnameCode();O+=this.getNameCode(),O+=this.dateCode(),O+=this.birthplace.cc,O+=A.getCheckCode(O),this.code=O}},{key:"reverse",value:function(){this.name=this.code.substr(3,3),this.surname=this.code.substr(0,3);var O=this.code.substr(6,2);O=A.toNumberIfOmocodia(O);var I=parseInt("19".concat(O),10),L=parseInt("20".concat(O),10),R=L>(new Date).getFullYear()?I:L,C=this.code.substr(8,1),S=N.MONTH_CODES.indexOf(C);this.gender="M";var T=this.code.substr(9,2);T=A.toNumberIfOmocodia(T);var G=parseInt(T,10);G>31&&(this.gender="F",G-=40),this.birthday=new Date(Date.UTC(R,S,G,0,0,0,0));var M=this.code.substr(11,4),B=A.toNumberIfOmocodia(M.substr(1,3));return M=M.charAt(0)+B,this.birthplace=E.Comune.GetByCC(M),this.toJSON()}},{key:"checkGender",value:function(A){if(this.gender=void 0!==A?A.toUpperCase():this.gender.toUpperCase(),"string"!=typeof this.gender)throw new Error("Gender must be a string");if("M"!==this.gender&&"F"!==this.gender)throw new Error("Gender must be either 'M' or 'F'");return A}},{key:"getSurnameCode",value:function(){return A.surnameCode(this.surname)}},{key:"getNameCode",value:function(){return A.nameCode(this.name)}},{key:"dateCode",value:function(){return A.dateCode(this.birthday.getDate(),this.birthday.getMonth()+1,this.birthday.getFullYear(),this.gender)}}],[{key:"getCheckCode",value:function(A){A=A.toUpperCase();for(var O=0,I=0;I<15;I+=1){var E=A[I];O+=I%2!=0?N.CHECK_CODE_EVEN[E]:N.CHECK_CODE_ODD[E]}return O%=26,N.CHECK_CODE_CHARS.charAt(O)}},{key:"findLocationCode",value:function(A,O){return new E.Comune(A,O).cc}},{key:"computeInverse",value:function(O){return new A(O).toJSON()}},{key:"reverse",value:function(O){return new A(O).toJSON()}},{key:"compute",value:function(O){return new A(O).toString()}},{key:"check",value:function(O){if("string"!=typeof O)return!1;var I=O.toUpperCase();if(16!==I.length)return!1;if(!/^[A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1}$/.test(I))return!1;var E=O.charAt(15);return I=O.slice(0,15),A.getCheckCode(I).toUpperCase()===E.toUpperCase()}},{key:"getOmocodie",value:function(O){return new A(O).omocodie()}},{key:"surnameCode",value:function(A){return"".concat((0,L.extractConsonants)(A)).concat((0,L.extractVowels)(A),"XXX").substr(0,3).toUpperCase()}},{key:"nameCode",value:function(A){var O=(0,L.extractConsonants)(A);return(O=O.length>=4?O.charAt(0)+O.charAt(2)+O.charAt(3):(O+="".concat((0,L.extractVowels)(A),"XXX")).substr(0,3)).toUpperCase()}},{key:"dateCode",value:function(A,O,I,E){return I=(I="0".concat(I)).substr(I.length-2,2),O=N.MONTH_CODES[O-1],"F"===E.toUpperCase()&&(A+=40),A=(A="0".concat(A)).substr(A.length-2,2),"".concat(I).concat(O).concat(A)}},{key:"toNumberIfOmocodia",value:function(A){return isNaN(A)&&(A=(A=R(A).map((function(A){return isNaN(A)?N.OMOCODIA_TABLE_INVERSE[A]:A}))).join("")),A}}]),A}();M.utils={birthplaceFields:L.birthplaceFields},A.exports=M},function(A,O,I){"use strict";Object.defineProperty(O,"__esModule",{value:!0}),O.Comune=void 0;var E=I(0),N=I(1);function L(A,O){var I;if("undefined"==typeof Symbol||null==A[Symbol.iterator]){if(Array.isArray(A)||(I=function(A,O){if(!A)return;if("string"==typeof A)return R(A,O);var I=Object.prototype.toString.call(A).slice(8,-1);"Object"===I&&A.constructor&&(I=A.constructor.name);if("Map"===I||"Set"===I)return Array.from(A);if("Arguments"===I||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(I))return R(A,O)}(A))||O&&A&&"number"==typeof A.length){I&&(A=I);var E=0,N=function(){};return{s:N,n:function(){return E>=A.length?{done:!0}:{done:!1,value:A[E++]}},e:function(A){throw A},f:N}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var L,C=!0,S=!1;return{s:function(){I=A[Symbol.iterator]()},n:function(){var A=I.next();return C=A.done,A},e:function(A){S=!0,L=A},f:function(){try{C||null==I.return||I.return()}finally{if(S)throw L}}}}function R(A,O){(null==O||O>A.length)&&(O=A.length);for(var I=0,E=new Array(O);I<O;I++)E[I]=A[I];return E}function C(A,O){if(!(A instanceof O))throw new TypeError("Cannot call a class as a function")}function S(A,O){for(var I=0;I<O.length;I++){var E=O[I];E.enumerable=E.enumerable||!1,E.configurable=!0,"value"in E&&(E.writable=!0),Object.defineProperty(A,E.key,E)}}function T(A,O,I){return O&&S(A.prototype,O),I&&S(A,I),A}var G=function(){function A(O,I,E){var N=!(arguments.length>3&&void 0!==arguments[3])||arguments[3];if(C(this,A),N||void 0===E||void 0===I){var L=this.searchByNameAndProvince(O,I);if(void 0===L&&4===O.length&&(L=this.searchByCC(O)),void 0===L)throw new Error("Comune with name ".concat(O," doesn't exist"));if(void 0!==E&&L.cc!==E)throw new Error("Comune with cc ".concat(E," doesn't exist"));this.nome=L.nome,this.prov=L.prov,this.cc=L.cc}else this.nome=O,this.prov=I,this.cc=E}return T(A,[{key:"nomeNorm",get:function(){return(0,N.normalizeString)(this.nome)}}]),T(A,[{key:"searchByCC",value:function(O){var I;try{I=A.GetByCC(O)}catch(A){}if(void 0!==I)return I.toJSON()}},{key:"searchByName",value:function(A){this.searchByNameAndProvince(A)}},{key:"searchByNameAndProvince",value:function(O,I){var L=(0,N.normalizeString)(O),R=I&&(0,N.normalizeString)(I),C=E.COMUNI.filter((function(A){return R?A[1]===R&&A[2]===L:A[2]===L})).map((function(A){return{cc:A[0],prov:A[1],nome:A[2],active:1===A[3]}}));if(1===C.length)return C[0];if(1===(C=C.filter((function(A){return A.active}))).length)return C[0];if(I)throw new Error("Comune with name of ".concat(O," and prov ").concat(I," doesn't exists"));if(4===O.length&&O.toUpperCase()===O)return A.GetByCC(O);throw new Error("Comune with name of ".concat(O," is found in more than one province. Please specify the province code"))}},{key:"toJSON",value:function(){return{cc:this.cc,nome:this.nome,prov:this.prov}}}],[{key:"GetByName",value:function(O,I){return new A(O,I)}},{key:"GetByCC",value:function(O){var I,N,R=L(E.COMUNI);try{for(R.s();!(N=R.n()).done;){var C=N.value;if(C[0]===O&&1==C[3]){I=C;break}C[0]===O&&(I=C)}}catch(A){R.e(A)}finally{R.f()}if(void 0!==I)return new A(I[2],I[1],I[0],!1);throw new Error("Comune with cc ".concat(O," doesn't exist"))}}]),A}();O.Comune=G},function(A,O,I){"use strict";Object.defineProperty(O,"__esModule",{value:!0}),O.PROVINCE=void 0;O.PROVINCE={AG:"Agrigento",AL:"Alessandria",AN:"Ancona",AO:"Aosta",AP:"Ascoli Piceno",AQ:"L'Aquila",AR:"Arezzo",AT:"Asti",AV:"Avellino",BA:"Bari",BG:"Bergamo",BI:"Biella",BL:"Belluno",BN:"Benevento",BO:"Bologna",BR:"Brindisi",BS:"Brescia",BT:"Barletta-Andria-Trani",BZ:"Bolzano",CA:"Cagliari",CB:"Campobasso",CE:"Caserta",CH:"Chieti",CL:"Caltanissetta",CN:"Cuneo",CO:"Como",CR:"Cremona",CS:"Cosenza",CT:"Catania",CZ:"Catanzaro",EN:"Enna",FC:"Forlì-Cesena",FE:"Ferrara",FG:"Foggia",FI:"Firenze",FM:"Fermo",FR:"Frosinone",GE:"Genova",GO:"Gorizia",GR:"Grosseto",IM:"Imperia",IS:"Isernia",KR:"Crotone",LC:"Lecco",LE:"Lecce",LI:"Livorno",LO:"Lodi",LT:"Latina",LU:"Lucca",MB:"Monza e della Brianza",MC:"Macerata",ME:"Messina",MI:"Milano",MN:"Mantova",MO:"Modena",MS:"Massa-Carrara",MT:"Matera",NA:"Napoli",NO:"Novara",NU:"Nuoro",OR:"Oristano",PA:"Palermo",PC:"Piacenza",PD:"Padova",PE:"Pescara",PG:"Perugia",PI:"Pisa",PN:"Pordenone",PO:"Prato",PR:"Parma",PT:"Pistoia",PU:"Pesaro e Urbino",PV:"Pavia",PZ:"Potenza",RA:"Ravenna",RC:"Reggio Calabria",RE:"Reggio Emilia",RG:"Ragusa",RI:"Rieti",RM:"Roma",RN:"Rimini",RO:"Rovigo",SA:"Salerno",SI:"Siena",SO:"Sondrio",SP:"La Spezia",SR:"Siracusa",SS:"Sassari",SU:"Sud Sardegna",SV:"Savona",TA:"Taranto",TE:"Teramo",TN:"Trento",TO:"Torino",TP:"Trapani",TR:"Terni",TS:"Trieste",TV:"Treviso",UD:"Udine",VA:"Varese",VB:"Verbano-Cusio-Ossola",VC:"Vercelli",VE:"Venezia",VI:"Vicenza",VR:"Verona",VS:"Medio Campidano",VT:"Viterbo",VV:"Vibo Valentia",EE:"Estero"}},function(A,O,I){"use strict";Object.defineProperty(O,"__esModule",{value:!0}),O.CHECK_CODE_CHARS=O.OMOCODIA_TABLE_INVERSE=O.OMOCODIA_TABLE=O.CHECK_CODE_EVEN=O.CHECK_CODE_ODD=O.MONTH_CODES=void 0;O.MONTH_CODES=["A","B","C","D","E","H","L","M","P","R","S","T"];O.CHECK_CODE_ODD={0:1,1:0,2:5,3:7,4:9,5:13,6:15,7:17,8:19,9:21,A:1,B:0,C:5,D:7,E:9,F:13,G:15,H:17,I:19,J:21,K:2,L:4,M:18,N:20,O:11,P:3,Q:6,R:8,S:12,T:14,U:16,V:10,W:22,X:25,Y:24,Z:23};O.CHECK_CODE_EVEN={0:0,1:1,2:2,3:3,4:4,5:5,6:6,7:7,8:8,9:9,A:0,B:1,C:2,D:3,E:4,F:5,G:6,H:7,I:8,J:9,K:10,L:11,M:12,N:13,O:14,P:15,Q:16,R:17,S:18,T:19,U:20,V:21,W:22,X:23,Y:24,Z:25};O.OMOCODIA_TABLE={0:"L",1:"M",2:"N",3:"P",4:"Q",5:"R",6:"S",7:"T",8:"U",9:"V"};O.OMOCODIA_TABLE_INVERSE={L:"0",M:"1",N:"2",P:"3",Q:"4",R:"5",S:"6",T:"7",U:"8",V:"9"};O.CHECK_CODE_CHARS="ABCDEFGHIJKLMNOPQRSTUVWXYZ"}]);

/***/ }),

/***/ "TNV1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var defaults = __webpack_require__("KCLY");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ "TcQ7":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("MU5D");
var defined = __webpack_require__("52gC");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "U5ju":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("M6a0");
__webpack_require__("zQR9");
__webpack_require__("+tPU");
__webpack_require__("CXw9");
__webpack_require__("EqBC");
__webpack_require__("jKW+");
module.exports = __webpack_require__("FeBl").Promise;


/***/ }),

/***/ "UNcj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BCollapse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__ = __webpack_require__("rhEV");


var script = {
  name: 'BCollapse',
  props: {
    open: {
      type: Boolean,
      default: true
    },
    animation: {
      type: String,
      default: 'fade'
    },
    ariaId: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'is-top',
      validator: function validator(value) {
        return ['is-top', 'is-bottom'].indexOf(value) > -1;
      }
    }
  },
  data: function data() {
    return {
      isOpen: this.open
    };
  },
  watch: {
    open: function open(value) {
      this.isOpen = value;
    }
  },
  methods: {
    /**
    * Toggle and emit events
    */
    toggle: function toggle() {
      this.isOpen = !this.isOpen;
      this.$emit('update:open', this.isOpen);
      this.$emit(this.isOpen ? 'open' : 'close');
    }
  },
  render: function render(createElement) {
    var trigger = createElement('div', {
      staticClass: 'collapse-trigger',
      on: {
        click: this.toggle
      }
    }, this.$scopedSlots.trigger ? [this.$scopedSlots.trigger({
      open: this.isOpen
    })] : [this.$slots.trigger]);
    var content = createElement('transition', {
      props: {
        name: this.animation
      }
    }, [createElement('div', {
      staticClass: 'collapse-content',
      attrs: {
        'id': this.ariaId,
        'aria-expanded': this.isOpen
      },
      directives: [{
        name: 'show',
        value: this.isOpen
      }]
    }, this.$slots.default)]);
    return createElement('div', {
      staticClass: 'collapse'
    }, this.position === 'is-top' ? [trigger, content] : [content, trigger]);
  }
};

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Collapse = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["c" /* _ */])(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["d" /* r */])(Vue, Collapse);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "UZQh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return File; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HTMLElement; });
// Polyfills for SSR
var isSSR = typeof window === 'undefined';
var HTMLElement = isSSR ? Object : window.HTMLElement;
var File = isSSR ? Object : window.File;




/***/ }),

/***/ "UuGF":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "V5O4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VueInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setVueInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setOptions; });
var config = {
  defaultContainerElement: null,
  defaultIconPack: 'mdi',
  defaultIconComponent: null,
  defaultIconPrev: 'chevron-left',
  defaultIconNext: 'chevron-right',
  defaultDialogConfirmText: null,
  defaultDialogCancelText: null,
  defaultSnackbarDuration: 3500,
  defaultSnackbarPosition: null,
  defaultToastDuration: 2000,
  defaultToastPosition: null,
  defaultNotificationDuration: 2000,
  defaultNotificationPosition: null,
  defaultTooltipType: 'is-primary',
  defaultTooltipAnimated: false,
  defaultTooltipDelay: 0,
  defaultInputAutocomplete: 'on',
  defaultDateFormatter: null,
  defaultDateParser: null,
  defaultDateCreator: null,
  defaultTimeCreator: null,
  defaultDayNames: null,
  defaultMonthNames: null,
  defaultFirstDayOfWeek: null,
  defaultUnselectableDaysOfWeek: null,
  defaultTimeFormatter: null,
  defaultTimeParser: null,
  defaultModalCanCancel: ['escape', 'x', 'outside', 'button'],
  defaultModalScroll: null,
  defaultDatepickerMobileNative: true,
  defaultTimepickerMobileNative: true,
  defaultNoticeQueue: true,
  defaultInputHasCounter: true,
  defaultTaginputHasCounter: true,
  defaultUseHtml5Validation: true,
  defaultDropdownMobileModal: true,
  defaultFieldLabelPosition: null,
  defaultDatepickerYearsRange: [-100, 3],
  defaultDatepickerNearbyMonthDays: true,
  defaultDatepickerNearbySelectableMonthDays: false,
  defaultDatepickerShowWeekNumber: false,
  defaultDatepickerMobileModal: true,
  defaultTrapFocus: false,
  defaultButtonRounded: false,
  defaultCarouselInterval: 3500,
  defaultTabsAnimated: true,
  defaultLinkTags: ['a', 'button', 'input', 'router-link', 'nuxt-link', 'n-link', 'RouterLink', 'NuxtLink', 'NLink'],
  customIconPacks: null
}; // TODO defaultTrapFocus to true in the next breaking change
var setOptions = function setOptions(options) {
  config = options;
};
var setVueInstance = function setVueInstance(Vue) {
  VueInstance = Vue;
};
var VueInstance;




/***/ }),

/***/ "VU/8":
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "Vd1k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BSnackbar */
/* unused harmony export SnackbarProgrammatic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_53640c15_js__ = __webpack_require__("kGGF");






//
var script = {
  name: 'BSnackbar',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__chunk_53640c15_js__["a" /* N */]],
  props: {
    actionText: {
      type: String,
      default: 'OK'
    },
    onAction: {
      type: Function,
      default: function _default() {}
    },
    indefinite: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      newDuration: this.duration || __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultSnackbarDuration
    };
  },
  methods: {
    /**
    * Click listener.
    * Call action prop before closing (from Mixin).
    */
    action: function action() {
      this.onAction();
      this.close();
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"enter-active-class":_vm.transition.enter,"leave-active-class":_vm.transition.leave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"snackbar",class:[_vm.type,_vm.position],attrs:{"role":_vm.actionText ? 'alertdialog' : 'alert'}},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),(_vm.actionText)?_c('div',{staticClass:"action",class:_vm.type,on:{"click":_vm.action}},[_c('button',{staticClass:"button"},[_vm._v(_vm._s(_vm.actionText))])]):_vm._e()])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Snackbar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var localVueInstance;
var SnackbarProgrammatic = {
  open: function open(params) {
    var parent;

    if (typeof params === 'string') {
      params = {
        message: params
      };
    }

    var defaultParam = {
      type: 'is-success',
      position: __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultSnackbarPosition || 'is-bottom-right'
    };

    if (params.parent) {
      parent = params.parent;
      delete params.parent;
    }

    var propsData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* merge */])(defaultParam, params);
    var vm = typeof window !== 'undefined' && window.Vue ? window.Vue : localVueInstance || __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["d" /* V */];
    var SnackbarComponent = vm.extend(Snackbar);
    return new SnackbarComponent({
      parent: parent,
      el: document.createElement('div'),
      propsData: propsData
    });
  }
};
var Plugin = {
  install: function install(Vue) {
    localVueInstance = Vue;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["a"])(Vue, 'snackbar', SnackbarProgrammatic);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "W2nU":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "X8DO":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "Xd32":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+tPU");
__webpack_require__("zQR9");
module.exports = __webpack_require__("5PlU");


/***/ }),

/***/ "XmWM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var buildURL = __webpack_require__("DQCr");
var InterceptorManager = __webpack_require__("fuGk");
var dispatchRequest = __webpack_require__("xLtR");
var mergeConfig = __webpack_require__("DUeU");
var validator = __webpack_require__("/506");

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "Xxa5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("jyFz");


/***/ }),

/***/ "YEJw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BNumberinput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_d0a313ea_js__ = __webpack_require__("EmVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__ = __webpack_require__("QR9R");








var _components;
var script = {
  name: 'BNumberinput',
  components: (_components = {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__["a" /* I */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__["a" /* I */]), _components),
  mixins: [__WEBPACK_IMPORTED_MODULE_3__chunk_d0a313ea_js__["a" /* F */]],
  inheritAttrs: false,
  props: {
    value: Number,
    min: [Number, String],
    max: [Number, String],
    step: [Number, String],
    disabled: Boolean,
    type: {
      type: String,
      default: 'is-primary'
    },
    editable: {
      type: Boolean,
      default: true
    },
    controls: {
      type: Boolean,
      default: true
    },
    controlsRounded: {
      type: Boolean,
      default: false
    },
    controlsPosition: String
  },
  data: function data() {
    return {
      newValue: !isNaN(this.value) ? this.value : parseFloat(this.min) || 0,
      newStep: this.step || 1,
      _elementRef: 'input'
    };
  },
  computed: {
    computedValue: {
      get: function get() {
        return this.newValue;
      },
      set: function set(value) {
        var newValue = value;

        if (value === '') {
          newValue = parseFloat(this.min) || null;
        }

        this.newValue = newValue;
        this.$emit('input', newValue);
        !this.isValid && this.$refs.input.checkHtml5Validity();
      }
    },
    fieldClasses: function fieldClasses() {
      return [{
        'has-addons': this.controlsPosition === 'compact'
      }, {
        'is-grouped': this.controlsPosition !== 'compact'
      }, {
        'is-expanded': this.expanded
      }];
    },
    buttonClasses: function buttonClasses() {
      return [this.type, this.size, {
        'is-rounded': this.controlsRounded
      }];
    },
    minNumber: function minNumber() {
      return typeof this.min === 'string' ? parseFloat(this.min) : this.min;
    },
    maxNumber: function maxNumber() {
      return typeof this.max === 'string' ? parseFloat(this.max) : this.max;
    },
    stepNumber: function stepNumber() {
      return typeof this.newStep === 'string' ? parseFloat(this.newStep) : this.newStep;
    },
    disabledMin: function disabledMin() {
      return this.computedValue - this.stepNumber < this.minNumber;
    },
    disabledMax: function disabledMax() {
      return this.computedValue + this.stepNumber > this.maxNumber;
    },
    stepDecimals: function stepDecimals() {
      var step = this.stepNumber.toString();
      var index = step.indexOf('.');

      if (index >= 0) {
        return step.substring(index + 1).length;
      }

      return 0;
    }
  },
  watch: {
    /**
    * When v-model is changed:
    *   1. Set internal value.
    */
    value: function value(_value) {
      this.newValue = _value;
    }
  },
  methods: {
    decrement: function decrement() {
      if (typeof this.minNumber === 'undefined' || this.computedValue - this.stepNumber >= this.minNumber) {
        var value = this.computedValue - this.stepNumber;
        this.computedValue = parseFloat(value.toFixed(this.stepDecimals));
      }
    },
    increment: function increment() {
      if (typeof this.maxNumber === 'undefined' || this.computedValue + this.stepNumber <= this.maxNumber) {
        var value = this.computedValue + this.stepNumber;
        this.computedValue = parseFloat(value.toFixed(this.stepDecimals));
      }
    },
    onControlClick: function onControlClick(event, inc) {
      // IE 11 -> filter click event
      if (event.detail !== 0 || event.type === 'click') return;
      if (inc) this.increment();else this.decrement();
    },
    onStartLongPress: function onStartLongPress(event, inc) {
      var _this = this;

      if (event.button !== 0 && event.type !== 'touchstart') return;
      this._$intervalTime = new Date();
      clearInterval(this._$intervalRef);
      this._$intervalRef = setInterval(function () {
        if (inc) _this.increment();else _this.decrement();
      }, 250);
    },
    onStopLongPress: function onStopLongPress(inc) {
      if (!this._$intervalRef) return;
      var d = new Date();

      if (d - this._$intervalTime < 250) {
        if (inc) this.increment();else this.decrement();
      }

      clearInterval(this._$intervalRef);
      this._$intervalRef = null;
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-numberinput field",class:_vm.fieldClasses},[(_vm.controls)?_c('p',{staticClass:"control",on:{"mouseup":function($event){_vm.onStopLongPress(false);},"mouseleave":function($event){_vm.onStopLongPress(false);},"touchend":function($event){_vm.onStopLongPress(false);},"touchcancel":function($event){_vm.onStopLongPress(false);}}},[_c('button',{staticClass:"button",class:_vm.buttonClasses,attrs:{"type":"button","disabled":_vm.disabled || _vm.disabledMin},on:{"mousedown":function($event){_vm.onStartLongPress($event, false);},"touchstart":function($event){$event.preventDefault();_vm.onStartLongPress($event, false);},"click":function($event){_vm.onControlClick($event, false);}}},[_c('b-icon',{attrs:{"icon":"minus","both":"","pack":_vm.iconPack,"size":_vm.iconSize}})],1)]):_vm._e(),_vm._v(" "),_c('b-input',_vm._b({ref:"input",attrs:{"type":"number","step":_vm.newStep,"max":_vm.max,"min":_vm.min,"size":_vm.size,"disabled":_vm.disabled,"readonly":!_vm.editable,"loading":_vm.loading,"rounded":_vm.rounded,"icon":_vm.icon,"icon-pack":_vm.iconPack,"autocomplete":_vm.autocomplete,"expanded":_vm.expanded,"use-html5-validation":_vm.useHtml5Validation},on:{"focus":function($event){_vm.$emit('focus', $event);},"blur":function($event){_vm.$emit('blur', $event);}},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=_vm._n($$v);},expression:"computedValue"}},'b-input',_vm.$attrs,false)),_vm._v(" "),(_vm.controls)?_c('p',{staticClass:"control",on:{"mouseup":function($event){_vm.onStopLongPress(true);},"mouseleave":function($event){_vm.onStopLongPress(true);},"touchend":function($event){_vm.onStopLongPress(true);},"touchcancel":function($event){_vm.onStopLongPress(true);}}},[_c('button',{staticClass:"button",class:_vm.buttonClasses,attrs:{"type":"button","disabled":_vm.disabled || _vm.disabledMax},on:{"mousedown":function($event){_vm.onStartLongPress($event, true);},"touchstart":function($event){$event.preventDefault();_vm.onStartLongPress($event, true);},"click":function($event){_vm.onControlClick($event, true);}}},[_c('b-icon',{attrs:{"icon":"plus","both":"","pack":_vm.iconPack,"size":_vm.iconSize}})],1)]):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Numberinput = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["d" /* r */])(Vue, Numberinput);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "Yobk":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("77Pl");
var dPs = __webpack_require__("qio6");
var enumBugKeys = __webpack_require__("xnc9");
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("ON07")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("RPLV").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "Z339":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BNotification */
/* unused harmony export NotificationProgrammatic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_0e26d208_js__ = __webpack_require__("1Wsa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chunk_53640c15_js__ = __webpack_require__("kGGF");








//
var script = {
  name: 'BNotification',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__chunk_0e26d208_js__["a" /* M */]],
  props: {
    position: String,
    ariaCloseLabel: String,
    animation: {
      type: String,
      default: 'fade'
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.animation}},[_c('article',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"notification",class:[_vm.type, _vm.position]},[(_vm.closable)?_c('button',{staticClass:"delete",attrs:{"type":"button","aria-label":_vm.ariaCloseLabel},on:{"click":_vm.close}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media"},[(_vm.computedIcon && _vm.hasIcon)?_c('div',{staticClass:"media-left"},[_c('b-icon',{attrs:{"icon":_vm.computedIcon,"pack":_vm.iconPack,"both":"","size":"is-large","aria-hidden":""}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-content"},[(_vm.message)?_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._t("default")],2)])])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Notification = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//
var script$1 = {
  name: 'BNotificationNotice',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__chunk_53640c15_js__["a" /* N */]],
  props: {
    indefinite: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      newDuration: this.duration || __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultNotificationDuration
    };
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-notification',_vm._b({on:{"close":_vm.close}},'b-notification',_vm.$options.propsData,false))};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var NotificationNotice = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

var localVueInstance;
var NotificationProgrammatic = {
  open: function open(params) {
    var parent;

    if (typeof params === 'string') {
      params = {
        message: params
      };
    }

    var defaultParam = {
      position: __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultNotificationPosition || 'is-top-right'
    };

    if (params.parent) {
      parent = params.parent;
      delete params.parent;
    }

    var propsData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* merge */])(defaultParam, params);
    var vm = typeof window !== 'undefined' && window.Vue ? window.Vue : localVueInstance || __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["d" /* V */];
    var NotificationNoticeComponent = vm.extend(NotificationNotice);
    return new NotificationNoticeComponent({
      parent: parent,
      el: document.createElement('div'),
      propsData: propsData
    });
  }
};
var Plugin = {
  install: function install(Vue) {
    localVueInstance = Vue;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, Notification);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["a"])(Vue, 'notification', NotificationProgrammatic);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "ZJkx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* unused harmony reexport BIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__ = __webpack_require__("rhEV");







var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */]);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);


/***/ }),

/***/ "a5T5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_d0a313ea_js__ = __webpack_require__("EmVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__ = __webpack_require__("QR9R");
/* unused harmony reexport BInput */









var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["d" /* r */])(Vue, __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__["a" /* I */]);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);


/***/ }),

/***/ "aGWY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Modal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_42f463e6_js__ = __webpack_require__("mMDG");





//
var script = {
  name: 'BModal',
  directives: {
    trapFocus: __WEBPACK_IMPORTED_MODULE_3__chunk_42f463e6_js__["a" /* t */]
  },
  props: {
    active: Boolean,
    component: [Object, Function],
    content: String,
    programmatic: Boolean,
    props: Object,
    events: Object,
    width: {
      type: [String, Number],
      default: 960
    },
    hasModalCard: Boolean,
    animation: {
      type: String,
      default: 'zoom-out'
    },
    canCancel: {
      type: [Array, Boolean],
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultModalCanCancel;
      }
    },
    onCancel: {
      type: Function,
      default: function _default() {}
    },
    scroll: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultModalScroll ? __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultModalScroll : 'clip';
      },
      validator: function validator(value) {
        return ['clip', 'keep'].indexOf(value) >= 0;
      }
    },
    fullScreen: Boolean,
    trapFocus: {
      type: Boolean,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultTrapFocus;
      }
    },
    customClass: String,
    ariaRole: {
      type: String,
      validator: function validator(value) {
        return ['dialog', 'alertdialog'].indexOf(value) >= 0;
      }
    },
    ariaModal: Boolean,
    destroyOnHide: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isActive: this.active || false,
      savedScrollTop: null,
      newWidth: typeof this.width === 'number' ? this.width + 'px' : this.width,
      animating: true,
      destroyed: !this.active
    };
  },
  computed: {
    cancelOptions: function cancelOptions() {
      return typeof this.canCancel === 'boolean' ? this.canCancel ? __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultModalCanCancel : [] : this.canCancel;
    },
    showX: function showX() {
      return this.cancelOptions.indexOf('x') >= 0;
    },
    customStyle: function customStyle() {
      if (!this.fullScreen) {
        return {
          maxWidth: this.newWidth
        };
      }

      return null;
    }
  },
  watch: {
    active: function active(value) {
      this.isActive = value;
    },
    isActive: function isActive(value) {
      var _this = this;

      if (value) this.destroyed = false;
      this.handleScroll();
      this.$nextTick(function () {
        if (value && _this.$el && _this.$el.focus) {
          _this.$el.focus();
        }
      });
    }
  },
  methods: {
    handleScroll: function handleScroll() {
      if (typeof window === 'undefined') return;

      if (this.scroll === 'clip') {
        if (this.isActive) {
          document.documentElement.classList.add('is-clipped');
        } else {
          document.documentElement.classList.remove('is-clipped');
        }

        return;
      }

      this.savedScrollTop = !this.savedScrollTop ? document.documentElement.scrollTop : this.savedScrollTop;

      if (this.isActive) {
        document.body.classList.add('is-noscroll');
      } else {
        document.body.classList.remove('is-noscroll');
      }

      if (this.isActive) {
        document.body.style.top = "-".concat(this.savedScrollTop, "px");
        return;
      }

      document.documentElement.scrollTop = this.savedScrollTop;
      document.body.style.top = null;
      this.savedScrollTop = null;
    },

    /**
    * Close the Modal if canCancel and call the onCancel prop (function).
    */
    cancel: function cancel(method) {
      if (this.cancelOptions.indexOf(method) < 0) return;
      this.onCancel.apply(null, arguments);
      this.close();
    },

    /**
    * Call the onCancel prop (function).
    * Emit events, and destroy modal if it's programmatic.
    */
    close: function close() {
      var _this2 = this;

      this.$emit('close');
      this.$emit('update:active', false); // Timeout for the animation complete before destroying

      if (this.programmatic) {
        this.isActive = false;
        setTimeout(function () {
          _this2.$destroy();

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_js__["b" /* removeElement */])(_this2.$el);
        }, 150);
      }
    },

    /**
    * Keypress event that is bound to the document.
    */
    keyPress: function keyPress(event) {
      // Esc key
      if (this.isActive && event.keyCode === 27) this.cancel('escape');
    },

    /**
    * Transition after-enter hook
    */
    afterEnter: function afterEnter() {
      this.animating = false;
    },

    /**
    * Transition before-leave hook
    */
    beforeLeave: function beforeLeave() {
      this.animating = true;
    },

    /**
    * Transition after-leave hook
    */
    afterLeave: function afterLeave() {
      if (this.destroyOnHide) {
        this.destroyed = true;
      }
    }
  },
  created: function created() {
    if (typeof window !== 'undefined') {
      document.addEventListener('keyup', this.keyPress);
    }
  },
  beforeMount: function beforeMount() {
    // Insert the Modal component in body tag
    // only if it's programmatic
    this.programmatic && document.body.appendChild(this.$el);
  },
  mounted: function mounted() {
    if (this.programmatic) this.isActive = true;else if (this.isActive) this.handleScroll();
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      document.removeEventListener('keyup', this.keyPress); // reset scroll

      document.documentElement.classList.remove('is-clipped');
      var savedScrollTop = !this.savedScrollTop ? document.documentElement.scrollTop : this.savedScrollTop;
      document.body.classList.remove('is-noscroll');
      document.documentElement.scrollTop = savedScrollTop;
      document.body.style.top = null;
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.animation},on:{"after-enter":_vm.afterEnter,"before-leave":_vm.beforeLeave,"after-leave":_vm.afterLeave}},[(!_vm.destroyed)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"},{name:"trap-focus",rawName:"v-trap-focus",value:(_vm.trapFocus),expression:"trapFocus"}],staticClass:"modal is-active",class:[{'is-full-screen': _vm.fullScreen}, _vm.customClass],attrs:{"tabindex":"-1","role":_vm.ariaRole,"aria-modal":_vm.ariaModal}},[_c('div',{staticClass:"modal-background",on:{"click":function($event){_vm.cancel('outside');}}}),_vm._v(" "),_c('div',{staticClass:"animation-content",class:{ 'modal-content': !_vm.hasModalCard },style:(_vm.customStyle)},[(_vm.component)?_c(_vm.component,_vm._g(_vm._b({tag:"component",on:{"close":_vm.close}},'component',_vm.props,false),_vm.events)):(_vm.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._t("default"),_vm._v(" "),(_vm.showX)?_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.animating),expression:"!animating"}],staticClass:"modal-close is-large",attrs:{"type":"button"},on:{"click":function($event){_vm.cancel('x');}}}):_vm._e()],2)]):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Modal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );




/***/ }),

/***/ "ajTP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Datepicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_d0a313ea_js__ = __webpack_require__("EmVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__ = __webpack_require__("QR9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chunk_4d76806f_js__ = __webpack_require__("t4YS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chunk_eb60b35a_js__ = __webpack_require__("RbWz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__chunk_77ffdf8b_js__ = __webpack_require__("8cDm");











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'BDatepickerTableRow',
  props: {
    selectedDate: {
      type: [Date, Array]
    },
    hoveredDateRange: Array,
    day: {
      type: Number
    },
    week: {
      type: Array,
      required: true
    },
    month: {
      type: Number,
      required: true
    },
    minDate: Date,
    maxDate: Date,
    disabled: Boolean,
    unselectableDates: Array,
    unselectableDaysOfWeek: Array,
    selectableDates: Array,
    events: Array,
    indicators: String,
    dateCreator: Function,
    nearbyMonthDays: Boolean,
    nearbySelectableMonthDays: Boolean,
    showWeekNumber: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    range: Boolean,
    multiple: Boolean,
    rulesForFirstWeek: {
      type: Number,
      default: function _default() {
        return 4;
      }
    },
    firstDayOfWeek: Number
  },
  watch: {
    day: {
      handler: function handler(day) {
        var _this = this;

        var refName = "day-".concat(day);

        if (this.$refs[refName] && this.$refs[refName].length > 0) {
          this.$nextTick(function () {
            if (_this.$refs[refName][0]) {
              _this.$refs[refName][0].focus();
            }
          }); // $nextTick needed when month is changed
        }
      },
      immediate: true
    }
  },
  methods: {
    firstWeekOffset: function firstWeekOffset(year, dow, doy) {
      // first-week day -- which january is always in the first week (4 for iso, 1 for other)
      var fwd = 7 + dow - doy; // first-week day local weekday -- which local weekday is fwd

      var firstJanuary = new Date(year, 0, fwd);
      var fwdlw = (7 + firstJanuary.getDay() - dow) % 7;
      return -fwdlw + fwd - 1;
    },
    daysInYear: function daysInYear(year) {
      return this.isLeapYear(year) ? 366 : 365;
    },
    isLeapYear: function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    },
    getSetDayOfYear: function getSetDayOfYear(input) {
      return Math.round((input - new Date(input.getFullYear(), 0, 1)) / 864e5) + 1;
    },
    weeksInYear: function weeksInYear(year, dow, doy) {
      var weekOffset = this.firstWeekOffset(year, dow, doy);
      var weekOffsetNext = this.firstWeekOffset(year + 1, dow, doy);
      return (this.daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    },
    getWeekNumber: function getWeekNumber(mom) {
      var dow = this.firstDayOfWeek; // first day of week
      // Rules for the first week : 1 for the 1st January, 4 for the 4th January

      var doy = this.rulesForFirstWeek;
      var weekOffset = this.firstWeekOffset(mom.getFullYear(), dow, doy);
      var week = Math.floor((this.getSetDayOfYear(mom) - weekOffset - 1) / 7) + 1;
      var resWeek;
      var resYear;

      if (week < 1) {
        resYear = mom.getFullYear() - 1;
        resWeek = week + this.weeksInYear(resYear, dow, doy);
      } else if (week > this.weeksInYear(mom.getFullYear(), dow, doy)) {
        resWeek = week - this.weeksInYear(mom.getFullYear(), dow, doy);
        resYear = mom.getFullYear() + 1;
      } else {
        resYear = mom.getFullYear();
        resWeek = week;
      }

      return resWeek;
    },

    /*
     * Check that selected day is within earliest/latest params and
     * is within this month
     */
    selectableDate: function selectableDate(day) {
      var validity = [];

      if (this.minDate) {
        validity.push(day >= this.minDate);
      }

      if (this.maxDate) {
        validity.push(day <= this.maxDate);
      }

      if (this.nearbyMonthDays && !this.nearbySelectableMonthDays) {
        validity.push(day.getMonth() === this.month);
      }

      if (this.selectableDates) {
        for (var i = 0; i < this.selectableDates.length; i++) {
          var enabledDate = this.selectableDates[i];

          if (day.getDate() === enabledDate.getDate() && day.getFullYear() === enabledDate.getFullYear() && day.getMonth() === enabledDate.getMonth()) {
            return true;
          } else {
            validity.push(false);
          }
        }
      }

      if (this.unselectableDates) {
        for (var _i = 0; _i < this.unselectableDates.length; _i++) {
          var disabledDate = this.unselectableDates[_i];
          validity.push(day.getDate() !== disabledDate.getDate() || day.getFullYear() !== disabledDate.getFullYear() || day.getMonth() !== disabledDate.getMonth());
        }
      }

      if (this.unselectableDaysOfWeek) {
        for (var _i2 = 0; _i2 < this.unselectableDaysOfWeek.length; _i2++) {
          var dayOfWeek = this.unselectableDaysOfWeek[_i2];
          validity.push(day.getDay() !== dayOfWeek);
        }
      }

      return validity.indexOf(false) < 0;
    },

    /*
    * Emit select event with chosen date as payload
    */
    emitChosenDate: function emitChosenDate(day) {
      if (this.disabled) return;

      if (this.selectableDate(day)) {
        this.$emit('select', day);
      }
    },
    eventsDateMatch: function eventsDateMatch(day) {
      if (!this.events || !this.events.length) return false;
      var dayEvents = [];

      for (var i = 0; i < this.events.length; i++) {
        if (this.events[i].date.getDay() === day.getDay()) {
          dayEvents.push(this.events[i]);
        }
      }

      if (!dayEvents.length) {
        return false;
      }

      return dayEvents;
    },

    /*
    * Build classObject for cell using validations
    */
    classObject: function classObject(day) {
      function dateMatch(dateOne, dateTwo, multiple) {
        // if either date is null or undefined, return false
        // if using multiple flag, return false
        if (!dateOne || !dateTwo || multiple) {
          return false;
        }

        if (Array.isArray(dateTwo)) {
          return dateTwo.some(function (date) {
            return dateOne.getDate() === date.getDate() && dateOne.getFullYear() === date.getFullYear() && dateOne.getMonth() === date.getMonth();
          });
        }

        return dateOne.getDate() === dateTwo.getDate() && dateOne.getFullYear() === dateTwo.getFullYear() && dateOne.getMonth() === dateTwo.getMonth();
      }

      function dateWithin(dateOne, dates, multiple) {
        if (!Array.isArray(dates) || multiple) {
          return false;
        }

        return dateOne > dates[0] && dateOne < dates[1];
      }

      return {
        'is-selected': dateMatch(day, this.selectedDate) || dateWithin(day, this.selectedDate, this.multiple),
        'is-first-selected': dateMatch(day, Array.isArray(this.selectedDate) && this.selectedDate[0], this.multiple),
        'is-within-selected': dateWithin(day, this.selectedDate, this.multiple),
        'is-last-selected': dateMatch(day, Array.isArray(this.selectedDate) && this.selectedDate[1], this.multiple),
        'is-within-hovered-range': this.hoveredDateRange && this.hoveredDateRange.length === 2 && (dateMatch(day, this.hoveredDateRange) || dateWithin(day, this.hoveredDateRange)),
        'is-first-hovered': dateMatch(day, Array.isArray(this.hoveredDateRange) && this.hoveredDateRange[0]),
        'is-within-hovered': dateWithin(day, this.hoveredDateRange),
        'is-last-hovered': dateMatch(day, Array.isArray(this.hoveredDateRange) && this.hoveredDateRange[1]),
        'is-today': dateMatch(day, this.dateCreator()),
        'is-selectable': this.selectableDate(day) && !this.disabled,
        'is-unselectable': !this.selectableDate(day) || this.disabled,
        'is-invisible': !this.nearbyMonthDays && day.getMonth() !== this.month,
        'is-nearby': this.nearbySelectableMonthDays && day.getMonth() !== this.month
      };
    },
    setRangeHoverEndDate: function setRangeHoverEndDate(day) {
      if (this.range) {
        this.$emit('rangeHoverEndDate', day);
      }
    },
    changeFocus: function changeFocus(day, inc) {
      var nextDay = day;
      nextDay.setDate(day.getDate() + inc);
      this.$emit('change-focus', nextDay);
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datepicker-row"},[(_vm.showWeekNumber)?_c('a',{staticClass:"datepicker-cell is-week-number"},[_c('span',[_vm._v(_vm._s(_vm.getWeekNumber(_vm.week[6])))])]):_vm._e(),_vm._v(" "),_vm._l((_vm.week),function(weekDay,index){return [(_vm.selectableDate(weekDay) && !_vm.disabled)?_c('a',{key:index,ref:("day-" + (weekDay.getDate())),refInFor:true,staticClass:"datepicker-cell",class:[_vm.classObject(weekDay), {'has-event': _vm.eventsDateMatch(weekDay)}, _vm.indicators],attrs:{"role":"button","href":"#","disabled":_vm.disabled,"tabindex":_vm.day === weekDay.getDate() ? null : -1},on:{"click":function($event){$event.preventDefault();_vm.emitChosenDate(weekDay);},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();_vm.emitChosenDate(weekDay);},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();_vm.emitChosenDate(weekDay);},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"arrow-left",undefined,$event.key,undefined)){ return null; }$event.preventDefault();_vm.changeFocus(weekDay, -1);},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"arrow-right",undefined,$event.key,undefined)){ return null; }$event.preventDefault();_vm.changeFocus(weekDay, 1);},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"arrow-up",undefined,$event.key,undefined)){ return null; }$event.preventDefault();_vm.changeFocus(weekDay, -7);},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"arrow-down",undefined,$event.key,undefined)){ return null; }$event.preventDefault();_vm.changeFocus(weekDay, 7);}],"mouseenter":function($event){_vm.setRangeHoverEndDate(weekDay);}}},[_c('span',[_vm._v(_vm._s(weekDay.getDate()))]),_vm._v(" "),(_vm.eventsDateMatch(weekDay))?_c('div',{staticClass:"events"},_vm._l((_vm.eventsDateMatch(weekDay)),function(event,index){return _c('div',{key:index,staticClass:"event",class:event.type})})):_vm._e()]):_c('div',{key:index,staticClass:"datepicker-cell",class:_vm.classObject(weekDay)},[_c('span',[_vm._v(_vm._s(weekDay.getDate()))])])]})],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var DatepickerTableRow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var isDefined = function isDefined(d) {
  return d !== undefined;
};

var script$1 = {
  name: 'BDatepickerTable',
  components: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({}, DatepickerTableRow.name, DatepickerTableRow),
  props: {
    value: {
      type: [Date, Array]
    },
    dayNames: Array,
    monthNames: Array,
    firstDayOfWeek: Number,
    events: Array,
    indicators: String,
    minDate: Date,
    maxDate: Date,
    focused: Object,
    disabled: Boolean,
    dateCreator: Function,
    unselectableDates: Array,
    unselectableDaysOfWeek: Array,
    selectableDates: Array,
    nearbyMonthDays: Boolean,
    nearbySelectableMonthDays: Boolean,
    showWeekNumber: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    rulesForFirstWeek: {
      type: Number,
      default: function _default() {
        return 4;
      }
    },
    range: Boolean,
    multiple: Boolean
  },
  data: function data() {
    return {
      selectedBeginDate: undefined,
      selectedEndDate: undefined,
      hoveredEndDate: undefined,
      multipleSelectedDates: this.multiple && this.value ? this.value : []
    };
  },
  computed: {
    visibleDayNames: function visibleDayNames() {
      var visibleDayNames = [];
      var index = this.firstDayOfWeek;

      while (visibleDayNames.length < this.dayNames.length) {
        var currentDayName = this.dayNames[index % this.dayNames.length];
        visibleDayNames.push(currentDayName);
        index++;
      }

      if (this.showWeekNumber) visibleDayNames.unshift('');
      return visibleDayNames;
    },
    hasEvents: function hasEvents() {
      return this.events && this.events.length;
    },

    /*
    * Return array of all events in the specified month
    */
    eventsInThisMonth: function eventsInThisMonth() {
      if (!this.events) return [];
      var monthEvents = [];

      for (var i = 0; i < this.events.length; i++) {
        var event = this.events[i];

        if (!event.hasOwnProperty('date')) {
          event = {
            date: event
          };
        }

        if (!event.hasOwnProperty('type')) {
          event.type = 'is-primary';
        }

        if (event.date.getMonth() === this.focused.month && event.date.getFullYear() === this.focused.year) {
          monthEvents.push(event);
        }
      }

      return monthEvents;
    },

    /*
    * Return array of all weeks in the specified month
    */
    weeksInThisMonth: function weeksInThisMonth() {
      this.validateFocusedDay();
      var month = this.focused.month;
      var year = this.focused.year;
      var weeksInThisMonth = [];
      var startingDay = 1;

      while (weeksInThisMonth.length < 6) {
        var newWeek = this.weekBuilder(startingDay, month, year);
        weeksInThisMonth.push(newWeek);
        startingDay += 7;
      }

      return weeksInThisMonth;
    },
    hoveredDateRange: function hoveredDateRange() {
      if (!this.range) {
        return [];
      }

      if (!isNaN(this.selectedEndDate)) {
        return [];
      }

      if (this.hoveredEndDate < this.selectedBeginDate) {
        return [this.hoveredEndDate, this.selectedBeginDate].filter(isDefined);
      }

      return [this.selectedBeginDate, this.hoveredEndDate].filter(isDefined);
    }
  },
  methods: {
    /*
    * Emit input event with selected date as payload for v-model in parent
    */
    updateSelectedDate: function updateSelectedDate(date) {
      if (!this.range && !this.multiple) {
        this.$emit('input', date);
      } else if (this.range) {
        this.handleSelectRangeDate(date);
      } else if (this.multiple) {
        this.handleSelectMultipleDates(date);
      }
    },

    /*
    * If both begin and end dates are set, reset the end date and set the begin date.
    * If only begin date is selected, emit an array of the begin date and the new date.
    * If not set, only set the begin date.
    */
    handleSelectRangeDate: function handleSelectRangeDate(date) {
      if (this.selectedBeginDate && this.selectedEndDate) {
        this.selectedBeginDate = date;
        this.selectedEndDate = undefined;
        this.$emit('range-start', date);
      } else if (this.selectedBeginDate && !this.selectedEndDate) {
        if (this.selectedBeginDate > date) {
          this.selectedEndDate = this.selectedBeginDate;
          this.selectedBeginDate = date;
        } else {
          this.selectedEndDate = date;
        }

        this.$emit('range-end', date);
        this.$emit('input', [this.selectedBeginDate, this.selectedEndDate]);
      } else {
        this.selectedBeginDate = date;
        this.$emit('range-start', date);
      }
    },

    /*
    * If selected date already exists list of selected dates, remove it from the list
    * Otherwise, add date to list of selected dates
    */
    handleSelectMultipleDates: function handleSelectMultipleDates(date) {
      var multipleSelect = this.multipleSelectedDates.filter(function (selectedDate) {
        return selectedDate.getDate() === date.getDate() && selectedDate.getFullYear() === date.getFullYear() && selectedDate.getMonth() === date.getMonth();
      });

      if (multipleSelect.length) {
        this.multipleSelectedDates = this.multipleSelectedDates.filter(function (selectedDate) {
          return selectedDate.getDate() !== date.getDate() || selectedDate.getFullYear() !== date.getFullYear() || selectedDate.getMonth() !== date.getMonth();
        });
      } else {
        this.multipleSelectedDates.push(date);
      }

      this.$emit('input', this.multipleSelectedDates);
    },

    /*
     * Return array of all days in the week that the startingDate is within
     */
    weekBuilder: function weekBuilder(startingDate, month, year) {
      var thisMonth = new Date(year, month);
      var thisWeek = [];
      var dayOfWeek = new Date(year, month, startingDate).getDay();
      var end = dayOfWeek >= this.firstDayOfWeek ? dayOfWeek - this.firstDayOfWeek : 7 - this.firstDayOfWeek + dayOfWeek;
      var daysAgo = 1;

      for (var i = 0; i < end; i++) {
        thisWeek.unshift(new Date(thisMonth.getFullYear(), thisMonth.getMonth(), startingDate - daysAgo));
        daysAgo++;
      }

      thisWeek.push(new Date(year, month, startingDate));
      var daysForward = 1;

      while (thisWeek.length < 7) {
        thisWeek.push(new Date(year, month, startingDate + daysForward));
        daysForward++;
      }

      return thisWeek;
    },
    validateFocusedDay: function validateFocusedDay() {
      var focusedDate = new Date(this.focused.year, this.focused.month, this.focused.day);
      if (this.selectableDate(focusedDate)) return;
      var day = 0; // Number of days in the current month

      var monthDays = new Date(this.focused.year, this.focused.month + 1, 0).getDate();
      var firstFocusable = null;

      while (!firstFocusable && ++day < monthDays) {
        var date = new Date(this.focused.year, this.focused.month, day);

        if (this.selectableDate(date)) {
          firstFocusable = focusedDate;
          var focused = {
            day: date.getDate(),
            month: date.getMonth(),
            year: date.getFullYear()
          };
          this.$emit('update:focused', focused);
        }
      }
    },

    /*
     * Check that selected day is within earliest/latest params and
     * is within this month
     */
    selectableDate: function selectableDate(day) {
      var validity = [];

      if (this.minDate) {
        validity.push(day >= this.minDate);
      }

      if (this.maxDate) {
        validity.push(day <= this.maxDate);
      }

      if (this.nearbyMonthDays && !this.nearbySelectableMonthDays) {
        validity.push(day.getMonth() === this.focused.month);
      }

      if (this.selectableDates) {
        for (var i = 0; i < this.selectableDates.length; i++) {
          var enabledDate = this.selectableDates[i];

          if (day.getDate() === enabledDate.getDate() && day.getFullYear() === enabledDate.getFullYear() && day.getMonth() === enabledDate.getMonth()) {
            return true;
          } else {
            validity.push(false);
          }
        }
      }

      if (this.unselectableDates) {
        for (var _i = 0; _i < this.unselectableDates.length; _i++) {
          var disabledDate = this.unselectableDates[_i];
          validity.push(day.getDate() !== disabledDate.getDate() || day.getFullYear() !== disabledDate.getFullYear() || day.getMonth() !== disabledDate.getMonth());
        }
      }

      if (this.unselectableDaysOfWeek) {
        for (var _i2 = 0; _i2 < this.unselectableDaysOfWeek.length; _i2++) {
          var dayOfWeek = this.unselectableDaysOfWeek[_i2];
          validity.push(day.getDay() !== dayOfWeek);
        }
      }

      return validity.indexOf(false) < 0;
    },
    eventsInThisWeek: function eventsInThisWeek(week) {
      return this.eventsInThisMonth.filter(function (event) {
        var stripped = new Date(Date.parse(event.date));
        stripped.setHours(0, 0, 0, 0);
        var timed = stripped.getTime();
        return week.some(function (weekDate) {
          return weekDate.getTime() === timed;
        });
      });
    },
    setRangeHoverEndDate: function setRangeHoverEndDate(day) {
      this.hoveredEndDate = day;
    },
    changeFocus: function changeFocus(day) {
      var focused = {
        day: day.getDate(),
        month: day.getMonth(),
        year: day.getFullYear()
      };
      this.$emit('update:focused', focused);
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"datepicker-table"},[_c('header',{staticClass:"datepicker-header"},_vm._l((_vm.visibleDayNames),function(day,index){return _c('div',{key:index,staticClass:"datepicker-cell"},[_c('span',[_vm._v(_vm._s(day))])])})),_vm._v(" "),_c('div',{staticClass:"datepicker-body",class:{'has-events':_vm.hasEvents}},_vm._l((_vm.weeksInThisMonth),function(week,index){return _c('b-datepicker-table-row',{key:index,attrs:{"selected-date":_vm.value,"day":_vm.focused.day,"week":week,"month":_vm.focused.month,"min-date":_vm.minDate,"max-date":_vm.maxDate,"disabled":_vm.disabled,"unselectable-dates":_vm.unselectableDates,"unselectable-days-of-week":_vm.unselectableDaysOfWeek,"selectable-dates":_vm.selectableDates,"events":_vm.eventsInThisWeek(week),"indicators":_vm.indicators,"date-creator":_vm.dateCreator,"nearby-month-days":_vm.nearbyMonthDays,"nearby-selectable-month-days":_vm.nearbySelectableMonthDays,"show-week-number":_vm.showWeekNumber,"first-day-of-week":_vm.firstDayOfWeek,"rules-for-first-week":_vm.rulesForFirstWeek,"range":_vm.range,"hovered-date-range":_vm.hoveredDateRange,"multiple":_vm.multiple},on:{"select":_vm.updateSelectedDate,"rangeHoverEndDate":_vm.setRangeHoverEndDate,"change-focus":_vm.changeFocus}})}),1)])};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var DatepickerTable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$2 = {
  name: 'BDatepickerMonth',
  props: {
    value: {
      type: [Date, Array]
    },
    monthNames: Array,
    events: Array,
    indicators: String,
    minDate: Date,
    maxDate: Date,
    focused: Object,
    disabled: Boolean,
    dateCreator: Function,
    unselectableDates: Array,
    unselectableDaysOfWeek: Array,
    selectableDates: Array,
    multiple: Boolean
  },
  data: function data() {
    return {
      multipleSelectedDates: this.multiple && this.value ? this.value : []
    };
  },
  computed: {
    hasEvents: function hasEvents() {
      return this.events && this.events.length;
    },

    /*
    * Return array of all events in the specified month
    */
    eventsInThisYear: function eventsInThisYear() {
      if (!this.events) return [];
      var yearEvents = [];

      for (var i = 0; i < this.events.length; i++) {
        var event = this.events[i];

        if (!event.hasOwnProperty('date')) {
          event = {
            date: event
          };
        }

        if (!event.hasOwnProperty('type')) {
          event.type = 'is-primary';
        }

        if (event.date.getFullYear() === this.focused.year) {
          yearEvents.push(event);
        }
      }

      return yearEvents;
    },
    monthDates: function monthDates() {
      var year = this.focused.year;
      var months = [];

      for (var i = 0; i < 12; i++) {
        var d = new Date(year, i, 1);
        d.setHours(0, 0, 0, 0);
        months.push(d);
      }

      return months;
    },
    focusedMonth: function focusedMonth() {
      return this.focused.month;
    }
  },
  watch: {
    focusedMonth: {
      handler: function handler(month) {
        var _this = this;

        var refName = "month-".concat(month);

        if (this.$refs[refName] && this.$refs[refName].length > 0) {
          this.$nextTick(function () {
            if (_this.$refs[refName][0]) {
              _this.$refs[refName][0].focus();
            }
          }); // $nextTick needed when year is changed
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    selectMultipleDates: function selectMultipleDates(date) {
      var multipleSelect = this.multipleSelectedDates.filter(function (selectedDate) {
        return selectedDate.getDate() === date.getDate() && selectedDate.getFullYear() === date.getFullYear() && selectedDate.getMonth() === date.getMonth();
      });

      if (multipleSelect.length) {
        this.multipleSelectedDates = this.multipleSelectedDates.filter(function (selectedDate) {
          return selectedDate.getDate() !== date.getDate() || selectedDate.getFullYear() !== date.getFullYear() || selectedDate.getMonth() !== date.getMonth();
        });
      } else {
        this.multipleSelectedDates.push(date);
      }

      this.$emit('input', this.multipleSelectedDates);
    },
    selectableDate: function selectableDate(day) {
      var validity = [];

      if (this.minDate) {
        validity.push(day >= this.minDate);
      }

      if (this.maxDate) {
        validity.push(day <= this.maxDate);
      }

      validity.push(day.getFullYear() === this.focused.year);

      if (this.selectableDates) {
        for (var i = 0; i < this.selectableDates.length; i++) {
          var enabledDate = this.selectableDates[i];

          if (day.getFullYear() === enabledDate.getFullYear() && day.getMonth() === enabledDate.getMonth()) {
            return true;
          } else {
            validity.push(false);
          }
        }
      }

      if (this.unselectableDates) {
        for (var _i = 0; _i < this.unselectableDates.length; _i++) {
          var disabledDate = this.unselectableDates[_i];
          validity.push(day.getFullYear() !== disabledDate.getFullYear() || day.getMonth() !== disabledDate.getMonth());
        }
      }

      if (this.unselectableDaysOfWeek) {
        for (var _i2 = 0; _i2 < this.unselectableDaysOfWeek.length; _i2++) {
          var dayOfWeek = this.unselectableDaysOfWeek[_i2];
          validity.push(day.getDay() !== dayOfWeek);
        }
      }

      return validity.indexOf(false) < 0;
    },
    eventsDateMatch: function eventsDateMatch(day) {
      if (!this.eventsInThisYear.length) return false;
      var monthEvents = [];

      for (var i = 0; i < this.eventsInThisYear.length; i++) {
        if (this.eventsInThisYear[i].date.getMonth() === day.getMonth()) {
          monthEvents.push(this.events[i]);
        }
      }

      if (!monthEvents.length) {
        return false;
      }

      return monthEvents;
    },

    /*
    * Build classObject for cell using validations
    */
    classObject: function classObject(day) {
      function dateMatch(dateOne, dateTwo, multiple) {
        // if either date is null or undefined, return false
        if (!dateOne || !dateTwo || multiple) {
          return false;
        }

        return dateOne.getFullYear() === dateTwo.getFullYear() && dateOne.getMonth() === dateTwo.getMonth();
      }

      function dateMultipleSelected(dateOne, dates, multiple) {
        if (!Array.isArray(dates) || !multiple) {
          return false;
        }

        return dates.some(function (date) {
          return dateOne.getDate() === date.getDate() && dateOne.getFullYear() === date.getFullYear() && dateOne.getMonth() === date.getMonth();
        });
      }

      return {
        'is-selected': dateMatch(day, this.value, this.multiple) || dateMultipleSelected(day, this.multipleSelectedDates, this.multiple),
        'is-today': dateMatch(day, this.dateCreator()),
        'is-selectable': this.selectableDate(day) && !this.disabled,
        'is-unselectable': !this.selectableDate(day) || this.disabled
      };
    },

    /*
     * Emit select event with chosen date as payload
     */
    emitChosenDate: function emitChosenDate(day) {
      if (this.disabled) return;

      if (!this.multiple) {
        if (this.selectableDate(day)) {
          this.$emit('input', day);
        }
      } else {
        this.selectMultipleDates(day);
      }
    },
    changeFocus: function changeFocus(month, inc) {
      var nextMonth = month;
      nextMonth.setMonth(month.getMonth() + inc);
      this.$emit('change-focus', nextMonth);
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"datepicker-table"},[_c('div',{staticClass:"datepicker-body",class:{'has-events':_vm.hasEvents}},[_c('div',{staticClass:"datepicker-months"},[_vm._l((_vm.monthDates),function(date,index){return [(_vm.selectableDate(date) && !_vm.disabled)?_c('a',{key:index,ref:("month-" + (date.getMonth())),refInFor:true,staticClass:"datepicker-cell",class:[
                            _vm.classObject(date),
                            {'has-event': _vm.eventsDateMatch(date)},
                            _vm.indicators
                        ],attrs:{"role":"button","href":"#","disabled":_vm.disabled,"tabindex":_vm.focused.month === date.getMonth() ? null : -1},on:{"click":function($event){$event.preventDefault();_vm.emitChosenDate(date);},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();_vm.emitChosenDate(date);},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();_vm.emitChosenDate(date);},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"arrow-left",undefined,$event.key,undefined)){ return null; }$event.preventDefault();_vm.changeFocus(date, -1);},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"arrow-right",undefined,$event.key,undefined)){ return null; }$event.preventDefault();_vm.changeFocus(date, 1);},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"arrow-up",undefined,$event.key,undefined)){ return null; }$event.preventDefault();_vm.changeFocus(date, -3);},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"arrow-down",undefined,$event.key,undefined)){ return null; }$event.preventDefault();_vm.changeFocus(date, 3);}]}},[_vm._v("\r\n                        "+_vm._s(_vm.monthNames[date.getMonth()])+"\r\n                        "),(_vm.eventsDateMatch(date))?_c('div',{staticClass:"events"},_vm._l((_vm.eventsDateMatch(date)),function(event,index){return _c('div',{key:index,staticClass:"event",class:event.type})})):_vm._e()]):_c('div',{key:index,staticClass:"datepicker-cell",class:_vm.classObject(date)},[_vm._v("\r\n                        "+_vm._s(_vm.monthNames[date.getMonth()])+"\r\n                    ")])]})],2)])])};
var __vue_staticRenderFns__$2 = [];

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var DatepickerMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

var _components;

var defaultDateFormatter = function defaultDateFormatter(date, vm) {
  var targetDates = Array.isArray(date) ? date : [date];
  var dates = targetDates.map(function (date) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12);
    return !vm.isTypeMonth ? d.toLocaleDateString() : d.toLocaleDateString(undefined, {
      year: 'numeric',
      month: '2-digit'
    });
  });
  return !vm.multiple ? dates.join(' - ') : dates.join(', ');
};

var defaultDateParser = function defaultDateParser(date, vm) {
  if (!vm.isTypeMonth) return new Date(Date.parse(date));

  if (date) {
    var s = date.split('/');
    var year = s[0].length === 4 ? s[0] : s[1];
    var month = s[0].length === 2 ? s[0] : s[1];

    if (year && month) {
      return new Date(parseInt(year, 10), parseInt(month - 1, 10), 1, 0, 0, 0, 0);
    }
  }

  return null;
};

var script$3 = {
  name: 'BDatepicker',
  components: (_components = {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, DatepickerTable.name, DatepickerTable), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, DatepickerMonth.name, DatepickerMonth), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__["a" /* I */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_8__chunk_eb60b35a_js__["a" /* F */].name, __WEBPACK_IMPORTED_MODULE_8__chunk_eb60b35a_js__["a" /* F */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_9__chunk_77ffdf8b_js__["a" /* S */].name, __WEBPACK_IMPORTED_MODULE_9__chunk_77ffdf8b_js__["a" /* S */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__["a" /* I */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_7__chunk_4d76806f_js__["a" /* D */].name, __WEBPACK_IMPORTED_MODULE_7__chunk_4d76806f_js__["a" /* D */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_7__chunk_4d76806f_js__["b" /* a */].name, __WEBPACK_IMPORTED_MODULE_7__chunk_4d76806f_js__["b" /* a */]), _components),
  mixins: [__WEBPACK_IMPORTED_MODULE_3__chunk_d0a313ea_js__["a" /* F */]],
  inheritAttrs: false,
  props: {
    value: {
      type: [Date, Array]
    },
    dayNames: {
      type: Array,
      default: function _default() {
        if (Array.isArray(__WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDayNames)) {
          return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDayNames;
        } else {
          return ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'S'];
        }
      }
    },
    monthNames: {
      type: Array,
      default: function _default() {
        if (Array.isArray(__WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultMonthNames)) {
          return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultMonthNames;
        } else {
          return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        }
      }
    },
    firstDayOfWeek: {
      type: Number,
      default: function _default() {
        if (typeof __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultFirstDayOfWeek === 'number') {
          return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultFirstDayOfWeek;
        } else {
          return 0;
        }
      }
    },
    inline: Boolean,
    minDate: Date,
    maxDate: Date,
    focusedDate: Date,
    placeholder: String,
    editable: Boolean,
    disabled: Boolean,
    horizontalTimePicker: Boolean,
    unselectableDates: Array,
    unselectableDaysOfWeek: {
      type: Array,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultUnselectableDaysOfWeek;
      }
    },
    selectableDates: Array,
    dateFormatter: {
      type: Function,
      default: function _default(date, vm) {
        if (typeof __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDateFormatter === 'function') {
          return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDateFormatter(date);
        } else {
          return defaultDateFormatter(date, vm);
        }
      }
    },
    dateParser: {
      type: Function,
      default: function _default(date, vm) {
        if (typeof __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDateParser === 'function') {
          return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDateParser(date);
        } else {
          return defaultDateParser(date, vm);
        }
      }
    },
    dateCreator: {
      type: Function,
      default: function _default() {
        if (typeof __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDateCreator === 'function') {
          return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDateCreator();
        } else {
          return new Date();
        }
      }
    },
    mobileNative: {
      type: Boolean,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDatepickerMobileNative;
      }
    },
    position: String,
    events: Array,
    indicators: {
      type: String,
      default: 'dots'
    },
    openOnFocus: Boolean,
    iconPrev: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultIconPrev;
      }
    },
    iconNext: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultIconNext;
      }
    },
    yearsRange: {
      type: Array,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDatepickerYearsRange;
      }
    },
    type: {
      type: String,
      validator: function validator(value) {
        return ['month'].indexOf(value) >= 0;
      }
    },
    nearbyMonthDays: {
      type: Boolean,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDatepickerNearbyMonthDays;
      }
    },
    nearbySelectableMonthDays: {
      type: Boolean,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDatepickerNearbySelectableMonthDays;
      }
    },
    showWeekNumber: {
      type: Boolean,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDatepickerShowWeekNumber;
      }
    },
    rulesForFirstWeek: {
      type: Number,
      default: function _default() {
        return 4;
      }
    },
    range: {
      type: Boolean,
      default: false
    },
    closeOnClick: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    mobileModal: {
      type: Boolean,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDatepickerMobileModal;
      }
    },
    focusable: {
      type: Boolean,
      default: true
    },
    trapFocus: {
      type: Boolean,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultTrapFocus;
      }
    },
    appendToBody: Boolean,
    ariaNextLabel: String,
    ariaPreviousLabel: String
  },
  data: function data() {
    var focusedDate = (Array.isArray(this.value) ? this.value[0] : this.value) || this.focusedDate || this.dateCreator();
    return {
      dateSelected: this.value,
      focusedDateData: {
        day: focusedDate.getDate(),
        month: focusedDate.getMonth(),
        year: focusedDate.getFullYear()
      },
      _elementRef: 'input',
      _isDatepicker: true
    };
  },
  computed: {
    computedValue: {
      get: function get() {
        return this.dateSelected;
      },
      set: function set(value) {
        var _this = this;

        this.updateInternalState(value);
        if (!this.multiple) this.togglePicker(false);
        this.$emit('input', value);

        if (this.useHtml5Validation) {
          this.$nextTick(function () {
            _this.checkHtml5Validity();
          });
        }
      }
    },
    listOfMonths: function listOfMonths() {
      var minMonth = 0;
      var maxMonth = 12;

      if (this.minDate && this.focusedDateData.year === this.minDate.getFullYear()) {
        minMonth = this.minDate.getMonth();
      }

      if (this.maxDate && this.focusedDateData.year === this.maxDate.getFullYear()) {
        maxMonth = this.maxDate.getMonth();
      }

      return this.monthNames.map(function (name, index) {
        return {
          name: name,
          index: index,
          disabled: index < minMonth || index > maxMonth
        };
      });
    },

    /*
     * Returns an array of years for the year dropdown. If earliest/latest
     * dates are set by props, range of years will fall within those dates.
    */
    listOfYears: function listOfYears() {
      var latestYear = this.focusedDateData.year + this.yearsRange[1];

      if (this.maxDate && this.maxDate.getFullYear() < latestYear) {
        latestYear = Math.max(this.maxDate.getFullYear(), this.focusedDateData.year);
      }

      var earliestYear = this.focusedDateData.year + this.yearsRange[0];

      if (this.minDate && this.minDate.getFullYear() > earliestYear) {
        earliestYear = Math.min(this.minDate.getFullYear(), this.focusedDateData.year);
      }

      var arrayOfYears = [];

      for (var i = earliestYear; i <= latestYear; i++) {
        arrayOfYears.push(i);
      }

      return arrayOfYears.reverse();
    },
    showPrev: function showPrev() {
      if (!this.minDate) return false;

      if (this.isTypeMonth) {
        return this.focusedDateData.year <= this.minDate.getFullYear();
      }

      var dateToCheck = new Date(this.focusedDateData.year, this.focusedDateData.month);
      var date = new Date(this.minDate.getFullYear(), this.minDate.getMonth());
      return dateToCheck <= date;
    },
    showNext: function showNext() {
      if (!this.maxDate) return false;

      if (this.isTypeMonth) {
        return this.focusedDateData.year >= this.maxDate.getFullYear();
      }

      var dateToCheck = new Date(this.focusedDateData.year, this.focusedDateData.month);
      var date = new Date(this.maxDate.getFullYear(), this.maxDate.getMonth());
      return dateToCheck >= date;
    },
    isMobile: function isMobile$1() {
      return this.mobileNative && __WEBPACK_IMPORTED_MODULE_1__helpers_js__["c" /* isMobile */].any();
    },
    isTypeMonth: function isTypeMonth() {
      return this.type === 'month';
    },
    ariaRole: function ariaRole() {
      if (!this.inline) {
        return 'dialog';
      }
    }
  },
  watch: {
    /**
    * When v-model is changed:
    *   1. Update internal value.
    *   2. If it's invalid, validate again.
    */
    value: function value(_value) {
      this.updateInternalState(_value);
      if (!this.multiple) this.togglePicker(false);
    },
    focusedDate: function focusedDate(value) {
      if (value) {
        this.focusedDateData = {
          day: value.getDate(),
          month: value.getMonth(),
          year: value.getFullYear()
        };
      }
    },

    /*
    * Emit input event on month and/or year change
    */
    'focusedDateData.month': function focusedDateDataMonth(value) {
      this.$emit('change-month', value);
    },
    'focusedDateData.year': function focusedDateDataYear(value) {
      this.$emit('change-year', value);
    }
  },
  methods: {
    /*
    * Parse string into date
    */
    onChange: function onChange(value) {
      var date = this.dateParser(value, this);

      if (date && (!isNaN(date) || Array.isArray(date) && date.length === 2 && !isNaN(date[0]) && !isNaN(date[1]))) {
        this.computedValue = date;
      } else {
        // Force refresh input value when not valid date
        this.computedValue = null;
        this.$refs.input.newValue = this.computedValue;
      }
    },

    /*
    * Format date into string
    */
    formatValue: function formatValue(value) {
      if (Array.isArray(value)) {
        var isArrayWithValidDates = Array.isArray(value) && value.every(function (v) {
          return !isNaN(v);
        });
        return isArrayWithValidDates ? this.dateFormatter(value, this) : null;
      }

      return value && !isNaN(value) ? this.dateFormatter(value, this) : null;
    },

    /*
    * Either decrement month by 1 if not January or decrement year by 1
    * and set month to 11 (December) or decrement year when 'month'
    */
    prev: function prev() {
      if (this.disabled) return;

      if (this.isTypeMonth) {
        this.focusedDateData.year -= 1;
      } else {
        if (this.focusedDateData.month > 0) {
          this.focusedDateData.month -= 1;
        } else {
          this.focusedDateData.month = 11;
          this.focusedDateData.year -= 1;
        }
      }
    },

    /*
    * Either increment month by 1 if not December or increment year by 1
    * and set month to 0 (January) or increment year when 'month'
    */
    next: function next() {
      if (this.disabled) return;

      if (this.isTypeMonth) {
        this.focusedDateData.year += 1;
      } else {
        if (this.focusedDateData.month < 11) {
          this.focusedDateData.month += 1;
        } else {
          this.focusedDateData.month = 0;
          this.focusedDateData.year += 1;
        }
      }
    },
    formatNative: function formatNative(value) {
      return this.isTypeMonth ? this.formatYYYYMM(value) : this.formatYYYYMMDD(value);
    },

    /*
    * Format date into string 'YYYY-MM-DD'
    */
    formatYYYYMMDD: function formatYYYYMMDD(value) {
      var date = new Date(value);

      if (value && !isNaN(date)) {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        return year + '-' + ((month < 10 ? '0' : '') + month) + '-' + ((day < 10 ? '0' : '') + day);
      }

      return '';
    },

    /*
    * Format date into string 'YYYY-MM'
    */
    formatYYYYMM: function formatYYYYMM(value) {
      var date = new Date(value);

      if (value && !isNaN(date)) {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        return year + '-' + ((month < 10 ? '0' : '') + month);
      }

      return '';
    },

    /*
    * Parse date from string
    */
    onChangeNativePicker: function onChangeNativePicker(event) {
      var date = event.target.value;
      var s = date ? date.split('-') : [];

      if (s.length === 3) {
        var year = parseInt(s[0], 10);
        var month = parseInt(s[1]) - 1;
        var day = parseInt(s[2]);
        this.computedValue = new Date(year, month, day);
      } else {
        this.computedValue = null;
      }
    },
    updateInternalState: function updateInternalState(value) {
      var currentDate = Array.isArray(value) ? !value.length ? this.dateCreator() : value[0] : !value ? this.dateCreator() : value;
      this.focusedDateData = {
        day: currentDate.getDate(),
        month: currentDate.getMonth(),
        year: currentDate.getFullYear()
      };
      this.dateSelected = value;
    },

    /*
    * Toggle datepicker
    */
    togglePicker: function togglePicker(active) {
      if (this.$refs.dropdown) {
        if (this.closeOnClick) {
          this.$refs.dropdown.isActive = typeof active === 'boolean' ? active : !this.$refs.dropdown.isActive;
        }
      }
    },

    /*
    * Call default onFocus method and show datepicker
    */
    handleOnFocus: function handleOnFocus(event) {
      this.onFocus(event);

      if (this.openOnFocus) {
        this.togglePicker(true);
      }
    },

    /*
    * Toggle dropdown
    */
    toggle: function toggle() {
      if (this.mobileNative && this.isMobile) {
        var input = this.$refs.input.$refs.input;
        input.focus();
        input.click();
        return;
      }

      this.$refs.dropdown.toggle();
    },

    /*
    * Avoid dropdown toggle when is already visible
    */
    onInputClick: function onInputClick(event) {
      if (this.$refs.dropdown.isActive) {
        event.stopPropagation();
      }
    },

    /**
     * Keypress event that is bound to the document.
     */
    keyPress: function keyPress(event) {
      // Esc key
      if (this.$refs.dropdown && this.$refs.dropdown.isActive && event.keyCode === 27) {
        this.togglePicker(false);
      }
    },

    /**
     * Emit 'blur' event on dropdown is not active (closed)
     */
    onActiveChange: function onActiveChange(value) {
      if (!value) {
        this.onBlur();
      }
    },
    changeFocus: function changeFocus(day) {
      this.focusedDateData = {
        day: day.getDate(),
        month: day.getMonth(),
        year: day.getFullYear()
      };
    }
  },
  created: function created() {
    if (typeof window !== 'undefined') {
      document.addEventListener('keyup', this.keyPress);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      document.removeEventListener('keyup', this.keyPress);
    }
  }
};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datepicker control",class:[_vm.size, {'is-expanded': _vm.expanded}]},[(!_vm.isMobile || _vm.inline)?_c('b-dropdown',{ref:"dropdown",attrs:{"position":_vm.position,"disabled":_vm.disabled,"inline":_vm.inline,"mobile-modal":_vm.mobileModal,"trap-focus":_vm.trapFocus,"aria-role":_vm.ariaRole,"aria-modal":!_vm.inline,"append-to-body":_vm.appendToBody,"append-to-body-copy-parent":""},on:{"active-change":_vm.onActiveChange}},[(!_vm.inline)?_c('b-input',_vm._b({ref:"input",attrs:{"slot":"trigger","autocomplete":"off","value":_vm.formatValue(_vm.computedValue),"placeholder":_vm.placeholder,"size":_vm.size,"icon":_vm.icon,"icon-pack":_vm.iconPack,"rounded":_vm.rounded,"loading":_vm.loading,"disabled":_vm.disabled,"readonly":!_vm.editable,"use-html5-validation":false},on:{"focus":_vm.handleOnFocus},nativeOn:{"click":function($event){return _vm.onInputClick($event)},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.togglePicker(true);},"change":function($event){_vm.onChange($event.target.value);}},slot:"trigger"},'b-input',_vm.$attrs,false)):_vm._e(),_vm._v(" "),_c('b-dropdown-item',{class:{'dropdown-horizonal-timepicker': _vm.horizontalTimePicker},attrs:{"disabled":_vm.disabled,"focusable":_vm.focusable,"custom":""}},[_c('div',[_c('header',{staticClass:"datepicker-header"},[(_vm.$slots.header !== undefined && _vm.$slots.header.length)?[_vm._t("header")]:_c('div',{staticClass:"pagination field is-centered",class:_vm.size},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showPrev && !_vm.disabled),expression:"!showPrev && !disabled"}],staticClass:"pagination-previous",attrs:{"role":"button","href":"#","disabled":_vm.disabled,"aria-label":_vm.ariaPreviousLabel},on:{"click":function($event){$event.preventDefault();return _vm.prev($event)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.prev($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.prev($event)}]}},[_c('b-icon',{attrs:{"icon":_vm.iconPrev,"pack":_vm.iconPack,"both":"","type":"is-primary is-clickable"}})],1),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showNext && !_vm.disabled),expression:"!showNext && !disabled"}],staticClass:"pagination-next",attrs:{"role":"button","href":"#","disabled":_vm.disabled,"aria-label":_vm.ariaNextLabel},on:{"click":function($event){$event.preventDefault();return _vm.next($event)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.next($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.next($event)}]}},[_c('b-icon',{attrs:{"icon":_vm.iconNext,"pack":_vm.iconPack,"both":"","type":"is-primary is-clickable"}})],1),_vm._v(" "),_c('div',{staticClass:"pagination-list"},[_c('b-field',[(!_vm.isTypeMonth)?_c('b-select',{attrs:{"disabled":_vm.disabled,"size":_vm.size},model:{value:(_vm.focusedDateData.month),callback:function ($$v) {_vm.$set(_vm.focusedDateData, "month", $$v);},expression:"focusedDateData.month"}},_vm._l((_vm.listOfMonths),function(month){return _c('option',{key:month.name,attrs:{"disabled":month.disabled},domProps:{"value":month.index}},[_vm._v("\r\n                                            "+_vm._s(month.name)+"\r\n                                        ")])})):_vm._e(),_vm._v(" "),_c('b-select',{attrs:{"disabled":_vm.disabled,"size":_vm.size},model:{value:(_vm.focusedDateData.year),callback:function ($$v) {_vm.$set(_vm.focusedDateData, "year", $$v);},expression:"focusedDateData.year"}},_vm._l((_vm.listOfYears),function(year){return _c('option',{key:year,domProps:{"value":year}},[_vm._v("\r\n                                            "+_vm._s(year)+"\r\n                                        ")])}))],1)],1)])],2),_vm._v(" "),(!_vm.isTypeMonth)?_c('div',{staticClass:"datepicker-content",class:{'content-horizonal-timepicker': _vm.horizontalTimePicker}},[_c('b-datepicker-table',{attrs:{"day-names":_vm.dayNames,"month-names":_vm.monthNames,"first-day-of-week":_vm.firstDayOfWeek,"rules-for-first-week":_vm.rulesForFirstWeek,"min-date":_vm.minDate,"max-date":_vm.maxDate,"focused":_vm.focusedDateData,"disabled":_vm.disabled,"unselectable-dates":_vm.unselectableDates,"unselectable-days-of-week":_vm.unselectableDaysOfWeek,"selectable-dates":_vm.selectableDates,"events":_vm.events,"indicators":_vm.indicators,"date-creator":_vm.dateCreator,"type-month":_vm.isTypeMonth,"nearby-month-days":_vm.nearbyMonthDays,"nearby-selectable-month-days":_vm.nearbySelectableMonthDays,"show-week-number":_vm.showWeekNumber,"range":_vm.range,"multiple":_vm.multiple},on:{"update:focused":function($event){_vm.focusedDateData=$event;},"range-start":function (date) { return _vm.$emit('range-start', date); },"range-end":function (date) { return _vm.$emit('range-end', date); },"close":function($event){_vm.togglePicker(false);}},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v;},expression:"computedValue"}})],1):_c('div',[_c('b-datepicker-month',{attrs:{"month-names":_vm.monthNames,"min-date":_vm.minDate,"max-date":_vm.maxDate,"focused":_vm.focusedDateData,"disabled":_vm.disabled,"unselectable-dates":_vm.unselectableDates,"unselectable-days-of-week":_vm.unselectableDaysOfWeek,"selectable-dates":_vm.selectableDates,"events":_vm.events,"indicators":_vm.indicators,"date-creator":_vm.dateCreator,"multiple":_vm.multiple},on:{"update:focused":function($event){_vm.focusedDateData=$event;},"close":function($event){_vm.togglePicker(false);},"change-focus":_vm.changeFocus},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v;},expression:"computedValue"}})],1)]),_vm._v(" "),(_vm.$slots.default !== undefined && _vm.$slots.default.length)?_c('footer',{staticClass:"datepicker-footer",class:{'footer-horizontal-timepicker': _vm.horizontalTimePicker}},[_vm._t("default")],2):_vm._e()])],1):_c('b-input',_vm._b({ref:"input",attrs:{"type":!_vm.isTypeMonth ? 'date' : 'month',"autocomplete":"off","value":_vm.formatNative(_vm.computedValue),"placeholder":_vm.placeholder,"size":_vm.size,"icon":_vm.icon,"icon-pack":_vm.iconPack,"rounded":_vm.rounded,"loading":_vm.loading,"max":_vm.formatNative(_vm.maxDate),"min":_vm.formatNative(_vm.minDate),"disabled":_vm.disabled,"readonly":false,"use-html5-validation":false},on:{"focus":_vm.onFocus,"blur":_vm.onBlur},nativeOn:{"change":function($event){return _vm.onChangeNativePicker($event)}}},'b-input',_vm.$attrs,false))],1)};
var __vue_staticRenderFns__$3 = [];

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Datepicker = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    undefined,
    undefined
  );




/***/ }),

/***/ "ax3d":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("e8AB")('keys');
var uid = __webpack_require__("3Eo+");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "bRrM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var dP = __webpack_require__("evD5");
var DESCRIPTORS = __webpack_require__("+E39");
var SPECIES = __webpack_require__("dSzd")('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "cGG2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("JP+z");

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ "cWxy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("dVOP");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "d7EF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__("us/S");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ "dIwP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "dNDb":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "dSMT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BSwitch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__ = __webpack_require__("rhEV");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'BSwitch',
  props: {
    value: [String, Number, Boolean, Function, Object, Array, Date],
    nativeValue: [String, Number, Boolean, Function, Object, Array, Date],
    disabled: Boolean,
    type: String,
    passiveType: String,
    name: String,
    required: Boolean,
    size: String,
    trueValue: {
      type: [String, Number, Boolean, Function, Object, Array, Date],
      default: true
    },
    falseValue: {
      type: [String, Number, Boolean, Function, Object, Array, Date],
      default: false
    },
    rounded: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      newValue: this.value,
      isMouseDown: false
    };
  },
  computed: {
    computedValue: {
      get: function get() {
        return this.newValue;
      },
      set: function set(value) {
        this.newValue = value;
        this.$emit('input', value);
      }
    },
    newClass: function newClass() {
      return [this.size, {
        'is-disabled': this.disabled,
        'is-rounded': this.rounded,
        'is-outlined': this.outlined
      }];
    }
  },
  watch: {
    /**
    * When v-model change, set internal value.
    */
    value: function value(_value) {
      this.newValue = _value;
    }
  },
  methods: {
    focus: function focus() {
      // MacOS FireFox and Safari do not focus when clicked
      this.$refs.input.focus();
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{ref:"label",staticClass:"switch",class:_vm.newClass,attrs:{"disabled":_vm.disabled},on:{"click":_vm.focus,"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();_vm.$refs.label.click();},"mousedown":function($event){_vm.isMouseDown = true;},"mouseup":function($event){_vm.isMouseDown = false;},"mouseout":function($event){_vm.isMouseDown = false;},"blur":function($event){_vm.isMouseDown = false;}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.computedValue),expression:"computedValue"}],ref:"input",attrs:{"type":"checkbox","disabled":_vm.disabled,"name":_vm.name,"required":_vm.required,"true-value":_vm.trueValue,"false-value":_vm.falseValue},domProps:{"value":_vm.nativeValue,"checked":Array.isArray(_vm.computedValue)?_vm._i(_vm.computedValue,_vm.nativeValue)>-1:_vm._q(_vm.computedValue,_vm.trueValue)},on:{"click":function($event){$event.stopPropagation();},"change":function($event){var $$a=_vm.computedValue,$$el=$event.target,$$c=$$el.checked?(_vm.trueValue):(_vm.falseValue);if(Array.isArray($$a)){var $$v=_vm.nativeValue,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.computedValue=$$a.concat([$$v]));}else{$$i>-1&&(_vm.computedValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else{_vm.computedValue=$$c;}}}}),_vm._v(" "),_c('span',{staticClass:"check",class:[
                { 'is-elastic': _vm.isMouseDown && !_vm.disabled },
                (_vm.passiveType &&(_vm.passiveType + "-passive")),
                _vm.type]}),_vm._v(" "),_c('span',{staticClass:"control-label"},[_vm._t("default")],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Switch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["d" /* r */])(Vue, Switch);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "dSzd":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("e8AB")('wks');
var uid = __webpack_require__("3Eo+");
var Symbol = __webpack_require__("7KvD").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "dVOP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "dY0y":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("dSzd")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "e6n0":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("evD5").f;
var has = __webpack_require__("D2L2");
var TAG = __webpack_require__("dSzd")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "e8AB":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("FeBl");
var global = __webpack_require__("7KvD");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("O4g8") ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "eCA0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_d0a313ea_js__ = __webpack_require__("EmVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__ = __webpack_require__("QR9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chunk_3fcea532_js__ = __webpack_require__("es+Q");
/* unused harmony reexport BAutocomplete */










var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["d" /* r */])(Vue, __WEBPACK_IMPORTED_MODULE_7__chunk_3fcea532_js__["a" /* A */]);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);


/***/ }),

/***/ "es+Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Autocomplete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_d0a313ea_js__ = __webpack_require__("EmVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_d1591eb8_js__ = __webpack_require__("QR9R");






var script = {
  name: 'BAutocomplete',
  components: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({}, __WEBPACK_IMPORTED_MODULE_4__chunk_d1591eb8_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_4__chunk_d1591eb8_js__["a" /* I */]),
  mixins: [__WEBPACK_IMPORTED_MODULE_2__chunk_d0a313ea_js__["a" /* F */]],
  inheritAttrs: false,
  props: {
    value: [Number, String],
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    field: {
      type: String,
      default: 'value'
    },
    keepFirst: Boolean,
    clearOnSelect: Boolean,
    openOnFocus: Boolean,
    customFormatter: Function,
    checkInfiniteScroll: Boolean,
    keepOpen: Boolean,
    clearable: Boolean,
    maxHeight: [String, Number],
    dropdownPosition: {
      type: String,
      default: 'auto'
    },
    iconRight: String,
    iconRightClickable: Boolean,
    appendToBody: Boolean
  },
  data: function data() {
    return {
      selected: null,
      hovered: null,
      isActive: false,
      newValue: this.value,
      newAutocomplete: this.autocomplete || 'off',
      isListInViewportVertically: true,
      hasFocus: false,
      style: {},
      _isAutocomplete: true,
      _elementRef: 'input',
      _bodyEl: undefined // Used to append to body

    };
  },
  computed: {
    /**
     * White-listed items to not close when clicked.
     * Add input, dropdown and all children.
     */
    whiteList: function whiteList() {
      var whiteList = [];
      whiteList.push(this.$refs.input.$el.querySelector('input'));
      whiteList.push(this.$refs.dropdown); // Add all chidren from dropdown

      if (this.$refs.dropdown !== undefined) {
        var children = this.$refs.dropdown.querySelectorAll('*');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var child = _step.value;
            whiteList.push(child);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      if (this.$parent.$data._isTaginput) {
        // Add taginput container
        whiteList.push(this.$parent.$el); // Add .tag and .delete

        var tagInputChildren = this.$parent.$el.querySelectorAll('*');
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = tagInputChildren[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var tagInputChild = _step2.value;
            whiteList.push(tagInputChild);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      return whiteList;
    },

    /**
     * Check if exists default slot
     */
    hasDefaultSlot: function hasDefaultSlot() {
      return !!this.$scopedSlots.default;
    },

    /**
     * Check if exists "empty" slot
     */
    hasEmptySlot: function hasEmptySlot() {
      return !!this.$slots.empty;
    },

    /**
     * Check if exists "header" slot
     */
    hasHeaderSlot: function hasHeaderSlot() {
      return !!this.$slots.header;
    },

    /**
     * Check if exists "footer" slot
     */
    hasFooterSlot: function hasFooterSlot() {
      return !!this.$slots.footer;
    },

    /**
     * Apply dropdownPosition property
     */
    isOpenedTop: function isOpenedTop() {
      return this.dropdownPosition === 'top' || this.dropdownPosition === 'auto' && !this.isListInViewportVertically;
    },
    newIconRight: function newIconRight() {
      if (this.clearable && this.newValue) {
        return 'close-circle';
      }

      return this.iconRight;
    },
    newIconRightClickable: function newIconRightClickable() {
      if (this.clearable) {
        return true;
      }

      return this.iconRightClickable;
    },
    contentStyle: function contentStyle() {
      return {
        maxHeight: this.maxHeight === undefined ? null : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px'
      };
    }
  },
  watch: {
    /**
     * When dropdown is toggled, check the visibility to know when
     * to open upwards.
     */
    isActive: function isActive(active) {
      var _this = this;

      if (this.dropdownPosition === 'auto') {
        if (active) {
          this.calcDropdownInViewportVertical();
        } else {
          // Timeout to wait for the animation to finish before recalculating
          setTimeout(function () {
            _this.calcDropdownInViewportVertical();
          }, 100);
        }
      }

      if (active) this.$nextTick(function () {
        return _this.setHovered(null);
      });
    },

    /**
     * When updating input's value
     *   1. Emit changes
     *   2. If value isn't the same as selected, set null
     *   3. Close dropdown if value is clear or else open it
     */
    newValue: function newValue(value) {
      this.$emit('input', value); // Check if selected is invalid

      var currentValue = this.getValue(this.selected);

      if (currentValue && currentValue !== value) {
        this.setSelected(null, false);
      } // Close dropdown if input is clear or else open it


      if (this.hasFocus && (!this.openOnFocus || value)) {
        this.isActive = !!value;
      }
    },

    /**
     * When v-model is changed:
     *   1. Update internal value.
     *   2. If it's invalid, validate again.
     */
    value: function value(_value) {
      this.newValue = _value;
    },

    /**
     * Select first option if "keep-first
     */
    data: function data(value) {
      // Keep first option always pre-selected
      if (this.keepFirst) {
        this.selectFirstOption(value);
      }
    }
  },
  methods: {
    /**
     * Set which option is currently hovered.
     */
    setHovered: function setHovered(option) {
      if (option === undefined) return;
      this.hovered = option;
    },

    /**
     * Set which option is currently selected, update v-model,
     * update input value and close dropdown.
     */
    setSelected: function setSelected(option) {
      var _this2 = this;

      var closeDropdown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      if (option === undefined) return;
      this.selected = option;
      this.$emit('select', this.selected, event);

      if (this.selected !== null) {
        this.newValue = this.clearOnSelect ? '' : this.getValue(this.selected);
        this.setHovered(null);
      }

      closeDropdown && this.$nextTick(function () {
        _this2.isActive = false;
      });
      this.checkValidity();
    },

    /**
     * Select first option
     */
    selectFirstOption: function selectFirstOption(options) {
      var _this3 = this;

      this.$nextTick(function () {
        if (options.length) {
          // If has visible data or open on focus, keep updating the hovered
          if (_this3.openOnFocus || _this3.newValue !== '' && _this3.hovered !== options[0]) {
            _this3.setHovered(options[0]);
          }
        } else {
          _this3.setHovered(null);
        }
      });
    },

    /**
     * Enter key listener.
     * Select the hovered option.
     */
    enterPressed: function enterPressed(event) {
      if (this.hovered === null) return;
      this.setSelected(this.hovered, !this.keepOpen, event);
    },

    /**
     * Tab key listener.
     * Select hovered option if it exists, close dropdown, then allow
     * native handling to move to next tabbable element.
     */
    tabPressed: function tabPressed(event) {
      if (this.hovered === null) {
        this.isActive = false;
        return;
      }

      this.setSelected(this.hovered, !this.keepOpen, event);
    },

    /**
     * Close dropdown if clicked outside.
     */
    clickedOutside: function clickedOutside(event) {
      if (this.whiteList.indexOf(event.target) < 0) this.isActive = false;
    },

    /**
     * Return display text for the input.
     * If object, get value from path, or else just the value.
     */
    getValue: function getValue(option) {
      if (option === null) return;

      if (typeof this.customFormatter !== 'undefined') {
        return this.customFormatter(option);
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["a" /* b */])(option) === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["e" /* getValueByPath */])(option, this.field) : option;
    },

    /**
     * Check if the scroll list inside the dropdown
     * reached it's end.
     */
    checkIfReachedTheEndOfScroll: function checkIfReachedTheEndOfScroll(list) {
      if (list.clientHeight !== list.scrollHeight && list.scrollTop + list.clientHeight >= list.scrollHeight) {
        this.$emit('infinite-scroll');
      }
    },

    /**
     * Calculate if the dropdown is vertically visible when activated,
     * otherwise it is openened upwards.
     */
    calcDropdownInViewportVertical: function calcDropdownInViewportVertical() {
      var _this4 = this;

      this.$nextTick(function () {
        /**
        * this.$refs.dropdown may be undefined
        * when Autocomplete is conditional rendered
        */
        if (_this4.$refs.dropdown === undefined) return;

        var rect = _this4.$refs.dropdown.getBoundingClientRect();

        _this4.isListInViewportVertically = rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);

        if (_this4.appendToBody) {
          _this4.updateAppendToBody();
        }
      });
    },

    /**
     * Arrows keys listener.
     * If dropdown is active, set hovered option, or else just open.
     */
    keyArrows: function keyArrows(direction) {
      var sum = direction === 'down' ? 1 : -1;

      if (this.isActive) {
        var index = this.data.indexOf(this.hovered) + sum;
        index = index > this.data.length - 1 ? this.data.length : index;
        index = index < 0 ? 0 : index;
        this.setHovered(this.data[index]);
        var list = this.$refs.dropdown.querySelector('.dropdown-content');
        var element = list.querySelectorAll('a.dropdown-item:not(.is-disabled)')[index];
        if (!element) return;
        var visMin = list.scrollTop;
        var visMax = list.scrollTop + list.clientHeight - element.clientHeight;

        if (element.offsetTop < visMin) {
          list.scrollTop = element.offsetTop;
        } else if (element.offsetTop >= visMax) {
          list.scrollTop = element.offsetTop - list.clientHeight + element.clientHeight;
        }
      } else {
        this.isActive = true;
      }
    },

    /**
     * Focus listener.
     * If value is the same as selected, select all text.
     */
    focused: function focused(event) {
      if (this.getValue(this.selected) === this.newValue) {
        this.$el.querySelector('input').select();
      }

      if (this.openOnFocus) {
        this.isActive = true;

        if (this.keepFirst) {
          this.selectFirstOption(this.data);
        }
      }

      this.hasFocus = true;
      this.$emit('focus', event);
    },

    /**
    * Blur listener.
    */
    onBlur: function onBlur(event) {
      this.hasFocus = false;
      this.$emit('blur', event);
    },
    onInput: function onInput(event) {
      var currentValue = this.getValue(this.selected);
      if (currentValue && currentValue === this.newValue) return;
      this.$emit('typing', this.newValue);
      this.checkValidity();
    },
    rightIconClick: function rightIconClick(event) {
      if (this.clearable) {
        this.newValue = '';

        if (this.openOnFocus) {
          this.$el.focus();
        }
      } else {
        this.$emit('icon-right-click', event);
      }
    },
    checkValidity: function checkValidity() {
      var _this5 = this;

      if (this.useHtml5Validation) {
        this.$nextTick(function () {
          _this5.checkHtml5Validity();
        });
      }
    },
    updateAppendToBody: function updateAppendToBody() {
      var dropdownMenu = this.$refs.dropdown;
      var trigger = this.$refs.input.$el;

      if (dropdownMenu && trigger) {
        // update wrapper dropdown
        var root = this.$data._bodyEl;
        root.classList.forEach(function (item) {
          return root.classList.remove(item);
        });
        root.classList.add('autocomplete');
        root.classList.add('control');

        if (this.expandend) {
          root.classList.add('is-expandend');
        }

        var rect = trigger.getBoundingClientRect();
        var top = rect.top + window.scrollY;
        var left = rect.left + window.scrollX;

        if (!this.isOpenedTop) {
          top += trigger.clientHeight;
        } else {
          top -= dropdownMenu.clientHeight;
        }

        this.style = {
          position: 'absolute',
          top: "".concat(top, "px"),
          left: "".concat(left, "px"),
          width: "".concat(trigger.clientWidth, "px"),
          maxWidth: "".concat(trigger.clientWidth, "px"),
          zIndex: '99'
        };
      }
    }
  },
  created: function created() {
    if (typeof window !== 'undefined') {
      document.addEventListener('click', this.clickedOutside);
      if (this.dropdownPosition === 'auto') window.addEventListener('resize', this.calcDropdownInViewportVertical);
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    if (this.checkInfiniteScroll && this.$refs.dropdown && this.$refs.dropdown.querySelector('.dropdown-content')) {
      var list = this.$refs.dropdown.querySelector('.dropdown-content');
      list.addEventListener('scroll', function () {
        return _this6.checkIfReachedTheEndOfScroll(list);
      });
    }

    if (this.appendToBody) {
      this.$data._bodyEl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["d" /* createAbsoluteElement */])(this.$refs.dropdown);
      this.updateAppendToBody();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      document.removeEventListener('click', this.clickedOutside);
      if (this.dropdownPosition === 'auto') window.removeEventListener('resize', this.calcDropdownInViewportVertical);
    }

    if (this.checkInfiniteScroll && this.$refs.dropdown && this.$refs.dropdown.querySelector('.dropdown-content')) {
      var list = this.$refs.dropdown.querySelector('.dropdown-content');
      list.removeEventListener('scroll', this.checkIfReachedTheEndOfScroll);
    }

    if (this.appendToBody) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["b" /* removeElement */])(this.$data._bodyEl);
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"autocomplete control",class:{'is-expanded': _vm.expanded}},[_c('b-input',_vm._b({ref:"input",attrs:{"type":"text","size":_vm.size,"loading":_vm.loading,"rounded":_vm.rounded,"icon":_vm.icon,"icon-right":_vm.newIconRight,"icon-right-clickable":_vm.newIconRightClickable,"icon-pack":_vm.iconPack,"maxlength":_vm.maxlength,"autocomplete":_vm.newAutocomplete,"use-html5-validation":false},on:{"input":_vm.onInput,"focus":_vm.focused,"blur":_vm.onBlur,"icon-right-click":_vm.rightIconClick,"icon-click":function (event) { return _vm.$emit('icon-click', event); }},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }$event.preventDefault();_vm.isActive = false;},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.tabPressed($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.enterPressed($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();_vm.keyArrows('up');},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();_vm.keyArrows('down');}]},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v;},expression:"newValue"}},'b-input',_vm.$attrs,false)),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive && (_vm.data.length > 0 || _vm.hasEmptySlot || _vm.hasHeaderSlot)),expression:"isActive && (data.length > 0 || hasEmptySlot || hasHeaderSlot)"}],ref:"dropdown",staticClass:"dropdown-menu",class:{ 'is-opened-top': _vm.isOpenedTop && !_vm.appendToBody },style:(_vm.style)},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"dropdown-content",style:(_vm.contentStyle)},[(_vm.hasHeaderSlot)?_c('div',{staticClass:"dropdown-item"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_vm._l((_vm.data),function(option,index){return _c('a',{key:index,staticClass:"dropdown-item",class:{ 'is-hovered': option === _vm.hovered },on:{"click":function($event){_vm.setSelected(option, undefined, $event);}}},[(_vm.hasDefaultSlot)?_vm._t("default",null,{option:option,index:index}):_c('span',[_vm._v("\r\n                            "+_vm._s(_vm.getValue(option, true))+"\r\n                        ")])],2)}),_vm._v(" "),(_vm.data.length === 0 && _vm.hasEmptySlot)?_c('div',{staticClass:"dropdown-item is-disabled"},[_vm._t("empty")],2):_vm._e(),_vm._v(" "),(_vm.hasFooterSlot)?_c('div',{staticClass:"dropdown-item"},[_vm._t("footer")],2):_vm._e()],2)])])],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Autocomplete = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );




/***/ }),

/***/ "evD5":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var IE8_DOM_DEFINE = __webpack_require__("SfB7");
var toPrimitive = __webpack_require__("MmMw");
var dP = Object.defineProperty;

exports.f = __webpack_require__("+E39") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "exGp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ "fJUb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var isObject = __webpack_require__("EqjI");
var newPromiseCapability = __webpack_require__("qARP");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "fZjL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("jFbC"), __esModule: true };

/***/ }),

/***/ "fkB2":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("UuGF");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "fuGk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "fxRn":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+tPU");
__webpack_require__("zQR9");
module.exports = __webpack_require__("g8Ux");


/***/ }),

/***/ "g8Ux":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var get = __webpack_require__("3fs2");
module.exports = __webpack_require__("FeBl").getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ "gNW3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckRadioMixin; });
var CheckRadioMixin = {
  props: {
    value: [String, Number, Boolean, Function, Object, Array],
    nativeValue: [String, Number, Boolean, Function, Object, Array],
    type: String,
    disabled: Boolean,
    required: Boolean,
    name: String,
    size: String
  },
  data: function data() {
    return {
      newValue: this.value
    };
  },
  computed: {
    computedValue: {
      get: function get() {
        return this.newValue;
      },
      set: function set(value) {
        this.newValue = value;
        this.$emit('input', value);
      }
    }
  },
  watch: {
    /**
    * When v-model change, set internal value.
    */
    value: function value(_value) {
      this.newValue = _value;
    }
  },
  methods: {
    focus: function focus() {
      // MacOS FireFox and Safari do not focus when clicked
      this.$refs.input.focus();
    }
  }
};




/***/ }),

/***/ "gO9G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BMenu */
/* unused harmony export BMenuItem */
/* unused harmony export BMenuList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__ = __webpack_require__("rhEV");






//
//
//
//
//
//
var script = {
  name: 'BMenu',
  props: {
    accordion: {
      type: Boolean,
      default: true
    },
    activable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      _isMenu: true // Used by MenuItem

    };
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_vm._t("default")],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Menu = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var script$1 = {
  name: 'BMenuList',
  functional: true,
  props: {
    label: String,
    icon: String,
    iconPack: String,
    ariaRole: {
      type: String,
      default: ''
    }
  },
  render: function render(createElement, context) {
    var vlabel = null;
    var slots = context.slots();

    if (context.props.label || slots.label) {
      vlabel = createElement('p', {
        attrs: {
          'class': 'menu-label'
        }
      }, context.props.label ? context.props.icon ? [createElement('b-icon', {
        props: {
          'icon': context.props.icon,
          'pack': context.props.iconPack,
          'size': 'is-small'
        }
      }), createElement('span', {}, context.props.label)] : context.props.label : slots.label);
    }

    var vnode = createElement('ul', {
      attrs: {
        'class': 'menu-list',
        'role': context.props.ariaRole === 'menu' ? context.props.ariaRole : null
      }
    }, slots.default);
    return vlabel ? [vlabel, vnode] : vnode;
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = undefined;
  /* style inject */
  
  /* style inject SSR */
  

  
  var MenuList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    {},
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

var script$2 = {
  name: 'BMenuItem',
  components: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({}, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */]),
  inheritAttrs: false,
  props: {
    label: String,
    active: Boolean,
    expanded: Boolean,
    disabled: Boolean,
    iconPack: String,
    icon: String,
    animation: {
      type: String,
      default: 'slide'
    },
    tag: {
      type: String,
      default: 'a',
      validator: function validator(value) {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultLinkTags.indexOf(value) >= 0;
      }
    },
    ariaRole: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      newActive: this.active,
      newExpanded: this.expanded
    };
  },
  computed: {
    ariaRoleMenu: function ariaRoleMenu() {
      return this.ariaRole === 'menuitem' ? this.ariaRole : null;
    }
  },
  watch: {
    active: function active(value) {
      this.newActive = value;
    },
    expanded: function expanded(value) {
      this.newExpanded = value;
    }
  },
  methods: {
    onClick: function onClick(event) {
      if (this.disabled) return;
      var menu = this.getMenu();
      this.reset(this.$parent, menu);
      this.newExpanded = !this.newExpanded;
      this.$emit('update:expanded', this.newActive);

      if (menu && menu.activable) {
        this.newActive = true;
        this.$emit('update:active', this.newActive);
      }
    },
    reset: function reset(parent, menu) {
      var _this = this;

      var items = parent.$children.filter(function (c) {
        return c.name === _this.name;
      });
      items.forEach(function (item) {
        if (item !== _this) {
          _this.reset(item, menu);

          if (!parent.$data._isMenu || parent.$data._isMenu && parent.accordion) {
            item.newExpanded = false;
            item.$emit('update:expanded', item.newActive);
          }

          if (menu && menu.activable) {
            item.newActive = false;
            item.$emit('update:active', item.newActive);
          }
        }
      });
    },
    getMenu: function getMenu() {
      var parent = this.$parent;

      while (parent && !parent.$data._isMenu) {
        parent = parent.$parent;
      }

      return parent;
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{attrs:{"role":_vm.ariaRoleMenu}},[_c(_vm.tag,_vm._g(_vm._b({tag:"component",class:{
                'is-active': _vm.newActive,
                'is-disabled': _vm.disabled
            },on:{"click":function($event){_vm.onClick($event);}}},'component',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('b-icon',{attrs:{"icon":_vm.icon,"pack":_vm.iconPack,"size":"is-small"}}):_vm._e(),_vm._v(" "),(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._t("label",null,{expanded:_vm.newExpanded,active:_vm.newActive})],2),_vm._v(" "),(_vm.$slots.default)?[_c('transition',{attrs:{"name":_vm.animation}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.newExpanded),expression:"newExpanded"}]},[_vm._t("default")],2)])]:_vm._e()],2)};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var MenuItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, Menu);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, MenuList);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, MenuItem);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "h65t":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("UuGF");
var defined = __webpack_require__("52gC");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "h7Sf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_cca88db8_js__ = __webpack_require__("rhEV");



//
var script = {
  name: 'BTooltip',
  props: {
    active: {
      type: Boolean,
      default: true
    },
    type: String,
    label: String,
    position: {
      type: String,
      default: 'is-top',
      validator: function validator(value) {
        return ['is-top', 'is-bottom', 'is-left', 'is-right'].indexOf(value) > -1;
      }
    },
    always: Boolean,
    animated: Boolean,
    square: Boolean,
    dashed: Boolean,
    multilined: Boolean,
    size: {
      type: String,
      default: 'is-medium'
    },
    delay: Number
  },
  computed: {
    newType: function newType() {
      return this.type || __WEBPACK_IMPORTED_MODULE_0__chunk_6985c8ce_js__["a" /* c */].defaultTooltipType;
    },
    newAnimated: function newAnimated() {
      return this.animated || __WEBPACK_IMPORTED_MODULE_0__chunk_6985c8ce_js__["a" /* c */].defaultTooltipAnimated;
    },
    newDelay: function newDelay() {
      return this.delay || __WEBPACK_IMPORTED_MODULE_0__chunk_6985c8ce_js__["a" /* c */].defaultTooltipDelay;
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[_vm.newType, _vm.position, _vm.size, {
            'b-tooltip': _vm.active,
            'is-square': _vm.square,
            'is-animated': _vm.newAnimated,
            'is-always': _vm.always,
            'is-multiline': _vm.multilined,
            'is-dashed': _vm.dashed
        }],style:({'transition-delay': (_vm.newDelay + "ms")}),attrs:{"data-label":_vm.label}},[_vm._t("default")],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Tooltip = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );




/***/ }),

/***/ "hJx8":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("evD5");
var createDesc = __webpack_require__("X8DO");
module.exports = __webpack_require__("+E39") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "iBFZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimepickerMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_d0a313ea_js__ = __webpack_require__("EmVE");




var AM = 'AM';
var PM = 'PM';
var HOUR_FORMAT_24 = '24';
var HOUR_FORMAT_12 = '12';

var defaultTimeFormatter = function defaultTimeFormatter(date, vm) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  var period = '';

  if (vm.hourFormat === HOUR_FORMAT_12) {
    period = ' ' + (hours < 12 ? AM : PM);

    if (hours > 12) {
      hours -= 12;
    } else if (hours === 0) {
      hours = 12;
    }
  }

  return vm.pad(hours) + ':' + vm.pad(minutes) + (vm.enableSeconds ? ':' + vm.pad(seconds) : '') + period;
};

var defaultTimeParser = function defaultTimeParser(timeString, vm) {
  if (timeString) {
    var am = false;

    if (vm.hourFormat === HOUR_FORMAT_12) {
      var dateString12 = timeString.split(' ');
      timeString = dateString12[0];
      am = dateString12[1] === AM;
    }

    var time = timeString.split(':');
    var hours = parseInt(time[0], 10);
    var minutes = parseInt(time[1], 10);
    var seconds = vm.enableSeconds ? parseInt(time[2], 10) : 0;

    if (isNaN(hours) || hours < 0 || hours > 23 || vm.hourFormat === HOUR_FORMAT_12 && (hours < 1 || hours > 12) || isNaN(minutes) || minutes < 0 || minutes > 59) {
      return null;
    }

    var d = null;

    if (vm.computedValue && !isNaN(vm.computedValue)) {
      d = new Date(vm.computedValue);
    } else {
      d = vm.timeCreator();
      d.setMilliseconds(0);
    }

    d.setSeconds(seconds);
    d.setMinutes(minutes);

    if (vm.hourFormat === HOUR_FORMAT_12) {
      if (am && hours === 12) {
        hours = 0;
      } else if (!am && hours !== 12) {
        hours += 12;
      }
    }

    d.setHours(hours);
    return new Date(d.getTime());
  }

  return null;
};

var TimepickerMixin = {
  mixins: [__WEBPACK_IMPORTED_MODULE_2__chunk_d0a313ea_js__["a" /* F */]],
  inheritAttrs: false,
  props: {
    value: Date,
    inline: Boolean,
    minTime: Date,
    maxTime: Date,
    placeholder: String,
    editable: Boolean,
    disabled: Boolean,
    hourFormat: {
      type: String,
      default: HOUR_FORMAT_24,
      validator: function validator(value) {
        return value === HOUR_FORMAT_24 || value === HOUR_FORMAT_12;
      }
    },
    incrementHours: {
      type: Number,
      default: 1
    },
    incrementMinutes: {
      type: Number,
      default: 1
    },
    incrementSeconds: {
      type: Number,
      default: 1
    },
    timeFormatter: {
      type: Function,
      default: function _default(date, vm) {
        if (typeof __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultTimeFormatter === 'function') {
          return __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultTimeFormatter(date);
        } else {
          return defaultTimeFormatter(date, vm);
        }
      }
    },
    timeParser: {
      type: Function,
      default: function _default(date, vm) {
        if (typeof __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultTimeParser === 'function') {
          return __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultTimeParser(date);
        } else {
          return defaultTimeParser(date, vm);
        }
      }
    },
    mobileNative: {
      type: Boolean,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultTimepickerMobileNative;
      }
    },
    timeCreator: {
      type: Function,
      default: function _default() {
        if (typeof __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultTimeCreator === 'function') {
          return __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultTimeCreator();
        } else {
          return new Date();
        }
      }
    },
    position: String,
    unselectableTimes: Array,
    openOnFocus: Boolean,
    enableSeconds: Boolean,
    defaultMinutes: Number,
    defaultSeconds: Number,
    focusable: {
      type: Boolean,
      default: true
    },
    tzOffset: {
      type: Number,
      default: 0
    },
    appendToBody: Boolean
  },
  data: function data() {
    return {
      dateSelected: this.value,
      hoursSelected: null,
      minutesSelected: null,
      secondsSelected: null,
      meridienSelected: null,
      _elementRef: 'input',
      AM: AM,
      PM: PM,
      HOUR_FORMAT_24: HOUR_FORMAT_24,
      HOUR_FORMAT_12: HOUR_FORMAT_12
    };
  },
  computed: {
    computedValue: {
      get: function get() {
        return this.dateSelected;
      },
      set: function set(value) {
        this.dateSelected = value;
        this.$emit('input', this.dateSelected);
      }
    },
    hours: function hours() {
      if (!this.incrementHours || this.incrementHours < 1) throw new Error('Hour increment cannot be null or less than 1.');
      var hours = [];
      var numberOfHours = this.isHourFormat24 ? 24 : 12;

      for (var i = 0; i < numberOfHours; i += this.incrementHours) {
        var value = i;
        var label = value;

        if (!this.isHourFormat24) {
          value = i + 1;
          label = value;

          if (this.meridienSelected === this.AM) {
            if (value === 12) {
              value = 0;
            }
          } else if (this.meridienSelected === this.PM) {
            if (value !== 12) {
              value += 12;
            }
          }
        }

        hours.push({
          label: this.formatNumber(label),
          value: value
        });
      }

      return hours;
    },
    minutes: function minutes() {
      if (!this.incrementMinutes || this.incrementMinutes < 1) throw new Error('Minute increment cannot be null or less than 1.');
      var minutes = [];

      for (var i = 0; i < 60; i += this.incrementMinutes) {
        minutes.push({
          label: this.formatNumber(i, true),
          value: i
        });
      }

      return minutes;
    },
    seconds: function seconds() {
      if (!this.incrementSeconds || this.incrementSeconds < 1) throw new Error('Second increment cannot be null or less than 1.');
      var seconds = [];

      for (var i = 0; i < 60; i += this.incrementSeconds) {
        seconds.push({
          label: this.formatNumber(i, true),
          value: i
        });
      }

      return seconds;
    },
    meridiens: function meridiens() {
      return [AM, PM];
    },
    isMobile: function isMobile$1() {
      return this.mobileNative && __WEBPACK_IMPORTED_MODULE_0__helpers_js__["c" /* isMobile */].any();
    },
    isHourFormat24: function isHourFormat24() {
      return this.hourFormat === HOUR_FORMAT_24;
    }
  },
  watch: {
    hourFormat: function hourFormat() {
      if (this.hoursSelected !== null) {
        this.meridienSelected = this.hoursSelected >= 12 ? PM : AM;
      }
    },

    /**
     * When v-model is changed:
     *   1. Update internal value.
     *   2. If it's invalid, validate again.
     */
    value: {
      handler: function handler(value) {
        this.updateInternalState(value);
        !this.isValid && this.$refs.input.checkHtml5Validity();
      },
      immediate: true
    }
  },
  methods: {
    onMeridienChange: function onMeridienChange(value) {
      if (this.hoursSelected !== null) {
        if (value === PM) {
          this.hoursSelected += 12;
        } else if (value === AM) {
          this.hoursSelected -= 12;
        }
      }

      this.updateDateSelected(this.hoursSelected, this.minutesSelected, this.enableSeconds ? this.secondsSelected : 0, value);
    },
    onHoursChange: function onHoursChange(value) {
      if (!this.minutesSelected && typeof this.defaultMinutes !== 'undefined') {
        this.minutesSelected = this.defaultMinutes;
      }

      if (!this.secondsSelected && typeof this.defaultSeconds !== 'undefined') {
        this.secondsSelected = this.defaultSeconds;
      }

      this.updateDateSelected(parseInt(value, 10), this.minutesSelected, this.enableSeconds ? this.secondsSelected : 0, this.meridienSelected);
    },
    onMinutesChange: function onMinutesChange(value) {
      if (!this.secondsSelected && this.defaultSeconds) {
        this.secondsSelected = this.defaultSeconds;
      }

      this.updateDateSelected(this.hoursSelected, parseInt(value, 10), this.enableSeconds ? this.secondsSelected : 0, this.meridienSelected);
    },
    onSecondsChange: function onSecondsChange(value) {
      this.updateDateSelected(this.hoursSelected, this.minutesSelected, parseInt(value, 10), this.meridienSelected);
    },
    updateDateSelected: function updateDateSelected(hours, minutes, seconds, meridiens) {
      if (hours != null && minutes != null && (!this.isHourFormat24 && meridiens !== null || this.isHourFormat24)) {
        var time = null;

        if (this.computedValue && !isNaN(this.computedValue)) {
          time = new Date(this.computedValue);
        } else {
          time = this.timeCreator();
          time.setMilliseconds(0);
        }

        time.setHours(hours);
        time.setMinutes(minutes);
        time.setSeconds(seconds);
        this.computedValue = new Date(time.getTime());
      }
    },
    updateInternalState: function updateInternalState(value) {
      if (value) {
        this.hoursSelected = value.getHours();
        this.minutesSelected = value.getMinutes();
        this.secondsSelected = value.getSeconds();
        this.meridienSelected = value.getHours() >= 12 ? PM : AM;
      } else {
        this.hoursSelected = null;
        this.minutesSelected = null;
        this.secondsSelected = null;
        this.meridienSelected = AM;
      }

      this.dateSelected = value;
    },
    isHourDisabled: function isHourDisabled(hour) {
      var _this = this;

      var disabled = false;

      if (this.minTime) {
        var minHours = this.minTime.getHours();
        var noMinutesAvailable = this.minutes.every(function (minute) {
          return _this.isMinuteDisabledForHour(hour, minute.value);
        });
        disabled = hour < minHours || noMinutesAvailable;
      }

      if (this.maxTime) {
        if (!disabled) {
          var maxHours = this.maxTime.getHours();
          disabled = hour > maxHours;
        }
      }

      if (this.unselectableTimes) {
        if (!disabled) {
          var unselectable = this.unselectableTimes.filter(function (time) {
            if (_this.enableSeconds && _this.secondsSelected !== null) {
              return time.getHours() === hour && time.getMinutes() === _this.minutesSelected && time.getSeconds() === _this.secondsSelected;
            } else if (_this.minutesSelected !== null) {
              return time.getHours() === hour && time.getMinutes() === _this.minutesSelected;
            } else {
              return time.getHours() === hour;
            }
          });
          disabled = unselectable.length > 0;
        }
      }

      return disabled;
    },
    isMinuteDisabledForHour: function isMinuteDisabledForHour(hour, minute) {
      var disabled = false;

      if (this.minTime) {
        var minHours = this.minTime.getHours();
        var minMinutes = this.minTime.getMinutes();
        disabled = hour === minHours && minute < minMinutes;
      }

      if (this.maxTime) {
        if (!disabled) {
          var maxHours = this.maxTime.getHours();
          var maxMinutes = this.maxTime.getMinutes();
          disabled = hour === maxHours && minute > maxMinutes;
        }
      }

      return disabled;
    },
    isMinuteDisabled: function isMinuteDisabled(minute) {
      var _this2 = this;

      var disabled = false;

      if (this.hoursSelected !== null) {
        if (this.isHourDisabled(this.hoursSelected)) {
          disabled = true;
        } else {
          disabled = this.isMinuteDisabledForHour(this.hoursSelected, minute);
        }

        if (this.unselectableTimes) {
          if (!disabled) {
            var unselectable = this.unselectableTimes.filter(function (time) {
              if (_this2.enableSeconds && _this2.secondsSelected !== null) {
                return time.getHours() === _this2.hoursSelected && time.getMinutes() === minute && time.getSeconds() === _this2.secondsSelected;
              } else {
                return time.getHours() === _this2.hoursSelected && time.getMinutes() === minute;
              }
            });
            disabled = unselectable.length > 0;
          }
        }
      }

      return disabled;
    },
    isSecondDisabled: function isSecondDisabled(second) {
      var _this3 = this;

      var disabled = false;

      if (this.minutesSelected !== null) {
        if (this.isMinuteDisabled(this.minutesSelected)) {
          disabled = true;
        } else {
          if (this.minTime) {
            var minHours = this.minTime.getHours();
            var minMinutes = this.minTime.getMinutes();
            var minSeconds = this.minTime.getSeconds();
            disabled = this.hoursSelected === minHours && this.minutesSelected === minMinutes && second < minSeconds;
          }

          if (this.maxTime) {
            if (!disabled) {
              var maxHours = this.maxTime.getHours();
              var maxMinutes = this.maxTime.getMinutes();
              var maxSeconds = this.maxTime.getSeconds();
              disabled = this.hoursSelected === maxHours && this.minutesSelected === maxMinutes && second > maxSeconds;
            }
          }
        }

        if (this.unselectableTimes) {
          if (!disabled) {
            var unselectable = this.unselectableTimes.filter(function (time) {
              return time.getHours() === _this3.hoursSelected && time.getMinutes() === _this3.minutesSelected && time.getSeconds() === second;
            });
            disabled = unselectable.length > 0;
          }
        }
      }

      return disabled;
    },

    /*
    * Parse string into date
    */
    onChange: function onChange(value) {
      var date = this.timeParser(value, this);
      this.updateInternalState(date);

      if (date && !isNaN(date)) {
        this.computedValue = date;
      } else {
        // Force refresh input value when not valid date
        this.computedValue = null;
        this.$refs.input.newValue = this.computedValue;
      }
    },

    /*
    * Toggle timepicker
    */
    toggle: function toggle(active) {
      if (this.$refs.dropdown) {
        this.$refs.dropdown.isActive = typeof active === 'boolean' ? active : !this.$refs.dropdown.isActive;
      }
    },

    /*
    * Close timepicker
    */
    close: function close() {
      this.toggle(false);
    },

    /*
    * Call default onFocus method and show timepicker
    */
    handleOnFocus: function handleOnFocus() {
      this.onFocus();

      if (this.openOnFocus) {
        this.toggle(true);
      }
    },

    /*
    * Format date into string 'HH-MM-SS'
    */
    formatHHMMSS: function formatHHMMSS(value) {
      var date = new Date(value);

      if (value && !isNaN(date)) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        return this.formatNumber(hours, true) + ':' + this.formatNumber(minutes, true) + ':' + this.formatNumber(seconds, true);
      }

      return '';
    },

    /*
    * Parse time from string
    */
    onChangeNativePicker: function onChangeNativePicker(event) {
      var date = event.target.value;

      if (date) {
        var time = null;

        if (this.computedValue && !isNaN(this.computedValue)) {
          time = new Date(this.computedValue);
        } else {
          time = new Date();
          time.setMilliseconds(0);
        }

        var t = date.split(':');
        time.setHours(parseInt(t[0], 10));
        time.setMinutes(parseInt(t[1], 10));
        time.setSeconds(t[2] ? parseInt(t[2], 10) : 0);
        this.computedValue = new Date(time.getTime());
      } else {
        this.computedValue = null;
      }
    },
    formatNumber: function formatNumber(value, prependZero) {
      return this.isHourFormat24 || prependZero ? this.pad(value) : value;
    },
    pad: function pad(value) {
      return (value < 10 ? '0' : '') + value;
    },

    /*
    * Format date into string
    */
    formatValue: function formatValue(date) {
      if (date && !isNaN(date)) {
        return this.timeFormatter(date, this);
      } else {
        return null;
      }
    },

    /**
     * Keypress event that is bound to the document.
     */
    keyPress: function keyPress(event) {
      // Esc key
      if (this.$refs.dropdown && this.$refs.dropdown.isActive && event.keyCode === 27) {
        this.toggle(false);
      }
    },

    /**
     * Emit 'blur' event on dropdown is not active (closed)
     */
    onActiveChange: function onActiveChange(value) {
      if (!value) {
        this.onBlur();
      }
    }
  },
  created: function created() {
    if (typeof window !== 'undefined') {
      document.addEventListener('keyup', this.keyPress);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      document.removeEventListener('keyup', this.keyPress);
    }
  }
};




/***/ }),

/***/ "iUbK":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "jFbC":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Cdx3");
module.exports = __webpack_require__("FeBl").Object.keys;


/***/ }),

/***/ "jKW+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("kM2E");
var newPromiseCapability = __webpack_require__("qARP");
var perform = __webpack_require__("dNDb");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "ji3u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SlotComponent; });
var SlotComponent = {
  name: 'BSlotComponent',
  props: {
    component: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      default: 'default'
    },
    scoped: {
      type: Boolean
    },
    props: {
      type: Object
    },
    tag: {
      type: String,
      default: 'div'
    },
    event: {
      type: String,
      default: 'hook:updated'
    }
  },
  methods: {
    refresh: function refresh() {
      this.$forceUpdate();
    },
    isVueComponent: function isVueComponent() {
      return this.component && this.component._isVue;
    }
  },
  created: function created() {
    if (this.isVueComponent()) {
      this.component.$on(this.event, this.refresh);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isVueComponent()) {
      this.component.$off(this.event, this.refresh);
    }
  },
  render: function render(createElement) {
    if (this.isVueComponent()) {
      return createElement(this.tag, {}, this.scoped ? this.component.$scopedSlots[this.name](this.props) : this.component.$slots[this.name]);
    }
  }
};




/***/ }),

/***/ "jyFz":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__("SldL");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),

/***/ "k5jX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConfigProgrammatic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* unused harmony reexport createAbsoluteElement */
/* unused harmony reexport createNewEvent */
/* unused harmony reexport escapeRegExpChars */
/* unused harmony reexport getValueByPath */
/* unused harmony reexport indexOf */
/* unused harmony reexport isMobile */
/* unused harmony reexport merge */
/* unused harmony reexport multiColumnSort */
/* unused harmony reexport removeElement */
/* unused harmony reexport sign */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_d0a313ea_js__ = __webpack_require__("EmVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__ = __webpack_require__("QR9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chunk_3fcea532_js__ = __webpack_require__("es+Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__autocomplete_js__ = __webpack_require__("eCA0");
/* unused harmony reexport Autocomplete */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__button_js__ = __webpack_require__("nsBO");
/* unused harmony reexport Button */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__carousel_js__ = __webpack_require__("HE5t");
/* unused harmony reexport Carousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__chunk_2793447b_js__ = __webpack_require__("gNW3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__chunk_7bdbd626_js__ = __webpack_require__("QBkZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__checkbox_js__ = __webpack_require__("IvMs");
/* unused harmony reexport Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__collapse_js__ = __webpack_require__("UNcj");
/* unused harmony reexport Collapse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__chunk_1196ee55_js__ = __webpack_require__("iBFZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__chunk_42f463e6_js__ = __webpack_require__("mMDG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__chunk_4d76806f_js__ = __webpack_require__("t4YS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__chunk_eb60b35a_js__ = __webpack_require__("RbWz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__clockpicker_js__ = __webpack_require__("IXWv");
/* unused harmony reexport Clockpicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__chunk_77ffdf8b_js__ = __webpack_require__("8cDm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__chunk_66a4ceca_js__ = __webpack_require__("ajTP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__datepicker_js__ = __webpack_require__("m6gj");
/* unused harmony reexport Datepicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__chunk_a684d1f3_js__ = __webpack_require__("5udn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__datetimepicker_js__ = __webpack_require__("/Rej");
/* unused harmony reexport Datetimepicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__chunk_0cb0546b_js__ = __webpack_require__("aGWY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__dialog_js__ = __webpack_require__("M3yv");
/* unused harmony reexport Dialog */
/* unused harmony reexport DialogProgrammatic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__dropdown_js__ = __webpack_require__("rHUL");
/* unused harmony reexport Dropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__field_js__ = __webpack_require__("IHYB");
/* unused harmony reexport Field */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__icon_js__ = __webpack_require__("ZJkx");
/* unused harmony reexport Icon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__input_js__ = __webpack_require__("a5T5");
/* unused harmony reexport Input */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__chunk_b9bdb0e4_js__ = __webpack_require__("UZQh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__loading_js__ = __webpack_require__("4xRR");
/* unused harmony reexport Loading */
/* unused harmony reexport LoadingProgrammatic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__menu_js__ = __webpack_require__("gO9G");
/* unused harmony reexport Menu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__chunk_0e26d208_js__ = __webpack_require__("1Wsa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__message_js__ = __webpack_require__("ucd5");
/* unused harmony reexport Message */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__modal_js__ = __webpack_require__("3wcG");
/* unused harmony reexport Modal */
/* unused harmony reexport ModalProgrammatic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__notification_js__ = __webpack_require__("Z339");
/* unused harmony reexport Notification */
/* unused harmony reexport NotificationProgrammatic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__chunk_53640c15_js__ = __webpack_require__("kGGF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__navbar_js__ = __webpack_require__("2uRq");
/* unused harmony reexport Navbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__numberinput_js__ = __webpack_require__("YEJw");
/* unused harmony reexport Numberinput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__chunk_bd608559_js__ = __webpack_require__("lZGu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pagination_js__ = __webpack_require__("OGWA");
/* unused harmony reexport Pagination */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__progress_js__ = __webpack_require__("Ftan");
/* unused harmony reexport Progress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__radio_js__ = __webpack_require__("oIlB");
/* unused harmony reexport Radio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__rate_js__ = __webpack_require__("tYb/");
/* unused harmony reexport Rate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__select_js__ = __webpack_require__("01Ww");
/* unused harmony reexport Select */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__skeleton_js__ = __webpack_require__("vkRo");
/* unused harmony reexport Skeleton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__sidebar_js__ = __webpack_require__("P1Pc");
/* unused harmony reexport Sidebar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__chunk_9ec85033_js__ = __webpack_require__("h7Sf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__slider_js__ = __webpack_require__("vLxT");
/* unused harmony reexport Slider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__snackbar_js__ = __webpack_require__("Vd1k");
/* unused harmony reexport Snackbar */
/* unused harmony reexport SnackbarProgrammatic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__chunk_0e3f4fb5_js__ = __webpack_require__("ji3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__steps_js__ = __webpack_require__("lvuN");
/* unused harmony reexport Steps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__switch_js__ = __webpack_require__("dSMT");
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__table_js__ = __webpack_require__("EzMU");
/* unused harmony reexport Table */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__tabs_js__ = __webpack_require__("I6hQ");
/* unused harmony reexport Tabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__chunk_7292bea2_js__ = __webpack_require__("vNXG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__tag_js__ = __webpack_require__("O9Pj");
/* unused harmony reexport Tag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__taginput_js__ = __webpack_require__("ATYI");
/* unused harmony reexport Taginput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__timepicker_js__ = __webpack_require__("sBwo");
/* unused harmony reexport Timepicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__toast_js__ = __webpack_require__("SdYw");
/* unused harmony reexport Toast */
/* unused harmony reexport ToastProgrammatic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__tooltip_js__ = __webpack_require__("+wWI");
/* unused harmony reexport Tooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__upload_js__ = __webpack_require__("wrzx");
/* unused harmony reexport Upload */











































































































var components = /*#__PURE__*/Object.freeze({
    Autocomplete: __WEBPACK_IMPORTED_MODULE_8__autocomplete_js__["a" /* default */],
    Button: __WEBPACK_IMPORTED_MODULE_9__button_js__["a" /* default */],
    Carousel: __WEBPACK_IMPORTED_MODULE_10__carousel_js__["a" /* default */],
    Checkbox: __WEBPACK_IMPORTED_MODULE_13__checkbox_js__["a" /* default */],
    Clockpicker: __WEBPACK_IMPORTED_MODULE_19__clockpicker_js__["a" /* default */],
    Collapse: __WEBPACK_IMPORTED_MODULE_14__collapse_js__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_22__datepicker_js__["a" /* default */],
    Datetimepicker: __WEBPACK_IMPORTED_MODULE_24__datetimepicker_js__["a" /* default */],
    Dialog: __WEBPACK_IMPORTED_MODULE_26__dialog_js__["a" /* default */],
    Dropdown: __WEBPACK_IMPORTED_MODULE_27__dropdown_js__["a" /* default */],
    Field: __WEBPACK_IMPORTED_MODULE_28__field_js__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_29__icon_js__["a" /* default */],
    Input: __WEBPACK_IMPORTED_MODULE_30__input_js__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_32__loading_js__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_33__menu_js__["a" /* default */],
    Message: __WEBPACK_IMPORTED_MODULE_35__message_js__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_36__modal_js__["a" /* default */],
    Navbar: __WEBPACK_IMPORTED_MODULE_39__navbar_js__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_37__notification_js__["a" /* default */],
    Numberinput: __WEBPACK_IMPORTED_MODULE_40__numberinput_js__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_42__pagination_js__["a" /* default */],
    Progress: __WEBPACK_IMPORTED_MODULE_43__progress_js__["a" /* default */],
    Radio: __WEBPACK_IMPORTED_MODULE_44__radio_js__["a" /* default */],
    Rate: __WEBPACK_IMPORTED_MODULE_45__rate_js__["a" /* default */],
    Select: __WEBPACK_IMPORTED_MODULE_46__select_js__["a" /* default */],
    Skeleton: __WEBPACK_IMPORTED_MODULE_47__skeleton_js__["a" /* default */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_48__sidebar_js__["a" /* default */],
    Slider: __WEBPACK_IMPORTED_MODULE_50__slider_js__["a" /* default */],
    Snackbar: __WEBPACK_IMPORTED_MODULE_51__snackbar_js__["a" /* default */],
    Steps: __WEBPACK_IMPORTED_MODULE_53__steps_js__["a" /* default */],
    Switch: __WEBPACK_IMPORTED_MODULE_54__switch_js__["a" /* default */],
    Table: __WEBPACK_IMPORTED_MODULE_55__table_js__["a" /* default */],
    Tabs: __WEBPACK_IMPORTED_MODULE_56__tabs_js__["a" /* default */],
    Tag: __WEBPACK_IMPORTED_MODULE_58__tag_js__["a" /* default */],
    Taginput: __WEBPACK_IMPORTED_MODULE_59__taginput_js__["a" /* default */],
    Timepicker: __WEBPACK_IMPORTED_MODULE_60__timepicker_js__["a" /* default */],
    Toast: __WEBPACK_IMPORTED_MODULE_61__toast_js__["a" /* default */],
    Tooltip: __WEBPACK_IMPORTED_MODULE_62__tooltip_js__["a" /* default */],
    Upload: __WEBPACK_IMPORTED_MODULE_63__upload_js__["a" /* default */]
});

var ConfigComponent = {
  getOptions: function getOptions() {
    return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */];
  },
  setOptions: function setOptions$1(options) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["b" /* s */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* merge */])(__WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */], options, true));
  }
};

var Buefy = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["c" /* a */])(Vue); // Options

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["b" /* s */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* merge */])(__WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */], options, true)); // Components

    for (var componentKey in components) {
      Vue.use(components[componentKey]);
    } // Config component


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["a"])(Vue, 'config', ConfigComponent);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["b" /* u */])(Buefy);

/* harmony default export */ __webpack_exports__["a"] = (Buefy);



/***/ }),

/***/ "kGGF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoticeMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__ = __webpack_require__("V5O4");



var NoticeMixin = {
  props: {
    type: {
      type: String,
      default: 'is-dark'
    },
    message: String,
    duration: Number,
    queue: {
      type: Boolean,
      default: undefined
    },
    position: {
      type: String,
      default: 'is-top',
      validator: function validator(value) {
        return ['is-top-right', 'is-top', 'is-top-left', 'is-bottom-right', 'is-bottom', 'is-bottom-left'].indexOf(value) > -1;
      }
    },
    container: String
  },
  data: function data() {
    return {
      isActive: false,
      parentTop: null,
      parentBottom: null,
      newContainer: this.container || __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultContainerElement
    };
  },
  computed: {
    correctParent: function correctParent() {
      switch (this.position) {
        case 'is-top-right':
        case 'is-top':
        case 'is-top-left':
          return this.parentTop;

        case 'is-bottom-right':
        case 'is-bottom':
        case 'is-bottom-left':
          return this.parentBottom;
      }
    },
    transition: function transition() {
      switch (this.position) {
        case 'is-top-right':
        case 'is-top':
        case 'is-top-left':
          return {
            enter: 'fadeInDown',
            leave: 'fadeOut'
          };

        case 'is-bottom-right':
        case 'is-bottom':
        case 'is-bottom-left':
          return {
            enter: 'fadeInUp',
            leave: 'fadeOut'
          };
      }
    }
  },
  methods: {
    shouldQueue: function shouldQueue() {
      var queue = this.queue !== undefined ? this.queue : __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultNoticeQueue;
      if (!queue) return false;
      return this.parentTop.childElementCount > 0 || this.parentBottom.childElementCount > 0;
    },
    close: function close() {
      var _this = this;

      clearTimeout(this.timer);
      this.isActive = false;
      this.$emit('close'); // Timeout for the animation complete before destroying

      setTimeout(function () {
        _this.$destroy();

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_js__["b" /* removeElement */])(_this.$el);
      }, 150);
    },
    showNotice: function showNotice() {
      var _this2 = this;

      if (this.shouldQueue()) {
        // Call recursively if should queue
        setTimeout(function () {
          return _this2.showNotice();
        }, 250);
        return;
      }

      this.correctParent.insertAdjacentElement('afterbegin', this.$el);
      this.isActive = true;

      if (!this.indefinite) {
        this.timer = setTimeout(function () {
          return _this2.close();
        }, this.newDuration);
      }
    },
    setupContainer: function setupContainer() {
      this.parentTop = document.querySelector((this.newContainer ? this.newContainer : 'body') + '>.notices.is-top');
      this.parentBottom = document.querySelector((this.newContainer ? this.newContainer : 'body') + '>.notices.is-bottom');
      if (this.parentTop && this.parentBottom) return;

      if (!this.parentTop) {
        this.parentTop = document.createElement('div');
        this.parentTop.className = 'notices is-top';
      }

      if (!this.parentBottom) {
        this.parentBottom = document.createElement('div');
        this.parentBottom.className = 'notices is-bottom';
      }

      var container = document.querySelector(this.newContainer) || document.body;
      container.appendChild(this.parentTop);
      container.appendChild(this.parentBottom);

      if (this.newContainer) {
        this.parentTop.classList.add('has-custom-container');
        this.parentBottom.classList.add('has-custom-container');
      }
    }
  },
  beforeMount: function beforeMount() {
    this.setupContainer();
  },
  mounted: function mounted() {
    this.showNotice();
  }
};




/***/ }),

/***/ "kM2E":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var ctx = __webpack_require__("+ZMJ");
var hide = __webpack_require__("hJx8");
var has = __webpack_require__("D2L2");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "knuC":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "lOnJ":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "lZGu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Pagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PaginationButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__ = __webpack_require__("rhEV");





//
var script = {
  name: 'BPaginationButton',
  props: {
    page: {
      type: Object,
      required: true
    },
    tag: {
      type: String,
      default: 'a',
      validator: function validator(value) {
        return __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultLinkTags.indexOf(value) >= 0;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    href: function href() {
      if (this.tag === 'a') {
        return '#';
      }
    },
    isDisabled: function isDisabled() {
      return this.disabled || this.page.disabled;
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",staticClass:"pagination-link",class:( _obj = { 'is-current': _vm.page.isCurrent }, _obj[_vm.page.class] = true, _obj ),attrs:{"role":"button","href":_vm.href,"disabled":_vm.isDisabled,"aria-label":_vm.page['aria-label'],"aria-current":_vm.page.isCurrent},on:{"click":function($event){$event.preventDefault();return _vm.page.click($event)}}},'component',_vm.$attrs,false),[_vm._t("default",[_vm._v(_vm._s(_vm.page.number))])],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PaginationButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var _components;
var script$1 = {
  name: 'BPagination',
  components: (_components = {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_2__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_2__chunk_cdfca85b_js__["a" /* I */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, PaginationButton.name, PaginationButton), _components),
  props: {
    total: [Number, String],
    perPage: {
      type: [Number, String],
      default: 20
    },
    current: {
      type: [Number, String],
      default: 1
    },
    rangeBefore: {
      type: [Number, String],
      default: 1
    },
    rangeAfter: {
      type: [Number, String],
      default: 1
    },
    size: String,
    simple: Boolean,
    rounded: Boolean,
    order: String,
    iconPack: String,
    iconPrev: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultIconPrev;
      }
    },
    iconNext: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__["a" /* c */].defaultIconNext;
      }
    },
    ariaNextLabel: String,
    ariaPreviousLabel: String,
    ariaPageLabel: String,
    ariaCurrentLabel: String
  },
  computed: {
    rootClasses: function rootClasses() {
      return [this.order, this.size, {
        'is-simple': this.simple,
        'is-rounded': this.rounded
      }];
    },
    beforeCurrent: function beforeCurrent() {
      return parseInt(this.rangeBefore);
    },
    afterCurrent: function afterCurrent() {
      return parseInt(this.rangeAfter);
    },

    /**
    * Total page size (count).
    */
    pageCount: function pageCount() {
      return Math.ceil(this.total / this.perPage);
    },

    /**
    * First item of the page (count).
    */
    firstItem: function firstItem() {
      var firstItem = this.current * this.perPage - this.perPage + 1;
      return firstItem >= 0 ? firstItem : 0;
    },

    /**
    * Check if previous button is available.
    */
    hasPrev: function hasPrev() {
      return this.current > 1;
    },

    /**
    * Check if first page button should be visible.
    */
    hasFirst: function hasFirst() {
      return this.current >= 2 + this.beforeCurrent;
    },

    /**
    * Check if first ellipsis should be visible.
    */
    hasFirstEllipsis: function hasFirstEllipsis() {
      return this.current >= this.beforeCurrent + 4;
    },

    /**
    * Check if last page button should be visible.
    */
    hasLast: function hasLast() {
      return this.current <= this.pageCount - (1 + this.afterCurrent);
    },

    /**
    * Check if last ellipsis should be visible.
    */
    hasLastEllipsis: function hasLastEllipsis() {
      return this.current < this.pageCount - (2 + this.afterCurrent);
    },

    /**
    * Check if next button is available.
    */
    hasNext: function hasNext() {
      return this.current < this.pageCount;
    },

    /**
    * Get near pages, 1 before and 1 after the current.
    * Also add the click event to the array.
    */
    pagesInRange: function pagesInRange() {
      if (this.simple) return;
      var left = Math.max(1, this.current - this.beforeCurrent);

      if (left - 1 === 2) {
        left--; // Do not show the ellipsis if there is only one to hide
      }

      var right = Math.min(this.current + this.afterCurrent, this.pageCount);

      if (this.pageCount - right === 2) {
        right++; // Do not show the ellipsis if there is only one to hide
      }

      var pages = [];

      for (var i = left; i <= right; i++) {
        pages.push(this.getPage(i));
      }

      return pages;
    }
  },
  watch: {
    /**
    * If current page is trying to be greater than page count, set to last.
    */
    pageCount: function pageCount(value) {
      if (this.current > value) this.last();
    }
  },
  methods: {
    /**
    * Previous button click listener.
    */
    prev: function prev(event) {
      this.changePage(this.current - 1, event);
    },

    /**
    * Next button click listener.
    */
    next: function next(event) {
      this.changePage(this.current + 1, event);
    },

    /**
    * First button click listener.
    */
    first: function first(event) {
      this.changePage(1, event);
    },

    /**
    * Last button click listener.
    */
    last: function last(event) {
      this.changePage(this.pageCount, event);
    },
    changePage: function changePage(num, event) {
      if (this.current === num || num < 1 || num > this.pageCount) return;
      this.$emit('change', num);
      this.$emit('update:current', num); // Set focus on element to keep tab order

      if (event && event.target) {
        this.$nextTick(function () {
          return event.target.focus();
        });
      }
    },
    getPage: function getPage(num) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return {
        number: num,
        isCurrent: this.current === num,
        click: function click(event) {
          return _this.changePage(num, event);
        },
        disabled: options.disabled || false,
        class: options.class || '',
        'aria-label': options['aria-label'] || this.getAriaPageLabel(num, this.current === num)
      };
    },

    /**
    * Get text for aria-label according to page number.
    */
    getAriaPageLabel: function getAriaPageLabel(pageNumber, isCurrent) {
      if (this.ariaPageLabel && (!isCurrent || !this.ariaCurrentLabel)) {
        return this.ariaPageLabel + ' ' + pageNumber + '.';
      } else if (this.ariaPageLabel && isCurrent && this.ariaCurrentLabel) {
        return this.ariaCurrentLabel + ', ' + this.ariaPageLabel + ' ' + pageNumber + '.';
      }

      return null;
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"pagination",class:_vm.rootClasses},[(_vm.$scopedSlots.previous)?_vm._t("previous",[_c('b-icon',{attrs:{"icon":_vm.iconPrev,"pack":_vm.iconPack,"both":"","aria-hidden":"true"}})],{page:_vm.getPage(_vm.current - 1, {
                disabled: !_vm.hasPrev,
                class: 'pagination-previous',
                'aria-label': _vm.ariaPreviousLabel
        })}):_c('BPaginationButton',{staticClass:"pagination-previous",attrs:{"disabled":!_vm.hasPrev,"page":_vm.getPage(_vm.current - 1)}},[_c('b-icon',{attrs:{"icon":_vm.iconPrev,"pack":_vm.iconPack,"both":"","aria-hidden":"true"}})],1),_vm._v(" "),(_vm.$scopedSlots.next)?_vm._t("next",[_c('b-icon',{attrs:{"icon":_vm.iconNext,"pack":_vm.iconPack,"both":"","aria-hidden":"true"}})],{page:_vm.getPage(_vm.current + 1, {
                disabled: !_vm.hasNext,
                class: 'pagination-next',
                'aria-label': _vm.ariaNextLabel
        })}):_c('BPaginationButton',{staticClass:"pagination-next",attrs:{"disabled":!_vm.hasNext,"page":_vm.getPage(_vm.current + 1)}},[_c('b-icon',{attrs:{"icon":_vm.iconNext,"pack":_vm.iconPack,"both":"","aria-hidden":"true"}})],1),_vm._v(" "),(_vm.simple)?_c('small',{staticClass:"info"},[(_vm.perPage == 1)?[_vm._v("\r\n                "+_vm._s(_vm.firstItem)+" / "+_vm._s(_vm.total)+"\r\n            ")]:[_vm._v("\r\n                "+_vm._s(_vm.firstItem)+"-"+_vm._s(Math.min(_vm.current * _vm.perPage, _vm.total))+" / "+_vm._s(_vm.total)+"\r\n            ")]],2):_c('ul',{staticClass:"pagination-list"},[(_vm.hasFirst)?_c('li',[(_vm.$scopedSlots.default)?_vm._t("default",null,{page:_vm.getPage(1)}):_c('BPaginationButton',{attrs:{"page":_vm.getPage(1)}})],2):_vm._e(),_vm._v(" "),(_vm.hasFirstEllipsis)?_c('li',[_c('span',{staticClass:"pagination-ellipsis"},[_vm._v("…")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.pagesInRange),function(page){return _c('li',{key:page.number},[(_vm.$scopedSlots.default)?_vm._t("default",null,{page:page}):_c('BPaginationButton',{attrs:{"page":page}})],2)}),_vm._v(" "),(_vm.hasLastEllipsis)?_c('li',[_c('span',{staticClass:"pagination-ellipsis"},[_vm._v("…")])]):_vm._e(),_vm._v(" "),(_vm.hasLast)?_c('li',[(_vm.$scopedSlots.default)?_vm._t("default",null,{page:_vm.getPage(_vm.pageCount)}):_c('BPaginationButton',{attrs:{"page":_vm.getPage(_vm.pageCount)}})],2):_vm._e()],2)],2)};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Pagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );




/***/ }),

/***/ "lktj":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("Ibhu");
var enumBugKeys = __webpack_require__("xnc9");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "lvuN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BStepItem */
/* unused harmony export BSteps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_0e3f4fb5_js__ = __webpack_require__("ji3u");







var _components;
var script = {
  name: 'BSteps',
  components: (_components = {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, __WEBPACK_IMPORTED_MODULE_5__chunk_0e3f4fb5_js__["a" /* S */].name, __WEBPACK_IMPORTED_MODULE_5__chunk_0e3f4fb5_js__["a" /* S */]), _components),
  props: {
    value: [Number, String],
    type: [String, Object],
    size: String,
    animated: {
      type: Boolean,
      default: true
    },
    destroyOnHide: {
      type: Boolean,
      default: false
    },
    iconPack: String,
    iconPrev: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultIconPrev;
      }
    },
    iconNext: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultIconNext;
      }
    },
    hasNavigation: {
      type: Boolean,
      default: true
    },
    vertical: {
      type: Boolean,
      default: false
    },
    position: String,
    labelPosition: {
      type: String,
      validator: function validator(value) {
        return ['bottom', 'right', 'left'].indexOf(value) > -1;
      },
      default: 'bottom'
    },
    rounded: {
      type: Boolean,
      default: true
    },
    mobileMode: {
      type: String,
      validator: function validator(value) {
        return ['minimalist', 'compact'].indexOf(value) > -1;
      },
      default: 'minimalist'
    },
    ariaNextLabel: String,
    ariaPreviousLabel: String
  },
  data: function data() {
    return {
      activeStep: 0,
      defaultSlots: [],
      contentHeight: 0,
      isTransitioning: false,
      _isSteps: true // Used internally by StepItem

    };
  },
  computed: {
    wrapperClasses: function wrapperClasses() {
      return [this.size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({
        'is-vertical': this.vertical
      }, this.position, this.position && this.vertical)];
    },
    mainClasses: function mainClasses() {
      return [this.type, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({
        'has-label-right': this.labelPosition === 'right',
        'has-label-left': this.labelPosition === 'left',
        'is-animated': this.animated,
        'is-rounded': this.rounded
      }, "mobile-".concat(this.mobileMode), this.mobileMode !== null)];
    },
    stepItems: function stepItems() {
      return this.defaultSlots.filter(function (vnode) {
        return vnode.componentInstance && vnode.componentInstance.$data && vnode.componentInstance.$data._isStepItem;
      }).map(function (vnode) {
        return vnode.componentInstance;
      });
    },
    reversedStepItems: function reversedStepItems() {
      return this.stepItems.slice().reverse();
    },

    /**
     * Check the first visible step index.
     */
    firstVisibleStepIndex: function firstVisibleStepIndex() {
      return this.stepItems.map(function (step, idx) {
        return step.visible;
      }).indexOf(true);
    },

    /**
     * Check if previous button is available.
     */
    hasPrev: function hasPrev() {
      return this.firstVisibleStepIndex >= 0 && this.activeStep > this.firstVisibleStepIndex;
    },

    /**
     * Check the last visible step index.
     */
    lastVisibleStepIndex: function lastVisibleStepIndex() {
      var idx = this.reversedStepItems.map(function (step, idx) {
        return step.visible;
      }).indexOf(true);

      if (idx >= 0) {
        return this.stepItems.length - 1 - idx;
      }

      return idx;
    },

    /**
     * Check if next button is available.
     */
    hasNext: function hasNext() {
      return this.lastVisibleStepIndex >= 0 && this.activeStep < this.lastVisibleStepIndex;
    },
    navigationProps: function navigationProps() {
      return {
        previous: {
          disabled: !this.hasPrev,
          action: this.prev
        },
        next: {
          disabled: !this.hasNext,
          action: this.next
        }
      };
    }
  },
  watch: {
    /**
    * When v-model is changed set the new active step.
    */
    value: function value(_value) {
      var index = this.getIndexByValue(_value);
      this.changeStep(index);
    },

    /**
    * When step-items are updated, set active one.
    */
    stepItems: function stepItems() {
      var _this = this;

      if (this.activeStep < this.stepItems.length) {
        var previous = this.activeStep;
        this.stepItems.map(function (step, idx) {
          if (step.isActive) {
            previous = idx;

            if (previous < _this.stepItems.length) {
              _this.stepItems[previous].isActive = false;
            }
          }
        });
        this.stepItems[this.activeStep].isActive = true;
      } else if (this.activeStep > 0) {
        this.changeStep(this.activeStep - 1);
      }
    }
  },
  methods: {
    refreshSlots: function refreshSlots() {
      this.defaultSlots = this.$slots.default || [];
    },

    /**
     * Change the active step and emit change event.
     */
    changeStep: function changeStep(newIndex) {
      if (this.activeStep === newIndex) return;
      if (newIndex > this.stepItems.length) throw new Error('The index you trying to set is bigger than the steps length');

      if (this.activeStep < this.stepItems.length) {
        this.stepItems[this.activeStep].deactivate(this.activeStep, newIndex);
      }

      this.stepItems[newIndex].activate(this.activeStep, newIndex);
      this.activeStep = newIndex;
      this.$emit('change', this.getValueByIndex(newIndex));
    },

    /**
     * Return if the step should be clickable or not.
     */
    isItemClickable: function isItemClickable(stepItem, index) {
      if (stepItem.clickable === undefined) {
        return this.activeStep > index;
      }

      return stepItem.clickable;
    },

    /**
     * Step click listener, emit input event and change active step.
     */
    stepClick: function stepClick(index) {
      this.$emit('input', this.getValueByIndex(index));
      this.changeStep(index);
    },

    /**
     * Previous button click listener.
     */
    prev: function prev() {
      var _this2 = this;

      if (!this.hasPrev) return;
      var prevItemIdx = this.reversedStepItems.map(function (step, idx) {
        return _this2.stepItems.length - 1 - idx < _this2.activeStep && step.visible;
      }).indexOf(true);

      if (prevItemIdx >= 0) {
        prevItemIdx = this.stepItems.length - 1 - prevItemIdx;
      }

      this.$emit('input', this.getValueByIndex(prevItemIdx));
      this.changeStep(prevItemIdx);
    },

    /**
     * Previous button click listener.
     */
    next: function next() {
      var _this3 = this;

      if (!this.hasNext) return;
      var nextItemIdx = this.stepItems.map(function (step, idx) {
        return idx > _this3.activeStep && step.visible;
      }).indexOf(true);
      this.$emit('input', this.getValueByIndex(nextItemIdx));
      this.changeStep(nextItemIdx);
    },
    getIndexByValue: function getIndexByValue(value) {
      var index = this.stepItems.map(function (t) {
        return t.$options.propsData ? t.$options.propsData.value : undefined;
      }).indexOf(value);
      return index >= 0 ? index : value;
    },
    getValueByIndex: function getValueByIndex(index) {
      var propsData = this.stepItems[index].$options.propsData;
      return propsData && propsData.value ? propsData.value : index;
    }
  },
  mounted: function mounted() {
    this.activeStep = this.getIndexByValue(this.value || 0);

    if (this.activeStep < this.stepItems.length) {
      this.stepItems[this.activeStep].isActive = true;
    }

    this.refreshSlots();
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-steps",class:_vm.wrapperClasses},[_c('nav',{staticClass:"steps",class:_vm.mainClasses},[_c('ul',{staticClass:"step-items"},_vm._l((_vm.stepItems),function(stepItem,index){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(stepItem.visible),expression:"stepItem.visible"}],key:index,staticClass:"step-item",class:[stepItem.type || _vm.type, {
                        'is-active': _vm.activeStep === index,
                        'is-previous': _vm.activeStep > index
                }]},[_c('a',{staticClass:"step-link",class:{'is-clickable': _vm.isItemClickable(stepItem, index)},on:{"click":function($event){_vm.isItemClickable(stepItem, index) && _vm.stepClick(index);}}},[_c('div',{staticClass:"step-marker"},[(stepItem.icon)?_c('b-icon',{attrs:{"icon":stepItem.icon,"pack":stepItem.iconPack,"size":_vm.size}}):(stepItem.step)?_c('span',[_vm._v(_vm._s(stepItem.step))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"step-details"},[_c('span',{staticClass:"step-title"},[_vm._v(_vm._s(stepItem.label))])])])])}))]),_vm._v(" "),_c('section',{staticClass:"step-content",class:{'is-transitioning': _vm.isTransitioning}},[_vm._t("default")],2),_vm._v(" "),_vm._t("navigation",[(_vm.hasNavigation)?_c('nav',{staticClass:"step-navigation"},[_c('a',{staticClass:"pagination-previous",attrs:{"role":"button","disabled":_vm.navigationProps.previous.disabled,"aria-label":_vm.ariaPreviousLabel},on:{"click":function($event){$event.preventDefault();return _vm.navigationProps.previous.action($event)}}},[_c('b-icon',{attrs:{"icon":_vm.iconPrev,"pack":_vm.iconPack,"both":"","aria-hidden":"true"}})],1),_vm._v(" "),_c('a',{staticClass:"pagination-next",attrs:{"role":"button","disabled":_vm.navigationProps.next.disabled,"aria-label":_vm.ariaNextLabel},on:{"click":function($event){$event.preventDefault();return _vm.navigationProps.next.action($event)}}},[_c('b-icon',{attrs:{"icon":_vm.iconNext,"pack":_vm.iconPack,"both":"","aria-hidden":"true"}})],1)]):_vm._e()],{previous:_vm.navigationProps.previous,next:_vm.navigationProps.next})],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Steps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var script$1 = {
  name: 'BStepItem',
  props: {
    step: [String, Number],
    label: String,
    type: [String, Object],
    icon: String,
    iconPack: String,
    clickable: {
      type: Boolean,
      default: undefined
    },
    visible: {
      type: Boolean,
      default: true
    },
    value: [String, Number]
  },
  data: function data() {
    return {
      isActive: false,
      transitionName: null,
      _isStepItem: true // Used internally by Step

    };
  },
  methods: {
    /**
    * Activate step, alter animation name based on the index.
    */
    activate: function activate(oldIndex, index) {
      this.transitionName = index < oldIndex ? this.$parent.vertical ? 'slide-down' : 'slide-next' : this.$parent.vertical ? 'slide-up' : 'slide-prev';
      this.isActive = true;
    },

    /**
    * Deactivate step, alter animation name based on the index.
    */
    deactivate: function deactivate(oldIndex, index) {
      this.transitionName = index < oldIndex ? this.$parent.vertical ? 'slide-down' : 'slide-next' : this.$parent.vertical ? 'slide-up' : 'slide-prev';
      this.isActive = false;
    }
  },
  created: function created() {
    if (!this.$parent.$data._isSteps) {
      this.$destroy();
      throw new Error('You should wrap bStepItem on a bSteps');
    }

    this.$parent.refreshSlots();
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.refreshSlots();
  },
  render: function render(createElement) {
    var _this = this;

    // if destroy apply v-if
    if (this.$parent.destroyOnHide) {
      if (!this.isActive || !this.visible) {
        return;
      }
    }

    var vnode = createElement('div', {
      directives: [{
        name: 'show',
        value: this.isActive && this.visible
      }],
      attrs: {
        'class': 'step-item'
      }
    }, this.$slots.default); // check animated prop

    if (this.$parent.animated) {
      return createElement('transition', {
        props: {
          'name': this.transitionName
        },
        on: {
          'before-enter': function beforeEnter() {
            _this.$parent.isTransitioning = true;
          },
          'after-enter': function afterEnter() {
            _this.$parent.isTransitioning = false;
          }
        }
      }, [vnode]);
    }

    return vnode;
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = undefined;
  /* style inject */
  
  /* style inject SSR */
  

  
  var StepItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    {},
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, Steps);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, StepItem);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "m6gj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_d0a313ea_js__ = __webpack_require__("EmVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__ = __webpack_require__("QR9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chunk_42f463e6_js__ = __webpack_require__("mMDG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chunk_4d76806f_js__ = __webpack_require__("t4YS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__chunk_eb60b35a_js__ = __webpack_require__("RbWz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__chunk_77ffdf8b_js__ = __webpack_require__("8cDm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__chunk_66a4ceca_js__ = __webpack_require__("ajTP");
/* unused harmony reexport BDatepicker */














var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["d" /* r */])(Vue, __WEBPACK_IMPORTED_MODULE_11__chunk_66a4ceca_js__["a" /* D */]);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);


/***/ }),

/***/ "mMDG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return directive; });
var findFocusable = function findFocusable(element) {
  var programmatic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!element) {
    return null;
  }

  if (programmatic) {
    return element.querySelectorAll("*[tabindex=\"-1\"]");
  }

  return element.querySelectorAll("a[href]:not([tabindex=\"-1\"]),\n                                     area[href],\n                                     input:not([disabled]),\n                                     select:not([disabled]),\n                                     textarea:not([disabled]),\n                                     button:not([disabled]),\n                                     iframe,\n                                     object,\n                                     embed,\n                                     *[tabindex]:not([tabindex=\"-1\"]),\n                                     *[contenteditable]");
};

var onKeyDown;

var bind = function bind(el, _ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? true : _ref$value;

  if (value) {
    var focusable = findFocusable(el);
    var focusableProg = findFocusable(el, true);

    if (focusable && focusable.length > 0) {
      onKeyDown = function onKeyDown(event) {
        // Need to get focusable each time since it can change between key events
        // ex. changing month in a datepicker
        focusable = findFocusable(el);
        focusableProg = findFocusable(el, true);
        var firstFocusable = focusable[0];
        var lastFocusable = focusable[focusable.length - 1];

        if (event.target === firstFocusable && event.shiftKey && event.key === 'Tab') {
          event.preventDefault();
          lastFocusable.focus();
        } else if ((event.target === lastFocusable || Array.from(focusableProg).indexOf(event.target) >= 0) && !event.shiftKey && event.key === 'Tab') {
          event.preventDefault();
          firstFocusable.focus();
        }
      };

      el.addEventListener('keydown', onKeyDown);
    }
  }
};

var unbind = function unbind(el) {
  el.removeEventListener('keydown', onKeyDown);
};

var directive = {
  bind: bind,
  unbind: unbind
};




/***/ }),

/***/ "msXi":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("77Pl");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "mtWM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("tIFN");

/***/ }),

/***/ "mvHQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("qkKv"), __esModule: true };

/***/ }),

/***/ "mypn":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "nsBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__ = __webpack_require__("rhEV");






var script = {
  name: 'BButton',
  components: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({}, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */]),
  inheritAttrs: false,
  props: {
    type: [String, Object],
    size: String,
    label: String,
    iconPack: String,
    iconLeft: String,
    iconRight: String,
    rounded: {
      type: Boolean,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultButtonRounded;
      }
    },
    loading: Boolean,
    outlined: Boolean,
    expanded: Boolean,
    inverted: Boolean,
    focused: Boolean,
    active: Boolean,
    hovered: Boolean,
    selected: Boolean,
    nativeType: {
      type: String,
      default: 'button',
      validator: function validator(value) {
        return ['button', 'submit', 'reset'].indexOf(value) >= 0;
      }
    },
    tag: {
      type: String,
      default: 'button',
      validator: function validator(value) {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultLinkTags.indexOf(value) >= 0;
      }
    }
  },
  computed: {
    computedTag: function computedTag() {
      if (this.$attrs.disabled !== undefined && this.$attrs.disabled !== false) {
        return 'button';
      }

      return this.tag;
    },
    iconSize: function iconSize() {
      if (!this.size || this.size === 'is-medium') {
        return 'is-small';
      } else if (this.size === 'is-large') {
        return 'is-medium';
      }

      return this.size;
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.computedTag,_vm._g(_vm._b({tag:"component",staticClass:"button",class:[_vm.size, _vm.type, {
            'is-rounded': _vm.rounded,
            'is-loading': _vm.loading,
            'is-outlined': _vm.outlined,
            'is-fullwidth': _vm.expanded,
            'is-inverted': _vm.inverted,
            'is-focused': _vm.focused,
            'is-active': _vm.active,
            'is-hovered': _vm.hovered,
            'is-selected': _vm.selected
        }],attrs:{"type":_vm.nativeType}},'component',_vm.$attrs,false),_vm.$listeners),[(_vm.iconLeft)?_c('b-icon',{attrs:{"pack":_vm.iconPack,"icon":_vm.iconLeft,"size":_vm.iconSize}}):_vm._e(),_vm._v(" "),(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label))]):(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.iconRight)?_c('b-icon',{attrs:{"pack":_vm.iconPack,"icon":_vm.iconRight,"size":_vm.iconSize}}):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Button = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, Button);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "oIlB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BRadio */
/* unused harmony export BRadioButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_2793447b_js__ = __webpack_require__("gNW3");



//
var script = {
  name: 'BRadio',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__chunk_2793447b_js__["a" /* C */]]
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{ref:"label",staticClass:"b-radio radio",class:[_vm.size, { 'is-disabled': _vm.disabled }],attrs:{"disabled":_vm.disabled},on:{"click":_vm.focus,"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();_vm.$refs.label.click();}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.computedValue),expression:"computedValue"}],ref:"input",attrs:{"type":"radio","disabled":_vm.disabled,"required":_vm.required,"name":_vm.name},domProps:{"value":_vm.nativeValue,"checked":_vm._q(_vm.computedValue,_vm.nativeValue)},on:{"click":function($event){$event.stopPropagation();},"change":function($event){_vm.computedValue=_vm.nativeValue;}}}),_vm._v(" "),_c('span',{staticClass:"check",class:_vm.type}),_vm._v(" "),_c('span',{staticClass:"control-label"},[_vm._t("default")],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Radio = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//
var script$1 = {
  name: 'BRadioButton',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__chunk_2793447b_js__["a" /* C */]],
  props: {
    type: {
      type: String,
      default: 'is-primary'
    },
    expanded: Boolean
  },
  data: function data() {
    return {
      isFocused: false
    };
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control",class:{ 'is-expanded': _vm.expanded }},[_c('label',{ref:"label",staticClass:"b-radio radio button",class:[_vm.newValue === _vm.nativeValue ? _vm.type : null, _vm.size, {
                'is-disabled': _vm.disabled,
                'is-focused': _vm.isFocused
            }],attrs:{"disabled":_vm.disabled},on:{"click":_vm.focus,"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();_vm.$refs.label.click();}}},[_vm._t("default"),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.computedValue),expression:"computedValue"}],ref:"input",attrs:{"type":"radio","disabled":_vm.disabled,"required":_vm.required,"name":_vm.name},domProps:{"value":_vm.nativeValue,"checked":_vm._q(_vm.computedValue,_vm.nativeValue)},on:{"click":function($event){$event.stopPropagation();},"focus":function($event){_vm.isFocused = true;},"blur":function($event){_vm.isFocused = false;},"change":function($event){_vm.computedValue=_vm.nativeValue;}}})],2)])};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var RadioButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["d" /* r */])(Vue, Radio);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["d" /* r */])(Vue, RadioButton);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "oJlt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "p1b6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ "pBtG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "pxG4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "qARP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("lOnJ");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "qRfI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "qio6":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("evD5");
var anObject = __webpack_require__("77Pl");
var getKeys = __webpack_require__("lktj");

module.exports = __webpack_require__("+E39") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "qkKv":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("FeBl");
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ "r429":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _defineProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _objectSpread2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _typeof; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _toArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _toConsumableArray; });
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}




/***/ }),

/***/ "rHUL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_42f463e6_js__ = __webpack_require__("mMDG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_4d76806f_js__ = __webpack_require__("t4YS");
/* unused harmony reexport BDropdown */
/* unused harmony reexport BDropdownItem */








var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["d" /* r */])(Vue, __WEBPACK_IMPORTED_MODULE_5__chunk_4d76806f_js__["a" /* D */]);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["d" /* r */])(Vue, __WEBPACK_IMPORTED_MODULE_5__chunk_4d76806f_js__["b" /* a */]);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);


/***/ }),

/***/ "rhEV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return normalizeComponent_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return registerComponentProgrammatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return registerComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return use; });
function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var use = function use(plugin) {
  if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
  }
};
var registerComponent = function registerComponent(Vue, component) {
  Vue.component(component.name, component);
};
var registerComponentProgrammatic = function registerComponentProgrammatic(Vue, property, component) {
  if (!Vue.prototype.$buefy) Vue.prototype.$buefy = {};
  Vue.prototype.$buefy[property] = component;
};




/***/ }),

/***/ "rjj0":
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__("tTVk")

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "sB3e":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("52gC");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "sBwo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_d0a313ea_js__ = __webpack_require__("EmVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chunk_d1591eb8_js__ = __webpack_require__("QR9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chunk_1196ee55_js__ = __webpack_require__("iBFZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chunk_42f463e6_js__ = __webpack_require__("mMDG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__chunk_4d76806f_js__ = __webpack_require__("t4YS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__chunk_eb60b35a_js__ = __webpack_require__("RbWz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__chunk_77ffdf8b_js__ = __webpack_require__("8cDm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__chunk_a684d1f3_js__ = __webpack_require__("5udn");
/* unused harmony reexport BTimepicker */















var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["d" /* r */])(Vue, __WEBPACK_IMPORTED_MODULE_12__chunk_a684d1f3_js__["a" /* T */]);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);


/***/ }),

/***/ "t4YS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DropdownItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_42f463e6_js__ = __webpack_require__("mMDG");






var DEFAULT_CLOSE_OPTIONS = ['escape', 'outside'];
var script = {
  name: 'BDropdown',
  directives: {
    trapFocus: __WEBPACK_IMPORTED_MODULE_4__chunk_42f463e6_js__["a" /* t */]
  },
  props: {
    value: {
      type: [String, Number, Boolean, Object, Array, Function],
      default: null
    },
    disabled: Boolean,
    hoverable: Boolean,
    inline: Boolean,
    scrollable: Boolean,
    maxHeight: {
      type: [String, Number],
      default: 200
    },
    position: {
      type: String,
      validator: function validator(value) {
        return ['is-top-right', 'is-top-left', 'is-bottom-left', 'is-bottom-right'].indexOf(value) > -1;
      }
    },
    mobileModal: {
      type: Boolean,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultDropdownMobileModal;
      }
    },
    ariaRole: {
      type: String,
      validator: function validator(value) {
        return ['menu', 'list', 'dialog'].indexOf(value) > -1;
      },
      default: null
    },
    animation: {
      type: String,
      default: 'fade'
    },
    multiple: Boolean,
    trapFocus: {
      type: Boolean,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultTrapFocus;
      }
    },
    closeOnClick: {
      type: Boolean,
      default: true
    },
    canClose: {
      type: [Array, Boolean],
      default: true
    },
    expanded: Boolean,
    appendToBody: Boolean,
    appendToBodyCopyParent: Boolean
  },
  data: function data() {
    return {
      selected: this.value,
      style: {},
      isActive: false,
      isHoverable: this.hoverable,
      _isDropdown: true,
      // Used internally by DropdownItem
      _bodyEl: undefined // Used to append to body

    };
  },
  computed: {
    rootClasses: function rootClasses() {
      return [this.position, {
        'is-disabled': this.disabled,
        'is-hoverable': this.hoverable,
        'is-inline': this.inline,
        'is-active': this.isActive || this.inline,
        'is-mobile-modal': this.isMobileModal,
        'is-expanded': this.expanded
      }];
    },
    isMobileModal: function isMobileModal() {
      return this.mobileModal && !this.inline && !this.hoverable;
    },
    cancelOptions: function cancelOptions() {
      return typeof this.canClose === 'boolean' ? this.canClose ? DEFAULT_CLOSE_OPTIONS : [] : this.canClose;
    },
    contentStyle: function contentStyle() {
      return {
        maxHeight: this.scrollable ? this.maxHeight === undefined ? null : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px' : null,
        overflow: this.scrollable ? 'auto' : null
      };
    }
  },
  watch: {
    /**
    * When v-model is changed set the new selected item.
    */
    value: function value(_value) {
      this.selected = _value;
    },

    /**
    * Emit event when isActive value is changed.
    */
    isActive: function isActive(value) {
      var _this = this;

      this.$emit('active-change', value);

      if (this.appendToBody) {
        this.$nextTick(function () {
          _this.updateAppendToBody();
        });
      }
    }
  },
  methods: {
    /**
    * Click listener from DropdownItem.
    *   1. Set new selected item.
    *   2. Emit input event to update the user v-model.
    *   3. Close the dropdown.
    */
    selectItem: function selectItem(value) {
      if (this.multiple) {
        if (this.selected) {
          var index = this.selected.indexOf(value);

          if (index === -1) {
            this.selected.push(value);
          } else {
            this.selected.splice(index, 1);
          }
        } else {
          this.selected = [value];
        }

        this.$emit('change', this.selected);
      } else {
        if (this.selected !== value) {
          this.selected = value;
          this.$emit('change', this.selected);
        }
      }

      this.$emit('input', this.selected);

      if (!this.multiple) {
        this.isActive = !this.closeOnClick;

        if (this.hoverable && this.closeOnClick) {
          this.isHoverable = false;
        }
      }
    },

    /**
    * White-listed items to not close when clicked.
    */
    isInWhiteList: function isInWhiteList(el) {
      if (el === this.$refs.dropdownMenu) return true;
      if (el === this.$refs.trigger) return true; // All chidren from dropdown

      if (this.$refs.dropdownMenu !== undefined) {
        var children = this.$refs.dropdownMenu.querySelectorAll('*');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var child = _step.value;

            if (el === child) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } // All children from trigger


      if (this.$refs.trigger !== undefined) {
        var _children = this.$refs.trigger.querySelectorAll('*');

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = _children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _child = _step2.value;

            if (el === _child) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      return false;
    },

    /**
    * Close dropdown if clicked outside.
    */
    clickedOutside: function clickedOutside(event) {
      if (this.cancelOptions.indexOf('outside') < 0) return;
      if (this.inline) return;
      if (!this.isInWhiteList(event.target)) this.isActive = false;
    },

    /**
     * Keypress event that is bound to the document
     */
    keyPress: function keyPress(event) {
      // Esc key
      if (this.isActive && event.keyCode === 27) {
        if (this.cancelOptions.indexOf('escape') < 0) return;
        this.isActive = false;
      }
    },

    /**
    * Toggle dropdown if it's not disabled.
    */
    toggle: function toggle() {
      var _this2 = this;

      if (this.disabled) return;

      if (!this.isActive) {
        // if not active, toggle after clickOutside event
        // this fixes toggling programmatic
        this.$nextTick(function () {
          var value = !_this2.isActive;
          _this2.isActive = value; // Vue 2.6.x ???

          setTimeout(function () {
            return _this2.isActive = value;
          });
        });
      } else {
        this.isActive = !this.isActive;
      }
    },
    checkHoverable: function checkHoverable() {
      if (this.hoverable) {
        this.isHoverable = true;
      }
    },
    updateAppendToBody: function updateAppendToBody() {
      var dropdownMenu = this.$refs.dropdownMenu;
      var trigger = this.$refs.trigger;

      if (dropdownMenu && trigger) {
        // update wrapper dropdown
        var dropdown = this.$data._bodyEl.children[0];
        dropdown.classList.forEach(function (item) {
          return dropdown.classList.remove(item);
        });
        dropdown.classList.add('dropdown');
        dropdown.classList.add('dropdown-menu-animation');

        if (this.$vnode && this.$vnode.data && this.$vnode.data.staticClass) {
          dropdown.classList.add(this.$vnode.data.staticClass);
        }

        this.rootClasses.forEach(function (item) {
          // skip position prop
          if (item && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["a" /* b */])(item) === 'object') {
            for (var key in item) {
              if (item[key]) {
                dropdown.classList.add(key);
              }
            }
          }
        });

        if (this.appendToBodyCopyParent) {
          var parentNode = this.$refs.dropdown.parentNode;
          var parent = this.$data._bodyEl;
          parent.classList.forEach(function (item) {
            return parent.classList.remove(item);
          });
          parentNode.classList.forEach(function (item) {
            parent.classList.add(item);
          });
        }

        var rect = trigger.getBoundingClientRect();
        var top = rect.top + window.scrollY;
        var left = rect.left + window.scrollX;

        if (!this.position || this.position.indexOf('bottom') >= 0) {
          top += trigger.clientHeight;
        } else {
          top -= dropdownMenu.clientHeight;
        }

        if (this.position && this.position.indexOf('left') >= 0) {
          left -= dropdownMenu.clientWidth - trigger.clientWidth;
        }

        this.style = {
          position: 'absolute',
          top: "".concat(top, "px"),
          left: "".concat(left, "px"),
          zIndex: '99'
        };
      }
    }
  },
  mounted: function mounted() {
    if (this.appendToBody) {
      this.$data._bodyEl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["d" /* createAbsoluteElement */])(this.$refs.dropdownMenu);
      this.updateAppendToBody();
    }
  },
  created: function created() {
    if (typeof window !== 'undefined') {
      document.addEventListener('click', this.clickedOutside);
      document.addEventListener('keyup', this.keyPress);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      document.removeEventListener('click', this.clickedOutside);
      document.removeEventListener('keyup', this.keyPress);
    }

    if (this.appendToBody) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["b" /* removeElement */])(this.$data._bodyEl);
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropdown",staticClass:"dropdown dropdown-menu-animation",class:_vm.rootClasses},[(!_vm.inline)?_c('div',{ref:"trigger",staticClass:"dropdown-trigger",attrs:{"role":"button","aria-haspopup":"true"},on:{"click":_vm.toggle,"mouseenter":_vm.checkHoverable}},[_vm._t("trigger",null,{active:_vm.isActive})],2):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":_vm.animation}},[(_vm.isMobileModal)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"background",attrs:{"aria-hidden":!_vm.isActive}}):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.animation}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:((!_vm.disabled && (_vm.isActive || _vm.isHoverable)) || _vm.inline),expression:"(!disabled && (isActive || isHoverable)) || inline"},{name:"trap-focus",rawName:"v-trap-focus",value:(_vm.trapFocus),expression:"trapFocus"}],ref:"dropdownMenu",staticClass:"dropdown-menu",style:(_vm.style),attrs:{"aria-hidden":!_vm.isActive}},[_c('div',{staticClass:"dropdown-content",style:(_vm.contentStyle),attrs:{"role":_vm.ariaRole}},[_vm._t("default")],2)])])],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Dropdown = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1 = {
  name: 'BDropdownItem',
  props: {
    value: {
      type: [String, Number, Boolean, Object, Array, Function],
      default: null
    },
    separator: Boolean,
    disabled: Boolean,
    custom: Boolean,
    focusable: {
      type: Boolean,
      default: true
    },
    paddingless: Boolean,
    hasLink: Boolean,
    ariaRole: {
      type: String,
      default: ''
    }
  },
  computed: {
    anchorClasses: function anchorClasses() {
      return {
        'is-disabled': this.$parent.disabled || this.disabled,
        'is-paddingless': this.paddingless,
        'is-active': this.isActive
      };
    },
    itemClasses: function itemClasses() {
      return {
        'dropdown-item': !this.hasLink,
        'is-disabled': this.disabled,
        'is-paddingless': this.paddingless,
        'is-active': this.isActive,
        'has-link': this.hasLink
      };
    },
    ariaRoleItem: function ariaRoleItem() {
      return this.ariaRole === 'menuitem' || this.ariaRole === 'listitem' ? this.ariaRole : null;
    },
    isClickable: function isClickable() {
      return !this.$parent.disabled && !this.separator && !this.disabled && !this.custom;
    },
    isActive: function isActive() {
      if (this.$parent.selected === null) return false;
      if (this.$parent.multiple) return this.$parent.selected.indexOf(this.value) >= 0;
      return this.value === this.$parent.selected;
    },
    isFocusable: function isFocusable() {
      return this.hasLink ? false : this.focusable;
    }
  },
  methods: {
    /**
    * Click listener, select the item.
    */
    selectItem: function selectItem() {
      if (!this.isClickable) return;
      this.$parent.selectItem(this.value);
      this.$emit('click');
    }
  },
  created: function created() {
    if (!this.$parent.$data._isDropdown) {
      this.$destroy();
      throw new Error('You should wrap bDropdownItem on a bDropdown');
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.separator)?_c('hr',{staticClass:"dropdown-divider"}):(!_vm.custom && !_vm.hasLink)?_c('a',{staticClass:"dropdown-item",class:_vm.anchorClasses,attrs:{"role":_vm.ariaRoleItem,"tabindex":_vm.isFocusable ? 0 : null},on:{"click":_vm.selectItem}},[_vm._t("default")],2):_c('div',{class:_vm.itemClasses,attrs:{"role":_vm.ariaRoleItem,"tabindex":_vm.isFocusable ? 0 : null},on:{"click":_vm.selectItem}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var DropdownItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );




/***/ }),

/***/ "t8qj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ "t8x9":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("77Pl");
var aFunction = __webpack_require__("lOnJ");
var SPECIES = __webpack_require__("dSzd")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "tIFN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var bind = __webpack_require__("JP+z");
var Axios = __webpack_require__("XmWM");
var mergeConfig = __webpack_require__("DUeU");
var defaults = __webpack_require__("KCLY");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("dVOP");
axios.CancelToken = __webpack_require__("cWxy");
axios.isCancel = __webpack_require__("pBtG");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("pxG4");

// Expose isAxiosError
axios.isAxiosError = __webpack_require__("SLDG");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "tTVk":
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),

/***/ "tYb/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BRate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__ = __webpack_require__("rhEV");






var script = {
  name: 'BRate',
  components: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({}, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */].name, __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__["a" /* I */]),
  props: {
    value: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 5
    },
    icon: {
      type: String,
      default: 'star'
    },
    iconPack: String,
    size: String,
    spaced: Boolean,
    rtl: Boolean,
    disabled: Boolean,
    showScore: Boolean,
    showText: Boolean,
    customText: String,
    texts: Array
  },
  data: function data() {
    return {
      newValue: this.value,
      hoverValue: 0
    };
  },
  computed: {
    halfStyle: function halfStyle() {
      return "width:".concat(this.valueDecimal, "%");
    },
    showMe: function showMe() {
      var result = '';

      if (this.showScore) {
        result = this.disabled ? this.value : this.newValue;
        if (result === 0) result = '';
      } else if (this.showText) {
        result = this.texts[Math.ceil(this.newValue) - 1];
      }

      return result;
    },
    valueDecimal: function valueDecimal() {
      return this.value * 100 - Math.floor(this.value) * 100;
    }
  },
  watch: {
    // When v-model is changed set the new value.
    value: function value(_value) {
      this.newValue = _value;
    }
  },
  methods: {
    resetNewValue: function resetNewValue() {
      if (this.disabled) return;
      this.hoverValue = 0;
    },
    previewRate: function previewRate(index, event) {
      if (this.disabled) return;
      this.hoverValue = index;
      event.stopPropagation();
    },
    confirmValue: function confirmValue(index) {
      if (this.disabled) return;
      this.newValue = index;
      this.$emit('change', this.newValue);
      this.$emit('input', this.newValue);
    },
    checkHalf: function checkHalf(index) {
      var showWhenDisabled = this.disabled && this.valueDecimal > 0 && index - 1 < this.value && index > this.value;
      return showWhenDisabled;
    },
    rateClass: function rateClass(index) {
      var output = '';
      var currentValue = this.hoverValue !== 0 ? this.hoverValue : this.newValue;

      if (index <= currentValue) {
        output = 'set-on';
      } else if (this.disabled && Math.ceil(this.value) === index) {
        output = 'set-half';
      }

      return output;
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rate",class:{ 'is-disabled': _vm.disabled, 'is-spaced': _vm.spaced, 'is-rtl': _vm.rtl }},[_vm._l((_vm.max),function(item,index){return _c('div',{key:index,staticClass:"rate-item",class:_vm.rateClass(item),on:{"mousemove":function($event){_vm.previewRate(item, $event);},"mouseleave":_vm.resetNewValue,"click":function($event){$event.preventDefault();_vm.confirmValue(item);}}},[_c('b-icon',{attrs:{"pack":_vm.iconPack,"icon":_vm.icon,"size":_vm.size}}),_vm._v(" "),(_vm.checkHalf(item))?_c('b-icon',{staticClass:"is-half",style:(_vm.halfStyle),attrs:{"pack":_vm.iconPack,"icon":_vm.icon,"size":_vm.size}}):_vm._e()],1)}),_vm._v(" "),(_vm.showText || _vm.showScore || _vm.customText)?_c('div',{staticClass:"rate-text",class:_vm.size},[_c('span',[_vm._v(_vm._s(_vm.showMe))]),_vm._v(" "),(_vm.customText && !_vm.showText)?_c('span',[_vm._v(_vm._s(_vm.customText))]):_vm._e()]):_vm._e()],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Rate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, Rate);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "ucd5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cdfca85b_js__ = __webpack_require__("y1ZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chunk_0e26d208_js__ = __webpack_require__("1Wsa");







//
var script = {
  name: 'BMessage',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__chunk_0e26d208_js__["a" /* M */]],
  props: {
    ariaCloseLabel: String
  },
  data: function data() {
    return {
      newIconSize: this.iconSize || this.size || 'is-large'
    };
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isActive)?_c('article',{staticClass:"message",class:[_vm.type, _vm.size]},[(_vm.title)?_c('header',{staticClass:"message-header"},[_c('p',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.closable)?_c('button',{staticClass:"delete",attrs:{"type":"button","aria-label":_vm.ariaCloseLabel},on:{"click":_vm.close}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"message-body"},[_c('div',{staticClass:"media"},[(_vm.computedIcon && _vm.hasIcon)?_c('div',{staticClass:"media-left"},[_c('b-icon',{class:_vm.type,attrs:{"icon":_vm.computedIcon,"pack":_vm.iconPack,"both":"","size":_vm.newIconSize}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-content"},[_vm._t("default")],2)])])]):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["d" /* r */])(Vue, Message);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "uqUo":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("kM2E");
var core = __webpack_require__("FeBl");
var fails = __webpack_require__("S82l");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "us/S":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("Xd32"), __esModule: true };

/***/ }),

/***/ "vFc/":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("TcQ7");
var toLength = __webpack_require__("QRG4");
var toAbsoluteIndex = __webpack_require__("fkB2");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "vIB/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("O4g8");
var $export = __webpack_require__("kM2E");
var redefine = __webpack_require__("880/");
var hide = __webpack_require__("hJx8");
var Iterators = __webpack_require__("/bQp");
var $iterCreate = __webpack_require__("94VQ");
var setToStringTag = __webpack_require__("e6n0");
var getPrototypeOf = __webpack_require__("PzxK");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "vLxT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BSlider */
/* unused harmony export BSliderTick */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_9ec85033_js__ = __webpack_require__("h7Sf");





var script = {
  name: 'BSliderThumb',
  components: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])({}, __WEBPACK_IMPORTED_MODULE_3__chunk_9ec85033_js__["a" /* T */].name, __WEBPACK_IMPORTED_MODULE_3__chunk_9ec85033_js__["a" /* T */]),
  inheritAttrs: false,
  props: {
    value: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    },
    tooltip: {
      type: Boolean,
      default: true
    },
    customFormatter: Function
  },
  data: function data() {
    return {
      isFocused: false,
      dragging: false,
      startX: 0,
      startPosition: 0,
      newPosition: null,
      oldValue: this.value
    };
  },
  computed: {
    disabled: function disabled() {
      return this.$parent.disabled;
    },
    max: function max() {
      return this.$parent.max;
    },
    min: function min() {
      return this.$parent.min;
    },
    step: function step() {
      return this.$parent.step;
    },
    precision: function precision() {
      return this.$parent.precision;
    },
    currentPosition: function currentPosition() {
      return "".concat((this.value - this.min) / (this.max - this.min) * 100, "%");
    },
    wrapperStyle: function wrapperStyle() {
      return {
        left: this.currentPosition
      };
    },
    tooltipLabel: function tooltipLabel() {
      return typeof this.customFormatter !== 'undefined' ? this.customFormatter(this.value) : this.value.toString();
    }
  },
  methods: {
    onFocus: function onFocus() {
      this.isFocused = true;
    },
    onBlur: function onBlur() {
      this.isFocused = false;
    },
    onButtonDown: function onButtonDown(event) {
      if (this.disabled) return;
      event.preventDefault();
      this.onDragStart(event);

      if (typeof window !== 'undefined') {
        document.addEventListener('mousemove', this.onDragging);
        document.addEventListener('touchmove', this.onDragging);
        document.addEventListener('mouseup', this.onDragEnd);
        document.addEventListener('touchend', this.onDragEnd);
        document.addEventListener('contextmenu', this.onDragEnd);
      }
    },
    onLeftKeyDown: function onLeftKeyDown() {
      if (this.disabled || this.value === this.min) return;
      this.newPosition = parseFloat(this.currentPosition) - this.step / (this.max - this.min) * 100;
      this.setPosition(this.newPosition);
      this.$parent.emitValue('change');
    },
    onRightKeyDown: function onRightKeyDown() {
      if (this.disabled || this.value === this.max) return;
      this.newPosition = parseFloat(this.currentPosition) + this.step / (this.max - this.min) * 100;
      this.setPosition(this.newPosition);
      this.$parent.emitValue('change');
    },
    onHomeKeyDown: function onHomeKeyDown() {
      if (this.disabled || this.value === this.min) return;
      this.newPosition = 0;
      this.setPosition(this.newPosition);
      this.$parent.emitValue('change');
    },
    onEndKeyDown: function onEndKeyDown() {
      if (this.disabled || this.value === this.max) return;
      this.newPosition = 100;
      this.setPosition(this.newPosition);
      this.$parent.emitValue('change');
    },
    onDragStart: function onDragStart(event) {
      this.dragging = true;
      this.$emit('dragstart');

      if (event.type === 'touchstart') {
        event.clientX = event.touches[0].clientX;
      }

      this.startX = event.clientX;
      this.startPosition = parseFloat(this.currentPosition);
      this.newPosition = this.startPosition;
    },
    onDragging: function onDragging(event) {
      if (this.dragging) {
        if (event.type === 'touchmove') {
          event.clientX = event.touches[0].clientX;
        }

        var diff = (event.clientX - this.startX) / this.$parent.sliderSize() * 100;
        this.newPosition = this.startPosition + diff;
        this.setPosition(this.newPosition);
      }
    },
    onDragEnd: function onDragEnd() {
      this.dragging = false;
      this.$emit('dragend');

      if (this.value !== this.oldValue) {
        this.$parent.emitValue('change');
      }

      this.setPosition(this.newPosition);

      if (typeof window !== 'undefined') {
        document.removeEventListener('mousemove', this.onDragging);
        document.removeEventListener('touchmove', this.onDragging);
        document.removeEventListener('mouseup', this.onDragEnd);
        document.removeEventListener('touchend', this.onDragEnd);
        document.removeEventListener('contextmenu', this.onDragEnd);
      }
    },
    setPosition: function setPosition(percent) {
      if (percent === null || isNaN(percent)) return;

      if (percent < 0) {
        percent = 0;
      } else if (percent > 100) {
        percent = 100;
      }

      var stepLength = 100 / ((this.max - this.min) / this.step);
      var steps = Math.round(percent / stepLength);
      var value = steps * stepLength / 100 * (this.max - this.min) + this.min;
      value = parseFloat(value.toFixed(this.precision));
      this.$emit('input', value);

      if (!this.dragging && value !== this.oldValue) {
        this.oldValue = value;
      }
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-slider-thumb-wrapper",class:{ 'is-dragging': _vm.dragging },style:(_vm.wrapperStyle)},[_c('b-tooltip',{attrs:{"label":_vm.tooltipLabel,"type":_vm.type,"always":_vm.dragging || _vm.isFocused,"active":!_vm.disabled && _vm.tooltip}},[_c('div',_vm._b({staticClass:"b-slider-thumb",attrs:{"tabindex":_vm.disabled ? false : 0},on:{"mousedown":_vm.onButtonDown,"touchstart":_vm.onButtonDown,"focus":_vm.onFocus,"blur":_vm.onBlur,"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }$event.preventDefault();return _vm.onLeftKeyDown($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }$event.preventDefault();return _vm.onRightKeyDown($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.onLeftKeyDown($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.onRightKeyDown($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"home",undefined,$event.key,undefined)){ return null; }$event.preventDefault();return _vm.onHomeKeyDown($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"end",undefined,$event.key,undefined)){ return null; }$event.preventDefault();return _vm.onEndKeyDown($event)}]}},'div',_vm.$attrs,false))])],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var SliderThumb = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
var script$1 = {
  name: 'BSliderTick',
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  computed: {
    position: function position() {
      var pos = (this.value - this.$parent.min) / (this.$parent.max - this.$parent.min) * 100;
      return pos >= 0 && pos <= 100 ? pos : 0;
    },
    hidden: function hidden() {
      return this.value === this.$parent.min || this.value === this.$parent.max;
    }
  },
  methods: {
    getTickStyle: function getTickStyle(position) {
      return {
        'left': position + '%'
      };
    }
  },
  created: function created() {
    if (!this.$parent.$data._isSlider) {
      this.$destroy();
      throw new Error('You should wrap bSliderTick on a bSlider');
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-slider-tick",class:{ 'is-tick-hidden': _vm.hidden },style:(_vm.getTickStyle(_vm.position))},[(_vm.$slots.default)?_c('span',{staticClass:"b-slider-tick-label"},[_vm._t("default")],2):_vm._e()])};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var SliderTick = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

var _components;
var script$2 = {
  name: 'BSlider',
  components: (_components = {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, SliderThumb.name, SliderThumb), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["b" /* _ */])(_components, SliderTick.name, SliderTick), _components),
  props: {
    value: {
      type: [Number, Array],
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: 'is-primary'
    },
    size: String,
    ticks: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: Boolean,
      default: true
    },
    tooltipType: String,
    rounded: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    },
    customFormatter: Function,
    ariaLabel: [String, Array],
    biggerSliderFocus: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      value1: null,
      value2: null,
      dragging: false,
      isRange: false,
      _isSlider: true // Used by Thumb and Tick

    };
  },
  computed: {
    newTooltipType: function newTooltipType() {
      return this.tooltipType ? this.tooltipType : this.type;
    },
    tickValues: function tickValues() {
      if (!this.ticks || this.min > this.max || this.step === 0) return [];
      var result = [];

      for (var i = this.min + this.step; i < this.max; i = i + this.step) {
        result.push(i);
      }

      return result;
    },
    minValue: function minValue() {
      return Math.min(this.value1, this.value2);
    },
    maxValue: function maxValue() {
      return Math.max(this.value1, this.value2);
    },
    barSize: function barSize() {
      return this.isRange ? "".concat(100 * (this.maxValue - this.minValue) / (this.max - this.min), "%") : "".concat(100 * (this.value1 - this.min) / (this.max - this.min), "%");
    },
    barStart: function barStart() {
      return this.isRange ? "".concat(100 * (this.minValue - this.min) / (this.max - this.min), "%") : '0%';
    },
    precision: function precision() {
      var precisions = [this.min, this.max, this.step].map(function (item) {
        var decimal = ('' + item).split('.')[1];
        return decimal ? decimal.length : 0;
      });
      return Math.max.apply(Math, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["e" /* d */])(precisions));
    },
    barStyle: function barStyle() {
      return {
        width: this.barSize,
        left: this.barStart
      };
    },
    rootClasses: function rootClasses() {
      return {
        'is-rounded': this.rounded,
        'is-dragging': this.dragging,
        'is-disabled': this.disabled,
        'slider-focus': this.biggerSliderFocus
      };
    }
  },
  watch: {
    /**
    * When v-model is changed set the new active step.
    */
    value: function value(_value) {
      this.setValues(_value);
    },
    value1: function value1() {
      this.onInternalValueUpdate();
    },
    value2: function value2() {
      this.onInternalValueUpdate();
    },
    min: function min() {
      this.setValues(this.value);
    },
    max: function max() {
      this.setValues(this.value);
    }
  },
  methods: {
    setValues: function setValues(newValue) {
      if (this.min > this.max) {
        return;
      }

      if (Array.isArray(newValue)) {
        this.isRange = true;
        var smallValue = typeof newValue[0] !== 'number' || isNaN(newValue[0]) ? this.min : Math.min(Math.max(this.min, newValue[0]), this.max);
        var largeValue = typeof newValue[1] !== 'number' || isNaN(newValue[1]) ? this.max : Math.max(Math.min(this.max, newValue[1]), this.min);
        this.value1 = this.isThumbReversed ? largeValue : smallValue;
        this.value2 = this.isThumbReversed ? smallValue : largeValue;
      } else {
        this.isRange = false;
        this.value1 = isNaN(newValue) ? this.min : Math.min(this.max, Math.max(this.min, newValue));
        this.value2 = null;
      }
    },
    onInternalValueUpdate: function onInternalValueUpdate() {
      if (this.isRange) {
        this.isThumbReversed = this.value1 > this.value2;
      }

      if (!this.lazy || !this.dragging) {
        this.emitValue('input');
      }

      if (this.dragging) {
        this.emitValue('dragging');
      }
    },
    sliderSize: function sliderSize() {
      return this.$refs.slider.getBoundingClientRect().width;
    },
    onSliderClick: function onSliderClick(event) {
      if (this.disabled || this.isTrackClickDisabled) return;
      var sliderOffsetLeft = this.$refs.slider.getBoundingClientRect().left;
      var percent = (event.clientX - sliderOffsetLeft) / this.sliderSize() * 100;
      var targetValue = this.min + percent * (this.max - this.min) / 100;
      var diffFirst = Math.abs(targetValue - this.value1);

      if (!this.isRange) {
        if (diffFirst < this.step / 2) return;
        this.$refs.button1.setPosition(percent);
      } else {
        var diffSecond = Math.abs(targetValue - this.value2);

        if (diffFirst <= diffSecond) {
          if (diffFirst < this.step / 2) return;
          this.$refs['button1'].setPosition(percent);
        } else {
          if (diffSecond < this.step / 2) return;
          this.$refs['button2'].setPosition(percent);
        }
      }

      this.emitValue('change');
    },
    onDragStart: function onDragStart() {
      this.dragging = true;
      this.$emit('dragstart');
    },
    onDragEnd: function onDragEnd() {
      var _this = this;

      this.isTrackClickDisabled = true;
      setTimeout(function () {
        // avoid triggering onSliderClick after dragend
        _this.isTrackClickDisabled = false;
      }, 0);
      this.dragging = false;
      this.$emit('dragend');

      if (this.lazy) {
        this.emitValue('input');
      }
    },
    emitValue: function emitValue(type) {
      this.$emit(type, this.isRange ? [this.minValue, this.maxValue] : this.value1);
    }
  },
  created: function created() {
    this.isThumbReversed = false;
    this.isTrackClickDisabled = false;
    this.setValues(this.value);
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-slider",class:[_vm.size, _vm.type, _vm.rootClasses ],on:{"click":_vm.onSliderClick}},[_c('div',{ref:"slider",staticClass:"b-slider-track"},[_c('div',{staticClass:"b-slider-fill",style:(_vm.barStyle)}),_vm._v(" "),(_vm.ticks)?_vm._l((_vm.tickValues),function(val,key){return _c('b-slider-tick',{key:key,attrs:{"value":val}})}):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('b-slider-thumb',{ref:"button1",attrs:{"type":_vm.newTooltipType,"tooltip":_vm.tooltip,"custom-formatter":_vm.customFormatter,"role":"slider","aria-valuenow":_vm.value1,"aria-valuemin":_vm.min,"aria-valuemax":_vm.max,"aria-orientation":"horizontal","aria-label":Array.isArray(_vm.ariaLabel) ? _vm.ariaLabel[0] : _vm.ariaLabel,"aria-disabled":_vm.disabled},on:{"dragstart":_vm.onDragStart,"dragend":_vm.onDragEnd},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v;},expression:"value1"}}),_vm._v(" "),(_vm.isRange)?_c('b-slider-thumb',{ref:"button2",attrs:{"type":_vm.newTooltipType,"tooltip":_vm.tooltip,"custom-formatter":_vm.customFormatter,"role":"slider","aria-valuenow":_vm.value2,"aria-valuemin":_vm.min,"aria-valuemax":_vm.max,"aria-orientation":"horizontal","aria-label":Array.isArray(_vm.ariaLabel) ? _vm.ariaLabel[1] : '',"aria-disabled":_vm.disabled},on:{"dragstart":_vm.onDragStart,"dragend":_vm.onDragEnd},model:{value:(_vm.value2),callback:function ($$v) {_vm.value2=$$v;},expression:"value2"}}):_vm._e()],2)])};
var __vue_staticRenderFns__$2 = [];

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Slider = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["d" /* r */])(Vue, Slider);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["d" /* r */])(Vue, SliderTick);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "vNXG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__ = __webpack_require__("rhEV");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'BTag',
  props: {
    attached: Boolean,
    closable: Boolean,
    type: String,
    size: String,
    rounded: Boolean,
    disabled: Boolean,
    ellipsis: Boolean,
    tabstop: {
      type: Boolean,
      default: true
    },
    ariaCloseLabel: String,
    closeType: String
  },
  methods: {
    /**
    * Emit close event when delete button is clicked
    * or delete key is pressed.
    */
    close: function close(event) {
      if (this.disabled) return;
      this.$emit('close', event);
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.attached && _vm.closable)?_c('div',{staticClass:"tags has-addons"},[_c('span',{staticClass:"tag",class:[_vm.type, _vm.size, { 'is-rounded': _vm.rounded }]},[_c('span',{class:{ 'has-ellipsis': _vm.ellipsis }},[_vm._t("default")],2)]),_vm._v(" "),_c('a',{staticClass:"tag is-delete",class:[_vm.size, _vm.closeType, { 'is-rounded': _vm.rounded }],attrs:{"role":"button","aria-label":_vm.ariaCloseLabel,"tabindex":_vm.tabstop ? 0 : false,"disabled":_vm.disabled},on:{"click":_vm.close,"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }$event.preventDefault();return _vm.close($event)}}})]):_c('span',{staticClass:"tag",class:[_vm.type, _vm.size, { 'is-rounded': _vm.rounded }]},[_c('span',{class:{ 'has-ellipsis': _vm.ellipsis }},[_vm._t("default")],2),_vm._v(" "),(_vm.closable)?_c('a',{staticClass:"delete is-small",class:_vm.closeType,attrs:{"role":"button","aria-label":_vm.ariaCloseLabel,"disabled":_vm.disabled,"tabindex":_vm.tabstop ? 0 : false},on:{"click":_vm.close,"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }$event.preventDefault();return _vm.close($event)}}}):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Tag = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );




/***/ }),

/***/ "vkRo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BSkeleton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__ = __webpack_require__("rhEV");


var script = {
  name: 'BSkeleton',
  functional: true,
  props: {
    active: {
      type: Boolean,
      default: true
    },
    animated: {
      type: Boolean,
      default: true
    },
    width: [Number, String],
    height: [Number, String],
    circle: Boolean,
    rounded: {
      type: Boolean,
      default: true
    },
    count: {
      type: Number,
      default: 1
    },
    size: String
  },
  render: function render(createElement, context) {
    if (!context.props.active) return;
    var items = [];
    var width = context.props.width;
    var height = context.props.height;

    for (var i = 0; i < context.props.count; i++) {
      items.push(createElement('div', {
        staticClass: 'b-skeleton-item',
        class: {
          'is-rounded': context.props.rounded
        },
        key: i,
        style: {
          height: height === undefined ? null : isNaN(height) ? height : height + 'px',
          width: width === undefined ? null : isNaN(width) ? width : width + 'px',
          borderRadius: context.props.circle ? '50%' : null
        }
      }));
    }

    return createElement('div', {
      staticClass: 'b-skeleton',
      class: [context.props.size, {
        'is-animated': context.props.animated
      }]
    }, items);
  }
};

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Skeleton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["c" /* _ */])(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["d" /* r */])(Vue, Skeleton);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "wrzx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUpload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chunk_d0a313ea_js__ = __webpack_require__("EmVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__ = __webpack_require__("rhEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_b9bdb0e4_js__ = __webpack_require__("UZQh");





//
var script = {
  name: 'BUpload',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__chunk_d0a313ea_js__["a" /* F */]],
  inheritAttrs: false,
  props: {
    value: {
      type: [Object, Function, __WEBPACK_IMPORTED_MODULE_3__chunk_b9bdb0e4_js__["a" /* F */], Array]
    },
    multiple: Boolean,
    disabled: Boolean,
    accept: String,
    dragDrop: Boolean,
    type: {
      type: String,
      default: 'is-primary'
    },
    native: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      newValue: this.value,
      dragDropFocus: false,
      _elementRef: 'input'
    };
  },
  watch: {
    /**
     *   When v-model is changed:
     *   1. Get value from input file
     *   2. Set internal value.
     *   3. Reset input value if array is empty or when input file is not found in newValue
     *   4. If it's invalid, validate again.
     */
    value: function value(_value) {
      var inputFiles = this.$refs.input.files;
      this.newValue = _value;

      if (!this.newValue || Array.isArray(this.newValue) && this.newValue.length === 0 || !inputFiles[0] || Array.isArray(this.newValue) && !this.newValue.some(function (a) {
        return a.name === inputFiles[0].name;
      })) {
        this.$refs.input.value = null;
      }

      !this.isValid && !this.dragDrop && this.checkHtml5Validity();
    }
  },
  methods: {
    /**
    * Listen change event on input type 'file',
    * emit 'input' event and validate
    */
    onFileChange: function onFileChange(event) {
      if (this.disabled || this.loading) return;

      if (this.dragDrop) {
        this.updateDragDropFocus(false);
      }

      var value = event.target.files || event.dataTransfer.files;

      if (value.length === 0) {
        if (!this.newValue) {
          return;
        }

        if (this.native) {
          this.newValue = null;
        }
      } else if (!this.multiple) {
        // only one element in case drag drop mode and isn't multiple
        if (this.dragDrop && value.length !== 1) return;else {
          var file = value[0];

          if (this.checkType(file)) {
            this.newValue = file;
          } else if (this.newValue) {
            this.newValue = null;
          } else {
            return;
          }
        }
      } else {
        // always new values if native or undefined local
        var newValues = false;

        if (this.native || !this.newValue) {
          this.newValue = [];
          newValues = true;
        }

        for (var i = 0; i < value.length; i++) {
          var _file = value[i];

          if (this.checkType(_file)) {
            this.newValue.push(_file);
            newValues = true;
          }
        }

        if (!newValues) {
          return;
        }
      }

      this.$emit('input', this.newValue);
      !this.dragDrop && this.checkHtml5Validity();
    },

    /**
    * Listen drag-drop to update internal variable
    */
    updateDragDropFocus: function updateDragDropFocus(focus) {
      if (!this.disabled && !this.loading) {
        this.dragDropFocus = focus;
      }
    },

    /**
    * Check mime type of file
    */
    checkType: function checkType(file) {
      if (!this.accept) return true;
      var types = this.accept.split(',');
      if (types.length === 0) return true;
      var valid = false;

      for (var i = 0; i < types.length && !valid; i++) {
        var type = types[i].trim();

        if (type) {
          if (type.substring(0, 1) === '.') {
            // check extension
            var extIndex = file.name.lastIndexOf('.');
            var extension = extIndex >= 0 ? file.name.substring(extIndex) : '';

            if (extension.toLowerCase() === type.toLowerCase()) {
              valid = true;
            }
          } else {
            // check mime type
            if (file.type.match(type)) {
              valid = true;
            }
          }
        }
      }

      return valid;
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"upload control",class:{'is-expanded' : _vm.expanded}},[(!_vm.dragDrop)?[_vm._t("default")]:_c('div',{staticClass:"upload-draggable",class:[_vm.type, {
                'is-loading': _vm.loading,
                'is-disabled': _vm.disabled,
                'is-hovered': _vm.dragDropFocus,
                'is-expanded': _vm.expanded,
            }],on:{"dragover":function($event){$event.preventDefault();_vm.updateDragDropFocus(true);},"dragleave":function($event){$event.preventDefault();_vm.updateDragDropFocus(false);},"dragenter":function($event){$event.preventDefault();_vm.updateDragDropFocus(true);},"drop":function($event){$event.preventDefault();return _vm.onFileChange($event)}}},[_vm._t("default")],2),_vm._v(" "),_c('input',_vm._b({ref:"input",attrs:{"type":"file","multiple":_vm.multiple,"accept":_vm.accept,"disabled":_vm.disabled},on:{"change":_vm.onFileChange}},'input',_vm.$attrs,false))],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Upload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["d" /* r */])(Vue, Upload);
  }
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__chunk_cca88db8_js__["b" /* u */])(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Plugin);



/***/ }),

/***/ "xGkn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("4mcu");
var step = __webpack_require__("EGZi");
var Iterators = __webpack_require__("/bQp");
var toIObject = __webpack_require__("TcQ7");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("vIB/")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "xH/j":
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__("hJx8");
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ "xLtR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var transformData = __webpack_require__("TNV1");
var isCancel = __webpack_require__("pBtG");
var defaults = __webpack_require__("KCLY");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "xnc9":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "y1ZE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__ = __webpack_require__("r429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__("LPeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__ = __webpack_require__("V5O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__ = __webpack_require__("rhEV");





var mdiIcons = {
  sizes: {
    'default': 'mdi-24px',
    'is-small': null,
    'is-medium': 'mdi-36px',
    'is-large': 'mdi-48px'
  },
  iconPrefix: 'mdi-'
};

var faIcons = function faIcons() {
  var faIconPrefix = __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */] && __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultIconComponent ? '' : 'fa-';
  return {
    sizes: {
      'default': faIconPrefix + 'lg',
      'is-small': null,
      'is-medium': faIconPrefix + '2x',
      'is-large': faIconPrefix + '3x'
    },
    iconPrefix: faIconPrefix,
    internalIcons: {
      'information': 'info-circle',
      'alert': 'exclamation-triangle',
      'alert-circle': 'exclamation-circle',
      'chevron-right': 'angle-right',
      'chevron-left': 'angle-left',
      'chevron-down': 'angle-down',
      'eye-off': 'eye-slash',
      'menu-down': 'caret-down',
      'menu-up': 'caret-up',
      'close-circle': 'times-circle'
    }
  };
};

var getIcons = function getIcons() {
  var icons = {
    mdi: mdiIcons,
    fa: faIcons(),
    fas: faIcons(),
    far: faIcons(),
    fad: faIcons(),
    fab: faIcons(),
    fal: faIcons()
  };

  if (__WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */] && __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].customIconPacks) {
    icons = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* merge */])(icons, __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].customIconPacks, true);
  }

  return icons;
};

var script = {
  name: 'BIcon',
  props: {
    type: [String, Object],
    component: String,
    pack: String,
    icon: String,
    size: String,
    customSize: String,
    customClass: String,
    both: Boolean // This is used internally to show both MDI and FA icon

  },
  computed: {
    iconConfig: function iconConfig() {
      var allIcons = getIcons();
      return allIcons[this.newPack];
    },
    iconPrefix: function iconPrefix() {
      if (this.iconConfig && this.iconConfig.iconPrefix) {
        return this.iconConfig.iconPrefix;
      }

      return '';
    },

    /**
    * Internal icon name based on the pack.
    * If pack is 'fa', gets the equivalent FA icon name of the MDI,
    * internal icons are always MDI.
    */
    newIcon: function newIcon() {
      return "".concat(this.iconPrefix).concat(this.getEquivalentIconOf(this.icon));
    },
    newPack: function newPack() {
      return this.pack || __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultIconPack;
    },
    newType: function newType() {
      if (!this.type) return;
      var splitType = [];

      if (typeof this.type === 'string') {
        splitType = this.type.split('-');
      } else {
        for (var key in this.type) {
          if (this.type[key]) {
            splitType = key.split('-');
            break;
          }
        }
      }

      if (splitType.length <= 1) return;

      var _splitType = splitType,
          _splitType2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__chunk_1fafdf15_js__["d" /* c */])(_splitType),
          type = _splitType2.slice(1);

      return "has-text-".concat(type.join('-'));
    },
    newCustomSize: function newCustomSize() {
      return this.customSize || this.customSizeByPack;
    },
    customSizeByPack: function customSizeByPack() {
      if (this.iconConfig && this.iconConfig.sizes) {
        if (this.size && this.iconConfig.sizes[this.size] !== undefined) {
          return this.iconConfig.sizes[this.size];
        } else if (this.iconConfig.sizes.default) {
          return this.iconConfig.sizes.default;
        }
      }

      return null;
    },
    useIconComponent: function useIconComponent() {
      return this.component || __WEBPACK_IMPORTED_MODULE_2__chunk_6985c8ce_js__["a" /* c */].defaultIconComponent;
    }
  },
  methods: {
    /**
    * Equivalent icon name of the MDI.
    */
    getEquivalentIconOf: function getEquivalentIconOf(value) {
      // Only transform the class if the both prop is set to true
      if (!this.both) {
        return value;
      }

      if (this.iconConfig && this.iconConfig.internalIcons && this.iconConfig.internalIcons[value]) {
        return this.iconConfig.internalIcons[value];
      }

      return value;
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",class:[_vm.newType, _vm.size]},[(!_vm.useIconComponent)?_c('i',{class:[_vm.newPack, _vm.newIcon, _vm.newCustomSize, _vm.customClass]}):_c(_vm.useIconComponent,{tag:"component",class:[_vm.customClass],attrs:{"icon":[_vm.newPack, _vm.newIcon],"size":_vm.newCustomSize}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Icon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chunk_cca88db8_js__["c" /* _ */])(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );




/***/ }),

/***/ "zQR9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("h65t")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("vIB/")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ })

});


// WEBPACK FOOTER //
// static/js/vendor.a976972d0f80b659bac5.js